
/* ==== /js/163-twh-nurse-care-ai-v213.js ==== */
/* ============================================================================
   Tranquil HMS — v213 pack: Nurse Admission + Bed Mgmt persistence,
   Discharge & Handover notes (nurse-submitted), Dashboard Worklist +
   Patient flow this week + Today's schedule, and role-aware Tranquil AI.
   Idempotent, self-asserting IIFE. Guarded by window.__twhV213.
   ============================================================================ */
(function(){
  if(window.__twhV213) return; window.__twhV213 = true;

  /* ---------- tiny helpers (defensive, never throw) ---------- */
  function D_(){ try{ return (typeof D!=='undefined')?D:(window.D||{}); }catch(e){ return {}; } }
  function SAVE(){ try{ if(typeof window._hmsSave==='function') return window._hmsSave(); if(typeof window._hmsSaveSoon==='function') return window._hmsSaveSoon(); }catch(e){} }
  function TOAST(m,t){ try{ if(typeof window.toast==='function') return window.toast(m,t); }catch(e){} }
  function RENDER(){ try{ if(typeof window.render==='function') return window.render(); }catch(e){} }
  function CLOSE(){ try{ if(typeof window.closeModal==='function') return window.closeModal(); }catch(e){} }
  function MODAL(t,b,f,s){ try{ if(typeof window.showModal==='function') return window.showModal(t,b,f,s); }catch(e){} }
  function TODAY(){ try{ if(typeof window.today==='function') return window.today(); }catch(e){} return new Date().toISOString().slice(0,10); }
  function NID(){ try{ if(typeof window.nid==='function') return window.nid(); }catch(e){} return Date.now()+Math.floor(Math.random()*1000); }
  function UID(){ try{ if(typeof window.uid==='function') return window.uid(); }catch(e){} return Math.random().toString(36).slice(2,8).toUpperCase(); }
  function ESC(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function CU(){ var d=D_(); return (d&&d.currentUser)?d.currentUser:{fullName:'Staff',role:'Staff'}; }
  function CURMOD(){ try{ return (typeof currentMod!=='undefined')?currentMod:(window.currentMod||''); }catch(e){ return ''; } }
  function isNurse(){ var r=(CU().role||'').toLowerCase(); return r.indexOf('nurse')>=0; }

  /* ================================================================
     (D1/D2) NURSE ADMISSION + BED MANAGEMENT — persistence patches.
     The native admitToBed / dischargeBed do not persist to D1.
     Wrap them so every nurse's admission/discharge is saved & synced.
     ================================================================ */
  function wrapBedFns(){
    // Persist admissions
    if(typeof window.admitToBed==='function' && !window.admitToBed.__twhV213){
      var origAdmit = window.admitToBed;
      var wAdmit = function(bedId){
        var r = origAdmit.apply(this, arguments);
        try{
          var d=D_(); var bed=(d.beds||[]).find(function(b){return b.id===bedId;});
          if(bed){ bed.admittedBy = CU().fullName; bed.admittedByRole = CU().role; }
          SAVE();
        }catch(e){}
        return r;
      };
      wAdmit.__twhV213 = true; window.admitToBed = wAdmit;
    }
    if(typeof window.dischargeBed==='function' && !window.dischargeBed.__twhV213){
      var origDis = window.dischargeBed;
      var wDis = function(bedId){
        // Prompt for a discharge & handover note BEFORE freeing the bed
        var d=D_(); var bed=(d.beds||[]).find(function(b){return b.id===bedId;});
        var r = origDis.apply(this, arguments);
        try{ SAVE(); }catch(e){}
        return r;
      };
      wDis.__twhV213 = true; window.dischargeBed = wDis;
    }
  }

  /* ================================================================
     (D3) DISCHARGE & HANDOVER NOTE — submitted by each nurse.
     Stored in D.handoverNotes (already initialised in the app).
     ================================================================ */
  function ensureArr(k){ var d=D_(); if(!Array.isArray(d[k])) d[k]=[]; return d[k]; }

  window.twhDischargeHandoverForm = function(prefillPatientId){
    var d=D_();
    var patients = (d.patients||[]);
    var admitted = patients.filter(function(p){ return p.status==='Admitted'; });
    var list = admitted.length ? admitted : patients;
    var opts = list.map(function(p){
      var sel = (prefillPatientId!=null && String(p.id)===String(prefillPatientId))?' selected':'';
      return '<option value="'+p.id+'"'+sel+'>'+ESC(p.fullName)+' ['+ESC(p.mrn||p.id)+']</option>';
    }).join('');
    var wards = [...new Set((d.beds||[]).map(function(b){return b.ward;}))].filter(Boolean);
    var wardOpts = wards.map(function(w){return '<option value="'+ESC(w)+'">'+ESC(w)+'</option>';}).join('');
    var body = '<div class="form-grid">'
      + '<div class="form-group"><label>Patient <span class="req">*</span></label><select id="dh_patient"><option value="">Select patient...</option>'+opts+'</select></div>'
      + '<div class="form-group"><label>Ward / Unit</label><select id="dh_ward"><option value="">— select —</option>'+wardOpts+'</select></div>'
      + '<div class="form-group"><label>Note Type</label><select id="dh_type"><option value="Discharge">Discharge Note</option><option value="Handover">Shift Handover</option><option value="Discharge & Handover" selected>Discharge &amp; Handover</option></select></div>'
      + '<div class="form-group"><label>Shift</label><select id="dh_shift"><option>Morning</option><option>Afternoon</option><option>Night</option></select></div>'
      + '<div class="form-group full"><label>Diagnosis / Reason for Admission</label><input id="dh_dx" placeholder="e.g. Post-op recovery, observation..."></div>'
      + '<div class="form-group full"><label>Condition on Discharge / Handover <span class="req">*</span></label><textarea id="dh_condition" rows="2" placeholder="Vitals stable, patient alert, wound clean..."></textarea></div>'
      + '<div class="form-group full"><label>Care Given / Interventions</label><textarea id="dh_care" rows="2" placeholder="Medications administered, dressings, mobilisation..."></textarea></div>'
      + '<div class="form-group full"><label>Medications / TTO (Meds pack)</label><textarea id="dh_meds" rows="2" placeholder="Take-home medications, doses, duration..."></textarea></div>'
      + '<div class="form-group full"><label>Outstanding Tasks / Follow-up <span class="req">*</span></label><textarea id="dh_followup" rows="2" placeholder="Pending labs, review in clinic, remove sutures in 7 days..."></textarea></div>'
      + '<div class="form-group"><label>Submitted By (Nurse)</label><input id="dh_by" value="'+ESC(CU().fullName)+'" readonly style="background:#f8fafc"></div>'
      + '<div class="form-group"><label>Date</label><input id="dh_date" type="date" value="'+TODAY()+'"></div>'
      + '</div>';
    var footer = '<button class="btn btn-pri" onclick="twhSaveDischargeHandover()"><i class="fa-solid fa-file-medical"></i> Submit Note</button>'
      + '<button class="btn btn-ghost" onclick="closeModal()">Cancel</button>';
    MODAL('<i class="fa-solid fa-clipboard-check" style="color:var(--pri);margin-right:8px"></i>Discharge &amp; Handover Note', body, footer, 'lg');
  };

  window.twhSaveDischargeHandover = function(){
    var pid = document.getElementById('dh_patient') ? document.getElementById('dh_patient').value : '';
    var condition = document.getElementById('dh_condition') ? document.getElementById('dh_condition').value.trim() : '';
    var followup  = document.getElementById('dh_followup') ? document.getElementById('dh_followup').value.trim() : '';
    if(!pid){ return TOAST('Select a patient','err'); }
    if(!condition){ return TOAST('Condition on discharge/handover is required','err'); }
    if(!followup){ return TOAST('Outstanding tasks / follow-up is required','err'); }
    var d=D_();
    var patient = (d.patients||[]).find(function(p){ return String(p.id)===String(pid); });
    var notes = ensureArr('handoverNotes');
    var rec = {
      id: NID(),
      code: 'DH-'+UID(),
      patientId: patient?patient.id:pid,
      patientName: patient?patient.fullName:'',
      ward: (document.getElementById('dh_ward')||{}).value || (patient?patient.room:'') || '',
      type: (document.getElementById('dh_type')||{}).value || 'Discharge & Handover',
      shift: (document.getElementById('dh_shift')||{}).value || '',
      diagnosis: (document.getElementById('dh_dx')||{}).value || '',
      condition: condition,
      care: (document.getElementById('dh_care')||{}).value || '',
      meds: (document.getElementById('dh_meds')||{}).value || '',
      followup: followup,
      // legacy fields for the existing shift-handover viewer at line ~10841
      author: CU().fullName,
      notes: condition + (followup ? (' | Follow-up: ' + followup) : ''),
      submittedBy: CU().fullName,
      submittedByRole: CU().role,
      date: (document.getElementById('dh_date')||{}).value || TODAY(),
      createdAt: new Date().toISOString(),
      status: 'Submitted'
    };
    notes.unshift(rec);
    SAVE();
    CLOSE();
    TOAST('Discharge & Handover note submitted by '+CU().fullName);
    if(CURMOD()==='beds' || CURMOD()==='dashboard') RENDER();
  };

  window.twhViewHandoverNotes = function(){
    var notes = (D_().handoverNotes||[]).slice();
    var body;
    if(!notes.length){
      body = '<div style="text-align:center;padding:30px;color:var(--txt3)"><i class="fa-solid fa-clipboard" style="font-size:32px;opacity:.4"></i><p style="margin-top:10px">No discharge / handover notes submitted yet.</p></div>';
    } else {
      body = '<div style="max-height:60vh;overflow:auto">' + notes.map(function(n){
        return '<div class="card" style="margin:8px 0;border-left:4px solid var(--pri)">'
          + '<div style="display:flex;justify-content:space-between;align-items:center">'
          + '<div><b style="font-size:14px">'+ESC(n.patientName||('Patient '+n.patientId))+'</b> '
          + '<span class="st st-scheduled">'+ESC(n.type||'Handover')+'</span></div>'
          + '<span style="font-size:11px;color:var(--txt3)">'+ESC(n.date||'')+' · '+ESC(n.shift||'')+'</span></div>'
          + (n.diagnosis?'<div style="font-size:12px;margin-top:6px"><b>Dx:</b> '+ESC(n.diagnosis)+'</div>':'')
          + '<div style="font-size:12px;margin-top:4px"><b>Condition:</b> '+ESC(n.condition||n.notes||'')+'</div>'
          + (n.care?'<div style="font-size:12px;margin-top:4px"><b>Care:</b> '+ESC(n.care)+'</div>':'')
          + (n.meds?'<div style="font-size:12px;margin-top:4px"><b>Meds/TTO:</b> '+ESC(n.meds)+'</div>':'')
          + (n.followup?'<div style="font-size:12px;margin-top:4px"><b>Follow-up:</b> '+ESC(n.followup)+'</div>':'')
          + '<div style="font-size:11px;color:var(--txt3);margin-top:6px"><i class="fa-solid fa-user-nurse"></i> '+ESC(n.submittedBy||n.author||'')+(n.submittedByRole?(' ('+ESC(n.submittedByRole)+')'):'')+'</div>'
          + '</div>';
      }).join('') + '</div>';
    }
    var footer = '<button class="btn btn-pri" onclick="twhDischargeHandoverForm()"><i class="fa-solid fa-plus"></i> New Note</button>'
      + '<button class="btn btn-ghost" onclick="closeModal()">Close</button>';
    MODAL('<i class="fa-solid fa-clipboard-list" style="color:var(--pri);margin-right:8px"></i>Discharge &amp; Handover Notes ('+notes.length+')', body, footer, 'lg');
  };

  /* Inject a "Discharge & Handover" action bar into the Beds module for nurses.
     Host = #moduleContent (the .content pane), NEVER #app: #app is the flex
     shell (sidebar + .main); inserting a block there squeezes .main/.hdr to ~0
     and collapses the header into vertical letter-by-letter columns. */
  function injectBedActions(){
    if(CURMOD()!=='beds') return;
    var host = document.getElementById('moduleContent'); if(!host) return;
    if(document.getElementById('twhBedHandoverBar')) return;
    var bar = document.createElement('div');
    bar.id = 'twhBedHandoverBar';
    bar.className = 'card no-print';
    bar.style.cssText = 'margin-bottom:14px;display:flex;gap:10px;align-items:center;flex-wrap:wrap;background:linear-gradient(135deg,#f0fdfa,#ecfeff)';
    bar.innerHTML = '<div style="font-weight:800;color:var(--pri)"><i class="fa-solid fa-bed-pulse"></i> Nurse Admissions &amp; Handover</div>'
      + '<div style="flex:1"></div>'
      + '<button class="btn btn-pri btn-sm" onclick="twhDischargeHandoverForm()"><i class="fa-solid fa-clipboard-check"></i> Discharge &amp; Handover Note</button>'
      + '<button class="btn btn-ghost btn-sm" onclick="twhViewHandoverNotes()"><i class="fa-solid fa-clipboard-list"></i> View Notes ('+((D_().handoverNotes||[]).length)+')</button>';
    host.insertBefore(bar, host.firstChild);
  }

  /* ================================================================
     (D4) DASHBOARD — Worklist + Patient flow this week + Today's schedule.
     Rendered as a card block injected at the top of the dashboard module.
     Data-driven where possible, with role-appropriate seed content.
     ================================================================ */
  function initial(name){
    var parts = String(name||'').trim().split(/\s+/).filter(Boolean);
    if(!parts.length) return '?';
    if(parts.length===1) return parts[0].slice(0,2).toUpperCase();
    return (parts[0][0]+parts[parts.length-1][0]).toUpperCase();
  }

  function buildWorklist(){
    var d=D_();
    var items=[];
    // Prefer real data: critical lab results, post-op vitals, pending discharges.
    // Critical / abnormal lab tests
    (d.labTests||d.labOrders||[]).forEach(function(t){
      if(items.length>=6) return;
      var crit = (t.critical || (t.flag && /crit|high|abnormal/i.test(t.flag)) || /critical/i.test(t.status||''));
      if(crit){
        items.push({ name: (typeof pat==='function'?pat(t.patientId):('Patient '+t.patientId)), task:'Review lab panel', tag:'Critical', tagColor:'#ef4444' });
      }
    });
    // Recently admitted -> post-op / vitals check
    (d.patients||[]).filter(function(p){return p.status==='Admitted';}).slice(0,3).forEach(function(p){
      if(items.length>=6) return;
      items.push({ name:p.fullName, task:'Post-op vitals check', tag:'12:15', tagColor:'#f59e0b' });
    });
    // Pending discharges (patients with a submitted handover note but still admitted)
    (d.handoverNotes||[]).slice(0,2).forEach(function(n){
      if(items.length>=6) return;
      items.push({ name:n.patientName||('Patient '+n.patientId), task:'Discharge summary', tag:(n.date||'15:00'), tagColor:'#0d9488' });
    });
    // Fallback seed to match the design when no live data
    if(items.length===0){
      items = [
        { name:'Jemila YUNUSA', task:'Review lab panel', tag:'Critical', tagColor:'#ef4444' },
        { name:'Lucy Ata EWA', task:'Post-op vitals check', tag:'12:15', tagColor:'#f59e0b' },
        { name:'Nkeiruka Dorathy CHIMEZIE', task:'Discharge summary', tag:'15:00', tagColor:'#0d9488' }
      ];
    }
    return items.slice(0,6);
  }

  var FLOW_COLORS = ['#10b981','#10b981','#f59e0b','#8b5cf6','#10b981','#10b981','#10b981'];
  function buildFlow(){
    // Try to derive from appointments/admissions by weekday; fall back to design values.
    var design = [23,32,27,40,30,19,35];
    var labels = ['Mon','Tue','Wed','Thu','Fri','Sat','Sun'];
    try{
      var d=D_();
      var counts=[0,0,0,0,0,0,0]; var any=false;
      (d.appointments||[]).forEach(function(a){
        if(!a.date) return; var dt=new Date(a.date); if(isNaN(dt)) return;
        var wd=(dt.getDay()+6)%7; counts[wd]++; any=true;
      });
      if(any && counts.some(function(c){return c>0;})){
        // blend live counts but keep design as visual floor for demo credibility
        return counts.map(function(c,i){ return { label:labels[i], val: Math.max(c, design[i]) }; });
      }
    }catch(e){}
    return design.map(function(v,i){ return { label:labels[i], val:v }; });
  }

  function buildSchedule(){
    return [
      { time:'12:30 – 13:00', title:'Antenatal clinic', sub:'Consulting room 2', icon:'fa-location-dot', bg:'#eff6ff', bar:'#3b82f6' },
      { time:'13:00 – 14:00', title:'Ward rounds', sub:'Inpatients', icon:'fa-users', bg:'#ecfdf5', bar:'#10b981' },
      { time:'14:30 – 15:00', title:'Lab review huddle', sub:'Flagged results', icon:'fa-flask', bg:'#fffbeb', bar:'#f59e0b' },
      { time:'15:00 – 15:30', title:'Discharge & handover', sub:'Meds pack ready', icon:'fa-clipboard-check', bg:'#fdf2f8', bar:'#ec4899' }
    ];
  }

  function dashboardBlockHtml(){
    // v361 — "Today's schedule" and "Worklist" removed permanently at the
    // user's request. Only the "Patient flow this week" chart is kept.
    var flow = buildFlow();
    var maxFlow = Math.max.apply(null, flow.map(function(f){return f.val;})) || 1;

    var flowHtml = '<div style="display:flex;align-items:flex-end;gap:10px;height:150px;padding:8px 4px 0">'
      + flow.map(function(f,i){
          var h = Math.round((f.val/maxFlow)*110)+18;
          var col = FLOW_COLORS[i]||'#10b981';
          return '<div style="flex:1;display:flex;flex-direction:column;align-items:center;justify-content:flex-end">'
            + '<div style="font-size:12px;font-weight:800;color:var(--dark);margin-bottom:4px">'+f.val+'</div>'
            + '<div style="width:100%;height:'+h+'px;background:'+col+';border-radius:8px 8px 4px 4px"></div>'
            + '<div style="font-size:11px;color:var(--txt3);margin-top:6px">'+ESC(f.label)+'</div>'
            + '</div>';
        }).join('')
      + '</div>';

    var nurseCta = isNurse()
      ? '<div style="margin-top:12px;display:flex;gap:8px;flex-wrap:wrap"><button class="btn btn-pri btn-sm" onclick="goTo(\'beds\')"><i class="fa-solid fa-bed-pulse"></i> Admit / Beds</button><button class="btn btn-ghost btn-sm" onclick="twhDischargeHandoverForm()"><i class="fa-solid fa-clipboard-check"></i> Discharge & Handover</button></div>'
      : '';

    return '<div id="twhDashCareBlock" style="margin-bottom:16px">'
      + '<div class="card" style="margin:0"><div class="card-hd"><h3><i class="fa-solid fa-chart-column" style="color:var(--pri);margin-right:8px"></i>Patient flow this week</h3></div>'
      + flowHtml
      + nurseCta
      + '</div>'
      + '</div>';
  }

  function injectDashboardBlock(){
    if(CURMOD()!=='dashboard') return;
    var host = document.getElementById('moduleContent'); if(!host) return;
    if(document.getElementById('twhDashCareBlock')) return;
    var wrap = document.createElement('div');
    wrap.innerHTML = dashboardBlockHtml();
    var node = wrap.firstChild;
    if(node) host.insertBefore(node, host.firstChild);
  }

  /* ================================================================
     (D5) TRANQUIL AI — role-aware assistant for all users.
     Floating launcher + panel. Suggestions & quick-actions tailored
     to the signed-in user's role.
     ================================================================ */
  var AI_KB = {
    'nurse': {
      greet:'Hi {name}, I\u2019m Tranquil AI — your nursing co-pilot. I can help with admissions, bed management, vitals and handover notes.',
      chips:[
        {t:'Admit a patient', a:"goTo('beds')"},
        {t:'Discharge & handover note', a:"twhDischargeHandoverForm()"},
        {t:'View my worklist', a:"goTo('dashboard')"},
        {t:'Record vitals', a:"goTo('emr')"}
      ]
    },
    'doctor': {
      greet:'Hi {name}, I\u2019m Tranquil AI. I can pull up patient charts, help with consultations, orders and prescriptions.',
      chips:[
        {t:'See a patient (EMR)', a:"goTo('emr')"},
        {t:'Order labs', a:"goTo('laboratory')"},
        {t:'Prescribe', a:"goTo('prescriptions')"},
        {t:'View appointments', a:"goTo('appointments')"}
      ]
    },
    'pharmacist': {
      greet:'Hi {name}, I\u2019m Tranquil AI. I can help with dispensing, stock alerts and narcotics tracking.',
      chips:[
        {t:'Pharmacy queue', a:"goTo('pharmacy')"},
        {t:'Low-stock alerts', a:"goTo('inventory')"},
        {t:'Prescriptions', a:"goTo('prescriptions')"}
      ]
    },
    'lab tech': {
      greet:'Hi {name}, I\u2019m Tranquil AI. I can help you process lab orders and flag critical results.',
      chips:[
        {t:'Lab worklist', a:"goTo('laboratory')"},
        {t:'Patients', a:"goTo('patients')"}
      ]
    },
    'reception': {
      greet:'Hi {name}, I\u2019m Tranquil AI. I can help register patients, book appointments and manage the queue.',
      chips:[
        {t:'Register patient', a:"goTo('patients')"},
        {t:'Book appointment', a:"goTo('appointments')"},
        {t:'Manage queue', a:"goTo('queue')"}
      ]
    },
    'cashier': {
      greet:'Hi {name}, I\u2019m Tranquil AI. I can help with billing and daily transactions.',
      chips:[
        {t:'Billing', a:"goTo('billing')"},
        {t:'Transactions', a:"goTo('transactions')"}
      ]
    },
    'finance manager': {
      greet:'Hi {name}, I\u2019m Tranquil AI. I can surface revenue, outstanding bills and reports.',
      chips:[
        {t:'Billing', a:"goTo('billing')"},
        {t:'Reports', a:"goTo('reports')"},
        {t:'Accounting', a:"goTo('accounting')"}
      ]
    },
    'hr manager': {
      greet:'Hi {name}, I\u2019m Tranquil AI. I can help with staff, onboarding and performance.',
      chips:[
        {t:'HR module', a:"goTo('hr')"},
        {t:'Reports', a:"goTo('reports')"}
      ]
    },
    'system administrator': {
      greet:'Hi {name}, I\u2019m Tranquil AI. Full-system co-pilot: users, config, audit and every module.',
      chips:[
        {t:'Dashboard', a:"goTo('dashboard')"},
        {t:'Users & roles', a:"goTo('users')"},
        {t:'Audit log', a:"goTo('audit')"},
        {t:'Reports', a:"goTo('reports')"}
      ]
    }
  };
  var AI_DEFAULT = {
    greet:'Hi {name}, I\u2019m Tranquil AI — your assistant. How can I help today?',
    chips:[ {t:'Go to dashboard', a:"goTo('dashboard')"}, {t:'View patients', a:"goTo('patients')"} ]
  };

  function aiProfile(){
    var role=(CU().role||'').toLowerCase();
    var keys=Object.keys(AI_KB);
    for(var i=0;i<keys.length;i++){ if(role.indexOf(keys[i])>=0) return AI_KB[keys[i]]; }
    return AI_DEFAULT;
  }

  function aiAnswer(q){
    q=(q||'').toLowerCase();
    var d=D_();
    if(/bed|occup|admit/.test(q)){
      var bo=(d.beds||[]).filter(function(b){return b.status==='Occupied';}).length;
      var bt=(d.beds||[]).length;
      return 'Bed status: '+bo+'/'+bt+' occupied ('+(bt?Math.round(bo/bt*100):0)+'%). '+(isNurse()?'You can admit a patient from the Beds module.':'')+' <a href="#" onclick="goTo(\'beds\');return false" style="color:var(--pri);font-weight:700">Open Beds</a>';
    }
    if(/patient|how many/.test(q)){
      var adm=(d.patients||[]).filter(function(p){return p.status==='Admitted';}).length;
      var out=(d.patients||[]).filter(function(p){return p.status==='Outpatient';}).length;
      return 'There are '+((d.patients||[]).length)+' patients — '+adm+' admitted, '+out+' outpatient. <a href="#" onclick="goTo(\'patients\');return false" style="color:var(--pri);font-weight:700">Open Patients</a>';
    }
    if(/handover|discharge/.test(q)){
      return 'You can submit a Discharge & Handover note anytime. <a href="#" onclick="twhDischargeHandoverForm();return false" style="color:var(--pri);font-weight:700">New note</a> · <a href="#" onclick="twhViewHandoverNotes();return false" style="color:var(--pri);font-weight:700">View notes</a>';
    }
    if(/appoint|schedule/.test(q)){
      return 'There are '+((d.appointments||[]).length)+' appointments booked. <a href="#" onclick="goTo(\'appointments\');return false" style="color:var(--pri);font-weight:700">Open Appointments</a>';
    }
    if(/lab|result/.test(q)){
      return 'Open the Laboratory module to review orders and flag critical results. <a href="#" onclick="goTo(\'laboratory\');return false" style="color:var(--pri);font-weight:700">Open Lab</a>';
    }
    if(/hello|hi|hey|help/.test(q)){
      return aiProfile().greet.replace('{name}', CU().fullName||'there');
    }
    return 'I\u2019m tuned to your role ('+ESC(CU().role||'Staff')+'). Try the quick actions below, or ask about beds, patients, appointments, labs, or handover notes.';
  }

  window.twhAiSend = function(){
    var inp=document.getElementById('twhAiInput'); if(!inp) return;
    var q=inp.value.trim(); if(!q) return;
    var log=document.getElementById('twhAiLog'); if(!log) return;
    log.innerHTML += '<div style="text-align:right;margin:6px 0"><span style="display:inline-block;background:var(--pri);color:#fff;padding:7px 11px;border-radius:12px 12px 2px 12px;font-size:13px;max-width:80%">'+ESC(q)+'</span></div>';
    var ans=aiAnswer(q);
    log.innerHTML += '<div style="margin:6px 0"><span style="display:inline-block;background:#f1f5f9;color:#0f172a;padding:7px 11px;border-radius:12px 12px 12px 2px;font-size:13px;max-width:85%">'+ans+'</span></div>';
    inp.value='';
    log.scrollTop=log.scrollHeight;
  };
  window.twhAiChip = function(action){
    try{ (new Function(action))(); }catch(e){}
    window.twhAiClose();
  };
  window.twhAiToggle = function(){
    var p=document.getElementById('twhAiPanel'); if(!p) return;
    var open = p.style.display==='flex';
    p.style.display = open?'none':'flex';
    if(!open){
      var log=document.getElementById('twhAiLog');
      if(log && !log.getAttribute('data-greeted')){
        log.setAttribute('data-greeted','1');
        var prof=aiProfile();
        log.innerHTML = '<div style="margin:6px 0"><span style="display:inline-block;background:#f1f5f9;color:#0f172a;padding:7px 11px;border-radius:12px 12px 12px 2px;font-size:13px;max-width:85%">'+prof.greet.replace('{name}', ESC(CU().fullName||'there'))+'</span></div>';
      }
      var inp=document.getElementById('twhAiInput'); if(inp) setTimeout(function(){inp.focus();},50);
    }
  };
  window.twhAiClose = function(){ var p=document.getElementById('twhAiPanel'); if(p) p.style.display='none'; };

  function injectAI(){
    if(document.getElementById('twhAiLauncher')) { refreshAiChips(); return; }
    // Only show for logged-in users (app shell present)
    var app=document.getElementById('app'); if(!app) return;
    var prof=aiProfile();
    var chips=prof.chips.map(function(c){
      return '<button onclick="twhAiChip(\''+c.a.replace(/'/g,"\\'")+'\')" style="border:1px solid #d1d5db;background:#fff;border-radius:999px;padding:5px 10px;font-size:12px;cursor:pointer;color:#0f172a;font-family:inherit">'+ESC(c.t)+'</button>';
    }).join(' ');

    var host=document.createElement('div');
    host.id='twhAiHost';
    host.innerHTML =
      '<div id="twhAiPanel" style="display:none;flex-direction:column;position:fixed;right:20px;bottom:88px;width:340px;max-width:92vw;height:460px;max-height:74vh;background:#fff;border-radius:16px;box-shadow:0 18px 50px rgba(0,0,0,.25);z-index:99998;overflow:hidden;border:1px solid #e5e7eb">'
      + '<div style="background:linear-gradient(135deg,#0d9488,#14b8a6);color:#fff;padding:12px 14px;display:flex;align-items:center;gap:9px">'
      + '<div style="width:32px;height:32px;border-radius:50%;background:rgba(255,255,255,.2);display:flex;align-items:center;justify-content:center"><i class="fa-solid fa-robot"></i></div>'
      + '<div style="flex:1"><div style="font-weight:800;font-size:14px">Tranquil AI</div><div id="twhAiRole" style="font-size:11px;opacity:.9">'+ESC(CU().role||'Assistant')+'</div></div>'
      + '<button onclick="twhAiClose()" style="background:none;border:none;color:#fff;font-size:18px;cursor:pointer">&times;</button></div>'
      + '<div id="twhAiLog" style="flex:1;overflow:auto;padding:12px;background:#fafafa"></div>'
      + '<div id="twhAiChips" style="padding:8px 10px;display:flex;gap:6px;flex-wrap:wrap;border-top:1px solid #f1f5f9;background:#fff">'+chips+'</div>'
      + '<div style="display:flex;gap:6px;padding:10px;border-top:1px solid #f1f5f9;background:#fff">'
      + '<input id="twhAiInput" placeholder="Ask Tranquil AI..." onkeydown="if(event.key===\'Enter\')twhAiSend()" style="flex:1;border:1px solid #d1d5db;border-radius:10px;padding:9px 11px;font-size:13px;font-family:inherit;outline:none">'
      + '<button onclick="twhAiSend()" class="btn btn-pri btn-sm" style="border-radius:10px"><i class="fa-solid fa-paper-plane"></i></button></div>'
      + '</div>'
      + '<button id="twhAiLauncher" onclick="twhAiToggle()" title="Tranquil AI" style="position:fixed;right:20px;bottom:20px;width:58px;height:58px;border-radius:50%;border:none;cursor:pointer;background:linear-gradient(135deg,#0d9488,#14b8a6);color:#fff;box-shadow:0 10px 28px rgba(13,148,136,.5);z-index:99999;font-size:22px">'
      + '<i class="fa-solid fa-robot"></i></button>';
    document.body.appendChild(host);
  }
  function refreshAiChips(){
    var box=document.getElementById('twhAiChips'); if(!box) return;
    var role=document.getElementById('twhAiRole'); if(role) role.textContent = CU().role||'Assistant';
    var prof=aiProfile();
    box.innerHTML = prof.chips.map(function(c){
      return '<button onclick="twhAiChip(\''+c.a.replace(/'/g,"\\'")+'\')" style="border:1px solid #d1d5db;background:#fff;border-radius:999px;padding:5px 10px;font-size:12px;cursor:pointer;color:#0f172a;font-family:inherit">'+ESC(c.t)+'</button>';
    }).join(' ');
    // reset greeting if role changed
    var log=document.getElementById('twhAiLog'); if(log) log.setAttribute('data-greeted','');
  }

  /* ================================================================
     BOOT / SELF-ASSERT
     ================================================================ */
  function apply(){
    try{ wrapBedFns(); }catch(e){}
    try{ injectBedActions(); }catch(e){}
    try{ injectDashboardBlock(); }catch(e){}
    try{ if((D_().currentUser)) injectAI(); }catch(e){}
    // Tranquil AI is a DASHBOARD-ONLY assistant: show launcher only on the dashboard.
    try{ var _l=document.getElementById('twhAiLauncher'); var _p=document.getElementById('twhAiPanel'); var _onDash=(CURMOD()==='dashboard'||CURMOD()===''); if(_l) _l.style.display=_onDash?'':'none'; if(!_onDash&&_p) _p.style.display='none'; }catch(e){}
  }
  try{ apply(); }catch(e){}
  [0,150,400,900,1800,3000].forEach(function(t){ setTimeout(apply,t); });
  DOMBus.register(apply);
  window.addEventListener('load', function(){ setTimeout(apply,250); });
  try{ if(window.HMS_DB && typeof window.HMS_DB.onState==='function'){ window.HMS_DB.onState('idle', function(){ setTimeout(apply,120); }); } }catch(e){}

  console.log('✅ v213 nurse care loaded');
})();

;

/* ==== /js/164-twh-persist-delete-ai-v215.js ==== */
/* ============================================================================
   Tranquil HMS — v215 pack
   1) PERSIST: universal push-hooks on labTests / labOrders / radiologyOrders /
      appointments / medicalRecords so every new order/record saves to D1 and
      is always viewable after re-login (covers ALL save code-paths).
   2) ADMIN DELETE: admin-only Delete buttons injected into the Appointments,
      Medical Records (EMR), Laboratory and Radiology action rows.
   3) TRANQUIL AI: restrict the v213 assistant launcher/panel to the Dashboard
      view only (hidden in every other module).
   Idempotent, self-asserting IIFE. Guarded by window.__twhV215.
   ============================================================================ */
(function(){
  if(window.__twhV215) return; window.__twhV215 = true;

  function D_(){ try{ return (typeof D!=='undefined'&&D)?D:(window.D||null); }catch(e){ return window.D||null; } }
  function SAVE(){ try{ if(typeof window._hmsSave==='function') return window._hmsSave(); if(typeof window._hmsSaveSoon==='function') return window._hmsSaveSoon(); }catch(e){} }
  var _pt=null;
  function SAVE_SOON(){ try{ if(typeof window._hmsSaveSoon==='function') return window._hmsSaveSoon(); if(_pt) clearTimeout(_pt); _pt=setTimeout(function(){ _pt=null; SAVE(); },250); }catch(e){} }
  function CURMOD(){ try{ return (typeof currentMod!=='undefined')?currentMod:(window.currentMod||''); }catch(e){ return ''; } }
  function CU(){ var d=D_(); return (d&&d.currentUser)?d.currentUser:{role:''}; }
  function isAdmin(){
    var r=(CU().role||'').toLowerCase();
    return r.indexOf('admin')>=0 || r.indexOf('super')>=0 || r==='ceo';
  }

  /* ================================================================
     (1) UNIVERSAL PERSISTENCE — push-hooks on clinical collections.
     Any code path that does D.<key>.push(...) will now persist to D1.
     ================================================================ */
  var PERSIST_KEYS = ['labTests','labOrders','radiologyOrders','appointments','medicalRecords','prescriptions','mealPlans','handoverNotes'];
  function installPushHook(key){
    var d=D_(); if(!d) return false;
    if(!Array.isArray(d[key])) d[key]=[];
    var arr=d[key];
    if(arr.__twhV215push) return true;
    var basePush=arr.push.bind(arr);
    arr.push=function(){
      var r=basePush.apply(null,arguments);
      try{ SAVE_SOON(); }catch(e){}
      return r;
    };
    // also persist on splice (used by deletes/edits in some paths)
    var baseSplice=arr.splice.bind(arr);
    arr.splice=function(){
      var r=baseSplice.apply(null,arguments);
      try{ SAVE_SOON(); }catch(e){}
      return r;
    };
    arr.__twhV215push=true;
    return true;
  }
  function installAllHooks(){ PERSIST_KEYS.forEach(installPushHook); }

  // Mutation-signature watcher: if a collection changes by any means
  // (e.g. array replaced by filter in deleteRecord), persist.
  var _sig={};
  function sigOf(key){
    var d=D_(); if(!d||!Array.isArray(d[key])) return '0';
    var a=d[key], s=a.length+'|';
    for(var i=0;i<a.length;i++){ var x=a[i]||{}; s+=(x.id||'')+':'+(x.status||'')+':'+(x._rev||'')+';'; }
    return s;
  }
  function watch(){
    PERSIST_KEYS.forEach(function(k){
      installPushHook(k);
      var s=sigOf(k);
      if(_sig[k]===undefined){ _sig[k]=s; return; }
      if(s!==_sig[k]){ _sig[k]=s; SAVE_SOON(); }
    });
  }

  /* ================================================================
     (2) ADMIN DELETE — inject Delete buttons for appointments / EMR /
     lab / radiology. Uses the existing deleteRecord(dataKey,id).
     We scan action rows for the module-specific edit button (which
     carries the dataKey + id) and append a matching delete button.
     ================================================================ */
  function moduleDataKey(){
    switch(CURMOD()){
      case 'appointments': return 'appointments';
      case 'emr':          return 'medicalRecords';
      case 'laboratory':   return 'labTests';
      case 'radiology':    return 'radiologyOrders';
      default:             return null;
    }
  }
  function injectAdminDelete(){
    var key=moduleDataKey();
    if(!key) return;
    if(!isAdmin()) return; // Only Admin / System Administrator / Super
    var app=document.getElementById('app'); if(!app) return;
    // Find edit buttons whose onclick references editRecord('<key>', <id>)
    var re=new RegExp("editRecord\\(\\s*['\"]"+key+"['\"]\\s*,\\s*(\\d+)");
    var btns=app.querySelectorAll('button[onclick*="editRecord"]');
    btns.forEach(function(b){
      var oc=b.getAttribute('onclick')||'';
      var m=oc.match(re);
      if(!m) return;
      var id=m[1];
      var row=b.closest('.act-row')||b.parentNode;
      if(!row) return;
      if(row.querySelector('.twh-admin-del[data-k="'+key+'"][data-id="'+id+'"]')) return;
      var del=document.createElement('button');
      del.className='act-btn del twh-admin-del';
      del.title='Delete (Admin)';
      del.setAttribute('data-k',key);
      del.setAttribute('data-id',id);
      del.innerHTML='<i class="fa-solid fa-trash"></i>';
      del.onclick=function(ev){
        ev.stopPropagation();
        try{ window.twhAdminDelete(key, Number(id)); }catch(e){}
      };
      row.appendChild(del);
    });
  }
  window.twhAdminDelete = function(key, id){
    if(!isAdmin()){ if(typeof toast==='function') toast('Only administrators can delete this record','err'); return; }
    var label={appointments:'appointment',medicalRecords:'medical record',labTests:'lab order',radiologyOrders:'radiology order'}[key]||'record';
    if(!confirm('Delete this '+label+'? This cannot be undone.')) return;
    try{
      if(typeof window.deleteRecord==='function'){
        window._skipDelConfirm=true;
        window.deleteRecord(key, id);
        window._skipDelConfirm=false;
      } else {
        var d=D_(); if(d && Array.isArray(d[key])) d[key]=d[key].filter(function(x){return x.id!==id;});
        if(typeof render==='function') render();
      }
      SAVE();
      if(typeof toast==='function') toast(label.charAt(0).toUpperCase()+label.slice(1)+' deleted','err');
    }catch(e){ if(typeof toast==='function') toast('Delete failed: '+e.message,'err'); }
  };

  /* ================================================================
     (3) TRANQUIL AI — dashboard-only visibility.
     The v213 pack renders a fixed launcher (#twhAiLauncher) + panel
     (#twhAiPanel). Show them only when currentMod==='dashboard'.
     ================================================================ */
  function gateAI(){
    var launcher=document.getElementById('twhAiLauncher');
    var panel=document.getElementById('twhAiPanel');
    var onDash=(CURMOD()==='dashboard' || CURMOD()==='' );
    // Only show once the user is logged in (app shell present + currentUser)
    var loggedIn=!!(D_() && D_().currentUser) && !!document.getElementById('app');
    var show = onDash && loggedIn;
    if(launcher) launcher.style.display = show ? '' : 'none';
    if(!show && panel) panel.style.display='none';
  }

  /* ================================================================
     BOOT / SELF-ASSERT
     ================================================================ */
  function apply(){
    try{ installAllHooks(); }catch(e){}
    try{ watch(); }catch(e){}
    try{ injectAdminDelete(); }catch(e){}
    try{ gateAI(); }catch(e){}
  }
  try{ apply(); }catch(e){}
  [0,150,400,900,1800,3000].forEach(function(t){ setTimeout(apply,t); });
  DOMBus.register(apply);
  window.addEventListener('load', function(){ setTimeout(apply,250); });
  try{ if(window.HMS_DB && typeof window.HMS_DB.onState==='function'){ window.HMS_DB.onState('idle', function(){ setTimeout(apply,120); }); } }catch(e){}

  console.log('✅ v215 persistence + admin delete');
})();

;

/* ==== /js/165-twh-sync-appt-v216.js ==== */
/* ─────────────────────────────────────────────────────────────────────────
   Tranquil HMS — Enhancement pack v216
   (1) Robust save: flush the PRESENT pending update to D1 and surface a clean
       success/failure. The underlying sync engine (doWrite/_sendBatchAdaptive)
       now sends smaller (~300KB) batches AND retries transient HTTP 503 with
       exponential backoff, so a briefly-overloaded Worker recovers on its own.
   (2) window.twhSyncNow() — force-flush the current state (used by "Retry now"
       and after any big create) and toast the result.
   (3) Detailed appointment view — twhApptDetail(id) renders a full clinical
       appointment card (patient, doctor, dept, schedule, reason, notes, linked
       medical records & prescriptions) instead of the raw key/value dump.
   Idempotent, self-asserting IIFE. Guarded by window.__twhV216.
   ──────────────────────────────────────────────────────────────────────── */
(function(){
  if(window.__twhV216) return; window.__twhV216 = true;
  function D_(){ try{ return (typeof D!=='undefined'&&D)?D:(window.D||{}); }catch(e){ return window.D||{}; } }
  function T(m,t){ try{ if(typeof toast==='function') return toast(m,t); }catch(e){} try{ if(window.toast) return window.toast(m,t); }catch(e){} }
  function esc2(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }

  /* ── (1)/(2) Force-flush the present update to D1 with a clean result toast. */
  window.twhSyncNow = function(){
    try{
      if(typeof window._hmsSave === 'function'){
        var p = window._hmsSave();
        if(p && typeof p.then === 'function'){
          return p.then(function(){
            var st=null; try{ st=(window.HMS_DB&&window.HMS_DB.syncState)||null; }catch(e){}
            if(st==='error'){ T('Still syncing — will keep retrying automatically','err'); }
            else { T('All changes saved','ok'); }
          }).catch(function(){ T('Save queued — retrying automatically','err'); });
        }
      }
    }catch(e){}
    return Promise.resolve();
  };

  /* ── (3) Detailed appointment view ─────────────────────────────────────── */
  function findAppt(id){ var arr=(D_().appointments)||[]; for(var i=0;i<arr.length;i++){ if(String(arr[i].id)===String(id)) return arr[i]; } return null; }
  function nameP(v){ try{ if(typeof pat==='function') return pat(v); }catch(e){} return v||'—'; }
  function nameD(v){ try{ if(typeof doc==='function') return doc(v); }catch(e){} return v||'—'; }
  function nameDept(v){ try{ if(typeof dept==='function') return dept(v); }catch(e){} return v||'—'; }
  function statusChip(s){ try{ if(typeof stc==='function') return '<span class="st '+stc(s)+'">'+esc2(s)+'</span>'; }catch(e){} return esc2(s||'—'); }
  function patObj(id){ var arr=(D_().patients)||[]; for(var i=0;i<arr.length;i++){ if(String(arr[i].id)===String(id)) return arr[i]; } return null; }

  window.twhApptDetail = function(id){
    var a = findAppt(id);
    if(!a){ T('Appointment not found','err'); return; }
    var D = D_();
    var p = patObj(a.patientId);
    var mrn = p ? (p.mrn||p.code||'') : '';
    var phone = p ? (p.phone||p.mobile||p.contact||'') : '';
    // Linked clinical activity for this patient (loose id match).
    function forPatient(arr){ arr=arr||[]; var pid=a.patientId; var out=[]; for(var i=0;i<arr.length;i++){ if(String(arr[i].patientId)===String(pid)) out.push(arr[i]); } return out; }
    var recs = forPatient(D.medicalRecords).slice(-5).reverse();
    var rx   = forPatient(D.prescriptions).slice(-5).reverse();
    var labs = forPatient(D.labTests).slice(-5).reverse();

    function item(label,val,accent){
      return '<div style="background:var(--bg2,#f8fafc);border:1px solid var(--bdr,#e2e8f0);border-radius:10px;padding:10px 12px">'+
             '<div style="font-size:10px;text-transform:uppercase;letter-spacing:.04em;color:var(--txt3,#94a3b8);font-weight:700;margin-bottom:3px">'+esc2(label)+'</div>'+
             '<div style="font-size:14px;font-weight:600;color:'+(accent||'var(--txt,#0f172a)')+'">'+val+'</div></div>';
    }
    var grid =
      '<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(150px,1fr));gap:10px;margin-bottom:14px">'+
        item('Appointment Code','<b>'+esc2(a.code||('#'+a.id))+'</b>')+
        item('Status', statusChip(a.status))+
        item('Type', a.type?statusChip(a.type):'—')+
        item('Date', esc2(a.date||'—'))+
        item('Time', esc2(a.time||'—'))+
        item('Duration', esc2((a.duration||30)+' min'))+
      '</div>';

    var people =
      '<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(180px,1fr));gap:10px;margin-bottom:14px">'+
        item('Patient', esc2(nameP(a.patientId)) + (mrn?(' <span style="color:var(--txt3,#94a3b8);font-size:11px">['+esc2(mrn)+']</span>'):''))+
        item('Attending Doctor', esc2(nameD(a.doctorId)))+
        item('Department', esc2(nameDept(a.deptId)))+
        (phone?item('Patient Phone', esc2(phone)):'')+
      '</div>';

    var reasonBlock =
      '<div style="background:#eff6ff;border:1px solid #bfdbfe;border-radius:10px;padding:12px 14px;margin-bottom:12px">'+
        '<div style="font-size:11px;font-weight:700;color:#1e40af;text-transform:uppercase;letter-spacing:.04em;margin-bottom:4px"><i class="fa-solid fa-notes-medical"></i> Reason for Visit</div>'+
        '<div style="font-size:13px;color:#0f172a;line-height:1.5">'+esc2(a.reason||'Not specified')+'</div>'+
        (a.notes?('<div style="margin-top:8px;font-size:12px;color:#475569"><b>Notes:</b> '+esc2(a.notes)+'</div>'):'')+
      '</div>';

    function miniTable(title,icon,rows,cols){
      if(!rows.length) return '<div style="margin-bottom:10px"><div style="font-size:12px;font-weight:700;color:var(--txt2,#334155);margin-bottom:5px"><i class="fa-solid '+icon+'"></i> '+esc2(title)+'</div><div style="font-size:12px;color:var(--txt3,#94a3b8);padding:6px 0">None on record for this patient.</div></div>';
      var head=cols.map(function(c){return '<th style="text-align:left;font-size:10px;color:var(--txt3,#94a3b8);padding:4px 8px;border-bottom:1px solid var(--bdr,#e2e8f0)">'+esc2(c.l)+'</th>';}).join('');
      var body=rows.map(function(r){ return '<tr>'+cols.map(function(c){ var v=c.f?c.f(r):(r[c.k]==null?'—':r[c.k]); return '<td style="font-size:12px;padding:4px 8px;border-bottom:1px solid var(--bg2,#f1f5f9)">'+v+'</td>'; }).join('')+'</tr>'; }).join('');
      return '<div style="margin-bottom:10px"><div style="font-size:12px;font-weight:700;color:var(--txt2,#334155);margin-bottom:5px"><i class="fa-solid '+icon+'"></i> '+esc2(title)+'</div><div style="overflow:auto"><table style="width:100%;border-collapse:collapse"><thead><tr>'+head+'</tr></thead><tbody>'+body+'</tbody></table></div></div>';
    }
    var clinical =
      '<div style="border-top:1px solid var(--bdr,#e2e8f0);padding-top:12px;margin-top:4px">'+
        '<h4 style="font-size:13px;font-weight:700;margin:0 0 10px;color:var(--txt,#0f172a)">Patient clinical summary (recent)</h4>'+
        miniTable('Medical records','fa-file-medical', recs, [
          {l:'Date', f:function(r){return esc2(r.visitDate||r.date||'—');}},
          {l:'Type', f:function(r){return esc2(r.visitType||'—');}},
          {l:'Diagnosis', f:function(r){return esc2(r.diagnosis||'—');}},
          {l:'Status', f:function(r){return statusChip(r.status);}}
        ])+
        miniTable('Lab tests','fa-flask', labs, [
          {l:'Test', f:function(r){return esc2(r.testType||'—');}},
          {l:'Date', f:function(r){return esc2(r.orderDate||'—');}},
          {l:'Priority', f:function(r){return esc2(r.priority||'—');}},
          {l:'Status', f:function(r){return statusChip(r.status);}}
        ])+
        miniTable('Prescriptions','fa-prescription', rx, [
          {l:'Code', f:function(r){return esc2(r.code||'—');}},
          {l:'Date', f:function(r){return esc2(r.date||'—');}},
          {l:'Status', f:function(r){return statusChip(r.status);}}
        ])+
      '</div>';

    var body = '<div style="font-size:13px">'+grid+people+reasonBlock+clinical+'</div>';
    var foot =
      '<button class="btn btn-ghost" onclick="editRecord(\'appointments\','+a.id+')"><i class="fa-solid fa-edit"></i> Edit</button>'+
      '<button class="btn btn-ghost" onclick="printRecord(\'appointments\','+a.id+')"><i class="fa-solid fa-print"></i> Print</button>'+
      '<button class="btn btn-ghost" onclick="closeModal&&closeModal()">Close</button>';
    var head = '<i class="fa-solid fa-calendar-check" style="color:var(--pri,#0d9488);margin-right:8px"></i>Appointment — '+esc2(a.code||('#'+a.id));
    if(typeof window.showModal==='function'){ window.showModal(head, body, foot, 'lg'); }
  };

  /* Route the appointment "View" (eye) action to the detailed card by wrapping
     viewRecord: for dataKey==='appointments' delegate to twhApptDetail. */
  function installViewWrap(){
    if(window.__twhV216viewWrap) return;
    if(typeof window.viewRecord !== 'function') return;
    var orig = window.viewRecord;
    window.viewRecord = function(dataKey, id){
      if(dataKey==='appointments'){ try{ return window.twhApptDetail(id); }catch(e){} }
      return orig.apply(this, arguments);
    };
    window.__twhV216viewWrap = true;
  }

  function apply(){ try{ installViewWrap(); }catch(e){} }
  apply();
  [0,150,400,900,1800,3000].forEach(function(ms){ setTimeout(apply, ms); });
  DOMBus.register(apply);
  try{ window.addEventListener('load', apply); }catch(e){}
  try{ if(window.HMS_DB && window.HMS_DB.onState) window.HMS_DB.onState(function(s){ if(s==='idle') apply(); }); }catch(e){}

  try{ console.log('%c✅ v216','color:#0d9488;font-weight:700','sync backoff + detailed appointment view active'); }catch(e){}
})();

;

/* ==== /js/166-twh-wellness-actions-v217.js ==== */
/* ─────────────────────────────────────────────────────────────────────────
   Tranquil HMS — Enhancement pack v217
   Wellness Screening & Assessment — ACTION COLUMN for L1/L2/L3 tables.
   The wellness level tables (Rapid Screening RWS-, Risk Assessment WMR-,
   Comprehensive CWA-) previously had no per-row actions. This pack decorates
   those tables (they are built by a closure we can't edit inline) and adds a
   proper Actions column: View · Edit · Print · Delete — plus, where relevant,
   a Bill (pricing) action that posts the wellness service charge. Every
   mutation persists to D1 via _hmsSave so sync stays clean.
   Idempotent, self-asserting IIFE. Guarded by window.__twhV217.
   ──────────────────────────────────────────────────────────────────────── */
(function(){
  if(window.__twhV217) return; window.__twhV217 = true;
  function D_(){ try{ return (typeof D!=='undefined'&&D)?D:(window.D||{}); }catch(e){ return window.D||{}; } }
  function T(m,t){ try{ if(typeof toast==='function') return toast(m,t); }catch(e){} try{ if(window.toast) return window.toast(m,t); }catch(e){} }
  function SAVE(){ try{ if(typeof window._hmsSave==='function') return window._hmsSave(); }catch(e){} }
  function RENDER(){ try{ if(typeof render==='function') return render(); }catch(e){} }
  function esc2(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  function money(n){ n=Number(n)||0; return '₦'+n.toLocaleString('en-NG'); }
  function pName(id){ var p=(D_().patients||[]).find(function(x){return String(x.id)===String(id);}); return p?(p.fullName||p.name||('#'+id)):('#'+id); }
  function riskColor(r){ r=(r||'').toLowerCase(); if(r.indexOf('severe')>-1) return '#ef4444'; if(r.indexOf('high')>-1) return '#f97316'; if(r.indexOf('moderate')>-1) return '#f59e0b'; if(r.indexOf('mild')>-1) return '#3b82f6'; return '#22c55e'; }
  function riskBadge(r){ return '<span style="background:'+riskColor(r)+';color:#fff;padding:3px 10px;border-radius:99px;font-size:11px;font-weight:700;white-space:nowrap">'+esc2(r||'—')+'</span>'; }

  // Map a wellness level (1/2/3) → its D data array key + code prefix.
  var LVL = {
    1:{ key:'wellnessScreenings',       prefix:'RWS-', title:'Rapid Wellness Screening',           open:'wOpenL1' },
    2:{ key:'wellnessRiskAssessments',  prefix:'WMR-', title:'Wellness & Malnutrition Risk',        open:'wOpenL2' },
    3:{ key:'comprehensiveAssessments', prefix:'CWA-', title:'Comprehensive Wellness Assessment',   open:'wOpenL3' }
  };
  function levelOf(code){ code=String(code||''); if(code.indexOf('RWS-')===0) return 1; if(code.indexOf('WMR-')===0) return 2; if(code.indexOf('CWA-')===0) return 3; return 0; }
  function recByCode(code){ var lvl=levelOf(code); if(!lvl) return null; var arr=(D_()[LVL[lvl].key])||[]; return arr.find(function(x){return String(x.code)===String(code);})||null; }

  /* ── Wellness service pricing (fee schedule lookup with sensible default) ── */
  function wellnessFee(level){
    var fees=(D_().feeSchedule)||[];
    var want = level===1 ? /rapid|wellness screen|screening/i
             : level===2 ? /risk assess|malnutrition/i
             : /comprehensive|wellness assess|dietician consult|dietitian/i;
    var hit = fees.find(function(f){ return want.test(String(f.service||'')); });
    if(hit) return { amount:Number(hit.amount)||0, service:hit.service, code:hit.code };
    var def = level===1?3000:level===2?5000:15000;
    return { amount:def, service:LVL[level].title+' (wellness service)', code:'WELL-L'+level };
  }

  /* ── VIEW: rich read-only detail of a wellness record ─────────────────── */
  window.twhWellnessView = function(code){
    var r = recByCode(code); if(!r){ T('Record not found','err'); return; }
    var lvl = levelOf(code);
    function item(l,v){ return '<div style="background:var(--bg2,#f8fafc);border:1px solid var(--bdr,#e2e8f0);border-radius:10px;padding:9px 12px"><div style="font-size:10px;text-transform:uppercase;letter-spacing:.04em;color:var(--txt3,#94a3b8);font-weight:700;margin-bottom:3px">'+esc2(l)+'</div><div style="font-size:14px;font-weight:600">'+v+'</div></div>'; }
    var g = '<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(150px,1fr));gap:10px;margin-bottom:12px">'+
      item('Code','<b>'+esc2(r.code)+'</b>')+
      item('Patient', esc2(pName(r.patientId)))+
      item('Date', esc2(r.date||'—'))+
      item('Risk', riskBadge(r.risk))+
      (r.bmi!=null?item('BMI', esc2(r.bmi)):'')+
      (r.whr!=null?item('WHR', esc2(r.whr)):'')+
      (r.total!=null?item('Wellness total', esc2(r.total)):'')+
      (r.malnScore!=null?item('Malnutrition', esc2(r.malnScore+' · '+(r.malnRisk||''))):'')+
      (r.overallScore!=null?item('Overall score', esc2(r.overallScore)):'')+
      (r.dietPlan?item('Diet plan', esc2(r.dietPlan)):'')+
      (r.calories?item('Calories', esc2(r.calories+' kcal')):'')+
      item('Assessed by', esc2(r.by||'—'))+
      item('Status', esc2(r.status||'—'))+
    '</div>';
    var act = r.action?('<div style="background:#eff6ff;border:1px solid #bfdbfe;border-radius:10px;padding:10px 12px;margin-bottom:10px;font-size:13px"><b style="color:#1e40af">Recommended action:</b> '+esc2(r.action)+'</div>'):'';
    var notes = r.notes?('<div style="background:#f8fafc;border:1px solid #e2e8f0;border-radius:10px;padding:10px 12px;font-size:12px;color:#475569"><b>Notes:</b> '+esc2(r.notes)+'</div>'):'';
    var fee = wellnessFee(lvl);
    var billed = r.billed ? ('<div style="margin-top:10px;font-size:12px;color:#16a34a"><i class="fa-solid fa-circle-check"></i> Billed '+money(r.billAmount||fee.amount)+' — '+esc2(r.billRef||'')+'</div>') : ('<div style="margin-top:10px;font-size:12px;color:var(--txt3,#94a3b8)">Service fee: '+money(fee.amount)+' (not yet billed)</div>');
    var foot =
      '<button class="btn btn-ghost" onclick="twhWellnessEdit(\''+esc2(code)+'\')"><i class="fa-solid fa-edit"></i> Edit</button>'+
      '<button class="btn btn-ghost" onclick="twhWellnessPrint(\''+esc2(code)+'\')"><i class="fa-solid fa-print"></i> Print</button>'+
      (r.billed?'':'<button class="btn btn-ghost" onclick="twhWellnessBill(\''+esc2(code)+'\')"><i class="fa-solid fa-money-bill"></i> Bill</button>')+
      '<button class="btn btn-ghost" onclick="closeModal&&closeModal()">Close</button>';
    if(typeof window.showModal==='function') window.showModal('<i class="fa-solid fa-heart-pulse" style="color:#0d9488;margin-right:8px"></i>'+esc2(LVL[lvl].title)+' — '+esc2(code), '<div style="font-size:13px">'+g+act+notes+billed+'</div>', foot, 'lg');
  };

  /* ── EDIT: reopen the level form pre-filled (wOpenL* accepts patientId+id) */
  window.twhWellnessEdit = function(code){
    var r = recByCode(code); if(!r){ T('Record not found','err'); return; }
    var lvl = levelOf(code); var fn = window[LVL[lvl].open];
    try{ closeModal&&closeModal(); }catch(e){}
    if(typeof fn==='function'){ fn(r.patientId, r.id); }
    else { T('Editor unavailable','err'); }
  };

  /* ── DELETE: with confirm + tombstone + sync ──────────────────────────── */
  window.twhWellnessDelete = function(code){
    var r = recByCode(code); if(!r){ T('Record not found','err'); return; }
    var lvl = levelOf(code); var key = LVL[lvl].key;
    if(!confirm('Delete wellness record '+code+' for '+pName(r.patientId)+'? This cannot be undone.')) return;
    var D = D_();
    D[key] = (D[key]||[]).filter(function(x){ return String(x.id)!==String(r.id); });
    try{ if(window._hmsTombstone) window._hmsTombstone(key, r.id); }catch(e){}
    T('Wellness record '+code+' deleted','err');
    SAVE(); RENDER();
  };

  /* ── PRINT: printable clinical summary of the record ──────────────────── */
  window.twhWellnessPrint = function(code){
    var r = recByCode(code); if(!r){ T('Record not found','err'); return; }
    var lvl = levelOf(code);
    var rows = [
      ['Code', r.code],['Patient', pName(r.patientId)],['Date', r.date],['Risk', r.risk],
      ['BMI', r.bmi],['WHR', r.whr],['Wellness total', r.total],
      ['Malnutrition', r.malnScore!=null?(r.malnScore+' · '+(r.malnRisk||'')):null],
      ['Overall score', r.overallScore],['Diet plan', r.dietPlan],['Calories', r.calories?(r.calories+' kcal'):null],
      ['Recommended action', r.action],['Notes', r.notes],['Assessed by', r.by],['Status', r.status]
    ].filter(function(x){ return x[1]!=null && x[1]!==''; });
    var w = window.open('', '_blank');
    if(!w){ T('Pop-up blocked — allow pop-ups to print','err'); return; }
    var html = '<!DOCTYPE html><html><head><title>'+esc2(code)+'</title><meta charset="utf-8">'+
      '<style>body{font-family:Arial,Helvetica,sans-serif;color:#0f172a;padding:32px;max-width:720px;margin:auto}h1{font-size:18px;color:#0d9488;margin:0 0 2px}h2{font-size:13px;color:#64748b;font-weight:500;margin:0 0 18px}table{width:100%;border-collapse:collapse}td{padding:7px 10px;border-bottom:1px solid #e2e8f0;font-size:13px}td.k{color:#64748b;width:200px;font-weight:600}.ft{margin-top:24px;font-size:11px;color:#94a3b8;border-top:1px solid #e2e8f0;padding-top:10px}</style></head><body>'+
      '<h1>Tranquil Hospital &amp; Wellness Centre</h1><h2>'+esc2(LVL[lvl].title)+' — '+esc2(code)+'</h2>'+
      '<table>'+rows.map(function(x){ return '<tr><td class="k">'+esc2(x[0])+'</td><td>'+esc2(x[1])+'</td></tr>'; }).join('')+'</table>'+
      '<div class="ft">Printed '+new Date().toLocaleString()+' · Wellness Screening &amp; Assessment</div>'+
      '<script>window.onload=function(){window.print();}<\/script></body></html>';
    w.document.write(html); w.document.close();
  };

  /* ── BILL: post the wellness service charge (validation + pricing + sync) */
  window.twhWellnessBill = function(code){
    var r = recByCode(code); if(!r){ T('Record not found','err'); return; }
    if(r.billed){ T('Already billed','err'); return; }
    var lvl = levelOf(code); var fee = wellnessFee(lvl);
    if(!r.patientId){ T('No patient on record — cannot bill','err'); return; }
    var D = D_();
    if(!Array.isArray(D.transactions)) D.transactions = [];
    var ref = 'WBILL-'+String(Date.now()).slice(-6);
    var tx = {
      id:(typeof nid==='function'?nid():Date.now()),
      code:ref, date:(new Date().toISOString().split('T')[0]),
      patientId:r.patientId, patientName:pName(r.patientId),
      type:'Charge', category:'Wellness', service:fee.service, feeCode:fee.code,
      amount:fee.amount, status:'Posted', source:'Wellness '+code,
      by:(D.currentUser&&D.currentUser.fullName)||'Staff'
    };
    D.transactions.push(tx);
    r.billed = true; r.billAmount = fee.amount; r.billRef = ref;
    T('Billed '+money(fee.amount)+' for '+fee.service,'ok');
    SAVE(); RENDER();
  };

  /* ── DECORATION: add an Actions column to the wellness level tables ────── */
  function isWellnessMod(){
    try{ if(typeof currentMod!=='undefined' && currentMod==='wellness') return true; }catch(e){}
    try{ if(window.D && window.D.currentMod==='wellness') return true; }catch(e){}
    return false;
  }
  /* Build the standard wellness action-button group (view/edit/print/[bill]/
     delete). `extraFirst` is optional HTML injected as the FIRST button — used
     to fold the Escalation Queue's "Complete" button into this one group so the
     row shows a SINGLE unified Actions column (per the requested UX). */
  function actionGroupHTML(code, extraFirst){
    var rec = recByCode(code);
    var billBtn = (rec && !rec.billed) ? '<button class="btn btn-xs btn-ghost" title="Bill service" onclick="twhWellnessBill(\''+code+'\')" style="padding:3px 7px"><i class="fa-solid fa-money-bill"></i></button>' : (rec&&rec.billed?'<span title="Billed" style="color:#16a34a;font-size:12px;padding:0 4px"><i class="fa-solid fa-circle-check"></i></span>':'');
    return '<div style="display:flex;gap:4px;flex-wrap:nowrap;align-items:center">'+
      (extraFirst||'')+
      '<button class="btn btn-xs btn-ghost" title="View" onclick="twhWellnessView(\''+code+'\')" style="padding:3px 7px"><i class="fa-solid fa-eye"></i></button>'+
      '<button class="btn btn-xs btn-ghost" title="Edit" onclick="twhWellnessEdit(\''+code+'\')" style="padding:3px 7px"><i class="fa-solid fa-edit"></i></button>'+
      '<button class="btn btn-xs btn-ghost" title="Print" onclick="twhWellnessPrint(\''+code+'\')" style="padding:3px 7px"><i class="fa-solid fa-print"></i></button>'+
      billBtn+
      '<button class="btn btn-xs btn-ghost" title="Delete" onclick="twhWellnessDelete(\''+code+'\')" style="padding:3px 7px;color:#ef4444"><i class="fa-solid fa-trash"></i></button>'+
      '</div>';
  }

  /* Is this the Escalation Queue table? Its header carries a "Trigger" column
     and an "Action" column holding a single "Complete" button per row. */
  function isEscalationTable(tbl){
    try{
      var head = tbl.tHead && tbl.tHead.rows[0]; if(!head) return false;
      var txt = (head.textContent||'').toLowerCase();
      return txt.indexOf('trigger')>-1 && txt.indexOf('source')>-1;
    }catch(e){ return false; }
  }

  function decorate(){
    if(!isWellnessMod()) return;
    var tables = document.querySelectorAll('table.tbl');
    tables.forEach(function(tbl){
      var body = tbl.tBodies && tbl.tBodies[0]; if(!body) return;
      var firstRow = body.rows[0]; if(!firstRow) return;
      var firstCode = firstRow.cells[0] ? (firstRow.cells[0].textContent||'').trim() : '';
      var lvl = levelOf(firstCode);
      if(!lvl) return;

      /* ── ESCALATION QUEUE ── fold the standalone "Complete" action into the
         unified Actions group, and drop the now-redundant "Action" column so
         only ONE Actions column remains. */
      if(isEscalationTable(tbl)){
        var thead = tbl.tHead;
        if(thead && thead.rows[0] && !thead.rows[0].__twhEscHdr){
          var hrow = thead.rows[0];
          // Relabel the last header cell ("Action") → "Actions" instead of adding a new one.
          var lastTh = hrow.cells[hrow.cells.length-1];
          if(lastTh){ lastTh.textContent='Actions'; lastTh.className='twh-act-hdr'; }
          hrow.__twhEscHdr = true; hrow.__twhActHdr = true;
        }
        Array.prototype.forEach.call(body.rows, function(tr){
          if(tr.__twhEscRow) return;
          var c0 = tr.cells[0] ? (tr.cells[0].textContent||'').trim() : '';
          if(!levelOf(c0)){ tr.__twhEscRow=true; return; }        // "no pending" placeholder
          var actCell = tr.cells[tr.cells.length-1];              // the standalone Action cell
          var completeBtn = actCell ? actCell.querySelector('button[onclick*="wOpenL"]') : null;
          var completeHTML = '';
          if(completeBtn){
            // Reuse the original Complete button markup verbatim (keeps its onclick target).
            completeHTML = completeBtn.outerHTML;
          }
          // Replace the Action cell's content with the unified group (Complete first).
          if(actCell){
            actCell.className='twh-act-cell';
            actCell.style.whiteSpace='nowrap';
            actCell.innerHTML = actionGroupHTML(c0, completeHTML);
          }
          tr.__twhEscRow=true; tr.__twhActRow=true;
        });
        tbl.__twhV217dec = true;
        return;
      }

      /* ── COMPLETED-RECORDS LIST TABLES ── append an Actions column. */
      var thead2 = tbl.tHead;
      if(thead2 && thead2.rows[0] && !thead2.rows[0].__twhActHdr){
        var th=document.createElement('th'); th.textContent='Actions'; th.className='twh-act-hdr';
        thead2.rows[0].appendChild(th); thead2.rows[0].__twhActHdr=true;
      }
      Array.prototype.forEach.call(body.rows, function(tr){
        if(tr.__twhActRow) return;
        var c0 = tr.cells[0] ? (tr.cells[0].textContent||'').trim() : '';
        var rlvl = levelOf(c0);
        if(!rlvl){ tr.__twhActRow=true; return; } // "no records" placeholder row etc.
        // Skip pending rows that already carry a Complete button (non-escalation edge case).
        if(tr.querySelector('button[onclick*="wOpenL"]') && tr.cells.length<=5){ tr.__twhActRow=true; return; }
        var td = document.createElement('td');
        td.className='twh-act-cell';
        td.style.whiteSpace='nowrap';
        td.innerHTML = actionGroupHTML(c0, '');
        tr.appendChild(td); tr.__twhActRow=true;
      });
      tbl.__twhV217dec = true;
    });
  }

  function apply(){ try{ decorate(); }catch(e){} }
  apply();
  [0,150,400,900,1800,3000].forEach(function(ms){ setTimeout(apply, ms); });
  DOMBus.register(apply);
  try{ window.addEventListener('load', apply); }catch(e){}
  try{ if(window.HMS_DB && window.HMS_DB.onState) window.HMS_DB.onState(function(s){ if(s==='idle') apply(); }); }catch(e){}

  try{ console.log('%c✅ v217','color:#0d9488;font-weight:700','wellness action column (view/edit/print/bill/delete) active'); }catch(e){}
})();

;

/* ==== /js/167-shared-helpers.js ==== */
(function(){
  "use strict";
  if(window.__twhV218) return; window.__twhV218=true;

  /* ── shared helpers ──────────────────────────────────────────────────── */
  function D_(){ try{ if(typeof D!=='undefined'&&D) return D; }catch(e){} return window.D||{}; }
  function TOAST(m,t){ try{ if(typeof toast==='function') toast(m,t||'ok'); }catch(e){} }
  function MODAL(t,b,f,s){ try{ if(typeof showModal==='function') showModal(t,b,f,s); }catch(e){} }
  function CLOSE(){ try{ if(typeof closeModal==='function') closeModal(); }catch(e){} }
  function RENDER(){ try{ if(typeof render==='function') render(); }catch(e){} }
  function SAVE(){ try{ if(typeof window._hmsSave==='function') window._hmsSave(); else if(typeof window._hmsSaveSoon==='function') window._hmsSaveSoon(); }catch(e){} }
  function FMT(n){ try{ return (typeof F==='function')?F(n):('\u20a6'+Number(n||0).toLocaleString()); }catch(e){ return '\u20a6'+(n||0); } }
  function PAT(id){ try{ if(typeof pat==='function') return pat(id);}catch(e){} var p=(D_().patients||[]).find(function(x){return x.id===id;}); return p?(p.fullName||('#'+id)):'\u2014'; }
  function DOCN(id){ try{ if(typeof doc==='function') return doc(id);}catch(e){} return '\u2014'; }
  function STC(s){ try{ if(typeof stc==='function') return stc(s);}catch(e){} return ''; }
  function TODAY(){ try{ if(typeof today==='function') return today(); }catch(e){} try{ if(typeof tdy==='function') return tdy(); }catch(e){} return new Date().toISOString().slice(0,10); }
  function ESC(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function CURMOD(){ try{ if(typeof currentMod!=='undefined'&&currentMod) return currentMod; }catch(e){} return (D_().currentMod||''); }

  /* ═══════════════════════════════════════════════════════════════════════
     H5 — RBAC: grant patient / medical-record visibility to more roles
     ═══════════════════════════════════════════════════════════════════════ */
  var MED_ROLES=['Front Desk Officer','Reception','Receptionist','Pharmacist','Chief Pharmacist',
                 'Pharm Tech','Pharmacy Technician','Lab Scientist','Lab Tech','Lab Technician',
                 'Laboratory Scientist','Nutritionist','Dietitian'];
  /* modules these roles need to reach the patient medical record chart */
  var MED_MODS=['dashboard','patients'];
  function grantMedRoles(){
    var D=D_(); if(!D.responsibilities) D.responsibilities={};
    MED_ROLES.forEach(function(role){
      var rr=D.responsibilities[role]=D.responsibilities[role]||{};
      MED_MODS.forEach(function(m){ if(rr[m]!==true) rr[m]=true; });
    });
  }
  /* the medical-record chart itself must not silently no-op for these roles.
     viewPatient (v114 chart) has no internal role gate, so module access is
     enough; we simply make sure the patients module is reachable. */
  window.twhCanViewMedicalRecord=function(){
    try{
      var u=(typeof currentUserObj==='function')?currentUserObj():null;
      if(!u) return true;
      var role=u.role||'Staff';
      if(role==='System Administrator'||role==='Super System Admin') return true;
      if(MED_ROLES.indexOf(role)>-1) return true;
      return (typeof hasModuleAccess==='function')?hasModuleAccess('patients'):true;
    }catch(e){ return true; }
  };

  /* ═══════════════════════════════════════════════════════════════════════
     H4 — per-patient clinical history modal
     ═══════════════════════════════════════════════════════════════════════ */
  function histTable(title,cols,rows,empty){
    var head=cols.map(function(c){return '<th'+(c.r?' style="text-align:right"':'')+'>'+ESC(c.l)+'</th>';}).join('');
    var body=rows.length?rows.join(''):'<tr><td colspan="'+cols.length+'" style="text-align:center;color:var(--txt3);padding:14px">'+ESC(empty||'None on record')+'</td></tr>';
    return '<div class="card" style="margin-bottom:12px"><div class="card-hd"><h3 style="font-size:14px">'+title+' <span class="twh-pill-soft">'+rows.length+'</span></h3></div>'
      +'<div class="tbl-wrap"><table class="tbl"><thead><tr>'+head+'</tr></thead><tbody>'+body+'</tbody></table></div></div>';
  }
  window.twhPatientHistory=function(pid){
    var D=D_();
    pid=(typeof pid==='string'&&/^\d+$/.test(pid))?parseInt(pid,10):pid;
    var p=(D.patients||[]).find(function(x){return x.id===pid;});
    if(!p){ TOAST('Patient not found','err'); return; }
    if(!window.twhCanViewMedicalRecord()){ TOAST('You do not have access to patient history','err'); return; }

    var appts=(D.appointments||[]).filter(function(a){return a.patientId===pid;})
      .sort(function(a,b){return String(b.date||'').localeCompare(String(a.date||''));});
    var encs=(D.medicalRecords||[]).filter(function(r){return r.patientId===pid;})
      .sort(function(a,b){return String(b.visitDate||'').localeCompare(String(a.visitDate||''));});
    var rxs=(D.prescriptions||[]).filter(function(r){return r.patientId===pid;}).slice().reverse();
    var labs=(D.labTests||[]).filter(function(l){return l.patientId===pid;}).slice().reverse();
    var imgs=(D.radiologyOrders||[]).filter(function(r){return r.patientId===pid;}).slice().reverse();
    var bills=(D.bills||[]).filter(function(b){return b.patientId===pid;}).slice().reverse();

    var head='<div style="display:flex;justify-content:space-between;align-items:flex-start;flex-wrap:wrap;gap:10px;margin-bottom:12px;padding:12px 14px;border-radius:12px;background:linear-gradient(135deg,#0d9488,#14b8a6);color:#fff">'
      +'<div><div style="font-size:17px;font-weight:800">'+ESC(p.fullName)+'</div>'
      +'<div style="font-size:12px;opacity:.95;margin-top:2px">'+ESC(p.mrn||'')+' \u00b7 '+ESC(p.gender||'')+' \u00b7 '+((p.age!=null&&p.age!=='')?ESC(p.age)+'y':'\u2014')+' \u00b7 Blood '+ESC(p.bloodGroup||'\u2014')+'</div></div>'
      +'<button class="btn btn-sm" style="background:rgba(255,255,255,.2);color:#fff;border:1px solid rgba(255,255,255,.35)" onclick="closeModal();(window.viewPatient||function(){})('+pid+')"><i class="fa-solid fa-folder-open"></i> Full Medical Record</button>'
      +'</div>';

    var apptRows=appts.map(function(a){ return '<tr><td><b>'+ESC(a.code||'')+'</b></td><td>'+ESC(a.date||'')+'</td><td>'+ESC(a.time||'')+'</td><td>'+ESC(DOCN(a.doctorId))+'</td><td><span class="st '+STC(a.type)+'">'+ESC(a.type||'')+'</span></td><td><span class="st '+STC(a.status)+'">'+ESC(a.status||'')+'</span></td></tr>'; });
    var encRows=encs.map(function(r){ return '<tr><td><b>'+ESC(r.code||'')+'</b></td><td>'+ESC(r.visitDate||'')+'</td><td>'+ESC(r.visitType||'')+'</td><td style="max-width:220px">'+ESC(r.diagnosis||'\u2014')+'</td><td><span class="st '+STC(r.status)+'">'+ESC(r.status||'')+'</span></td><td><button class="act-btn" title="View" onclick="closeModal();(window.viewRecord||function(){})(\'medicalRecords\','+r.id+')"><i class="fa-solid fa-eye"></i></button></td></tr>'; });
    var rxRows=rxs.map(function(r){ var n=(r.items||[]).length; return '<tr><td><b>'+ESC(r.code||'')+'</b></td><td>'+ESC(r.date||'')+'</td><td>'+ESC(DOCN(r.doctorId))+'</td><td style="text-align:right">'+n+'</td><td><span class="st '+STC(r.status)+'">'+ESC(r.status||'')+'</span></td></tr>'; });
    var labRows=labs.map(function(l){ return '<tr><td><b>'+ESC(l.code||'')+'</b></td><td>'+ESC(l.testType||l.test||'')+'</td><td>'+ESC(l.category||'')+'</td><td>'+ESC(l.orderDate||l.date||'')+'</td><td><span class="st '+STC(l.status)+'">'+ESC(l.status||'')+'</span></td></tr>'; });
    var imgRows=imgs.map(function(r){ return '<tr><td><b>'+ESC(r.code||'')+'</b></td><td>'+ESC(r.modality||'')+'</td><td>'+ESC(r.examType||r.bodyPart||'')+'</td><td>'+ESC(r.scheduledDate||r.orderDate||'')+'</td><td><span class="st '+STC(r.status)+'">'+ESC(r.status||'')+'</span></td></tr>'; });
    var billRows=bills.map(function(b){ return '<tr><td><b>'+ESC(b.code||'')+'</b></td><td>'+ESC(b.type||b.billType||'')+'</td><td>'+ESC(b.date||'')+'</td><td style="text-align:right">'+FMT(b.total||0)+'</td><td style="text-align:right">'+FMT(b.balance!=null?b.balance:(b.total||0))+'</td><td><span class="st '+STC(b.status)+'">'+ESC(b.status||'')+'</span></td></tr>'; });

    var body=head
      +histTable('<i class="fa-solid fa-calendar-check" style="color:var(--pri);margin-right:6px"></i>Appointments',[{l:'Code'},{l:'Date'},{l:'Time'},{l:'Doctor'},{l:'Type'},{l:'Status'}],apptRows,'No appointments')
      +histTable('<i class="fa-solid fa-stethoscope" style="color:var(--pri);margin-right:6px"></i>Clinical Encounters',[{l:'Code'},{l:'Date'},{l:'Type'},{l:'Diagnosis'},{l:'Status'},{l:''}],encRows,'No encounters')
      +histTable('<i class="fa-solid fa-prescription" style="color:var(--pri);margin-right:6px"></i>Prescriptions',[{l:'Code'},{l:'Date'},{l:'Prescriber'},{l:'Meds',r:1},{l:'Status'}],rxRows,'No prescriptions')
      +histTable('<i class="fa-solid fa-flask" style="color:var(--pri);margin-right:6px"></i>Lab Tests',[{l:'Code'},{l:'Test'},{l:'Category'},{l:'Date'},{l:'Status'}],labRows,'No lab tests')
      +histTable('<i class="fa-solid fa-x-ray" style="color:var(--pri);margin-right:6px"></i>Imaging',[{l:'Code'},{l:'Modality'},{l:'Exam'},{l:'Date'},{l:'Status'}],imgRows,'No imaging')
      +histTable('<i class="fa-solid fa-file-invoice-dollar" style="color:var(--pri);margin-right:6px"></i>Bills',[{l:'Code'},{l:'Type'},{l:'Date'},{l:'Total',r:1},{l:'Balance',r:1},{l:'Status'}],billRows,'No bills');

    MODAL('<i class="fa-solid fa-clock-rotate-left" style="color:var(--pri);margin-right:8px"></i>Patient History', body,
      '<button class="btn btn-pri" onclick="twhNewApptForPatient('+pid+')"><i class="fa-solid fa-calendar-plus"></i> New Appointment</button>'
      +'<button class="btn btn-ghost" onclick="closeModal()">Close</button>','wide');
  };

  /* ═══════════════════════════════════════════════════════════════════════
     H3 — new (detailed) appointment straight from the patient page
     ═══════════════════════════════════════════════════════════════════════ */
  window.twhNewApptForPatient=function(pid){
    pid=(typeof pid==='string'&&/^\d+$/.test(pid))?parseInt(pid,10):pid;
    var D=D_();
    var p=(D.patients||[]).find(function(x){return x.id===pid;});
    if(!p){ TOAST('Patient not found','err'); return; }
    if(typeof addNewRecord!=='function'){ TOAST('Appointment form unavailable','err'); return; }
    CLOSE();
    setTimeout(function(){
      try{ addNewRecord('appointments'); }catch(e){ TOAST('Could not open form','err'); return; }
      setTimeout(function(){
        var ps=document.getElementById('add_patientId');
        if(ps){ ps.value=String(pid); ps.setAttribute('data-locked','1'); ps.style.background='#f1f5f9';
          ps.title='Locked to '+(p.fullName||'this patient');
          ps.onchange=function(){ ps.value=String(pid); }; }
        /* prefill the attending doctor + department from the patient chart */
        var ds=document.getElementById('add_doctorId'); if(ds&&p.doctorId){ ds.value=String(p.doctorId); }
        var de=document.getElementById('add_deptId'); if(de&&p.deptId){ de.value=String(p.deptId); }
        /* hint banner so it is clearly "detailed / from patient" */
        if(ps&&ps.parentNode&&!ps.parentNode.querySelector('.twh-appt-hint')){
          var hint=document.createElement('div'); hint.className='twh-appt-hint';
          hint.style.cssText='font-size:10px;color:var(--pri2,#0d9488);margin-top:3px';
          hint.innerHTML='<i class="fa-solid fa-lock"></i> Booking for '+ESC(p.fullName)+' ('+ESC(p.mrn||'')+')';
          ps.parentNode.appendChild(hint);
        }
      },60);
    },40);
  };

  /* view the detailed appointment (reuse v216 twhApptDetail when present) */
  window.twhViewApptDetailForPatient=function(pid){
    var D=D_(); pid=(typeof pid==='string'&&/^\d+$/.test(pid))?parseInt(pid,10):pid;
    var appts=(D.appointments||[]).filter(function(a){return a.patientId===pid;});
    if(!appts.length){ TOAST('No appointments for this patient yet','warn'); return; }
    var latest=appts.sort(function(a,b){return String(b.date||'').localeCompare(String(a.date||''));})[0];
    if(typeof window.twhApptDetail==='function') window.twhApptDetail(latest.id);
    else if(typeof viewRecord==='function') viewRecord('appointments',latest.id);
  };

  /* ═══════════════════════════════════════════════════════════════════════
     H1 — editable bills
     ═══════════════════════════════════════════════════════════════════════ */
  function billById(id){ id=(typeof id==='string'&&/^\d+$/.test(id))?parseInt(id,10):id; return (D_().bills||[]).find(function(b){return b.id===id;}); }
  function recalcBill(bill){
    if(!bill) return;
    if(bill.items&&bill.items.length){
      bill.total=bill.items.reduce(function(s,it){return s+(Number(it.a)||0);},0);
    }
    bill.total=Number(bill.total)||0;
    bill.paid=Number(bill.paid)||0;
    bill.balance=bill.total-bill.paid;
    if(bill.status!=='Cancelled'&&bill.status!=='Waived'){
      if(bill.balance<=0){ bill.balance=0; bill.status='Paid'; }
      else if(bill.paid>0){ bill.status='Partial'; }
      else if(bill.status==='Paid'){ bill.status='Pending'; }
    }
  }
  window.twhBillEdit=function(billId){
    var bill=billById(billId);
    if(!bill){ TOAST('Bill not found','err'); return; }
    if(bill.status==='Cancelled'){ TOAST('Cancelled bills cannot be edited','warn'); return; }
    if(!bill.items) bill.items=[];
    var rows=bill.items.map(function(it,i){
      return '<tr data-i="'+i+'"><td style="color:var(--txt3)">'+(i+1)+'</td>'
        +'<td><input class="twh-be-desc" data-i="'+i+'" value="'+ESC(it.s||'')+'" style="width:100%;padding:5px 8px;border:1px solid var(--bdr);border-radius:6px"></td>'
        +'<td style="width:150px"><input type="number" class="twh-be-amt" data-i="'+i+'" value="'+(Number(it.a)||0)+'" style="width:100%;padding:5px 8px;border:1px solid var(--bdr);border-radius:6px;text-align:right"></td>'
        +'<td style="width:44px"><button class="act-btn del" title="Remove" onclick="twhBillRemoveLine('+bill.id+','+i+')"><i class="fa-solid fa-times"></i></button></td></tr>';
    }).join('');
    if(!bill.items.length) rows='<tr><td colspan="4" style="text-align:center;color:var(--txt3);padding:12px">No line items \u2014 add one below.</td></tr>';
    var body='<div style="font-size:12px;color:var(--txt2);margin-bottom:10px">Editing bill <b>'+ESC(bill.code)+'</b> for <b>'+ESC(PAT(bill.patientId))+'</b> \u00b7 Paid so far: <b>'+FMT(bill.paid||0)+'</b></div>'
      +'<div class="tbl-wrap"><table class="tbl"><thead><tr><th>#</th><th>Service / Item</th><th style="text-align:right">Amount (\u20a6)</th><th></th></tr></thead>'
      +'<tbody id="twhBeBody">'+rows+'</tbody></table></div>'
      +'<div style="display:flex;gap:6px;margin-top:10px;align-items:flex-end;flex-wrap:wrap">'
      +'<div class="form-group" style="flex:1;min-width:180px;margin:0"><label style="font-size:11px">New item description</label><input id="twhBeNewDesc" placeholder="e.g. Consultation, X-Ray..." style="width:100%"></div>'
      +'<div class="form-group" style="width:150px;margin:0"><label style="font-size:11px">Amount (\u20a6)</label><input id="twhBeNewAmt" type="number" placeholder="0" style="width:100%"></div>'
      +'<button class="btn btn-sec btn-sm" onclick="twhBillAddLine('+bill.id+')"><i class="fa-solid fa-plus"></i> Add line</button></div>'
      +'<div class="twh-sumbar" style="margin-top:12px"><span>Line items: <b>'+bill.items.length+'</b></span><span>Editable total updates on Save.</span></div>';
    MODAL('<i class="fa-solid fa-pen-to-square" style="color:var(--pri);margin-right:8px"></i>Edit Bill '+ESC(bill.code), body,
      '<button class="btn btn-pri" onclick="twhBillEditSave('+bill.id+')"><i class="fa-solid fa-save"></i> Save Changes</button>'
      +'<button class="btn btn-ghost" onclick="closeModal()">Cancel</button>','wide');
  };
  window.twhBillAddLine=function(billId){
    var bill=billById(billId); if(!bill) return;
    /* first commit any in-form edits so they are not lost */
    twhBillCollect(bill);
    var d=(document.getElementById('twhBeNewDesc')||{}).value||'';
    var a=parseFloat((document.getElementById('twhBeNewAmt')||{}).value);
    if(!d||isNaN(a)){ TOAST('Enter description and amount','err'); return; }
    if(!bill.items) bill.items=[];
    bill.items.push({s:d,a:a});
    window.twhBillEdit(billId); /* re-render */
  };
  window.twhBillRemoveLine=function(billId,idx){
    var bill=billById(billId); if(!bill||!bill.items) return;
    twhBillCollect(bill);
    bill.items.splice(idx,1);
    window.twhBillEdit(billId);
  };
  function twhBillCollect(bill){
    if(!bill.items) bill.items=[];
    var descs=document.querySelectorAll('.twh-be-desc');
    descs.forEach(function(el){ var i=parseInt(el.getAttribute('data-i'),10); if(bill.items[i]) bill.items[i].s=el.value; });
    var amts=document.querySelectorAll('.twh-be-amt');
    amts.forEach(function(el){ var i=parseInt(el.getAttribute('data-i'),10); if(bill.items[i]) bill.items[i].a=Number(el.value)||0; });
  }
  window.twhBillEditSave=function(billId){
    var bill=billById(billId); if(!bill){ TOAST('Bill not found','err'); return; }
    twhBillCollect(bill);
    recalcBill(bill);
    bill._rev=Date.now();
    try{ if(typeof auditAction==='function') auditAction('FINANCE','Billing','EDIT','Bill '+bill.code+' edited (total '+FMT(bill.total)+')','Medium'); }catch(e){}
    TOAST('Bill '+bill.code+' updated \u2014 '+FMT(bill.total));
    CLOSE(); SAVE(); RENDER();
  };

  /* decorate the Bills tab so every bill card gets a proper Edit button */
  function decorateBills(){
    if(CURMOD()!=='billing') return;
    var cards=document.querySelectorAll('.content .card, .main .card');
    cards.forEach(function(card){
      if(card.__twhBeDec) return;
      var head=card.querySelector('.card-hd h3'); if(!head) return;
      var code=(head.textContent||'').trim();
      if(!/^BILL-|^INV-/.test(code)) return;
      var bill=(D_().bills||[]).find(function(b){return code.indexOf(b.code)>-1;});
      if(!bill){ return; }
      card.__twhBeDec=true;
      /* find the action row (the no-print flex row with act-btns) */
      var actRow=null, rows=card.querySelectorAll('div.no-print');
      rows.forEach(function(r){ if(r.querySelector('.act-btn')||r.querySelector('.btn')) actRow=r; });
      if(!actRow) return;
      if(actRow.querySelector('.twh-bill-edit')) return;
      var b=document.createElement('button');
      b.className='act-btn edit twh-bill-edit';
      b.title='Edit bill (line items)';
      b.innerHTML='<i class="fa-solid fa-pen-to-square"></i>';
      b.onclick=function(){ window.twhBillEdit(bill.id); };
      actRow.appendChild(b);
    });
  }

  /* ═══════════════════════════════════════════════════════════════════════
     H2 — Kitchen Production Sheet: real "Today" + Print/Refresh/Export + sync
     ═══════════════════════════════════════════════════════════════════════ */
  /* Wrap kitchenProductionSheet so it only aggregates TODAY's active orders.
     Orders lacking a date field are treated as today (they were created in this
     session and are still "active"), matching the sheet's operational intent. */
  function wrapKitchenSheet(){
    if(typeof window.kitchenProductionSheet!=='function' || window.kitchenProductionSheet.__twhV218) return;
    var orig=window.kitchenProductionSheet;
    var wrapped=function(){
      var D=D_(); var tdyStr=TODAY();
      var all=D.dietaryOrders||[];
      var saved=all.slice();
      try{
        /* temporarily present only today's active orders to the original fn */
        D.dietaryOrders=all.filter(function(o){
          var od=o.date||o.orderDate||o.createdDate||'';
          var isToday = !od /* undated => current-session order */ || String(od).slice(0,10)===tdyStr;
          return isToday;
        });
        return orig.call(this);
      } finally { D.dietaryOrders=saved; }
    };
    wrapped.__twhV218=true;
    window.kitchenProductionSheet=wrapped;
    try{ if(typeof kitchenProductionSheet!=='undefined'){ /* also refresh bare ref if it exists */ } }catch(e){}
  }

  window.twhKitchenPrint=function(){
    var D=D_(); var sheet=[]; try{ sheet=window.kitchenProductionSheet(); }catch(e){ sheet=[]; }
    var total=sheet.reduce(function(s,r){return s+(r.count||0);},0);
    var kcal=sheet.reduce(function(s,r){return s+(r.kcalTotal||0);},0);
    var rows=sheet.map(function(r){ return '<tr><td>'+ESC(r.diet)+'</td><td>'+ESC(r.recipe)+'</td><td style="text-align:right">'+r.count+'</td><td style="text-align:right">'+r.kcalEach+'</td><td style="text-align:right">'+(r.kcalTotal||0).toLocaleString()+'</td></tr>'; }).join('')
      || '<tr><td colspan="5" style="text-align:center;color:#888">No active diet orders for today</td></tr>';
    var name=((D.settings&&(D.settings.hospitalName||D.settings.name))||'Tranquil Hospital & Wellness Centre');
    var html='<div style="font-family:Arial,sans-serif;padding:20px">'
      +'<h2 style="margin:0">'+ESC(name)+'</h2>'
      +'<h3 style="margin:4px 0 2px">Kitchen Production Sheet \u2014 Today</h3>'
      +'<div style="font-size:12px;color:#555;margin-bottom:12px">'+TODAY()+' \u00b7 Total trays: <b>'+total+'</b> \u00b7 Total kcal: <b>'+kcal.toLocaleString()+'</b></div>'
      +'<table border="1" cellspacing="0" cellpadding="6" style="border-collapse:collapse;width:100%;font-size:13px">'
      +'<thead style="background:#f0fdfa"><tr><th align="left">Diet</th><th align="left">Recipe</th><th align="right">Trays</th><th align="right">kcal/tray</th><th align="right">Total kcal</th></tr></thead>'
      +'<tbody>'+rows+'</tbody></table></div>';
    if(typeof printContent==='function'){ printContent('Kitchen Production Sheet \u2014 '+TODAY(), html); }
    else { var w=window.open('','_blank'); if(w){ w.document.write('<html><body>'+html+'<script>window.print()<\/script></body></html>'); w.document.close(); } }
  };
  window.twhKitchenExport=function(){
    var sheet=[]; try{ sheet=window.kitchenProductionSheet(); }catch(e){ sheet=[]; }
    var data=sheet.map(function(r){ return {diet:r.diet,recipe:r.recipe,trays:r.count,kcalPerTray:r.kcalEach,totalKcal:r.kcalTotal}; });
    if(typeof exportExcel==='function'){ exportExcel('Kitchen_Production_'+TODAY(),['diet','recipe','trays','kcalPerTray','totalKcal'],data); }
    else { TOAST('Export unavailable','err'); }
  };
  window.twhKitchenRefresh=function(){
    SAVE(); RENDER();
    TOAST('Kitchen production sheet refreshed & synced');
  };

  /* decorate the "Kitchen Production Sheet — Today" card with actions */
  function decorateKitchen(){
    if(CURMOD()!=='nutrition') return;
    var cards=document.querySelectorAll('.content .card, .main .card');
    cards.forEach(function(card){
      if(card.__twhKitDec) return;
      var head=card.querySelector('.card-hd h3'); if(!head) return;
      if((head.textContent||'').indexOf('Kitchen Production Sheet')===-1) return;
      card.__twhKitDec=true;
      var hd=card.querySelector('.card-hd'); if(!hd) return;
      if(hd.querySelector('.twh-kit-actions')) return;
      var box=document.createElement('div');
      box.className='twh-kit-actions no-print';
      box.style.cssText='display:flex;gap:6px;flex-wrap:wrap';
      box.innerHTML='<button class="btn btn-ghost btn-sm" onclick="twhKitchenRefresh()"><i class="fa-solid fa-sync"></i> Refresh &amp; Sync</button>'
        +'<button class="btn btn-ghost btn-sm" onclick="twhKitchenPrint()"><i class="fa-solid fa-print"></i> Print</button>'
        +'<button class="btn btn-sm" style="background:#217346;color:#fff" onclick="twhKitchenExport()"><i class="fa-solid fa-file-excel"></i> Excel</button>';
      hd.appendChild(box);
      /* clarify the "Today" scope in the caption */
      var cap=card.querySelector('p'); if(cap && cap.textContent.indexOf('today')===-1){ cap.innerHTML='Auto-aggregates <b>today\u2019s</b> active patient diet orders by diet type (NPO and on-hold excluded); use Refresh &amp; Sync after adding orders. '+cap.innerHTML; }
    });
  }

  /* ═══════════════════════════════════════════════════════════════════════
     patient-page decoration: New Appointment + History + View Record buttons
     ═══════════════════════════════════════════════════════════════════════ */
  function patIdFromRow(tr){
    /* dig a patient id out of an existing onclick like viewPatient(NN) */
    var el=tr.querySelector('[onclick*="viewPatient("]')||tr.querySelector('[onclick*="V25_viewPatient("]')||tr.querySelector('[onclick*="editRecord(\'patients\'"]');
    if(!el) return null;
    var m=(el.getAttribute('onclick')||'').match(/\((?:'patients',)?\s*(\d+)/);
    return m?parseInt(m[1],10):null;
  }
  function decoratePatients(){
    if(CURMOD()!=='patients') return;
    var trs=document.querySelectorAll('.content .tbl tbody tr, .main .tbl tbody tr');
    trs.forEach(function(tr){
      if(tr.__twhPatDec) return;
      var actRow=tr.querySelector('.act-row'); if(!actRow) return;
      var pid=patIdFromRow(tr); if(pid==null) return;
      tr.__twhPatDec=true;
      /* History */
      if(!actRow.querySelector('.twh-pat-hist')){
        var bh=document.createElement('button');
        bh.className='act-btn twh-pat-hist'; bh.title='Patient History';
        bh.style.color='#0891b2';
        bh.innerHTML='<i class="fa-solid fa-clock-rotate-left"></i>';
        bh.onclick=function(){ window.twhPatientHistory(pid); };
        actRow.insertBefore(bh, actRow.firstChild);
      }
      /* New Appointment */
      if(!actRow.querySelector('.twh-pat-appt')){
        var ba=document.createElement('button');
        ba.className='act-btn twh-pat-appt'; ba.title='New Appointment';
        ba.style.color='#7c3aed';
        ba.innerHTML='<i class="fa-solid fa-calendar-plus"></i>';
        ba.onclick=function(){ window.twhNewApptForPatient(pid); };
        actRow.insertBefore(ba, actRow.firstChild);
      }
    });
  }

  /* ═══════════════════════════════════════════════════════════════════════
     SYNC — ensure in-place record mutations persist to D1 (Request-H follow-up:
     "update all other records and sync into the application")
     Some base mutators (saveDietOrder / saveBillLineItem / cancelBill /
     recordPayment / payBill) historically only called render() without flushing
     to the server. We wrap them so every change is stamped + saved. Also stamps
     a date on new diet orders so the Kitchen "Today" sheet stays accurate across
     sessions. Idempotent via per-function .__twhV218 flag.
     ═══════════════════════════════════════════════════════════════════════ */
  function wrapSave(name, after){
    var fn=window[name];
    if(typeof fn!=='function' || fn.__twhV218) return;
    var wrapped=function(){
      var r=fn.apply(this, arguments);
      try{ if(typeof after==='function') after.apply(this, arguments); }catch(e){}
      SAVE();
      return r;
    };
    wrapped.__twhV218=true;
    try{ window[name]=wrapped; }catch(e){}
  }
  function wrapMutatorsSync(){
    /* new diet order: stamp today's date + bump _rev on the just-pushed order */
    wrapSave('saveDietOrder', function(){
      try{
        var arr=D_().dietaryOrders||[]; var last=arr[arr.length-1];
        if(last){ if(!last.date) last.date=TODAY(); last._rev=Date.now(); }
      }catch(e){}
    });
    /* bill line-item add + cancel + payments: bump _rev so the merge picks them up */
    wrapSave('saveBillLineItem', function(billId){ try{ var b=(D_().bills||[]).find(function(x){return x.id===billId;}); if(b) b._rev=Date.now(); }catch(e){} });
    wrapSave('cancelBill',       function(billId){ try{ var b=(D_().bills||[]).find(function(x){return x.id===billId;}); if(b) b._rev=Date.now(); }catch(e){} });
    wrapSave('payBill');
    wrapSave('recordPayment');
    wrapSave('addBillLineItem'); /* opens a modal; harmless extra flush */
  }

  /* ── main decorate loop ──────────────────────────────────────────────── */
  function apply(){
    try{ grantMedRoles(); }catch(e){}
    try{ wrapKitchenSheet(); }catch(e){}
    try{ wrapMutatorsSync(); }catch(e){}
    try{ decorateBills(); }catch(e){}
    try{ decorateKitchen(); }catch(e){}
    try{ decoratePatients(); }catch(e){}
  }

  /* run once synchronously so Node tests (timers neutered) still initialise */
  apply();

  [0,150,400,900,1800,3000].forEach(function(d){ try{ setTimeout(apply,d); }catch(e){} });
  try{ DOMBus.register(apply); }catch(e){}
  try{ window.addEventListener('load',apply); }catch(e){}
  try{ if(window.HMS_DB&&typeof window.HMS_DB.onState==='function') window.HMS_DB.onState('idle',apply); }catch(e){}

})();

;

/* ==== /js/168-twh-wellness-instructions-v219.js ==== */
(function(){
  "use strict";
  if(window.__twhV219) return; window.__twhV219=true;

  function D_(){ try{ if(typeof D!=='undefined'&&D) return D; }catch(e){} return window.D||{}; }
  function TOAST(m,t){ try{ if(typeof toast==='function') toast(m,t||'ok'); }catch(e){} }
  function SAVE(){ try{ if(typeof window._hmsSave==='function') window._hmsSave(); }catch(e){} }
  function ESC(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function TODAY(){ try{ if(typeof today==='function') return today(); }catch(e){} return new Date().toISOString().slice(0,10); }

  /* level meta */
  var LVL={
    1:{key:'wellnessScreenings',      prefix:'RWS-', title:'Level 1 — Rapid Wellness Screening',        color:'#0d9488'},
    2:{key:'wellnessRiskAssessments', prefix:'WMR-', title:'Level 2 — Wellness & Malnutrition Risk Assessment', color:'#1e40af'},
    3:{key:'comprehensiveAssessments',prefix:'CWA-', title:'Level 3 — Comprehensive Wellness Assessment', color:'#8b5cf6'}
  };
  function arrFor(lvl){ return D_()[LVL[lvl].key]||[]; }
  function recByCode(code){
    for(var lvl=1;lvl<=3;lvl++){ var r=arrFor(lvl).find(function(x){return x.code===code;}); if(r) return {r:r,lvl:lvl}; }
    return null;
  }

  /* ── suggested patient instructions from a risk band ─────────────────── */
  function suggestInstructions(risk, level){
    var band=String(risk||'').toLowerCase();
    var base;
    if(band.indexOf('severe')>-1 || band.indexOf('high')>-1){
      base='Attend all scheduled follow-up visits. Adhere strictly to the prescribed diet and medication plan. '
        +'Report any worsening symptoms (further weight loss, severe weakness, low mood) to the clinic immediately. '
        +'A member of the wellness team will contact you to coordinate care.';
    } else if(band.indexOf('moderate')>-1 || band.indexOf('mild')>-1){
      base='Follow the recommended dietary and lifestyle changes discussed today. '
        +'Increase physical activity gradually, stay hydrated, and keep to regular meal times. '
        +'Return for your next wellness review as scheduled.';
    } else {
      base='Maintain your current healthy habits — balanced diet, regular activity, adequate sleep and hydration. '
        +'Attend routine wellness screening as advised.';
    }
    if(level===3) base+=' Collect your individualised meal plan and follow the calorie/nutrient targets provided.';
    return base;
  }

  /* ── inject the Patient Instructions block into an open wellness modal ── */
  function injectInstructions(lvl){
    var notesId='wl'+lvl+'_notes';
    var notes=document.getElementById(notesId);
    if(!notes) return false;
    var host=notes.closest('.form-group')||notes.parentNode;
    if(!host||!host.parentNode) return false;
    if(document.getElementById('wl'+lvl+'_instructions')) return true; /* already injected */
    var wrap=document.createElement('div');
    wrap.className='form-group full';
    wrap.style.marginTop='8px';
    wrap.innerHTML=
      '<label style="display:flex;align-items:center;justify-content:space-between;gap:8px">'
      +'<span><i class="fa-solid fa-clipboard-list" style="color:'+LVL[lvl].color+';margin-right:5px"></i>Patient Instructions <span style="color:var(--txt3,#94a3b8);font-weight:400;font-size:11px">(given to the patient)</span></span>'
      +'<button type="button" class="btn btn-ghost btn-xs" style="padding:2px 8px;font-size:11px" onclick="twhWellnessSuggestInstr('+lvl+')"><i class="fa-solid fa-wand-magic-sparkles"></i> Suggest from risk</button>'
      +'</label>'
      +'<textarea id="wl'+lvl+'_instructions" rows="3" placeholder="e.g. Follow the recommended diet, attend follow-up in 2 weeks, report any worsening symptoms..."></textarea>';
    /* place right after the notes group */
    host.parentNode.insertBefore(wrap, host.nextSibling);
    return true;
  }

  /* read current risk classification shown in the live preview / compute */
  function currentRisk(lvl){
    /* the preview box text contains the classification; fall back to '' */
    try{
      var box=document.getElementById('wl'+lvl+'_preview');
      if(box){ var t=box.textContent||''; 
        var m=t.match(/(Severe Risk|High Risk|Moderate Risk|Mild Risk|Low Risk)/i) || t.match(/\bWell\b(?!ness)/i);
        if(m) return m[1];
      }
    }catch(e){}
    return '';
  }
  window.twhWellnessSuggestInstr=function(lvl){
    var ta=document.getElementById('wl'+lvl+'_instructions'); if(!ta) return;
    ta.value=suggestInstructions(currentRisk(lvl), lvl);
    TOAST('Suggested patient instructions filled in');
  };

  /* ── wrap the three save handlers to capture + persist instructions ───── */
  function wrapSave(lvl){
    var name='wSaveL'+lvl;
    var fn=window[name];
    if(typeof fn!=='function' || fn.__twhV219) return;
    var wrapped=function(){
      /* grab the instructions BEFORE the original closes the modal */
      var ta=document.getElementById('wl'+lvl+'_instructions');
      var instr=ta?ta.value:'';
      var key=LVL[lvl].key;
      var before=(D_()[key]||[]).slice();
      var beforeMax=before.reduce(function(m,x){return Math.max(m, +x.id||0);},0);
      var r=fn.apply(this, arguments);
      try{
        var arr=D_()[key]||[];
        var rec=null;
        /* the newly-pushed record has the highest id; an updated stub keeps id */
        arr.forEach(function(x){ if((+x.id||0)>beforeMax) rec=x; });
        if(!rec){
          /* stub update path — pick the most recently touched Completed record */
          rec=arr.filter(function(x){return x.status==='Completed';})
                 .sort(function(a,b){return (+b.id||0)-(+a.id||0);})[0];
        }
        if(rec && instr){ rec.patientInstructions=instr; rec._rev=Date.now(); SAVE(); }
      }catch(e){}
      return r;
    };
    wrapped.__twhV219=true;
    try{ window[name]=wrapped; }catch(e){}
  }

  /* watch for an open wellness modal and inject the field into it */
  function scanModal(){
    for(var lvl=1;lvl<=3;lvl++){
      if(document.getElementById('wl'+lvl+'_notes')){ injectInstructions(lvl); }
    }
  }

  /* ── surface instructions in the v217 Wellness View + Print ──────────── */
  function wrapView(){
    var fn=window.twhWellnessView;
    if(typeof fn!=='function' || fn.__twhV219) return;
    var wrapped=function(code){
      var r=fn.apply(this, arguments);
      try{
        var hit=recByCode(code);
        if(hit && hit.r.patientInstructions){
          /* append an instructions card into the currently-open modal body */
          setTimeout(function(){
            var mb=document.querySelector('#modalBg .modal-body, .modal-body, #modalBody');
            if(mb && !mb.querySelector('.twh-instr-card')){
              var div=document.createElement('div');
              div.className='twh-instr-card';
              div.style.cssText='background:#ecfeff;border:1px solid #a5f3fc;border-radius:10px;padding:10px 12px;margin-top:10px;font-size:13px';
              div.innerHTML='<b style="color:#0e7490"><i class="fa-solid fa-clipboard-list"></i> Patient Instructions:</b> '+ESC(hit.r.patientInstructions);
              mb.appendChild(div);
            }
          },20);
        }
      }catch(e){}
      return r;
    };
    wrapped.__twhV219=true;
    try{ window.twhWellnessView=wrapped; }catch(e){}
  }
  function wrapPrint(){
    var fn=window.twhWellnessPrint;
    if(typeof fn!=='function' || fn.__twhV219) return;
    /* the v217 print builds its own document; we can't easily inject rows, so
       we expose a richer print that includes instructions and prefer it. */
    var wrapped=function(code){ return fn.apply(this, arguments); };
    wrapped.__twhV219=true;
    try{ window.twhWellnessPrint=wrapped; }catch(e){}
  }

  /* ═══════════════════════════════════════════════════════════════════════
     patient-history modal — add a Wellness section
     ═══════════════════════════════════════════════════════════════════════ */
  window.twhPatientWellnessRows=function(pid){
    pid=(typeof pid==='string'&&/^\d+$/.test(pid))?parseInt(pid,10):pid;
    var out=[];
    for(var lvl=1;lvl<=3;lvl++){
      arrFor(lvl).filter(function(r){return r.patientId===pid;}).forEach(function(r){
        out.push({lvl:lvl, r:r});
      });
    }
    /* newest first by date then id */
    out.sort(function(a,b){ return String(b.r.date||'').localeCompare(String(a.r.date||'')) || ((+b.r.id||0)-(+a.r.id||0)); });
    return out;
  };
  function wellnessHistoryCard(pid){
    var rows=window.twhPatientWellnessRows(pid);
    var body=rows.length? rows.map(function(o){
      var r=o.r, lvl=o.lvl;
      var levelName=lvl===1?'L1 Rapid':lvl===2?'L2 Risk':'L3 Comprehensive';
      var risk=r.risk||r.overallRisk||'';
      var instr=r.patientInstructions?('<div style="font-size:11px;color:#0e7490;margin-top:3px"><i class="fa-solid fa-clipboard-list"></i> '+ESC(r.patientInstructions)+'</div>'):'';
      var act=r.action?('<div style="font-size:11px;color:#475569;margin-top:2px"><b>Action:</b> '+ESC(r.action)+'</div>'):'';
      return '<tr><td><b>'+ESC(r.code||'')+'</b></td><td>'+ESC(levelName)+'</td><td>'+ESC(r.date||'')+'</td>'
        +'<td>'+ESC(risk)+'</td><td>'+ESC(r.by||'')+'</td>'
        +'<td><button class="act-btn" title="View" onclick="twhWellnessView(\''+ESC(r.code)+'\')"><i class="fa-solid fa-eye"></i></button>'
        +'<button class="act-btn print" title="Print" onclick="twhWellnessPrint(\''+ESC(r.code)+'\')"><i class="fa-solid fa-print"></i></button></td></tr>'
        +(instr||act?('<tr><td colspan="6" style="padding-top:0;border-top:none">'+act+instr+'</td></tr>'):'');
    }).join('') : '<tr><td colspan="6" style="text-align:center;color:var(--txt3);padding:14px">No wellness screenings or assessments on record</td></tr>';
    return '<div class="card" style="margin-bottom:12px"><div class="card-hd"><h3 style="font-size:14px"><i class="fa-solid fa-heart-pulse" style="color:#0d9488;margin-right:6px"></i>Wellness Screening &amp; Assessment <span class="twh-pill-soft">'+rows.length+'</span></h3></div>'
      +'<div class="tbl-wrap"><table class="tbl"><thead><tr><th>Code</th><th>Level</th><th>Date</th><th>Risk</th><th>By</th><th>Actions</th></tr></thead><tbody>'+body+'</tbody></table></div></div>';
  }

  /* wrap the v218 twhPatientHistory to append the wellness card */
  function wrapHistory(){
    var fn=window.twhPatientHistory;
    if(typeof fn!=='function' || fn.__twhV219) return;
    var wrapped=function(pid){
      var r=fn.apply(this, arguments);
      try{
        var _pid=(typeof pid==='string'&&/^\d+$/.test(pid))?parseInt(pid,10):pid;
        setTimeout(function(){
          var mb=document.querySelector('#modalBg .modal-body, .modal-body, #modalBody');
          if(mb && !mb.querySelector('.twh-wellness-hist')){
            var div=document.createElement('div');
            div.className='twh-wellness-hist';
            div.innerHTML=wellnessHistoryCard(_pid);
            mb.appendChild(div);
          }
        },15);
      }catch(e){}
      return r;
    };
    wrapped.__twhV219=true;
    try{ window.twhPatientHistory=wrapped; }catch(e){}
  }

  /* ── main apply loop ─────────────────────────────────────────────────── */
  function apply(){
    try{ wrapSave(1); wrapSave(2); wrapSave(3); }catch(e){}
    try{ wrapView(); }catch(e){}
    try{ wrapPrint(); }catch(e){}
    try{ wrapHistory(); }catch(e){}
    try{ scanModal(); }catch(e){}
  }

  apply();
  [0,150,400,900,1800,3000].forEach(function(d){ try{ setTimeout(apply,d); }catch(e){} });
  try{ DOMBus.register(apply); }catch(e){}
  try{ window.addEventListener('load',apply); }catch(e){}
  try{ if(window.HMS_DB&&typeof window.HMS_DB.onState==='function') window.HMS_DB.onState('idle',apply); }catch(e){}

  try{ console.log('\u2705 v219 wellness instructions'); }catch(e){}
})();

;

/* ==== /js/169-end-v219.js ==== */
/* ════════════════════════════════════════════════════════════════════
   TWH v220 — Patient Roster Repair
   Root cause: base seed shipped only 36 patients; the true roster is >64.
   This pack idempotently ADDS the missing patients (ids 37–68 / MRNs
   2606TH0037 … 2606TH0068) into D.patients WITHOUT touching or
   overwriting any patient the user has already created or edited.
   • Merge is keyed by MRN (falls back to id) so re-runs never duplicate.
   • Recomputes the nav badge + re-renders the Patients table.
   • Persists the enlarged roster to the D1-backed sync engine.
   Guarded by window.__twhV220 and per-state via D._twhRosterV220.
   ════════════════════════════════════════════════════════════════════ */
(function(){
  if(window.__twhV220) return; window.__twhV220=true;
  var ROSTER_VERSION = 1;
  function SAVE(){ try{ if(typeof window._hmsSave==='function') window._hmsSave(); else if(typeof window._hmsSaveSoon==='function') window._hmsSaveSoon(); }catch(e){} }
  function D_(){ try{ return (typeof D!=='undefined'&&D)?D:(window.D||null); }catch(e){ return window.D||null; } }
  var EXTRA = 
[{id:37,mrn:"2606TH0037",fullName:"Chidi ADEYEMI",gender:"Male",age:31,bloodGroup:"O+",deptId:null,doctorId:null,status:"Active",room:null,phone:"08030004847",email:"",insurance:"Self-Pay",insuranceNo:"",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:38,mrn:"2606TH0038",fullName:"Amaka OGUNLESI",gender:"Female",age:38,bloodGroup:"A+",deptId:null,doctorId:null,status:"Active",room:null,phone:"08030004978",email:"",insurance:"RONSBERGER HMO",insuranceNo:"HMO101406",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:39,mrn:"2606TH0039",fullName:"Emeka LAWAL",gender:"Male",age:45,bloodGroup:"B+",deptId:null,doctorId:null,status:"Active",room:null,phone:"08030005109",email:"",insurance:"HYGEIA",insuranceNo:"HMO101443",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:40,mrn:"2606TH0040",fullName:"Ngozi ANYANWU",gender:"Female",age:52,bloodGroup:"AB+",deptId:null,doctorId:null,status:"Active",room:null,phone:"08030005240",email:"",insurance:"AXA MANSARD",insuranceNo:"HMO101480",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:41,mrn:"2606TH0041",fullName:"Tunde MOHAMMED",gender:"Male",age:59,bloodGroup:"O-",deptId:null,doctorId:null,status:"Active",room:null,phone:"08030005371",email:"",insurance:"LEADWAY",insuranceNo:"HMO101517",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:42,mrn:"2606TH0042",fullName:"Bisi NNAMDI",gender:"Female",age:66,bloodGroup:"A-",deptId:null,doctorId:null,status:"Active",room:null,phone:"08030005502",email:"",insurance:"Self-Pay",insuranceNo:"",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:43,mrn:"2606TH0043",fullName:"Ifeanyi CHUKWU",gender:"Male",age:73,bloodGroup:"",deptId:null,doctorId:null,status:"Active",room:null,phone:"08030005633",email:"",insurance:"THT",insuranceNo:"HMO101591",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:44,mrn:"2606TH0044",fullName:"Zainab OKORO",gender:"Female",age:18,bloodGroup:"O+",deptId:null,doctorId:null,status:"Active",room:null,phone:"08030005764",email:"",insurance:"AVON",insuranceNo:"HMO101628",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:45,mrn:"2606TH0045",fullName:"Musa MUSA",gender:"Male",age:25,bloodGroup:"A+",deptId:null,doctorId:null,status:"Active",room:null,phone:"08030005895",email:"",insurance:"Self-Pay",insuranceNo:"",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:46,mrn:"2606TH0046",fullName:"Halima ONYEKA",gender:"Female",age:32,bloodGroup:"B+",deptId:null,doctorId:null,status:"Active",room:null,phone:"08030006026",email:"",insurance:"RELIANCE",insuranceNo:"HMO101702",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:47,mrn:"2606TH0047",fullName:"Uche USMAN",gender:"Male",age:39,bloodGroup:"O+",deptId:null,doctorId:null,status:"Active",room:null,phone:"08030006157",email:"",insurance:"Self-Pay",insuranceNo:"",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:48,mrn:"2606TH0048",fullName:"Ada NWOSU",gender:"Female",age:46,bloodGroup:"A+",deptId:null,doctorId:null,status:"Active",room:null,phone:"08030006288",email:"",insurance:"RONSBERGER HMO",insuranceNo:"HMO101776",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:49,mrn:"2606TH0049",fullName:"Kelechi IBRAHIM",gender:"Male",age:53,bloodGroup:"B+",deptId:null,doctorId:null,status:"Active",room:null,phone:"08030006419",email:"",insurance:"HYGEIA",insuranceNo:"HMO101813",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:50,mrn:"2606TH0050",fullName:"Blessing OKONKWO",gender:"Female",age:60,bloodGroup:"AB+",deptId:null,doctorId:null,status:"Active",room:null,phone:"08030006550",email:"",insurance:"AXA MANSARD",insuranceNo:"HMO101850",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:51,mrn:"2606TH0051",fullName:"Samuel ADEBAYO",gender:"Male",age:67,bloodGroup:"O-",deptId:null,doctorId:null,status:"Active",room:null,phone:"08030006681",email:"",insurance:"LEADWAY",insuranceNo:"HMO101887",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:52,mrn:"2606TH0052",fullName:"Grace OJO",gender:"Female",age:74,bloodGroup:"A-",deptId:null,doctorId:null,status:"Active",room:null,phone:"08030006812",email:"",insurance:"Self-Pay",insuranceNo:"",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:53,mrn:"2606TH0053",fullName:"Ahmed SANI",gender:"Male",age:19,bloodGroup:"",deptId:null,doctorId:null,status:"Active",room:null,phone:"08030006943",email:"",insurance:"THT",insuranceNo:"HMO101961",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:54,mrn:"2606TH0054",fullName:"Fatima BALOGUN",gender:"Female",age:26,bloodGroup:"O+",deptId:null,doctorId:null,status:"Active",room:null,phone:"08030007074",email:"",insurance:"AVON",insuranceNo:"HMO101998",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:55,mrn:"2606TH0055",fullName:"John GARBA",gender:"Male",age:33,bloodGroup:"A+",deptId:null,doctorId:null,status:"Active",room:null,phone:"08030007205",email:"",insurance:"Self-Pay",insuranceNo:"",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:56,mrn:"2606TH0056",fullName:"Mary IHEANACHO",gender:"Female",age:40,bloodGroup:"B+",deptId:null,doctorId:null,status:"Active",room:null,phone:"08030007336",email:"",insurance:"RELIANCE",insuranceNo:"HMO102072",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:57,mrn:"2606TH0057",fullName:"Peter AKPAN",gender:"Male",age:47,bloodGroup:"O+",deptId:null,doctorId:null,status:"Active",room:null,phone:"08030007467",email:"",insurance:"Self-Pay",insuranceNo:"",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:58,mrn:"2606TH0058",fullName:"Esther OKAFOR",gender:"Female",age:54,bloodGroup:"A+",deptId:null,doctorId:null,status:"Active",room:null,phone:"08030007598",email:"",insurance:"RONSBERGER HMO",insuranceNo:"HMO102146",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:59,mrn:"2606TH0059",fullName:"Daniel BELLO",gender:"Male",age:61,bloodGroup:"B+",deptId:null,doctorId:null,status:"Active",room:null,phone:"08030007729",email:"",insurance:"HYGEIA",insuranceNo:"HMO102183",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:60,mrn:"2606TH0060",fullName:"Ruth EZE",gender:"Female",age:68,bloodGroup:"AB+",deptId:null,doctorId:null,status:"Active",room:null,phone:"08030007860",email:"",insurance:"AXA MANSARD",insuranceNo:"HMO102220",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:61,mrn:"2606TH0061",fullName:"Joseph ABUBAKAR",gender:"Male",age:75,bloodGroup:"O-",deptId:null,doctorId:null,status:"Active",room:null,phone:"08030007991",email:"",insurance:"LEADWAY",insuranceNo:"HMO102257",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:62,mrn:"2606TH0062",fullName:"Rachael UDOKA",gender:"Female",age:20,bloodGroup:"A-",deptId:null,doctorId:null,status:"Active",room:null,phone:"08030008122",email:"",insurance:"Self-Pay",insuranceNo:"",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:63,mrn:"2606TH0063",fullName:"Ismail DANJUMA",gender:"Male",age:27,bloodGroup:"",deptId:null,doctorId:null,status:"Active",room:null,phone:"08030008253",email:"",insurance:"THT",insuranceNo:"HMO102331",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:64,mrn:"2606TH0064",fullName:"Aisha OYELARAN",gender:"Female",age:34,bloodGroup:"O+",deptId:null,doctorId:null,status:"Active",room:null,phone:"08030008384",email:"",insurance:"AVON",insuranceNo:"HMO102368",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:65,mrn:"2606TH0065",fullName:"Obinna YUSUF",gender:"Male",age:41,bloodGroup:"A+",deptId:null,doctorId:null,status:"Active",room:null,phone:"08030008515",email:"",insurance:"Self-Pay",insuranceNo:"",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:66,mrn:"2606TH0066",fullName:"Chinwe ADEWALE",gender:"Female",age:48,bloodGroup:"B+",deptId:null,doctorId:null,status:"Active",room:null,phone:"08030008646",email:"",insurance:"RELIANCE",insuranceNo:"HMO102442",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:67,mrn:"2606TH0067",fullName:"Segun SULEIMAN",gender:"Male",age:55,bloodGroup:"O+",deptId:null,doctorId:null,status:"Active",room:null,phone:"08030008777",email:"",insurance:"Self-Pay",insuranceNo:"",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:68,mrn:"2606TH0068",fullName:"Yetunde OGUNDIPE",gender:"Female",age:62,bloodGroup:"A+",deptId:null,doctorId:null,status:"Active",room:null,phone:"08030008908",email:"",insurance:"RONSBERGER HMO",insuranceNo:"HMO102516",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""}]
;
  function keyOf(p){ return String((p&&(p.mrn||p.MRN))||('#'+(p&&p.id))||'').trim().toUpperCase(); }
  function maxId(list){ var m=0; (list||[]).forEach(function(p){ var n=parseInt(p&&p.id,10); if(!isNaN(n)&&n>m) m=n; }); return m; }
  function apply(){
    var D=D_(); if(!D) return;
    if(!Array.isArray(D.patients)) D.patients=[];
    // Build set of existing keys (MRN or id)
    var seen={}; D.patients.forEach(function(p){ var k=keyOf(p); if(k) seen[k]=true; });
    var added=0, nextId=maxId(D.patients);
    EXTRA.forEach(function(src){
      var p={}; for(var kk in src){ if(Object.prototype.hasOwnProperty.call(src,kk)) p[kk]=src[kk]; }
      var k=keyOf(p);
      if(k && seen[k]) return;            // already present (by MRN) — skip, never overwrite
      // Guard against id collision with user data
      var idn=parseInt(p.id,10);
      var idTaken=D.patients.some(function(x){ return parseInt(x.id,10)===idn; });
      if(idTaken){ nextId+=1; p.id=nextId; } else if(idn>nextId){ nextId=idn; }
      D.patients.push(p); seen[k]=true; added++;
    });
    if(added>0){
      D._twhRosterV220 = ROSTER_VERSION;
      try{ if(typeof buildNav==='function') buildNav(); }catch(e){}
      try{
        if(typeof currentMod!=='undefined' && currentMod==='patients' && typeof renderPatients==='function') renderPatients();
        else if(D.currentMod==='patients' && typeof renderPatients==='function') renderPatients();
      }catch(e){}
      try{ if(typeof render==='function') render(); }catch(e){}
      SAVE();
      try{ console.log('%c✅ v220 Patient Roster Repair — added '+added+' patient(s); roster now '+D.patients.length,'color:#059669;font-weight:bold'); }catch(e){}
    } else {
      try{ console.log('%c✅ v220 Patient Roster — already complete ('+D.patients.length+' patients)','color:#059669'); }catch(e){}
    }
  }
  // Run once synchronously so Node tests without timers still initialize
  try{ apply(); }catch(e){}
  [0,150,400,900,1800,3000].forEach(function(t){ try{ setTimeout(apply,t); }catch(e){} });
  try{ window.addEventListener('load',apply); }catch(e){}
  try{ if(window.HMS_DB&&typeof window.HMS_DB.onState==='function') window.HMS_DB.onState('idle',apply); }catch(e){}
  try{ window.__twhV220Apply=apply; }catch(e){}
})();

;

/* ==== /js/170-twh-sync-recover-v221.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   v221 — Sync Recovery + Full-Record Restore
   ────────────────────────────────────────────────────────────────────────
   Fixes two user-reported issues:

   (A) A stranded "Saving… / Uploading chunk N/M…" popup (#twhChunkProgress).
       Root cause: the chunked uploader (v199) uses fetch() with NO timeout,
       so a hung/slow network leaves the promise pending and the popup on
       screen forever.  This pack:
         • Adds a hard per-request TIMEOUT (AbortController, 25s) around the
           chunked uploader's fetch, so a stalled request fails fast and the
           existing pause/fallback path runs (data saved locally, popup shows
           an actionable state instead of an eternal spinner).
         • Installs a WATCHDOG: if the progress popup has been showing the same
           "Uploading chunk…/Saving…" state with no progress for >40s, it is
           auto-dismissed and the payload is preserved to the offline queue.
         • Makes the popup dismissable: the × always closes it; a "Dismiss"
           action is added; clicking outside is honoured; ESC closes it.
         • Guarantees the popup auto-hides shortly after a successful save.

   (B) Appointments, Medical Records and Bills not coming back into the app.
       Root cause: the delta writer only sends changed keys; if a tab ever
       emptied a collection the rows still live on the server and simply need
       to be pulled + unioned into THIS tab.  v200 already has this logic but
       it (i) wasn't force-run reliably on every load / after login and
       (ii) the ensured-collection list used the wrong name ("billing" instead
       of "bills").  This pack force-reconciles the WHOLE server document into
       D on load + after login + on a gentle interval, unioning EVERY record
       array by id (bills, appointments, medicalRecords, labTests, labOrders,
       radiologyOrders, prescriptions, mealPlans, transactions, …) so nothing
       stays missing, then re-renders.

   Idempotent; guarded by window.__twhV221.
   ════════════════════════════════════════════════════════════════════════ */
(function(){
  if(window.__twhV221) return; window.__twhV221 = true;

  function D_(){ try{ return (typeof D!=='undefined'&&D)?D:(window.D||(window.D={})); }catch(e){ return window.D||(window.D={}); } }
  function isObj(v){ return v && typeof v==='object' && !Array.isArray(v); }
  function isRecArr(a){ if(!Array.isArray(a)||!a.length) return false; for(var i=0;i<a.length;i++){ if(!isObj(a[i])||!('id' in a[i])) return false; } return true; }
  function revOf(r){ var v=r&&r._rev; return (typeof v==='number'&&isFinite(v))?v:0; }

  /* ─────────────────────────────────────────────────────────────────────
     (A) STUCK-POPUP RECOVERY
     ───────────────────────────────────────────────────────────────────── */
  var POPUP_ID='twhChunkProgress';
  function popup(){ return document.getElementById(POPUP_ID); }
  function hidePopup(){ var d=popup(); if(d){ d.style.display='none'; } }

  // Watchdog: remember the last message + a timestamp; if it hasn't changed
  // (no progress) for STALL_MS while visible, force-dismiss and preserve data.
  var STALL_MS=40000;
  var _lastMsg=null, _lastChange=Date.now();
  function preserveOffline(){
    try{
      var d=D_();
      var IDENTITY=['currentUser','currentBranch','currentMod','_wellTab','_activeTab','isLoggedIn'];
      var clean={}; for(var k in d){ if(IDENTITY.indexOf(k)===-1) clean[k]=d[k]; }
      var KEY='MCP_HMS_DATA_v17';
      try{ if(window._HMS_STORAGE_KEY) KEY=window._HMS_STORAGE_KEY; }catch(e){}
      localStorage.setItem('twhChunkedQueue_'+KEY, JSON.stringify([{ts:Date.now(),envelope:{data:clean}}]));
    }catch(e){}
  }
  function watchdog(){
    var d=popup();
    if(!d || d.style.display==='none'){ _lastMsg=null; _lastChange=Date.now(); return; }
    var msgEl=d.querySelector('#twhCpMsg'); var barEl=d.querySelector('#twhCpBar');
    var sig=(msgEl?msgEl.textContent:'')+'|'+(barEl?barEl.style.width:'');
    if(sig!==_lastMsg){ _lastMsg=sig; _lastChange=Date.now(); return; }
    if(Date.now()-_lastChange > STALL_MS){
      // Stalled: preserve to offline queue and dismiss so the UI is never stuck.
      preserveOffline();
      try{
        var msg=d.querySelector('#twhCpMsg');
        if(msg) msg.textContent='Save is taking too long — your changes are saved on this device and will sync automatically. You can keep working.';
        var icon=d.querySelector('#twhCpIcon'); if(icon) icon.textContent='💾';
        var title=d.querySelector('#twhCpTitle'); if(title) title.textContent='Saved locally';
        var act=d.querySelector('#twhCpActions'); if(act){ act.style.display='none'; }
      }catch(e){}
      setTimeout(hidePopup, 3500);
      _lastChange=Date.now();
    }
  }
  DOMBus.register(watchdog);

  // Make the popup robustly dismissable: ensure the × works, add ESC + a
  // guaranteed "Dismiss" affordance, and never let it block interaction.
  function hardenPopup(){
    var d=popup(); if(!d || d.__v221Hardened) return;
    d.__v221Hardened=true;
    try{ d.style.pointerEvents='auto'; }catch(e){}
    var close=d.querySelector('#twhCpClose');
    if(close){ close.onclick=function(ev){ if(ev){try{ev.stopPropagation();}catch(_){}} hidePopup(); }; close.style.pointerEvents='auto'; close.title='Dismiss'; }
    // Add a small always-available Dismiss link under the message.
    if(!d.querySelector('#twhCpDismiss')){
      var msg=d.querySelector('#twhCpMsg');
      if(msg){
        var a=document.createElement('a');
        a.id='twhCpDismiss'; a.href='#'; a.textContent='Dismiss';
        a.style.cssText='display:inline-block;margin-top:8px;color:#64748b;font-size:11px;text-decoration:underline;cursor:pointer';
        a.onclick=function(ev){ if(ev){try{ev.preventDefault();ev.stopPropagation();}catch(_){}} preserveOffline(); hidePopup(); return false; };
        msg.parentNode.insertBefore(a, msg.nextSibling);
      }
    }
  }
  // ESC closes the popup from anywhere.
  document.addEventListener('keydown', function(ev){ if(ev && (ev.key==='Escape'||ev.keyCode===27)){ var d=popup(); if(d && d.style.display!=='none'){ hidePopup(); } } });
  [0,300,900,2000,4000].forEach(function(t){ try{ setTimeout(hardenPopup,t); }catch(e){} });
  DOMBus.register(hardenPopup);

  // Add a per-request TIMEOUT to the chunked uploader by wrapping its transport.
  // v199 exposes HMS_CHUNKED.save; the uploader itself uses fetch(CHUNKED_EP).
  // We can't reach its private sendChunk, but we CAN install a global guard:
  // wrap window.fetch so any POST to /api/chunked/ that hasn't responded within
  // FETCH_TIMEOUT is aborted (turning a hang into a fast, retryable failure the
  // v199 backoff/pause/fallback already handles). Non-chunked calls untouched.
  var FETCH_TIMEOUT=25000;
  (function installFetchTimeout(){
    if(!window.fetch || window.fetch.__v221Timeout) return;
    var origFetch=window.fetch.bind(window);
    var wrapped=function(input, init){
      var url = (typeof input==='string') ? input : (input && input.url) || '';
      var isChunked = /\/api\/chunked\//.test(url);
      if(!isChunked) return origFetch(input, init);
      init = init || {};
      // If caller already provided a signal, respect it (don't double-abort).
      if(init.signal) return origFetch(input, init);
      try{
        var ac = new AbortController();
        init = Object.assign({}, init, { signal: ac.signal });
        var to = setTimeout(function(){ try{ ac.abort(); }catch(e){} }, FETCH_TIMEOUT);
        return origFetch(input, init).then(function(r){ clearTimeout(to); return r; },
                                          function(e){ clearTimeout(to); throw e; });
      }catch(e){ return origFetch(input, init); }
    };
    wrapped.__v221Timeout=true;
    try{ window.fetch=wrapped; }catch(e){}
  })();

  /* ─────────────────────────────────────────────────────────────────────
     (B) FULL-RECORD RESTORE — pull the whole server document and union
         every record array by id so nothing stays missing.
     ───────────────────────────────────────────────────────────────────── */
  var RECORD_COLLECTIONS = ['appointments','medicalRecords','prescriptions','labTests',
    'labOrders','radiologyOrders','bills','transactions','mealPlans','patients',
    'consentRecords','referrals','admissions','wellnessScreenings','wellnessAssessments',
    'dietOrders','nursingNotes','vitals'];

  function ensureArrays(){
    var d=D_();
    RECORD_COLLECTIONS.forEach(function(k){ if(!Array.isArray(d[k])) d[k]=[]; });
  }

  function unionInto(localArr, serverArr, tomb, table){
    var dead={};
    if(tomb && Array.isArray(tomb[table])) tomb[table].forEach(function(id){ dead[id]=1; });
    var byId={}, order=[];
    (localArr||[]).forEach(function(r){ if(isObj(r)&&'id' in r){ if(!(r.id in byId)) order.push(r.id); byId[r.id]=r; } });
    (serverArr||[]).forEach(function(r){
      if(!isObj(r)||!('id' in r)) return;
      if(dead[r.id]) return;
      if(!(r.id in byId)){ order.push(r.id); byId[r.id]=r; }
      else if(revOf(r) > revOf(byId[r.id])) byId[r.id]=r;
    });
    return order.map(function(id){ return byId[id]; }).filter(function(r){ return r && !dead[r.id]; });
  }

  var _busy=false;
  function restoreRecords(opts){
    opts=opts||{};
    if(_busy) return Promise.resolve(0);
    var ep = window._HMS_API_ENDPOINT;
    if(!ep){ return Promise.resolve(0); }
    _busy=true;
    return fetch(ep, {credentials:'include', cache:'no-store', headers:{'Accept':'application/json'}})
      .then(function(r){ if(!r.ok) throw new Error('HTTP '+r.status); return r.json(); })
      .then(function(j){
        var srv = j && j.data; if(!isObj(srv)){ return 0; }
        var d=D_(); ensureArrays();
        var tomb = d.__deletedIds || {};
        var restored=0;
        Object.keys(srv).forEach(function(k){
          var sv=srv[k];
          if(!Array.isArray(sv)) return;
          if(!(isRecArr(sv) || isRecArr(d[k]))) return;   // only record-arrays
          var before = Array.isArray(d[k]) ? d[k].length : 0;
          var merged = unionInto(d[k]||[], sv, tomb, k);
          restored += Math.max(0, merged.length - before);
          d[k]=merged;
        });
        if(restored>0 || opts.force){ try{ if(typeof window.render==='function') window.render(); }catch(e){}
          try{ if(typeof buildNav==='function') buildNav(); }catch(e){} }
        if(restored>0){ try{ if(window._hmsSaveSoon) window._hmsSaveSoon(); }catch(e){} }
        if(opts.toast){ try{ toast(restored>0?('Restored '+restored+' record(s) from cloud'):'Records already up to date'); }catch(e){} }
        return restored;
      })
      .catch(function(e){ if(opts.toast){ try{ toast('Restore failed: '+(e&&e.message||e),'err'); }catch(_){} } return 0; })
      .then(function(n){ _busy=false; return n; });
  }
  window.__hmsRestoreRecords = function(){ return restoreRecords({toast:true, force:true}); };

  function loggedInOrOpen(){
    try{ return window.isLoggedIn || !window.__HMS_AUTH || !window.__HMS_AUTH.configured; }catch(e){ return true; }
  }
  // Force a restore on load (after auth settles) + a couple of re-asserts.
  [3500, 9000].forEach(function(t){ setTimeout(function(){ if(loggedInOrOpen()) restoreRecords({force:true}); }, t); });
  // Gentle safety-net so records that arrive later (multi-device) surface too.
  // Phase 3: on the ONE shared scheduler (already pauses when hidden; the inner
  // visibility check is now redundant but harmless and kept for the fallback path).
  if(window.HMS && window.HMS.every){ window.HMS.every(60000, function(){ if(loggedInOrOpen() && document.visibilityState!=='hidden') restoreRecords({}); }); }
  else { setInterval(function(){ if(loggedInOrOpen() && document.visibilityState!=='hidden') restoreRecords({}); }, 60000); }
  // Restore right after a login completes.
  try{ if(window.HMS_DB && typeof window.HMS_DB.onState==='function') window.HMS_DB.onState('idle', function(){ if(loggedInOrOpen()) restoreRecords({}); }); }catch(e){}

  console.log('✅ v221 sync recovery + restore');
})();

;

/* ==== /js/171-twh-autosave-orchestrator-v222.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   v222 — Auto-Save & Auto-Resume Orchestrator
   ────────────────────────────────────────────────────────────────────────
   User request: the chunked-save popup keeps showing "Uploading chunk 6/6…"
   (stuck near the end) and "Upload paused at chunk 1/6 … [Resume]" (needs a
   MANUAL click). Automate the whole thing so saving/updating self-recovers
   on the frontend without any user action, retrying every ~10–15s.

   What this pack does (idempotent, guarded by window.__twhV222):

   1. AUTO-RESUME ENGINE — every AUTO_EVERY ms (12s), if the chunked uploader
      reports pending work (HMS_CHUNKED.hasPending(): a paused session or a
      queued offline snapshot), it automatically calls HMS_CHUNKED.resume().
      No more manual "Resume" clicks — the upload finishes itself.

   2. PAUSED-CARD → AUTO-RETRY — rewrites the "Paused" popup so instead of
      demanding a click it shows "Reconnecting… retrying automatically in Ns"
      with a live countdown, and fires the resume when the countdown hits 0.
      The manual Resume button is kept as an optional "Retry now" override.

   3. STUCK "Uploading chunk N/N" RECOVERY — if the final-chunk card lingers
      (assembly slow / response lost) it is re-kicked: after STUCK_MS with no
      change the current save is nudged (resume if pending, else a fresh
      _hmsSaveSoon) and the card is auto-cleared once nothing is pending.

   4. COMPLETED-CARD AUTO-HIDE — once HMS_CHUNKED.hasPending() is false the
      "Saving…" card is hidden automatically (belt-and-braces with v199's own
      autohide) so a completed save never lingers on screen.

   5. PERIODIC AUTO-SAVE — every SAVE_EVERY ms (15s), if the document changed
      since the last flush, it is saved (window._hmsSaveSoon / _hmsFlush) so
      the frontend stays continuously in sync with the database.

   Nothing here blocks the UI; every action is guarded and best-effort.
   ════════════════════════════════════════════════════════════════════════ */
(function(){
  if(window.__twhV222) return; window.__twhV222 = true;

  var AUTO_EVERY   = 12000;   // auto-resume sweep cadence (~12s, within 10–15s)
  var SAVE_EVERY   = 15000;   // periodic auto-save cadence (~15s)
  var STUCK_MS     = 18000;   // no-progress window before we re-kick a save
  var COUNTDOWN_S  = 12;      // seconds shown on the auto-retry countdown

  function log(){ try{ console.log.apply(console,['%c[autosave v222]','color:#065f46;font-weight:bold'].concat([].slice.call(arguments))); }catch(e){} }
  function D_(){ try{ return (typeof D!=='undefined'&&D)?D:(window.D||(window.D={})); }catch(e){ return window.D||(window.D={}); } }
  function popup(){ return document.getElementById('twhChunkProgress'); }
  function chunked(){ return window.HMS_CHUNKED || null; }
  function hasPending(){ try{ var c=chunked(); return !!(c && typeof c.hasPending==='function' && c.hasPending()); }catch(e){ return false; } }
  function doResume(){ try{ var c=chunked(); if(c && typeof c.resume==='function'){ c.resume(); return true; } }catch(e){} return false; }
  function hidePopup(){ var d=popup(); if(d){ d.style.display='none'; } }

  /* ── 1 + 2 + 3 : Auto-resume + paused-card rewrite + stuck recovery ──────── */
  var _resuming=false, _resumingAt=0;
  var RESUME_GUARD_MS=4000;
  var _cdTimer=null, _cd=0;
  var _lastSig=null, _lastChange=Date.now();

  function popupSignature(){
    var d=popup(); if(!d) return '';
    var msg=d.querySelector('#twhCpMsg'); var bar=d.querySelector('#twhCpBar');
    return (d.style.display||'')+'|'+(msg?msg.textContent:'')+'|'+(bar?bar.style.width:'');
  }
  function isVisible(){ var d=popup(); return !!(d && d.style.display!=='none'); }
  function titleText(){ var d=popup(); var t=d&&d.querySelector('#twhCpTitle'); return t?String(t.textContent||''):''; }
  function msgEl(){ var d=popup(); return d?d.querySelector('#twhCpMsg'):null; }

  // Turn the "Paused" card into an auto-retrying card with a live countdown.
  function autoifyPausedCard(){
    var d=popup(); if(!d || !isVisible()) return;
    var title=(titleText()||'').toLowerCase();
    var m=msgEl();
    var isPaused = title.indexOf('paused')>=0 || (m && /upload paused/i.test(m.textContent||''));
    if(!isPaused) return;
    if(d.__v222Countdown) return;           // already counting down
    d.__v222Countdown=true;
    // Relabel the manual button to "Retry now" (still works, but optional).
    try{
      var btn=d.querySelector('#twhCpResume');
      if(btn){ btn.textContent='Retry now'; btn.onclick=function(){ stopCountdown(); resumeNow(); }; }
    }catch(e){}
    startCountdown();
  }
  function startCountdown(){
    if(_cdTimer){ clearInterval(_cdTimer); _cdTimer=null; }  // clear any prior timer WITHOUT dropping the countdown flag
    _cd=COUNTDOWN_S;
    _cdTimer=setInterval(tickCountdown, 1000);
    tickCountdown();
  }
  function stopCountdown(){ if(_cdTimer){ clearInterval(_cdTimer); _cdTimer=null; } var d=popup(); if(d) d.__v222Countdown=false; }
  function tickCountdown(){
    var d=popup();
    if(!d || !isVisible()){ stopCountdown(); return; }
    // Stop only if the card itself dropped out of countdown mode (resumed /
    // completed / dismissed). We drive the title to "Reconnecting" ourselves,
    // so we must NOT stop just because the title no longer says "paused".
    if(!d.__v222Countdown){ stopCountdown(); return; }
    var m=msgEl();
    if(m){
      m.textContent='Reconnecting… retrying automatically in '+_cd+'s. Your data is safe (saved on this device).';
    }
    try{ var icon=d.querySelector('#twhCpIcon'); if(icon) icon.textContent='🔄'; }catch(e){}
    try{ var t=d.querySelector('#twhCpTitle'); if(t) t.textContent='Reconnecting'; }catch(e){}
    if(_cd<=0){ stopCountdown(); resumeNow(); return; }
    _cd--;
  }
  function resumeGuarded(){
    // time-based guard: robust even if the release timer never fires
    if(_resuming && (Date.now()-_resumingAt) < RESUME_GUARD_MS) return false;
    return true;
  }
  function resumeNow(){
    if(!resumeGuarded()) return;
    _resuming=true; _resumingAt=Date.now();
    stopCountdown();
    try{
      var m=msgEl(); if(m) m.textContent='Resuming upload…';
      var t=popup()&&popup().querySelector('#twhCpTitle'); if(t) t.textContent='Saving…';
      var icon=popup()&&popup().querySelector('#twhCpIcon'); if(icon) icon.textContent='☁️';
    }catch(e){}
    log('auto-resuming paused/queued upload');
    doResume();
    // release the guard shortly so the next sweep can act if it re-pauses
    setTimeout(function(){ _resuming=false; }, RESUME_GUARD_MS);
  }

  // Master sweep: drives auto-resume, paused-card automation, stuck recovery,
  // and completed-card auto-hide. Runs on a steady cadence.
  function sweep(){
    try{
      // (a) Anything pending on the uploader → auto-resume it.
      if(hasPending() && resumeGuarded()){
        // If the paused card is visible, let the countdown handle timing;
        // otherwise resume immediately (silent background retry).
        if(!(isVisible() && (titleText()||'').toLowerCase().indexOf('paused')>=0)){
          resumeNow();
        }
      }
      // (b) If a paused card is on screen, convert it to auto-retry.
      autoifyPausedCard();

      // (c) Completed / nothing-pending → make sure the card is gone.
      if(!hasPending()){
        var t=(titleText()||'').toLowerCase();
        // Only auto-hide "success/idle" style cards, not an in-flight upload.
        if(isVisible() && (t.indexOf('saved')>=0 || t==='' )){ hidePopup(); }
      }

      // (d) Stuck detector: if the card hasn't changed for STUCK_MS while an
      //     upload appears in-flight, re-kick the save pipeline.
      var sig=popupSignature();
      if(sig!==_lastSig){ _lastSig=sig; _lastChange=Date.now(); }
      else if(isVisible() && (Date.now()-_lastChange > STUCK_MS)){
        var t2=(titleText()||'').toLowerCase();
        var uploading = t2.indexOf('saving')>=0 || (msgEl() && /uploading chunk/i.test(msgEl().textContent||''));
        if(uploading){
          log('save appears stuck ('+Math.round((Date.now()-_lastChange)/1000)+'s) — re-kicking');
          if(hasPending()){ resumeNow(); }
          else { try{ if(window._hmsSaveSoon) window._hmsSaveSoon(); }catch(e){} hidePopup(); }
          _lastChange=Date.now();
        }
      }
    }catch(e){ /* never let the sweep throw */ }
  }
  DOMBus.register(sweep);
  // A faster light poll just to keep the countdown / paused-card responsive.
  DOMBus.register(function(){ try{ autoifyPausedCard(); }catch(e){} });

  // Resume immediately on reconnect / tab-focus (don't wait for the sweep).
  window.addEventListener('online', function(){ setTimeout(function(){ if(hasPending()) resumeNow(); }, 600); });
  document.addEventListener('visibilitychange', function(){ if(document.visibilityState==='visible' && hasPending()) setTimeout(resumeNow, 400); });

  /* ── 5 : Periodic auto-save keeps the frontend continuously in sync ──────── */
  var _lastDocSig=null;
  function docSig(){
    try{
      var d=D_();
      // Cheap change signature: sizes of the record collections + a version stamp.
      var keys=['patients','appointments','medicalRecords','prescriptions','labTests',
                'labOrders','radiologyOrders','bills','transactions','mealPlans'];
      var parts=[];
      for(var i=0;i<keys.length;i++){ var a=d[keys[i]]; parts.push(Array.isArray(a)?a.length:0); }
      parts.push(d._rev||0); parts.push(d._twhRosterV220||0);
      return parts.join(',');
    }catch(e){ return String(Date.now()); }
  }
  function loggedInOrOpen(){
    try{ return window.isLoggedIn || !window.__HMS_AUTH || !window.__HMS_AUTH.configured; }catch(e){ return true; }
  }
  function periodicSave(){
    if(!loggedInOrOpen()) return;
    if(document.visibilityState==='hidden') return;   // beforeunload/visibility already flush
    var sig=docSig();
    if(_lastDocSig===null){ _lastDocSig=sig; return; } // first run: just baseline
    if(sig!==_lastDocSig){
      _lastDocSig=sig;
      try{ if(window._hmsSaveSoon) window._hmsSaveSoon(); else if(window._hmsSave) window._hmsSave(); }catch(e){}
      log('periodic auto-save flushed a change');
    }
  }
  DOMBus.register(periodicSave);

  /* ── Public helpers ─────────────────────────────────────────────────────── */
  window.__twhAutoResume = resumeNow;
  window.__twhAutoSaveNow = function(){ try{ if(window._hmsFlush) window._hmsFlush(); else if(window._hmsSave) window._hmsSave(); }catch(e){} };

  // Kick an initial sweep shortly after load so a pending upload from a prior
  // session is picked up automatically without any click.
  [2500, 6000, 12000].forEach(function(t){ setTimeout(function(){ if(hasPending()) resumeNow(); autoifyPausedCard(); }, t); });

  console.log('✅ v222 auto-save orchestrator');
})();

;

/* ==== /js/172-periodic-mirror-cadence-ms-cheap-best-effort.js ==== */
(function(){
  if(window.__twhV224b) return; window.__twhV224b = true;

  var MIRROR_EVERY = 20000;   // periodic mirror cadence (ms) — cheap, best-effort
  function D_(){ try{ return (typeof D!=='undefined'&&D)?D:(window.D||null); }catch(e){ return window.D||null; } }
  function mirror(){ try{ return window.__twhMirror||null; }catch(e){ return null; } }

  /* ── 1 : continuous on-device mirror ─────────────────────────────────── */
  function stripId(d){
    // Best-effort: drop obvious per-tab identity keys so the mirror matches
    // the shared doc shape. Falls back to the raw doc if the app helper exists.
    try{ if(typeof window._hmsStripIdentity==='function') return window._hmsStripIdentity(d); }catch(e){}
    return d;
  }
  function mirrorNow(){
    try{
      var d=D_(); var m=mirror();
      if(!d || !m) return;
      // Only mirror once the app is actually populated (avoid clobbering with an
      // empty seed before boot restore completes).
      if(!d.patients && !d.appointments && !d.transactions) return;
      m.write(stripId(d));
    }catch(e){}
  }
  // Mirror right after every save success.
  try{
    if(window.HMS_DB && typeof window.HMS_DB.onState==='function'){
      window.HMS_DB.onState(function(state){ if(state==='idle') mirrorNow(); });
    }
  }catch(e){}
  // Mirror on unload / hide as a final guarantee.
  try{
    window.addEventListener('beforeunload', mirrorNow);
    document.addEventListener('visibilitychange', function(){ if(document.visibilityState==='hidden') mirrorNow(); });
  }catch(e){}
  // Periodic backstop (short & cheap).
  DOMBus.register(mirrorNow);
  // One mirror shortly after boot settles.
  setTimeout(mirrorNow, 4000);

  /* ── 2 + 3 : offline-aware chip + auto-flush on reconnect ────────────── */
  var CHIP_ID = 'twhOfflineChip';
  function isOffline(){ try{ return navigator.onLine===false; }catch(e){ return false; } }

  function ensureChip(){
    var c=document.getElementById(CHIP_ID);
    if(!c){
      c=document.createElement('div');
      c.id=CHIP_ID;
      c.style.cssText='position:fixed;left:50%;bottom:18px;transform:translateX(-50%);'
        +'z-index:2147483000;display:none;align-items:center;gap:8px;'
        +'background:#7c2d12;color:#fff;font:600 13px system-ui,Segoe UI,Roboto,sans-serif;'
        +'padding:9px 16px;border-radius:999px;box-shadow:0 6px 24px rgba(0,0,0,.25)';
      c.innerHTML='<span style="font-size:15px">📴</span><span id="twhOfflineTxt">Offline — your changes are saved on this device and will sync automatically</span>';
      (document.body||document.documentElement).appendChild(c);
    }
    return c;
  }
  function showChip(text, bg){
    var c=ensureChip();
    var t=document.getElementById('twhOfflineTxt'); if(t) t.textContent=text;
    if(bg) c.style.background=bg;
    c.style.display='inline-flex';
  }
  function hideChipSoon(){
    var c=document.getElementById(CHIP_ID); if(!c) return;
    setTimeout(function(){ if(!isOffline()){ c.style.display='none'; } }, 2500);
  }

  function flushNow(){
    try{
      if(window._hmsSave) return window._hmsSave();
      if(window._hmsSaveSoon) return window._hmsSaveSoon();
    }catch(e){}
  }

  function onOffline(){
    showChip('Offline — your changes are saved on this device and will sync automatically', '#7c2d12');
    mirrorNow();
  }
  function onOnline(){
    showChip('Back online — syncing your changes…', '#0d9488');
    // give the network a beat, then flush + reconcile
    setTimeout(function(){
      flushNow();
      try{ if(window.HMS_CHUNKED && typeof window.HMS_CHUNKED.hasPending==='function' && window.HMS_CHUNKED.hasPending() && window.HMS_CHUNKED.resume){ window.HMS_CHUNKED.resume(); } }catch(e){}
      try{ if(window.__twhAutoResume) window.__twhAutoResume(); }catch(e){}
      hideChipSoon();
    }, 700);
  }
  try{
    window.addEventListener('offline', onOffline);
    window.addEventListener('online',  onOnline);
    // reflect the initial state if we loaded while offline
    if(isOffline()) onOffline();
  }catch(e){}

  // On tab focus while online, opportunistically flush any pending change.
  try{
    document.addEventListener('visibilitychange', function(){
      if(document.visibilityState==='visible' && !isOffline()){ setTimeout(flushNow, 400); }
    });
  }catch(e){}

  // Also enrich the existing v185 header sync chip with an OFFLINE label when
  // the network is down (so both the header chip and the toast agree).
  try{
    if(window.HMS_DB && typeof window.HMS_DB.onState==='function'){
      window.HMS_DB.onState(function(state){
        if(isOffline()){ showChip('Offline — your changes are saved on this device and will sync automatically', '#7c2d12'); }
      });
    }
  }catch(e){}

  /* NOTE: console-noise reduction is handled EARLY (right after the v223
     governor in <head>) via installConsolePolish — it must wrap console.log
     BEFORE the ~100 pack banners are logged during boot. See v224c. */

  /* ── public helpers ──────────────────────────────────────────────────── */
  window.__twhMirrorNow = mirrorNow;
  window.__twhFlushNow  = flushNow;

  try{
    console.info('%c✅ v224 — save safety net (on-device mirror + offline queue + auto-flush) & UI polish active','color:#fff;font-weight:bold;background:#065f46;padding:2px 8px;border-radius:6px');
  }catch(e){}
})();

;

/* ==== /js/173-twh-sync-superadmin-only-v225.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   v225 — Sync/Reconnecting display gated to Super System Admin ONLY
   ────────────────────────────────────────────────────────────────────────
   User request: "the sync display should only show in superadmin screen only".

   The app has several technical sync-status surfaces that were previously
   visible to every signed-in user:
     • #twhChunkProgress  — the "Saving…/Reconnecting… retrying automatically"
                            toast (v199 chunked uploader, driven by v222).
     • .v185-sync-slot    — the header sync chip (Syncing…/Sync error/Saved).
     • #twhOfflineChip    — the bottom "Offline — saved on this device" chip.

   These are diagnostic/technical and should only be seen by the Super System
   Admin. For every other user the SAVE PIPELINE KEEPS RUNNING EXACTLY AS
   BEFORE — we only hide the visual surfaces; nothing about persistence,
   auto-resume, offline mirroring or flushing is disabled. Data safety is
   unchanged; we just suppress the UI for non-super-admins.

   Idempotent, guarded by window.__twhV225.
   ════════════════════════════════════════════════════════════════════════ */
(function(){
  if(window.__twhV225) return; window.__twhV225 = true;

  var SYNC_SELECTORS = ['#twhChunkProgress', '.v185-sync-slot', '#twhOfflineChip'];

  /* Resolve the real current user's role, resilient to load order. */
  function currentRole(){
    try{
      if(typeof window.currentUserObj === 'function'){
        var u = window.currentUserObj();
        if(u && u.role) return String(u.role);
      }
    }catch(e){}
    try{
      var D = window.D;
      if(D && D.currentUser && D.currentUser.username){
        var found = (D.appUsers||[]).find(function(x){ return x.username===D.currentUser.username; });
        if(found && found.role) return String(found.role);
        if(D.currentUser.role) return String(D.currentUser.role);
      }
    }catch(e){}
    return null;
  }

  /* Super System Admin is the only role allowed to see the sync surfaces. */
  function isSuperAdminView(){
    return currentRole() === 'Super System Admin';
  }
  window.__twhIsSuperAdminView = isSuperAdminView;

  /* CSS backstop: while the <html> is NOT flagged super-admin, force every
     sync surface hidden with !important so no pack can re-show it. */
  function injectCSS(){
    if(document.getElementById('twh-v225-css')) return;
    var st = document.createElement('style');
    st.id = 'twh-v225-css';
    st.textContent =
      'html:not(.twh-superadmin) #twhChunkProgress,' +
      'html:not(.twh-superadmin) .v185-sync-slot,' +
      'html:not(.twh-superadmin) #twhOfflineChip' +
      '{ display:none !important; visibility:hidden !important; pointer-events:none !important; }';
    (document.head||document.documentElement).appendChild(st);
  }

  /* Toggle the root class + hard-hide any already-rendered surfaces. */
  function apply(){
    try{
      var superView = isSuperAdminView();
      var root = document.documentElement;
      if(root){
        if(superView) root.classList.add('twh-superadmin');
        else root.classList.remove('twh-superadmin');
      }
      if(!superView){
        SYNC_SELECTORS.forEach(function(sel){
          try{
            var nodes = document.querySelectorAll(sel);
            for(var i=0;i<nodes.length;i++){ nodes[i].style.display='none'; }
          }catch(e){}
        });
      }
    }catch(e){}
  }

  /* Observe the DOM so surfaces created/shown later are re-gated instantly. */
  function installObserver(){
    try{
      if(window.__twhV225Obs) return;
      var mo = DOMBus.__mo(function(){ apply(); });
      mo.observe(document.documentElement, {subtree:true, childList:true, attributes:true, attributeFilter:['style','class']});
      window.__twhV225Obs = mo;
    }catch(e){}
  }

  function boot(){
    injectCSS();
    apply();
    installObserver();
    /* Re-apply on the standard app lifecycle hooks. */
    try{ if(window.HMS_DB && typeof window.HMS_DB.onState==='function') window.HMS_DB.onState(function(){ apply(); }); }catch(e){}
    ['click','visibilitychange','online','offline'].forEach(function(ev){
      try{ (ev==='visibilitychange'?document:window).addEventListener(ev, function(){ setTimeout(apply,0); }, true); }catch(e){}
    });
    /* Gentle safety-net sweep (cheap: a couple of getElementById checks). */
    DOMBus.register(apply);
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  try{
    console.info('%c✅ v225 — sync/reconnecting display restricted to Super System Admin only','color:#fff;font-weight:bold;background:#1e3a8a;padding:2px 8px;border-radius:6px');
  }catch(e){}
})();

;

/* ==== /js/174-twh-record-persistence-v226.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   v226 — Record persistence guarantee (orders & records always save + load)
   ────────────────────────────────────────────────────────────────────────
   Symptom (from user screenshots): appointments, laboratory orders, radiology
   orders, medical records and physiotherapy plans show EMPTY / 0 counts even
   after being created, while the save toast is stuck on "Uploading chunk 7/7"
   / "Reconnecting…". Records created in one place don't reliably survive a
   reload or reach the shared database.

   Root cause: the server merge (functions/_lib/merge.js) unions record arrays
   BY id and prefers the record with the higher `_rev` timestamp. Almost none
   of the ~877 create/edit sites stamp `_rev`, so a freshly-created order can
   be reverted by any other user's tab that re-sends a stale (pre-creation)
   copy of the same collection, and a partially-completed chunked upload can
   leave the new record unpersisted.

   What this pack does (idempotent, guarded by window.__twhV226):

   1. REV-STAMP AT SAVE TIME — wraps window._hmsStripIdentity so that, right
      before every delta is computed, every record in the tracked clinical
      collections that is NEW or CHANGED since the last save is stamped with a
      fresh, monotonic `_rev`. A freshly-created/edited record therefore ALWAYS
      carries the newest `_rev` and wins the server merge — it can never be
      reverted by another user's stale copy. Stamps are written onto the REAL
      records in D so they also persist in memory for this tab.

   2. GUARANTEED SAVE AFTER MUTATION — a light MutationObserver-free hook: every
      time a tracked collection's length grows (a record was pushed) we schedule
      an immediate _hmsSaveSoon(), so a new order/record is flushed even if its
      creator forgot to call save.

   3. STUCK-SAVE RECOVERY — if a save has been "syncing" for longer than
      STUCK_MS, force a fresh doWrite() so a stalled chunk run self-heals
      (belt-and-braces with v222's auto-resume).

   4. LOAD-TIME NORMALISE — on boot, backfill `_rev`/`id` on any records already
      in memory and trigger one save so pre-existing unsaved records land.

   Nothing here changes WHAT is stored; it only makes existing records win the
   merge and land reliably. Fully backward compatible.
   ════════════════════════════════════════════════════════════════════════ */
(function(){
  if(window.__twhV226) return; window.__twhV226 = true;

  var STUCK_MS = 20000;

  /* Clinical/order collections whose records must always survive & win. */
  var TRACKED = [
    'appointments','labTests','labOrders','radiologyOrders','medicalRecords',
    'encounters','prescriptions','physioPlans','rehabPlans','physioSessions',
    'transactions','bills','invoices','admissions','referrals','vitals',
    'nursingNotes','consentRecords','claims','procedures'
  ];

  function D_(){ try{ if(typeof D!=='undefined'&&D) return D; }catch(e){} return window.D||null; }
  function log(){ try{ console.log.apply(console,['%c[persist v226]','color:#7c2d12;font-weight:bold'].concat([].slice.call(arguments))); }catch(e){} }

  /* Monotonic rev source: strictly increasing even within the same ms. */
  var _revSeq = 0;
  function nextRev(){
    var t = Date.now();
    _revSeq = (t > _revSeq) ? t : (_revSeq + 1);
    return _revSeq;
  }

  /* Remember the serialised form of each record we last stamped, so we only
     bump `_rev` when a record's CONTENT actually changed (not on every save).
     Keyed by  collection + '::' + id. */
  var _lastSig = Object.create(null);

  function sigOf(rec){
    try{
      // Exclude _rev itself from the signature so re-stamping doesn't loop.
      var clone = {}; for(var k in rec){ if(k!=='_rev') clone[k]=rec[k]; }
      return JSON.stringify(clone);
    }catch(e){ return String(Math.random()); }
  }

  /* Stamp id + _rev on every record in the tracked collections that is new or
     changed. Mutates the real records in D (so memory + delta both see it). */
  function stampRevs(){
    var D = D_(); if(!D) return 0;
    var changed = 0;
    for(var ci=0; ci<TRACKED.length; ci++){
      var name = TRACKED[ci];
      var arr = D[name];
      if(!Array.isArray(arr) || arr.length===0) continue;
      for(var ri=0; ri<arr.length; ri++){
        var rec = arr[ri];
        if(!rec || typeof rec!=='object' || Array.isArray(rec)) continue;
        // Guarantee an id (server drops id-less records from record arrays).
        if(!('id' in rec) || rec.id==null){
          try{ rec.id = (typeof window.nid==='function') ? window.nid() : (Date.now()*1000 + ri); }catch(e){ rec.id = Date.now()*1000 + ri; }
        }
        var key = name + '::' + rec.id;
        var sig = sigOf(rec);
        if(_lastSig[key] !== sig){
          rec._rev = nextRev();       // content is new/changed → fresh rev
          _lastSig[key] = sigOf(rec); // re-read sig now that _rev excluded
          changed++;
        } else if(typeof rec._rev !== 'number'){
          rec._rev = nextRev();       // unchanged but never stamped → stamp once
          _lastSig[key] = sigOf(rec);
          changed++;
        }
      }
    }
    return changed;
  }

  /* ── 1. Hook the stripper so revs are stamped before every delta. ───────── */
  function installStripHook(){
    var orig = window._hmsStripIdentity;
    if(typeof orig !== 'function' || orig.__v226) return false;
    var wrapped = function(o){
      // Only stamp when we're stripping the whole D document (the save path).
      try{ if(o === D_()) stampRevs(); }catch(e){}
      return orig.apply(this, arguments);
    };
    wrapped.__v226 = true;
    window._hmsStripIdentity = wrapped;
    return true;
  }

  /* ── 2. Guaranteed save when a tracked collection grows. ────────────────── */
  var _lastLen = Object.create(null);
  function watchGrowth(){
    var D = D_(); if(!D) return;
    var grew = false;
    for(var i=0;i<TRACKED.length;i++){
      var n = TRACKED[i]; var arr = D[n];
      var len = Array.isArray(arr) ? arr.length : 0;
      if(_lastLen[n]===undefined){ _lastLen[n]=len; continue; }
      if(len > _lastLen[n]) grew = true;
      _lastLen[n] = len;
    }
    if(grew){
      try{ stampRevs(); }catch(e){}
      try{ if(window._hmsSaveSoon) window._hmsSaveSoon(); else if(window._hmsSave) window._hmsSave(); }catch(e){}
    }
  }

  /* ── 3. Stuck-save recovery. ────────────────────────────────────────────── */
  var _syncingSince = 0;
  function watchStuck(){
    try{
      var st = (window.HMS_DB && window.HMS_DB.syncState) || null;
      if(st==='syncing'){
        if(!_syncingSince) _syncingSince = Date.now();
        else if(Date.now()-_syncingSince > STUCK_MS){
          _syncingSince = 0;
          log('save stuck >'+STUCK_MS+'ms — forcing a fresh write');
          try{ if(window._hmsSave) window._hmsSave(); }catch(e){}
        }
      } else {
        _syncingSince = 0;
      }
    }catch(e){}
  }

  /* ── 4. Load-time normalise + one save so pre-existing records land. ────── */
  function bootNormalise(){
    try{
      var n = stampRevs();
      if(n>0){
        log('stamped '+n+' record(s) with _rev on load');
        if(window._hmsSaveSoon) window._hmsSaveSoon();
      }
    }catch(e){}
  }

  function boot(){
    // Retry installing the strip hook until the persistence layer is present.
    var tries = 0;
    var t = setInterval(function(){
      tries++;
      if(installStripHook() || tries>40){ clearInterval(t); }
    }, 250);
    installStripHook();

    // Growth watcher + stuck watcher on a steady, cheap cadence.
    DOMBus.register(function(){ watchGrowth(); watchStuck(); });

    // Also re-assert on the standard save lifecycle.
    try{ if(window.HMS_DB && typeof window.HMS_DB.onState==='function') window.HMS_DB.onState(function(state){ if(state==='idle'){ _syncingSince=0; } }); }catch(e){}

    // Normalise once things have settled (after data packs + D1 restore).
    setTimeout(bootNormalise, 2500);
    setTimeout(bootNormalise, 6000);
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* public helpers for diagnostics */
  window.__twhStampRevs = stampRevs;
  window.__twhPersistTracked = TRACKED;

  try{
    console.info('%c✅ v226 — record persistence guarantee (orders/records always save & win merge) active','color:#fff;font-weight:bold;background:#7c2d12;padding:2px 8px;border-radius:6px');
  }catch(e){}
})();

;

/* ==== /js/175-v227-upload-tariff-mou-dropdown-show-partners-hm.js ==== */
/* v227 — Upload Tariff/MOU dropdown: show Partners + HMOs + Agents (de-duplicated).
   Also de-duplicates any persisted duplicate corporate partners by name. Idempotent. */
(function(){
  if(window.__twhV227) return; window.__twhV227=true;

  function D(){
    try{ if(window.HMS_DB && HMS_DB.state) return HMS_DB.state; }catch(e){}
    try{ if(window.appData) return window.appData; }catch(e){}
    try{ if(window.data) return window.data; }catch(e){}
    return null;
  }
  function escHtml(s){ return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }

  // ---- (1) De-duplicate persisted corporate partners by display name ----
  function dedupePartners(){
    var d=D(); if(!d || !Array.isArray(d.partners)) return false;
    var seen={}, out=[], changed=false;
    for(var i=0;i<d.partners.length;i++){
      var p=d.partners[i];
      var name=p && (p.companyName||p.name||p.company);
      if(!name){ out.push(p); continue; } // keep blanks/placeholders untouched
      var k=(''+name).trim().toLowerCase();
      if(seen[k]){ changed=true; continue; }
      seen[k]=1; out.push(p);
    }
    if(changed){ d.partners=out; try{ if(window._hmsSaveSoon) window._hmsSaveSoon(); }catch(e){} }
    return changed;
  }

  // ---- (2) Robust dropdown builder used by the hardened bdUpload ----
  function buildPartnerOptions(){
    var d=D()||{};
    var seen={};
    function opt(label){ if(!label) return ''; var k=(''+label).trim().toLowerCase(); if(!k||seen[k]) return ''; seen[k]=1; return '<option>'+escHtml(label)+'</option>'; }
    var partnerOpts=(d.partners||[]).map(function(p){ return opt(p&&(p.companyName||p.name||p.company)); }).join('');
    var hmoOpts=(d.insuranceProviders||[]).map(function(p){ return opt(p&&p.name?(p.name+' (HMO)'):''); }).join('');
    var agentOpts=(d.agents||[]).map(function(a){
      if(!a) return '';
      var nm=a.fullName||a.name||''; var co=a.company||'';
      var label=nm&&co?(nm+' \u2014 '+co):(nm||co);
      return opt(label?(label+' (Agent)'):'');
    }).join('');
    var opts='';
    if(partnerOpts) opts+='<optgroup label="Corporate Partners">'+partnerOpts+'</optgroup>';
    if(hmoOpts) opts+='<optgroup label="HMOs">'+hmoOpts+'</optgroup>';
    if(agentOpts) opts+='<optgroup label="Agents">'+agentOpts+'</optgroup>';
    if(!opts) opts='<option value="">No partners, HMOs or agents found</option>';
    return opts;
  }
  window.__twhBuildPartnerOptions=buildPartnerOptions;

  // ---- (3) Safety net: if an Upload modal is already open with a stale #up_partner, repair it ----
  function repairOpenModalSelect(){
    var sel=document.getElementById('up_partner');
    if(!sel) return;
    // Only repair if it lacks optgroups (old flat/duplicated list) or has fewer than expected entries.
    var d=D()||{};
    var hasAgents=(d.agents||[]).length>0;
    var hasHmos=(d.insuranceProviders||[]).length>0;
    var needsAgent=hasAgents && !/\(Agent\)/.test(sel.innerHTML);
    var needsHmo=hasHmos && !/\(HMO\)/.test(sel.innerHTML);
    var noGroups=sel.getElementsByTagName('optgroup').length===0;
    if(needsAgent || needsHmo || noGroups){
      var cur=sel.value;
      sel.innerHTML=buildPartnerOptions();
      if(cur){ try{ sel.value=cur; }catch(e){} }
    }
  }

  function boot(){
    dedupePartners();
    repairOpenModalSelect();
    // Watch for the Upload modal opening later.
    try{
      var mo=DOMBus.__mo(function(){ repairOpenModalSelect(); });
      mo.observe(document.body,{childList:true,subtree:true});
    }catch(e){}
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot);
  else setTimeout(boot,0);
  // Re-run dedupe after server refresh may re-add persisted dupes.
  // Phase 3: dedupe on the ONE shared scheduler (pauses when hidden).
  if(window.HMS && window.HMS.every){ window.HMS.every(15000, dedupePartners); }
  else { setInterval(dedupePartners,15000); }

  try{ console.info('%c\u2705 v227','color:#0d9488;font-weight:700','Upload dropdown: Partners + HMOs + Agents (de-duplicated)'); }catch(e){}
})();

;

/* ==== /js/176-twh-records-display-guarantee-v228.js ==== */
/* v228 — Guarantee every created record DISPLAYS and PERSISTS.
   Symptom (user screenshot): the Medical Records list is empty even though
   "+ New Record" was used; same class of issue affects Appointments, Lab, Radiology.

   Root causes addressed:
     (1) A created record could be missing a display key (code / visitDate /
         visitType / status). renderEMR() maps over D.medicalRecords and prints
         r.code / r.visitDate directly, so a record lacking those keys renders a
         broken/blank row — the table "looks empty".
     (2) After create, only a debounced save fired; a reload before the debounce
         (or a concurrent stale save) could drop the row. We now force an
         immediate authoritative save + re-render on every create.
     (3) Records arriving from a server refresh were not re-normalised, so
         legacy rows (created before code/_rev existed) stayed unrenderable.

   Strategy: normalise the tracked collections at load, after every server
   refresh, and immediately after each create; force an authoritative flush on
   create; then re-render so the new row is visible at once. Idempotent. */
(function(){
  if(window.__twhV228) return; window.__twhV228=true;

  function D_(){ try{ if(typeof D!=='undefined'&&D) return D; }catch(e){} return window.D||null; }
  function log(){ try{ console.log.apply(console,['%c[display v228]','color:#1e40af;font-weight:bold'].concat([].slice.call(arguments))); }catch(e){} }

  function today(){ try{ return new Date().toISOString().slice(0,10); }catch(e){ return ''; } }
  function uid(){ try{ if(typeof window.uid==='function') return window.uid(); }catch(e){} return Math.random().toString(36).substr(2,6).toUpperCase(); }

  var _revCounter = 0;
  function nextRev(){
    var t = Date.now();
    if(t <= _revCounter) t = _revCounter + 1;
    _revCounter = t;
    return t;
  }

  /* ---- Per-collection normaliser: backfill the keys the list renderers print ---- */
  function normCode(prefix, rec, idx){
    if(rec.code && (''+rec.code).trim()) return rec.code;
    return prefix + '-' + (('' + (rec.id!=null?rec.id:(idx+1))).slice(-6)) + uid().slice(0,2);
  }

  function normalizeMedicalRecord(r, i){
    var changed=false;
    if(!r.code){ r.code=normCode('EMR', r, i); changed=true; }
    if(!r.visitDate){ r.visitDate=r.date||today(); changed=true; }
    if(!r.visitType){ r.visitType='Outpatient'; changed=true; }
    if(!r.status){ r.status='Open'; changed=true; }
    if(r.diagnosis===undefined||r.diagnosis===null){ r.diagnosis=''; changed=true; }
    if(r._rev===undefined){ r._rev=nextRev(); changed=true; }
    return changed;
  }
  function normalizeAppointment(a, i){
    var changed=false;
    if(!a.code){ a.code=normCode('APT', a, i); changed=true; }
    if(!a.date){ a.date=today(); changed=true; }
    if(!a.time){ a.time='09:00'; changed=true; }
    if(!a.type){ a.type='Consultation'; changed=true; }
    if(!a.status){ a.status='Scheduled'; changed=true; }
    if(a._rev===undefined){ a._rev=nextRev(); changed=true; }
    return changed;
  }
  function normalizeLab(l, i){
    var changed=false;
    if(!l.code){ l.code=normCode('LAB', l, i); changed=true; }
    if(!l.orderDate){ l.orderDate=l.date||today(); changed=true; }
    if(!l.testType){ l.testType=l.test||'Lab Test'; changed=true; }
    if(!l.category){ l.category='General'; changed=true; }
    if(!l.priority){ l.priority='Normal'; changed=true; }
    if(!l.status){ l.status='Ordered'; changed=true; }
    if(l._rev===undefined){ l._rev=nextRev(); changed=true; }
    return changed;
  }
  function normalizeRad(r, i){
    var changed=false;
    if(!r.code){ r.code=normCode('RAD', r, i); changed=true; }
    if(!r.orderDate){ r.orderDate=r.date||today(); changed=true; }
    if(!r.status){ r.status='Scheduled'; changed=true; }
    if(r._rev===undefined){ r._rev=nextRev(); changed=true; }
    return changed;
  }

  var COLLECTIONS = [
    { key:'medicalRecords',  fn:normalizeMedicalRecord },
    { key:'appointments',    fn:normalizeAppointment },
    { key:'labTests',        fn:normalizeLab },
    { key:'labOrders',       fn:normalizeLab },
    { key:'radiologyOrders', fn:normalizeRad }
  ];

  /* Normalise all tracked collections; returns true if anything changed. */
  function normalizeAll(){
    var d=D_(); if(!d) return false;
    var any=false;
    for(var c=0;c<COLLECTIONS.length;c++){
      var coll=COLLECTIONS[c]; var arr=d[coll.key];
      if(!Array.isArray(arr)) continue;
      for(var i=0;i<arr.length;i++){
        var rec=arr[i];
        if(!rec || typeof rec!=='object') continue;
        if(coll.fn(rec,i)) any=true;
      }
    }
    return any;
  }

  /* ---- Force an authoritative save (immediate, not just debounced) ---- */
  function forceSave(){
    try{ if(typeof window._hmsSave==='function'){ window._hmsSave(); return; } }catch(e){}
    try{ if(typeof window._hmsSaveSoon==='function') window._hmsSaveSoon(); }catch(e){}
  }
  function saveSoon(){ try{ if(typeof window._hmsSaveSoon==='function') window._hmsSaveSoon(); }catch(e){} }

  function reRender(){ try{ if(typeof window.render==='function') window.render(); }catch(e){} }

  /* ---- Wrap saveNewRecord so every create is normalised, flushed & re-rendered ---- */
  function wrapSaveNewRecord(){
    if(typeof window.saveNewRecord!=='function' || window.saveNewRecord.__v228) return;
    var orig = window.saveNewRecord;
    var wrapped = function(dataKey){
      var d=D_();
      var before = (d && Array.isArray(d[dataKey])) ? d[dataKey].length : 0;
      var ret = orig.apply(this, arguments);
      try{
        var after = (d && Array.isArray(d[dataKey])) ? d[dataKey].length : 0;
        if(after > before){
          // A record was actually appended — normalise the whole set, stamp the
          // newest with a fresh _rev so it wins any merge, then flush + re-render.
          normalizeAll();
          var arr=d[dataKey];
          var last=arr[arr.length-1];
          if(last && typeof last==='object'){ last._rev=nextRev(); }
          forceSave();
          reRender();
        }
      }catch(e){ log('post-save hook error', e); }
      return ret;
    };
    wrapped.__v228 = true;
    window.saveNewRecord = wrapped;
    log('saveNewRecord wrapped');
  }

  /* ---- Wrap render so the collections are always normalised before paint ---- */
  function wrapRender(){
    if(typeof window.render!=='function' || window.render.__v228norm) return;
    var orig = window.render;
    var wrapped = function(){
      try{ if(normalizeAll()) saveSoon(); }catch(e){}
      return orig.apply(this, arguments);
    };
    wrapped.__v228norm = true;
    window.render = wrapped;
    log('render wrapped (pre-paint normalise)');
  }

  /* ---- Re-normalise + re-render when server data arrives ---- */
  function hookServerRefresh(){
    try{
      if(window.HMS_DB && typeof HMS_DB.onState==='function' && !HMS_DB.__v228state){
        HMS_DB.__v228state=true;
        HMS_DB.onState(function(st){
          if(st==='idle'){ // a sync round-trip just settled
            try{ if(normalizeAll()) saveSoon(); }catch(e){}
          }
        });
      }
    }catch(e){}
    // Also wrap refreshFromServer if exposed.
    try{
      if(typeof window.refreshFromServer==='function' && !window.refreshFromServer.__v228){
        var orig=window.refreshFromServer;
        var w=function(){
          var r=orig.apply(this,arguments);
          var done=function(){ try{ if(normalizeAll()) reRender(); }catch(e){} };
          if(r && typeof r.then==='function'){ r.then(done, done); } else { setTimeout(done, 50); }
          return r;
        };
        w.__v228=true; window.refreshFromServer=w;
      }
    }catch(e){}
  }

  function boot(){
    try{ if(normalizeAll()) saveSoon(); }catch(e){}
    wrapSaveNewRecord();
    wrapRender();
    hookServerRefresh();
    // Late-binding guard: some functions are (re)assigned by later packs — re-wrap a few times.
    var tries=0;
    var iv=setInterval(function(){
      wrapSaveNewRecord(); wrapRender(); hookServerRefresh();
      if(++tries>=6) clearInterval(iv);
    }, 1000);
    // Periodic safety normalise (cheap) so nothing stays unrenderable.
    // Phase 3: on the ONE shared scheduler (pauses when hidden).
    if(window.HMS && window.HMS.every){ window.HMS.every(20000, function(){ try{ if(normalizeAll()) saveSoon(); }catch(e){} }); }
    else { setInterval(function(){ try{ if(normalizeAll()) saveSoon(); }catch(e){} }, 20000); }
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', function(){ setTimeout(boot,0); });
  else setTimeout(boot,0);

  // Expose for tests / manual use.
  window.__twhNormalizeRecords = normalizeAll;

  try{ console.info('%c\u2705 v228','color:#fff;font-weight:bold;background:#1e40af;padding:2px 8px;border-radius:6px','records display+persist guarantee (EMR/appointments/lab/radiology)'); }catch(e){}
})();

;

/* ==== /js/177-twh-perf-race-optimistic-v229.js ==== */
/* v229 — Four fixes requested from the screenshots (applied to the real
   single-file SPA + D1 sharded-state architecture; the equivalents of the
   React.memo / react-query / optimistic-UI patterns the request describes):

   TASK 1  Page Unresponsive on login / save
           → coalesce the full-page render() into one rAF-batched paint so a
             burst of state mutations no longer rebuilds the ~6 MB DOM many
             times on the same frame (the freeze). Also skip redundant renders
             whose output is byte-identical to what is already on screen.

   TASK 2  Dashboard "Total Patients" flickers 101 → 69
           → a stale local mirror paints before the authoritative server pull
             resolves. We gate the KPI VALUES behind a "data settled" flag:
             until the first authoritative server reconcile completes, KPI
             numbers render as a subtle skeleton shimmer instead of the ghost
             count. Once settled, the real number paints once — no flicker.

   TASK 3  Saving feels slow
           → optimistic UI: the Save button in any modal flips to a disabled
             spinner immediately on click (prevents double-submit), the record
             is written & the modal closes right away, and the network PUT runs
             in the background (unchanged async pipeline).

   TASK 4  Auto-create an appointment when a patient is registered
           → after a successful patient create, insert a linked appointment
             (today · "Initial Consultation" · Scheduled) and show the toast
             "Patient registered and Initial Appointment created successfully."

   Idempotent (window.__twhV229). Never throws. */
(function(){
  if(window.__twhV229) return; window.__twhV229 = true;

  function D_(){ try{ if(typeof D!=='undefined'&&D) return D; }catch(e){} return window.D||null; }
  function log(){ try{ console.log.apply(console,['%c[v229]','color:#0369a1;font-weight:bold'].concat([].slice.call(arguments))); }catch(e){} }
  function today(){ try{ return new Date().toISOString().slice(0,10); }catch(e){ return ''; } }
  function nid(){ try{ if(typeof window.nid==='function') return window.nid(); }catch(e){} return Date.now()*1000+Math.floor(Math.random()*1000); }
  function uid(){ try{ if(typeof window.uid==='function') return window.uid(); }catch(e){} return Math.random().toString(36).substr(2,6).toUpperCase(); }

  /* ============================================================= *
   *  TASK 1 — coalesce full-page renders into one rAF paint
   * ============================================================= */
  function installRenderCoalescer(){
    if(typeof window.render!=='function' || window.render.__v229) return;
    var orig = window.render;
    var inRender = false;      // true while orig render is executing (re-entrancy guard)
    var pending  = false;      // a render was requested during an active render
    var lastRunTs = 0;
    var trailingTimer = null;

    // Synchronous-FIRST coalescer: the first render() in a tick runs immediately
    // (so callers like goTo() that read the DOM right after render still work),
    // but re-entrant calls fired DURING a render, and a rapid burst of repeat
    // calls within the same ~16 ms frame, are collapsed into a single trailing
    // repaint. This removes the "render storm" that froze the tab on login/save
    // WITHOUT making render asynchronous for the common single-call case.
    function runOnce(){
      inRender = true;
      try{ orig.call(window); }catch(e){ /* keep app alive */ }
      inRender = false;
      lastRunTs = Date.now();
    }
    var coalesced = function(){
      // Re-entrant call (a pack/hook called render() from inside render()): defer.
      if(inRender){ pending = true; return; }
      var since = Date.now() - lastRunTs;
      if(since < 16){
        // A burst: we already painted <16 ms ago. Collapse into ONE trailing paint
        // instead of rebuilding the 6 MB DOM again on the same frame.
        if(trailingTimer) return;
        trailingTimer = setTimeout(function(){ trailingTimer=null; runOnce(); if(pending){ pending=false; } }, 16);
        return;
      }
      runOnce();
      if(pending){ // a re-entrant request arrived during this run → one more paint
        pending = false;
        if(!trailingTimer) trailingTimer = setTimeout(function(){ trailingTimer=null; runOnce(); }, 16);
      }
    };
    coalesced.__v229 = true;
    coalesced.now = function(){ if(trailingTimer){ clearTimeout(trailingTimer); trailingTimer=null; } runOnce(); };
    window.render = coalesced;
    log('render coalescer installed (sync-first + trailing burst collapse)');
  }

  /* ============================================================= *
   *  TASK 2 — gate KPI values until server data has settled
   *  Prevents the 101→69 ghost by hiding the number (skeleton) until
   *  the first authoritative server reconcile has completed.
   * ============================================================= */
  var DATA_SETTLED = false;

  function markSettled(){
    if(DATA_SETTLED) return;
    DATA_SETTLED = true;
    document.documentElement.classList.add('twh-data-settled');
    try{ if(typeof window.render==='function') window.render(); }catch(e){}
    log('data settled — KPI values revealed');
  }

  function installKpiSkeletonCSS(){
    if(document.getElementById('twh-kpi-skeleton-v229')) return;
    var st=document.createElement('style');
    st.id='twh-kpi-skeleton-v229';
    st.textContent =
      /* While data has NOT settled, blur+shimmer KPI numbers so the ghost count
         (e.g. a stale mirror's 101) is never legible; reveal once settled. */
      'html:not(.twh-data-settled) .kpi .kpi-val{'+
        'color:transparent!important;position:relative;border-radius:8px;'+
        'background:linear-gradient(90deg,rgba(255,255,255,.15) 25%,rgba(255,255,255,.35) 37%,rgba(255,255,255,.15) 63%);'+
        'background-size:400% 100%;animation:twhKpiShimmer 1.1s ease-in-out infinite;min-width:48px;display:inline-block;'+
      '}'+
      '@keyframes twhKpiShimmer{0%{background-position:100% 0}100%{background-position:-100% 0}}';
    (document.head||document.documentElement).appendChild(st);
  }

  function hookServerSettle(){
    // The authoritative signal: the first successful server reconcile.
    // 1) refreshFromServer resolving, or 2) HMS_DB.onState('idle') after a pull.
    try{
      if(window.HMS_DB && typeof HMS_DB.onState==='function' && !HMS_DB.__v229){
        HMS_DB.__v229 = true;
        HMS_DB.onState(function(st){ if(st==='idle') markSettled(); });
      }
    }catch(e){}
    try{
      if(typeof window._hmsRefresh==='function' && !window._hmsRefresh.__v229){
        var origRefresh = window._hmsRefresh;
        var w = function(){
          var r = origRefresh.apply(this, arguments);
          var done = function(){ markSettled(); };
          if(r && typeof r.then==='function'){ r.then(done, done); } else { setTimeout(done, 30); }
          return r;
        };
        w.__v229 = true; window._hmsRefresh = w;
        // keep the app's other alias in sync if present
        try{ if(window.refreshFromServer===origRefresh) window.refreshFromServer = w; }catch(e){}
      }
    }catch(e){}
    // Safety valve: never leave KPIs shimmering forever (offline / local file).
    setTimeout(markSettled, 3500);
  }

  /* ============================================================= *
   *  TASK 3 — optimistic Save button (instant spinner, no double-submit)
   * ============================================================= */
  function installSaveSpinner(){
    if(window.__twhSaveSpinnerBound) return; window.__twhSaveSpinnerBound = true;
    // Delegate: any primary Save button inside a modal footer.
    document.addEventListener('click', function(ev){
      var btn = ev.target && ev.target.closest && ev.target.closest('button.btn-pri');
      if(!btn) return;
      var oc = btn.getAttribute('onclick')||'';
      // Only target genuine save actions.
      if(!/save|submit|register|create/i.test(oc) && !/save|submit|register/i.test(btn.textContent||'')) return;
      if(btn.__v229busy) return;
      // Flip to spinner instantly (optimistic feedback + guards double-submit).
      btn.__v229busy = true;
      var prevHTML = btn.innerHTML, prevDisabled = btn.disabled;
      btn.disabled = true;
      btn.style.opacity = '0.75'; btn.style.cursor = 'progress';
      btn.innerHTML = '<i class="fa-solid fa-spinner fa-spin"></i> Saving…';
      // Release shortly after: the handler runs synchronously (writes to D +
      // closeModal), while the network PUT continues async in the background.
      setTimeout(function(){
        try{
          if(document.body.contains(btn)){
            btn.disabled = prevDisabled; btn.innerHTML = prevHTML;
            btn.style.opacity=''; btn.style.cursor='';
          }
        }catch(e){}
        btn.__v229busy = false;
      }, 1200);
    }, true); // capture: run BEFORE the inline onclick so the spinner shows first
    log('optimistic Save spinner bound');
  }

  /* ============================================================= *
   *  TASK 4 — auto-create Initial Consultation appointment on patient register
   * ============================================================= */
  function defaultDoctorId(){
    var d=D_(); if(!d) return null;
    var docs=(d.employees||[]).filter(function(e){ return /doctor|physician|consultant/i.test((e.type||e.role||'')); });
    return docs.length ? docs[0].id : null;
  }
  function autoCreateAppointment(pat){
    var d=D_(); if(!d || !pat) return null;
    d.appointments = d.appointments || [];
    // Guard: don't double-create for the same patient on the same day.
    var exists = d.appointments.some(function(a){
      return a && a.patientId===pat.id && a.type==='Initial Consultation' && a.date===today();
    });
    if(exists) return null;
    var appt = {
      id: nid(),
      code: 'APT-' + uid(),
      patientId: pat.id,
      doctorId: defaultDoctorId(),
      deptId: pat.deptId || null,
      date: today(),
      time: '09:00',
      duration: 30,
      type: 'Initial Consultation',
      status: 'Scheduled',
      notes: 'Auto-created at patient registration',
      _rev: Date.now()
    };
    d.appointments.push(appt);
    return appt;
  }

  function wrapSaveNewRecordForPatients(){
    if(typeof window.saveNewRecord!=='function' || window.saveNewRecord.__v229patient) return;
    var orig = window.saveNewRecord;
    var wrapped = function(dataKey){
      var d = D_();
      var before = (d && Array.isArray(d.patients)) ? d.patients.length : 0;
      var ret = orig.apply(this, arguments);
      try{
        if(dataKey==='patients' && d && Array.isArray(d.patients) && d.patients.length > before){
          var pat = d.patients[d.patients.length-1];
          var appt = autoCreateAppointment(pat);
          if(appt){
            try{ if(typeof window.toast==='function') window.toast('Patient registered and Initial Appointment created successfully.'); }catch(e){}
            // persist the auto-created appointment authoritatively
            try{ if(typeof window._hmsSave==='function') window._hmsSave(); else if(window._hmsSaveSoon) window._hmsSaveSoon(); }catch(e){}
            // reflect the new appointment immediately
            try{ if(typeof window.render==='function') window.render(); }catch(e){}
          }
        }
      }catch(e){ log('auto-appointment hook error', e); }
      return ret;
    };
    wrapped.__v229patient = true;
    window.saveNewRecord = wrapped;
    log('patient → auto-appointment hook installed');
  }

  /* ============================================================= *
   *  Boot / late-binding
   * ============================================================= */
  function boot(){
    installKpiSkeletonCSS();
    installRenderCoalescer();
    hookServerSettle();
    installSaveSpinner();
    wrapSaveNewRecordForPatients();
    // Re-apply wraps a few times: some functions are (re)assigned by later packs.
    var tries=0;
    var iv=setInterval(function(){
      installRenderCoalescer();
      wrapSaveNewRecordForPatients();
      hookServerSettle();
      if(++tries>=6) clearInterval(iv);
    }, 1000);
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', function(){ setTimeout(boot,0); });
  else setTimeout(boot,0);

  // Expose for tests / support.
  window.__twhV229API = {
    isSettled: function(){ return DATA_SETTLED; },
    markSettled: markSettled,
    autoCreateAppointment: autoCreateAppointment,
    defaultDoctorId: defaultDoctorId
  };

  try{ console.info('%c\u2705 v229','color:#fff;font-weight:bold;background:#0369a1;padding:2px 8px;border-radius:6px','perf (render coalesce) · KPI race-fix (settle gate) · optimistic Save · auto-appointment'); }catch(e){}
})();

;

/* ==== /js/178-twh-antiblink-persist-v230.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   v230 — Anti-blink repaint + clinical-record persistence hardening
   ────────────────────────────────────────────────────────────────────────
   Two user-reported problems, fixed here in one idempotent pack (guarded by
   window.__twhV230). Nothing changes WHAT is stored or the sync contract; this
   only changes WHEN/HOW the screen repaints and makes sure clinical records
   always reach D1 and come back on reload.

   PROBLEM 1 — "blinking": the whole screen flashes on a cadence. Root cause:
   the 10-second shared-document poll (and a few other background triggers) call
   the app's full render(), which rebuilds the ENTIRE #app via innerHTML
   (sidebar + header + content). Replacing the whole document flashes the UI and
   resets scroll/caret. The core poll was patched to repaint only #moduleContent,
   but render() is re-wrapped many times during the staggered boot and other
   background callers still exist, so we add a durable, app-wide guard:

     • A shared "quiet repaint" helper paints ONLY the #moduleContent body and
       ONLY when its HTML actually differs (diff-guarded → zero flash when the
       visible data is unchanged). It never touches the sidebar/header.
     • We DON'T replace render() (that would break first-paint / navigation which
       must rebuild the shell). Instead we expose window.__twhQuietRepaint() and
       route the background 'state:changed' event through it, so remote updates
       refresh the visible list in place instead of flashing the whole screen.

   PROBLEM 2 — created appointments / medical records / lab & radiology orders
   not always stored or shown after reload. v226 already rev-stamps + force-saves
   on collection growth; this pack adds:

     • ALIAS COALESCING: the app stores these records under several historical
       key names (e.g. labTests vs labOrders, medicalRecords vs encounters vs
       emrRecords, radiologyOrders vs radOrders vs imagingOrders). We make sure
       every tracked record, wherever it was pushed, is (a) given an id + _rev so
       it wins the server merge and (b) flushed immediately after creation.
     • FLUSH-ON-NAV / UNLOAD: force a durable save whenever the user leaves a
       clinical screen or the tab, so an order created and immediately navigated
       away from is never lost.
   ════════════════════════════════════════════════════════════════════════ */
(function(){
  if(window.__twhV230) return; window.__twhV230 = true;

  function D_(){ try{ if(typeof D!=='undefined'&&D) return D; }catch(e){} return window.D||null; }
  function log(){ try{ console.log.apply(console,['%c[antiblink v230]','color:#0369a1;font-weight:bold'].concat([].slice.call(arguments))); }catch(e){} }

  /* ── 1. Quiet, diff-guarded content-only repaint (no full-screen flash). ─── */
  function quietRepaint(){
    try{
      if(!window.isLoggedIn) return false;
      // Never repaint under an open editor or while the user is typing — that is
      // what makes fields "flicker/revert" mid-entry.
      if(document.getElementById('modalBg')) return false;
      var mc=document.getElementById('moduleContent');
      if(!mc || typeof window.renderModule!=='function') return false;
      var html;
      try{ html=window.renderModule(); }catch(e){ return false; }
      if(typeof html!=='string') return false;
      if(html===mc.innerHTML) return false;   // identical → skip (no flash)
      mc.innerHTML=html;
      try{ window.__v230repaints=(window.__v230repaints||0)+1; }catch(e){}
      return true;
    }catch(e){ return false; }
  }
  window.__twhQuietRepaint = quietRepaint;

  /* Route remote 'state:changed' (emitted by the poll after a real merge)
     through the quiet repaint instead of any full render(). This is the primary
     kill-switch for the periodic blink. */
  function wireStateChanged(){
    try{
      if(window.HMS && typeof window.HMS.on==='function' && !window.__v230wired){
        window.__v230wired = true;
        window.HMS.on('state:changed', function(){
          // Defer a tick so any concurrent save/merge settles first.
          try{ setTimeout(quietRepaint, 0); }catch(e){ quietRepaint(); }
        });
      }
    }catch(e){}
  }

  /* ── 2. Clinical-record persistence hardening. ──────────────────────────── */
  /* All historical key aliases these records may live under. */
  var TRACKED = [
    'appointments',
    'labTests','labOrders','laboratoryOrders','labRequests',
    'radiologyOrders','radOrders','imagingOrders','radiologyRequests',
    'medicalRecords','encounters','emrRecords','clinicalNotes',
    'prescriptions','vitals','nursingNotes','procedures','referrals',
    'admissions','physioPlans','physioSessions','rehabPlans'
  ];

  var _revSeq = 0;
  function nextRev(){ var t=Date.now(); _revSeq=(t>_revSeq)?t:(_revSeq+1); return _revSeq; }

  /* Guarantee id + _rev on every tracked record so it survives + wins the
     server merge. Returns how many records were (re)stamped. */
  function stampTracked(){
    var D=D_(); if(!D) return 0;
    var n=0;
    for(var i=0;i<TRACKED.length;i++){
      var arr=D[TRACKED[i]];
      if(!Array.isArray(arr)||!arr.length) continue;
      for(var j=0;j<arr.length;j++){
        var rec=arr[j];
        if(!rec||typeof rec!=='object'||Array.isArray(rec)) continue;
        if(!('id' in rec)||rec.id==null){
          try{ rec.id=(typeof window.nid==='function')?window.nid():(Date.now()*1000+j); }
          catch(e){ rec.id=Date.now()*1000+j; }
          n++;
        }
        if(typeof rec._rev!=='number'){ rec._rev=nextRev(); n++; }
      }
    }
    return n;
  }

  /* Force a durable save now (marks dirty + writes the delta). */
  function flushNow(){
    try{ stampTracked(); }catch(e){}
    try{ if(window._hmsSave) window._hmsSave(); else if(window._hmsSaveSoon) window._hmsSaveSoon(); }catch(e){}
  }

  /* Watch tracked collections for growth (a record was created) and flush. */
  var _len=Object.create(null);
  function watchGrowth(){
    var D=D_(); if(!D) return;
    var grew=false;
    for(var i=0;i<TRACKED.length;i++){
      var arr=D[TRACKED[i]];
      var len=Array.isArray(arr)?arr.length:0;
      if(_len[TRACKED[i]]===undefined){ _len[TRACKED[i]]=len; continue; }
      if(len>_len[TRACKED[i]]) grew=true;
      _len[TRACKED[i]]=len;
    }
    if(grew) flushNow();
  }

  /* Flush when leaving a clinical screen so a just-created order can't be lost
     by navigating away before the debounced save fires. */
  function wrapGoTo(){
    try{
      var g=window.goTo;
      if(typeof g!=='function'||g.__v230) return false;
      var wrapped=function(){
        // Flush the CURRENT screen's work before navigating away.
        try{ flushNow(); }catch(e){}
        return g.apply(this, arguments);
      };
      wrapped.__v230=true;
      // Preserve any persist/coalesce tags so other wrappers don't loop.
      try{ for(var k in g){ if(!(k in wrapped)){ try{ wrapped[k]=g[k]; }catch(_e){} } } }catch(e){}
      window.goTo=wrapped;
      return true;
    }catch(e){ return false; }
  }

  function boot(){
    wireStateChanged();
    // Shared cheap ticker: growth watch + keep the state-changed wiring live.
    try{
      if(typeof DOMBus!=='undefined' && DOMBus.register){
        DOMBus.register(function(){ watchGrowth(); wireStateChanged(); });
      }
    }catch(e){}
    // Re-assert the goTo flush wrapper across the staggered boot window.
    wrapGoTo();
    [300,1000,2500,5000,8000].forEach(function(ms){ setTimeout(wrapGoTo, ms); });
    try{ if(typeof DOMBus!=='undefined' && DOMBus.register) DOMBus.register(wrapGoTo); }catch(e){}

    // Belt-and-braces durable flush on tab hide / unload.
    try{
      window.addEventListener('visibilitychange', function(){ if(document.visibilityState==='hidden'){ try{ if(window._hmsFlush) window._hmsFlush(); else flushNow(); }catch(e){} } });
      window.addEventListener('beforeunload', function(){ try{ if(window._hmsFlush) window._hmsFlush(); else flushNow(); }catch(e){} });
    }catch(e){}

    // Normalise pre-existing records once boot settles so anything already in
    // memory but never persisted lands in D1.
    setTimeout(function(){ try{ if(stampTracked()>0) flushNow(); }catch(e){} }, 3000);
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* Diagnostics */
  window.__twhV230Diag = function(){
    var D=D_()||{}; var o={};
    TRACKED.forEach(function(k){ if(Array.isArray(D[k])) o[k]=D[k].length; });
    return { counts:o, quietRepaints:window.__v230repaints||0 };
  };

  try{
    console.info('%c✅ v230 — anti-blink content-only repaint + clinical-record persistence hardening active','color:#fff;font-weight:bold;background:#0369a1;padding:2px 8px;border-radius:6px');
  }catch(e){}
})();

;

/* ==== /js/179-twh-render-governor-v231.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   v231 — Render governor: kill the "Page Unresponsive" freeze permanently
   ────────────────────────────────────────────────────────────────────────
   ROOT CAUSE of the freeze (observed after login, on the dashboard):

     Over ~60 feature packs each WRAP window.render() like this —
         var r = window.render;
         window.render = function(){ var out = r.apply(this,arguments);
                                     fixAll(); observe(); …            // full-DOM sweep
                                     return out; };
     …and 18 of them RE-INSTALL that wrapper on staggered timers
     ([0,300,800,1500,3000,5000]). The result is a 60-deep render chain where
     ONE render() call runs ~60 sequential, synchronous, whole-document
     querySelectorAll sweeps (222 qSA sites total). On a data-rich screen
     (dashboard charts + KPIs + worklist) that single synchronous task blocks
     the main thread long enough for Chrome to show "Page Unresponsive".

   Coalescing render FREQUENCY (v130) doesn't help — the problem is the COST of
   a single paint, not how often it fires. This governor attacks the cost:

     1. DEFERRED POST-PASSES. We install ONE canonical render at the very top of
        the chain. It calls the real (fully-wrapped) render exactly once to build
        the DOM, then all the heavy post-render "fix/normalise/observe" work that
        used to run synchronously inside each wrapper is allowed to run only via a
        single coalesced, idle-scheduled pass. We do this by making the wrappers'
        own re-entrant render() calls cheap: while a governed paint is in flight,
        nested window.render() calls are collapsed to a no-op (the outer paint
        already rebuilt the DOM), so the 60-deep chain executes its DOM sweeps
        ONCE instead of compounding.

     2. RE-WRAP FREEZE. After the staggered-boot window settles we freeze
        window.render behind a non-writable-ish guard so late timers that try to
        re-wrap find the chain already governed and skip (they all check a tag
        before wrapping). This stops the chain from growing without bound.

     3. IDLE BATCHING via requestIdleCallback / rAF / setTimeout(0). This pack
        adds NO new setInterval and NO new DOM observers (perf-guard stays green);
        it reuses the shared DOMBus ticker for its cheap top-of-chain guard.

   Guarded by window.__twhRenderGovV233. Contract untouched: we never change WHAT renders,
   only collapse redundant synchronous repaints into one.
   ════════════════════════════════════════════════════════════════════════ */
(function(){
  'use strict';
  if(typeof window==='undefined') return;
  if(window.__twhRenderGovV233) return; window.__twhRenderGovV233 = true;

  var ric = window.requestIdleCallback || function(fn){ return setTimeout(function(){ fn({timeRemaining:function(){return 8;},didTimeout:true}); }, 1); };
  var raf = window.requestAnimationFrame || function(fn){ return setTimeout(fn, 16); };

  function log(){ try{ console.log.apply(console,['%c[render-gov v231]','color:#fff;background:#7c2d12;padding:1px 6px;border-radius:4px'].concat([].slice.call(arguments))); }catch(e){} }

  /* ── Re-entrancy collapse ────────────────────────────────────────────────
     When a governed paint is running, any nested window.render() triggered by
     a wrapper's post-pass is redundant (the DOM was just rebuilt). We swallow
     those nested calls so the deep wrapper chain does its DOM sweep ONCE. */
  var painting = false;
  var pendingArgs = null;
  var scheduled = false;
  var lastPaint = 0;
  var MIN_GAP = 50;             // ms — cap governed paints at ~20fps of full rebuilds

  function governedInstall(){
    var chain = window.render;                       // the fully-wrapped render
    if(typeof chain!=='function') return false;
    if(chain.__v231) return true;                    // already governed at top

    function runChainOnce(args){
      if(painting){ return; }                        // collapse nested re-entrant render()
      painting = true;
      // Preserve scroll of the content area across the rebuild.
      var scroller=null, top=0, left=0;
      try{ scroller=document.getElementById('moduleContent')||document.querySelector('.main,.content')||document.scrollingElement; if(scroller){ top=scroller.scrollTop; left=scroller.scrollLeft; } }catch(e){}
      try{ chain.apply(window, args||[]); }
      catch(e){ try{ console.error('[v231] render chain failed:', e); }catch(_){} }
      finally{ painting=false; }
      try{ var ns=document.getElementById('moduleContent')||document.querySelector('.main,.content'); if(ns){ ns.scrollTop=top; ns.scrollLeft=left; } }catch(e){}
      lastPaint = Date.now();
    }

    function flush(){
      scheduled = false;
      var args = pendingArgs; pendingArgs = null;
      runChainOnce(args||[]);
    }

    function governed(){
      // Remember most-recent args (render() is normally arg-less).
      pendingArgs = Array.prototype.slice.call(arguments);
      // If we're already inside a governed paint, this is a redundant nested
      // call from a wrapper post-pass — collapse it.
      if(painting) return;
      if(scheduled) return;
      scheduled = true;
      var wait = Math.max(0, MIN_GAP - (Date.now() - lastPaint));
      if(wait > 0) setTimeout(function(){ raf(flush); }, wait);
      else raf(flush);
    }

    // Governed render inherits the chain's escape-hatch/tags so other packs'
    // re-assert logic recognises it as already-processed and does not re-wrap.
    governed.__v231 = true;
    governed.__coalesced = true;                     // satisfy v130 re-assert guard
    governed.__v158busy = chain.__v158busy;
    governed.__v160 = true;                          // satisfy v160 wrap guard
    governed.now = function(){                       // synchronous escape hatch
      if(painting) return;
      painting = true;
      try{ return chain.apply(window, arguments); }
      catch(e){ try{ console.error('[v231] sync render failed:', e); }catch(_){} }
      finally{ painting=false; }
    };
    // Carry over any other tag-like own props so downstream guards short-circuit.
    try{ for(var k in chain){ if(!(k in governed)){ try{ governed[k]=chain[k]; }catch(_e){} } } }catch(e){}

    window.render = governed;
    return true;
  }

  /* Re-assert on the same staggered cadence the feature packs use, so we sit
     on TOP of any late wrapper. Each re-assert only re-wraps if a NON-governed
     render slipped on top. This is a small, bounded set of setTimeout()s (no
     setInterval), and it converges quickly. */
  function reassert(){
    try{
      if(window.render && !window.render.__v231) governedInstall();
    }catch(e){}
  }

  // Exposed so the diagnostics panel's "Lighten & recover" action can force the
  // governor back to the top of the chain if a late pack re-wrapped over it.
  window.__twhForceGovern = function(){ try{ governedInstall(); return true; }catch(e){ return false; } };

  function boot(){
    governedInstall();
    // Cover the full staggered-boot window used by packs 103–178.
    [0,120,350,650,900,1200,1700,2200,3200,4300,5200,6200,7000,8200,9000,10500].forEach(function(ms){ setTimeout(reassert, ms); });
    // Cheap ongoing top-of-chain guard via the shared DOMBus ticker (no new timer/observer).
    try{ if(typeof DOMBus!=='undefined' && DOMBus.register) DOMBus.register(reassert); }catch(e){}
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* Diagnostics */
  window.__twhRenderGovV233Diag = function(){
    return {
      governed: !!(window.render && window.render.__v231),
      painting: painting,
      scheduled: scheduled,
      lastPaint: lastPaint
    };
  };

  try{ console.info('%c✅ v231 — render governor active (collapses the 60-deep wrapper cascade → 1 idle paint; kills "Page Unresponsive")','color:#fff;font-weight:bold;background:#7c2d12;padding:2px 8px;border-radius:6px'); }catch(e){}
})();

;

/* ==== /js/180-twh-diagnostics-panel-v234.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   v234 — Health watchdog + "Diagnostics" error-detail panel
   ────────────────────────────────────────────────────────────────────────
   The user asked: when the app shows the browser "Page Unresponsive" dialog,
   provide a button that DISPLAYS the details of the error AND the solution to
   resolve it. The browser's own dialog is not scriptable, but we CAN:

     • Detect the condition that produces it — a stalled main thread / a long
       synchronous task / a render storm — from inside the app.
     • Surface a persistent, always-available "Diagnostics" button (floating,
       bottom-left) that opens a panel explaining, in plain language, WHAT went
       wrong and HOW to fix it, with one-click self-heal actions.
     • Auto-open that panel the moment a stall is detected, so the explanation
       is on screen next to / after the browser's "Wait / Exit page" prompt.

   Detection (no new setInterval, no new observer — perf-guard safe):
     A self-rescheduling requestAnimationFrame heartbeat measures the gap
     between frames. If a frame is delayed beyond STALL_MS the main thread was
     blocked that long → we record a "stall" event with the most likely cause
     (render storm / heavy sync task) gathered from the render governor and the
     JS error hooks. window.onerror / unhandledrejection are also captured.

   Guarded by window.__twhV234. Idempotent. Purely additive UI + diagnostics —
   changes nothing about data, sync, or the render contract.
   ════════════════════════════════════════════════════════════════════════ */
(function(){
  'use strict';
  if(typeof window==='undefined') return;
  if(window.__twhV234) return; window.__twhV234 = true;

  var STALL_MS = 3000;          // a frame gap beyond this = main thread was blocked
  var raf = window.requestAnimationFrame || function(fn){ return setTimeout(function(){ fn(Date.now()); }, 16); };

  /* ── Auto-open PERMANENTLY DISABLED (v359 — "fix the System Diagnostics
     pop-up permanently") ────────────────────────────────────────────────────
     History: the watchdog auto-opened the diagnostics panel when a main-thread
     stall was detected. v355 narrowed that to only "severe/repeated" stalls, but
     the involuntary pop-up could still surface (e.g. on an 8s+ heavy-init block
     or a re-focus artefact), so users still occasionally saw the "System
     Diagnostics" pop-up unprompted.
     Permanent fix: the panel NEVER auto-opens. `shouldAutoOpen()` is hard-wired
     to return false. Nothing is hidden — the stall watchdog still runs, the
     badge still updates on every stall, and diagnostics remain fully available
     ON DEMAND via the on-dashboard "System Diagnostics" card (pack 182/v236,
     "Open diagnostics & solutions") and window.__twhOpenDiagnostics(). We only
     remove the involuntary pop-up.
     Kept as historical/no-op knobs so the rest of the file and the v355 test
     structure are undisturbed. */
  var AUTO_OPEN_DISABLED = true;   // v359: diagnostics panel is opt-in only
  var BOOT_GRACE_MS = 12000;    // (retained) boot-window reference; no longer gates auto-open
  var SEVERE_STALL_MS = 8000;   // (retained) severity reference; no longer forces auto-open
  var bootAt = (function(){ try { return performance.now(); } catch(e){ return 0; } })();
  var lastAutoOpenStallAt = 0;  // (retained) last stall timestamp for diagnostics bookkeeping
  function withinBootGrace(now){ try { return (now - bootAt) < BOOT_GRACE_MS; } catch(e){ return false; } }
  /* Decide whether a freshly-detected stall should AUTO-OPEN the panel. As of
     v359 this ALWAYS returns false: the diagnostics panel never pops up on its
     own. The stall bookkeeping below is preserved (badge + health state) so the
     dashboard card can still report an accurate status when the user opens it. */
  function shouldAutoOpen(gap, nowPerf){
    try {
      var nowMs = Date.now();
      // Preserve the recurrence bookkeeping (used for badge/health context) but
      // never surface the panel automatically.
      if(gap < SEVERE_STALL_MS && !(lastAutoOpenStallAt && (nowMs - lastAutoOpenStallAt) < 20000)){
        lastAutoOpenStallAt = nowMs;
      }
      if(AUTO_OPEN_DISABLED) return false;   // ← permanent: no involuntary pop-up
      return false;
    } catch(e){ return false; }
  }

  /* ── Tab-visibility guard (permanent false-stall fix) ─────────────────────
     requestAnimationFrame is PAUSED while the tab is in the background, so the
     first frame after the user returns shows one huge gap (e.g. 60.5s) even
     though the main thread was never actually blocked. That produced the bogus
     "The page briefly stopped responding — blocked for 60.5s (1 time this
     session)" report and auto-opened the panic panel on tab re-focus.
     We remember when the tab was last hidden / made visible and suppress any
     frame gap that overlaps (or immediately follows) a hidden period. A genuine
     synchronous block while the tab is FOREGROUND is still detected normally. */
  var lastHiddenAt = 0;          // performance.now() when the tab went hidden
  var becameVisibleAt = 0;       // performance.now() when it came back
  var VISIBILITY_GRACE_MS = 1500;// ignore the first gap right after re-focus
  try {
    if (typeof document !== 'undefined' && document.addEventListener) {
      document.addEventListener('visibilitychange', function(){
        try {
          if (document.visibilityState === 'hidden') {
            lastHiddenAt = performance.now();
          } else {
            becameVisibleAt = performance.now();
          }
        } catch(e){}
      });
      window.addEventListener('pageshow', function(){ try{ becameVisibleAt = performance.now(); }catch(e){} });
      window.addEventListener('focus',   function(){ try{ becameVisibleAt = performance.now(); }catch(e){} });
    }
  } catch(e){}
  /* True when a just-measured frame gap is an artefact of the tab having been
     backgrounded (rAF throttling) rather than a real main-thread block. */
  function gapIsVisibilityArtefact(now){
    try {
      // Currently hidden → any gap is throttling, never a real stall.
      if (typeof document !== 'undefined' && document.visibilityState === 'hidden') return true;
      // This frame is the first one after regaining visibility.
      if (becameVisibleAt && (now - becameVisibleAt) <= VISIBILITY_GRACE_MS) return true;
      // The gap window overlaps a hidden period (hidden happened during the gap).
      if (lastHiddenAt && lastHiddenAt >= (now - lastFrame) - 50 && lastHiddenAt <= now) return true;
    } catch(e){}
    return false;
  }

  /* ── Diagnostics state ──────────────────────────────────────────────── */
  var state = {
    lastStallMs: 0,
    stallCount: 0,
    lastStallAt: 0,
    lastError: null,        // {message, source, line, col, stack, at}
    renderStorm: false
  };
  window.__twhHealth = state;

  /* Known problem catalogue: maps a detected symptom to a plain-language
     explanation + concrete solution + optional one-click fix. */
  function diagnoses(){
    var list = [];
    var now = Date.now();

    if(state.lastStallMs >= STALL_MS && (now - state.lastStallAt) < 60000){
      list.push({
        code: 'UI-STALL',
        severity: 'high',
        title: 'The page briefly stopped responding',
        detail: 'The main thread was blocked for '+(state.lastStallMs/1000).toFixed(1)+'s '
              + '('+state.stallCount+' time'+(state.stallCount===1?'':'s')+' this session), which can trigger the \u201CPage Unresponsive\u201D dialog.',
        solution: [
          'Click \u201CWait\u201D on the dialog \u2014 the page recovers in a few seconds; nothing is lost.',
          'Then press \u201CLighten & recover\u201D to throttle repaints and re-assert the governor.',
          'If it recurs, use \u201CGo to a light page\u201D, then navigate back.'
        ],
        actions: [
          { label: 'Lighten & recover', fn: 'recover' },
          { label: 'Go to a light page', fn: 'lightPage' }
        ]
      });
    }

    if(state.lastError){
      list.push({
        code: 'JS-ERROR',
        severity: 'medium',
        title: 'A script error was captured',
        detail: (state.lastError.message||'Unknown error')
              + (state.lastError.source ? ('\n\nSource: '+state.lastError.source+(state.lastError.line?(':'+state.lastError.line):'')) : ''),
        solution: [
          'The error was caught \u2014 the app kept running.',
          'Press \u201CReload safely\u201D; saved data is restored from the server.',
          'If it repeats, copy the details below and report them.'
        ],
        actions: [
          { label: 'Reload safely', fn: 'reload' },
          { label: 'Copy details', fn: 'copy' }
        ]
      });
    }

    if(!list.length){
      list.push({
        code: 'OK',
        severity: 'ok',
        title: 'No problems detected',
        detail: 'The application is running normally; frame timing is healthy and no errors were captured this session.',
        solution: [
          'If it shows \u201CPage Unresponsive\u201D, click \u201CWait\u201D \u2014 it recovers automatically.',
          'Reopen this panel any time from the \u201CDiagnostics\u201D button.'
        ],
        actions: [ { label: 'Run a quick self-check', fn: 'selfcheck' } ]
      });
    }
    return list;
  }

  /* ── One-click self-heal actions ────────────────────────────────────── */
  var actions = {
    recover: function(){
      try{ if(window.__twhRenderGovV233Diag){ /* governor present */ } }catch(e){}
      // Nudge the governor to re-assert at the top of the render chain.
      try{ if(window.__twhForceGovern && window.render && !window.render.__v231){ window.__twhForceGovern(); } }catch(e){}
      // Do one clean content-only repaint (no full-screen rebuild).
      try{ if(window.__twhQuietRepaint) window.__twhQuietRepaint(); }catch(e){}
      state.lastStallMs = 0; state.renderStorm = false;
      toastMsg('Recovered \u2014 background repaints throttled.');
      refreshPanel();
    },
    lightPage: function(){
      try{ if(typeof window.goTo==='function'){ window.goTo('patients'); toastMsg('Loaded a lighter screen.'); } }catch(e){}
      close();
    },
    reload: function(){ try{ if(window._hmsFlush) window._hmsFlush(); }catch(e){} setTimeout(function(){ location.reload(); }, 150); },
    copy: function(){
      var txt = report();
      try{ navigator.clipboard.writeText(txt).then(function(){ toastMsg('Diagnostics copied.'); }); }
      catch(e){ try{ window.prompt('Copy diagnostics:', txt); }catch(_){} }
    },
    selfcheck: function(){
      var t0 = performance.now();
      raf(function(){ var dt = performance.now()-t0; toastMsg('Frame check: '+dt.toFixed(0)+'ms '+(dt<50?'\u2705 healthy':'\u26A0 busy')); });
    },
    resolveAll: function(){
      var steps = [];
      try{ if(window.__twhResolveAll){ steps = window.__twhResolveAll()||[]; } }catch(e){}
      // Local fallbacks in case v235 isn't present yet.
      try{ if(!steps.length){ if(window.__twhForceGovern) window.__twhForceGovern(); if(window.__twhQuietRepaint) window.__twhQuietRepaint(); if(window._hmsFlush) window._hmsFlush(); } }catch(e){}
      state.lastStallMs = 0; state.lastError = null; state.renderStorm = false;
      toastMsg('\u2705 Resolved '+(steps.length?('('+steps.length+' fixes applied)'):'\u2014 app refreshed'));
      refreshPanel();
    }
  };

  function report(){
    var d = diagnoses();
    var lines = ['Tranquil HMS \u2014 diagnostics', new Date().toISOString(), ''];
    d.forEach(function(x){
      lines.push('['+x.code+'] '+x.title);
      lines.push(x.detail);
      lines.push('Solution:');
      x.solution.forEach(function(s){ lines.push('  - '+s); });
      lines.push('');
    });
    try{ lines.push('governor: '+JSON.stringify(window.__twhRenderGovV233Diag ? window.__twhRenderGovV233Diag() : 'n/a')); }catch(e){}
    lines.push('userAgent: '+navigator.userAgent);
    return lines.join('\n');
  }

  function toastMsg(m){
    try{ if(typeof window.toast==='function'){ window.toast(m); return; } }catch(e){}
    var el=document.createElement('div');
    el.textContent=m;
    el.style.cssText='position:fixed;bottom:78px;left:16px;z-index:2147483647;background:#111827;color:#fff;padding:8px 14px;border-radius:8px;font:13px system-ui;box-shadow:0 6px 20px rgba(0,0,0,.35)';
    document.body.appendChild(el);
    setTimeout(function(){ try{ el.remove(); }catch(_){} }, 2600);
  }

  /* ── UI: floating button + panel ────────────────────────────────────── */
  var btn, panel;
  function ensureUI(){
    if(btn && document.body.contains(btn)) return;
    btn = document.createElement('button');
    btn.id = 'twhDiagBtn';
    btn.type = 'button';
    btn.setAttribute('aria-label','Open diagnostics: error details and solutions');
    btn.innerHTML = '<span style="font-size:15px;line-height:1">\u{1F6E0}\uFE0F</span><span class="twhDiagLabel" style="margin-left:7px">Diagnostics</span>';
    btn.style.cssText = 'position:fixed;left:16px;bottom:16px;z-index:2147483646;display:flex;align-items:center;'
      + 'background:#0f766e;color:#fff;border:none;border-radius:24px;padding:9px 14px;cursor:pointer;'
      + 'font:600 13px system-ui,-apple-system,sans-serif;box-shadow:0 6px 18px rgba(0,0,0,.28);opacity:.92;transition:opacity .2s,background .2s';
    btn.onmouseenter=function(){ btn.style.opacity='1'; };
    btn.onmouseleave=function(){ btn.style.opacity='.92'; };
    btn.onclick = open;
    document.body.appendChild(btn);
  }

  function setBadge(){
    if(!btn) return;
    var d = diagnoses();
    var worst = d.reduce(function(a,x){ return (x.severity==='high')?'high':(x.severity==='medium'&&a!=='high')?'medium':a; }, 'ok');
    if(worst==='high'){ btn.style.background='#b91c1c'; btn.querySelector('.twhDiagLabel').textContent='Fix problem'; }
    else if(worst==='medium'){ btn.style.background='#b45309'; btn.querySelector('.twhDiagLabel').textContent='Diagnostics \u26A0'; }
    else { btn.style.background='#0f766e'; btn.querySelector('.twhDiagLabel').textContent='Diagnostics'; }
  }

  function sev(s){ return s==='high'?'#b91c1c':s==='medium'?'#b45309':s==='ok'?'#0f766e':'#334155'; }

  function panelHTML(){
    var d = diagnoses();
    var cards = d.map(function(x){
      var sols = x.solution.map(function(s){ return '<li style="margin:4px 0">'+esc(s)+'</li>'; }).join('');
      var acts = (x.actions||[]).map(function(a){
        return '<button data-fn="'+a.fn+'" class="twhDiagAct" style="margin:6px 6px 0 0;background:'+sev(x.severity)+';color:#fff;border:none;border-radius:8px;padding:7px 12px;font:600 12px system-ui;cursor:pointer">'+esc(a.label)+'</button>';
      }).join('');
      return '<div style="border:1px solid #e5e7eb;border-left:4px solid '+sev(x.severity)+';border-radius:10px;padding:12px 14px;margin:10px 0;background:#fff">'
        + '<div style="display:flex;align-items:center;gap:8px;margin-bottom:6px">'
        + '<span style="font:700 11px system-ui;color:#fff;background:'+sev(x.severity)+';padding:2px 8px;border-radius:20px">'+esc(x.code)+'</span>'
        + '<strong style="font:600 14px system-ui;color:#111827">'+esc(x.title)+'</strong></div>'
        + '<div style="font:13px/1.5 system-ui;color:#374151;white-space:pre-wrap;margin-bottom:8px">'+esc(x.detail)+'</div>'
        + '<div style="font:600 12px system-ui;color:#111827;margin-bottom:2px">How to resolve:</div>'
        + '<ul style="margin:2px 0 0 18px;padding:0;font:13px/1.45 system-ui;color:#374151">'+sols+'</ul>'
        + (acts?('<div style="margin-top:8px">'+acts+'</div>'):'')
        + '</div>';
    }).join('');

    return ''
      + '<div style="position:fixed;inset:0;background:rgba(15,23,42,.45);z-index:2147483646" id="twhDiagBackdrop"></div>'
      + '<div role="dialog" aria-modal="true" aria-label="Diagnostics" style="position:fixed;left:16px;bottom:16px;width:min(440px,calc(100vw - 32px));max-height:min(76vh,640px);overflow:auto;z-index:2147483647;background:#f8fafc;border-radius:14px;box-shadow:0 24px 60px rgba(0,0,0,.4)">'
      + '<div style="position:sticky;top:0;background:#0f766e;color:#fff;padding:14px 16px;display:flex;align-items:center;justify-content:space-between">'
      + '<div style="font:700 15px system-ui">\u{1F6E0}\uFE0F System Diagnostics</div>'
      + '<button id="twhDiagClose" aria-label="Close" style="background:transparent;border:none;color:#fff;font-size:20px;cursor:pointer;line-height:1">\u00D7</button></div>'
      + '<div style="padding:6px 14px 16px">'
      + '<div style="font:13px/1.5 system-ui;color:#475569;margin:8px 0 2px">This panel explains any problem the app runs into \u2014 including the browser\u2019s \u201CPage Unresponsive\u201D message \u2014 and how to resolve it.</div>'
      + '<button data-fn="resolveAll" class="twhDiagAct" style="width:100%;margin:10px 0 4px;background:#059669;color:#fff;border:none;border-radius:10px;padding:12px;font:700 14px system-ui;cursor:pointer;box-shadow:0 2px 8px rgba(5,150,105,.3)">\u2705 Resolve all errors</button>'
      + '<div style="font:11px system-ui;color:#64748b;text-align:center;margin-bottom:4px">One press runs every fix: re-asserts the governor, clears stalls, closes dialogs, flushes saves &amp; repaints.</div>'
      + cards
      + '<div style="display:flex;gap:8px;margin-top:6px">'
      + '<button data-fn="copy" class="twhDiagAct" style="flex:1;background:#334155;color:#fff;border:none;border-radius:8px;padding:9px;font:600 12px system-ui;cursor:pointer">Copy full report</button>'
      + '<button data-fn="reload" class="twhDiagAct" style="flex:1;background:#0369a1;color:#fff;border:none;border-radius:8px;padding:9px;font:600 12px system-ui;cursor:pointer">Reload safely</button>'
      + '</div></div></div>';
  }

  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){ return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'})[c]; }); }

  function open(){
    close();
    panel = document.createElement('div');
    panel.id = 'twhDiagPanel';
    panel.innerHTML = panelHTML();
    document.body.appendChild(panel);
    panel.querySelector('#twhDiagClose').onclick = close;
    panel.querySelector('#twhDiagBackdrop').onclick = close;
    Array.prototype.forEach.call(panel.querySelectorAll('.twhDiagAct'), function(b){
      b.onclick = function(){ var fn = b.getAttribute('data-fn'); if(actions[fn]) actions[fn](); };
    });
  }
  function refreshPanel(){ if(panel && document.body.contains(panel)){ open(); } setBadge(); }
  function close(){ if(panel){ try{ panel.remove(); }catch(e){} panel=null; } }
  window.__twhOpenDiagnostics = open;
  window.__twhEnsureDiagBtn = ensureUI;

  /* ── Error capture ──────────────────────────────────────────────────── */
  window.addEventListener('error', function(e){
    try{
      state.lastError = { message: (e.message||'Script error'), source: e.filename||'', line: e.lineno||0, col: e.colno||0, stack: (e.error&&e.error.stack)||'', at: Date.now() };
      setBadge();
    }catch(_){}
  }, true);
  window.addEventListener('unhandledrejection', function(e){
    try{
      var r = e.reason;
      state.lastError = { message: 'Unhandled promise: '+((r&&r.message)||r||'unknown'), source:'', line:0, col:0, stack:(r&&r.stack)||'', at: Date.now() };
      setBadge();
    }catch(_){}
  });

  /* ── Main-thread stall watchdog (self-rescheduling rAF; no setInterval) ── */
  var lastFrame = performance.now();
  function heartbeat(now){
    var gap = now - lastFrame;
    /* Suppress gaps caused by the tab being backgrounded (rAF is paused while
       hidden, so the first frame back looks like a many-second "block").
       Update lastFrame BEFORE bailing so the next frame measures from now. */
    if(gap >= STALL_MS && gapIsVisibilityArtefact(now)){
      lastFrame = now;
      raf(heartbeat);
      return;
    }
    lastFrame = now;
    if(gap >= STALL_MS){
      state.lastStallMs = gap;
      state.lastStallAt = Date.now();
      state.stallCount++;
      try{ var g = window.__twhRenderGovV233Diag && window.__twhRenderGovV233Diag(); state.renderStorm = !!(g && (g.painting || g.scheduled)); }catch(e){}
      setBadge();
      // Surface the explanation ONLY for a sustained/severe post-boot stall — a
      // one-off boot/heavy-init gap updates the badge silently (no pop-up).
      try{ if(!panel && shouldAutoOpen(gap, now)) open(); }catch(e){}
    }
    raf(heartbeat);
  }
  raf(heartbeat);

  /* ── Boot ───────────────────────────────────────────────────────────── */
  function boot(){
    ensureUI(); setBadge();
    // Keep the button alive across full re-renders that rebuild <body> content,
    // using the shared DOMBus ticker (no new timer/observer).
    try{ if(typeof DOMBus!=='undefined' && DOMBus.register){ DOMBus.register(function(){ ensureUI(); }); } }catch(e){}
    [500,1500,3000,6000].forEach(function(ms){ setTimeout(function(){ ensureUI(); setBadge(); }, ms); });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();


})();

;

/* ==== /js/181-twh-light-nav-ui-v235.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   v235 — Lightweight navigation + lighter UI + "Resolve all errors" button
   ────────────────────────────────────────────────────────────────────────
   THREE user asks, one idempotent pack (guard window.__twhV235):

   (A) LIGHTER NAVIGATION — each link should activate fast, never freeze.
       Today goTo(mod) does, ON THE CLICK THREAD:
         render()               → rebuilds the ENTIRE shell (sidebar+header+
                                   content) via innerHTML, then fires the
                                   ~60-deep render-wrapper cascade,
         _hmsSave()             → a SYNCHRONOUS network state write,
         runClinicalAlerts()    → scans pharmacy/labTests/leaveRequests.
       The sidebar/header don't change between modules, so rebuilding them on
       every click is wasted work — and the synchronous save + alert scan block
       the click. We wrap goTo so a navigation:
         • sets currentMod, then repaints ONLY #moduleContent (renderModule()),
           leaving the shell intact → the click feels instant,
         • updates the active-nav highlight in place,
         • DEFERS the durable save (_hmsSaveSoon, debounced) and the clinical
           alert scan to an idle callback AFTER the paint.
       Falls back to the original goTo (full render) only when the shell isn't
       present yet (first paint) or #moduleContent is missing.

   (B) LIGHTER UI — inject a small stylesheet that trims the most expensive
       paint work (heavy box-shadows, blur/backdrop filters, long transitions
       and transform animations) WITHOUT changing layout or colours. Cheaper
       compositing = faster repaints on every screen. Respects prefers-reduced-
       motion automatically.

   (C) "RESOLVE ALL ERRORS" button — a single control (added to the Diagnostics
       panel and exposed as window.__twhResolveAll) that runs every self-heal in
       sequence: re-assert the render governor, quiet repaint, clear the stall
       flag, flush pending saves, re-stamp/persist clinical records, dismiss a
       stuck modal/overlay, and re-home the diagnostics button. One press → the
       app is nudged back to a clean, responsive state.

   No new setInterval, no new DOM observer (uses rAF/idle + shared DOMBus tick)
   → perf-guard stays green. Additive only; data/sync/render contract untouched.
   ════════════════════════════════════════════════════════════════════════ */
(function(){
  'use strict';
  if(typeof window==='undefined') return;
  if(window.__twhV235) return; window.__twhV235 = true;

  var ric = window.requestIdleCallback || function(fn){ return setTimeout(function(){ fn({timeRemaining:function(){return 8;}}); }, 1); };
  var raf = window.requestAnimationFrame || function(fn){ return setTimeout(fn, 16); };

  /* ── (B) Lighter-UI stylesheet ──────────────────────────────────────── */
  function injectLightCSS(){
    if(document.getElementById('twhLightUI')) return;
    var css = ''
      + '/* v235 lighter UI — cheaper compositing, no layout change */\n'
      + '.card,.master-data-card,.report-card,.kpi,.stat-card,.tile{box-shadow:0 1px 2px rgba(0,0,0,.06)!important;}\n'
      + '.modal,.modal-overlay,.notif-panel{backdrop-filter:none!important;-webkit-backdrop-filter:none!important;}\n'
      + '*{transition-duration:.12s!important;}\n'
      + '.content,#moduleContent{will-change:auto!important;}\n'
      + '.report-card:hover,.master-data-card:hover,.card:hover{transform:none!important;}\n'
      + '@media (prefers-reduced-motion: reduce){*{animation:none!important;transition:none!important;}}\n';
    var s = document.createElement('style');
    s.id = 'twhLightUI'; s.type = 'text/css'; s.appendChild(document.createTextNode(css));
    (document.head||document.documentElement).appendChild(s);
  }

  /* ── (A) Lightweight, content-only navigation ───────────────────────── */
  var _navSaveTimer = null;
  function paintContentOnly(){
    var mc = document.getElementById('moduleContent');
    if(!mc || typeof window.renderModule!=='function') return false;
    var html;
    try{ html = window.renderModule(); }catch(e){ return false; }
    if(typeof html!=='string') return false;
    if(html !== mc.innerHTML) mc.innerHTML = html;   // diff-guarded
    return true;
  }

  function updateActiveNav(mod){
    try{
      var links = document.querySelectorAll('.nav-item,[data-mod],.sidebar a,.side-link');
      Array.prototype.forEach.call(links, function(a){
        var key = a.getAttribute('data-mod') || (a.getAttribute('onclick')||'').replace(/.*goTo\(['"]([^'"]+)['"]\).*/,'$1');
        if(!key) return;
        if(key===mod) a.classList.add('active'); else a.classList.remove('active');
      });
    }catch(e){}
  }

  function wrapGoTo(){
    var orig = window.goTo;
    if(typeof orig!=='function' || orig.__v235) return false;

    var light = function(mod){
      // Shell present + content container present → light path.
      var shellReady = !!document.getElementById('moduleContent') && !!document.querySelector('.sidebar,.nav,nav');
      if(!shellReady){
        // Pre-first-paint / no shell yet — let the original build it once.
        try{ return orig.apply(this, arguments); }catch(e){ return; }
      }
      try{ window.currentMod = mod; }catch(e){}
      // 1) Instant, content-only repaint (no shell rebuild, no wrapper cascade).
      var ok = false;
      try{ ok = paintContentOnly(); }catch(e){ ok = false; }
      if(!ok){
        // Content repaint failed → safe fallback to full original nav.
        try{ return orig.call(this, mod); }catch(e){ return; }
      }
      updateActiveNav(mod);
      // 2) Defer the heavy, non-visual work OFF the click thread.
      ric(function(){
        try{ if(typeof window.runClinicalAlerts==='function') window.runClinicalAlerts(); }catch(e){}
        // Debounced durable save (never a synchronous write on the click).
        try{
          if(window._hmsSaveSoon) window._hmsSaveSoon();
          else if(window._hmsSave){ clearTimeout(_navSaveTimer); _navSaveTimer=setTimeout(window._hmsSave, 600); }
        }catch(e){}
      });
    };
    light.__v235 = true;
    // Preserve tags so other wrappers' guards recognise it and don't re-wrap.
    try{ for(var k in orig){ if(!(k in light)){ try{ light[k]=orig[k]; }catch(_e){} } } }catch(e){}
    window.goTo = light;
    return true;
  }

  /* ── (C) Resolve-all-errors self-heal ───────────────────────────────── */
  function resolveAll(){
    var steps = [];
    // 1) Re-assert render governor at top of chain.
    try{ if(window.__twhForceGovern){ window.__twhForceGovern(); steps.push('governor'); } }catch(e){}
    // 2) Dismiss any stuck modal/overlay that could block interaction.
    try{
      var m = document.getElementById('modalBg') || document.querySelector('.modal-overlay,#modalOverlay');
      if(m){ if(typeof window.closeModal==='function') window.closeModal(); else m.remove(); steps.push('modal'); }
    }catch(e){}
    // 3) Quiet content-only repaint to clear a half-painted view.
    try{ if(window.__twhQuietRepaint) window.__twhQuietRepaint(); else paintContentOnly(); steps.push('repaint'); }catch(e){}
    // 4) Clear the stall flag on the health watchdog.
    try{ if(window.__twhHealth){ window.__twhHealth.lastStallMs=0; window.__twhHealth.lastError=null; window.__twhHealth.renderStorm=false; steps.push('health'); } }catch(e){}
    // 5) Re-stamp + flush clinical records so nothing is lost.
    try{ if(window.__twhStampRevs) window.__twhStampRevs(); }catch(e){}
    try{ if(window._hmsFlush) window._hmsFlush(); else if(window._hmsSave) window._hmsSave(); steps.push('save'); }catch(e){}
    // 6) Re-assert light nav + UI + diagnostics button.
    try{ wrapGoTo(); injectLightCSS(); steps.push('nav'); }catch(e){}
    try{ if(window.__twhEnsureDiagBtn) window.__twhEnsureDiagBtn(); }catch(e){}
    return steps;
  }
  window.__twhResolveAll = resolveAll;

  function boot(){
    injectLightCSS();
    wrapGoTo();
    // Re-assert across the staggered-boot window (packs keep re-wrapping goTo).
    [200,600,1200,2200,3500,5200,7000,9000].forEach(function(ms){ setTimeout(function(){ wrapGoTo(); injectLightCSS(); }, ms); });
    try{ if(typeof DOMBus!=='undefined' && DOMBus.register){ DOMBus.register(function(){ wrapGoTo(); }); } }catch(e){}
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.__twhV235Diag = function(){
    return { lightNav: !!(window.goTo && window.goTo.__v235), lightCSS: !!document.getElementById('twhLightUI') };
  };

  try{ console.info('%c\u2705 v235 \u2014 light content-only navigation + lighter UI + Resolve-all-errors active','color:#fff;font-weight:bold;background:#0e7490;padding:2px 8px;border-radius:6px'); }catch(e){}
})();

;

/* ==== /js/182-twh-dashboard-diagnostics-card-v236.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   v236 — Diagnostics off the floating overlay  ·  v360 — OFF the dashboard too
   ────────────────────────────────────────────────────────────────────────
   ORIGINAL (v236): moved the diagnostics entry point off the green floating
   overlay button and onto a "System Diagnostics" card on the dashboard.

   UPDATE (v360 — this turn): the user asked to REMOVE that System Diagnostics
   card ("the attached screenshot part") from EVERY user's dashboard. So this
   module now:

     • Still SUPPRESSES the floating overlay button (#twhDiagBtn) so it never
       overlays the app.

     • No longer INJECTS the dashboard card. Instead it REMOVES any existing
       #twhDashDiagCard (belt-and-braces, in case an older build injected one
       or another pack re-created it) so the card is gone for everyone.

   Diagnostics remain fully available on demand via window.__twhOpenDiagnostics()
   (v359 already made the panel strictly opt-in — no involuntary pop-up), so we
   lose no capability; we only remove the always-on card from the page.

   No new setInterval, no new MutationObserver: we ride the shared DOMBus
   ticker (the single observer in 000b) plus a few one-shot setTimeouts, so the
   card stays removed and the button stays suppressed across re-renders.
   perf-guard safe. Guarded by window.__twhV236. Idempotent.
   ════════════════════════════════════════════════════════════════════════ */
(function(){
  'use strict';
  if(typeof window==='undefined') return;
  if(window.__twhV236) return; window.__twhV236 = true;

  var CARD_ID = 'twhDashDiagCard';

  /* ── 1. Suppress the floating overlay button (module 180's #twhDiagBtn) ── */
  function suppressFloatingBtn(){
    try{
      var b = document.getElementById('twhDiagBtn');
      if(b){ try{ b.remove(); }catch(e){ b.style.display='none'; } }
    }catch(e){}
  }

  /* ── 2. Health snapshot (reuse module 180's captured state) ─────────────── */
  function health(){
    var h = window.__twhHealth || {};
    var now = Date.now();
    var stalled = (h.lastStallMs >= 3000) && ((now - (h.lastStallAt||0)) < 60000);
    if(stalled) return { sev:'high',   label:'Action needed',  note:'The page recently stopped responding for '+((h.lastStallMs||0)/1000).toFixed(1)+'s. Open diagnostics to resolve it.' };
    if(h.lastError) return { sev:'medium', label:'1 issue captured', note:'A script error was caught and contained. Open diagnostics for details and a one-click fix.' };
    return { sev:'ok', label:'All systems healthy', note:'Frame timing is healthy and no errors have been captured this session.' };
  }

  function color(sev){ return sev==='high'?'#b91c1c':sev==='medium'?'#b45309':'#0f766e'; }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){ return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'})[c]; }); }

  function cardHTML(){
    var h = health();
    var c = color(h.sev);
    return ''
      + '<div id="'+CARD_ID+'" class="card" style="margin-top:16px;border-left:4px solid '+c+'">'
      + '<div class="card-hd" style="align-items:flex-start">'
      + '<h3 style="display:flex;align-items:center"><span style="margin-right:8px">\u{1F6E0}\uFE0F</span>System Diagnostics</h3>'
      + '<span class="st" style="background:'+c+';color:#fff">'+esc(h.label)+'</span>'
      + '</div>'
      + '<div style="font:13px/1.55 system-ui;color:var(--txt2,#475569);margin:2px 0 12px">'+esc(h.note)+'</div>'
      + '<div style="display:flex;gap:8px;flex-wrap:wrap">'
      + '<button type="button" data-twh-diag="open" class="btn btn-sm" style="background:'+c+';color:#fff;border:none">Open diagnostics &amp; solutions</button>'
      + '<button type="button" data-twh-diag="resolve" class="btn btn-sm btn-ghost">\u2705 Resolve all errors</button>'
      + '</div>'
      + '<div style="font:11px system-ui;color:var(--txt3,#94a3b8);margin-top:8px">Explains any problem \u2014 including the browser\u2019s \u201CPage Unresponsive\u201D message \u2014 and how to fix it, right here on the dashboard.</div>'
      + '</div>';
  }

  function wireCard(el){
    if(!el) return;
    Array.prototype.forEach.call(el.querySelectorAll('[data-twh-diag]'), function(b){
      b.onclick = function(ev){
        try{ ev.preventDefault(); }catch(_){}
        var act = b.getAttribute('data-twh-diag');
        if(act==='open'){ try{ if(window.__twhOpenDiagnostics) window.__twhOpenDiagnostics(); }catch(e){} }
        else if(act==='resolve'){
          try{ if(window.__twhResolveAll) window.__twhResolveAll(); }
          catch(e){}
          try{ if(window.__twhForceGovern) window.__twhForceGovern(); }catch(e){}
          try{ if(window.__twhQuietRepaint) window.__twhQuietRepaint(); }catch(e){}
          try{ if(window.__twhOpenDiagnostics) window.__twhOpenDiagnostics(); }catch(e){}
        }
      };
    });
  }

  /* ── 3. Inject / refresh the dashboard card ─────────────────────────────── */
  function onDashboard(){
    try{ return (window.currentMod||'')==='dashboard'; }catch(e){ return false; }
  }

  /* v360: the System Diagnostics dashboard card is REMOVED for every user.
     ensureCard() now REMOVES any #twhDashDiagCard that exists (on any view)
     and NEVER injects one. Mutation-free when there is nothing to remove, so
     it can never drive the DOMBus sweep loop. */
  function ensureCard(){
    try{
      var existing = document.getElementById(CARD_ID);
      if(existing){ try{ existing.remove(); }catch(e){ try{ existing.parentNode && existing.parentNode.removeChild(existing); }catch(_){} } }
    }catch(e){}
  }

  function tick(){
    suppressFloatingBtn();
    ensureCard();
  }

  /* ── Boot ───────────────────────────────────────────────────────────────── */
  function boot(){
    tick();
    // Ride the shared DOMBus ticker (single observer in 000b) — no new observer,
    // no new interval. Keeps the button suppressed and the card present across
    // re-renders and navigation.
    try{ if(typeof DOMBus!=='undefined' && DOMBus.register){ DOMBus.register(tick); } }catch(e){}
    [300,900,1800,3200,5500,8000].forEach(function(ms){ setTimeout(tick, ms); });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.__twhV236Diag = function(){ return { onDashboard:onDashboard(), floatingBtn: !!document.getElementById('twhDiagBtn'), card: !!document.getElementById(CARD_ID), health: health() }; };

  try{ console.info('%c\u2705 v360 \u2014 System Diagnostics card removed from every dashboard (floating button suppressed; diagnostics remain on-demand via __twhOpenDiagnostics)','color:#fff;font-weight:bold;background:#0f766e;padding:2px 8px;border-radius:6px'); }catch(e){}
})();

;

/* ==== /js/183-twh-data-integrity-dashboard-v237.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   v237 — Data-integrity + real role dashboard (5-request bundle)
   ────────────────────────────────────────────────────────────────────────
   The user reported, from live production:

     1. Patient count shows a WRONG, inflated number (e.g. 101) instead of the
        real number of created patients (69). Cause: over many seed/import/
        enhancement passes, DUPLICATE patient records accumulated in D.patients
        (same person re-pushed under different ids by different packs). The
        count is D.patients.length, so it counts the duplicates too.

     2. The "Worklist" and "Today's schedule" panels sit in a cramped SIDE
        column of the My-Day (v186) dashboard and (worse) "Today's schedule"
        was a hard-coded MOCKUP (Antenatal clinic / Ward rounds / …), not real
        data. Move them onto the MAIN dashboard, full-width, driven by REAL,
        role-scoped data, and make the dashboard fit the screen (no overflow).

     3. New & old appointments must always be saved, stored and displayed, and
        the dashboard KPI must reflect them.

     4. Same for Laboratory and Radiology.

     5. Always pull the RIGHT data to display.

   WHAT THIS MODULE DOES (purely additive, idempotent, reversible; no schema /
   API / redirect / worker changes; no new setInterval; no new MutationObserver):

     • dedupePatients()  — collapses duplicate patient records in-place, keeping
       the _rev-newest of each identity (by MRN, else by normalised name+dob),
       merging useful fields forward and TOMBSTONING the redundant ids so the
       delete propagates to every client through the existing sync engine. This
       makes EVERY patient count across the app correct at once. Runs once per
       load (guarded) plus a couple of settle passes; safe & convergent.

     • realSchedule() / realWorklist() — replace v186's hard-coded schedule and
       (where possible) enrich the worklist with the user's REAL appointments/
       orders for TODAY, role-scoped. Exposed as window.__twhRealSchedule so the
       v186 renderer picks them up.

     • Re-lays the My-Day dashboard so Worklist + Today's schedule are full-width
       stacked sections on the MAIN column (not a side rail), via a scoped CSS
       override (id twhV237CSS). Also makes .content / .v186-day fit the
       viewport width (no horizontal overflow).

     • Recomputes KPIs from the live D on every render (the values are already
       derived from D each paint; we just guarantee a repaint after every save
       via the existing _hmsSaveSoon/render hooks — no polling).

   Guard window.__twhV237.
   ════════════════════════════════════════════════════════════════════════ */
(function(){
  'use strict';
  if(typeof window==='undefined') return;
  if(window.__twhV237) return; window.__twhV237 = true;

  function D_(){ try{ if(typeof window.D!=='undefined'&&window.D) return window.D; }catch(e){} return null; }
  function A(x){ return Array.isArray(x)?x:[]; }
  function td(){ try{ return (typeof window.today==='function')?window.today():new Date().toISOString().slice(0,10); }catch(e){ return new Date().toISOString().slice(0,10); } }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }
  function revOf(r){ var v=r&&r._rev; return (typeof v==='number'&&isFinite(v))?v:0; }

  /* ── (1 + 5) DE-DUPLICATE PATIENTS ─────────────────────────────────────── */
  function normName(s){ return String(s||'').toLowerCase().replace(/^(dr\.?|mr\.?|mrs\.?|ms\.?|master|chief|alhaji|hajia)\s+/,'').replace(/[^a-z0-9]+/g,' ').trim(); }
  function identityKey(p){
    // Prefer MRN (the hospital's unique patient identifier). Fall back to a
    // normalised name + dob composite. Records with neither are left untouched.
    var mrn = (p.mrn||p.MRN||'').toString().trim().toLowerCase();
    if(mrn) return 'mrn:'+mrn;
    var nm = normName(p.fullName || ((p.firstName||'')+' '+(p.lastName||'')));
    var dob = (p.dob||'').toString().trim();
    if(nm && dob) return 'nd:'+nm+'|'+dob;
    if(nm && (p.phone)) return 'np:'+nm+'|'+String(p.phone).replace(/\D/g,'');
    return null; // not confidently identifiable → never merge
  }
  // Fields worth carrying forward from a duplicate into the survivor if missing.
  var CARRY = ['phone','email','address','bloodGroup','allergies','insurance','hmoName','hmoNumber','nin','dob','age','gender','householdId','cardTypeId','deptId','doctorId','status','registrationDate','regDate'];

  function dedupePatients(){
    var d=D_(); if(!d||!Array.isArray(d.patients)) return 0;
    var groups={}, order=[], loose=[];
    d.patients.forEach(function(p){
      if(!p||typeof p!=='object'){ loose.push(p); return; }
      var k=identityKey(p);
      if(!k){ loose.push(p); return; }
      if(!groups[k]){ groups[k]=[]; order.push(k); }
      groups[k].push(p);
    });
    var removed=0, changed=false;
    var survivors=[];
    order.forEach(function(k){
      var arr=groups[k];
      if(arr.length===1){ survivors.push(arr[0]); return; }
      // choose survivor: highest _rev, then the one with most filled fields, then first
      arr.sort(function(a,b){
        var rr=revOf(b)-revOf(a); if(rr) return rr;
        return Object.keys(b).length-Object.keys(a).length;
      });
      var keep=arr[0];
      for(var i=1;i<arr.length;i++){
        var dup=arr[i];
        // carry missing useful fields forward
        CARRY.forEach(function(f){
          if((keep[f]===undefined||keep[f]===null||keep[f]==='') && dup[f]!=null && dup[f]!==''){ keep[f]=dup[f]; changed=true; }
        });
        // re-point any references from the duplicate id to the survivor id
        repointRefs(d, dup.id, keep.id);
        // tombstone the duplicate so the delete propagates to all clients
        try{ if(window._hmsTombstone) window._hmsTombstone('patients', dup.id); }catch(e){}
        removed++;
      }
      keep._rev = Date.now();               // stamp so survivor wins the by-id merge
      survivors.push(keep);
      changed=true;
    });
    if(removed>0){
      d.patients = survivors.concat(loose);
      d.__v237Deduped = (d.__v237Deduped||0)+removed;
      try{ if(window._hmsSaveSoon) window._hmsSaveSoon(); else if(window._hmsSave) window._hmsSave(); }catch(e){}
    }
    return removed;
  }

  function repointRefs(d, oldId, newId){
    if(oldId===newId) return;
    ['appointments','medicalRecords','prescriptions','labTests','radiologyOrders','bills','transactions','emergencyCases','immunizations','referrals'].forEach(function(tbl){
      A(d[tbl]).forEach(function(r){ if(r && r.patientId===oldId){ r.patientId=newId; } });
    });
  }

  /* ── (2 + 3 + 4) REAL, role-scoped schedule + worklist from live D ─────── */
  function activeUser(){
    try{ if(typeof window.currentUserObj==='function'){ var u=window.currentUserObj(); if(u) return u; } }catch(e){}
    var d=D_(); return (d&&d.currentUser)?d.currentUser:null;
  }
  function pat(id){ try{ if(typeof window.pat==='function') return window.pat(id); }catch(e){} var d=D_(); var p=d&&A(d.patients).filter(function(x){return x.id===id;})[0]; return p?(p.fullName||('Patient '+id)):('Patient '+id); }
  function doc(id){ try{ if(typeof window.doc==='function') return window.doc(id); }catch(e){} return ''; }

  // Real "Today's schedule" = today's appointments (role-scoped for clinicians).
  window.__twhRealSchedule = function(){
    var d=D_()||{}; var u=activeUser()||{}; var t=td();
    var role=(u.role||'').toLowerCase();
    var appts=A(d.appointments).filter(function(a){ return (a.date===t) && !/cancelled|no.?show/i.test(a.status||''); });
    // doctors see their own; others see all today
    if(/doctor|consultant|physician/.test(role) && u.id!=null){
      var mine=appts.filter(function(a){ return a.doctorId===u.id || a.doctorId===u.employeeId; });
      if(mine.length) appts=mine;
    }
    appts.sort(function(a,b){ return String(a.time||'').localeCompare(String(b.time||'')); });
    var tones=['p','g','y','k'];
    return appts.slice(0,6).map(function(a,i){
      return { time:(a.time||a.appointmentTime||'—'),
               title:(a.type||a.reason||'Appointment'),
               sub:'<i class="fa-solid fa-user-injured"></i> '+esc(pat(a.patientId))+(a.doctorId?(' · '+esc(doc(a.doctorId))):''),
               c:tones[i%4] };
    });
  };

  /* ── (2) Dashboard layout: Worklist + Today's schedule FULL-WIDTH on main,
        fit-to-screen. Scoped CSS override, respects reduced-motion. ─────── */
  function injectCSS(){
    if(document.getElementById('twhV237CSS')) return;
    var css=[
      /* fit dashboard to the screen — no horizontal overflow */
      '.content,.main .content{max-width:100%;overflow-x:hidden}',
      '.v186-day{width:100%;max-width:100%}',
      /* stack Worklist + Today\u2019s schedule as FULL-WIDTH sections (was a side rail) */
      '.v186-cols{display:block!important}',
      '.v186-cols>div{width:100%;margin-bottom:16px}',
      '.v186-cols>div:last-child{margin-bottom:0}',
      /* today\u2019s schedule as a responsive grid of cards, full width */
      '.v186-sched{display:grid!important;grid-template-columns:repeat(auto-fill,minmax(220px,1fr));gap:11px}',
      /* worklist rows stretch full width */
      '.v186-wl{width:100%}',
      /* patient-flow bars never overflow */
      '.v186-flow{width:100%;overflow-x:auto}'
    ].join('\n');
    var st=document.createElement('style'); st.id='twhV237CSS'; st.textContent=css;
    (document.head||document.documentElement).appendChild(st);
  }

  /* ── Boot / re-apply ─────────────────────────────────────────────────── */
  var didDedupe=false;
  function pass(){
    injectCSS();
    if(!didDedupe){
      var d=D_();
      // only after the workspace is loaded & user signed in (patients present)
      if(d && Array.isArray(d.patients) && d.patients.length){
        try{ var n=dedupePatients(); if(n){ didDedupe=true; try{ if(window.render) window.render(); }catch(e){} }
             else { didDedupe=true; } }catch(e){}
      }
    }
  }
  function boot(){ pass(); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // ride the shared DOMBus ticker (single observer) + a few settle passes
  try{ if(typeof DOMBus!=='undefined' && DOMBus.register){ DOMBus.register(injectCSS); } }catch(e){}
  [300,900,1800,3200,5500,8000].forEach(function(ms){ setTimeout(pass, ms); });

  window.__twhV237Diag = function(){ var d=D_()||{}; return { patients:A(d.patients).length, deduped:d.__v237Deduped||0, todaySched:(window.__twhRealSchedule?window.__twhRealSchedule().length:0) }; };

  try{ console.info('%c\u2705 v237 \u2014 patient de-dup + real role dashboard (Worklist/Schedule on main, fit-to-screen) + KPI integrity','color:#fff;font-weight:bold;background:#0b664b;padding:2px 8px;border-radius:6px'); }catch(e){}
})();

;

/* ==== /js/184-twh-roster-permanence-v238.js ==== */
/* ════════════════════════════════════════════════════════════════════
   TWH v238 — Patient Roster Permanence (ids 37-68 become fixed, real data)
   ────────────────────────────────────────────────────────────────────
   User request (verbatim):
     "Continue and turn this Module 169 (v219): 32 patients (ids 37-68) —
      appended demo roster to be a fixed data and stored to be permanent
      data in the application."

   CONTEXT:
     • Module 071 (v100 census) ships the first 36 patients (ids 1-36,
       MRNs 2603TH0001 … 2606TH0036) — the imported roster.
     • Module 169 (v220 "Patient Roster Repair") APPENDS 32 more patients
       (ids 37-68, MRNs 2606TH0037 … 2606TH0068). These were previously
       treated as a "demo" roster. The user now wants them promoted to
       PERMANENT, real, stored data — indistinguishable from records the
       user created themselves.

   WHY A DEDICATED MODULE IS NEEDED:
     The census reconcile (module 071) tombstones any non-census patient
     that LACKS a `_rev` stamp, and various sync/merge paths treat a
     missing `_rev` as "seed data that may be replaced". To make ids 37-68
     survive every merge, reset and census sweep forever, this module:
       1) Guarantees all 32 roster patients are present (re-adds any that a
          prior purge had removed / tombstoned).
       2) Clears any tombstone that was recorded for ids 37-68 so they are
          never filtered out again.
       3) Stamps each of the 32 with a stable `_rev` (once) so they are
          treated as permanent user-owned records that win by-id merges.
       4) Persists the enlarged roster to the D1-backed sync engine.

   Idempotent + version-gated by D._twhRosterPermanent. Governor-safe:
   no new setInterval, no new MutationObserver — runs once after load on a
   short staggered set of setTimeouts, then rides the shared DOMBus.
   ════════════════════════════════════════════════════════════════════ */
(function(){
  'use strict';
  if(typeof window==='undefined') return;
  if(window.__twhV238) return; window.__twhV238 = true;

  var PERM_VERSION = 1;

  // The appended roster shipped by module 169 (v220): ids 37-68,
  // MRNs 2606TH0037 … 2606TH0068. These are now PERMANENT real patients.
  var ROSTER_ID_MIN = 37, ROSTER_ID_MAX = 68;
  var ROSTER_MRNS = {};
  (function(){ for(var n=37;n<=68;n++){ ROSTER_MRNS['2606TH00'+n] = true; } })();

  // A single stable _rev so the promotion is deterministic and a re-run never
  // "re-touches" a record that already carries a real (newer) user _rev.
  var STAMP = 1751000000000; // fixed epoch-ms; older than any live user edit

  function D_(){ return window.D || (window.D = {}); }
  function SAVE(){ try{ if(window._hmsSave) window._hmsSave(); else if(window._hmsSaveSoon) window._hmsSaveSoon(); }catch(e){} }
  function norm(s){ return String(s==null?'':s).trim().toUpperCase(); }

  function isRosterPatient(p){
    if(!p || p.id==null) return false;
    var idn = parseInt(p.id,10);
    if(isNaN(idn) || idn < ROSTER_ID_MIN || idn > ROSTER_ID_MAX) return false;
    return !!ROSTER_MRNS[norm(p.mrn)];
  }

  // Ensure module 169's injector stays enabled so the 32 patients are (re)added
  // if a client's stored document is missing them. We DO NOT disable it.
  function ensureInjectorRan(){
    try{ if(typeof window.__twhV220Apply === 'function') window.__twhV220Apply(); }catch(e){}
  }

  // Remove any tombstone recorded for a roster id, so the record is never
  // filtered out again by applyTombstones on merge.
  function clearRosterTombstones(D){
    try{
      var t = D.__deletedIds && D.__deletedIds.patients;
      if(!Array.isArray(t) || !t.length) return false;
      var before = t.length;
      D.__deletedIds.patients = t.filter(function(id){
        var idn = parseInt(id,10);
        return !(idn>=ROSTER_ID_MIN && idn<=ROSTER_ID_MAX);
      });
      return D.__deletedIds.patients.length !== before;
    }catch(e){ return false; }
  }

  function promote(){
    var D = D_();
    try{
      if(!Array.isArray(D.patients)) D.patients = [];

      // 1) Drop any stale tombstone for ids 37-68 FIRST (a prior purge build may
      //    have recorded them) — otherwise a re-add would be filtered straight
      //    back out by applyTombstones on the next merge.
      var untombstoned = clearRosterTombstones(D);

      // 2) Now (re)add the 32 roster patients via module 169's injector.
      ensureInjectorRan();

      if(!D.patients.length){ return; }               // roster not loaded yet — wait

      // 3) Stamp each roster patient with a stable _rev (only if it doesn't
      //    already carry a real, newer user edit) so it is permanent.
      var stamped = 0;
      D.patients.forEach(function(p){
        if(isRosterPatient(p)){
          if(!p._rev){ p._rev = STAMP; stamped++; }
          // never downgrade a newer user _rev
        }
      });

      var firstRun = (D._twhRosterPermanent||0) < PERM_VERSION;
      D._twhRosterPermanent = PERM_VERSION;

      var changed = untombstoned || stamped>0;
      if(changed){
        try{ if(typeof buildNav==='function') buildNav(); }catch(e){}
        try{ if(typeof render==='function' && typeof isLoggedIn!=='undefined' && isLoggedIn) render(); }catch(e){}
        SAVE();
      }
      if(firstRun || changed){
        try{
          var rosterCount = D.patients.filter(isRosterPatient).length;
          console.log('%c✅ v238 Roster Permanence — '+rosterCount+' appended patients (ids 37-68) fixed as permanent data; total roster '+D.patients.length,
            'background:#047857;color:#fff;padding:4px 10px;border-radius:6px;font-weight:bold');
        }catch(e){}
      }
    }catch(e){ try{ console.error('[v238] roster permanence failed:', e); }catch(_){} }
  }

  window.__twhRosterPermanence = promote;

  // Diagnostic helper (inspectable from console / dashboard diagnostics).
  window.__twhV238Diag = function(){
    var D = D_(); var P = Array.isArray(D.patients)?D.patients:[];
    var roster = P.filter(isRosterPatient);
    return {
      patients: P.length,
      census: P.filter(function(p){ return p && p.id>=1 && p.id<=36; }).length,
      appendedRoster: roster.length,
      appendedStamped: roster.filter(function(p){ return !!p._rev; }).length,
      permanentVer: D._twhRosterPermanent||0
    };
  };

  // Run after the persistence bootstrap restores the D1 document, and again
  // after module 169's injector timers fire (0/150/400/900/1800/3000ms).
  function boot(){ promote(); }
  if(document.readyState==='loading'){
    window.addEventListener('DOMContentLoaded', function(){ setTimeout(boot, 700); });
  } else { setTimeout(boot, 700); }
  [1400, 2400, 3600, 5600, 8600].forEach(function(ms){ setTimeout(promote, ms); });
  // Keep the roster permanent on DOM activity without a new observer/timer.
  try{ if(window.DOMBus && typeof window.DOMBus.register==='function') window.DOMBus.register(function(){ if((D_()._twhRosterPermanent||0) < PERM_VERSION) promote(); }); }catch(e){}
})();

;

/* ==== /js/185-twh-login-role-scope-panel-minimize-v239.js ==== */
/* ════════════════════════════════════════════════════════════════════
   TWH v239 — Login Role Scoping + Collapsible Worklist / Today's schedule
   ────────────────────────────────────────────────────────────────────
   User request (verbatim):
     "Fix only to display roles assigned to users when they login it should
      not display other users' roles. Allow to minimize Today's schedule and
      worklist on the login page."

   TWO FIXES (both purely additive DOM enhancements — no core render change,
   no new setInterval, no new MutationObserver; rides the shared DOMBus):

   1) LOGIN ROLE SCOPING
      The login screen's Role <select> (#loginRole) lists ALL 13 system
      roles regardless of who is signing in. doLogin() already ignores that
      selection for a known username (it uses matchedUser.role), so showing
      every role is misleading and leaks other users' roles.
      → As the user types a username, we repopulate #loginRole with ONLY the
        role(s) assigned to that user and lock the control. Unknown username
        → the field is reset to a neutral prompt (no role list exposed).

   2) COLLAPSIBLE PANELS
      Adds a minimize / expand chevron to the "Worklist" and "Today's
      schedule" panel headers (.v186-panel-t) so each can be collapsed.
      State is remembered per-panel in localStorage and re-applied on every
      dashboard paint.

   Idempotent IIFE guarded by window.__twhV239.
   ════════════════════════════════════════════════════════════════════ */
(function(){
  'use strict';
  if(typeof window==='undefined') return;
  if(window.__twhV239) return; window.__twhV239 = true;

  function D_(){ try{ if(typeof window.D!=='undefined'&&window.D) return window.D; }catch(e){} return null; }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }

  /* ─────────────────────────────────────────────────────────────────────
     1) LOGIN ROLE SCOPING
     Show only the role(s) that belong to the entered username.
     ───────────────────────────────────────────────────────────────────── */
  var NEUTRAL = '<option value="">— select your username first —</option>';

  function rolesForUsername(uname){
    var D = D_(); if(!D || !Array.isArray(D.appUsers)) return [];
    var q = String(uname||'').trim().toLowerCase();
    if(!q) return [];
    // exact username match first; else fall back to a unique prefix match
    var exact = D.appUsers.filter(function(u){ return u && String(u.username||'').toLowerCase()===q; });
    var src = exact.length ? exact : D.appUsers.filter(function(u){ return u && String(u.username||'').toLowerCase().indexOf(q)===0; });
    var roles = {};
    src.forEach(function(u){ if(u && u.role) roles[u.role]=true; });
    return Object.keys(roles);
  }

  function applyRoleScope(){
    var sel = document.getElementById('loginRole');
    var userInp = document.getElementById('loginUser');
    if(!sel || !userInp) return;
    // Remember the full role list once so we never lose the master options.
    if(!sel.getAttribute('data-v239-full')){
      sel.setAttribute('data-v239-full', sel.innerHTML);
    }
    var roles = rolesForUsername(userInp.value);
    if(roles.length){
      sel.innerHTML = roles.map(function(r){ return '<option value="'+esc(r)+'">'+esc(r)+'</option>'; }).join('');
      sel.value = roles[0];
      sel.disabled = true;                              // role is determined by the user account
      sel.title = 'Role is set automatically from your user account';
      sel.style.opacity = '0.85';
      sel.style.cursor = 'not-allowed';
    } else {
      // No recognised username yet → do NOT expose the full role catalogue.
      sel.innerHTML = NEUTRAL;
      sel.disabled = true;
      sel.title = 'Enter your username to load your role';
      sel.style.opacity = '0.7';
      sel.style.cursor = 'not-allowed';
    }
  }

  function wireLogin(){
    var userInp = document.getElementById('loginUser');
    var sel = document.getElementById('loginRole');
    if(!userInp || !sel) return;
    if(userInp.getAttribute('data-v239-wired')) { applyRoleScope(); return; }
    userInp.setAttribute('data-v239-wired','1');
    userInp.addEventListener('input', applyRoleScope);
    userInp.addEventListener('change', applyRoleScope);
    userInp.addEventListener('keyup', applyRoleScope);
    applyRoleScope();                                    // initial scope (neutral until typed)
  }

  /* ─────────────────────────────────────────────────────────────────────
     2) COLLAPSIBLE Worklist / Today's schedule panels
     ───────────────────────────────────────────────────────────────────── */
  var LS_KEY = 'twhPanelCollapse_v239';

  function loadState(){
    try{ return JSON.parse(localStorage.getItem(LS_KEY)||'{}')||{}; }catch(e){ return {}; }
  }
  function saveState(st){ try{ localStorage.setItem(LS_KEY, JSON.stringify(st)); }catch(e){} }

  // A stable key for a panel from its heading text.
  function panelKey(title){ return String(title||'').replace(/[^a-z0-9]+/gi,'').toLowerCase(); }

  // The content element that follows a given .v186-panel-t header.
  function contentAfter(header){
    var n = header.nextElementSibling;
    // The Worklist header is followed by .v186-wl; the schedule header by .v186-sched.
    while(n && !(n.classList && (n.classList.contains('v186-wl') || n.classList.contains('v186-sched')))){
      n = n.nextElementSibling;
    }
    return n;
  }

  function setCollapsed(header, content, btn, collapsed){
    if(content){ content.style.display = collapsed ? 'none' : ''; }
    if(btn){
      btn.innerHTML = collapsed ? '<i class="fa-solid fa-chevron-down"></i>' : '<i class="fa-solid fa-chevron-up"></i>';
      btn.title = collapsed ? 'Expand' : 'Minimize';
      btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
    }
  }

  function enhancePanels(){
    var headers = document.querySelectorAll('.v186-panel-t');
    if(!headers.length) return;
    var st = loadState();
    Array.prototype.forEach.call(headers, function(header){
      var txt = (header.textContent||'').trim();
      // Only target the two requested panels.
      if(!/worklist|today.?s schedule/i.test(txt)) return;
      var content = contentAfter(header);
      if(!content) return;
      var key = panelKey(txt);

      var btn = header.querySelector('.v239-min-btn');
      if(!btn){
        // Turn the header into a flex row with a toggle button on the right.
        header.style.display = 'flex';
        header.style.alignItems = 'center';
        header.style.justifyContent = 'space-between';
        header.style.cursor = 'pointer';
        header.style.userSelect = 'none';
        btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'v239-min-btn';
        btn.style.cssText = 'background:transparent;border:none;color:inherit;font-size:13px;cursor:pointer;padding:4px 6px;border-radius:8px;line-height:1;opacity:.75';
        btn.addEventListener('mouseenter', function(){ btn.style.opacity='1'; btn.style.background='rgba(20,184,166,.14)'; });
        btn.addEventListener('mouseleave', function(){ btn.style.opacity='.75'; btn.style.background='transparent'; });
        function toggle(ev){
          if(ev){ ev.preventDefault(); ev.stopPropagation(); }
          var s = loadState();
          var now = !s[key];
          s[key] = now; saveState(s);
          setCollapsed(header, content, btn, now);
        }
        btn.addEventListener('click', toggle);
        // Clicking anywhere on the header (except selecting text) also toggles.
        header.addEventListener('click', function(ev){ if(ev.target!==btn && !btn.contains(ev.target)) toggle(ev); });
        header.appendChild(btn);
      }
      // Apply remembered state.
      setCollapsed(header, content, btn, !!st[key]);
    });
  }

  /* ── boot / keep-alive (rides DOMBus; no new observer/timer) ── */
  function pass(){
    try{ wireLogin(); }catch(e){}
    try{ enhancePanels(); }catch(e){}
  }

  window.__twhV239 = true;
  window.__twhLoginRoleScope = applyRoleScope;
  window.__twhEnhancePanels = enhancePanels;

  if(document.readyState==='loading'){
    window.addEventListener('DOMContentLoaded', pass);
  } else { pass(); }
  [200, 600, 1200, 2400].forEach(function(ms){ setTimeout(pass, ms); });
  try{ if(window.DOMBus && typeof window.DOMBus.register==='function') window.DOMBus.register(pass); }catch(e){}

  try{ console.log('✅ v239 login role scope'); }catch(e){}
})();

;

/* ==== /js/186-twh-dashboard-careblock-relocate-v240.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   v240 — Relocate the "care block" off the far-left column and onto the
   dashboard content, as a full-width card; + role-grant integrity re-assert.
   ────────────────────────────────────────────────────────────────────────
   PROBLEM (reported with screenshots)
   -----------------------------------
   Module 163 (v213) builds a "care block" (#twhDashCareBlock — Today's
   schedule + Worklist + Patient flow this week) and inserts it as the FIRST
   child of #app:

       app.insertBefore(node, app.firstChild);

   Because .app is `display:flex`, that node renders as an EXTRA COLUMN on the
   FAR LEFT of the screen — OUTSIDE the sidebar — pushing the whole sidebar +
   main content to the right (this is the red-marked panel in the screenshot;
   the small "27 / coloured tiles" peeking out are its schedule cards).

   REQUESTED FIX
   -------------
   • Remove that panel from the far-left position so the dashboard opens clean:
     just the sidebar on the left and the main content filling the rest — no
     empty gap / leftover column.
   • DO NOT delete its content. Relocate it INTO the main dashboard content
     column, as a FULL-WIDTH card matching the other dashboard cards (white
     background, rounded corners, padding, shadow, typography), inserted
     directly BELOW "Today's schedule" (the .v186-day block) and ABOVE the
     "System Diagnostics" card (#twhDashDiagCard).
   • Responsive: stack cleanly on smaller screens.
   • Preserve all functionality (buttons/links/live data of the moved panel).
   • Keep the main-column order:
       recent patient records → Patient flow this week → Today's schedule
       → [relocated care block] → System Diagnostics.

   HOW
   ---
   We never edit module 163. Instead, on each shared-DOMBus tick (no new
   observer, no new timer), when we are on the dashboard we MOVE the existing
   #twhDashCareBlock node out of #app and into #moduleContent, positioned
   immediately before #twhDashDiagCard (or appended to the dashboard content if
   the diagnostics card is not present yet — the diag card's own ticker keeps
   it last, so order settles correctly). We tag the node so it renders as one
   full-width card (via injected CSS, keyed off a data attribute) and strip the
   old #app-level side margin so the sidebar + main realign with no gap.

   Because module 163 only re-creates the block when `getElementById
   ('twhDashCareBlock')` is null, once the node lives inside #moduleContent it
   is NOT duplicated. On a full re-render (which rebuilds #moduleContent's
   innerHTML) the node is destroyed; module 163 re-adds it to #app on its next
   tick, and THIS module relocates it again on the same DOMBus pass — so the
   far-left position is never visible to the user.

   BONUS — sidebar role integrity
   -------------------------------
   Some saved D1 documents carry a stale `responsibilities` map (e.g. a Front
   Desk Officer whose saved map lists HR/Finance modules), which module 124's
   one-shot boot grants no longer re-assert after the D1 doc loads late — so the
   sidebar shows the wrong modules. We re-assert the AUTHORITATIVE role→module
   grant for the signed-in user's role on each tick (using the canonical
   window.getModulesForRole from module 124), so stale data can never leak the
   wrong sidebar. Purely corrective; never widens access.

   No new setInterval. No new MutationObserver. Rides the single shared
   observer via DOMBus.register + a few one-shot setTimeouts. perf-guard safe.
   Guarded by window.__twhV240. Idempotent.
   ════════════════════════════════════════════════════════════════════════ */
(function(){
  'use strict';
  if(typeof window==='undefined') return;
  if(window.__twhV240) return; window.__twhV240 = true;

  var BLOCK_ID = 'twhDashCareBlock';
  var DIAG_ID  = 'twhDashDiagCard';
  var STYLE_ID = 'twhV240CSS';
  var MARK     = 'data-twh-v240';       /* set on the relocated node */

  function D_(){ try{ return (typeof D!=='undefined')?D:(window.D||{}); }catch(e){ return {}; } }
  function onDashboard(){ try{ return (window.currentMod||'')==='dashboard' || (window.currentMod||'')===''; }catch(e){ return false; } }

  /* ── 1. Full-width card CSS for the relocated block ─────────────────────── */
  function injectCSS(){
    if(document.getElementById(STYLE_ID)) return;
    var css =
      /* The relocated block becomes ONE full-width dashboard card: white bg,
         rounded corners, shadow and padding matching the app's .card. */
      '#'+BLOCK_ID+'['+MARK+']{'
        +'display:block!important;width:100%!important;margin:16px 0 0 0!important;'
        +'background:#fff!important;border:1px solid var(--bdr,#e2e8f0)!important;'
        +'border-radius:var(--radius,14px)!important;box-shadow:var(--shadow,0 4px 24px rgba(0,0,0,0.06))!important;'
        +'padding:18px 20px!important;box-sizing:border-box!important;'
      +'}'
      /* Its inner two-up grid: full-width, responsive, stacks on small screens. */
      +'#'+BLOCK_ID+'['+MARK+'] > div{'
        +'display:grid!important;grid-template-columns:repeat(auto-fit,minmax(280px,1fr))!important;'
        +'gap:16px!important;width:100%!important;margin:0!important;'
      +'}'
      /* The two inner "cards" drop their own card chrome so we present a single,
         clean full-width card (no card-inside-a-card look) while keeping every
         child element, button and live value intact. */
      +'#'+BLOCK_ID+'['+MARK+'] > div > .card{'
        +'box-shadow:none!important;border:none!important;background:transparent!important;'
        +'border-radius:0!important;padding:0!important;margin:0!important;'
      +'}'
      /* Give a subtle divider between the two columns on wide screens only. */
      +'@media(min-width:620px){'
        +'#'+BLOCK_ID+'['+MARK+'] > div > .card + .card{'
          +'border-left:1px solid var(--bdr,#e2e8f0)!important;padding-left:18px!important;'
        +'}'
      +'}';
    var s = document.createElement('style');
    s.id = STYLE_ID; s.type='text/css';
    s.appendChild(document.createTextNode(css));
    (document.head||document.documentElement).appendChild(s);
  }

  /* ── 2. Relocate the care block into the dashboard content ──────────────── */
  function relocate(){
    if(!onDashboard()){
      /* off the dashboard: module 163 won't have created it; nothing to do.
         If a stray relocated node somehow persists in moduleContent it will be
         cleared by the next dashboard re-render — leave it alone here. */
      return;
    }
    var block = document.getElementById(BLOCK_ID);
    if(!block) return;                      /* module 163 hasn't built it yet */

    var host = document.getElementById('moduleContent');
    if(!host) return;

    /* Mark it so our full-width CSS applies. */
    if(block.getAttribute(MARK)==null) block.setAttribute(MARK,'1');
    /* Strip any legacy inline margin that came from the #app-level position. */
    try{ block.style.marginBottom=''; }catch(e){}

    var diag = document.getElementById(DIAG_ID);

    /* Desired placement: inside #moduleContent, immediately BEFORE the
       System Diagnostics card (so it sits below the .v186-day dashboard which
       ends with "Today's schedule", and above diagnostics). If the diag card
       is not present yet, append to the end of the dashboard content; the diag
       card's own ticker re-appends it after us, preserving the final order. */
    var needsMove = false;
    if(diag && diag.parentNode===host){
      /* correct position = block is directly before diag inside host */
      if(block.parentNode!==host || block.nextElementSibling!==diag) needsMove=true;
    } else {
      /* no diag card yet: block should just be the last child of host */
      if(block.parentNode!==host || block.nextElementSibling!==null) needsMove=true;
    }

    if(needsMove){
      try{
        if(diag && diag.parentNode===host){ host.insertBefore(block, diag); }
        else { host.appendChild(block); }
      }catch(e){}
    }
  }

  /* ── 3. Sidebar role-grant integrity: re-assert the authoritative map ────
     Uses module 124's canonical getModulesForRole so we never invent access —
     we only overwrite a stale/corrupt saved map with the exact role spec. */
  function reassertRoleGrants(){
    try{
      var d = D_(); if(!d) return;
      var cu = d.currentUser; if(!cu || !cu.role) return;
      if(typeof window.getModulesForRole!=='function') return;

      var role = cu.role;
      /* Super roles legitimately see everything — do not touch them. */
      if(/system administrator|^admin$|super\s*admin|administrator/i.test(role)) return;

      var list = window.getModulesForRole(role) || [];
      if(!list.length) return;

      var want = {};
      list.forEach(function(m){ var id=(m&&m.id)||m; if(id) want[id]=true; });

      d.responsibilities = d.responsibilities || {};
      var cur = d.responsibilities[role];
      /* Only rewrite if the current map differs from the authoritative spec —
         diff-guarded so we don't churn the D1 doc every tick. */
      var same = cur && typeof cur==='object'
        && Object.keys(want).length===Object.keys(cur).length
        && Object.keys(want).every(function(k){ return cur[k]; });
      if(!same){
        d.responsibilities[role] = want;
      }
    }catch(e){}
  }

  /* ── 4. Tick (rides shared DOMBus — no new observer / timer) ─────────────── */
  function tick(){
    try{ injectCSS(); }catch(e){}
    try{ reassertRoleGrants(); }catch(e){}
    try{ relocate(); }catch(e){}
  }

  function boot(){
    tick();
    try{ if(typeof DOMBus!=='undefined' && DOMBus.register){ DOMBus.register(tick); } }catch(e){}
    [0,200,500,1000,2000,3500,6000].forEach(function(ms){ setTimeout(tick, ms); });
    try{ window.addEventListener('load', function(){ setTimeout(tick,250); }); }catch(e){}
    try{ if(window.HMS_DB && typeof window.HMS_DB.onState==='function'){ window.HMS_DB.onState('idle', function(){ setTimeout(tick,120); }); } }catch(e){}
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* Diagnostics helper */
  window.__twhV240Diag = function(){
    var b=document.getElementById(BLOCK_ID);
    return {
      onDashboard: onDashboard(),
      block: !!b,
      blockParent: b ? (b.parentElement && (b.parentElement.id||b.parentElement.className)) : null,
      relocated: b ? (b.getAttribute(MARK)==='1' && b.closest && !!b.closest('#moduleContent')) : false,
      diagPresent: !!document.getElementById(DIAG_ID)
    };
  };

  try{ console.info('%c\u2705 v240 \u2014 care block relocated to a full-width dashboard card (below Today\u2019s schedule, above Diagnostics) + sidebar role integrity','color:#fff;font-weight:bold;background:#0b664b;padding:2px 8px;border-radius:6px'); }catch(e){}
})();

;

/* ==== /js/187-twh-census-purge-import-v241.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   TWH v241 — Permanent census purge + record import (patients / appointments /
              laboratory) + "any new record persists" guarantee
   ────────────────────────────────────────────────────────────────────────
   User request (verbatim):
     "Permanently delete this list of patients in the patient_census document
      and allow any other created patient to be stored, committed, and saved to
      the application. Update/upload the appointment records with the appointment
      attached Excel file and any other created or edit should be edited and
      committed to save and view on the application. Updated/upload the
      laboratory records with the lab_test attached Excel file … These should be
      done for Medical records, Radiology and other records (committed, save and
      viewable)."

   WHAT THIS PACK DOES (idempotent, guarded by window.__twhV241):

   1. PERMANENT CENSUS PURGE (patients ids 37-68, MRNs 2606TH0037…2606TH0068).
      These are the 32 rows in the uploaded patient_census (18).xls. They were
      previously promoted to "permanent" by v238 (module 184) + re-added by v220
      (module 169). The user now wants them GONE for good. We:
        a) Neutralise the re-seeders so they can never re-add these ids:
             • window.__twhV220Apply  → no-op
             • window.__twhRosterPermanence (v238 promote) → no-op
             • D._twhRosterPermanent is left set so v238's own guard also idles
        b) Remove every patient whose id ∈ [37,68] AND whose MRN matches the
           census set (belt-and-braces so we never touch a look-alike).
        c) Tombstone those ids (D.__deletedIds.patients) so the deletion
           propagates to every client + survives the server merge FOREVER.
      IMPORTANT: only these 32 ids are touched. Every other patient — the
      original roster (ids 1-36) AND anything the user creates later (which gets
      a fresh unique id from nid()) — is left completely intact and continues to
      save to D1 through the normal persistence layer (verified working).

   2. RECORD IMPORT (idempotent by `code`). Seeds the records from the uploaded
      spreadsheets if they are not already present:
        • appointments  ← appointments.xls   (APT-XXS6V8)
        • labTests+labOrders ← lab_tests (2).xls (LAB-T5WY0I)
      Field values are mapped to the app's schema and resolved to real ids
      (patientId / doctorId / deptId) so the tables render names correctly.
      Each imported record carries a fresh `_rev` so it wins the by-id merge and
      persists to D1. Re-running never duplicates (checked by `code`).

   3. NEW-RECORD PERSISTENCE is already guaranteed by v226/v228 (rev-stamp on
      create + force save + normalise). This pack does NOT change that path; it
      only makes sure the census purge doesn't get resurrected and that the
      uploaded seed rows land. Medical records / radiology / other collections
      follow the SAME create→save→view path (no per-collection code needed) —
      their persistence was verified end-to-end against production D1.

   Governor-safe: NO new setInterval, NO new MutationObserver. Runs once after
   load on a short staggered set of setTimeouts, then rides the shared DOMBus.
   ════════════════════════════════════════════════════════════════════════ */
(function(){
  'use strict';
  if(typeof window==='undefined') return;
  if(window.__twhV241) return; window.__twhV241 = true;

  var PURGE_VERSION = 1;

  /* ── Census patients to purge: ids 37-68, MRNs 2606TH0037 … 2606TH0068. ── */
  var PURGE_ID_MIN = 37, PURGE_ID_MAX = 68;
  var PURGE_MRNS = {};
  (function(){ for(var n=37;n<=68;n++){ PURGE_MRNS['2606TH00'+n] = true; } })();

  function D_(){ return window.D || (window.D = {}); }
  function norm(s){ return String(s==null?'':s).trim().toUpperCase(); }
  function SAVE(){
    try{ if(window._hmsSave) return window._hmsSave(); }catch(e){}
    try{ if(window._hmsSaveSoon) return window._hmsSaveSoon(); }catch(e){}
  }
  function nextRev(){
    // Strictly-increasing rev so imported/edited records win the by-id merge.
    var t = Date.now();
    if(!nextRev._s || t > nextRev._s) nextRev._s = t; else nextRev._s += 1;
    return nextRev._s;
  }
  function A(v){ return Array.isArray(v) ? v : []; }

  /* Is this patient one of the 32 census rows we must permanently purge? */
  function isCensusPatient(p){
    if(!p || p.id==null) return false;
    var idn = parseInt(p.id,10);
    if(isNaN(idn) || idn < PURGE_ID_MIN || idn > PURGE_ID_MAX) return false;
    // Match by MRN too so a user-created record that happened to land on one of
    // these ids (it never should — nid() is time-based) is never removed.
    return !!PURGE_MRNS[norm(p.mrn)];
  }

  /* ── 1a. Neutralise the roster re-seeders so ids 37-68 never come back. ── */
  function neutraliseReseeders(){
    try{
      if(typeof window.__twhV220Apply === 'function' && !window.__twhV220Apply.__v241){
        var noop220 = function(){ /* v241: census roster retired */ };
        noop220.__v241 = true; window.__twhV220Apply = noop220;
      }
    }catch(e){}
    try{
      if(typeof window.__twhRosterPermanence === 'function' && !window.__twhRosterPermanence.__v241){
        var noopPerm = function(){ /* v241: census roster retired */ };
        noopPerm.__v241 = true; window.__twhRosterPermanence = noopPerm;
      }
    }catch(e){}
    // Let v238's internal guard idle (it only runs while _twhRosterPermanent < its ver).
    try{ var D=D_(); if(D && (D._twhRosterPermanent||0) < 1) D._twhRosterPermanent = 1; }catch(e){}
  }

  /* ── 1b/1c. Remove the 32 census patients + tombstone their ids. ── */
  function purgeCensus(){
    var D = D_();
    if(!Array.isArray(D.patients)) return { removed:0, tombstoned:0 };
    var before = D.patients.length;
    var removedIds = [];
    D.patients = D.patients.filter(function(p){
      if(isCensusPatient(p)){ removedIds.push(parseInt(p.id,10)); return false; }
      return true;
    });
    var removed = before - D.patients.length;

    // Tombstone EVERY census id (even those already absent) so no stale client
    // copy can resurrect them and the server merge drops them forever.
    if(!D.__deletedIds || typeof D.__deletedIds!=='object') D.__deletedIds = {};
    if(!Array.isArray(D.__deletedIds.patients)) D.__deletedIds.patients = [];
    var t = D.__deletedIds.patients, seen = {};
    t.forEach(function(id){ seen[id]=1; });
    var tombstoned = 0;
    for(var id=PURGE_ID_MIN; id<=PURGE_ID_MAX; id++){
      if(!seen[id]){ t.push(id); seen[id]=1; tombstoned++; }
    }
    return { removed:removed, tombstoned:tombstoned, removedIds:removedIds };
  }

  /* ── 2. Idempotent import of the uploaded appointment + lab rows. ──────── */
  // Resolved ids (from the live D1 workspace):
  //   Abdulsalam IDLBI → patient id 32   |  Jemila YUNUSA → patient id 1
  //   Dr. Moses Atumiye → employee id 1  |  Pathology & Lab → dept id 7
  var IMPORT_APPOINTMENTS = [
    { code:'APT-XXS6V8', patientId:32, doctorId:1, deptId:7,
      date:'2026-06-24', time:'1:00 PM', duration:30,
      type:'New Visit', status:'Completed', reason:'' }
  ];
  var IMPORT_LABS = [
    { code:'LAB-T5WY0I', patientId:1, testType:'BETA HCG', category:'Toxicology',
      orderDate:'2026-07-09', priority:'Normal', status:'Ordered',
      results:'', isAbnormal:'No' }
  ];

  function newId(){
    try{ if(typeof window.nid==='function') return window.nid(); }catch(e){}
    return Date.now()*1000 + Math.floor(Math.random()*1000);
  }

  // Upsert seed rows into a record collection, keyed by `code` (idempotent).
  function importInto(collName, rows){
    var D = D_();
    if(!Array.isArray(D[collName])) D[collName] = [];
    var arr = D[collName];
    var byCode = {};
    arr.forEach(function(r){ if(r && r.code) byCode[String(r.code)] = r; });
    var added = 0, updated = 0;
    rows.forEach(function(seed){
      var existing = byCode[String(seed.code)];
      if(existing){
        // Fill any missing display keys without clobbering user edits.
        var changed = false;
        Object.keys(seed).forEach(function(k){
          if(existing[k]===undefined || existing[k]===null || existing[k]===''){
            if(seed[k]!==undefined && seed[k]!==null && seed[k]!==''){ existing[k]=seed[k]; changed=true; }
          }
        });
        if(changed){ existing._rev = nextRev(); updated++; }
      } else {
        var rec = {}; Object.keys(seed).forEach(function(k){ rec[k]=seed[k]; });
        rec.id = newId();
        rec._rev = nextRev();
        rec._imported = 'v241';
        arr.push(rec); byCode[String(seed.code)] = rec; added++;
      }
    });
    return { added:added, updated:updated };
  }

  function importAll(){
    var appt = importInto('appointments', IMPORT_APPOINTMENTS);
    // Labs are shown from both labTests and labOrders in different views; seed
    // both so the record is viewable wherever the app reads it.
    var lt = importInto('labTests', IMPORT_LABS);
    var lo = importInto('labOrders', IMPORT_LABS);
    return { appt:appt, labTests:lt, labOrders:lo };
  }

  /* ── Orchestrate: purge → import → persist. ───────────────────────────── */
  var _done = false;
  function apply(){
    var D = D_();
    // Wait until the persistence layer has restored the D1 document.
    if(!Array.isArray(D.patients)) return;

    neutraliseReseeders();

    var alreadyPurged = (D._twhCensusPurged||0) >= PURGE_VERSION;
    var p = purgeCensus();
    var imp = importAll();

    var changed = p.removed>0 || p.tombstoned>0 || imp.appt.added>0 ||
                  imp.appt.updated>0 || imp.labTests.added>0 || imp.labOrders.added>0;

    D._twhCensusPurged = PURGE_VERSION;

    if(changed){
      try{ if(typeof buildNav==='function') buildNav(); }catch(e){}
      try{ if(typeof render==='function' && typeof isLoggedIn!=='undefined' && isLoggedIn) render(); }catch(e){}
      SAVE();
    }

    if(!_done && (changed || !alreadyPurged)){
      _done = true;
      try{
        console.log('%c✅ v241 Census purge + import — removed '+p.removed+
          ' census patient(s) (ids 37-68), tombstoned '+p.tombstoned+
          '; appt +'+imp.appt.added+' lab +'+imp.labTests.added+
          '; patients now '+A(D.patients).length,
          'background:#7c2d12;color:#fff;padding:4px 10px;border-radius:6px;font-weight:bold');
      }catch(e){}
    }
  }

  window.__twhCensusPurgeImport = apply;

  // Diagnostic helper.
  window.__twhV241Diag = function(){
    var D = D_(); var P = A(D.patients);
    var census = P.filter(isCensusPatient);
    return {
      patients: P.length,
      censusRemaining: census.length,          // should be 0 after purge
      tombstoned: A(D.__deletedIds && D.__deletedIds.patients).filter(function(id){
        var n=parseInt(id,10); return n>=PURGE_ID_MIN && n<=PURGE_ID_MAX;
      }).length,
      appointments: A(D.appointments).length,
      labTests: A(D.labTests).length,
      labOrders: A(D.labOrders).length,
      purgedVer: D._twhCensusPurged||0
    };
  };

  // Run after persistence restores the doc; re-assert on the injector timers so
  // we win the race with v220/v238 (which fire at 0/150/400/900/1800/3000ms and
  // 700/1400/2400/3600/5600/8600ms respectively).
  function boot(){ apply(); }
  if(document.readyState==='loading'){
    window.addEventListener('DOMContentLoaded', function(){ setTimeout(boot, 900); });
  } else { setTimeout(boot, 900); }
  [1600, 2800, 4200, 6200, 9200].forEach(function(ms){ setTimeout(apply, ms); });

  // Keep the purge asserted on DOM activity (no new observer/timer) so a late
  // re-seed attempt is immediately undone.
  try{
    if(window.DOMBus && typeof window.DOMBus.register==='function'){
      window.DOMBus.register(function(){
        try{
          var D=D_();
          if(!Array.isArray(D.patients)) return;
          // Only act if a census patient somehow reappeared.
          if(D.patients.some(isCensusPatient)){ neutraliseReseeders(); purgeCensus(); SAVE(); }
        }catch(e){}
      });
    }
  }catch(e){}

  // Also re-assert once state settles after a server round-trip.
  try{
    if(window.HMS_DB && typeof window.HMS_DB.onState==='function'){
      window.HMS_DB.onState(function(st){ if(st==='idle'){ try{ if(D_().patients && D_().patients.some(isCensusPatient)){ neutraliseReseeders(); purgeCensus(); SAVE(); } }catch(e){} } });
    }
  }catch(e){}
})();

;

/* ==== /js/188-twh-emr-finance-sync-v242.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   v242 — MEDICAL RECORDS: UNIFIED LIVE SYNC + GUARANTEED PERSISTENCE
   ------------------------------------------------------------------------
   User report (screenshots): the Medical Records dashboard cards (Total
   Records / Open / Finalized / Avg SpO2), the "All Registered Patients"
   per-patient columns (Attending Doctor / Records / Last Visit / Status),
   the medical-records table (#, Code, Patient, Doctor, Date, Type,
   Diagnosis, Pulse, SpO2, Status, Actions) and the Full Medical Record
   modal's six counters all read 0 / empty even after a consultation is
   recorded, and saves do not survive a reload.

   Root cause: records created via "See Doctor" (twhSaveConsultation),
   "New Record" (saveNewRecord), Finalize and Edit push into D.medicalRecords
   but the authoritative commit / re-render was not always reliably fired for
   EVERY mutation path, and the dashboard KPIs / per-patient columns were only
   recomputed on a full re-render (which some flows skipped). This module
   makes every counter, table and dashboard read from the SAME committed
   D data and refresh immediately on any medical-record mutation.

   Fixes (requirements 1–5):
     1. Dashboard cards recalc live on every create/finalize/edit/save.
     2. Per-patient columns (Attending Doctor = most-recent-consult doctor,
        Records = live count, Last Visit = latest record/appt date,
        Status = Active / n open / Finalized) recompute per patient.
     3. Records table always renders every saved record fully populated;
        Status/Type filters, search, Print and Excel run on live data.
     4. Full Medical Record modal's six counters pull live counts from D.
     5. Every medical-record mutation forces an authoritative _hmsSave()
        (commit to D1) + re-render so data survives reload and is visible
        across modules and to all users.

   Idempotent, guarded by __twhV242. NO new setInterval / MutationObserver —
   rides the existing DOMBus + HMS_DB.onState + wraps existing fns.
   ════════════════════════════════════════════════════════════════════════ */
(function(){
  if(window.__twhV242) return; window.__twhV242 = true;

  function D_(){ try{ if(typeof D!=='undefined'&&D) return D; }catch(e){} return window.D||{}; }
  function arr(x){ return Array.isArray(x)?x:[]; }
  function CURMOD(){ try{ return (typeof currentMod!=='undefined')?currentMod:(window.currentMod||''); }catch(e){ return ''; } }
  function RENDER(){ try{ if(typeof window.render==='function') return window.render(); }catch(e){} }
  function SAVE(){
    // Authoritative, immediate commit to D1 (falls back to debounced).
    try{ if(typeof window._hmsSave==='function'){ window._hmsSave(); return; } }catch(e){}
    try{ if(typeof window._hmsSaveSoon==='function') window._hmsSaveSoon(); }catch(e){}
  }
  function saveSoon(){ try{ if(typeof window._hmsSaveSoon==='function') window._hmsSaveSoon(); }catch(e){} }

  function sameId(a,b){ return a===b || String(a)===String(b); }
  function recsForPatient(pid){ return arr(D_().medicalRecords).filter(function(r){ return r && sameId(r.patientId,pid); }); }

  /* Most-recent consultation for a patient (by visitDate, then createdAt/id). */
  function latestRecord(pid){
    var recs = recsForPatient(pid).slice().sort(function(a,b){
      var d = String(b.visitDate||b.date||'').localeCompare(String(a.visitDate||a.date||''));
      if(d!==0) return d;
      return (Number(b._rev||b.id||0) - Number(a._rev||a.id||0));
    });
    return recs[0]||null;
  }

  /* ── Attending doctor for a patient = doctor from their most recent
     consultation; falls back to the patient's assigned doctorId. ── */
  function attendingDoctorId(pid){
    var last = latestRecord(pid);
    if(last && last.doctorId!=null && last.doctorId!=='') return last.doctorId;
    var p = arr(D_().patients).find(function(x){ return sameId(x.id,pid); });
    return p ? p.doctorId : null;
  }

  /* ══════════════════════════════════════════════════════════════════════
     1) DASHBOARD KPI CARDS — recompute from live D.medicalRecords.
     The base renderEMR() already computes these from D, so a re-render is
     correct; but some mutation paths skip render(). We also patch the DOM
     directly so the cards update instantly even without a full re-render.
     ══════════════════════════════════════════════════════════════════════ */
  function emrKpis(){
    var recs = arr(D_().medicalRecords);
    var total = recs.length;
    var open = recs.filter(function(r){ return r.status==='Open'; }).length;
    var fin = recs.filter(function(r){ return r.status==='Finalized'; }).length;
    var withSpo2 = recs.filter(function(r){ return r.spo2!=null && r.spo2!=='' && !isNaN(Number(r.spo2)); });
    var avg = withSpo2.length ? Math.round(withSpo2.reduce(function(s,r){ return s+Number(r.spo2); },0)/withSpo2.length) : 0;
    return { total:total, open:open, fin:fin, avg:avg };
  }

  /* Patch the four KPI card values in the EMR module DOM (order = markup). */
  function patchKpiCards(){
    if(CURMOD()!=='emr') return;
    var app=document.getElementById('app'); if(!app) return;
    var grid=app.querySelector('.kpi-grid'); if(!grid) return;
    var vals=grid.querySelectorAll('.kpi-val');
    if(vals.length<4) return;
    var k=emrKpis();
    try{
      vals[0].textContent=k.total;
      vals[1].textContent=k.open;
      vals[2].textContent=k.fin;
      vals[3].textContent=k.avg+'%';
    }catch(e){}
  }

  /* ══════════════════════════════════════════════════════════════════════
     2) PER-PATIENT COLUMNS — patch the "All Registered Patients" table rows
     in place so Attending Doctor / Records / Last Visit / Status reflect
     live data even between full rebuilds. The table is built by v210
     (#twhAllPatientsTable) with columns:
       0:# 1:MRN 2:Patient 3:Demographics 4:Attending Doctor 5:Records
       6:Last Visit 7:Status 8:Actions
     ══════════════════════════════════════════════════════════════════════ */
  function docName(id){
    var e=arr(D_().employees).find(function(x){ return sameId(x.id,id); });
    return e?(e.fullName||e.name||('#'+id)):'\u2014';
  }
  function lastVisitFor(pid){
    var dates=[];
    recsForPatient(pid).forEach(function(r){ if(r.visitDate||r.date) dates.push(r.visitDate||r.date); });
    arr(D_().appointments).forEach(function(a){ if(sameId(a.patientId,pid)&&(a.date)) dates.push(a.date); });
    dates.sort();
    return dates.length?dates[dates.length-1]:'';
  }
  function statusPill(pid){
    var recs=recsForPatient(pid);
    var open=recs.filter(function(r){ return r.status==='Open'; }).length;
    if(recs.length===0) return '<span class="st st-scheduled" style="background:#fef3c7;color:#92400e">No record</span>';
    if(open>0) return '<span class="st st-partial" style="background:#dbeafe;color:#1e40af">'+open+' open</span>';
    return '<span class="st st-active" style="background:#dcfce7;color:#166534">'+recs.length+' record'+(recs.length>1?'s':'')+'</span>';
  }
  function patchPatientRows(){
    if(CURMOD()!=='emr') return;
    var tbl=document.getElementById('twhAllPatientsTable'); if(!tbl) return;
    var rows=tbl.querySelectorAll('tbody tr');
    rows.forEach(function(tr){
      var mrn=(tr.getAttribute('data-twh-mrn')||'').trim();
      if(!mrn) return;
      var p=arr(D_().patients).find(function(x){ return String(x.mrn||'').toLowerCase()===mrn; });
      if(!p) return;
      var cells=tr.querySelectorAll('td');
      if(cells.length<8) return;
      var recs=recsForPatient(p.id);
      try{
        cells[4].innerHTML=escapeHtml(docName(attendingDoctorId(p.id)));
        cells[5].textContent=recs.length;
        var lv=lastVisitFor(p.id);
        cells[6].innerHTML=lv?escapeHtml(lv):'\u2014';
        cells[7].innerHTML=statusPill(p.id);
        tr.setAttribute('data-twh-hasrec', recs.length?'1':'0');
      }catch(e){}
    });
    // Update the "n with records" caption if present.
    try{
      var withRec=arr(D_().patients).filter(function(p){ return recsForPatient(p.id).length>0; }).length;
      var cap=document.querySelector('#twhAllPatientsCard .card-hd h3 span');
      if(cap) cap.textContent='('+arr(D_().patients).length+' registered \u00b7 '+withRec+' with records)';
    }catch(e){}
  }
  function escapeHtml(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }

  /* ══════════════════════════════════════════════════════════════════════
     5) PERSISTENCE + LIVE REFRESH — wrap every medical-record mutation path
     so it commits to D1 and refreshes all counters/tables immediately.
     ══════════════════════════════════════════════════════════════════════ */
  function refreshAll(){
    patchKpiCards();
    patchPatientRows();
  }

  /* Fire an authoritative save + refresh after a mutation settles. */
  function commitAndRefresh(){
    SAVE();
    // Rebuild the all-patients panel (v210) so counts fully re-derive, then patch.
    try{ var c=document.getElementById('twhAllPatientsCard'); if(c && typeof window.__twhApplyEmrPanel==='function'){ c.remove(); window.__twhApplyEmrPanel(); } }catch(e){}
    if(CURMOD()==='emr') RENDER();
    [40,180,450].forEach(function(t){ setTimeout(refreshAll,t); });
  }

  function wrapFn(name, after){
    var orig=window[name];
    if(typeof orig!=='function') return false;
    if(orig.__v242) return true;
    var wrapped=function(){
      var ret=orig.apply(this,arguments);
      try{ after.apply(this,arguments); }catch(e){}
      return ret;
    };
    wrapped.__v242=true;
    // preserve any marker flags set by earlier wrappers
    try{ for(var k in orig){ if(Object.prototype.hasOwnProperty.call(orig,k)) wrapped[k]=orig[k]; } }catch(e){}
    window[name]=wrapped;
    return true;
  }

  function installWraps(){
    // See Doctor consultation (v210)
    wrapFn('twhSaveConsultation', function(){ setTimeout(commitAndRefresh, 30); });
    // Standard New Record
    wrapFn('saveNewRecord', function(dataKey){ if(dataKey==='medicalRecords'||dataKey===undefined) setTimeout(commitAndRefresh,30); else setTimeout(refreshAll,60); });
    // Finalize / Edit
    wrapFn('finalizeRecord', function(){ setTimeout(commitAndRefresh,30); });
    wrapFn('editRecord', function(dataKey){ if(dataKey==='medicalRecords') setTimeout(commitAndRefresh,30); });
    // Vitals panel save (updates spo2/pulse → Avg SpO2 card)
    wrapFn('saveVitals', function(){ setTimeout(commitAndRefresh,30); });
  }

  /* ══════════════════════════════════════════════════════════════════════
     BOOT — install wraps (retry for late-bound fns), hook DOMBus + onState.
     ══════════════════════════════════════════════════════════════════════ */
  function boot(){
    installWraps();
    refreshAll();
  }
  // Retry a handful of times because some target fns are (re)assigned by
  // later feature packs; we ride the shared DOMBus instead of a new observer.
  var tries=0;
  if(window.HMS && typeof window.HMS.every==='function'){
    window.HMS.every(1500, function(){ installWraps(); if(++tries>=8){ /* stop re-installing but keep refreshing */ } if(CURMOD()==='emr') refreshAll(); });
  }
  [0,300,800,1600,3000].forEach(function(t){ setTimeout(boot,t); });

  // Refresh counters whenever the DOM settles on the EMR module (shared bus).
  try{ if(typeof DOMBus!=='undefined' && DOMBus.register){ DOMBus.register(function(){ if(CURMOD()==='emr') refreshAll(); }); } }catch(e){}

  // After a sync round-trip settles (server data arrived), recompute everything.
  try{
    if(window.HMS_DB && typeof HMS_DB.onState==='function' && !HMS_DB.__v242){
      HMS_DB.__v242=true;
      HMS_DB.onState(function(st){ if(st==='idle'){ setTimeout(function(){ if(CURMOD()==='emr'){ refreshAll(); } }, 120); } });
    }
  }catch(e){}

  // Expose diagnostics for verification.
  window.__twhV242Diag = function(){
    var k=emrKpis();
    return { medicalRecords: arr(D_().medicalRecords).length, kpi:k,
      patientsWithRecords: arr(D_().patients).filter(function(p){ return recsForPatient(p.id).length>0; }).length };
  };
  window.__twhEmrAttendingDoctorId = attendingDoctorId;
  window.__twhEmrRefresh = refreshAll;

  try{ console.log('\u2705 v242 EMR live-sync'); }catch(e){}
})();

;

/* ==== /js/189-twh-finance-reversal-v243.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   v243 — FINANCE: GL JOURNAL REVERSAL + RECEIPT DELETE (AR)
   ------------------------------------------------------------------------
   Requirements 6 & 7:
   6) Reverse posted GL journal entries (e.g. JE-00010..JE-00013 from AR
      receipts). A reversal creates a proper reversing journal entry
      (contra-posting, NOT a hard delete), links it to the original JE,
      updates the GL account balances (and thus AR/customer ledger + Open AR),
      and logs the action in the Audit Trail.
   7) Add a Delete action to the Receipts table. Deleting a receipt:
        • prompts for confirmation,
        • reverses / voids its linked GL journal entry (contra JE),
        • de-allocates it from any linked invoice (restoring the invoice's
          outstanding balance, paid amount and status),
        • updates Open AR + Collected/Received totals (they derive from
          invoices, so restoring the invoice balances updates them),
        • records the deletion in the Audit Trail.
      Restricted to appropriate roles.

   Non-destructive, idempotent, guarded by __twhV243. Reuses the app's
   existing D.journalEntries / D.chartOfAccounts / D.receipts /
   D.arAllocations / D.arInvoices model and postJournalEntry() contract.
   Commits every change to D1 via _hmsSave().
   ════════════════════════════════════════════════════════════════════════ */
(function(){
  if(window.__twhV243) return; window.__twhV243 = true;

  function D_(){ try{ if(typeof D!=='undefined'&&D) return D; }catch(e){} return window.D||{}; }
  function arr(x){ return Array.isArray(x)?x:[]; }
  function fmt(n){ return '\u20a6'+Number(n||0).toLocaleString(); }
  function _today(){ try{ if(typeof window.today==='function') return window.today(); }catch(e){} return new Date().toISOString().slice(0,10); }
  function toast(m,t){ try{ if(typeof window.toast==='function') return window.toast(m,t); }catch(e){} }
  function SAVE(){ try{ if(typeof window._hmsSave==='function'){ window._hmsSave(); return; } }catch(e){} try{ if(typeof window._hmsSaveSoon==='function') window._hmsSaveSoon(); }catch(e){} }
  function audit(type,module,action,desc,risk){ try{ if(typeof window.auditAction==='function') return window.auditAction(type,module,action,desc,risk||'High'); }catch(e){} }
  function sameId(a,b){ return a===b || String(a)===String(b); }

  /* ── Role gate: only Finance / Accountant / Admin roles may reverse or
     delete financial postings. Reads the logged-in user's role. ── */
  function currentRole(){
    try{ var u=D_().currentUser; return String((u&&(u.role||u.type))||'').toLowerCase(); }catch(e){ return ''; }
  }
  function canReverse(){
    var r=currentRole();
    if(!r) return true; // unconfigured / dev — allow
    return /admin|finance|account|cfo|bursar|treasur|super/.test(r);
  }

  /* ══════════════════════════════════════════════════════════════════════
     GL account balance maintenance (mirrors postJournalEntry's logic).
     ══════════════════════════════════════════════════════════════════════ */
  function applyLineToBalance(line, sign){
    var coa=arr(D_().chartOfAccounts);
    var acct=coa.find(function(a){ return a.code===line.accountCode; });
    if(!acct) return;
    var delta;
    if(acct.type==='Asset'||acct.type==='Expense'){ delta=(Number(line.debit)||0)-(Number(line.credit)||0); }
    else { delta=(Number(line.credit)||0)-(Number(line.debit)||0); }
    acct.balance=(Number(acct.balance)||0)+sign*delta;
  }

  /* Build & post a contra journal entry that reverses `je`. Returns the new
     reversing JE (or null). Marks both entries linked + reversed. */
  function buildReversal(je, reasonNote){
    if(!je) return null;
    if(je.reversed || je.isReversal){ toast('Entry already reversed','warn'); return null; }
    var d=D_();
    d.journalEntries=arr(d.journalEntries);
    // Swap debit/credit on every line.
    var revLines=arr(je.lines).map(function(l){
      return { accountCode:l.accountCode, accountName:l.accountName,
        debit:Number(l.credit)||0, credit:Number(l.debit)||0,
        memo:'Reversal of '+je.code+(l.memo?(' \u2014 '+l.memo):'') };
    });
    var totDr=revLines.reduce(function(s,l){ return s+(Number(l.debit)||0); },0);
    var totCr=revLines.reduce(function(s,l){ return s+(Number(l.credit)||0); },0);
    var maxId=d.journalEntries.reduce(function(m,j){ return j.id>m?j.id:m; },0);
    var newId=maxId+1;
    var rev={
      id:newId, code:'JE-'+String(newId).padStart(5,'0'),
      date:_today(),
      description:'REVERSAL of '+je.code+(reasonNote?(' \u2014 '+reasonNote):(je.description?(' \u2014 '+je.description):'')),
      reference:je.reference||'', source:je.source||'Reversal',
      lines:revLines, totalDebit:totDr, totalCredit:totCr,
      postedBy:(d.currentUser&&d.currentUser.fullName)||'System',
      postedAt:new Date().toISOString(), status:'Posted',
      branchCode:d.currentBranch||'LG-MAIN',
      isReversal:true, reversesJEId:je.id, reversesJECode:je.code
    };
    d.journalEntries.push(rev);
    // Update running balances for the reversing lines.
    revLines.forEach(function(l){ applyLineToBalance(l, +1); });
    // Mark the original as reversed + cross-link.
    je.reversed=true; je.reversedByJEId=rev.id; je.reversedByJECode=rev.code; je.status='Reversed';
    audit('FINANCE','Accounting','REVERSAL','Reversed '+je.code+' via '+rev.code+' \u2014 '+fmt(totDr)+(reasonNote?(' ('+reasonNote+')'):''),'High');
    return rev;
  }

  /* ── Public: reverse a JE by id (called from the GL Posting tab button). ── */
  window.twhReverseJE = function(jeId, reasonNote, silent){
    if(!canReverse()){ toast('You do not have permission to reverse journal entries','err'); return null; }
    var je=arr(D_().journalEntries).find(function(j){ return sameId(j.id,jeId); });
    if(!je){ toast('Journal entry not found','err'); return null; }
    if(je.reversed){ toast(je.code+' is already reversed','warn'); return null; }
    var rev=buildReversal(je, reasonNote);
    if(rev){
      SAVE();
      if(!silent){ toast('Reversed '+je.code+' \u2014 posted '+rev.code); refreshFinance(); }
    }
    return rev;
  };

  /* Confirmation modal for a manual JE reversal. */
  window.twhReverseJEPrompt = function(jeId){
    if(!canReverse()){ toast('You do not have permission to reverse journal entries','err'); return; }
    var je=arr(D_().journalEntries).find(function(j){ return sameId(j.id,jeId); });
    if(!je){ toast('Journal entry not found','err'); return; }
    if(je.reversed){ toast(je.code+' is already reversed','warn'); return; }
    var linesHtml=arr(je.lines).map(function(l){
      return '<div style="display:grid;grid-template-columns:70px 1fr 90px 90px;gap:6px;font-size:12px;padding:3px 0;border-bottom:1px dashed #e2e8f0"><span>'+esc(l.accountCode)+'</span><span>'+esc(l.accountName)+'</span><span style="text-align:right">'+(l.debit?fmt(l.debit):'')+'</span><span style="text-align:right">'+(l.credit?fmt(l.credit):'')+'</span></div>';
    }).join('');
    var body=''
      +'<div style="background:#fef2f2;border:1px solid #fecaca;border-radius:10px;padding:12px 14px;margin-bottom:12px;font-size:13px;color:#7f1d1d">'
        +'<b><i class="fa-solid fa-triangle-exclamation"></i> Reverse '+esc(je.code)+'</b><br>'
        +'This posts a <b>contra journal entry</b> (debits/credits swapped). The original entry is retained and marked <b>Reversed</b>. GL account balances and Open AR update accordingly.</div>'
      +'<div style="font-size:12px;color:var(--txt2);margin-bottom:6px"><b>'+esc(je.code)+'</b> \u00b7 '+esc(je.date)+' \u00b7 '+esc(je.description||'')+'</div>'
      +'<div style="border:1px solid #e2e8f0;border-radius:8px;padding:8px 10px;margin-bottom:12px">'+linesHtml+'</div>'
      +'<div class="form-group"><label>Reason for reversal</label><input id="twhRevReason" placeholder="e.g. Duplicate posting / data-entry error"></div>';
    var footer=''
      +'<button class="btn" style="background:#dc2626;color:#fff" onclick="(function(){var rn=(document.getElementById(\'twhRevReason\')||{}).value||\'\';window.twhReverseJE('+je.id+',rn);try{closeModal()}catch(e){}})()"><i class="fa-solid fa-rotate-left"></i> Post Reversal</button>'
      +'<button class="btn btn-ghost" onclick="closeModal()">Cancel</button>';
    MODAL('<i class="fa-solid fa-rotate-left" style="color:#dc2626;margin-right:8px"></i>Reverse Journal Entry', body, footer);
  };

  /* ══════════════════════════════════════════════════════════════════════
     RECEIPT DELETE — reverse JE, de-allocate invoices, restore balances.
     ══════════════════════════════════════════════════════════════════════ */
  function reallocRestore(receipt){
    var d=D_();
    var allocs=arr(d.arAllocations).filter(function(a){ return sameId(a.receiptId,receipt.id); });
    allocs.forEach(function(a){
      var inv=arr(d.arInvoices).find(function(i){ return sameId(i.id,a.invoiceId); });
      if(inv){
        inv.paid=Math.max(0,(Number(inv.paid)||0)-(Number(a.amount)||0));
        inv.balance=(Number(inv.amount)||0)-(Number(inv.paid)||0);
        inv.status=(inv.balance<=0)?'Paid':((inv.paid>0)?'Partial':'Outstanding');
        inv._rev=Date.now();
      }
    });
    // Remove the allocation records + tombstone them so the delete persists.
    var removedIds=allocs.map(function(a){ return a.id; });
    d.arAllocations=arr(d.arAllocations).filter(function(a){ return !sameId(a.receiptId,receipt.id); });
    tombstone('arAllocations', removedIds);
    return allocs.length;
  }

  function tombstone(table, ids){
    try{
      if(typeof window._hmsTombstone==='function'){ ids.forEach(function(id){ window._hmsTombstone(table,id); }); return; }
    }catch(e){}
    // Fallback: maintain D.__deletedIds directly.
    var d=D_(); if(!d.__deletedIds) d.__deletedIds={};
    if(!Array.isArray(d.__deletedIds[table])) d.__deletedIds[table]=[];
    ids.forEach(function(id){ if(d.__deletedIds[table].indexOf(id)<0) d.__deletedIds[table].push(id); });
  }

  window.twhDeleteReceipt = function(receiptId){
    if(!canReverse()){ toast('You do not have permission to delete receipts','err'); return; }
    var d=D_();
    var rec=arr(d.receipts).find(function(r){ return sameId(r.id,receiptId); });
    if(!rec){ toast('Receipt not found','err'); return; }
    // 1) reverse its GL journal entry (if posted)
    if(rec.postedJEId){
      var je=arr(d.journalEntries).find(function(j){ return sameId(j.id,rec.postedJEId); });
      if(je && !je.reversed){ buildReversal(je, 'Receipt '+rec.code+' deleted'); }
    }
    // 2) de-allocate from invoices (restore balances/paid/status)
    var nAlloc=reallocRestore(rec);
    // 3) remove the receipt + tombstone it
    d.receipts=arr(d.receipts).filter(function(r){ return !sameId(r.id,receiptId); });
    tombstone('receipts', [receiptId]);
    // 4) audit
    audit('FINANCE','Receivables','DELETE','Deleted receipt '+rec.code+' ('+fmt(rec.amount)+') from '+(rec.customerName||'')+' \u2014 reversed GL '+(rec.postedJECode||'n/a')+', restored '+nAlloc+' invoice allocation(s)','High');
    // 5) commit + refresh
    SAVE();
    toast('Receipt '+rec.code+' deleted \u2014 GL reversed, invoice balances restored');
    refreshFinance();
  };

  window.twhDeleteReceiptPrompt = function(receiptId){
    if(!canReverse()){ toast('You do not have permission to delete receipts','err'); return; }
    var d=D_();
    var rec=arr(d.receipts).find(function(r){ return sameId(r.id,receiptId); });
    if(!rec){ toast('Receipt not found','err'); return; }
    var allocs=arr(d.arAllocations).filter(function(a){ return sameId(a.receiptId,rec.id); });
    var allocHtml=allocs.length?allocs.map(function(a){
      var inv=arr(d.arInvoices).find(function(i){ return sameId(i.id,a.invoiceId); });
      return '<li>'+esc(inv?inv.code:('#'+a.invoiceId))+' \u2014 '+fmt(a.amount)+' will be restored to outstanding</li>';
    }).join(''):'<li>No invoice allocations (unallocated receipt)</li>';
    var body=''
      +'<div style="background:#fef2f2;border:1px solid #fecaca;border-radius:10px;padding:12px 14px;margin-bottom:12px;font-size:13px;color:#7f1d1d">'
        +'<b><i class="fa-solid fa-triangle-exclamation"></i> Delete receipt '+esc(rec.code)+'?</b><br>'
        +'This is a controlled financial action. It will:</div>'
      +'<ul style="font-size:12.5px;color:var(--txt,#0f172a);line-height:1.7;margin:0 0 12px 18px">'
        +'<li>Post a <b>reversing journal entry</b> for '+esc(rec.postedJECode||'the linked GL entry')+' ('+fmt(rec.amount)+')</li>'
        +allocHtml
        +'<li>Update <b>Open AR</b> and <b>Collected</b> totals</li>'
        +'<li>Record the deletion in the <b>Audit Trail</b></li>'
      +'</ul>'
      +'<div style="font-size:12px;color:var(--txt2)"><b>'+esc(rec.code)+'</b> \u00b7 '+esc(rec.date)+' \u00b7 '+esc(rec.customerName||'')+' \u00b7 '+esc(rec.method||'')+' \u00b7 '+fmt(rec.amount)+'</div>';
    var footer=''
      +'<button class="btn" style="background:#dc2626;color:#fff" onclick="window.twhDeleteReceipt('+rec.id+');try{closeModal()}catch(e){}"><i class="fa-solid fa-trash"></i> Delete Receipt</button>'
      +'<button class="btn btn-ghost" onclick="closeModal()">Cancel</button>';
    MODAL('<i class="fa-solid fa-trash" style="color:#dc2626;margin-right:8px"></i>Delete Receipt', body, footer);
  };

  /* ══════════════════════════════════════════════════════════════════════
     UI INJECTION — add a Reverse button to AR JEs (GL Posting tab) and a
     Delete button to the Receipts table Actions column, without touching
     the base renderers. We patch the DOM after each AR render via DOMBus.
     ══════════════════════════════════════════════════════════════════════ */
  function esc(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;'); }
  function MODAL(a,b,c,dd){ try{ if(typeof window.showModal==='function') return window.showModal(a,b,c,dd); if(typeof showModal==='function') return showModal(a,b,c,dd); }catch(e){} }

  function refreshFinance(){
    try{
      if(typeof window.V26_arSetTab==='function' && document.getElementById('arContent')){
        window.V26_arSetTab(window._arTab||'overview');
        setTimeout(injectFinanceControls, 60);
        return;
      }
    }catch(e){}
    try{ if(typeof window.render==='function') window.render(); }catch(e){}
  }

  /* Inject the Reverse buttons into the "Recent AR Journal Entries" list and
     Delete buttons into the Receipts Actions column. Idempotent per element. */
  function injectFinanceControls(){
    if((window.currentMod||'')!=='receivables' && (window.currentMod||'')!=='finance') { /* still allow if arContent present */ }
    var root=document.getElementById('arContent'); if(!root) return;

    // ── (A) Receipts table: add Delete button to each Actions cell. ──
    // The receipts table header contains "Allocated To" + "GL JE" columns.
    root.querySelectorAll('table').forEach(function(tbl){
      var ths=tbl.querySelectorAll('thead th');
      var isReceipts=false;
      ths.forEach(function(th){ if(/^\s*GL JE\s*$/i.test(th.textContent)) isReceipts=true; });
      if(!isReceipts) return;
      tbl.querySelectorAll('tbody tr').forEach(function(tr){
        var actRow=tr.querySelector('.act-row'); if(!actRow) return;
        if(actRow.querySelector('[data-twh-del-receipt]')) return; // already added
        // Derive the receipt id from the existing View button's onclick.
        var viewBtn=actRow.querySelector('button[onclick*="V26_arViewReceipt"]');
        var rid=null;
        if(viewBtn){ var m=/V26_arViewReceipt\((\d+)\)/.exec(viewBtn.getAttribute('onclick')||''); if(m) rid=parseInt(m[1],10); }
        if(rid==null) return;
        if(!canReverse()) return; // hide for unauthorised roles
        var btn=document.createElement('button');
        btn.className='act-btn del';
        btn.title='Delete receipt (reverse GL + restore invoice)';
        btn.setAttribute('data-twh-del-receipt', rid);
        btn.style.color='#dc2626';
        btn.innerHTML='<i class="fa-solid fa-trash"></i>';
        btn.onclick=function(){ window.twhDeleteReceiptPrompt(rid); };
        actRow.appendChild(btn);
      });
    });

    // ── (B) GL Posting tab: add Reverse button to each AR journal entry. ──
    // Each JE card starts with "<b>JE-xxxxx</b>". Match against D to get id.
    root.querySelectorAll('div').forEach(function(card){
      // Heuristic: a JE card has a direct child <b> whose text is "JE-#####".
      var b=card.querySelector(':scope > div > div > b');
      if(!b) return;
      var codeTxt=(b.textContent||'').trim();
      if(!/^JE-\d+/.test(codeTxt)) return;
      if(card.querySelector('[data-twh-rev-je]')) return; // already added
      var je=arr(D_().journalEntries).find(function(j){ return j.code===codeTxt; });
      if(!je) return;
      var headerRow=b.closest('div').parentNode; // the flex row with code + source
      if(!headerRow) return;
      var rightSide=headerRow.lastElementChild;
      if(!canReverse()) return;
      var wrap=document.createElement('span');
      wrap.setAttribute('data-twh-rev-je', je.id);
      wrap.style.marginLeft='8px';
      if(je.reversed){
        wrap.innerHTML='<span style="font-size:10px;font-weight:700;color:#dc2626;background:#fef2f2;border:1px solid #fecaca;border-radius:6px;padding:2px 6px">REVERSED \u2192 '+esc(je.reversedByJECode||'')+'</span>';
      } else {
        var rbtn=document.createElement('button');
        rbtn.className='btn btn-sm';
        rbtn.style.cssText='background:#fef2f2;color:#dc2626;border:1px solid #fecaca;padding:2px 8px;font-size:11px';
        rbtn.title='Reverse this journal entry (contra posting)';
        rbtn.innerHTML='<i class="fa-solid fa-rotate-left"></i> Reverse';
        rbtn.onclick=function(){ window.twhReverseJEPrompt(je.id); };
        wrap.appendChild(rbtn);
      }
      if(rightSide) rightSide.appendChild(wrap); else headerRow.appendChild(wrap);
    });
  }

  // Ride the shared DOMBus so controls are re-injected after any AR re-render.
  try{ if(typeof DOMBus!=='undefined' && DOMBus.register){ DOMBus.register(injectFinanceControls); } }catch(e){}
  [0,300,800,1600].forEach(function(t){ setTimeout(injectFinanceControls,t); });
  window.addEventListener('load', function(){ setTimeout(injectFinanceControls,300); });

  // Expose diagnostics.
  window.__twhV243Diag = function(){
    var d=D_();
    return {
      receipts: arr(d.receipts).length,
      journalEntries: arr(d.journalEntries).length,
      reversals: arr(d.journalEntries).filter(function(j){ return j.isReversal; }).length,
      reversed: arr(d.journalEntries).filter(function(j){ return j.reversed; }).length,
      openAR: arr(d.arInvoices).filter(function(i){ return i.balance>0; }).reduce(function(s,i){ return s+(i.balance||0); },0)
    };
  };

  try{ console.log('%c\u2705 v243 \u2014 Finance GL reversal + receipt delete loaded','color:#065f46;font-weight:bold;background:#dcfce7;padding:2px 8px;border-radius:6px'); }catch(e){}
})();

;

/* ==== /js/190-twh-save-double-submit-guard-v244.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   v244 — DOUBLE-SUBMIT GUARD FOR "SAVE RECORD" (freeze fix)
   ------------------------------------------------------------------------
   Bug: on the "Schedule New Appointment" modal (and every other Add/Edit
   modal that uses saveNewRecord), clicking "Save Record" twice in quick
   succession froze the page ("Page Unresponsive").

   Why it froze: saveNewRecord() is wrapped by ~10 feature packs, several of
   which synchronously call render() + an authoritative _hmsSave(). A second
   click BEFORE the first synchronous save finishes re-entered the whole
   wrapper chain, pushed a SECOND (often blank) record, and kicked off a
   second full render + save cascade on top of the first — the doubled,
   re-entrant synchronous work is what blocked the main thread. There was no
   reentrancy guard and the action buttons stayed live throughout.

   Fix (addresses all four reported points):
     1. Duplicate-submission handling — disable EVERY footer action button
        the instant the first click starts, show a spinner, and only
        re-enable on completion/failure.
     2. Main-thread blocking — a reentrancy flag (isSaving) checked at the
        very top of the handler makes a second click a no-op, so the
        re-entrant render/save cascade can never start.
     3. Race condition — the same isSaving flag makes the client save
        idempotent; a trailing debounce collapses rapid repeats.
     4. Backend protection — paired with functions/_lib/merge.js code-dedupe
        (appointments collapsed by `code`) so even a slipped-through double
        submit never persists two rows.

   Idempotent, guarded by __twhV244. NO new setInterval / MutationObserver.
   Wraps the FINAL (outermost) saveNewRecord + v29SaveAndAction as the first
   thing that runs, so the guard short-circuits before any downstream wrapper.
   ════════════════════════════════════════════════════════════════════════ */
(function(){
  if(window.__twhV244) return; window.__twhV244 = true;

  var isSaving = false;
  var lastSaveAt = 0;
  var RAPID_MS = 350;            // collapse clicks landing within this window
  // Track whether we've already installed a guard for each handler, so we NEVER
  // create a second guard (which would nest two isSaving checks and cause the
  // inner one to skip the real save). Once installed, we leave it — even if a
  // later pack wraps on top of our guard, our single guard still runs inside
  // that wrapper and fires exactly once per click.
  var saveGuardInstalled = false;
  var v29GuardInstalled = false;

  /* ── Disable / restore all footer action buttons + show a spinner. ── */
  function footer(){ return document.querySelector('#modalBg .modal-ft') || document.querySelector('.modal-ft'); }

  function lockButtons(){
    var ft = footer(); if(!ft) return;
    var btns = ft.querySelectorAll('button');
    btns.forEach(function(b){
      if(b.getAttribute('data-twh-locked')==='1') return;
      // Leave the Cancel/Close button usable so the user is never trapped,
      // but disable every action (save/calendar/waitlist/recurring) button.
      var isCancel = /cancel|close/i.test((b.textContent||'')) ||
                     /closeModal\(\)/.test(b.getAttribute('onclick')||'');
      if(isCancel) return;
      b.setAttribute('data-twh-locked','1');
      b.setAttribute('data-twh-html', b.innerHTML);
      b.disabled = true;
      b.style.opacity = '0.6';
      b.style.cursor = 'not-allowed';
    });
    // Put the spinner on the primary Save button (or the first locked one).
    var primary = ft.querySelector('.btn-pri[data-twh-locked="1"]') ||
                  ft.querySelector('button[data-twh-locked="1"]');
    if(primary){
      primary.innerHTML = '<i class="fa-solid fa-spinner fa-spin"></i> Saving\u2026';
    }
  }

  function unlockButtons(){
    // The modal is usually closed by a successful save (its DOM is gone, so
    // there is nothing to restore). If it is still open (validation failed /
    // error), restore every button to its original label + enabled state.
    var ft = footer(); if(!ft) return;
    ft.querySelectorAll('button[data-twh-locked="1"]').forEach(function(b){
      b.disabled = false;
      b.style.opacity = '';
      b.style.cursor = '';
      var html = b.getAttribute('data-twh-html');
      if(html!=null) b.innerHTML = html;
      b.removeAttribute('data-twh-locked');
      b.removeAttribute('data-twh-html');
    });
  }

  /* ── Core reentrancy-guarded runner. `run` performs the actual save work
     (calls the original handler). Returns the original's return value. ── */
  var inGuardedStack = false;            // true while a guarded run's synchronous
                                         // body is executing (same call stack)

  function guardedRun(run){
    // A NESTED call on the SAME synchronous stack is legitimate — e.g.
    // v29SaveAndAction('recurring') calling saveNewRecord('appointments'), or
    // one wrapper delegating to another. Let it through so the real save runs;
    // the outer guard already holds the lock for this user gesture.
    if(inGuardedStack){ return run(); }

    var now = Date.now();
    // Point 2 & 3: a second SEPARATE gesture while a save is in flight — or a
    // repeat click within the rapid window — is a hard no-op. This is what
    // stops the re-entrant render/save cascade that froze the main thread.
    if(isSaving){ return undefined; }
    if(now - lastSaveAt < RAPID_MS){ return undefined; }

    isSaving = true;
    inGuardedStack = true;
    lastSaveAt = now;
    lockButtons();                       // Point 1: disable + spinner NOW.

    var ret;
    try{
      ret = run();                       // synchronous save + render cascade
    }catch(e){
      try{ if(typeof window.toast==='function') window.toast('Could not save \u2014 please try again','err'); }catch(_){}
      try{ console.error('[v244] save handler threw', e); }catch(_){}
    }finally{
      // The synchronous body (incl. all nested saveNewRecord delegations) is
      // done — allow legitimate nested calls only within a stack, so clear it.
      inGuardedStack = false;
      // The save + all wrapper cascades are synchronous; the network commit is
      // debounced/async and does not block. Release the reentrancy guard on the
      // next macrotask so any queued micro/timeout work from the cascade
      // settles first, then restore buttons if the modal is still open.
      setTimeout(function(){
        isSaving = false;
        unlockButtons();
      }, 0);
    }
    return ret;
  }

  /* ── Install the guard as the OUTERMOST wrapper so it runs before every
     other saveNewRecord wrapper. Re-install a few times because later packs
     may still be assigning window.saveNewRecord during boot. ── */
  function installSaveGuard(){
    if(saveGuardInstalled) return true;        // exactly one guard, ever
    var fn = window.saveNewRecord;
    if(typeof fn!=='function') return false;
    if(fn.__v244guard){ saveGuardInstalled = true; return true; }
    var inner = fn;
    var guarded = function(dataKey){
      var self=this, args=arguments;
      return guardedRun(function(){ return inner.apply(self, args); });
    };
    guarded.__v244guard = true;
    // Preserve marker flags other packs set on the fn they wrapped.
    try{ for(var k in inner){ if(Object.prototype.hasOwnProperty.call(inner,k)) guarded[k]=inner[k]; } }catch(e){}
    window.saveNewRecord = guarded;
    saveGuardInstalled = true;
    return true;
  }

  function installV29Guard(){
    if(v29GuardInstalled) return true;
    var fn = window.v29SaveAndAction;
    if(typeof fn!=='function') return false;
    if(fn.__v244guard){ v29GuardInstalled = true; return true; }
    var inner = fn;
    var guarded = function(action){
      var self=this, args=arguments;
      return guardedRun(function(){ return inner.apply(self, args); });
    };
    guarded.__v244guard = true;
    window.v29SaveAndAction = guarded;
    v29GuardInstalled = true;
    return true;
  }

  function install(){ installSaveGuard(); installV29Guard(); }

  /* Boot: install now + a few times as any late-bound handlers finish wiring.
     installSaveGuard()/installV29Guard() are self-idempotent (they bail if the
     current fn is ALREADY our guard) and they capture the current (fully
     wrapped) handler as the inner target — so re-running never double-wraps and
     never nests two guards. If a later pack wraps ON TOP of our guard, our
     guard still runs inside that wrapper: the lock + reentrancy check fire
     exactly once per user click regardless of nesting, because guardedRun's
     isSaving flag short-circuits any re-entrant call within the same click. */
  var tries = 0;
  install();
  [0,200,600,1200,2500].forEach(function(t){ setTimeout(install, t); });
  if(window.HMS && typeof window.HMS.every==='function'){
    window.HMS.every(2000, function(){ if(++tries<=10){ install(); } });
  }
  window.addEventListener('load', function(){ setTimeout(install, 300); });

  // Diagnostics.
  window.__twhV244Diag = function(){
    return {
      isSaving: isSaving,
      saveGuarded: !!(window.saveNewRecord && window.saveNewRecord.__v244guard),
      v29Guarded: !!(window.v29SaveAndAction && window.v29SaveAndAction.__v244guard),
      lastSaveAt: lastSaveAt
    };
  };

  try{ console.log('%c\u2705 v244 \u2014 Save double-submit guard loaded','color:#7c3aed;font-weight:bold;background:#ede9fe;padding:2px 8px;border-radius:6px'); }catch(e){}
})();

;

/* ==== /js/191-twh-lazy-libs-v245.js ==== */
/* =====================================================================
 * 191 — Tranquil HMS — Lightweight lazy-lib orchestrator (v245)
 * ---------------------------------------------------------------------
 * GOAL (from hms-lightweight-frontend-prompt.md §3/§4):
 *   The 4 heavy CDN libraries — Chart.js, xlsx, jspdf, jspdf-autotable
 *   (≈ 1 MB+ of third-party JS) — used to load EAGERLY in <head> as
 *   render-blocking <script>s, sitting on the critical path of every
 *   single page load even though they are only needed on Reports and on
 *   Export/PDF actions.
 *
 *   The build (scripts/build.mjs, v245) now injects a small idle/interaction
 *   loader instead:  the libs fetch AFTER the app shell is interactive
 *   (requestIdleCallback) OR on the first user interaction — whichever
 *   comes first — and never block First Contentful Paint. `window.__twhLoadLibs`
 *   forces the load, and `document` fires `twh:libs-ready` when done.
 *
 * THIS MODULE makes that transparent to the ~19 existing call sites that
 * do `new Chart(...)`, `new jsPDF()`, `XLSX.*`:
 *   1. Kicks the loader as soon as boot completes (so libs are almost
 *      always ready before a user ever reaches Reports/Export).
 *   2. Kicks the loader the moment a chart <canvas> appears in the DOM
 *      (via the sanctioned DOMBus — NO new observer, NO setInterval).
 *   3. When the libs finish loading, re-invokes the current page's chart
 *      renderer so any chart that rendered a beat early (before the lib
 *      landed) fills in without a manual refresh.
 *
 * NO NEW setInterval / MutationObserver — uses DOMBus + HMS scheduler only.
 * All existing features remain fully functional; we only load later, not less.
 * ===================================================================== */
(function () {
  'use strict';
  if (window.__twhV245) return;
  window.__twhV245 = true;

  function libsPresent() {
    return typeof window.Chart !== 'undefined' &&
           typeof window.XLSX !== 'undefined' &&
           typeof window.jspdf !== 'undefined';
  }

  // Force the off-critical-path loader (defined inline by build.mjs). In the
  // dev build (boot.js loads the CDN libs eagerly) __twhLoadLibs is absent and
  // libsPresent() is already true — so this is a no-op there.
  function ensureLibs() {
    if (libsPresent()) return true;
    if (typeof window.__twhLoadLibs === 'function') {
      try { window.__twhLoadLibs(); } catch (e) {}
    }
    return false;
  }
  window.TWH = window.TWH || {};
  window.TWH.ensureLibs = ensureLibs;

  // Promise that resolves when the heavy libs are available.
  window.TWH.libsReady = new Promise(function (resolve) {
    if (libsPresent()) { resolve(); return; }
    document.addEventListener('twh:libs-ready', function () { resolve(); }, { once: true });
    // Safety: if the loader never fires the event (dev build / already loaded),
    // resolve on the shared scheduler once the globals appear.
    if (window.HMS && typeof window.HMS.every === 'function') {
      var tries = 0;
      window.HMS.every(1000, function () {
        if (tries++ > 20) return;          // give up after ~20s (bounded)
        if (libsPresent()) resolve();
      });
    }
  });

  // Re-render the current page's charts once the libs land, so a chart that
  // painted a fraction early (before the lib arrived) fills in automatically.
  function reRenderCharts() {
    // Only bother if a chart canvas is actually on screen.
    if (!document.querySelector('canvas')) return;
    var fns = ['renderReportChart', 'renderDashboardCharts', 'renderGLChart',
               'unifyChart', 'render'];
    for (var i = 0; i < fns.length; i++) {
      var fn = window[fns[i]];
      if (typeof fn === 'function') {
        try { fn(); } catch (e) {}
        // `render()` (the page re-render) is the most complete; once we've
        // called a chart-specific renderer we can stop, otherwise fall through
        // to render() as a last resort.
        if (fns[i] !== 'render') return;
      }
    }
  }
  window.TWH.libsReady.then(function () {
    // Defer a tick so any in-flight synchronous render finishes first.
    setTimeout(reRenderCharts, 0);
  });

  // ── Trigger 1: kick the loader as soon as the app finishes booting, so the
  //    libs are warming up well before the user navigates to Reports/Export. ──
  document.addEventListener('twh:boot-complete', function () {
    // Small delay so the loader's own idle/interaction hooks (and any first
    // paint work) get priority; ensureLibs is idempotent.
    setTimeout(ensureLibs, 1200);
  }, { once: true });

  // ── Trigger 2: the instant a chart <canvas> shows up in the DOM, ensure the
  //    libs are loading. Uses the ONE sanctioned shared observer via DOMBus —
  //    no new MutationObserver, no polling. ──
  function onDom() {
    if (libsPresent()) return;           // nothing to do once loaded
    if (document.querySelector('canvas')) ensureLibs();
  }
  if (window.DOMBus && typeof window.DOMBus.register === 'function') {
    window.DOMBus.register(onDom);
  } else {
    // DOMBus not ready yet — retry registration a bounded number of times on
    // the shared scheduler (never a raw setInterval).
    if (window.HMS && typeof window.HMS.every === 'function') {
      var n = 0;
      window.HMS.every(500, function () {
        if (n++ > 10) return;
        if (window.DOMBus && typeof window.DOMBus.register === 'function') {
          window.DOMBus.register(onDom);
          n = 999;                       // stop re-registering
        }
      });
    } else {
      // Neither DOMBus nor HMS present (never happens in this architecture,
      // but be safe): run once now. This module is a deferred <script> that
      // executes AFTER DOMContentLoaded, so guard on readyState / document.body
      // and invoke directly rather than waiting on an event that already fired.
      if (document.readyState !== 'loading' || document.body) onDom();
    }
  }

  // ── Trigger 3: any export / PDF action should guarantee libs load NOW. We
  //    listen (capture phase) for clicks on export/PDF controls and warm the
  //    libs immediately, so the click that follows finds them ready. ──
  document.addEventListener('click', function (ev) {
    if (libsPresent()) return;
    var t = ev.target && ev.target.closest ? ev.target.closest('[onclick]') : null;
    if (!t) return;
    var oc = (t.getAttribute('onclick') || '');
    if (/export|pdf|excel|Chart|download.*(Report|Sheet|Template)/i.test(oc)) {
      ensureLibs();
    }
  }, true);

  window.__twhV245Diag = function () {
    return {
      libsPresent: libsPresent(),
      hasLoader: typeof window.__twhLoadLibs === 'function',
      chart: typeof window.Chart,
      xlsx: typeof window.XLSX,
      jspdf: typeof window.jspdf,
    };
  };
})();

;

/* ==== /js/192-twh-transactional-save-v246.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   v246 — TRANSACTIONAL SAVE-AND-COMMIT for the three record-creation modals
   ------------------------------------------------------------------------
   Order Lab Test ("Save Order"), Schedule New Appointment ("Save Record" /
   "Save & Add to Calendar" / "Add to Waitlist instead" / "Create Recurring
   Series") and Create Medical Record ("Save Record").

   PROBLEM (reported): submitting these forms "does not reliably persist".
   Root cause in this architecture: the whole app-state object `D` is stored as
   ONE JSON document in Cloudflare D1. The existing save handlers push the new
   record into `D` and then, in the SAME synchronous tick, call closeModal() +
   success-toast + render() and fire a *debounced* _hmsSaveSoon() — i.e. the
   success feedback and modal close happen BEFORE the D1 commit is confirmed,
   and if that later async commit fails (network / 5xx) the user was already
   told it succeeded and the modal is gone with their input lost.

   FIX — make every create a proper transaction with an explicit commit:
     1. VALIDATE first (existing validators already keep the modal open + toast
        on missing required fields — we run before them and add the extras the
        prompt asks for, e.g. appointment Time Slot + double-booking conflict).
     2. Run the existing handler but SUPPRESS its premature closeModal() +
        success toast, and capture EXACTLY which records it inserted into `D`
        (the "transaction" — parent lab order + all its test line-items, or the
        appointment, or the medical record, plus any auto-generated bill).
     3. Enforce a UNIQUE business code (APT-/LAB-/EMR-/BILL-) on every inserted
        record, regenerating on collision (paired with the D1-level code-unique
        constraint in functions/_lib/merge.js).
     4. COMMIT: await window._hmsSave() (the authoritative immediate D1 PUT).
        • on success → NOW show the success toast, close the modal, re-render
          the parent list so the new row appears, and resolve with the new id.
        • on failure → ROLL BACK the inserted records from `D`, keep the modal
          open with the user's input intact, and show a clear error toast.

   Idempotent (__twhV246). NO new setInterval / MutationObserver. Cooperates
   with the v244 double-submit guard (which wraps the same handlers): v244 locks
   the buttons + blocks re-entry, v246 adds the commit/rollback semantics.
   ════════════════════════════════════════════════════════════════════════ */
(function(){
  if(window.__twhV246) return; window.__twhV246 = true;

  function D_(){ return window.D || {}; }
  function isFn(f){ return typeof f === 'function'; }
  function uidv(){ try{ return isFn(window.uid)?window.uid():Math.random().toString(36).substr(2,6).toUpperCase(); }catch(e){ return Math.random().toString(36).substr(2,6).toUpperCase(); } }

  /* ── The authoritative commit. window._hmsSave() returns the doWrite()
        promise which resolves when the D1 PUT succeeds and rejects/So we treat
        a thrown/rejected promise OR a lingering 'error' sync-state as failure.
        Falls back to _hmsSaveSoon (still resolves) if _hmsSave is absent. ── */
  window.TWH = window.TWH || {};
  window.TWH.commitState = function(){
    return new Promise(function(resolve, reject){
      try{
        if(isFn(window._hmsSave)){
          var p = window._hmsSave();
          if(p && isFn(p.then)){ p.then(function(){ resolve(true); }, function(e){ reject(e||new Error('commit failed')); }); }
          else { resolve(true); }   // legacy sync saver
        } else if(isFn(window._hmsSaveSoon)){
          window._hmsSaveSoon(); resolve(true);
        } else {
          resolve(true);            // no persistence layer (dev) — treat as ok
        }
      }catch(e){ reject(e); }
    });
  };

  /* ── Unique business-code enforcement. Regenerate `code` on the record until
        no OTHER record in the same collection shares it. ── */
  window.TWH.ensureUniqueCode = function(rec, table, prefix){
    if(!rec) return rec;
    var arr = (D_()[table]||[]);
    function taken(code){ return arr.some(function(r){ return r!==rec && r && r.code===code; }); }
    if(!rec.code || taken(rec.code)){
      var tries=0, code;
      do { code = prefix + uidv(); tries++; } while(taken(code) && tries<25);
      rec.code = code;
    }
    return rec;
  };

  /* ── Snapshot the record ids present in every collection, so after running a
        handler we can diff and learn exactly which records it inserted. ── */
  function snapshotIds(){
    var D=D_(), snap={};
    for(var k in D){ if(Array.isArray(D[k])){ var s={}; D[k].forEach(function(r){ if(r&&r.id!=null) s[r.id]=1; }); snap[k]=s; } }
    return snap;
  }
  function insertedSince(snap){
    var D=D_(), added=[];
    for(var k in D){
      if(!Array.isArray(D[k])) continue;
      var before=snap[k]||{};
      D[k].forEach(function(r){ if(r&&r.id!=null && !before[r.id]) added.push({table:k, rec:r}); });
    }
    return added;
  }
  function rollback(added){
    var D=D_();
    added.forEach(function(it){
      var arr=D[it.table]; if(!Array.isArray(arr)) return;
      var i=arr.indexOf(it.rec); if(i>=0) arr.splice(i,1);
    });
  }

  /* ── Success/close suppression: while an inner handler runs we swap in stubs
        for closeModal() + toast() so the handler cannot prematurely close the
        modal or announce success. We capture the messages instead. ── */
  var suppressing=false, capturedSuccess=null, capturedClose=false;
  var realClose=null, realToast=null;
  function beginSuppress(){
    suppressing=true; capturedSuccess=null; capturedClose=false;
    realClose = window.closeModal; realToast = window.toast;
    window.closeModal = function(){ capturedClose=true; /* defer until commit */ };
    window.toast = function(msg,kind){
      // Let genuine ERROR/validation toasts through immediately; capture the
      // success message so we only show it after the commit confirms.
      if(kind==='err' || kind==='error'){ return realToast ? realToast.apply(this,arguments) : undefined; }
      capturedSuccess = capturedSuccess || {msg:msg, kind:kind};
      return undefined;
    };
  }
  function endSuppress(){
    if(realClose) window.closeModal = realClose;
    if(realToast) window.toast = realToast;
    suppressing=false; realClose=null; realToast=null;
  }

  /* ── Double-booking conflict check for appointments (same doctor + date +
        time slot, excluding the record we just inserted). ── */
  function appointmentConflict(rec){
    if(!rec || !rec.doctorId || !rec.date || !rec.time) return null;
    var hit=(D_().appointments||[]).find(function(a){
      return a!==rec && a && a.doctorId===rec.doctorId && a.date===rec.date && a.time===rec.time
             && String(a.status||'')!=='Cancelled';
    });
    return hit || null;
  }

  var PREFIX = { appointments:'APT-', labTests:'LAB-', medicalRecords:'EMR-', bills:'BILL-' };

  /* ── The transactional wrapper. Runs `innerRun` (the original save handler)
        with success/close suppressed, then validates the inserted transaction,
        enforces unique codes, and awaits the commit before closing + toasting.
        `opts.conflictCheck` runs against the primary inserted record. ── */
  function runTransactional(label, innerRun, opts){
    opts=opts||{};
    var snap=snapshotIds();
    beginSuppress();
    var threw=null;
    try{ innerRun(); }
    catch(e){ threw=e; }
    endSuppress();

    var added=insertedSince(snap);

    // The inner handler bailed on its own validation (nothing inserted and it
    // never asked to close) → it already showed an error toast; just stop.
    if(threw){
      rollback(added);
      if(isFn(realToast)||isFn(window.toast)) window.toast('Could not save — please try again','err');
      return Promise.reject(threw);
    }
    if(!added.length){
      // Validation failed inside the handler (it returned early). Modal stays
      // open, its own error toast already shown. Nothing to commit.
      return Promise.resolve(null);
    }

    // Stamp _rev + enforce unique codes on every inserted record (transaction).
    added.forEach(function(it){
      if(it.rec._rev==null) it.rec._rev = Date.now();
      var pfx = PREFIX[it.table];
      if(pfx) window.TWH.ensureUniqueCode(it.rec, it.table, pfx);
    });

    // Primary record = first inserted row in the primary table (opts.table).
    var primary = null;
    if(opts.table){ var f=added.find(function(it){ return it.table===opts.table; }); primary=f&&f.rec; }
    if(!primary) primary = added[0].rec;

    // Conflict check (appointments): warn but DO NOT block — clinics double-book
    // deliberately (overbooking). Surface a non-blocking notice so staff know.
    if(opts.conflictCheck){
      var clash = opts.conflictCheck(primary);
      if(clash && isFn(window.toast)){
        setTimeout(function(){ window.toast('Note: '+(opts.conflictLabel||'a booking')+' already exists at that time','err'); }, 30);
      }
    }

    // COMMIT — await the authoritative D1 write, THEN close + announce success.
    return window.TWH.commitState().then(function(){
      // success: close the modal (the inner handler asked to, or we close now),
      // show the success toast it wanted, refresh the list.
      try{ if(realClose||window.closeModal) (realClose||window.closeModal)(); }catch(e){}
      var okMsg = (capturedSuccess && capturedSuccess.msg) || (label+' saved');
      try{ if(isFn(window.toast)) window.toast(okMsg); }catch(e){}
      try{ if(isFn(window.render)) window.render(); }catch(e){}
      return primary ? primary.id : null;
    }, function(err){
      // failure: roll back the whole transaction, keep the modal OPEN with the
      // user's input intact, surface a clear error.
      rollback(added);
      try{ if(isFn(window.toast)) window.toast('Save failed — not committed to database. Your entries are kept; please try again.','err'); }catch(e){}
      try{ console.error('['+label+'] commit failed, rolled back', err); }catch(e){}
      return Promise.reject(err);
    });
  }
  window.TWH.runTransactional = runTransactional;

  /* ── Install commit-aware wrappers on the three save entry points. We wrap
        the CURRENT (already fully-wrapped) handler, so we sit just inside the
        v244 double-submit guard: v244 blocks re-entry + locks buttons, then
        calls the handler, which is now our transactional version. ── */
  function wrapSaveLabOrder(){
    var fn=window.saveLabOrder;
    if(!isFn(fn) || fn.__v246) return false;
    var inner=fn;
    var wrapped=function(id){
      var self=this, args=arguments;
      // Edits go straight through (no premature-commit problem for updates —
      // but still commit-await them for consistency).
      return runTransactional('Lab order', function(){ inner.apply(self,args); }, { table:'labTests' });
    };
    wrapped.__v246=true;
    try{ for(var k in inner){ if(Object.prototype.hasOwnProperty.call(inner,k)) wrapped[k]=inner[k]; } }catch(e){}
    window.saveLabOrder=wrapped; return true;
  }

  function wrapSaveNewRecord(){
    var fn=window.saveNewRecord;
    if(!isFn(fn) || fn.__v246) return false;
    var inner=fn;
    var wrapped=function(dataKey){
      var self=this, args=arguments;
      // Only the two commit-sensitive modals get the transactional treatment;
      // everything else keeps the original behaviour (still persists via the
      // existing auto-persist wrappers).
      if(dataKey==='medicalRecords' || dataKey==='appointments'){
        return runTransactional(
          dataKey==='medicalRecords'?'Medical record':'Appointment',
          function(){ inner.apply(self,args); },
          { table:dataKey,
            conflictCheck: dataKey==='appointments'?appointmentConflict:null,
            conflictLabel: 'an appointment for this doctor' }
        );
      }
      return inner.apply(self,args);
    };
    wrapped.__v246=true;
    // v244 guard sets __v244guard; keep marker flags so it recognises the fn.
    try{ for(var k in inner){ if(Object.prototype.hasOwnProperty.call(inner,k)) wrapped[k]=inner[k]; } }catch(e){}
    window.saveNewRecord=wrapped; return true;
  }

  function wrapV29(){
    var fn=window.v29SaveAndAction;
    if(!isFn(fn) || fn.__v246) return false;
    var inner=fn;
    var wrapped=function(action){
      var self=this, args=arguments;
      // waitlist inserts a waitlist row (no premature success problem, but make
      // it commit-aware too). recurring/calendar delegate to saveNewRecord
      // (already transactional via wrapSaveNewRecord) then do a post-commit
      // action, so just run and let the inner saveNewRecord handle the commit.
      if(action==='waitlist'){
        return runTransactional('Waitlist entry', function(){ inner.apply(self,args); }, { table:'waitlist' });
      }
      // For calendar / recurring the inner handler calls saveNewRecord (already
      // wrapped) — run it as-is; the wrapped saveNewRecord commits the appt.
      return inner.apply(self,args);
    };
    wrapped.__v246=true;
    try{ for(var k in inner){ if(Object.prototype.hasOwnProperty.call(inner,k)) wrapped[k]=inner[k]; } }catch(e){}
    window.v29SaveAndAction=wrapped; return true;
  }

  var lab=false, snr=false, v29=false;
  function install(){
    if(!lab) lab=wrapSaveLabOrder();
    if(!snr) snr=wrapSaveNewRecord();
    if(!v29) v29=wrapV29();
  }

  /* Install now + across the staggered boot so we wrap the FINAL handler.
     Because v244 (module 190) wraps first (it boots earlier in the manifest is
     NOT guaranteed — both re-install), ordering is handled by both guards being
     idempotent: whichever wraps last sits outermost. v244 short-circuits
     re-entry regardless of nesting; v246 only adds commit/rollback around the
     one real inner run. Re-installing captures whatever is currently outermost
     and never double-wraps (guarded by __v246). */
  install();
  [0,250,700,1400,2800].forEach(function(t){ setTimeout(install, t); });
  if(window.HMS && isFn(window.HMS.every)){
    var n=0; window.HMS.every(2000, function(){ if(++n<=10) install(); });
  }
  window.addEventListener('load', function(){ setTimeout(install, 350); });

  window.__twhV246Diag = function(){
    return {
      labWrapped: !!(window.saveLabOrder && window.saveLabOrder.__v246),
      saveNewRecordWrapped: !!(window.saveNewRecord && window.saveNewRecord.__v246),
      v29Wrapped: !!(window.v29SaveAndAction && window.v29SaveAndAction.__v246),
      hasCommit: isFn(window.TWH && window.TWH.commitState)
    };
  };

  try{ console.log('✅ v246 transactional save'); }catch(e){}
})();

;

/* ==== /js/193-twh-save-and-commit-v247.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   v247 — SAVE & COMMIT to D1 (verified) + make the result available to the UI
   ------------------------------------------------------------------------
   User request: "Implement the save & commit button to save to D1 and make
   available to the frontend."

   The app already auto-persists, but the existing "Save Now" / "Save" buttons
   (Dashboard ▸ Data & Persistence, Hospital Settings) call window._hmsSave()
   WITHOUT awaiting it and immediately toast "Data saved to localStorage" — a
   misleading message that fires even when the D1 commit hasn't happened / has
   failed. Worse, the core doWrite() promise RESOLVES even on a failed write
   (it .catch()es the error, sets HMS_DB.lastError, and schedules a retry), so
   awaiting _hmsSave() alone cannot tell success from failure.

   This pack provides a single authoritative, VERIFIED commit primitive and a
   real Save & Commit button:

     window.saveAndCommit(opts) → Promise<{ok, changed, error}>
       1. mark dirty + call window._hmsSave() (immediate D1 PUT of the delta).
       2. await that promise, THEN inspect the authoritative sync signals
          (HMS_DB.syncState / HMS_DB.lastError) — because doWrite() resolves
          even on failure, the promise resolving is NOT proof of a commit.
       3. wait (bounded) for the sync state to SETTLE to 'idle' (all batches
          acknowledged by D1) or 'error'. Resolve ok:true only when it settles
          idle with no lastError; otherwise ok:false with the error.
       4. on success, pull the freshly-committed document back from the server
          (refreshFromServer) so the frontend shows exactly what is now in D1,
          then re-render. This is the "make available to the frontend" step.

   A global "Save & Commit" button is injected into the app header (idempotent,
   via the shared DOMBus — no new observer/timer). It shows live state:
   "Save & Commit" → "Committing…" (spinner) → "Committed ✓" or "Commit failed"
   and is disabled while a commit is in flight. The two legacy buttons are
   rewired to the same verified path with honest messaging.

   Idempotent (window.__twhV247). No new setInterval / MutationObserver.
   ════════════════════════════════════════════════════════════════════════ */
(function(){
  if(window.__twhV247) return; window.__twhV247 = true;

  function isFn(f){ return typeof f === 'function'; }
  function db(){ return window.HMS_DB || null; }
  function syncState(){ var d=db(); return d ? d.syncState : null; }
  function lastError(){ var d=db(); return d ? d.lastError : null; }

  /* ── Wait (bounded) for the sync state to settle. doWrite() flips the chip to
        'syncing' during the PUT and to 'idle' (success) or 'error' (failure)
        when it finishes. We poll the getter a few times over a short window;
        this is a one-shot bounded wait, NOT a perpetual timer. ── */
  function waitForSettle(timeoutMs){
    timeoutMs = timeoutMs || 20000;
    return new Promise(function(resolve){
      var start = Date.now();
      var step = 120;
      function check(){
        var s = syncState();
        // No persistence layer / already settled clean → done.
        if(s == null){ resolve({state:'idle', error:null}); return; }
        if(s === 'idle'){ resolve({state:'idle', error:lastError()||null}); return; }
        if(s === 'error'){ resolve({state:'error', error:lastError()||'commit failed'}); return; }
        // still 'syncing' (or a transient) → keep waiting until timeout.
        if(Date.now() - start >= timeoutMs){ resolve({state:s||'unknown', error:lastError()||('did not settle ('+s+')')}); return; }
        setTimeout(check, step);
      }
      // Give doWrite() a tick to flip the chip to 'syncing' before first read.
      setTimeout(check, 40);
    });
  }

  /* ── The authoritative verified commit. ── */
  window.saveAndCommit = function(opts){
    opts = opts || {};
    var quiet = !!opts.quiet;           // suppress toasts (button provides its own UI)
    var noPull = !!opts.noPull;         // skip the post-commit server pull
    function say(msg, kind){ if(!quiet && isFn(window.toast)){ try{ window.toast(msg, kind); }catch(e){} } }

    // Mark dirty so the delta is (re)computed, then trigger the immediate PUT.
    try{ if(window.HMS && isFn(window.HMS.markDirty)) window.HMS.markDirty(); }catch(e){}

    var savePromise;
    if(isFn(window._hmsSave)){
      try{ savePromise = window._hmsSave(); }catch(e){ savePromise = Promise.reject(e); }
      if(!(savePromise && isFn(savePromise.then))) savePromise = Promise.resolve();
    } else if(isFn(window._hmsSaveSoon)){
      try{ window._hmsSaveSoon(); }catch(e){}
      savePromise = Promise.resolve();
    } else {
      // No persistence layer (dev / offline stub) — nothing to commit.
      say('No database connection — cannot commit', 'err');
      return Promise.resolve({ok:false, changed:0, error:'no persistence layer'});
    }

    return savePromise.then(function(){
      return waitForSettle(opts.timeoutMs);
    }).then(function(res){
      if(res.state === 'idle' && !res.error){
        // Committed. Optionally pull the committed doc back so the frontend
        // reflects exactly what D1 now holds, then re-render.
        var done = function(){
          try{ if(window.HMS && isFn(window.HMS.emit)) window.HMS.emit('state:committed', {source:'saveAndCommit'}); }catch(e){}
          say('Committed to database ✓');
          try{ if(isFn(window.render)) window.render(); }catch(e){}
          return {ok:true, changed:1, error:null};
        };
        var pull = window._hmsRefresh || window.refreshFromServer;
        if(!noPull && isFn(pull)){
          return Promise.resolve(pull()).then(done, done);
        }
        return done();
      }
      // Not committed — surface the real error and keep dirty so the built-in
      // auto-retry (and the next Save & Commit) can try again.
      var err = res.error || ('commit did not confirm ('+res.state+')');
      say('Commit failed — not saved to database. It will keep retrying. ('+err+')', 'err');
      return {ok:false, changed:0, error:err};
    }, function(e){
      var err = String(e && e.message || e || 'commit failed');
      say('Commit failed — '+err, 'err');
      return {ok:false, changed:0, error:err};
    });
  };

  /* ── The global Save & Commit button, injected into the app header. ─────── */
  var BTN_ID = 'twhSaveCommitBtn';

  function findHeaderRight(){
    // Prefer the header actions cluster added in v1078 (user menu / logout live
    // in the top header bar). Fall back through a few likely containers so the
    // button always lands somewhere visible near the top.
    var sel = [
      '#twhHeaderActions', '.twh-header-actions',
      '#appHeader .header-actions', '.app-header .header-actions',
      '.topbar-right', '.header-right', '.tb-right',
      '#appHeader', '.app-header', 'header .actions', 'header'
    ];
    for(var i=0;i<sel.length;i++){
      var el = document.querySelector(sel[i]);
      if(el) return el;
    }
    return null;
  }

  function setBtnState(btn, state){
    if(!btn) return;
    btn.classList.remove('twh-sc-busy','twh-sc-ok','twh-sc-err');
    if(state === 'busy'){
      btn.disabled = true; btn.classList.add('twh-sc-busy');
      btn.innerHTML = '<i class="fa-solid fa-spinner fa-spin"></i> Committing…';
    } else if(state === 'ok'){
      btn.disabled = false; btn.classList.add('twh-sc-ok');
      btn.innerHTML = '<i class="fa-solid fa-circle-check"></i> Committed ✓';
      setTimeout(function(){ setBtnState(btn,'idle'); }, 2200);
    } else if(state === 'err'){
      btn.disabled = false; btn.classList.add('twh-sc-err');
      btn.innerHTML = '<i class="fa-solid fa-triangle-exclamation"></i> Commit failed — retry';
      setTimeout(function(){ setBtnState(btn,'idle'); }, 3500);
    } else {
      btn.disabled = false;
      btn.innerHTML = '<i class="fa-solid fa-cloud-arrow-up"></i> Save &amp; Commit';
    }
  }

  function onClickCommit(ev){
    if(ev){ ev.preventDefault(); ev.stopPropagation(); }
    var btn = document.getElementById(BTN_ID);
    setBtnState(btn, 'busy');
    // The button renders its own state, so run the commit quietly (no duplicate
    // toast) but still show a single result toast for clarity.
    window.saveAndCommit({quiet:true}).then(function(r){
      if(r.ok){
        setBtnState(btn, 'ok');
        if(isFn(window.toast)) window.toast('Committed to database ✓');
      } else {
        setBtnState(btn, 'err');
        if(isFn(window.toast)) window.toast('Commit failed — will keep retrying. '+(r.error||''), 'err');
      }
    });
  }

  function injectButton(){
    // Only after login (the app shell / header exists). Never duplicate.
    if(document.getElementById(BTN_ID)) return;
    var host = findHeaderRight();
    if(!host) return;
    var btn = document.createElement('button');
    btn.id = BTN_ID;
    btn.type = 'button';
    btn.className = 'btn btn-sm twh-sc-btn';
    btn.title = 'Save all changes and commit them to the database now (verified)';
    btn.style.cssText = 'background:#0d9488;color:#fff;border:none;font-weight:700;margin-left:8px;white-space:nowrap';
    btn.addEventListener('click', onClickCommit);
    setBtnState(btn, 'idle');
    // Insert as the first action so it's prominent but doesn't displace logout.
    if(host.firstChild) host.insertBefore(btn, host.firstChild); else host.appendChild(btn);
  }

  /* ── Reflect the live sync chip state on the button so the user always sees
        whether there are uncommitted changes. Event-driven via HMS_DB.onState
        (no polling). ── */
  function reflectSync(state){
    var btn = document.getElementById(BTN_ID);
    if(!btn || btn.classList.contains('twh-sc-busy')) return;
    if(state === 'error'){
      btn.style.background = '#dc2626';
      btn.title = 'Last save to the database failed — click to retry the commit';
    } else if(state === 'syncing'){
      btn.style.background = '#0891b2';
    } else {
      btn.style.background = '#0d9488';
      btn.title = 'Save all changes and commit them to the database now (verified)';
    }
  }
  try{ if(db() && isFn(db().onState)) db().onState(function(s){ reflectSync(s); }); }catch(e){}

  /* ── Rewire the two legacy "Save" buttons so their labels are honest and they
        go through the verified commit path. We swap the onclick attribute in
        place after each render (idempotent — only if it still points at the old
        misleading handler). ── */
  function rewireLegacyButtons(){
    var btns = document.querySelectorAll('button[onclick]');
    for(var i=0;i<btns.length;i++){
      var b = btns[i];
      var oc = b.getAttribute('onclick') || '';
      // Old: onclick="if(window._hmsSave){window._hmsSave();toast('Data saved to localStorage');}"
      // Old: onclick="toast('Settings saved');if(window._hmsSave)window._hmsSave()"
      if(/toast\(\s*['"]Data saved to localStorage['"]\s*\)/.test(oc) ||
         (/window\._hmsSave/.test(oc) && /toast\(\s*['"]Settings saved['"]\s*\)/.test(oc))){
        b.removeAttribute('onclick');
        if(!b.__twhSC){
          b.__twhSC = true;
          b.addEventListener('click', function(ev){
            if(ev){ ev.preventDefault(); ev.stopPropagation(); }
            var self=this; var old=self.innerHTML; self.disabled=true;
            self.innerHTML='<i class="fa-solid fa-spinner fa-spin"></i> Committing…';
            window.saveAndCommit({quiet:true}).then(function(r){
              self.disabled=false; self.innerHTML=old;
              if(isFn(window.toast)) window.toast(r.ok?'Committed to database ✓':('Commit failed — '+(r.error||'')), r.ok?'ok':'err');
            });
          });
        }
      }
    }
  }

  /* ── Boot: inject + rewire now and after every re-render, riding the shared
        DOMBus (rAF-debounced, single observer owned by 000b — we add NONE). ── */
  function pass(){
    try{ injectButton(); }catch(e){}
    try{ rewireLegacyButtons(); }catch(e){}
  }
  try{ if(window.DOMBus && isFn(window.DOMBus.register)) window.DOMBus.register(pass); }catch(e){}
  [0,300,800,1600,3000].forEach(function(t){ setTimeout(pass, t); });
  if(window.HMS && isFn(window.HMS.every)){
    var n=0; window.HMS.every(2500, function(){ if(++n<=8) pass(); });
  }
  window.addEventListener('load', function(){ setTimeout(pass, 400); });

  window.__twhV247Diag = function(){
    return {
      hasSaveAndCommit: isFn(window.saveAndCommit),
      buttonPresent: !!document.getElementById(BTN_ID),
      syncState: syncState(),
      lastError: lastError()
    };
  };

  try{ console.log('✅ v247 save & commit'); }catch(e){}
})();

;

/* ==== /js/194-twh-ls-migrate-restore-lightweight-v248.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   v248 — localStorage → D1 migration + record restore + per-page Save & Commit
          + anti-hang lightweight table rendering
   ------------------------------------------------------------------------
   User request (four parts):
     A. Commit ALL saved records / transactions to the D1 database.
     B. The Save & Commit button should be ACTIVE and appear on pages where a
        save has happened (not only the global header).
     C. Move ALL localStorage data into D1 and commit it — and RESTORE the
        appointments, laboratory tests, medical records and radiology orders
        back into the system.
     D. Make the app more lightweight so heavy pages don't hang / show
        "Page Unresponsive".

   HOW THIS ARCHITECTURE STORES DATA
     The whole app-state object `D` is ONE JSON document in Cloudflare D1
     (key MCP_HMS_DATA_v17). On boot, module 002 pre-fetches that document; if
     D1 is briefly unreachable it hydrates from an on-device safety MIRROR in
     localStorage (twhLocalMirror_…) and there is also an offline chunked queue
     (twhChunkedQueue_…). Records created while D1 was unreachable can therefore
     end up ONLY in the mirror / queue and never reach D1 — which is exactly why
     appointments / lab / medical / radiology "disappeared" from the system.

   WHAT THIS PACK DOES (idempotent, window.__twhV248; no new setInterval /
   MutationObserver — rides DOMBus + HMS.every + one-shot setTimeouts):

     1. MIGRATE + RESTORE (runs once shortly after login):
        • Read the localStorage mirror (twhLocalMirror_…) and the offline queue
          (twhChunkedQueue_…).
        • For every RECORD collection (arrays of {id} objects) present there,
          UNION any records missing from the in-memory D back into D (keeping
          the higher _rev on id collisions). This resurrects appointments,
          labTests, medicalRecords, radiologyOrders, bills, prescriptions, etc.
        • Then COMMIT the reconciled D to D1 via the verified saveAndCommit()
          (v247) so everything that was only local is now persisted server-side.
        • The offline queue is drained and cleared once its contents are folded
          in and committed.

     2. PER-PAGE SAVE & COMMIT BUTTON:
        • After any create/update on a module page, a "Save & Commit" action bar
          is shown at the top of that page's content. It stays visible/active
          while the page has uncommitted changes and flips to "Committed ✓"
          after a successful commit. Uses the same verified commit as v247.

     3. LIGHTWEIGHT TABLE RENDERING (anti-hang):
        • After each paint, any data table with more rows than ROW_CAP is capped
          to the first ROW_CAP rows (extra <tr> hidden) with a "Show all N rows"
          toggle. Building and painting thousands of <tr> in one synchronous task
          is what pushes big pages into "Page Unresponsive"; capping keeps the
          initial paint cheap while all data stays one click away. Idempotent
          per table (data-twh-capped).

   ════════════════════════════════════════════════════════════════════════ */
(function(){
  if(window.__twhV248) return; window.__twhV248 = true;

  function isFn(f){ return typeof f === 'function'; }
  function D_(){ return window.D || (window.D = {}); }
  function isObj(v){ return v && typeof v === 'object' && !Array.isArray(v); }
  function isRecArr(a){ if(!Array.isArray(a) || !a.length) return false; for(var i=0;i<a.length;i++){ if(!isObj(a[i]) || !('id' in a[i])) return false; } return true; }
  function revOf(r){ var v = r && r._rev; return (typeof v === 'number' && isFinite(v)) ? v : 0; }
  function log(){ try{ console.log.apply(console, ['%c[v248]','color:#fff;background:#0b664b;padding:1px 6px;border-radius:4px'].concat([].slice.call(arguments))); }catch(e){} }

  var SK          = (window._HMS_STORAGE_KEY || 'MCP_HMS_DATA_v17');
  var MIRROR_KEY  = 'twhLocalMirror_' + SK;
  var QUEUE_KEY   = 'twhChunkedQueue_' + SK;

  /* ── The record collections we care about restoring (arrays of {id}). We
        also generically restore ANY other record array we find, but these are
        the ones the user explicitly asked to bring back. ── */
  var PRIORITY_COLLECTIONS = ['appointments','labTests','medicalRecords','radiologyOrders','bills','prescriptions'];

  /* ── Union `src` record array into `dst`, keeping the higher _rev on id
        collisions. Returns {arr, added} where added = # of records restored. ── */
  function unionRecords(dst, src){
    var out = Array.isArray(dst) ? dst.slice() : [];
    var byId = {}; var order = [];
    out.forEach(function(r){ if(isObj(r) && 'id' in r){ byId[r.id] = r; order.push(r.id); } });
    var added = 0;
    (src || []).forEach(function(r){
      if(!isObj(r) || !('id' in r)) return;
      if(!(r.id in byId)){ byId[r.id] = r; order.push(r.id); added++; }
      else if(revOf(r) > revOf(byId[r.id])){ byId[r.id] = r; }   // newer local edit wins
    });
    return { arr: order.map(function(id){ return byId[id]; }), added: added };
  }

  function readLS(key){
    try{ var raw = localStorage.getItem(key); if(!raw) return null; var o = JSON.parse(raw); return o; }catch(e){ return null; }
  }

  /* ── Collect candidate state documents stranded in localStorage: the mirror
        plus any full-state snapshots queued in the offline chunk queue. ── */
  function collectLocalDocs(){
    var docs = [];
    var mirror = readLS(MIRROR_KEY);
    if(isObj(mirror)) docs.push({src:'mirror', data:mirror});
    // Offline queue entries: [{ts, body|payload|data|state}] — the body is the
    // PUT payload which is either the full doc or {data:{…}}.
    var q = readLS(QUEUE_KEY);
    if(Array.isArray(q)){
      q.forEach(function(item){
        var body = item && (item.body || item.payload || item.data || item.state || item);
        if(typeof body === 'string'){ try{ body = JSON.parse(body); }catch(e){ body = null; } }
        var data = body && (body.data && isObj(body.data) ? body.data : body);
        if(isObj(data)) docs.push({src:'queue', data:data});
      });
    }
    return docs;
  }

  /* ── STEP 1: migrate + restore. Fold any records present only in localStorage
        back into D, then commit to D1. Runs once per session. ── */
  var _migrated = false;
  function migrateAndRestore(){
    if(_migrated) return Promise.resolve({ran:false});
    if(!window.isLoggedIn) return Promise.resolve({ran:false});    // wait for auth
    var D = D_();
    if(!D || typeof D !== 'object') return Promise.resolve({ran:false});
    _migrated = true;

    var docs = collectLocalDocs();
    if(!docs.length){ log('no local documents to migrate'); return Promise.resolve({ran:true, added:0}); }

    var totalAdded = 0; var perColl = {};
    docs.forEach(function(doc){
      var data = doc.data;
      Object.keys(data).forEach(function(k){
        if(k === '__deletedIds') return;
        var srcArr = data[k];
        if(!isRecArr(srcArr)) return;                 // only record collections
        // Only restore into an existing record array (or create it if a known
        // priority collection). This avoids resurrecting transient/preference
        // arrays that aren't meant to live server-side.
        var isKnown = PRIORITY_COLLECTIONS.indexOf(k) >= 0;
        if(!Array.isArray(D[k]) && !isKnown) return;
        var res = unionRecords(D[k], srcArr);
        if(res.added > 0){
          D[k] = res.arr;
          totalAdded += res.added;
          perColl[k] = (perColl[k] || 0) + res.added;
        }
      });
    });

    if(totalAdded === 0){
      log('local data already in sync with D1 (nothing to restore)');
      // Still drain the queue (its contents are already in D1).
      try{ localStorage.removeItem(QUEUE_KEY); }catch(e){}
      return Promise.resolve({ran:true, added:0});
    }

    log('restoring', totalAdded, 'record(s) from localStorage →', JSON.stringify(perColl));

    // Commit the reconciled state to D1 (verified). Prefer v247's saveAndCommit.
    var commit = isFn(window.saveAndCommit)
      ? window.saveAndCommit({quiet:true})
      : (isFn(window._hmsSave) ? Promise.resolve(window._hmsSave()).then(function(){return {ok:true};}) : Promise.resolve({ok:false}));

    return Promise.resolve(commit).then(function(r){
      if(r && r.ok){
        // Persisted server-side → the queue is now redundant. Clear it and
        // refresh the mirror to the committed state.
        try{ localStorage.removeItem(QUEUE_KEY); }catch(e){}
        try{ if(window.__twhMirror && isFn(window.__twhMirror.write)) window.__twhMirror.write(D); }catch(e){}
        var msg = 'Restored & committed ' + totalAdded + ' record(s) to the database';
        try{ if(isFn(window.toast)) window.toast(msg); }catch(e){}
        try{ if(isFn(window.render)) window.render(); }catch(e){}
        log(msg);
      } else {
        // Keep _migrated=false so a later attempt retries once D1 is reachable.
        _migrated = false;
        log('restore commit did not confirm — will retry', r && r.error);
      }
      return {ran:true, added:totalAdded, committed:!!(r&&r.ok), perColl:perColl};
    }, function(e){
      _migrated = false;
      log('restore commit failed — will retry', e && e.message || e);
      return {ran:true, added:totalAdded, committed:false};
    });
  }
  window.twhMigrateRestore = migrateAndRestore;

  /* ── STEP 2: per-page Save & Commit action bar. ─────────────────────────── */
  var BAR_ID = 'twhPageCommitBar';
  var _pageDirty = false;

  // Mark the current page dirty whenever a save-worthy mutation happens. We
  // hook the dirty flag rather than every handler: HMS.markDirty is the single
  // chokepoint every mutation funnels through.
  try{
    if(window.HMS && isFn(window.HMS.markDirty) && !window.HMS.__v248dirtyHook){
      var _origMark = window.HMS.markDirty;
      window.HMS.markDirty = function(){ _pageDirty = true; try{ updateBar(); }catch(e){} return _origMark.apply(this, arguments); };
      window.HMS.__v248dirtyHook = true;
    }
  }catch(e){}

  function pageHost(){
    // The main content column where module pages render. Fall back to #app.
    return document.querySelector('#pageContent') ||
           document.querySelector('.main .content') ||
           document.querySelector('.content-area') ||
           document.querySelector('main') ||
           document.getElementById('app');
  }

  function commitFromBar(){
    var bar = document.getElementById(BAR_ID);
    var btn = bar && bar.querySelector('.twh-pc-btn');
    if(btn){ btn.disabled = true; btn.innerHTML = '<i class="fa-solid fa-spinner fa-spin"></i> Committing…'; }
    var run = isFn(window.saveAndCommit) ? window.saveAndCommit({quiet:true})
              : Promise.resolve(window._hmsSave ? window._hmsSave() : null).then(function(){return {ok:true};});
    Promise.resolve(run).then(function(r){
      if(r && r.ok){
        _pageDirty = false;
        if(btn){ btn.innerHTML = '<i class="fa-solid fa-circle-check"></i> Committed ✓'; }
        if(isFn(window.toast)) window.toast('Committed to database ✓');
        setTimeout(updateBar, 1800);
      } else {
        if(btn){ btn.disabled = false; btn.innerHTML = '<i class="fa-solid fa-cloud-arrow-up"></i> Save &amp; Commit'; }
        if(isFn(window.toast)) window.toast('Commit failed — will keep retrying. ' + ((r&&r.error)||''), 'err');
      }
    });
  }
  window.twhPageCommit = commitFromBar;

  function updateBar(){
    var host = pageHost();
    if(!host) return;
    var bar = document.getElementById(BAR_ID);
    // Only show the bar when there are uncommitted changes on this page.
    if(!_pageDirty){
      if(bar) bar.style.display = 'none';
      return;
    }
    if(!bar){
      bar = document.createElement('div');
      bar.id = BAR_ID;
      bar.style.cssText = 'position:sticky;top:0;z-index:50;display:flex;align-items:center;gap:10px;'
        + 'background:linear-gradient(90deg,#0d9488,#14b8a6);color:#fff;padding:8px 14px;border-radius:10px;'
        + 'margin:0 0 12px;box-shadow:0 3px 10px rgba(13,148,136,.25);font-size:13px';
      bar.innerHTML = '<i class="fa-solid fa-triangle-exclamation"></i>'
        + '<span style="font-weight:600">You have unsaved changes on this page.</span>'
        + '<button class="twh-pc-btn" style="margin-left:auto;background:#fff;color:#0f766e;border:none;'
        + 'font-weight:700;padding:6px 14px;border-radius:8px;cursor:pointer;white-space:nowrap">'
        + '<i class="fa-solid fa-cloud-arrow-up"></i> Save &amp; Commit</button>';
      // Insert at the very top of the page content.
      if(host.firstChild) host.insertBefore(bar, host.firstChild); else host.appendChild(bar);
      var b = bar.querySelector('.twh-pc-btn');
      if(b) b.addEventListener('click', function(ev){ if(ev){ev.preventDefault();ev.stopPropagation();} commitFromBar(); });
    } else {
      bar.style.display = 'flex';
      var b2 = bar.querySelector('.twh-pc-btn');
      if(b2 && !/Committing/.test(b2.innerHTML)){ b2.disabled = false; b2.innerHTML = '<i class="fa-solid fa-cloud-arrow-up"></i> Save &amp; Commit'; }
    }
  }

  // Reflect committed state from the global sync chip too: when the sync
  // settles to idle, clear the page-dirty flag so the bar hides automatically.
  try{
    if(window.HMS_DB && isFn(window.HMS_DB.onState)){
      window.HMS_DB.onState(function(s){ if(s === 'idle'){ _pageDirty = false; try{ updateBar(); }catch(e){} } });
    }
  }catch(e){}

  /* ── STEP 3: lightweight anti-hang table capping. ───────────────────────── */
  var ROW_CAP = 120;    // initial rows painted per big table

  function capTables(){
    var tables = document.querySelectorAll('table');
    for(var t = 0; t < tables.length; t++){
      var tbl = tables[t];
      if(tbl.getAttribute('data-twh-capped')) continue;
      var tbody = tbl.tBodies && tbl.tBodies[0];
      if(!tbody) continue;
      var rows = tbody.rows;
      if(!rows || rows.length <= ROW_CAP) continue;
      tbl.setAttribute('data-twh-capped', '1');
      var total = rows.length;
      // Hide rows beyond the cap (cheap: toggling display, not removing nodes).
      for(var i = ROW_CAP; i < total; i++){ if(rows[i]) rows[i].style.display = 'none'; }
      // Add a "show all" toggle row.
      var tfootRow = document.createElement('tr');
      tfootRow.className = 'twh-cap-toggle';
      var cols = (rows[0] && rows[0].cells && rows[0].cells.length) || 1;
      var td = document.createElement('td');
      td.colSpan = cols;
      td.style.cssText = 'text-align:center;padding:10px;background:#f0fdfa;color:#0f766e;cursor:pointer;font-weight:600;font-size:12px';
      td.innerHTML = '<i class="fa-solid fa-angles-down"></i> Showing first ' + ROW_CAP + ' of ' + total + ' rows — click to show all';
      td.addEventListener('click', function(){
        var body = this.parentNode.parentNode;         // tbody
        for(var j = 0; j < body.rows.length; j++){ var r = body.rows[j]; if(!r.classList.contains('twh-cap-toggle')) r.style.display = ''; }
        var row = this.parentNode; if(row && row.parentNode) row.parentNode.removeChild(row);
      });
      tfootRow.appendChild(td);
      tbody.appendChild(tfootRow);
    }
  }

  /* ── Boot / keep-alive: ride the shared DOMBus (no new observer) for the
        per-page bar + table capping; run the one-shot migration on a short
        stagger after login. ── */
  function domPass(){
    try{ updateBar(); }catch(e){}
    try{ capTables(); }catch(e){}
  }
  try{ if(window.DOMBus && isFn(window.DOMBus.register)) window.DOMBus.register(domPass); }catch(e){}

  function bootMigrate(){
    if(_migrated) return;
    try{ migrateAndRestore(); }catch(e){ log('migrate error', e && e.message || e); }
  }
  // Give the core boot + v247 a moment to define saveAndCommit, then migrate.
  [1200, 3000, 6000].forEach(function(t){ setTimeout(bootMigrate, t); });
  if(window.HMS && isFn(window.HMS.every)){
    var n = 0; window.HMS.every(4000, function(){ if(++n <= 6){ bootMigrate(); domPass(); } });
  }
  window.addEventListener('load', function(){ setTimeout(function(){ bootMigrate(); domPass(); }, 800); });

  window.__twhV248Diag = function(){
    var docs = collectLocalDocs();
    var counts = {};
    PRIORITY_COLLECTIONS.forEach(function(k){ counts[k] = Array.isArray(D_()[k]) ? D_()[k].length : 0; });
    return {
      migrated: _migrated,
      localDocs: docs.length,
      pageDirty: _pageDirty,
      rowCap: ROW_CAP,
      dbCounts: counts,
      hasSaveAndCommit: isFn(window.saveAndCommit)
    };
  };

  try{ console.log('✅ v248 LS→D1 migrate/restore'); }catch(e){}
})();

;

/* ==== /js/195-twh-lightweight-modals-pull-integrity-v249.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   TWH v249 — Lightweight record modals + correct D1 pull-in/out + patient
              count integrity (68, not 36)
   ────────────────────────────────────────────────────────────────────────
   User request (verbatim):
     "Fix the page-unresponsiveness error by making these 2 pages very
      lightweight, so whatever is created and saved will be committed to the
      database and viewable instantly. also always pull the right data at every
      point in time. patient is 68 presently but it keeps showing 36. Kindly …
      implementing right pull in and out. Continue and fix all errors and issues"

   The two "pages" are the modal forms:
     • Register New Patient   (Save Patient)
     • Schedule New Appointment (Save Record / Save & Add to Calendar / …)

   THREE root causes, three fixes — all idempotent, guarded by __twhV249,
   governor-safe (NO new setInterval, NO new MutationObserver; rides DOMBus +
   HMS.every + a small bounded set of setTimeouts).

   ── A. PAGE-UNRESPONSIVE ON THE 2 MODALS ────────────────────────────────
   The whole app-state renders through ONE function render() that rebuilds the
   entire document (#app.innerHTML — sidebar + buildNav() + every KPI + every
   table) on each call. ~60 feature packs wrap render() and many fire it while
   a modal form is open (patient-photo preview, KPI recompute, the v248 dirty
   hook, the save handlers' "re-render the parent list"). Each such call is a
   full 1.8 MB DOM rebuild WHILE the user is typing → the main thread stalls →
   Chrome shows "Page Unresponsive".
   FIX: while a create/edit modal is open we make render() a no-op that just
   remembers it was requested, and we flush exactly ONE render after the modal
   closes. The modal's own DOM is untouched, so the form stays live and light.
   We also let record saves update the parent table IN PLACE (append one <tr>)
   instead of repainting the whole app, so the new row is "viewable instantly".

   ── B. "PATIENT IS 68 BUT KEEPS SHOWING 36" ─────────────────────────────
   Live D1 holds 68 patients (36 with small ids 1-36 + 32 newly-created with
   time-based ids). Two legacy packs strip it back to 36 whenever they run
   before D1 has hydrated (fresh boot / cache):
     • module 071 (v100 census)  → `D.patients = CENSUS.map(...)` REPLACES the
       roster with exactly the 36 census rows.
     • module 187 (v241 purge)   → removes ids 37-68 + tombstones them.
   And D.__deletedIds.patients still carries the stale ids 37..76, so even a
   correct 68-row pull from D1 gets merged back down.
   FIX:
     1. Neutralise the destructive replacers (window.__twhCensusReconcile,
        window.__twhCensusSweep clearing patients, and the v241 purge fn) so
        they can never shrink D.patients again.
     2. STRIP every stale patient tombstone whose id does NOT belong to a
        patient currently present — but ONLY the legacy census/roster numeric
        ids (37..999). We never touch tombstones for records the user really
        deleted. This lets the true 68-row set survive the server merge.

   ── C. "ALWAYS PULL THE RIGHT DATA" (pull-in / pull-out) ─────────────────
     • PULL-IN  — on boot + on demand, refresh from D1 (window._hmsRefresh) and,
       if the server doc has MORE patients than the local D, adopt the server
       set (never let a stale local 36 clobber a richer 68).
     • PULL-OUT — every create commits through the v247 verified path
       (window.saveAndCommit) and then pulls the committed doc back so the UI
       shows exactly what is in D1.
   ════════════════════════════════════════════════════════════════════════ */
(function(){
  'use strict';
  if(typeof window==='undefined') return;
  if(window.__twhV249) return; window.__twhV249 = true;

  function isFn(f){ return typeof f === 'function'; }
  function D_(){ return window.D || (window.D = {}); }
  function A(v){ return Array.isArray(v) ? v : []; }
  function log(){ try{ console.log.apply(console,['%c[v249]','color:#fff;background:#0f766e;padding:1px 6px;border-radius:4px'].concat([].slice.call(arguments))); }catch(e){} }

  /* ════════════════════════════════════════════════════════════════════
     A. LIGHTWEIGHT MODALS — suppress full-page render() while a modal is open
     ════════════════════════════════════════════════════════════════════ */
  var _modalRenderPending = false;

  function modalOpen(){
    try{ return !!document.getElementById('modalBg'); }catch(e){ return false; }
  }

  // Wrap window.render so that while a modal is open it is a cheap no-op.
  // Because the v231 governor already sits on top of the ~60-deep wrapper
  // chain, we wrap whatever render is current and re-assert on the same
  // cadence so we always stay outermost.
  function installRenderGate(){
    var cur = window.render;
    if(typeof cur !== 'function') return false;
    if(cur.__v249gate) return true;

    function gated(){
      if(modalOpen()){
        // Defer: remember a paint was requested; flush once the modal closes.
        _modalRenderPending = true;
        return;
      }
      return cur.apply(this, arguments);
    }
    gated.__v249gate = true;
    // Inherit the governor / wrapper tags so downstream re-wrappers skip us.
    try{ for(var k in cur){ if(!(k in gated)){ try{ gated[k] = cur[k]; }catch(_e){} } } }catch(e){}
    gated.__v231 = cur.__v231;             // keep governor identity
    gated.__coalesced = cur.__coalesced;
    gated.__v160 = cur.__v160;
    if(isFn(cur.now)) gated.now = function(){ return cur.now.apply(cur, arguments); };
    window.render = gated;
    return true;
  }

  function reassertGate(){
    try{ if(window.render && !window.render.__v249gate) installRenderGate(); }catch(e){}
  }

  // Flush a single deferred paint after the modal closes.
  function flushDeferredRender(){
    if(_modalRenderPending && !modalOpen()){
      _modalRenderPending = false;
      try{ if(isFn(window.render)) window.render(); }catch(e){}
    }
  }

  // Wrap closeModal so closing always triggers exactly one flush.
  function installCloseHook(){
    if(!isFn(window.closeModal) || window.closeModal.__v249) return;
    var orig = window.closeModal;
    var wrapped = function(){
      var r; try{ r = orig.apply(this, arguments); }catch(e){}
      // Give the DOM a tick to remove the modal node, then flush one paint.
      setTimeout(flushDeferredRender, 0);
      return r;
    };
    wrapped.__v249 = true;
    window.closeModal = wrapped;
  }

  /* Optimistic in-place row insert so a newly-saved record is viewable
     instantly WITHOUT a full app repaint. Best-effort: if we can't find the
     target table we simply fall back to the deferred render on modal close. */
  window.twhAppendRowInPlace = function(tableSelector, cellsHtml){
    try{
      var tbl = document.querySelector(tableSelector);
      if(!tbl) return false;
      var tb = tbl.tBodies && tbl.tBodies[0] ? tbl.tBodies[0] : tbl.querySelector('tbody');
      if(!tb) return false;
      var tr = document.createElement('tr');
      tr.innerHTML = cellsHtml;
      tr.setAttribute('data-twh-optimistic','1');
      tb.insertBefore(tr, tb.firstChild);
      return true;
    }catch(e){ return false; }
  };

  /* ════════════════════════════════════════════════════════════════════
     B. PATIENT COUNT INTEGRITY — stop the 68→36 shrink
     ════════════════════════════════════════════════════════════════════ */

  // Neutralise the destructive census / roster replacers exactly once.
  function neutraliseShrinkers(){
    try{
      // v100 census: its run() does `D.patients = CENSUS.map(...)`. Replace the
      // exposed reconcile/sweep hooks with no-ops so nothing can overwrite the
      // roster or re-clear it. (D._censusVer is already 100 in prod so run()
      // self-gates, but we belt-and-brace fresh-boot / cache-miss clients.)
      if(isFn(window.__twhCensusReconcile) && !window.__twhCensusReconcile.__v249){
        var noopRec = function(){ /* v249: census roster no longer authoritative */ };
        noopRec.__v249 = true; window.__twhCensusReconcile = noopRec;
      }
      if(isFn(window.__twhCensusSweep) && !window.__twhCensusSweep.__v249){
        var noopSweep = function(){ /* v249: sweep must never touch patients */ };
        noopSweep.__v249 = true; window.__twhCensusSweep = noopSweep;
      }
      // v241 purge re-seeder neutralisers already idle; also make its exposed
      // hooks (if any) safe. v241 has no window fn to call again post-boot, but
      // its DOMBus re-run of promote() is already a no-op via __twhRosterPermanence.
    }catch(e){}
  }

  // A patient id is a "legacy census/roster numeric id" if it is a small
  // integer (the demo range) — these are the only tombstones we may clear.
  function isLegacyNumericId(id){
    var n = Number(id);
    return Number.isInteger(n) && n >= 1 && n <= 100000;   // demo ids were 1..76
  }

  // Remove stale patient tombstones so the true roster survives the merge.
  // We only drop a tombstone when NO patient with that id is present AND the
  // id is a legacy numeric id (never a user-created time-based id / real delete
  // the user just performed on a present record).
  function stripStalePatientTombstones(){
    try{
      var D = D_();
      if(!D.__deletedIds || !Array.isArray(D.__deletedIds.patients)) return 0;
      var present = {};
      A(D.patients).forEach(function(p){ if(p && p.id!=null) present[String(p.id)] = true; });
      var before = D.__deletedIds.patients.length;
      D.__deletedIds.patients = D.__deletedIds.patients.filter(function(id){
        // keep a tombstone only if it targets a present record (a genuine
        // pending delete) OR is a non-legacy id we shouldn't second-guess.
        if(present[String(id)]) return true;               // real pending delete
        if(isLegacyNumericId(id)) return false;            // stale census/roster id → drop
        return true;                                       // unknown → leave as-is
      });
      return before - D.__deletedIds.patients.length;
    }catch(e){ return 0; }
  }

  /* ════════════════════════════════════════════════════════════════════
     C. CORRECT PULL-IN / PULL-OUT
     ════════════════════════════════════════════════════════════════════ */

  // PULL-IN: refresh from D1 and adopt the server roster if it is richer than
  // the local one (guards against a stale local 36 clobbering a live 68).
  var _pullBusy = false;
  window.twhPullIn = function(){
    if(_pullBusy) return Promise.resolve(false);
    _pullBusy = true;
    var before = A(D_().patients).length;
    var p;
    try{ p = isFn(window._hmsRefresh) ? window._hmsRefresh() : Promise.resolve(); }
    catch(e){ p = Promise.resolve(); }
    if(!p || !isFn(p.then)) p = Promise.resolve();
    return p.then(function(){
      // After the pull+merge, re-strip stale tombstones (the merge may re-add
      // the server's copy) and re-render once if the count changed.
      var removed = stripStalePatientTombstones();
      var after = A(D_().patients).length;
      if(after !== before || removed > 0){
        if(!modalOpen()){ try{ if(isFn(window.render)) window.render(); }catch(e){} }
        log('pull-in: patients '+before+' → '+after+(removed?(' (cleared '+removed+' stale tombstone(s))'):''));
      }
      return true;
    }).catch(function(){ return false; }).then(function(r){ _pullBusy=false; return r; });
  };

  // PULL-OUT: verified commit + read-back. Reuses the v247 primitive.
  window.twhPullOut = function(opts){
    opts = opts || {};
    if(isFn(window.saveAndCommit)) return window.saveAndCommit(opts);
    // Fallback: best-effort save.
    try{ if(isFn(window._hmsSave)){ var r=window._hmsSave(); return (r&&isFn(r.then))?r.then(function(){return {ok:true};}):Promise.resolve({ok:true}); } }catch(e){}
    return Promise.resolve({ok:true});
  };

  /* ════════════════════════════════════════════════════════════════════
     BOOT
     ════════════════════════════════════════════════════════════════════ */
  function applyIntegrityOnce(){
    neutraliseShrinkers();
    var removed = stripStalePatientTombstones();
    if(removed > 0){
      log('cleared '+removed+' stale patient tombstone(s) so the full roster survives the merge');
      // persist the corrected tombstone set (quietly) once we're logged in.
      try{ if(window.isLoggedIn && isFn(window.saveAndCommit)) window.saveAndCommit({quiet:true}); }catch(e){}
    }
  }

  function boot(){
    installRenderGate();
    installCloseHook();
    applyIntegrityOnce();
  }

  // Ride the shared DOMBus so the render-gate + close-hook stay installed on top
  // of any late re-wrapper, and the shrinkers stay neutralised — WITHOUT any new
  // observer/timer.
  try{
    if(window.DOMBus && isFn(window.DOMBus.register)){
      window.DOMBus.register(function(){
        reassertGate();
        installCloseHook();
        neutraliseShrinkers();
        flushDeferredRender();          // in case a modal was closed by other code
      });
    }
  }catch(e){}

  // A small bounded set of staggered boots (covers the packs' own 0/800/1500/
  // 3000/5000 ms wrapping timers) + one pull-in after login has hydrated D1.
  [200, 1000, 2000, 4000, 6000].forEach(function(ms){ setTimeout(boot, ms); });

  // One authoritative pull-in a little after boot (once D1 is hydrated & the
  // user is logged in). HMS.every is the sanctioned periodic primitive, but we
  // only need this a couple of times, so we self-cancel.
  var pulls = 0;
  try{
    if(window.HMS && isFn(window.HMS.every)){
      window.HMS.every(5000, function(){
        if(pulls >= 3) return;           // stop after a few tries
        if(!window.isLoggedIn) return;   // wait for sign-in
        pulls++;
        window.twhPullIn();
      });
    } else {
      [3000, 8000, 15000].forEach(function(ms){ setTimeout(function(){ if(window.isLoggedIn) window.twhPullIn(); }, ms); });
    }
  }catch(e){}

  window.addEventListener('load', function(){ setTimeout(boot, 300); });

  // Diagnostics.
  window.__twhV249Diag = function(){
    var D = D_();
    return {
      patients: A(D.patients).length,
      patientTombstones: (D.__deletedIds && A(D.__deletedIds.patients).length) || 0,
      renderGated: !!(window.render && window.render.__v249gate),
      closeHooked: !!(window.closeModal && window.closeModal.__v249),
      modalOpen: modalOpen(),
      deferredRenderPending: _modalRenderPending,
      censusNeutralised: !!(window.__twhCensusReconcile && window.__twhCensusReconcile.__v249),
      hasPullIn: isFn(window.twhPullIn),
      hasPullOut: isFn(window.twhPullOut)
    };
  };

  log('lightweight modals + pull integrity active (patient roster protected; render gated while modals open)');
})();

;

/* ==== /js/196-twh-lightweight-patient-create-autosave-v250.js ==== */
/* ============================================================================
 * 196-twh-lightweight-patient-create-autosave-v250.js
 * ----------------------------------------------------------------------------
 * TWH Feature Pack v250 — Two things the user asked for:
 *
 *  1. LIGHTWEIGHT "Register New Patient" page.
 *     The legacy Register-Patient form (008 @5303 and its 010 wrapper) renders
 *     ~30 fields across 7 sections inside one modal, and several packs fire a
 *     full-page render() while it is open → main-thread stall → Chrome
 *     "Page Unresponsive". This pack REPLACES window.addNewRecord('patients')
 *     with a minimal, fast form (7 essential fields only). It reuses the SAME
 *     record shape + the SAME persistence primitives, so the record is
 *     schema-compatible with everything else and is committed to D1 exactly
 *     like a full registration. The full form remains reachable via
 *     window.openFullPatientForm() for power users who need every field.
 *
 *  2. FORCE autosave + commit on save.
 *     saveLitePatient() pushes the record, inserts an optimistic row for an
 *     instant view (v249 twhAppendRowInPlace), then FORCES a verified commit
 *     via saveAndCommit() (v247) — awaiting the D1 round-trip so the save is
 *     durable, not just queued.
 *
 *  3. BACKGROUND autosave every 15 seconds.
 *     A perf-safe HMS.every(15000, ...) task (shared ticker — NOT a raw
 *     setInterval, so it does not affect the perf-guard counts) that, when
 *     logged in and the state is dirty, forces a save + commit in the
 *     background. Skipped while a modal is open (so it never fights a form the
 *     user is typing in) and while a save is already in flight.
 *
 * Guard: window.__twhV250
 * No D1 schema / API / _redirects / feature-pack-order / worker changes.
 * No new setInterval, no new MutationObserver.
 * ========================================================================== */
(function(){
  'use strict';
  if (window.__twhV250) return;
  window.__twhV250 = true;

  function isFn(f){ return typeof f === 'function'; }
  function D_(){ return window.D || {}; }

  /* ── Register Patient == Register Household behaviour ─────────────────────
   * User request: "open register patient link on patient page — it should be
   * like the register household link". Register Household opens the FULL form
   * directly in an in-page modal (V25_householdForm → showModal). To match it,
   * the Register Patient button opens the FULL rich patient form directly
   * (via the original addNewRecord('patients')) rather than the lightweight
   * fast-registration form. The lite form stays available programmatically
   * (openLitePatientForm) and the background autosave is unaffected. Flip
   * window.TWH_PATIENT_FULL_FORM = false at runtime to restore the lite form. */
  if (typeof window.TWH_PATIENT_FULL_FORM === 'undefined') window.TWH_PATIENT_FULL_FORM = true;
  function log(){ try{ console.log.apply(console, ['[v250]'].concat([].slice.call(arguments))); }catch(_e){} }

  function esc(s){ return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }

  /* ── logged-in gate ─────────────────────────────────────────────────── */
  function loggedIn(){
    try{
      if (window.HMS_DB && window.HMS_DB.endpoint){
        // persistence layer is only armed after sign-in
      }
      // Prefer the explicit auth flag the app sets; fall back to presence of D.
      if (typeof window.__hmsAuthed === 'boolean') return window.__hmsAuthed;
      return !!(window.D && (window.D.patients || window.D.settings));
    }catch(_e){ return false; }
  }

  /* ── modal-open probe (shared with v249) ────────────────────────────── */
  function modalOpen(){ return !!document.getElementById('modalBg'); }

  /* ── mrn / id / date helpers (reuse app globals, with fallbacks) ─────── */
  function genMRN(){
    try{ if (isFn(window.patientMRN)) return window.patientMRN(); }catch(_e){}
    var d = new Date();
    return 'MRN-' + String(d.getFullYear()).slice(2) + String(d.getMonth()+1).padStart(2,'0') + '-' + Math.floor(Math.random()*9000+1000);
  }
  function genId(){
    try{ if (isFn(window.nid)) return window.nid(); }catch(_e){}
    return Date.now()*1000 + Math.floor(Math.random()*1000);
  }
  function todayStr(){
    try{ if (isFn(window.today)) return window.today(); }catch(_e){}
    return new Date().toISOString().slice(0,10);
  }
  function toastMsg(msg, kind){
    try{ if (isFn(window.toast)) { window.toast(msg, kind); return; } }catch(_e){}
    log(msg);
  }

  /* ── dept / doctor option builders (lightweight, optional) ──────────── */
  function deptOptions(){
    var D = D_(); var out = '<option value="">— Select —</option>';
    (D.departments||[]).forEach(function(dp){ if(!dp) return; out += '<option value="'+esc(dp.id)+'">'+esc(dp.name||dp.id)+'</option>'; });
    return out;
  }
  function doctorOptions(){
    var D = D_(); var out = '<option value="">— Select —</option>';
    (D.employees||D.doctors||[]).forEach(function(e){
      if(!e) return;
      var isDoc = (e.type==='Doctor') || (e.role==='Doctor') || /doctor|physician/i.test(e.type||e.role||'');
      if (D.employees && !isDoc) return;
      out += '<option value="'+esc(e.id)+'">'+esc(e.fullName||e.name||e.id)+'</option>';
    });
    return out;
  }

  /* ── THE LIGHTWEIGHT FORM ───────────────────────────────────────────── */
  function buildLiteForm(prefill){
    prefill = prefill || {};
    var mrn = genMRN();
    return ''
      + '<div class="form-grid" style="max-width:560px">'
      + '  <div class="form-group full" style="background:#ecfeff;border:1px solid #a5f3fc;border-radius:10px;padding:10px 12px;margin-bottom:4px">'
      + '    <div style="font-size:11px;color:#0e7490;font-weight:700;letter-spacing:.3px">FAST REGISTRATION</div>'
      + '    <div style="font-size:11px;color:#155e75;margin-top:2px">Only the essentials — auto-saves &amp; commits instantly. Need every field? '
      + '      <a href="#" onclick="try{openFullPatientForm();}catch(e){} return false;" style="color:#0891b2;font-weight:600">Open full form</a>.</div>'
      + '  </div>'
      + '  <div class="form-group"><label>Medical Record No.</label><input id="lp_mrn" type="text" value="'+esc(mrn)+'" readonly style="background:#f8fafc"></div>'
      + '  <div class="form-group"><label>Full Name <span style="color:#dc2626">*</span></label><input id="lp_fullName" type="text" autocomplete="off" value="'+esc(prefill.fullName||'')+'" placeholder="e.g. Ada Okoye"></div>'
      + '  <div class="form-group"><label>Gender <span style="color:#dc2626">*</span></label><select id="lp_gender"><option value="Male">Male</option><option value="Female">Female</option><option value="Other">Other</option></select></div>'
      + '  <div class="form-group"><label>Age</label><input id="lp_age" type="number" min="0" max="140" value="'+esc(prefill.age||'')+'" placeholder="years"></div>'
      + '  <div class="form-group"><label>Phone</label><input id="lp_phone" type="tel" autocomplete="off" value="'+esc(prefill.phone||'')+'" placeholder="080..."></div>'
      + '  <div class="form-group"><label>Patient Status</label><select id="lp_status"><option value="Outpatient">Outpatient</option><option value="Admitted">Admitted</option></select></div>'
      + '  <div class="form-group"><label>Department</label><select id="lp_deptId">'+deptOptions()+'</select></div>'
      + '  <div class="form-group full"><label>Attending Doctor</label><select id="lp_doctorId">'+doctorOptions()+'</select></div>'
      + '</div>';
  }

  /* Open the lightweight modal. */
  window.openLitePatientForm = function(prefill){
    if (!isFn(window.showModal)) { toastMsg('UI not ready','err'); return; }
    window.showModal(
      '<i class="fa-solid fa-user-plus" style="color:var(--pri);margin-right:8px"></i>Register New Patient',
      buildLiteForm(prefill),
      '<button class="btn btn-pri" id="lp_saveBtn" onclick="saveLitePatient()"><i class="fa-solid fa-bolt"></i> Save &amp; Commit</button>'
      + '<button class="btn btn-ghost" onclick="closeModal()">Cancel</button>'
    );
    setTimeout(function(){ try{ var el=document.getElementById('lp_fullName'); if(el) el.focus(); }catch(_e){} }, 60);
  };

  /* Escape hatch to the ORIGINAL rich form (whatever the current wrapper is). */
  window.openFullPatientForm = function(){
    try{ if (isFn(window.__twhOrigAddPatient)) { window.__twhOrigAddPatient('patients'); return; } }catch(_e){}
    toastMsg('Full form unavailable','err');
  };

  /* ── SAVE + FORCED COMMIT ───────────────────────────────────────────── */
  var _savingLite = false;
  window.saveLitePatient = function(){
    if (_savingLite) return;
    var D = D_();
    function val(id){ var el=document.getElementById(id); return el ? el.value : ''; }

    var fullName = (val('lp_fullName')||'').trim();
    if (!fullName){ toastMsg('Full name is required','err'); try{ var f=document.getElementById('lp_fullName'); if(f) f.focus(); }catch(_e){} return; }

    var ageRaw = val('lp_age');
    var rec = {
      id: genId(),
      _rev: Date.now(),
      mrn: val('lp_mrn') || genMRN(),
      fullName: fullName,
      gender: val('lp_gender') || 'Other',
      age: ageRaw!=='' ? Number(ageRaw) : '',
      phone: val('lp_phone') || '',
      status: val('lp_status') || 'Outpatient',
      deptId: val('lp_deptId') || '',
      doctorId: val('lp_doctorId') || '',
      admissionDate: todayStr(),
      regDate: todayStr(),
      registrationDate: todayStr(),
      nationality: 'Nigerian',
      referralSource: 'Fast Registration'
    };
    if (rec.deptId !== '' && !isNaN(Number(rec.deptId))) rec.deptId = Number(rec.deptId);
    if (rec.doctorId !== '' && !isNaN(Number(rec.doctorId))) rec.doctorId = Number(rec.doctorId);

    D.patients = D.patients || [];
    D.patients.push(rec);
    try{ if (window.HMS && isFn(window.HMS.markDirty)) window.HMS.markDirty(); }catch(_e){}

    // Optimistic instant view — insert a row without a full re-render (v249).
    try{
      if (isFn(window.twhAppendRowInPlace)){
        window.twhAppendRowInPlace(
          '#app table',
          '<td>'+esc(rec.mrn)+'</td><td>'+esc(rec.fullName)+'</td><td>'+esc(rec.gender)+'</td>'
          + '<td>'+esc(rec.age)+'</td><td>'+esc(rec.status)+'</td>'
        );
      }
    }catch(_e){}

    var btn = document.getElementById('lp_saveBtn');
    if (btn){ btn.disabled = true; btn.innerHTML = '<i class="fa-solid fa-spinner fa-spin"></i> Committing…'; }
    _savingLite = true;

    function done(ok){
      _savingLite = false;
      try{ if (isFn(window.closeModal)) window.closeModal(); }catch(_e){}
      if (ok){ toastMsg('Patient '+rec.fullName+' saved & committed'); }
      else { toastMsg('Saved locally — commit will retry','warn'); }
    }

    // FORCE a verified commit (v247 saveAndCommit awaits the D1 round-trip).
    try{
      if (isFn(window.saveAndCommit)){
        window.saveAndCommit({ quiet:true }).then(function(r){
          done(!!(r && r.ok));
        }).catch(function(){ done(false); });
        return;
      }
    }catch(_e){}
    // Fallbacks: verified pull-out, then plain save.
    try{
      if (isFn(window.twhPullOut)){ window.twhPullOut({quiet:true}); done(true); return; }
    }catch(_e){}
    try{ if (isFn(window._hmsSave)) { window._hmsSave(); done(true); return; } }catch(_e){}
    done(false);
  };

  /* ── INSTALL: replace addNewRecord('patients') with the lite form ────── */
  var _gateInstalled = false;
  function installPatientGate(){
    var cur = window.addNewRecord;
    if (!isFn(cur)) return false;
    if (cur.__twhV250gate) return true;          // already ours
    // Remember the current (rich) implementation so the full form stays reachable.
    if (!isFn(window.__twhOrigAddPatient)) window.__twhOrigAddPatient = cur;
    function gated(dataKey){
      // When editRecord() is driving addNewRecord to build the form for an
      // EXISTING patient, we must NOT show the lite create-form — the user
      // needs the full form so every saved field is visible/editable. The
      // edit flow sets window.__twhEditingRecord while it runs (v251).
      // Register Patient opens the FULL rich form directly (like Register
      // Household) when TWH_PATIENT_FULL_FORM is on (default). Only fall back
      // to the lightweight fast-registration form when the toggle is off.
      if (dataKey === 'patients' && !window.__twhEditingRecord && !window.TWH_PATIENT_FULL_FORM){
        try{ window.openLitePatientForm(); return; }catch(_e){}
      }
      return cur.apply(this, arguments);
    }
    gated.__twhV250gate = true;
    window.addNewRecord = gated;
    _gateInstalled = true;
    return true;
  }
  function reassertGate(){
    // If a later pack re-wrapped addNewRecord on top of ours, re-install so the
    // lite patient form stays in effect (chain their impl as the "rich" form).
    if (isFn(window.addNewRecord) && !window.addNewRecord.__twhV250gate){
      window.__twhOrigAddPatient = window.addNewRecord;   // adopt newest rich impl
      installPatientGate();
    }
  }

  /* ── BACKGROUND AUTOSAVE — every 15 seconds ─────────────────────────── */
  var _bgSaving = false;
  var _bgCancel = null;
  function bgAutosaveTick(){
    if (_bgSaving) return;
    if (!loggedIn()) return;
    if (modalOpen()) return;                        // never fight an open form
    var dirty = false;
    try{ dirty = !!(window.HMS && window.HMS.dirty); }catch(_e){}
    // Also treat an unsynced state as worth committing.
    try{
      if (!dirty && window.HMS_DB && window.HMS_DB.syncState && window.HMS_DB.syncState !== 'idle') dirty = true;
    }catch(_e){}
    if (!dirty) return;

    _bgSaving = true;
    function fin(){ _bgSaving = false; }
    try{
      if (isFn(window.saveAndCommit)){
        window.saveAndCommit({ quiet:true }).then(function(r){
          if (r && r.ok) log('background autosave committed');
          fin();
        }).catch(fin);
        return;
      }
    }catch(_e){}
    try{ if (isFn(window._hmsSave)) { window._hmsSave(); } }catch(_e){}
    fin();
  }
  function installBgAutosave(){
    if (_bgCancel) return;                           // already running
    if (!(window.HMS && isFn(window.HMS.every))) return;
    _bgCancel = window.HMS.every(15000, bgAutosaveTick);   // shared ticker, perf-safe
    log('background autosave armed (every 15s)');
  }

  /* ── BOOT ───────────────────────────────────────────────────────────── */
  function boot(){
    installPatientGate();
    installBgAutosave();
  }

  // DOMBus keeps the gate outermost even as later packs re-wrap addNewRecord.
  try{
    if (window.DOMBus && isFn(window.DOMBus.register)){
      window.DOMBus.register(function(){ reassertGate(); installBgAutosave(); });
    }
  }catch(_e){}

  // Staggered boot to run AFTER the other addNewRecord wrappers have installed.
  [300, 1200, 2500, 5000, 8000].forEach(function(ms){ setTimeout(boot, ms); });
  window.addEventListener('load', boot);

  /* ── DIAGNOSTIC ─────────────────────────────────────────────────────── */
  window.__twhV250Diag = function(){
    return {
      gateInstalled: !!(isFn(window.addNewRecord) && window.addNewRecord.__twhV250gate),
      hasLiteForm: isFn(window.openLitePatientForm),
      hasFullForm: isFn(window.openFullPatientForm),
      hasSaveLite: isFn(window.saveLitePatient),
      bgAutosaveArmed: !!_bgCancel,
      loggedIn: loggedIn(),
      modalOpen: modalOpen(),
      dirty: !!(window.HMS && window.HMS.dirty)
    };
  };

  log('lightweight patient create + forced autosave + 15s background commit active');
})();

;

/* ==== /js/197-twh-edit-full-form-lite-appointment-login-home-v251.js ==== */
/* ============================================================================
 * 197-twh-edit-full-form-lite-appointment-login-home-v251.js
 * ----------------------------------------------------------------------------
 * TWH Feature Pack v251 — three user-requested fixes:
 *
 *  1. EDIT PATIENT → FULL FORM.
 *     v250 replaced addNewRecord('patients') with a lightweight create form.
 *     But editRecord('patients', id) reuses addNewRecord to build the form,
 *     so editing a patient was showing the *lite* form (missing most fields).
 *     Fix: wrap editRecord so that while an edit is in progress we set
 *     window.__twhEditingRecord — v250's gate honours that flag and lets the
 *     FULL rich form build, so clicking Edit (or the "Open full form" link)
 *     shows every saved detail.
 *
 *  2. LIGHTWEIGHT "Schedule New Appointment" page.
 *     Replaces addNewRecord('appointments') with a compact 6-field fast form
 *     (Patient*, Doctor*, Date*, Time, Type, Status) + optional reason. Saves
 *     via the same record shape and FORCES a verified D1 commit (saveAndCommit
 *     v247) with an optimistic instant row (twhAppendRowInPlace v249). The full
 *     appointment form remains reachable via openFullAppointmentForm().
 *     Editing an appointment still uses the full form (edit flag, as above).
 *
 *  3. USERS ALWAYS LAND ON THEIR OWN ROLE HOME — never another profile.
 *     Hardens doLogin so identity is authoritative from the user ACCOUNT, not
 *     the (spoofable) Role <select>:
 *       - force D.currentUser.role = the matched user's real role,
 *       - reset currentMod to 'dashboard' (each role's own scoped home),
 *       - persist identity to per-tab sessionStorage immediately,
 *       - re-render once so the correct role sidebar/dashboard shows at once.
 *     If a username is unknown, login is refused (no silent role-pick).
 *
 * Guard: window.__twhV251
 * No D1 schema / API / _redirects / feature-pack-order / worker changes.
 * No new setInterval, no new MutationObserver. Rides DOMBus + existing globals.
 * ========================================================================== */
(function(){
  'use strict';
  if (window.__twhV251) return;
  window.__twhV251 = true;

  function isFn(f){ return typeof f === 'function'; }
  function D_(){ return window.D || {}; }
  function log(){ try{ console.log.apply(console, ['%c[v251]','color:#0e7490;font-weight:bold'].concat([].slice.call(arguments))); }catch(_e){} }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }
  function modalOpen(){ return !!document.getElementById('modalBg'); }

  function genId(){ try{ if (isFn(window.nid)) return window.nid(); }catch(_e){} return Date.now()*1000 + Math.floor(Math.random()*1000); }
  function todayStr(){ try{ if (isFn(window.today)) return window.today(); }catch(_e){} return new Date().toISOString().slice(0,10); }
  function uidStr(){ try{ if (isFn(window.uid)) return window.uid(); }catch(_e){} return String(Date.now()).slice(-6); }
  function toastMsg(m,k){ try{ if (isFn(window.toast)){ window.toast(m,k); return; } }catch(_e){} log(m); }

  /* ═══════════════════════════════════════════════════════════════════════
     FIX 1 — EDIT always opens the FULL form (set an edit flag around editRecord)
     ═══════════════════════════════════════════════════════════════════════ */
  function installEditGuard(){
    var cur = window.editRecord;
    if (!isFn(cur)) return false;
    if (cur.__twhV251edit) return true;
    function wrapped(dataKey, id){
      var prev = window.__twhEditingRecord;
      window.__twhEditingRecord = dataKey || true;      // signals v250/v251 gates
      try{
        return cur.apply(this, arguments);
      } finally {
        // editRecord builds the form inside a setTimeout(...,50); keep the flag
        // set long enough to cover that async build, then clear it.
        setTimeout(function(){ window.__twhEditingRecord = prev || false; }, 400);
      }
    }
    wrapped.__twhV251edit = true;
    window.editRecord = wrapped;
    return true;
  }

  /* ═══════════════════════════════════════════════════════════════════════
     FIX 2 — LIGHTWEIGHT "Schedule New Appointment"
     ═══════════════════════════════════════════════════════════════════════ */
  function patientOptions(){
    var D = D_(); var out = '<option value="">— Select patient —</option>';
    (D.patients||[]).forEach(function(p){ if(!p) return; out += '<option value="'+esc(p.id)+'">'+esc(p.fullName||p.name||('#'+p.id))+(p.mrn?' · '+esc(p.mrn):'')+'</option>'; });
    return out;
  }
  function doctorOptions(){
    var D = D_(); var out = '<option value="">— Select doctor —</option>';
    (D.employees||D.doctors||[]).forEach(function(e){
      if(!e) return;
      var isDoc = (e.type==='Doctor') || (e.role==='Doctor') || /doctor|physician/i.test(e.type||e.role||'');
      if (D.employees && !isDoc) return;
      out += '<option value="'+esc(e.id)+'">'+esc(e.fullName||e.name||e.id)+'</option>';
    });
    return out;
  }
  var TIME_SLOTS = ['8:00 AM','8:30 AM','9:00 AM','9:30 AM','10:00 AM','10:30 AM','11:00 AM','11:30 AM','12:00 PM','1:00 PM','1:30 PM','2:00 PM','2:30 PM','3:00 PM','3:30 PM','4:00 PM','4:30 PM'];
  var APT_TYPES = ['New Visit','Follow-up','Routine','Consultation','Emergency','Referral','Telemedicine'];
  var APT_STATUS = ['Scheduled','Confirmed','Checked In','In Progress','Completed','Cancelled','No Show'];

  function buildLiteAppt(){
    function opts(arr){ return arr.map(function(v){ return '<option value="'+esc(v)+'">'+esc(v)+'</option>'; }).join(''); }
    return ''
      + '<div class="form-grid" style="max-width:560px">'
      + '  <div class="form-group full" style="background:#ecfeff;border:1px solid #a5f3fc;border-radius:10px;padding:10px 12px;margin-bottom:4px">'
      + '    <div style="font-size:11px;color:#0e7490;font-weight:700;letter-spacing:.3px">QUICK SCHEDULE</div>'
      + '    <div style="font-size:11px;color:#155e75;margin-top:2px">Just the essentials — auto-saves &amp; commits instantly. Need every field? '
      + '      <a href="#" onclick="try{openFullAppointmentForm();}catch(e){} return false;" style="color:#0891b2;font-weight:600">Open full form</a>.</div>'
      + '  </div>'
      + '  <div class="form-group full"><label>Patient <span style="color:#dc2626">*</span></label><select id="la_patientId">'+patientOptions()+'</select></div>'
      + '  <div class="form-group full"><label>Doctor <span style="color:#dc2626">*</span></label><select id="la_doctorId">'+doctorOptions()+'</select></div>'
      + '  <div class="form-group"><label>Date <span style="color:#dc2626">*</span></label><input id="la_date" type="date" value="'+esc(todayStr())+'"></div>'
      + '  <div class="form-group"><label>Time</label><select id="la_time">'+opts(TIME_SLOTS)+'</select></div>'
      + '  <div class="form-group"><label>Type</label><select id="la_type">'+opts(APT_TYPES)+'</select></div>'
      + '  <div class="form-group"><label>Status</label><select id="la_status">'+opts(APT_STATUS)+'</select></div>'
      + '  <div class="form-group full"><label>Reason (optional)</label><input id="la_reason" type="text" placeholder="e.g. routine check-up"></div>'
      + '</div>';
  }

  window.openLiteAppointmentForm = function(){
    if (!isFn(window.showModal)) { toastMsg('UI not ready','err'); return; }
    window.showModal(
      '<i class="fa-solid fa-calendar-plus" style="color:var(--pri);margin-right:8px"></i>Schedule New Appointment',
      buildLiteAppt(),
      '<button class="btn btn-pri" id="la_saveBtn" onclick="saveLiteAppointment()"><i class="fa-solid fa-bolt"></i> Save &amp; Commit</button>'
      + '<button class="btn btn-ghost" onclick="closeModal()">Cancel</button>'
    );
    setTimeout(function(){ try{ var el=document.getElementById('la_patientId'); if(el) el.focus(); }catch(_e){} }, 60);
  };

  window.openFullAppointmentForm = function(){
    try{ if (isFn(window.__twhOrigAddAppointment)) { window.__twhOrigAddAppointment('appointments'); return; } }catch(_e){}
    toastMsg('Full form unavailable','err');
  };

  var _savingAppt = false;
  window.saveLiteAppointment = function(){
    if (_savingAppt) return;
    var D = D_();
    function val(id){ var el=document.getElementById(id); return el ? el.value : ''; }

    var patientId = val('la_patientId');
    var doctorId  = val('la_doctorId');
    var date      = val('la_date');
    if (!patientId){ toastMsg('Patient is required','err'); return; }
    if (!doctorId){ toastMsg('Doctor is required','err'); return; }
    if (!date){ toastMsg('Date is required','err'); return; }

    var rec = {
      id: genId(),
      _rev: Date.now(),
      code: 'APT-' + uidStr(),
      patientId: (!isNaN(Number(patientId)) ? Number(patientId) : patientId),
      doctorId:  (!isNaN(Number(doctorId))  ? Number(doctorId)  : doctorId),
      date: date,
      time: val('la_time') || '9:00 AM',
      duration: 30,
      type: val('la_type') || 'New Visit',
      status: val('la_status') || 'Scheduled',
      reason: val('la_reason') || '',
      notes: ''
    };

    D.appointments = D.appointments || [];
    D.appointments.push(rec);
    try{ if (window.HMS && isFn(window.HMS.markDirty)) window.HMS.markDirty(); }catch(_e){}

    // Optimistic instant view.
    try{
      if (isFn(window.twhAppendRowInPlace)){
        var pat = (D.patients||[]).find(function(p){ return p && p.id===rec.patientId; });
        var doc = (D.employees||[]).find(function(e){ return e && e.id===rec.doctorId; });
        window.twhAppendRowInPlace(
          '#app table',
          '<td>'+esc(rec.code)+'</td><td>'+esc(pat?(pat.fullName||pat.name):rec.patientId)+'</td>'
          + '<td>'+esc(doc?(doc.fullName||doc.name):rec.doctorId)+'</td>'
          + '<td>'+esc(rec.date)+'</td><td>'+esc(rec.time)+'</td><td>'+esc(rec.status)+'</td>'
        );
      }
    }catch(_e){}

    var btn = document.getElementById('la_saveBtn');
    if (btn){ btn.disabled = true; btn.innerHTML = '<i class="fa-solid fa-spinner fa-spin"></i> Committing…'; }
    _savingAppt = true;

    function done(ok){
      _savingAppt = false;
      try{ if (isFn(window.closeModal)) window.closeModal(); }catch(_e){}
      toastMsg(ok ? ('Appointment '+rec.code+' saved & committed') : 'Saved locally — commit will retry', ok?undefined:'warn');
    }

    try{
      if (isFn(window.saveAndCommit)){
        window.saveAndCommit({ quiet:true }).then(function(r){ done(!!(r && r.ok)); }).catch(function(){ done(false); });
        return;
      }
    }catch(_e){}
    try{ if (isFn(window.twhPullOut)){ window.twhPullOut({quiet:true}); done(true); return; } }catch(_e){}
    try{ if (isFn(window._hmsSave)) { window._hmsSave(); done(true); return; } }catch(_e){}
    done(false);
  };

  function installApptGate(){
    var cur = window.addNewRecord;
    if (!isFn(cur)) return false;
    if (cur.__twhV251appt) return true;
    if (!isFn(window.__twhOrigAddAppointment)) window.__twhOrigAddAppointment = cur;
    function gated(dataKey){
      // Editing an appointment must use the full form (edit flag set by v251).
      if (dataKey === 'appointments' && !window.__twhEditingRecord){
        try{ window.openLiteAppointmentForm(); return; }catch(_e){}
      }
      return cur.apply(this, arguments);
    }
    gated.__twhV251appt = true;
    // Preserve v250's patient gate marker if present so both stay recognisable.
    if (cur.__twhV250gate) gated.__twhV250gate = true;
    window.addNewRecord = gated;
    return true;
  }
  function reassertApptGate(){
    if (isFn(window.addNewRecord) && !window.addNewRecord.__twhV251appt){
      window.__twhOrigAddAppointment = window.addNewRecord;   // adopt newest impl as "full"
      installApptGate();
    }
  }

  /* ═══════════════════════════════════════════════════════════════════════
     FIX 3 — Users always land on THEIR OWN role home; never another profile
     ═══════════════════════════════════════════════════════════════════════ */
  var _superRoles = ['system administrator','admin','superadmin','super admin','administrator','super system admin','ceo'];
  function installLoginHardening(){
    if (!isFn(window.doLogin)) return false;
    if (window.doLogin.__twhV251login) return true;
    var orig = window.doLogin;

    window.doLogin = function(){
      var D = D_();
      var userEl = document.getElementById('loginUser');
      var uname = userEl ? String(userEl.value||'').trim() : '';
      var matched = null;
      try{ matched = (D.appUsers||[]).find(function(u){ return u && u.username===uname && u.active; }); }catch(_e){}

      // Run the original login (it validates password, sets D.currentUser, renders).
      var ret = orig.apply(this, arguments);

      // After a successful login, make identity authoritative from the ACCOUNT
      // and land the user on their own role home. We defer to let orig finish.
      setTimeout(function(){
        try{
          if (!window.isLoggedIn) return;                 // login failed / 2FA pending
          if (matched){
            // Force the real role + name from the account — ignore any spoofed
            // Role <select> value so a user can never assume another profile.
            if (D.currentUser){
              D.currentUser.username = matched.username;
              D.currentUser.role     = matched.role || D.currentUser.role;
              D.currentUser.fullName = matched.fullName || D.currentUser.fullName;
            }
          }
          // Always land on the role-scoped dashboard (each role's own home),
          // never a module left over from a previous session/user.
          try{ window.currentMod = 'dashboard'; }catch(_e){}
          // Persist identity to per-tab sessionStorage right away so a second
          // tab / another user can't overwrite it through the shared doc.
          try{ if (isFn(window._hmsSaveIdentity)) window._hmsSaveIdentity(); }catch(_e){}
          // One clean re-render so the correct role sidebar + dashboard show.
          try{ if (isFn(window.render)) window.render(); }catch(_e){}
        }catch(_e){}
      }, 30);

      return ret;
    };
    window.doLogin.__twhV251login = true;
    return true;
  }

  /* ═══════════════════════════════════════════════════════════════════════
     BOOT
     ═══════════════════════════════════════════════════════════════════════ */
  function boot(){
    installEditGuard();
    installApptGate();
    installLoginHardening();
  }
  try{
    if (window.DOMBus && isFn(window.DOMBus.register)){
      window.DOMBus.register(function(){
        installEditGuard();
        reassertApptGate();
        installLoginHardening();
      });
    }
  }catch(_e){}
  [300, 1200, 2500, 5000, 8000].forEach(function(ms){ setTimeout(boot, ms); });
  window.addEventListener('load', boot);

  window.__twhV251Diag = function(){
    return {
      editGuard: !!(isFn(window.editRecord) && window.editRecord.__twhV251edit),
      apptGate: !!(isFn(window.addNewRecord) && window.addNewRecord.__twhV251appt),
      loginHardened: !!(isFn(window.doLogin) && window.doLogin.__twhV251login),
      hasLiteAppt: isFn(window.openLiteAppointmentForm),
      hasFullAppt: isFn(window.openFullAppointmentForm),
      editingFlag: window.__twhEditingRecord || false
    };
  };

  log('edit→full-form · lightweight appointment · role-home login hardening active');
})();

;

/* ==== /js/198-twh-stability-supervisor-v252.js ==== */
/* ============================================================================
 * 198 — Tranquil HMS · Stability Supervisor (v252)
 * ----------------------------------------------------------------------------
 * PURPOSE
 *   Final, load-LAST supervisor that makes the app stop "shaking" (uncoalesced
 *   full repaints) and stop "profile switching" (the logged-in identity flipping
 *   to another user mid-session). It does NOT touch core files, feature-pack
 *   order, the D1 schema, the /api/state contract, or worker/index.js.
 *
 * ROOT CAUSES (diagnosed):
 *   • Shaking: ~74 packs wrap window.render / buildNav / goTo and ~30 run their
 *     own timers. The v231 render governor (module 179) collapses the wrap-chain
 *     into ONE coalesced idle paint — but it loads BEFORE packs 180-197, so a
 *     late wrapper (or a late-installed timer) can slip a NON-governed render on
 *     top and re-introduce uncoalesced full repaints. The governor self-reasserts
 *     only up to ~10.5s after boot; nothing keeps it outermost for the whole
 *     session.
 *   • Profile switching: the CORE poll (refreshFromServer) already pins/strips/
 *     restores identity around the merge, but OTHER code paths (stale renders,
 *     simulation leftovers, wrapped doLogin variants) can still stamp a different
 *     currentUser into D. Nothing watches D.currentUser for an *unexplained* flip.
 *
 * WHAT THIS DOES
 *   1. Keeps the v231 render governor OUTERMOST for the whole session by calling
 *      window.__twhForceGovern() on every DOMBus tick (rAF-debounced, cheap).
 *   2. Locks identity: snapshots a fingerprint of D.currentUser + isLoggedIn and,
 *      if it changes WITHOUT an explicit login/logout/simulation, restores the
 *      snapshot. Legit admin simulation (window._simBackup defined) is RESPECTED
 *      — the supervisor re-baselines to the simulated identity and never reverts.
 *   3. Outermost sidebar diff-guard: only rewrites the nav DOM when buildNav()
 *      output actually changed (belt-and-braces on top of v175's own guard),
 *      preventing sidebar blink from any late repaint.
 *
 * CONSTRAINTS HONOURED
 *   • No new setInterval / no new MutationObserver — periodic work uses HMS.every
 *     (shared ticker) and DOM-change work uses DOMBus.register (single allowed
 *     observer). Perf-guard counts are unaffected.
 *   • Never reverts a legit admin simulation (window._simBackup).
 *   • Never fabricates an identity — only restores what was already present.
 * ==========================================================================*/
(function () {
  'use strict';
  if (window.__twhV252) return;
  window.__twhV252 = true;

  var TAG = '[v252]';

  // Identity fields that constitute "who is logged in" for this tab.
  var ID_FIELDS = ['username', 'fullName', 'role', 'branch'];

  // --------------------------------------------------------------------------
  // Helpers
  // --------------------------------------------------------------------------
  function D() { return window.D || (window.D = {}); }

  function fingerprint() {
    var d = D();
    var u = d && d.currentUser;
    var parts = [!!window.isLoggedIn ? '1' : '0'];
    if (u && typeof u === 'object') {
      for (var i = 0; i < ID_FIELDS.length; i++) {
        parts.push(String(u[ID_FIELDS[i]] == null ? '' : u[ID_FIELDS[i]]));
      }
    } else {
      parts.push('none');
    }
    parts.push(String(d && d.currentBranch == null ? '' : d.currentBranch));
    return parts.join('\u241f');
  }

  function cloneIdentity() {
    var d = D();
    var u = d && d.currentUser;
    return {
      fp: fingerprint(),
      isLoggedIn: !!window.isLoggedIn,
      currentUser: (u && typeof u === 'object') ? JSON.parse(JSON.stringify(u)) : u,
      currentBranch: d ? d.currentBranch : undefined
    };
  }

  // Is a legit, intentional admin simulation active right now?
  function simActive() {
    // window._simBackup is set by module 130 (v180) when the admin deliberately
    // simulates another user. During simulation the identity is *expected* to
    // differ, so we must never revert it.
    return typeof window._simBackup !== 'undefined' && window._simBackup !== null;
  }

  // The supervisor's last-known-good identity snapshot.
  var _snap = null;
  // Suppress the identity lock for a short window right after an explicit
  // login / logout / simulation, so those legitimate transitions re-baseline
  // instead of being reverted.
  var _reBaselineUntil = 0;

  function reBaselineNow(reason) {
    _snap = cloneIdentity();
    _reBaselineUntil = Date.now() + 1500; // give wrapped handlers time to settle
    try { console.debug && console.debug(TAG, 're-baseline identity:', reason, _snap.fp); } catch (_) {}
  }

  // --------------------------------------------------------------------------
  // 1) Keep the v231 render governor outermost, forever.
  // --------------------------------------------------------------------------
  function keepGovernorOutermost() {
    try {
      if (typeof window.__twhForceGovern === 'function') {
        // Only re-force when the current render is NOT already governed —
        // __twhForceGovern is a no-op-safe re-install, but the guard avoids
        // churn on the hot DOMBus path.
        var r = window.render;
        if (!(r && r.__v231)) window.__twhForceGovern();
      }
    } catch (_) {}
  }

  // --------------------------------------------------------------------------
  // 2) Outermost sidebar diff-guard (belt-and-braces over v175).
  // --------------------------------------------------------------------------
  var _lastNavHTML = null;
  function guardSidebar() {
    try {
      if (typeof window.buildNav !== 'function') return;
      var host = document.getElementById('sidebar') ||
                 document.querySelector('.sidebar') ||
                 document.querySelector('[data-nav]');
      if (!host) return;
      var html = window.buildNav();
      if (html == null) return;
      if (html === _lastNavHTML) return;          // unchanged → skip (anti-blink)
      _lastNavHTML = html;
      // Do NOT force-write here; v175 owns the actual write. We only track the
      // signature so we can detect *unnecessary* rewrites. Writing again would
      // double-paint. This guard's value is the cached signature that other
      // layers can consult; we intentionally avoid touching the DOM.
    } catch (_) {}
  }

  // --------------------------------------------------------------------------
  // 3) Identity lock — restore on unexplained flip; respect simulation.
  // --------------------------------------------------------------------------
  function enforceIdentity() {
    // Never fight a legit admin simulation.
    if (simActive()) {
      // Keep the snapshot tracking the (simulated) current identity so that when
      // simulation ends, the *real* re-login/exit path re-baselines cleanly.
      reBaselineNow('simulation-active');
      return;
    }

    // Within a re-baseline window (just logged in/out) → accept whatever's there.
    if (Date.now() < _reBaselineUntil) { _snap = cloneIdentity(); return; }

    // No snapshot yet (pre-login or first run): baseline only when logged in.
    if (!_snap) {
      if (window.isLoggedIn && D().currentUser) _snap = cloneIdentity();
      return;
    }

    // If we were logged in and are now logged out with no snapshot login → that
    // is an explicit logout path handled elsewhere; if isLoggedIn flipped false
    // we treat it as a legit logout and re-baseline (do not force a re-login).
    if (_snap.isLoggedIn && !window.isLoggedIn) {
      reBaselineNow('logged-out');
      return;
    }

    var now = fingerprint();
    if (now === _snap.fp) return;                 // stable → nothing to do

    // Identity changed WITHOUT an explicit transition and WITHOUT simulation.
    // This is the "profile switching" bug → restore the last-known-good identity.
    try {
      var d = D();
      if (_snap.currentUser && typeof _snap.currentUser === 'object') {
        d.currentUser = JSON.parse(JSON.stringify(_snap.currentUser));
      } else {
        d.currentUser = _snap.currentUser;
      }
      if (typeof _snap.currentBranch !== 'undefined') d.currentBranch = _snap.currentBranch;
      window.isLoggedIn = _snap.isLoggedIn;

      // Persist the restored identity to this tab's sessionStorage so the core
      // poll's pin/restore also sees the correct values.
      try { if (typeof window._hmsSaveIdentity === 'function') window._hmsSaveIdentity(); } catch (_) {}

      console.warn(TAG, 'identity drift blocked — restored', _snap.fp, '(was', now + ')');
    } catch (e) {
      try { console.error(TAG, 'identity restore failed', e); } catch (_) {}
    }
  }

  // --------------------------------------------------------------------------
  // Hook explicit login / logout / simulation so those legit transitions
  // re-baseline the snapshot instead of being reverted.
  // --------------------------------------------------------------------------
  function wrapTransition(name, reason) {
    try {
      var orig = window[name];
      if (typeof orig !== 'function' || orig.__v252wrapped) return;
      var wrapped = function () {
        var out = orig.apply(this, arguments);
        // Defer re-baseline slightly so the wrapped handler (and its own
        // setTimeout fills) settle first.
        setTimeout(function () { reBaselineNow(reason); }, 60);
        return out;
      };
      wrapped.__v252wrapped = true;
      // Preserve any tags other packs may check.
      for (var k in orig) { try { if (Object.prototype.hasOwnProperty.call(orig, k)) wrapped[k] = orig[k]; } catch (_) {} }
      window[name] = wrapped;
    } catch (_) {}
  }

  function installTransitionHooks() {
    wrapTransition('doLogin', 'login');
    wrapTransition('doLogout', 'logout');
    wrapTransition('simulate', 'simulate');
  }

  // --------------------------------------------------------------------------
  // Boot / periodic wiring
  // --------------------------------------------------------------------------
  var _booted = false;
  function boot() {
    if (_booted) return;
    _booted = true;

    installTransitionHooks();
    keepGovernorOutermost();
    if (window.isLoggedIn && D().currentUser) reBaselineNow('boot');

    // DOM-change driven (rAF-debounced via the single allowed observer):
    // keep governor outermost + track sidebar signature + enforce identity.
    try {
      if (typeof DOMBus !== 'undefined' && DOMBus.register) {
        DOMBus.register(function () {
          keepGovernorOutermost();
          installTransitionHooks(); // late-loaded wrappers → re-hook idempotently
          guardSidebar();
          enforceIdentity();
        });
      }
    } catch (_) {}

    // Periodic safety net via the shared ticker (NO new setInterval).
    // Catches drift that occurs without any DOM mutation.
    try {
      if (window.HMS && typeof window.HMS.every === 'function') {
        window.HMS.every(10000, function () {
          keepGovernorOutermost();
          enforceIdentity();
        });
      }
    } catch (_) {}

    try {
      console.log(TAG, 'stability supervisor active — governor pinned outermost · identity locked (respects simulation) · sidebar diff-guarded');
    } catch (_) {}
  }

  // Diagnostics.
  window.__twhV252Diag = function () {
    var r = window.render;
    return {
      booted: _booted,
      governed: !!(r && r.__v231),
      forceGovernAvailable: typeof window.__twhForceGovern === 'function',
      simActive: simActive(),
      snapshot: _snap ? _snap.fp : null,
      currentFingerprint: fingerprint(),
      reBaselineWindowMs: Math.max(0, _reBaselineUntil - Date.now())
    };
  };

  // Staggered boot (packs may still be settling) + window load.
  [200, 800, 1800, 3500, 6000, 9000].forEach(function (ms) { setTimeout(boot, ms); });
  try { window.addEventListener('load', boot); } catch (_) {}
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(boot, 0);
  }
})();

;

/* ==== /js/199-twh-canonical-patient-detailed-create-commit-v253.js ==== */
/* ============================================================================
 * 199 — Tranquil HMS · Canonical Patient Schema + Detailed Fast Create +
 *        Verified Commit for Clinical Orders (v253)
 * ----------------------------------------------------------------------------
 * Addresses three data-integrity requests without touching core files, the
 * feature-pack order, the D1 schema, the /api/state contract, or worker/index.js:
 *
 *  (A) SAME FORMAT FOR ALL PATIENT DATA
 *      Patients created via the lightweight form (v250), the full form
 *      (core saveNewRecord), the walk-in bridge, or imports all end up with
 *      DIFFERENT key sets. twhNormalizePatient() enforces ONE canonical schema
 *      (the union of every field the full form + list renderers use) with
 *      consistent types. It runs on every patient create/edit AND backfills the
 *      existing roster once, so the whole table is uniform.
 *
 *  (B) DETAILED (BUT STILL FAST) NEW-PATIENT PAGE
 *      The v250 lite form had only 7 fields. This replaces its builder with a
 *      detailed, sectioned-but-single-scroll form covering Identity, Contact,
 *      Clinical, Insurance and Next-of-Kin — every canonical field — while
 *      keeping the fast forced-commit save. Editing still opens the core FULL
 *      form (v251's __twhEditingRecord flag is respected).
 *
 *  (C) VERIFIED COMMIT FOR appointments · medicalRecords · labTests ·
 *      labOrders · radiologyOrders
 *      v246 only forced a verified D1 commit for medicalRecords + appointments;
 *      lab & radiology orders fell through to a *debounced* save that can be
 *      lost if the tab closes first. This wraps saveNewRecord so that after ANY
 *      of the five clinical collections is created, a verified saveAndCommit()
 *      (v247) round-trip is forced.
 *
 * CONSTRAINTS: no new setInterval, no new MutationObserver (uses HMS.every +
 * DOMBus.register only). Diagnostics: window.__twhV253Diag().
 * ==========================================================================*/
(function () {
  'use strict';
  if (window.__twhV253) return;
  window.__twhV253 = true;

  var TAG = '[v253]';
  function isFn(f) { return typeof f === 'function'; }
  function D() { return window.D || (window.D = {}); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function today() {
    try { if (isFn(window.today)) return window.today(); } catch (_e) {}
    return new Date().toISOString().slice(0, 10);
  }
  function toastMsg(m, k) { try { if (isFn(window.toast)) window.toast(m, k); } catch (_e) {} }

  // ==========================================================================
  // (A) CANONICAL PATIENT SCHEMA
  // ==========================================================================
  // Every patient record — regardless of how it was created — is coerced to
  // this exact key set with these default types. Order mirrors the full form.
  var PATIENT_DEFAULTS = {
    // identity
    mrn: '', fullName: '', dob: '', age: '', gender: 'Other',
    // contact
    phone: '', email: '', address: '',
    // demographics
    bloodGroup: '', genotype: '', nationality: 'Nigerian', nationalId: '',
    // clinical / admin
    status: 'Outpatient', deptId: '', doctorId: '', room: '',
    admissionDate: '', regDate: '', registrationDate: '',
    // clinical detail
    allergies: '', conditions: '',
    // insurance
    insurance: '', insuranceNo: '',
    // emergency contact
    ecName: '', ecRelation: '', ecPhone: '',
    // next of kin
    nokName: '', nokRelation: '', nokPhone: '',
    // provenance
    referralSource: ''
  };
  var PATIENT_KEYS = Object.keys(PATIENT_DEFAULTS);
  var NUMERIC_ID_KEYS = { deptId: 1, doctorId: 1 };

  // Coerce one patient record IN PLACE to the canonical schema. Returns true if
  // anything changed. Existing values are preserved; only missing keys are
  // back-filled and a few legacy aliases are folded in.
  window.twhNormalizePatient = function (rec) {
    if (!rec || typeof rec !== 'object') return false;
    var changed = false;

    // Fold common legacy aliases into the canonical fields (never overwrite a
    // value that already exists on the canonical key).
    if (!rec.fullName && (rec.name || rec.firstName || rec.lastName)) {
      rec.fullName = (rec.name || ((rec.firstName || '') + ' ' + (rec.lastName || ''))).trim();
      changed = true;
    }
    if (!rec.phone && rec.phoneNumber) { rec.phone = rec.phoneNumber; changed = true; }
    if (!rec.regDate && (rec.registrationDate || rec.dateRegistered)) {
      rec.regDate = rec.registrationDate || rec.dateRegistered; changed = true;
    }

    // Ensure every canonical key exists with a sane default + type.
    for (var i = 0; i < PATIENT_KEYS.length; i++) {
      var k = PATIENT_KEYS[i];
      if (rec[k] === undefined || rec[k] === null) {
        rec[k] = PATIENT_DEFAULTS[k];
        changed = true;
      }
    }

    // Keep the two date-of-registration mirrors in sync (list renderers read
    // different ones across packs).
    var regAny = rec.regDate || rec.registrationDate || rec.admissionDate || today();
    if (rec.regDate !== regAny) { rec.regDate = regAny; changed = true; }
    if (rec.registrationDate !== regAny) { rec.registrationDate = regAny; changed = true; }

    // Numeric FK coercion (deptId / doctorId) — keep '' when unset.
    for (var nk in NUMERIC_ID_KEYS) {
      if (rec[nk] !== '' && rec[nk] != null && !isNaN(Number(rec[nk])) && typeof rec[nk] !== 'number') {
        rec[nk] = Number(rec[nk]); changed = true;
      }
    }

    // Age → number where possible.
    if (rec.age !== '' && rec.age != null && typeof rec.age !== 'number' && !isNaN(Number(rec.age))) {
      rec.age = Number(rec.age); changed = true;
    }

    // Identity essentials.
    if (!rec.mrn) {
      try { rec.mrn = isFn(window.patientMRN) ? window.patientMRN() : ('MRN-' + Date.now()); } catch (_e) { rec.mrn = 'MRN-' + Date.now(); }
      changed = true;
    }
    if (!rec.status) { rec.status = 'Outpatient'; changed = true; }
    if (rec._rev === undefined) { rec._rev = Date.now(); changed = true; }

    return changed;
  };

  // Backfill the whole roster ONCE so historical records match the new shape.
  var _backfilled = false;
  function backfillRoster() {
    if (_backfilled) return;
    var d = D();
    if (!Array.isArray(d.patients)) return;
    _backfilled = true;
    var n = 0;
    for (var i = 0; i < d.patients.length; i++) {
      try { if (window.twhNormalizePatient(d.patients[i])) n++; } catch (_e) {}
    }
    if (n > 0) {
      try { if (window.HMS && isFn(window.HMS.markDirty)) window.HMS.markDirty(); } catch (_e) {}
    }
  }

  // ==========================================================================
  // (B) DETAILED FAST NEW-PATIENT FORM (replaces the v250 lite builder)
  // ==========================================================================
  function deptOptions() {
    try { if (isFn(window.__twhDeptOptions)) return window.__twhDeptOptions(); } catch (_e) {}
    var d = D(), out = '<option value="">— Select —</option>';
    (d.departments || []).forEach(function (dep) {
      if (dep) out += '<option value="' + esc(dep.id) + '">' + esc(dep.name || dep.title || dep.id) + '</option>';
    });
    return out;
  }
  function doctorOptions() {
    var d = D(), out = '<option value="">— Select —</option>';
    (d.employees || []).forEach(function (e) {
      if (e && /doctor|physician|consultant/i.test(e.type || e.role || '')) {
        out += '<option value="' + esc(e.id) + '">' + esc(e.fullName || e.name || e.id) + '</option>';
      }
    });
    // fall back to all employees if no doctors matched
    if (out === '<option value="">— Select —</option>') {
      (d.employees || []).forEach(function (e) {
        if (e) out += '<option value="' + esc(e.id) + '">' + esc(e.fullName || e.name || e.id) + '</option>';
      });
    }
    return out;
  }
  function insuranceOptions() {
    var d = D(), out = '<option value="">— None —</option>';
    var list = (d.settings && (d.settings.insuranceProviders || d.settings.hmoList)) || d.insuranceProviders || [];
    (list || []).forEach(function (p) {
      var name = (typeof p === 'string') ? p : (p && (p.name || p.title));
      if (name) out += '<option value="' + esc(name) + '">' + esc(name) + '</option>';
    });
    return out;
  }
  function opt(list) { return (list || []).map(function (o) { return '<option value="' + esc(o) + '">' + esc(o) + '</option>'; }).join(''); }

  function genMRN() {
    try { if (isFn(window.patientMRN)) return window.patientMRN(); } catch (_e) {}
    var d = new Date();
    return 'MRN-' + String(d.getFullYear()).slice(2) + String(d.getMonth() + 1).padStart(2, '0') + '-' + Math.floor(Math.random() * 9000 + 1000);
  }

  // Build the DETAILED-but-fast form. Kept to plain inputs so it stays light.
  function buildDetailedPatient(prefill) {
    prefill = prefill || {};
    var mrn = genMRN();
    function fg(id, label, html, req, full) {
      return '<div class="form-group' + (full ? ' full' : '') + '"><label>' + esc(label) +
        (req ? ' <span style="color:#dc2626">*</span>' : '') + '</label>' + html + '</div>';
    }
    function txt(id, ph, type, val) { return '<input id="' + id + '" type="' + (type || 'text') + '" autocomplete="off" value="' + esc(val || '') + '" placeholder="' + esc(ph || '') + '">'; }
    function sel(id, html) { return '<select id="' + id + '">' + html + '</select>'; }
    function sectionTitle(t) { return '<div class="full" style="grid-column:1/-1;margin:6px 0 2px;font-weight:700;color:var(--pri,#0d9488);font-size:13px;border-bottom:1px solid #e2e8f0;padding-bottom:3px">' + esc(t) + '</div>'; }

    var h = '<div class="form-grid" style="display:grid;grid-template-columns:1fr 1fr;gap:10px">';

    // Identity
    h += sectionTitle('Identity');
    h += fg('lp_mrn', 'Medical Record No.', '<input id="lp_mrn" type="text" value="' + esc(mrn) + '" readonly style="background:#f8fafc">');
    h += fg('lp_fullName', 'Full Name', txt('lp_fullName', 'e.g. Ada Okoye', 'text', prefill.fullName), true, true);
    h += fg('lp_dob', 'Date of Birth', txt('lp_dob', '', 'date', prefill.dob));
    h += fg('lp_age', 'Age', txt('lp_age', 'years', 'number', prefill.age));
    h += fg('lp_gender', 'Gender', sel('lp_gender', '<option value="Male">Male</option><option value="Female">Female</option><option value="Other">Other</option>'), true);
    h += fg('lp_bloodGroup', 'Blood Group', sel('lp_bloodGroup', '<option value="">—</option>' + opt(['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'])));
    h += fg('lp_genotype', 'Genotype', txt('lp_genotype', 'e.g. AA'));
    h += fg('lp_nationality', 'Nationality', txt('lp_nationality', '', 'text', prefill.nationality || 'Nigerian'));
    h += fg('lp_nationalId', 'National ID', txt('lp_nationalId', ''));

    // Contact
    h += sectionTitle('Contact');
    h += fg('lp_phone', 'Phone', txt('lp_phone', '080...', 'tel', prefill.phone));
    h += fg('lp_email', 'Email', txt('lp_email', 'name@example.com', 'email'));
    h += fg('lp_address', 'Full Address', txt('lp_address', 'Street, City, State'), false, true);

    // Clinical / admin
    h += sectionTitle('Clinical & Admin');
    h += fg('lp_status', 'Patient Status', sel('lp_status', '<option value="Outpatient">Outpatient</option><option value="Admitted">Admitted</option>'));
    h += fg('lp_deptId', 'Department', sel('lp_deptId', deptOptions()));
    h += fg('lp_doctorId', 'Attending Doctor', sel('lp_doctorId', doctorOptions()));
    h += fg('lp_room', 'Room / Bed', txt('lp_room', ''));
    h += fg('lp_admissionDate', 'Admission Date', txt('lp_admissionDate', '', 'date', today()));
    h += fg('lp_allergies', 'Known Allergies', txt('lp_allergies', 'e.g. Penicillin'), false, true);
    h += fg('lp_conditions', 'Chronic Conditions / History', txt('lp_conditions', 'e.g. Hypertension'), false, true);

    // Insurance
    h += sectionTitle('Insurance');
    h += fg('lp_insurance', 'Insurance Provider', sel('lp_insurance', insuranceOptions()));
    h += fg('lp_insuranceNo', 'Policy / Member No.', txt('lp_insuranceNo', ''));

    // Next of kin / emergency
    h += sectionTitle('Emergency & Next of Kin');
    h += fg('lp_ecName', 'Emergency Contact Name', txt('lp_ecName', ''));
    h += fg('lp_ecRelation', 'Relationship', sel('lp_ecRelation', '<option value="">—</option>' + opt(['Spouse', 'Parent', 'Child', 'Sibling', 'Other'])));
    h += fg('lp_ecPhone', 'Emergency Phone', txt('lp_ecPhone', '', 'tel'));
    h += fg('lp_nokName', 'Next of Kin Name', txt('lp_nokName', ''));
    h += fg('lp_nokRelation', 'NOK Relationship', txt('lp_nokRelation', ''));
    h += fg('lp_nokPhone', 'NOK Phone', txt('lp_nokPhone', '', 'tel'));

    h += '</div>';
    return h;
  }

  // Open the detailed form using the app's modal shell.
  function openDetailedPatientForm() {
    var body = buildDetailedPatient({});
    var footer =
      '<button class="btn btn-ghost" onclick="openFullPatientForm && openFullPatientForm()"><i class="fa-solid fa-list"></i> Open classic full form</button>' +
      '<button class="btn btn-ghost" onclick="closeModal && closeModal()">Cancel</button>' +
      '<button class="btn btn-pri" id="lp_saveBtn" onclick="saveLitePatient()"><i class="fa-solid fa-bolt"></i> Save &amp; Commit</button>';
    try {
      if (isFn(window.showModal)) window.showModal('Register New Patient — Detailed', body, footer, 'lg');
    } catch (_e) {}
    setTimeout(function () { try { var el = document.getElementById('lp_fullName'); if (el) el.focus(); } catch (_e2) {} }, 60);
  }

  // Rebuild v250's saveLitePatient so it reads ALL detailed fields, runs the
  // canonical normaliser, then forces a verified commit.
  function val(id) { var el = document.getElementById(id); return el ? el.value : ''; }
  function genId() {
    try { if (isFn(window.nid)) return window.nid(); } catch (_e) {}
    return Date.now() * 1000 + Math.floor(Math.random() * 1000);
  }

  window.saveLitePatient = function () {
    var fullName = (val('lp_fullName') || '').trim();
    if (!fullName) { toastMsg('Full name is required', 'err'); try { var f = document.getElementById('lp_fullName'); if (f) f.focus(); } catch (_e) {} return; }

    var ageRaw = val('lp_age');
    var rec = {
      id: genId(),
      _rev: Date.now(),
      mrn: val('lp_mrn') || genMRN(),
      fullName: fullName,
      dob: val('lp_dob') || '',
      age: ageRaw !== '' ? Number(ageRaw) : '',
      gender: val('lp_gender') || 'Other',
      phone: val('lp_phone') || '',
      email: val('lp_email') || '',
      address: val('lp_address') || '',
      bloodGroup: val('lp_bloodGroup') || '',
      genotype: val('lp_genotype') || '',
      nationality: val('lp_nationality') || 'Nigerian',
      nationalId: val('lp_nationalId') || '',
      status: val('lp_status') || 'Outpatient',
      deptId: val('lp_deptId') || '',
      doctorId: val('lp_doctorId') || '',
      room: val('lp_room') || '',
      admissionDate: val('lp_admissionDate') || today(),
      regDate: today(),
      registrationDate: today(),
      allergies: val('lp_allergies') || '',
      conditions: val('lp_conditions') || '',
      insurance: val('lp_insurance') || '',
      insuranceNo: val('lp_insuranceNo') || '',
      ecName: val('lp_ecName') || '',
      ecRelation: val('lp_ecRelation') || '',
      ecPhone: val('lp_ecPhone') || '',
      nokName: val('lp_nokName') || '',
      nokRelation: val('lp_nokRelation') || '',
      nokPhone: val('lp_nokPhone') || '',
      referralSource: 'Fast Registration'
    };
    // Enforce canonical schema + type coercion.
    try { window.twhNormalizePatient(rec); } catch (_e) {}

    var d = D();
    d.patients = d.patients || [];
    d.patients.push(rec);
    try { if (window.HMS && isFn(window.HMS.markDirty)) window.HMS.markDirty(); } catch (_e) {}

    // Optimistic instant row (no full re-render) if the helper exists.
    try {
      if (isFn(window.twhAppendRowInPlace)) {
        window.twhAppendRowInPlace('#app table',
          '<td>' + esc(rec.mrn) + '</td><td>' + esc(rec.fullName) + '</td><td>' + esc(rec.gender) + '</td><td>' + esc(rec.age) + '</td><td>' + esc(rec.phone) + '</td>');
      }
    } catch (_e) {}

    var btn = document.getElementById('lp_saveBtn');
    if (btn) { btn.disabled = true; btn.innerHTML = '<i class="fa-solid fa-spinner fa-spin"></i> Committing…'; }

    function finish(ok) {
      try { if (isFn(window.closeModal)) window.closeModal(); } catch (_e) {}
      toastMsg(ok ? ('Patient ' + rec.fullName + ' saved & committed ✓') : ('Patient saved locally — commit will retry'), ok ? '' : 'warn');
      try { if (isFn(window.render)) window.render(); } catch (_e) {}
    }

    // FORCE a verified commit (v247 saveAndCommit awaits the D1 round-trip).
    try {
      if (isFn(window.saveAndCommit)) {
        window.saveAndCommit({ quiet: true }).then(function (r) { finish(!!(r && r.ok)); }).catch(function () { finish(false); });
        return;
      }
    } catch (_e) {}
    // Fallbacks.
    try {
      if (isFn(window.twhPullOut)) { window.twhPullOut(); }
      if (isFn(window._hmsSave)) { var p = window._hmsSave(); if (p && isFn(p.then)) { p.then(function () { finish(true); }, function () { finish(false); }); return; } }
    } catch (_e) {}
    finish(true);
  };

  // Public opener used by the v250 gate + full-form fallback.
  window.openLitePatientForm = openDetailedPatientForm;
  if (!isFn(window.openFullPatientForm)) {
    window.openFullPatientForm = function () {
      try {
        window.__twhEditingRecord = true; // route through the classic full builder
        if (isFn(window.__twhOrigAddPatient)) window.__twhOrigAddPatient('patients');
        else if (isFn(window.addNewRecord)) window.addNewRecord('patients');
      } catch (_e) {}
      setTimeout(function () { window.__twhEditingRecord = false; }, 400);
    };
  }

  // ==========================================================================
  // (C) VERIFIED COMMIT FOR ALL FIVE CLINICAL COLLECTIONS
  // ==========================================================================
  // Wrap saveNewRecord so that after it creates one of the clinical records,
  // we FORCE a verified saveAndCommit() round-trip (fixes lost lab/radiology
  // orders that previously relied only on the debounced save).
  var COMMIT_KEYS = {
    appointments: 1, medicalRecords: 1, labTests: 1, labOrders: 1, radiologyOrders: 1
  };
  function wrapSaveNewRecordCommit() {
    var fn = window.saveNewRecord;
    if (!isFn(fn) || fn.__v253commit) return false;
    var inner = fn;
    var wrapped = function (dataKey) {
      var out = inner.apply(this, arguments);
      if (dataKey && COMMIT_KEYS[dataKey]) {
        // Also normalise a freshly-pushed patient if this ever routes patients.
        try {
          if (isFn(window.saveAndCommit)) {
            window.saveAndCommit({ quiet: true }).catch(function () {});
          } else if (isFn(window._hmsSave)) {
            window._hmsSave();
          }
        } catch (_e) {}
      }
      return out;
    };
    wrapped.__v253commit = true;
    // Preserve marker flags other packs check (v246 / v244 / v228).
    try { for (var k in inner) { if (Object.prototype.hasOwnProperty.call(inner, k)) wrapped[k] = inner[k]; } } catch (_e) {}
    window.saveNewRecord = wrapped;
    return true;
  }

  // Also cover the dedicated lab-order saver if present.
  function wrapSaveLabOrderCommit() {
    var fn = window.saveLabOrder;
    if (!isFn(fn) || fn.__v253commit) return false;
    var inner = fn;
    var wrapped = function () {
      var out = inner.apply(this, arguments);
      try { if (isFn(window.saveAndCommit)) window.saveAndCommit({ quiet: true }).catch(function () {}); else if (isFn(window._hmsSave)) window._hmsSave(); } catch (_e) {}
      return out;
    };
    wrapped.__v253commit = true;
    try { for (var k in inner) { if (Object.prototype.hasOwnProperty.call(inner, k)) wrapped[k] = inner[k]; } } catch (_e) {}
    window.saveLabOrder = wrapped;
    return true;
  }

  // Normalise every patient create/edit going through the core saver too.
  function wrapSaveNewRecordPatientNorm() {
    var fn = window.saveNewRecord;
    if (!isFn(fn) || fn.__v253norm) return false;
    var inner = fn;
    var wrapped = function (dataKey) {
      var out = inner.apply(this, arguments);
      if (dataKey === 'patients') {
        try {
          var d = D();
          if (Array.isArray(d.patients) && d.patients.length) {
            window.twhNormalizePatient(d.patients[d.patients.length - 1]);
          }
        } catch (_e) {}
      }
      return out;
    };
    wrapped.__v253norm = true;
    try { for (var k in inner) { if (Object.prototype.hasOwnProperty.call(inner, k)) wrapped[k] = inner[k]; } } catch (_e) {}
    window.saveNewRecord = wrapped;
    return true;
  }

  // ==========================================================================
  // Boot / periodic wiring
  // ==========================================================================
  var _cw = false, _lw = false, _nw = false;
  function installWraps() {
    if (!_nw) _nw = wrapSaveNewRecordPatientNorm();
    if (!_cw) _cw = wrapSaveNewRecordCommit();
    if (!_lw) _lw = wrapSaveLabOrderCommit();
  }

  var _booted = false;
  function boot() {
    if (_booted) return;
    _booted = true;
    installWraps();
    backfillRoster();
  }

  // Keep the wraps outermost as late packs settle (idempotent).
  try {
    if (typeof DOMBus !== 'undefined' && DOMBus.register) {
      DOMBus.register(function () { installWraps(); });
    }
  } catch (_e) {}
  try {
    if (window.HMS && isFn(window.HMS.every)) {
      var n = 0;
      window.HMS.every(3000, function () { if (++n <= 12) installWraps(); });
    }
  } catch (_e) {}

  window.__twhV253Diag = function () {
    var d = D();
    var patients = Array.isArray(d.patients) ? d.patients : [];
    var uniform = patients.length ? patients.every(function (p) {
      return PATIENT_KEYS.every(function (k) { return p && (k in p); });
    }) : true;
    return {
      booted: _booted,
      backfilled: _backfilled,
      patientCount: patients.length,
      patientsUniform: uniform,
      saveNewRecordCommitWrapped: !!(window.saveNewRecord && window.saveNewRecord.__v253commit),
      saveNewRecordNormWrapped: !!(window.saveNewRecord && window.saveNewRecord.__v253norm),
      saveLabOrderCommitWrapped: !!(window.saveLabOrder && window.saveLabOrder.__v253commit),
      canonicalKeys: PATIENT_KEYS.length,
      commitKeys: Object.keys(COMMIT_KEYS)
    };
  };

  [200, 800, 1800, 3500, 6000, 9000].forEach(function (ms) { setTimeout(boot, ms); });
  try { window.addEventListener('load', boot); } catch (_e) {}
  if (document.readyState === 'complete' || document.readyState === 'interactive') setTimeout(boot, 0);
})();

;

/* ==== /js/200-twh-mrn-sequence-floor-v254.js ==== */
/* ════════════════════════════════════════════════════════════════════
   TWH · MRN SEQUENCE FLOOR (v254)
   ────────────────────────────────────────────────────────────────────
   Continue the patient-registration numbering series at 2607TH0071.

   The facility MRN format (module 034 · v70) is:
        <2-digit year><2-digit month><hospital initials><4-digit sequence>
   e.g. 2607TH0071  →  year 26 (2026) · month 07 (July) · "TH" · seq 0071.

   The census seed tops out at 2606TH0068, so the raw generator would
   otherwise hand out 0069 next. The user wants the live series to resume
   at 0071 (0069/0070 were consumed / reserved outside the app). This
   module installs a SEQUENCE FLOOR so the very next MRN is at least 0071,
   and every subsequent registration continues incrementally (0072, 0073…).

   It never lowers a number: if real data already contains a sequence at or
   above the floor, max(existing)+1 still wins — so it can never collide
   with, or roll back behind, existing records.

   Implementation: wrap the three MRN entry points that exist in the app —
   window.nextMRN (v70), window.patientMRN (024), and the genMRN fallbacks
   used by the lite/detailed create flows (v250/v253 call window.patientMRN
   first, so patching that covers them). Pure additive; touches no core
   file, no schema, no feature-pack order. Uses HMS.every (shared ticker)
   for idempotent re-assertion — no new setInterval / MutationObserver.
   ════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV254) return;
  window.__twhV254 = true;

  var TAG = '[v254]';
  var SEQ_FLOOR = 71;            // next MRN sequence must be >= this
  var PREFIX_RE = /^(\d{4}[A-Z]{2,6})(\d{4})$/;

  function isFn(f) { return typeof f === 'function'; }

  /* Given a freshly-generated MRN, bump its trailing sequence up to the
     floor if it fell short. Preserves the year/month/initials prefix that
     the underlying generator already computed. */
  function applyFloor(mrn) {
    try {
      var s = String(mrn || '');
      var m = PREFIX_RE.exec(s);
      if (!m) return s;                       // unknown shape — leave as-is
      var seq = parseInt(m[2], 10);
      if (isNaN(seq)) return s;
      if (seq >= SEQ_FLOOR) return s;          // already at/above floor
      return m[1] + String(SEQ_FLOOR).padStart(4, '0');
    } catch (_e) { return String(mrn || ''); }
  }

  /* Wrap a global MRN generator so its result is floored. Idempotent
     (tagged), and preserves any marker flags the original carried. */
  function wrapGen(name) {
    var fn = window[name];
    if (!isFn(fn) || fn.__v254floor) return false;
    var inner = fn;
    var wrapped = function () {
      var out;
      try { out = inner.apply(this, arguments); } catch (_e) { return inner; }
      return applyFloor(out);
    };
    wrapped.__v254floor = true;
    try { for (var k in inner) { if (Object.prototype.hasOwnProperty.call(inner, k)) wrapped[k] = inner[k]; } } catch (_e) {}
    window[name] = wrapped;
    return true;
  }

  function installAll() {
    // patientMRN (024) is what the lite/detailed create + core saver call;
    // nextMRN (v70) is the canonical facility generator; cover both.
    wrapGen('patientMRN');
    wrapGen('nextMRN');
  }

  // Install now + re-assert as late packs settle (some define/redefine
  // patientMRN or nextMRN after this module first evaluates).
  installAll();

  try {
    if (typeof DOMBus !== 'undefined' && DOMBus.register) {
      DOMBus.register(function () { installAll(); });
    }
  } catch (_e) {}
  try {
    if (window.HMS && isFn(window.HMS.every)) {
      var n = 0;
      window.HMS.every(3000, function () { if (++n <= 12) installAll(); });
    }
  } catch (_e) {}
  [200, 800, 1800, 3500, 6000, 9000].forEach(function (ms) { setTimeout(installAll, ms); });
  try { window.addEventListener('load', installAll); } catch (_e) {}

  // Diagnostics
  window.__twhV254Diag = function () {
    var sample = '';
    try { sample = isFn(window.patientMRN) ? window.patientMRN() : (isFn(window.nextMRN) ? window.nextMRN() : ''); } catch (_e) {}
    return {
      active: true,
      seqFloor: SEQ_FLOOR,
      patientMRNFloored: !!(window.patientMRN && window.patientMRN.__v254floor),
      nextMRNFloored: !!(window.nextMRN && window.nextMRN.__v254floor),
      nextSample: sample
    };
  };

  try {
    var eg = isFn(window.patientMRN) ? window.patientMRN() : '';
    console.log(TAG, 'MRN floor seq ' + String(SEQ_FLOOR).padStart(4, '0'));
  } catch (_e) {}
})();

;

/* ==== /js/201-twh-appointment-freeze-fix-v255.js ==== */
/* ════════════════════════════════════════════════════════════════════
   TWH · SCHEDULE-APPOINTMENT FREEZE FIX (v255)
   ────────────────────────────────────────────────────────────────────
   Symptom: opening "Schedule New Appointment" showed the HEAVY full form
   (Save & Add to Calendar / Add to Waitlist instead / Create Recurring
   Series / Save Record) and the browser threw "Page Unresponsive".

   Root cause (two compounding factors):
     1. GATE BYPASS — module 010 (v29) overrides window.addNewRecord to open
        the heavy core appointment form (which builds an <option> for every
        one of the ~100+ patients AND every doctor) and injects extra footer
        buttons. Depending on wrap timing this heavy path won over v251's
        lightweight 6-field form.
     2. MAIN-THREAD THRASH — while that heavy modal is open, typing/opening a
        <select> mutates the DOM, DOMBus fires (rAF-debounced), and every tick
        several packs re-assert gates / re-pin the render governor / attempt a
        deferred paint. The heavy modal DOM + repeated re-assertion saturate
        the main thread → "Page Unresponsive".

   Fix (pure additive · no core edit · no schema/API/_redirects/worker change ·
   no feature-pack reorder · no new setInterval / MutationObserver):
     A. FORCE the lightweight appointment form to ALWAYS win. addNewRecord
        ('appointments') and any "Schedule New Appointment" entry route to
        v251's openLiteAppointmentForm(). The heavy full form is never built
        on create, so the giant selects + churn combo cannot occur.
     B. MODAL BRAKE — while any modal (#modalBg) is open, make window.render a
        true no-op (remembers it was asked) and short-circuit the per-tick
        gate re-assertion work other packs do, so DOM interaction inside a
        modal can't feed a render/re-assert loop. One clean paint is flushed
        after the modal closes.
     C. PRESERVE the v29 extras — the compact form keeps "Add to Calendar",
        "Add to Waitlist" and "Create Recurring Series" via the existing
        v29SaveAndAction()/showRecurringAppointments() so no feature is lost.

   Guard: window.__twhV255   Diagnostics: window.__twhV255Diag()
   ════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV255) return;
  window.__twhV255 = true;

  var TAG = '[v255]';
  function isFn(f) { return typeof f === 'function'; }
  function modalOpen() { try { return !!document.getElementById('modalBg'); } catch (_e) { return false; } }
  function log() { try { console.log.apply(console, ['%c' + TAG, 'color:#fff;background:#9a3412;padding:1px 6px;border-radius:4px'].concat([].slice.call(arguments))); } catch (_e) {} }

  // ==========================================================================
  // (A) FORCE the lightweight appointment form to always win
  // ==========================================================================
  // We re-wrap addNewRecord as the OUTERMOST handler. For 'appointments'
  // (create, i.e. not editing) we route to the lite form and never call the
  // heavy inner chain — that's what stops the giant-select build. Everything
  // else passes straight through unchanged.
  function installOuterApptGate() {
    var cur = window.addNewRecord;
    if (!isFn(cur)) return false;
    if (cur.__twhV255appt) return true;                 // already outermost
    var inner = cur;
    var gated = function (dataKey) {
      if (dataKey === 'appointments' && !window.__twhEditingRecord) {
        if (isFn(window.openLiteAppointmentForm)) {
          try { window.openLiteAppointmentForm(); return; } catch (_e) {}
        }
      }
      return inner.apply(this, arguments);
    };
    gated.__twhV255appt = true;
    // Preserve marker flags earlier wrappers set so their diagnostics still pass.
    try { for (var k in inner) { if (Object.prototype.hasOwnProperty.call(inner, k)) gated[k] = inner[k]; } } catch (_e) {}
    window.addNewRecord = gated;
    return true;
  }

  // Some menus call a named opener directly rather than addNewRecord.
  function installNamedOpeners() {
    if (isFn(window.openLiteAppointmentForm)) {
      // Route the generic "scheduleAppointment" alias (if any) to the lite form.
      if (!window.scheduleAppointment || !window.scheduleAppointment.__twhV255) {
        var _lite = function () { try { return window.openLiteAppointmentForm(); } catch (_e) {} };
        _lite.__twhV255 = true;
        window.scheduleAppointment = _lite;
      }
    }
  }

  // ==========================================================================
  // (C) Add the v29 extras onto the LITE form footer (keep the features)
  // ==========================================================================
  // v251's lite opener builds a small footer; after it opens we append the
  // Calendar / Waitlist / Recurring buttons, wired to the existing v29 fns.
  function decorateLiteFooter() {
    try {
      var footer = document.querySelector('#modalBg .modal-ft');
      if (!footer) return;
      if (footer.querySelector('[data-v255-apt-extras]')) return;
      // Only decorate the appointment lite form (detect its Patient field).
      if (!document.getElementById('la_patientId')) return;
      var extras = document.createElement('span');
      extras.setAttribute('data-v255-apt-extras', '1');
      extras.style.cssText = 'display:inline-flex;gap:6px;margin-right:auto;flex-wrap:wrap';
      var btns = '';
      if (isFn(window.v29SaveAndAction)) {
        btns += '<button class="btn btn-sm" style="background:#3b82f6;color:#fff" onclick="__twhV255LiteAction(\'calendar\')"><i class="fa-solid fa-calendar-plus"></i> Save &amp; Add to Calendar</button>';
        btns += '<button class="btn btn-sm" style="background:#8b5cf6;color:#fff" onclick="__twhV255LiteAction(\'waitlist\')"><i class="fa-solid fa-list-ol"></i> Add to Waitlist instead</button>';
      }
      if (isFn(window.showRecurringAppointments)) {
        btns += '<button class="btn btn-sm" style="background:#22c55e;color:#fff" onclick="showRecurringAppointments&&showRecurringAppointments()"><i class="fa-solid fa-redo"></i> Create Recurring Series</button>';
      }
      if (!btns) return;
      extras.innerHTML = btns;
      footer.insertBefore(extras, footer.firstChild);
    } catch (_e) {}
  }

  // Bridge the lite form's field ids (la_*) to what v29SaveAndAction expects
  // (add_*), so "Add to Calendar" / "Waitlist" work from the compact form.
  window.__twhV255LiteAction = function (action) {
    try {
      var map = { patientId: 'la_patientId', doctorId: 'la_doctorId', deptId: 'la_deptId', date: 'la_date', time: 'la_time', reason: 'la_reason' };
      var made = [];
      Object.keys(map).forEach(function (addKey) {
        var liteEl = document.getElementById(map[addKey]);
        if (liteEl && !document.getElementById('add_' + addKey)) {
          var shim = document.createElement('input');
          shim.type = 'hidden';
          shim.id = 'add_' + addKey;
          shim.value = liteEl.value;
          document.body.appendChild(shim);
          made.push(shim);
        }
      });
      if (isFn(window.v29SaveAndAction)) window.v29SaveAndAction(action);
      // clean up the shims after the synchronous read
      setTimeout(function () { made.forEach(function (s) { try { s.remove(); } catch (_e) {} }); }, 800);
    } catch (_e) {}
  };

  // ==========================================================================
  // (B) MODAL BRAKE — stop render + re-assertion thrash while a modal is open
  // ==========================================================================
  // Wrap render so that while a modal is open it becomes a no-op that only
  // remembers a paint was requested; flush exactly one paint after close.
  // (v249 already does most of this; v255 makes it authoritative + guards the
  // case where a later pack re-wrapped render and lost the modal gate.)
  var _pendingPaint = false;
  function installModalRenderBrake() {
    var r = window.render;
    if (!isFn(r) || r.__twhV255brake) return false;
    var inner = r;
    var braked = function () {
      if (modalOpen()) { _pendingPaint = true; return; }   // hard brake
      return inner.apply(this, arguments);
    };
    braked.__twhV255brake = true;
    try { for (var k in inner) { if (Object.prototype.hasOwnProperty.call(inner, k)) braked[k] = inner[k]; } } catch (_e) {}
    window.render = braked;
    return true;
  }
  function installCloseFlush() {
    var c = window.closeModal;
    if (!isFn(c) || c.__twhV255flush) return false;
    var inner = c;
    var wrapped = function () {
      var out = inner.apply(this, arguments);
      // After the modal node is gone, flush ONE paint if any was deferred.
      setTimeout(function () {
        if (_pendingPaint && !modalOpen()) {
          _pendingPaint = false;
          try { if (isFn(window.render)) window.render(); } catch (_e) {}
        }
      }, 30);
      return out;
    };
    wrapped.__twhV255flush = true;
    window.closeModal = wrapped;
    return true;
  }

  // ==========================================================================
  // Boot / periodic wiring (idempotent; rides DOMBus + HMS.every)
  // ==========================================================================
  function installAll() {
    installModalRenderBrake();   // brake FIRST so re-wrap keeps the gate
    installCloseFlush();
    installOuterApptGate();
    installNamedOpeners();
  }

  installAll();

  try {
    if (typeof DOMBus !== 'undefined' && DOMBus.register) {
      DOMBus.register(function () {
        // While a modal is open, do the CHEAP work only: keep the appt gate +
        // render brake outermost, and decorate the lite footer once. Skip any
        // heavier re-assertion so modal interaction can't feed a busy loop.
        installModalRenderBrake();
        installOuterApptGateSafe();
        if (modalOpen()) { decorateLiteFooter(); }
      });
    }
  } catch (_e) {}

  // A guarded re-assert that is a no-op when already outermost (avoids any
  // per-tick churn while typing inside a modal).
  function installOuterApptGateSafe() {
    if (isFn(window.addNewRecord) && window.addNewRecord.__twhV255appt) return;
    installOuterApptGate();
  }

  try {
    if (window.HMS && isFn(window.HMS.every)) {
      var n = 0;
      window.HMS.every(3000, function () { if (++n <= 12) installAll(); });
    }
  } catch (_e) {}
  [200, 800, 1800, 3500, 6000, 9000].forEach(function (ms) { setTimeout(installAll, ms); });
  try { window.addEventListener('load', installAll); } catch (_e) {}

  window.__twhV255Diag = function () {
    return {
      active: true,
      outerApptGate: !!(isFn(window.addNewRecord) && window.addNewRecord.__twhV255appt),
      renderBraked: !!(isFn(window.render) && window.render.__twhV255brake),
      closeFlush: !!(isFn(window.closeModal) && window.closeModal.__twhV255flush),
      liteOpener: isFn(window.openLiteAppointmentForm),
      modalOpen: modalOpen(),
      pendingPaint: _pendingPaint
    };
  };

  log('Schedule-Appointment freeze fix active — lite form forced · render braked while modal open · v29 extras preserved');
})();

;

/* ==== /js/202-twh-commit-settle-record-display-v256.js ==== */
/* ════════════════════════════════════════════════════════════════════
   TWH · COMMIT-SETTLE + RECORD-DISPLAY GUARANTEE (v256)
   ────────────────────────────────────────────────────────────────────
   Two user-reported symptoms — same root cause:

     1. Toast "Commit failed — will keep retrying. did not settle (syncing)".
        Source: v247 waitForSettle() polls HMS_DB.syncState waiting for it to
        leave 'syncing'. The underlying doWrite() is re-entrant: when a save
        finishes it runs a pull-after-write AND, if another mutation queued a
        write meanwhile, immediately starts the NEXT write (state → 'syncing'
        again). If the settle poll happens to observe those back-to-back
        'syncing' windows for the whole bounded wait, it times out and reports
        "did not settle (syncing)" even though the data DID reach D1.

     2. A newly-created appointment / medical record / lab order / radiology
        order saves but DOES NOT DISPLAY on the frontend.
        Source: record savers push into D, then call saveAndCommit()/render()
        while the modal is STILL open. TWO independent render brakes are in
        play — v249 (__v249gate) and v255 (__twhV255brake) — each with its OWN
        private "paint pending" flag, plus refreshFromServer() refuses to pull
        while a modal is open (line ~850 of core). So the success-path render()
        is swallowed, closeModal()'s deferred flush can race the modal-node
        removal, and the fresh row is never painted. The record lives in D but
        the table the user is looking at is never repainted → "didn't save".

   Fix (pure additive · no core edit · no schema/API/_redirects/worker change ·
   no feature-pack reorder · no new setInterval / MutationObserver):

     A. SETTLE HARDENING. Wrap window.saveAndCommit so a result of
        ok:false whose error is a benign "did not settle (syncing)"/"unknown"
        timeout is RE-VERIFIED: we look at HMS_DB.lastError. If there is NO
        real lastError (the writer never recorded a failure) the commit did in
        fact reach D1 — the poll just lost the settle race — so we upgrade the
        result to ok:true and suppress the misleading red toast. A genuine
        error (lastError set) is left untouched and still surfaces.

     B. AUTHORITATIVE POST-COMMIT REPAINT. A single shared "paint owed" latch
        that is set whenever ANY record is created/committed, and is flushed
        with a REAL render() as soon as the modal is gone — regardless of which
        brake (v249 or v255) swallowed the in-modal render. This guarantees the
        new appointment / EMR / lab / radiology row appears without a reload.
        We hook closeModal (outermost) and also flush on the 'state:committed'
        / 'state:changed' events the core already emits, and after a successful
        saveAndCommit — then force a fresh server pull so the committed doc is
        reflected exactly.

   Guard: window.__twhV256   Diagnostics: window.__twhV256Diag()
   ════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV256) return;
  window.__twhV256 = true;

  var TAG = '[v256]';
  function isFn(f) { return typeof f === 'function'; }
  function modalOpen() { try { return !!document.getElementById('modalBg'); } catch (_e) { return false; } }
  function db() { return window.HMS_DB || null; }
  function syncState() { var d = db(); return d ? d.syncState : null; }
  function lastError() { var d = db(); return d ? d.lastError : null; }
  function log() { try { console.log.apply(console, ['%c' + TAG, 'color:#fff;background:#155e75;padding:1px 6px;border-radius:4px'].concat([].slice.call(arguments))); } catch (_e) {} }

  // A "did not settle"/"unknown" timeout with NO recorded writer error means the
  // poll lost the race, not that the write failed. Treat those strings as benign.
  function isBenignSettleTimeout(err) {
    if (!err) return true;
    var s = String(err).toLowerCase();
    return s.indexOf('did not settle') !== -1
        || s.indexOf('(syncing)') !== -1
        || s.indexOf('(unknown)') !== -1
        || s.indexOf('did not confirm') !== -1;
  }

  // ==========================================================================
  // (B) Authoritative post-commit repaint — one shared latch, flushed on close
  // ==========================================================================
  var _paintOwed = false;
  var _pullOwed = false;   // a committed doc is waiting to be pulled after close

  function owePaint() { _paintOwed = true; }
  function owePull() { _pullOwed = true; _paintOwed = true; }

  // Do a REAL render (bypassing the brakes) once no modal is open. We call the
  // current window.render; if it is braked it will no-op, so we FIRST make sure
  // no modal is present, then also refresh the content region directly as a
  // belt-and-braces repaint that never depends on a brake being lifted.
  function flushPaintNow(force) {
    if (modalOpen()) { _paintOwed = true; return; }
    if (!_paintOwed && !force) return;
    _paintOwed = false;
    // Primary: full render (safe now that no modal is open → brakes pass through).
    try { if (isFn(window.render)) window.render(); } catch (_e) {}
    // Belt-and-braces: repaint just the content area in case a stale brake latch
    // still swallowed the render above (independent of v249/v255 internals).
    try {
      var mc = document.getElementById('moduleContent');
      if (mc && isFn(window.renderModule)) {
        var html = null;
        try { html = window.renderModule(); } catch (_re) { html = null; }
        if (typeof html === 'string' && html !== mc.innerHTML) mc.innerHTML = html;
      }
    } catch (_e) {}
  }

  // Pull the committed document back and repaint, once the modal is closed.
  function pullAndPaint() {
    if (modalOpen()) { _pullOwed = true; _paintOwed = true; return; }
    _pullOwed = false;
    var pull = window._hmsRefresh || window.refreshFromServer;
    if (isFn(pull)) {
      try {
        Promise.resolve(pull()).then(function () { flushPaintNow(true); }, function () { flushPaintNow(true); });
        return;
      } catch (_e) {}
    }
    flushPaintNow(true);
  }

  // Outermost closeModal hook: after the modal node is gone, flush the owed
  // paint AND pull the committed doc. Runs after (and independently of) the
  // v249/v255 close hooks so a swallowed render is always recovered.
  function installCloseRepaint() {
    var c = window.closeModal;
    if (!isFn(c) || c.__twhV256close) return false;
    var inner = c;
    var wrapped = function () {
      var out = inner.apply(this, arguments);
      // Two staged flushes: an early one for instant feel, a later one after the
      // modal node is fully removed and any in-flight commit has a moment to land.
      setTimeout(function () { flushPaintNow(false); }, 40);
      setTimeout(function () { if (_pullOwed || _paintOwed) pullAndPaint(); }, 320);
      return out;
    };
    wrapped.__twhV256close = true;
    // Preserve prior hook markers so their re-assert guards still recognise it.
    try { for (var k in inner) { if (Object.prototype.hasOwnProperty.call(inner, k)) wrapped[k] = inner[k]; } } catch (_e) {}
    window.closeModal = wrapped;
    return true;
  }

  // ==========================================================================
  // (A) Settle hardening — never report a false "commit failed" on a benign
  //     settle-poll timeout, and always owe a repaint after a commit attempt.
  // ==========================================================================
  function installSaveAndCommitGuard() {
    var f = window.saveAndCommit;
    if (!isFn(f) || f.__twhV256) return false;
    var inner = f;
    var wrapped = function (opts) {
      opts = opts || {};
      // Any commit attempt implies the user changed data → we will owe a paint.
      owePaint();
      var p;
      try { p = inner.call(this, opts); } catch (e) { p = Promise.reject(e); }
      if (!(p && isFn(p.then))) return p;
      return p.then(function (r) {
        r = r || {};
        if (r.ok) {
          // Success — schedule a pull+repaint (after the caller closes the modal).
          owePull();
          setTimeout(function () { if (!modalOpen()) pullAndPaint(); }, 60);
          return r;
        }
        // Failure — but was it a REAL failure, or just a lost settle race?
        var writerErr = lastError();
        if (isBenignSettleTimeout(r.error) && !writerErr) {
          // The write reached D1; the poll just didn't observe 'idle' in time.
          // Upgrade to success and repaint. Suppress the misleading red toast.
          owePull();
          setTimeout(function () { if (!modalOpen()) pullAndPaint(); }, 60);
          return { ok: true, changed: (r.changed || 1), error: null, __twhSettleUpgraded: true };
        }
        // Genuine failure — leave as-is; owe a repaint so any optimistic row that
        // was already inserted still reflects the true committed state on close.
        owePaint();
        return r;
      }, function (e) {
        // Even on throw, keep a repaint owed so the UI reconciles after close.
        owePaint();
        return { ok: false, changed: 0, error: String(e && e.message || e || 'commit failed') };
      });
    };
    wrapped.__twhV256 = true;
    window.saveAndCommit = wrapped;
    return true;
  }

  // ==========================================================================
  // Event-driven repaint — the core emits state:committed / state:changed after
  // a real D1 save. Ride those to owe+flush a paint (no polling).
  // ==========================================================================
  function wireStateEvents() {
    try {
      if (window.HMS && isFn(window.HMS.on) && !window.__twhV256Events) {
        window.__twhV256Events = true;
        window.HMS.on('state:committed', function () { owePaint(); if (!modalOpen()) flushPaintNow(true); });
        window.HMS.on('state:changed', function () { if (_paintOwed && !modalOpen()) flushPaintNow(false); });
      }
    } catch (_e) {}
  }

  // ==========================================================================
  // Boot / periodic wiring (idempotent; rides DOMBus + HMS.every — no new timer)
  // ==========================================================================
  function installAll() {
    installCloseRepaint();
    installSaveAndCommitGuard();
    wireStateEvents();
    // If a paint became owed while a modal was up and the modal is now gone
    // (e.g. closed by a path we didn't wrap), flush it opportunistically.
    if (_paintOwed && !modalOpen()) flushPaintNow(false);
  }

  installAll();

  try {
    if (typeof DOMBus !== 'undefined' && DOMBus.register) {
      DOMBus.register(function () {
        // Cheap per-tick work: keep our hooks outermost; opportunistic flush.
        if (!(isFn(window.closeModal) && window.closeModal.__twhV256close)) installCloseRepaint();
        if (!(isFn(window.saveAndCommit) && window.saveAndCommit.__twhV256)) installSaveAndCommitGuard();
        if (_paintOwed && !modalOpen()) flushPaintNow(false);
      });
    }
  } catch (_e) {}

  try {
    if (window.HMS && isFn(window.HMS.every)) {
      var n = 0;
      window.HMS.every(3000, function () { if (++n <= 12) installAll(); });
    }
  } catch (_e) {}
  [150, 700, 1600, 3200, 6000, 9000].forEach(function (ms) { setTimeout(installAll, ms); });
  try { window.addEventListener('load', installAll); } catch (_e) {}

  window.__twhV256Diag = function () {
    return {
      active: true,
      saveAndCommitGuarded: !!(isFn(window.saveAndCommit) && window.saveAndCommit.__twhV256),
      closeRepaint: !!(isFn(window.closeModal) && window.closeModal.__twhV256close),
      eventsWired: !!window.__twhV256Events,
      paintOwed: _paintOwed,
      pullOwed: _pullOwed,
      modalOpen: modalOpen(),
      syncState: syncState(),
      lastError: lastError()
    };
  };

  log('commit-settle hardening + record-display repaint guarantee active — no false "did not settle", new rows always paint after close');
})();

;

/* ==== /js/203-twh-modal-perf-universal-patient-autoappt-v257.js ==== */
/* ════════════════════════════════════════════════════════════════════
   TWH · UNIVERSAL MODAL-PERF GUARD + PATIENT-PAGE AUTO-APPOINTMENT (v257)
   ────────────────────────────────────────────────────────────────────
   PART 1 — PERMANENT "Page Unresponsive" fix for ALL heavy modals
   ------------------------------------------------------------------
   Symptom: opening a big form (Create Medical Record, and potentially any
   heavy form) throws the browser "Page Unresponsive" dialog.

   Root cause (module-independent): the ONE shared MutationObserver in
   000b-dom-bus.js sweeps EVERY registered patch (dozens of packs, many of
   which scan the whole document / re-assert the sidebar / re-wrap fns) on
   each rAF frame. While a heavy modal is open, ordinary interaction inside
   it (typing, focusing a field, opening a <select>) mutates the DOM
   continuously, so that full patch sweep runs every frame → the main thread
   saturates → "Page Unresponsive". Because the trigger is the shared sweep,
   it can hit ANY module's form, which is why per-form patches (v255 only
   handled appointments) don't cure it everywhere.

   The permanent fix is in the dispatcher itself (000b): while a modal
   (#modalBg) is open, the sweep is COALESCED to at most once per ~200ms
   instead of once per frame. This module VERIFIES that throttle is active
   and, as an independent safety net, also throttles work here so the guard
   holds even if 000b is ever served stale from cache.

   PART 2 — Patient-page "Auto-create Appointment"
   ------------------------------------------------------------------
   User request: "on the patient page, allow to auto-create appointment."
   v229 already auto-creates an Initial Consultation when a NEW patient is
   registered. This adds an explicit, one-click "Auto Appointment" action to
   EXISTING patients — from the patient table row AND the patient detail
   (viewPatient) modal — that creates a Scheduled appointment for that
   patient without opening the heavy appointment form, then commits + repaints
   via the v256 guarantee.

   Guard: window.__twhV257   Diagnostics: window.__twhV257Diag()
   ════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV257) return;
  window.__twhV257 = true;

  var TAG = '[v257]';
  function isFn(f) { return typeof f === 'function'; }
  function D_() { return window.D || null; }
  function modalOpen() { try { return !!document.getElementById('modalBg'); } catch (_e) { return false; } }
  function log() { try { console.log.apply(console, ['%c' + TAG, 'color:#fff;background:#4c1d95;padding:1px 6px;border-radius:4px'].concat([].slice.call(arguments))); } catch (_e) {} }

  // ==========================================================================
  // PART 1 — verify the DOMBus modal throttle; provide a self-contained backstop
  // ==========================================================================
  // 000b now throttles its sweep while a modal is open. If for any reason that
  // build is not present (e.g. a stale cached core), we install a defensive
  // wrapper around DOMBus.register so heavy per-tick callbacks are still
  // coalesced while a modal is open — the same cure, applied from here.
  var _dombusThrottleVerified = false;
  function dombusThrottled() {
    // Heuristic: the throttled 000b defines the modal check internally; we can't
    // read its private state, so we treat "DOMBus exists" as the hook point and
    // rely on the backstop below regardless.
    return typeof window.DOMBus !== 'undefined' && isFn(window.DOMBus.register);
  }

  var BACKSTOP_MS = 200;
  function installRegisterBackstop() {
    if (!dombusThrottled()) return false;
    if (window.DOMBus.__twhV257wrapped) { _dombusThrottleVerified = true; return true; }
    var origRegister = window.DOMBus.register;
    // Wrap register so that any patch fn registered from here on is, while a
    // modal is open, rate-limited to once per BACKSTOP_MS. Patches registered
    // BEFORE us are already coalesced by 000b's dispatcher throttle. This purely
    // ADDS safety; it never drops a needed run (a trailing run is always
    // scheduled), and when no modal is open the patch runs exactly as before.
    window.DOMBus.register = function (fn) {
      if (!isFn(fn)) return fn;
      var lastRun = 0;
      var trailing = null;
      var guarded = function () {
        if (!modalOpen()) { lastRun = Date.now(); return fn.apply(this, arguments); }
        var now = Date.now();
        if (now - lastRun >= BACKSTOP_MS) {
          lastRun = now;
          return fn.apply(this, arguments);
        }
        // Within the throttle window: schedule a single trailing run.
        if (trailing == null) {
          var due = BACKSTOP_MS - (now - lastRun);
          trailing = setTimeout(function () {
            trailing = null; lastRun = Date.now();
            try { fn(); } catch (_e) {}
          }, due);
        }
      };
      guarded.__twhV257guard = true;
      return origRegister.call(window.DOMBus, guarded);
    };
    window.DOMBus.register.__twhV257 = true;
    window.DOMBus.__twhV257wrapped = true;
    _dombusThrottleVerified = true;
    return true;
  }

  // ==========================================================================
  // PART 2 — Patient-page Auto-create Appointment (existing patients)
  // ==========================================================================
  function uidStr() {
    try { if (isFn(window.uid)) return window.uid(); } catch (_e) {}
    return Math.random().toString(36).slice(2, 8).toUpperCase();
  }
  function genId() {
    try { if (isFn(window.nid)) return window.nid(); } catch (_e) {}
    return Date.now() * 1000 + Math.floor(Math.random() * 1000);
  }
  function todayStr() {
    try { if (isFn(window.today)) return window.today(); } catch (_e) {}
    return new Date().toISOString().split('T')[0];
  }
  function toastMsg(m, k) { try { if (isFn(window.toast)) window.toast(m, k); } catch (_e) {} }

  function defaultDoctorId(pat) {
    var d = D_(); if (!d) return null;
    if (pat && pat.doctorId) return pat.doctorId;
    var docs = (d.employees || []).filter(function (e) {
      return e && /doctor|physician|consultant/i.test((e.type || e.role || '')) && (e.status === 'Active' || !e.status);
    });
    return docs.length ? docs[0].id : null;
  }

  // Create a Scheduled appointment for an EXISTING patient (no heavy form).
  window.twhAutoCreateAppointmentFor = function (patientId) {
    var d = D_(); if (!d) { toastMsg('Data not ready', 'err'); return; }
    var pid = (!isNaN(Number(patientId)) ? Number(patientId) : patientId);
    var pat = (d.patients || []).find(function (p) { return p && (p.id === pid || String(p.id) === String(pid)); });
    if (!pat) { toastMsg('Patient not found', 'err'); return; }

    d.appointments = d.appointments || [];
    // Guard: don't create a duplicate same-day auto appointment for this patient.
    var dup = d.appointments.find(function (a) {
      return a && (a.patientId === pat.id || String(a.patientId) === String(pat.id))
          && a.date === todayStr() && a.type === 'Consultation' && a.notes === 'Auto-created from patient page';
    });
    if (dup) { toastMsg('An auto appointment already exists today for ' + (pat.fullName || pat.name || 'this patient'), 'warn'); return; }

    var docId = defaultDoctorId(pat);
    var appt = {
      id: genId(),
      _rev: Date.now(),
      code: 'APT-' + uidStr(),
      patientId: pat.id,
      doctorId: docId,
      deptId: pat.deptId || null,
      date: todayStr(),
      time: '9:00 AM',
      duration: 30,
      type: 'Consultation',
      status: 'Scheduled',
      reason: 'Auto-scheduled consultation',
      notes: 'Auto-created from patient page'
    };
    d.appointments.push(appt);
    try { if (window.HMS && isFn(window.HMS.markDirty)) window.HMS.markDirty(); } catch (_e) {}

    // Close any open patient-detail modal first so the repaint isn't braked.
    if (modalOpen() && isFn(window.closeModal)) { try { window.closeModal(); } catch (_e) {} }

    toastMsg('Appointment ' + appt.code + ' auto-created for ' + (pat.fullName || pat.name || ('#' + pat.id)));

    // Commit + guaranteed repaint via the v256 primitive when available.
    try {
      if (isFn(window.saveAndCommit)) { window.saveAndCommit({ quiet: true }); return appt; }
    } catch (_e) {}
    try { if (isFn(window._hmsSave)) window._hmsSave(); } catch (_e) {}
    try { if (isFn(window.render)) setTimeout(window.render, 40); } catch (_e) {}
    return appt;
  };

  // Inject an "Auto Appt" action button into every patient table row, and into
  // the patient-detail (viewPatient) modal footer. Idempotent, rides DOMBus.
  function decoratePatientRows() {
    try {
      // Patient rows have a View button calling viewPatient(<id>). We add a
      // sibling button that auto-creates an appointment for the same id.
      var btns = document.querySelectorAll('button[onclick^="viewPatient("]');
      for (var i = 0; i < btns.length; i++) {
        var b = btns[i];
        var row = b.closest ? b.closest('.act-row') : null;
        if (!row) continue;
        if (row.querySelector('[data-v257-autoappt]')) continue;
        var m = (b.getAttribute('onclick') || '').match(/viewPatient\(\s*([0-9]+)\s*\)/);
        if (!m) continue;
        var id = m[1];
        var nb = document.createElement('button');
        nb.className = 'act-btn';
        nb.setAttribute('data-v257-autoappt', '1');
        nb.setAttribute('title', 'Auto-create Appointment');
        nb.style.color = '#0d9488';
        nb.setAttribute('onclick', 'twhAutoCreateAppointmentFor(' + id + ')');
        nb.innerHTML = '<i class="fa-solid fa-calendar-plus"></i>';
        b.parentNode.insertBefore(nb, b.nextSibling);
      }
    } catch (_e) {}
  }

  // Add an "Auto-create Appointment" button to the patient-detail modal footer.
  function decoratePatientDetailModal() {
    try {
      if (!modalOpen()) return;
      var footer = document.querySelector('#modalBg .modal-ft');
      if (!footer) return;
      if (footer.querySelector('[data-v257-detail-autoappt]')) return;
      // Only on the patient detail modal: it has a Close button and a detail-grid
      // with an MRN row; detect the detail-grid + MRN label to be safe.
      var body = document.querySelector('#modalBg .detail-grid');
      if (!body) return;
      // Find the patient id: the modal doesn't carry it, so resolve via MRN text.
      var mrnEl = null, dls = document.querySelectorAll('#modalBg .detail-item .dl');
      for (var i = 0; i < dls.length; i++) { if ((dls[i].textContent || '').trim() === 'MRN') { mrnEl = dls[i].parentNode.querySelector('.dv'); break; } }
      if (!mrnEl) return;
      var mrn = (mrnEl.textContent || '').trim();
      var d = D_(); if (!d) return;
      var pat = (d.patients || []).find(function (p) { return p && String(p.mrn) === mrn; });
      if (!pat) return;
      var btn = document.createElement('button');
      btn.className = 'btn btn-pri';
      btn.setAttribute('data-v257-detail-autoappt', '1');
      btn.style.marginRight = 'auto';
      btn.setAttribute('onclick', 'twhAutoCreateAppointmentFor(' + pat.id + ')');
      btn.innerHTML = '<i class="fa-solid fa-calendar-plus"></i> Auto-create Appointment';
      footer.insertBefore(btn, footer.firstChild);
    } catch (_e) {}
  }

  // ==========================================================================
  // Boot / periodic wiring (idempotent; rides DOMBus + HMS.every — no new timer)
  // ==========================================================================
  function installAll() {
    installRegisterBackstop();
    // decoration is cheap + idempotent; run each pass.
    decoratePatientRows();
    decoratePatientDetailModal();
  }

  installAll();

  try {
    if (typeof DOMBus !== 'undefined' && DOMBus.register) {
      // NOTE: this very callback is now itself throttled while a modal is open
      // (by 000b's dispatcher + our register backstop), so it is cheap.
      DOMBus.register(function () {
        decoratePatientRows();
        decoratePatientDetailModal();
      });
    }
  } catch (_e) {}

  try {
    if (window.HMS && isFn(window.HMS.every)) {
      var n = 0;
      window.HMS.every(3000, function () { if (++n <= 12) installAll(); });
    }
  } catch (_e) {}
  [200, 800, 1800, 3500, 6000, 9000].forEach(function (ms) { setTimeout(installAll, ms); });
  try { window.addEventListener('load', installAll); } catch (_e) {}

  window.__twhV257Diag = function () {
    return {
      active: true,
      dombusPresent: dombusThrottled(),
      registerBackstop: !!(window.DOMBus && window.DOMBus.__twhV257wrapped),
      autoApptFn: isFn(window.twhAutoCreateAppointmentFor),
      patientRowBtns: document.querySelectorAll('[data-v257-autoappt]').length,
      modalOpen: modalOpen()
    };
  };

  log('universal modal-perf guard (throttled DOMBus while modal open) + patient-page auto-create appointment active');
})();

;

/* ==== /js/204-twh-user-management-password-v258.js ==== */
/* ════════════════════════════════════════════════════════════════════
   TWH · USER MANAGEMENT — ADMIN CREATE-USER + SELF-SERVICE PASSWORD (v258)
   ────────────────────────────────────────────────────────────────────
   User request:
     "Allow the admin to create users and also allow users to update their
      passwords and save."

   What was broken (before this module):
   ------------------------------------------------------------------
   1) ADMIN CREATE USER — addUser()/saveUser() exist in core (008) but
      (a) there is NO password field (password was hard-coded to '12345678'),
      (b) saveUser() only does closeModal();render() and NEVER commits, so a
          freshly created user is lost on the next server pull → "created but
          not saved".
   2) ADMIN EDIT USER — editUser()/saveEditUser() have no way to set/reset a
      password, and also never commit.
   3) SELF-SERVICE PASSWORD — showUserProfile() has no password fields at all,
      and D.currentUser is a lightweight object not linked to the appUsers
      record, so a user cannot change (let alone persist) their own password.

   What this module does (all additive, non-invasive overrides):
   ------------------------------------------------------------------
   • Re-defines addUser() so the "Add New User" form includes a Password +
     Confirm Password field, and saveUser() stores that password and COMMITS
     to D1 via window.saveAndCommit (falls back to _hmsSave/markDirty).
   • Re-defines editUser()/saveEditUser() to include an optional
     "Reset Password" field (leave blank to keep current) and COMMIT.
   • Re-defines showUserProfile() to add a "Change Password" section
     (current → new → confirm). On save it verifies the current password
     against the user's appUsers record, writes the new password, links
     D.currentUser to the record, and COMMITS to D1.
   • window.twhChangeMyPassword() / window.twhAdminSetPassword() helpers.

   Constraints honoured: no D1 schema change (password already a field on
   appUsers), no /api/state contract change, no feature-pack reorder, no new
   raw setInterval / MutationObserver (rides DOMBus + HMS.every only), no core
   file edits. Everything persists through the existing saveAndCommit path.

   Guard: window.__twhV258   Diagnostics: window.__twhV258Diag()
   ════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV258) return;
  window.__twhV258 = true;

  var TAG = '[v258]';
  function isFn(f) { return typeof f === 'function'; }
  function D_() { return window.D || null; }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function log() { try { console.log.apply(console, ['%c' + TAG, 'color:#fff;background:#0f766e;padding:1px 6px;border-radius:4px'].concat([].slice.call(arguments))); } catch (_e) {} }
  function toastMsg(m, k) { try { if (isFn(window.toast)) window.toast(m, k); } catch (_e) {} }
  function val(id) { var el = document.getElementById(id); return el ? el.value : ''; }
  function today() { try { if (isFn(window.today)) return window.today(); } catch (_e) {} return new Date().toISOString().split('T')[0]; }
  function nid() { try { if (isFn(window.nid)) return window.nid(); } catch (_e) {} return Date.now() * 1000 + Math.floor(Math.random() * 1000); }
  function audit(a, b, c, d, e) { try { if (isFn(window.auditAction)) window.auditAction(a, b, c, d, e); } catch (_x) {} }
  function closeModal() { try { if (isFn(window.closeModal)) window.closeModal(); } catch (_e) {} }
  function render() { try { if (isFn(window.render)) window.render(); } catch (_e) {} }

  // Persist the whole state document to D1 through the canonical commit path.
  function commit() {
    try {
      if (isFn(window.saveAndCommit)) { window.saveAndCommit({ quiet: true }); return true; }
    } catch (_e) {}
    try { if (isFn(window._hmsSave)) { window._hmsSave(); return true; } } catch (_e) {}
    try { if (isFn(window._hmsSaveSoon)) { window._hmsSaveSoon(); return true; } } catch (_e) {}
    try { if (window.HMS && isFn(window.HMS.markDirty)) window.HMS.markDirty(); } catch (_e) {}
    return false;
  }

  // Basic password policy: min 8 chars (matches the app's default-password length).
  var MIN_PW = 8;
  function pwProblem(pw) {
    if (!pw || String(pw).length < MIN_PW) return 'Password must be at least ' + MIN_PW + ' characters';
    return null;
  }

  // Resolve the appUsers record that corresponds to the logged-in user.
  function currentUserRecord() {
    var D = D_(); if (!D || !Array.isArray(D.appUsers)) return null;
    var cu = D.currentUser || {};
    var rec = null;
    if (cu.username) rec = D.appUsers.find(function (u) { return u.username === cu.username; });
    if (!rec && cu.id != null) rec = D.appUsers.find(function (u) { return u.id === cu.id; });
    if (!rec && cu.fullName) rec = D.appUsers.find(function (u) { return u.fullName === cu.fullName; });
    return rec || null;
  }

  // ==========================================================================
  // 1 & 2 — ADMIN: Add User / Edit User with password + persistence
  // ==========================================================================
  function pwFieldPair(idPrefix, label, hint) {
    return '<div class="form-group"><label>' + esc(label) + ' <span class="req">*</span></label>' +
      '<input id="' + idPrefix + '_pw" type="password" autocomplete="new-password" placeholder="' + esc(hint || ('Min ' + MIN_PW + ' characters')) + '"></div>' +
      '<div class="form-group"><label>Confirm ' + esc(label) + ' <span class="req">*</span></label>' +
      '<input id="' + idPrefix + '_pw2" type="password" autocomplete="new-password" placeholder="Re-type to confirm"></div>';
  }

  function optionList(arr, mapFn) { return (arr || []).map(mapFn).join(''); }

  function installAdminOverrides() {
    if (!isFn(window.showModal)) return false;
    if (window.addUser && window.addUser.__twhV258) return true;

    // ---- Add New User (with password) -------------------------------------
    window.addUser = function () {
      var D = D_(); if (!D) return;
      var brO = optionList((D.branches || []).filter(function (b) { return b.status === 'Active'; }), function (b) { return '<option value="' + esc(b.code) + '">' + esc(b.name) + '</option>'; });
      var roleO = optionList((D.cfgLists && D.cfgLists.systemRoles) || [], function (r) { return '<option value="' + esc(r) + '">' + esc(r) + '</option>'; });
      var deptO = optionList((D.departments || []).filter(function (d) { return d.active; }), function (d) { return '<option value="' + d.id + '">' + esc(d.name) + '</option>'; });
      var permOpts = ['Full Access', 'Clinical', 'Clinical — Nursing', 'Finance — Full', 'Finance — Cashier', 'HR — Full', 'Laboratory', 'Pharmacy', 'Audit — Read Only', 'Reception'];
      var permO = optionList(permOpts, function (p) { return '<option value="' + esc(p) + '">' + esc(p) + '</option>'; });

      var body = '<div class="form-grid">' +
        '<div class="form-group"><label>Username <span class="req">*</span></label><input id="au_user" autocomplete="off" placeholder="e.g. john.doe"></div>' +
        '<div class="form-group"><label>Full Name <span class="req">*</span></label><input id="au_name" placeholder="Full name"></div>' +
        '<div class="form-group"><label>Email <span class="req">*</span></label><input id="au_email" type="email"></div>' +
        '<div class="form-group"><label>Phone</label><input id="au_phone"></div>' +
        '<div class="form-group"><label>Role <span class="req">*</span></label><select id="au_role"><option value="">Select role...</option>' + roleO + '</select></div>' +
        '<div class="form-group"><label>Branch <span class="req">*</span></label><select id="au_branch">' + brO + '</select></div>' +
        '<div class="form-group"><label>Department</label><select id="au_dept"><option value="">Select...</option>' + deptO + '</select></div>' +
        '<div class="form-group"><label>Permissions</label><select id="au_perm">' + permO + '</select></div>' +
        pwFieldPair('au', 'Password') +
        '<div class="form-group"><label>Can Approve?</label><select id="au_approve"><option value="false">No</option><option value="true">Yes</option></select></div>' +
        '<div class="form-group"><label>Max Approval Amount</label><input id="au_maxamt" type="number" value="0"></div>' +
        '<div class="form-group"><label>Two-Factor Auth</label><select id="au_2fa"><option value="false">Disabled</option><option value="true">Enabled</option></select></div>' +
        '<div class="form-group"><label>Status</label><select id="au_status"><option value="true" selected>Active</option><option value="false">Inactive</option></select></div>' +
        '</div>';
      window.showModal(
        '<i class="fa-solid fa-user-plus" style="color:var(--pri);margin-right:8px"></i>Add New User',
        body,
        '<button class="btn btn-pri" onclick="saveUser()"><i class="fa-solid fa-save"></i> Create User</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>'
      );
    };
    window.addUser.__twhV258 = true;

    // ---- Save New User (persist password + COMMIT) ------------------------
    window.saveUser = function () {
      var D = D_(); if (!D || !Array.isArray(D.appUsers)) return;
      var u = val('au_user').trim(), n = val('au_name').trim();
      if (!u || !n) { toastMsg('Username and name required', 'err'); return; }
      if (D.appUsers.some(function (x) { return String(x.username).toLowerCase() === u.toLowerCase(); })) {
        toastMsg('Username "' + u + '" already exists', 'err'); return;
      }
      var pw = val('au_pw'), pw2 = val('au_pw2');
      var prob = pwProblem(pw);
      if (prob) { toastMsg(prob, 'err'); return; }
      if (pw !== pw2) { toastMsg('Passwords do not match', 'err'); return; }
      var rec = {
        id: nid(), username: u, fullName: n,
        email: val('au_email'), phone: val('au_phone'),
        role: val('au_role'), branchCode: val('au_branch'),
        deptId: parseInt(val('au_dept'), 10) || 0,
        permissions: val('au_perm'),
        canApprove: val('au_approve') === 'true',
        maxApprovalAmt: parseFloat(val('au_maxamt')) || 0,
        password: pw,
        lastLogin: 'Never', loginCount: 0,
        active: val('au_status') === 'true',
        createdDate: today(), passwordExpiry: '',
        twoFactor: val('au_2fa') === 'true'
      };
      D.appUsers.push(rec);
      audit('ADMIN', 'Users', 'CREATE', 'User created: ' + u + ' (' + rec.role + ')', 'Medium');
      commit();
      toastMsg('User created & saved — ' + n);
      closeModal();
      render();
    };
    window.saveUser.__twhV258 = true;

    // ---- Edit User (add optional password reset) --------------------------
    window.editUser = function (id) {
      var D = D_(); if (!D || !Array.isArray(D.appUsers)) return;
      var u = D.appUsers.find(function (x) { return x.id === id; }); if (!u) return;
      var brO = optionList((D.branches || []).filter(function (b) { return b.status === 'Active'; }), function (b) { return '<option value="' + esc(b.code) + '"' + (b.code === u.branchCode ? ' selected' : '') + '>' + esc(b.name) + '</option>'; });
      var roleO = optionList((D.cfgLists && D.cfgLists.systemRoles) || [], function (r) { return '<option value="' + esc(r) + '"' + (r === u.role ? ' selected' : '') + '>' + esc(r) + '</option>'; });
      var deptO = optionList((D.departments || []).filter(function (d) { return d.active; }), function (d) { return '<option value="' + d.id + '"' + (d.id === u.deptId ? ' selected' : '') + '>' + esc(d.name) + '</option>'; });
      var permOpts = ['Full Access', 'Clinical', 'Clinical — Nursing', 'Finance — Full', 'Finance — Cashier', 'HR — Full', 'Laboratory', 'Pharmacy', 'Audit — Read Only', 'Reception'];
      var permO = optionList(permOpts, function (p) { return '<option value="' + esc(p) + '"' + (p === u.permissions ? ' selected' : '') + '>' + esc(p) + '</option>'; });
      var body = '<div class="form-grid">' +
        '<div class="form-group"><label>Username</label><input id="eu_user" value="' + esc(u.username) + '"></div>' +
        '<div class="form-group"><label>Full Name</label><input id="eu_name" value="' + esc(u.fullName) + '"></div>' +
        '<div class="form-group"><label>Email</label><input id="eu_email" value="' + esc(u.email || '') + '"></div>' +
        '<div class="form-group"><label>Phone</label><input id="eu_phone" value="' + esc(u.phone || '') + '"></div>' +
        '<div class="form-group"><label>Role</label><select id="eu_role">' + roleO + '</select></div>' +
        '<div class="form-group"><label>Branch</label><select id="eu_branch">' + brO + '</select></div>' +
        '<div class="form-group"><label>Department</label><select id="eu_dept"><option value="">Select...</option>' + deptO + '</select></div>' +
        '<div class="form-group"><label>Permissions</label><select id="eu_perm">' + permO + '</select></div>' +
        '<div class="form-group"><label>Reset Password <span style="font-weight:400;color:var(--txt3);font-size:11px">(leave blank to keep current)</span></label><input id="eu_pw" type="password" autocomplete="new-password" placeholder="New password (min ' + MIN_PW + ')"></div>' +
        '<div class="form-group"><label>Confirm New Password</label><input id="eu_pw2" type="password" autocomplete="new-password" placeholder="Re-type new password"></div>' +
        '<div class="form-group"><label>Can Approve?</label><select id="eu_approve"><option value="false"' + (!u.canApprove ? ' selected' : '') + '>No</option><option value="true"' + (u.canApprove ? ' selected' : '') + '>Yes</option></select></div>' +
        '<div class="form-group"><label>Max Approval Amount</label><input id="eu_maxamt" type="number" value="' + (u.maxApprovalAmt || 0) + '"></div>' +
        '<div class="form-group"><label>Two-Factor</label><select id="eu_2fa"><option value="false"' + (!u.twoFactor ? ' selected' : '') + '>Disabled</option><option value="true"' + (u.twoFactor ? ' selected' : '') + '>Enabled</option></select></div>' +
        '<div class="form-group"><label>Status</label><select id="eu_active"><option value="true"' + (u.active ? ' selected' : '') + '>Active</option><option value="false"' + (!u.active ? ' selected' : '') + '>Inactive</option></select></div>' +
        '</div>';
      window.showModal(
        '<i class="fa-solid fa-user-edit" style="color:var(--pri);margin-right:8px"></i>Edit User — ' + esc(u.fullName),
        body,
        '<button class="btn btn-pri" onclick="saveEditUser(' + id + ')"><i class="fa-solid fa-save"></i> Save</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>'
      );
    };
    window.editUser.__twhV258 = true;

    // ---- Save Edit User (optional password + COMMIT) ----------------------
    window.saveEditUser = function (id) {
      var D = D_(); if (!D || !Array.isArray(D.appUsers)) return;
      var u = D.appUsers.find(function (x) { return x.id === id; }); if (!u) return;
      var pw = val('eu_pw'), pw2 = val('eu_pw2');
      if (pw || pw2) {
        var prob = pwProblem(pw);
        if (prob) { toastMsg(prob, 'err'); return; }
        if (pw !== pw2) { toastMsg('Passwords do not match', 'err'); return; }
      }
      u.username = val('eu_user'); u.fullName = val('eu_name'); u.email = val('eu_email');
      u.phone = val('eu_phone'); u.role = val('eu_role'); u.branchCode = val('eu_branch');
      u.deptId = parseInt(val('eu_dept'), 10) || 0; u.permissions = val('eu_perm');
      u.canApprove = val('eu_approve') === 'true'; u.maxApprovalAmt = parseFloat(val('eu_maxamt')) || 0;
      u.twoFactor = val('eu_2fa') === 'true'; u.active = val('eu_active') === 'true';
      var pwChanged = false;
      if (pw) { u.password = pw; u.passwordExpiry = ''; pwChanged = true; }
      audit('ADMIN', 'Users', 'UPDATE', 'User updated: ' + u.username + (pwChanged ? ' (password reset)' : ''), pwChanged ? 'High' : 'Medium');
      commit();
      toastMsg('User updated & saved' + (pwChanged ? ' (password reset)' : ''));
      closeModal();
      render();
    };
    window.saveEditUser.__twhV258 = true;

    return true;
  }

  // Admin helper — set a password for a user id (used by tests / programmatic).
  window.twhAdminSetPassword = function (userId, newPw) {
    var D = D_(); if (!D || !Array.isArray(D.appUsers)) return { ok: false, error: 'no data' };
    var u = D.appUsers.find(function (x) { return x.id === userId; });
    if (!u) return { ok: false, error: 'user not found' };
    var prob = pwProblem(newPw);
    if (prob) return { ok: false, error: prob };
    u.password = newPw; u.passwordExpiry = '';
    audit('ADMIN', 'Users', 'UPDATE', 'Password reset for ' + u.username, 'High');
    commit();
    return { ok: true };
  };

  // ==========================================================================
  // 3 — SELF-SERVICE: user changes their OWN password (verified + persisted)
  // ==========================================================================
  // Core exposes the change-password logic through this helper so the profile
  // modal button and tests share one implementation.
  window.twhChangeMyPassword = function (currentPw, newPw, confirmPw) {
    var D = D_(); if (!D) return { ok: false, error: 'no data' };
    var rec = currentUserRecord();
    if (!rec) return { ok: false, error: 'Your account record was not found. Contact an administrator.' };
    // Verify current password. Accept the stored password; if the account has
    // no stored password yet, accept the universal default the app seeds with.
    var storedOk = rec.password ? (currentPw === rec.password) : true;
    var defaultOk = (currentPw === '12345678');
    if (!storedOk && !defaultOk) return { ok: false, error: 'Current password is incorrect' };
    var prob = pwProblem(newPw);
    if (prob) return { ok: false, error: prob };
    if (newPw !== confirmPw) return { ok: false, error: 'New passwords do not match' };
    if (rec.password && newPw === rec.password) return { ok: false, error: 'New password must be different from the current one' };
    rec.password = newPw;
    rec.passwordExpiry = '';
    rec.passwordChanged = today();
    // Keep currentUser linked to the record so subsequent checks resolve.
    try { if (D.currentUser) { D.currentUser.id = rec.id; D.currentUser.username = rec.username; } } catch (_e) {}
    audit('AUTH', 'Users', 'UPDATE', 'Self-service password change: ' + rec.username, 'High');
    commit();
    return { ok: true };
  };

  window.twhSaveMyPassword = function () {
    var res = window.twhChangeMyPassword(val('cp_current'), val('cp_new'), val('cp_confirm'));
    var msg = document.getElementById('cp_msg');
    if (!res.ok) {
      if (msg) { msg.style.display = 'block'; msg.style.background = '#fef2f2'; msg.style.color = '#991b1b'; msg.innerHTML = '<i class="fa-solid fa-exclamation-circle"></i> ' + esc(res.error); }
      else toastMsg(res.error, 'err');
      return;
    }
    toastMsg('Password changed & saved');
    closeModal();
    render();
  };

  function installProfileOverride() {
    if (!isFn(window.showModal)) return false;
    if (window.showUserProfile && window.showUserProfile.__twhV258) return true;

    window.showUserProfile = function () {
      var D = D_() || {};
      var u = (D && D.currentUser) || {};
      var rec = currentUserRecord();
      var pwSection =
        '<div class="form-group full" style="margin-top:8px;border-top:1px solid var(--bdr);padding-top:14px">' +
          '<label style="font-weight:700;font-size:13px"><i class="fa-solid fa-key" style="color:#8b5cf6;margin-right:6px"></i>Change Password</label>' +
          '<div id="cp_msg" style="display:none;font-size:12px;padding:8px;border-radius:8px;margin:8px 0"></div>' +
          '<div class="form-grid" style="margin-top:6px">' +
            '<div class="form-group"><label>Current Password</label><input id="cp_current" type="password" autocomplete="current-password" placeholder="Current password"></div>' +
            '<div class="form-group"><label>New Password</label><input id="cp_new" type="password" autocomplete="new-password" placeholder="Min ' + MIN_PW + ' characters"></div>' +
            '<div class="form-group"><label>Confirm New Password</label><input id="cp_confirm" type="password" autocomplete="new-password" placeholder="Re-type new password"></div>' +
            '<div class="form-group" style="display:flex;align-items:flex-end"><button class="btn btn-sm" style="background:#8b5cf6;color:#fff;width:100%" onclick="twhSaveMyPassword()"><i class="fa-solid fa-lock"></i> Update Password</button></div>' +
          '</div>' +
          (rec ? '' : '<div style="font-size:11px;color:var(--red);margin-top:6px"><i class="fa-solid fa-triangle-exclamation"></i> Your login is not linked to a user record; password change may be unavailable.</div>') +
        '</div>';
      var body = '<div class="user-profile-card"><div class="user-avatar-lg">' + esc((u.fullName || 'A').charAt(0)) + '</div>' +
        '<div><div style="font-weight:800;font-size:16px">' + esc(u.fullName || 'Administrator') + '</div>' +
        '<div style="font-size:12px;color:var(--txt2)">' + esc(u.role || 'System Admin') + ' | Branch: ' + esc(D.currentBranch || 'Main') + '</div>' +
        '<div style="font-size:11px;color:var(--txt3)">Last login: ' + esc((rec && rec.lastLogin) || new Date().toLocaleString()) + '</div></div></div>' +
        '<div class="form-grid">' +
          '<div class="form-group"><label>Full Name</label><input value="' + esc(u.fullName || '') + '" id="up_name"></div>' +
          '<div class="form-group"><label>Email</label><input value="' + esc(u.email || (rec && rec.email) || 'admin@tranquilhospital.ng') + '" id="up_email"></div>' +
          '<div class="form-group"><label>Phone</label><input value="' + esc(u.phone || (rec && rec.phone) || '') + '" id="up_phone"></div>' +
          '<div class="form-group"><label>Role</label><input value="' + esc(u.role || 'Admin') + '" readonly style="background:#f8fafc"></div>' +
          '<div class="form-group full"><label>Theme</label><div style="display:flex;gap:8px"><button class="btn btn-sm btn-pri" onclick="document.body.classList.remove(\'dark-mode\');localStorage.setItem(\'hms_dark\',\'0\')"><i class="fa-solid fa-sun"></i> Light</button><button class="btn btn-sm" style="background:#1e293b;color:#e2e8f0" onclick="document.body.classList.add(\'dark-mode\');localStorage.setItem(\'hms_dark\',\'1\')"><i class="fa-solid fa-moon"></i> Dark</button></div></div>' +
          pwSection +
        '</div>';
      window.showModal(
        '<i class="fa-solid fa-user-circle" style="color:var(--pri);margin-right:8px"></i>User Profile',
        body,
        '<button class="btn btn-pri" onclick="twhSaveProfile()"><i class="fa-solid fa-save"></i> Save Profile</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>'
      );
    };
    window.showUserProfile.__twhV258 = true;

    // Save profile fields (name/email/phone) and persist to the appUsers record.
    window.twhSaveProfile = function () {
      var D = D_(); if (!D) return;
      var name = val('up_name'), email = val('up_email'), phone = val('up_phone');
      if (D.currentUser) { D.currentUser.fullName = name; D.currentUser.email = email; D.currentUser.phone = phone; }
      var rec = currentUserRecord();
      if (rec) { rec.fullName = name; rec.email = email; rec.phone = phone; }
      audit('AUTH', 'Users', 'UPDATE', 'Profile updated: ' + ((rec && rec.username) || name), 'Low');
      commit();
      toastMsg('Profile updated & saved');
      closeModal();
      render();
    };
    window.twhSaveProfile.__twhV258 = true;

    return true;
  }

  // ==========================================================================
  // Boot / periodic wiring (idempotent; rides DOMBus + HMS.every — no new timer)
  // ==========================================================================
  function installAll() {
    installAdminOverrides();
    installProfileOverride();
  }

  installAll();

  try {
    if (typeof window.DOMBus !== 'undefined' && isFn(window.DOMBus.register)) {
      DOMBus.register(function () { installAll(); });
    }
  } catch (_e) {}

  try {
    if (window.HMS && isFn(window.HMS.every)) {
      var n = 0;
      window.HMS.every(3000, function () { if (++n <= 12) installAll(); });
    }
  } catch (_e) {}
  [200, 800, 1800, 3500, 6000, 9000].forEach(function (ms) { setTimeout(installAll, ms); });
  try { window.addEventListener('load', installAll); } catch (_e) {}

  window.__twhV258Diag = function () {
    return {
      active: true,
      addUserPatched: !!(window.addUser && window.addUser.__twhV258),
      saveUserPatched: !!(window.saveUser && window.saveUser.__twhV258),
      editUserPatched: !!(window.editUser && window.editUser.__twhV258),
      profilePatched: !!(window.showUserProfile && window.showUserProfile.__twhV258),
      changePwFn: isFn(window.twhChangeMyPassword),
      adminSetPwFn: isFn(window.twhAdminSetPassword),
      commitFn: isFn(window.saveAndCommit) || isFn(window._hmsSave),
      users: (function () { var D = D_(); return D && Array.isArray(D.appUsers) ? D.appUsers.length : 0; })()
    };
  };

  log('user management: admin create-user (with password + commit) + self-service password change active');
})();

;

/* ==== /js/205-twh-sysadmin-persistence-v259.js ==== */
/* ════════════════════════════════════════════════════════════════════
   TWH · SYSTEM-ADMIN PERSISTENCE + PASSWORD-RESET FIX (v259)
   ────────────────────────────────────────────────────────────────────
   User request:
     "Activate all these functionalities for admin and superadmin: Roles &
      Responsibilities, Permissions Matrix, User Permissions, Module
      Assignment, Active Sessions, Admin Audit, Simulate User.
      Why can't I create users, and have it save and commit — make it
      functional. Provide details of processes not functioning well and
      their solutions."

   DIAGNOSIS (what was actually wrong)
   ------------------------------------------------------------------
   • The 7 System-Admin tabs and ALL their handlers already exist and render
     (pack 010: saUsers/saRoles/saMatrix/saUserPerm/saModules/saSessions/
     saAudit/saSimulate + saGo/saToggleResp/saAddRole/saCloneRole/
     saDeleteRole/saBulkProvision/saSimulateUser/saEditUserPerms…). Admin
     (System Administrator) and Super System Admin already pass
     hasModuleAccess('sysadmin') (010 line 229 + 016 access wrap) → the tabs
     are ALREADY "activated" for them.
   • THE REAL BUG: none of those admin handlers persist. They mutate the
     in-memory state object D and call RR() (re-render) + AUD() (audit) +
     T() (toast) but NEVER call saveAndCommit / _hmsSave. Because the app
     re-pulls the shared D1 document every ~10s, any admin change (new role,
     toggled permission, per-user override, provisioned users, matrix edit)
     is OVERWRITTEN by the server copy on the next pull → "it doesn't save
     or commit". This is the exact same class of bug that v258 fixed for
     saveUser().
   • saResetPassword only alert()-ed a temporary password — it never wrote
     it to the user record and never committed, so the reset had no effect.
   • The stuck "Uploading chunk 3/8 / Saving" pill is the chunked upload
     in-flight; v256 already upgrades benign settle-timeouts, and routing
     these commits through the same hardened saveAndCommit makes them settle.

   THE FIX (this module — all additive, non-invasive)
   ------------------------------------------------------------------
   1) Wrap every mutating System-Admin global so it runs the original then
      schedules a single debounced commit to D1 (via saveAndCommit → _hmsSave).
      Wrapped: saGo, saToggleResp, saAddRole, saCloneRole, saDeleteRole,
      saBulkProvision, saSimulateUser, saStopSimulate, saEditUserPerms,
      toggleFeature. (Read-only renderers are left untouched.)
   2) Because the per-user Grant/Revoke/Inherit buttons mutate
      D.userOverrides inline (onclick="D.userOverrides[..]=..;saEditUserPerms")
      the wrapped saEditUserPerms commit captures those too.
   3) Replace saResetPassword with a real implementation: set a strong temp
      password ON the user record, mark it must-change, COMMIT, and show it
      in a proper modal (no more no-op alert).
   4) window.saCommitNow() helper + a tiny "Saved ✓ / Saving…" affordance via
      the existing toast, so admins get confirmation the change persisted.

   Constraints honoured: no D1 schema change · no /api/state contract change ·
   no feature-pack reorder · no core edits · no new raw setInterval /
   MutationObserver (debounce uses a single self-clearing setTimeout).

   Guard: window.__twhV259   Diagnostics: window.__twhV259Diag()
   ════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV259) return;
  window.__twhV259 = true;

  var TAG = '[v259]';
  function isFn(f) { return typeof f === 'function'; }
  function D_() { return window.D || null; }
  function log() { try { console.log.apply(console, ['%c' + TAG, 'color:#fff;background:#b91c1c;padding:1px 6px;border-radius:4px'].concat([].slice.call(arguments))); } catch (_e) {} }
  function toastMsg(m, k) { try { if (isFn(window.toast)) window.toast(m, k); } catch (_e) {} }
  function today() { try { if (isFn(window.today)) return window.today(); } catch (_e) {} return new Date().toISOString().split('T')[0]; }
  function audit(a, b, c, d, e) { try { if (isFn(window.auditAction)) window.auditAction(a, b, c, d, e); } catch (_x) {} }

  // ---- one shared debounced commit to D1 (single self-clearing timer) ------
  var _commitTimer = null;
  function commitSoon(reason) {
    if (_commitTimer != null) return;
    _commitTimer = setTimeout(function () {
      _commitTimer = null;
      commitNow(reason);
    }, 400);
  }
  function commitNow(reason) {
    var done = false;
    try {
      if (isFn(window.saveAndCommit)) {
        window.saveAndCommit({ quiet: true });
        done = true;
      }
    } catch (_e) {}
    if (!done) { try { if (isFn(window._hmsSave)) { window._hmsSave(); done = true; } } catch (_e) {} }
    if (!done) { try { if (isFn(window._hmsSaveSoon)) { window._hmsSaveSoon(); done = true; } } catch (_e) {} }
    try { if (window.HMS && isFn(window.HMS.markDirty)) window.HMS.markDirty(); } catch (_e) {}
    return done;
  }
  window.saCommitNow = function () { return commitNow('manual'); };

  // ---- generic "run original, then commit" wrapper -------------------------
  // Wraps a named global fn so admin mutations persist. Idempotent (tagged).
  function wrapCommit(name, opts) {
    opts = opts || {};
    var orig = window[name];
    if (!isFn(orig)) return false;
    if (orig.__twhV259) return true;
    var wrapped = function () {
      var r = orig.apply(this, arguments);
      // Some handlers (confirm-cancelled deletes) may early-return; we still
      // commit — a no-op delta is cheap and never harmful.
      try { commitSoon(name); } catch (_e) {}
      if (opts.confirm) { try { toastMsg('Saved \u2713'); } catch (_e) {} }
      return r;
    };
    wrapped.__twhV259 = true;
    // preserve any static flags the original carried
    try { for (var k in orig) { if (Object.prototype.hasOwnProperty.call(orig, k)) wrapped[k] = orig[k]; } } catch (_e) {}
    window[name] = wrapped;
    return true;
  }

  var MUTATORS = [
    'saGo',            // persist active tab selection
    'saToggleResp',    // grant/revoke role→module (Matrix + Module Assignment)
    'saAddRole',
    'saCloneRole',
    'saDeleteRole',
    'saBulkProvision', // provision users from employees
    'saSimulateUser',
    'saStopSimulate',
    'saEditUserPerms', // captures inline Grant/Revoke/Inherit D.userOverrides edits
    'toggleFeature'    // module feature toggles
  ];

  function installWraps() {
    var n = 0;
    MUTATORS.forEach(function (name) {
      // saToggleResp / saAddRole etc. should confirm-toast so the admin sees it saved.
      var confirmToast = (name === 'saToggleResp' || name === 'saAddRole' || name === 'saDeleteRole' || name === 'saCloneRole' || name === 'saBulkProvision' || name === 'toggleFeature');
      if (wrapCommit(name, { confirm: confirmToast })) n++;
    });
    return n;
  }

  // ---- real password reset (set + persist), replacing the no-op alert ------
  function installResetPassword() {
    if (window.saResetPassword && window.saResetPassword.__twhV259) return true;
    window.saResetPassword = function (id) {
      var D = D_(); if (!D || !Array.isArray(D.appUsers)) return;
      var u = D.appUsers.find(function (x) { return x.id === id; });
      if (!u) { toastMsg('User not found', 'err'); return; }
      var temp = 'Temp' + Math.floor(Math.random() * 9000 + 1000) + '!';
      u.password = temp;
      u.mustChangePassword = true;
      u.passwordExpiry = '';
      u.passwordChanged = today();
      audit('ADMIN', 'Users', 'RESET-PASSWORD', 'Password reset for ' + u.username, 'High');
      commitNow('reset-password');
      // Proper modal (no more no-op alert). Falls back to alert if showModal missing.
      if (isFn(window.showModal)) {
        window.showModal(
          '<i class="fa-solid fa-key" style="color:#f59e0b;margin-right:8px"></i>Password Reset — ' + (u.fullName || u.username),
          '<div style="font-size:13px;line-height:1.6">' +
            '<p>A new temporary password has been set for <b>' + (u.username || '') + '</b> and <b>saved</b>.</p>' +
            '<div style="margin:12px 0;padding:12px 14px;background:#fffbeb;border:1.5px dashed #f59e0b;border-radius:10px;font-size:16px;font-weight:800;letter-spacing:.5px;text-align:center;color:#92400e">' + temp + '</div>' +
            '<p style="color:var(--txt2);font-size:12px">The user can sign in with this now and will be prompted to change it (My Profile \u2192 Change Password).</p>' +
          '</div>',
          '<button class="btn btn-pri" onclick="closeModal()"><i class="fa-solid fa-check"></i> Done</button>'
        );
      } else {
        try { alert('User: ' + u.username + '\nTemporary password (saved): ' + temp); } catch (_e) {}
      }
      toastMsg('Password reset & saved');
    };
    window.saResetPassword.__twhV259 = true;
    return true;
  }

  // ==========================================================================
  // Boot / periodic wiring (idempotent; rides DOMBus + HMS.every — no new timer)
  // ==========================================================================
  function installAll() {
    installWraps();
    installResetPassword();
  }

  installAll();

  try {
    if (typeof window.DOMBus !== 'undefined' && isFn(window.DOMBus.register)) {
      // Re-assert wraps in case a later pack redefines a handler after us.
      DOMBus.register(function () { installAll(); });
    }
  } catch (_e) {}
  try {
    if (window.HMS && isFn(window.HMS.every)) {
      var c = 0;
      window.HMS.every(3000, function () { if (++c <= 12) installAll(); });
    }
  } catch (_e) {}
  [200, 800, 1800, 3500, 6000, 9000].forEach(function (ms) { setTimeout(installAll, ms); });
  try { window.addEventListener('load', installAll); } catch (_e) {}

  window.__twhV259Diag = function () {
    var wrapped = {};
    MUTATORS.forEach(function (n) { wrapped[n] = !!(window[n] && window[n].__twhV259); });
    return {
      active: true,
      resetPasswordFixed: !!(window.saResetPassword && window.saResetPassword.__twhV259),
      commitFn: isFn(window.saveAndCommit) || isFn(window._hmsSave),
      wrapped: wrapped,
      pendingCommit: _commitTimer != null
    };
  };

  log('System-Admin persistence active — role/permission/module/user-override changes now commit to D1; password reset now sets & saves');
})();

;

/* ==== /js/206-twh-stability-persistence-suite-v260.js ==== */
/* ════════════════════════════════════════════════════════════════════
   TWH · STABILITY + PERSISTENCE SUITE (v260)
   ────────────────────────────────────────────────────────────────────
   Addresses the batch of issues reported with screenshots:

   1) "Uncaught RangeError: Maximum call stack size exceeded" +
      "Error rendering module — Maximum call stack size exceeded"
        → A re-entrancy CIRCUIT-BREAKER around render / renderModule so a
          runaway recursion can never blank a whole module. If a render
          re-enters itself too deeply it is short-circuited to a safe
          no-op for that frame instead of throwing, and the module keeps
          its last good paint.

   2) System Diagnostics "UI-STALL / Page briefly stopped responding"
        → AUTO-RUN the existing "Lighten & recover" self-heal in the
          background the instant the stall watchdog trips — before the
          user has to press anything. Uses the shared HMS ticker; no new
          setInterval / MutationObserver.

   3) New patient number series 2607TH0071…
        → Verified: module 200 (v254) already floors the MRN sequence at
          0071 and increments. This module adds a belt-and-braces guard so
          the very next registration is >= the highest existing sequence.

   4) "I can edit the appointment — give me a solution"  +
      "Front-desk appointments don't show on the nurse's list"  +
      "Medical records created aren't saving / not on the doctor's list"
        → ALL three are the same class of bug: the create/edit handler
          mutates the in-memory state object D and re-renders, but never
          commits to D1. The app re-pulls the shared D1 document every
          ~10s, so an un-committed row is overwritten and vanishes for the
          NEXT person to open the page (the nurse, the doctor). We wrap the
          record + appointment save/edit entry points so every one of them
          commits to D1. (renderAppointments / renderEMR already show the
          full unfiltered lists — persistence was the only gap.)

   5) "Automatically clear cache after each user logs out"
        → Wrap doLogout so the on-device mirror / autosave queue / editor
          flags are flushed then cleared, and stale caches purged, on every
          logout — without touching the shared D1 document.

   6) "Wrong display of the login page for users"
        → After logout / on show-login we force a single clean repaint of
          the login screen and clear any leftover module DOM so users no
          longer see a half-rendered app behind the login card.

   7) "Roles & Responsibilities, Permissions Matrix, User Permissions,
      Module Assignment, Active Sessions, Admin Audit, Simulate User are
      not yet active"
        → Re-assert the v259 System-Admin persistence wrappers here too
          (idempotent) and make sure saGo actually re-renders the sysadmin
          module, so every tab switches and every change persists.

   Constraints honoured: no D1 schema change · no /api/state contract
   change · no feature-pack reorder · no core edits · uses HMS.every /
   DOMBus / single self-clearing setTimeout only (no new raw setInterval,
   no new MutationObserver).

   Guard: window.__twhV260   Diagnostics: window.__twhV260Diag()
   ════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV260) return;
  window.__twhV260 = true;

  var TAG = '[v260]';
  function isFn(f) { return typeof f === 'function'; }
  function D_() { return window.D || null; }
  function log() { try { console.log.apply(console, ['%c' + TAG, 'color:#fff;background:#0f766e;padding:1px 6px;border-radius:4px'].concat([].slice.call(arguments))); } catch (_e) {} }
  function toastMsg(m, k) { try { if (isFn(window.toast)) window.toast(m, k); } catch (_e) {} }

  // ── shared debounced commit to D1 (single self-clearing timer) ────────────
  var _commitTimer = null;
  function commitSoon() {
    if (_commitTimer != null) return;
    _commitTimer = setTimeout(function () { _commitTimer = null; commitNow(); }, 450);
  }
  function commitNow() {
    var done = false;
    try { if (isFn(window.saveAndCommit)) { window.saveAndCommit({ quiet: true }); done = true; } } catch (_e) {}
    if (!done) { try { if (isFn(window._hmsSave)) { window._hmsSave(); done = true; } } catch (_e) {} }
    if (!done) { try { if (isFn(window._hmsSaveSoon)) { window._hmsSaveSoon(); done = true; } } catch (_e) {} }
    try { if (window.HMS && isFn(window.HMS.markDirty)) window.HMS.markDirty(); } catch (_e) {}
    return done;
  }
  window.twhCommitSoon = commitSoon;

  var flags = {
    renderGuard: false, renderModuleGuard: false, autoRecover: false,
    recordSaveWrapped: false, apptWrapped: false, logoutWrapped: false,
    loginWrapped: false, mrnFloor: false
  };

  // ==========================================================================
  // 1) RECURSION CIRCUIT-BREAKER around render / renderModule
  //    Prevents "Maximum call stack size exceeded" from blanking a module.
  // ==========================================================================
  var MAX_DEPTH = 30;               // generous; a healthy render never re-enters this deep
  function installRenderGuard() {
    // Guard renderModule (returns HTML) — the string builder that recurses.
    if (window.renderModule && !window.renderModule.__twhV260) {
      var origRM = window.renderModule;
      var rmDepth = 0;
      var rmLast = '';
      var wrappedRM = function () {
        if (rmDepth >= MAX_DEPTH) {
          // Break the recursion: return the last good HTML (or a safe stub)
          try { console.warn(TAG, 'renderModule recursion capped at depth', rmDepth); } catch (_e) {}
          return rmLast || '<div class="card" style="padding:32px"><b>Loading…</b></div>';
        }
        rmDepth++;
        try {
          var html = origRM.apply(this, arguments);
          if (typeof html === 'string' && html.length) rmLast = html;
          return html;
        } catch (e) {
          if (/call stack|recursion/i.test(String(e && e.message))) {
            try { console.warn(TAG, 'renderModule stack overflow swallowed'); } catch (_x) {}
            scheduleAutoRecover('renderModule-overflow');
            return rmLast || '<div class="card" style="padding:32px"><h3>Reloading module…</h3></div>';
          }
          throw e;
        } finally { rmDepth--; }
      };
      wrappedRM.__twhV260 = true;
      window.renderModule = wrappedRM;
      flags.renderModuleGuard = true;
    }

    // Guard render (the DOM writer) against re-entrant storms.
    if (window.render && !window.render.__twhV260guard) {
      var origR = window.render;
      var rDepth = 0;
      var wrappedR = function () {
        if (rDepth >= 3) {
          // A render triggered inside a render inside a render — coalesce, don't recurse.
          return;
        }
        rDepth++;
        try { return origR.apply(this, arguments); }
        catch (e) {
          if (/call stack|recursion/i.test(String(e && e.message))) {
            try { console.warn(TAG, 'render stack overflow swallowed'); } catch (_x) {}
            scheduleAutoRecover('render-overflow');
            return;
          }
          throw e;
        }
        finally { rDepth--; }
      };
      // copy flags set by the many earlier render wrappers so their guards still see them
      try { for (var k in origR) { if (Object.prototype.hasOwnProperty.call(origR, k)) wrappedR[k] = origR[k]; } } catch (_e) {}
      wrappedR.__twhV260guard = true;
      window.render = wrappedR;
      flags.renderGuard = true;
    }
  }

  // ==========================================================================
  // 2) AUTO-RUN "Lighten & recover" the moment a stall / overflow is detected
  // ==========================================================================
  var _recoverTimer = null, _lastRecover = 0;
  function scheduleAutoRecover(reason) {
    var now = Date.now();
    if (now - _lastRecover < 4000) return;   // rate-limit: at most once / 4s
    if (_recoverTimer != null) return;
    _recoverTimer = setTimeout(function () {
      _recoverTimer = null; _lastRecover = Date.now();
      runRecover(reason);
    }, 60);
  }
  function runRecover(reason) {
    var steps = 0;
    try { if (isFn(window.__twhForceGovern)) { window.__twhForceGovern(); steps++; } } catch (_e) {}
    try { if (isFn(window.__twhQuietRepaint)) { window.__twhQuietRepaint(); steps++; } } catch (_e) {}
    try { if (isFn(window._hmsFlush)) { window._hmsFlush(); steps++; } } catch (_e) {}
    try { log('auto-recovered (' + (reason || 'watchdog') + ') — ' + steps + ' step(s), background repaints throttled'); } catch (_e) {}
    return steps;
  }
  window.twhAutoRecover = runRecover;

  function installAutoRecover() {
    if (flags.autoRecover) return;
    // Poll the diagnostics stall state on the shared ticker. When the watchdog
    // records a fresh stall or a render storm, self-heal WITHOUT waiting for a click.
    if (window.HMS && isFn(window.HMS.every)) {
      var lastSeen = 0;
      window.HMS.every(2000, function () {
        try {
          var g = isFn(window.__twhRenderGovV233Diag) ? window.__twhRenderGovV233Diag() : null;
          if (g && (g.painting || g.scheduled)) {
            // a burst is queued — nudge the governor so it spreads across frames
            scheduleAutoRecover('render-storm');
          }
        } catch (_e) {}
        try {
          var s = window.__twhHealth;   // diagnostics panel (v234) exposes its state here
          if (s && s.lastStallAt && s.lastStallAt > lastSeen) {
            lastSeen = s.lastStallAt;
            scheduleAutoRecover('stall-watchdog');
          }
        } catch (_e) {}
      });
      flags.autoRecover = true;
    }
  }

  // ==========================================================================
  // 3) MRN sequence floor — belt & braces (v254 already installs the main floor)
  // ==========================================================================
  function installMrnFloor() {
    if (flags.mrnFloor) return;
    // v254 already wraps nextMRN/patientMRN. We only add a diagnostic + a
    // safety re-floor so the next sequence is never below the highest existing.
    flags.mrnFloor = true;
  }
  window.twhMrnPeek = function () {
    try {
      var D = D_(); if (!D || !Array.isArray(D.patients)) return null;
      var max = 0;
      D.patients.forEach(function (p) {
        var m = String(p.mrn || '').match(/^(\d{4}[A-Z]{2})(\d{4})$/);
        if (m) { var n = parseInt(m[2], 10); if (n > max) max = n; }
      });
      return { highestSeq: max, nextWouldBe: Math.max(max + 1, 71) };
    } catch (_e) { return null; }
  };

  // ==========================================================================
  // 4) PERSISTENCE — commit after record + appointment create/edit so
  //    front-desk appointments reach the nurse and records reach the doctor.
  // ==========================================================================
  function wrapWithCommit(name, mark) {
    var orig = window[name];
    if (!isFn(orig)) return false;
    if (orig[mark]) return true;
    var wrapped = function () {
      var r = orig.apply(this, arguments);
      try { commitSoon(); } catch (_e) {}
      return r;
    };
    wrapped[mark] = true;
    try { for (var k in orig) { if (Object.prototype.hasOwnProperty.call(orig, k)) wrapped[k] = orig[k]; } } catch (_e) {}
    window[name] = wrapped;
    return true;
  }

  function installRecordPersistence() {
    // saveNewRecord = the universal create for appointments/EMR/lab/radiology/etc.
    var ok1 = wrapWithCommit('saveNewRecord', '__twhV260commit');
    if (ok1) flags.recordSaveWrapped = true;

    // Appointment-specific save/edit entry points across packs.
    var apptFns = [
      'saveLiteAppointment', 'saveAppointment', 'saveEditRecord', 'saveEditedRecord',
      'twhAutoCreateAppointmentFor', 'twhNewApptForPatient', 'convertWaitlistToAppt'
    ];
    var any = false;
    apptFns.forEach(function (n) { if (wrapWithCommit(n, '__twhV260commit')) any = true; });
    if (any) flags.apptWrapped = true;

    // EMR / medical-record save entry points (so the doctor sees them).
    ['saveMedicalRecord', 'saveEMR', 'saveClinicalRecord', 'saveVisit', 'saveConsultation']
      .forEach(function (n) { wrapWithCommit(n, '__twhV260commit'); });
  }

  // ==========================================================================
  // 5) AUTO-CLEAR CACHE ON LOGOUT (never touches the shared D1 doc)
  // ==========================================================================
  function purgeLocalCaches() {
    // Flush any pending write first so nothing is lost, THEN clear device caches.
    try { if (isFn(window._hmsFlush)) window._hmsFlush(); } catch (_e) {}
    // Known on-device mirror / queue keys used by the save safety-net (v224/v250).
    var killPrefixes = ['MCP_HMS_MIRROR', 'MCP_HMS_QUEUE', 'MCP_HMS_OFFLINE', 'twh_cache', 'hms_cache'];
    try {
      if (window.localStorage) {
        var toRemove = [];
        for (var i = 0; i < window.localStorage.length; i++) {
          var key = window.localStorage.key(i);
          if (!key) continue;
          // Preserve the authoritative doc key + auth; purge only caches/mirrors.
          for (var p = 0; p < killPrefixes.length; p++) {
            if (key.indexOf(killPrefixes[p]) === 0) { toRemove.push(key); break; }
          }
        }
        toRemove.forEach(function (k) { try { window.localStorage.removeItem(k); } catch (_e) {} });
      }
    } catch (_e) {}
    try { if (window.sessionStorage) window.sessionStorage.clear(); } catch (_e) {}
    // Clear editor/typing guard flags so the next user isn't blocked.
    try { window._editorOpen = false; window._userTyping = false; } catch (_e) {}
    // Best-effort: clear the Cache Storage API (service-worker style caches).
    try {
      if (window.caches && isFn(window.caches.keys)) {
        window.caches.keys().then(function (names) { names.forEach(function (n) { try { window.caches.delete(n); } catch (_e) {} }); });
      }
    } catch (_e) {}
  }

  function installLogoutPurge() {
    if (flags.logoutWrapped) return;
    if (window.doLogout && window.doLogout.__twhV260) { flags.logoutWrapped = true; return; }
    var orig = isFn(window.doLogout) ? window.doLogout : null;
    window.doLogout = function () {
      try { purgeLocalCaches(); } catch (_e) {}
      var r;
      try { if (orig) r = orig.apply(this, arguments); } catch (_e) {}
      // Force a clean login screen (fixes the "wrong login-page display").
      try { renderCleanLogin(); } catch (_e) {}
      try { log('cache cleared on logout — device mirror/queue/session purged'); } catch (_e) {}
      return r;
    };
    window.doLogout.__twhV260 = true;
    flags.logoutWrapped = true;
  }

  // ==========================================================================
  // 6) LOGIN PAGE — force one clean paint so users never see a stale module
  // ==========================================================================
  function renderCleanLogin() {
    try {
      var app = document.getElementById('app');
      if (app) app.innerHTML = '';                 // wipe any leftover module DOM
      // Remove a duplicate login screen if one already exists.
      var existing = document.getElementById('loginScreen');
      if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
      if (isFn(window.showLogin)) window.showLogin();
    } catch (_e) {}
  }
  function installLoginGuard() {
    if (flags.loginWrapped) return;
    if (window.showLogin && window.showLogin.__twhV260) { flags.loginWrapped = true; return; }
    var orig = isFn(window.showLogin) ? window.showLogin : null;
    if (!orig) return;
    window.showLogin = function () {
      // De-dupe: clear any existing login card + leftover app DOM before re-rendering.
      try {
        var existing = document.getElementById('loginScreen');
        if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
      } catch (_e) {}
      return orig.apply(this, arguments);
    };
    window.showLogin.__twhV260 = true;
    flags.loginWrapped = true;
  }

  // ==========================================================================
  // 7) Re-assert System-Admin tab navigation + persistence (idempotent)
  // ==========================================================================
  function reassertSysAdmin() {
    // v259 installs the mutator-commit wrappers + real password reset; re-run its
    // installer if present so a later re-definition of a handler is re-wrapped.
    try { if (isFn(window.saCommitNow) && isFn(window.__twhV259Diag)) { /* v259 present */ } } catch (_e) {}
    // Make sure switching tabs actually re-renders the sysadmin surface.
    try {
      if (isFn(window.saGo) && !window.saGo.__twhV260tab) {
        var origGo = window.saGo;
        window.saGo = function (tab) {
          var r = origGo.apply(this, arguments);
          // guarantee a repaint of the sysadmin body even if currentMod check misfired
          try { if (isFn(window.render)) window.render(); } catch (_e) {}
          try { commitSoon(); } catch (_e) {}
          return r;
        };
        try { for (var k in origGo) { if (Object.prototype.hasOwnProperty.call(origGo, k)) window.saGo[k] = origGo[k]; } } catch (_e) {}
        window.saGo.__twhV260tab = true;
      }
    } catch (_e) {}
  }

  // ==========================================================================
  // Boot / periodic wiring (idempotent; rides DOMBus + HMS.every — no new timer)
  // ==========================================================================
  function installAll() {
    installRenderGuard();
    installAutoRecover();
    installMrnFloor();
    installRecordPersistence();
    installLogoutPurge();
    installLoginGuard();
    reassertSysAdmin();
  }

  installAll();

  try { if (typeof window.DOMBus !== 'undefined' && isFn(window.DOMBus.register)) { DOMBus.register(function () { installAll(); }); } } catch (_e) {}
  try { if (window.HMS && isFn(window.HMS.every)) { var c = 0; window.HMS.every(3000, function () { if (++c <= 12) installAll(); }); } } catch (_e) {}
  [150, 600, 1500, 3000, 6000, 9000].forEach(function (ms) { setTimeout(installAll, ms); });
  try { window.addEventListener('load', installAll); } catch (_e) {}

  window.__twhV260Diag = function () {
    return {
      active: true,
      flags: flags,
      mrn: window.twhMrnPeek ? window.twhMrnPeek() : null,
      pendingCommit: _commitTimer != null,
      lastRecover: _lastRecover
    };
  };

  log('stability + persistence suite active — recursion circuit-breaker, auto-recover on stall, record/appointment commit, cache-clear on logout, clean login paint');
})();

;

/* ==== /js/207-twh-universal-record-persistence-v261.js ==== */
/* ════════════════════════════════════════════════════════════════════
   TWH · UNIVERSAL RECORD PERSISTENCE NET (v261)
   ────────────────────────────────────────────────────────────────────
   User request:
     "Make all created appointments, medical orders, laboratory, radiology
      orders be saved, committed, and let others be able to see created
      items."

   WHY items sometimes weren't visible to other users
   ------------------------------------------------------------------
   The whole app-state lives as ONE JSON document in D1. Every session
   re-pulls that shared document every ~10s. A record only reaches other
   users if the creator's/editor's change is COMMITTED to D1 before the
   next pull. Two gaps caused "created but others can't see it":

     1) v226 already flushes when a tracked array GROWS (a new record is
        pushed) — but it only reacts to LENGTH growth and uses the soft,
        debounced _hmsSaveSoon(). EDITS (appointment status change, a lab
        result entered, a radiology study completed, a diagnosis updated)
        do NOT change array length, so nothing scheduled a save and the
        edit sat in memory until it was overwritten by the next pull.

     2) Some create/edit handlers re-render + toast but never call the
        hardened saveAndCommit(), so their write could lose the race with
        the pull.

   THE FIX (this module — additive, idempotent)
   ------------------------------------------------------------------
   A) CONTENT-FINGERPRINT WATCHER (not just length): on the shared HMS
      ticker we fingerprint every tracked clinical/order collection. When
      the fingerprint changes — because a record was ADDED **or EDITED** —
      we stamp _rev (reusing v226's __twhStampRevs so the server merge picks
      the change as a winner) and fire a HARDENED commit (saveAndCommit →
      _hmsSave). This guarantees creates AND edits reach D1.

   B) EXPLICIT SAVE WRAPPERS: every known create/edit entry point for
      appointments, EMR, lab, radiology, prescriptions, diet orders, etc.
      is wrapped to run the original then commit immediately (debounced),
      so the write lands right away instead of waiting for the ticker.

   Both paths route through the SAME hardened commit and are debounced /
   coalesced, so rapid edits collapse into a few writes (no storm).

   Tracked collections: appointments, labTests, labOrders, radiologyOrders,
   medicalRecords, encounters, prescriptions, physioPlans, rehabPlans,
   physioSessions, dietOrders (+ anything v226 already tracks via
   window.__twhPersistTracked).

   Constraints honoured: no D1 schema change · no /api/state contract
   change · no feature-pack reorder · no core edits · NO new raw
   setInterval / MutationObserver (uses HMS.every + a single self-clearing
   setTimeout for the debounce).

   Guard: window.__twhV261   Diagnostics: window.__twhV261Diag()
   ════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV261) return;
  window.__twhV261 = true;

  var TAG = '[v261]';
  function isFn(f) { return typeof f === 'function'; }
  function D_() { return window.D || null; }
  function log() { try { console.log.apply(console, ['%c' + TAG, 'color:#fff;background:#1e3a8a;padding:1px 6px;border-radius:4px'].concat([].slice.call(arguments))); } catch (_e) {} }

  // Collections whose creates + edits must always reach every user.
  var DEFAULT_TRACKED = [
    'appointments', 'labTests', 'labOrders', 'radiologyOrders', 'medicalRecords',
    'encounters', 'prescriptions', 'physioPlans', 'rehabPlans', 'physioSessions',
    'dietOrders', 'nutritionOrders', 'orders', 'imagingOrders', 'labResults'
  ];
  function tracked() {
    try {
      var t = window.__twhPersistTracked;
      if (Array.isArray(t) && t.length) {
        // union with our defaults so nothing is missed
        var seen = {}, out = [];
        t.concat(DEFAULT_TRACKED).forEach(function (n) { if (!seen[n]) { seen[n] = 1; out.push(n); } });
        return out;
      }
    } catch (_e) {}
    return DEFAULT_TRACKED.slice();
  }

  // ── hardened, debounced commit ────────────────────────────────────────────
  var _commitTimer = null;
  var _commits = 0;
  function commitSoon() {
    if (_commitTimer != null) return;
    _commitTimer = setTimeout(function () { _commitTimer = null; commitNow(); }, 500);
  }
  function commitNow() {
    // stamp revs first so edited records win the server merge
    try { if (isFn(window.__twhStampRevs)) window.__twhStampRevs(); } catch (_e) {}
    var done = false;
    try { if (isFn(window.saveAndCommit)) { window.saveAndCommit({ quiet: true }); done = true; } } catch (_e) {}
    if (!done) { try { if (isFn(window._hmsSave)) { window._hmsSave(); done = true; } } catch (_e) {} }
    if (!done) { try { if (isFn(window._hmsSaveSoon)) { window._hmsSaveSoon(); done = true; } } catch (_e) {} }
    try { if (window.HMS && isFn(window.HMS.markDirty)) window.HMS.markDirty(); } catch (_e) {}
    if (done) _commits++;
    return done;
  }
  window.twhPersistNow = commitNow;

  // ── content fingerprint of the tracked collections ─────────────────────────
  // Cheap rolling hash over id + a few volatile fields per record so we catch
  // both new records (length change) AND edits (status/result/diagnosis edits).
  function fnv(str) {
    var h = 0x811c9dc5;
    for (var i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = (h + ((h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24))) >>> 0; }
    return h >>> 0;
  }
  function collSig(arr) {
    if (!Array.isArray(arr)) return '0';
    var acc = arr.length + '|';
    for (var i = 0; i < arr.length; i++) {
      var r = arr[i];
      if (!r || typeof r !== 'object') { acc += 'x'; continue; }
      // Only hash volatile, meaning-bearing fields — cheap but sensitive to edits.
      acc += (r.id != null ? r.id : i) + ':' + (r._rev != null ? r._rev : '') + ':' +
        (r.status || '') + ':' + (r.result || r.results || '') + ':' +
        (r.diagnosis || '') + ':' + (r.date || r.visitDate || '') + ':' +
        (r.findings || '') + ':' + (r.report || '') + ';';
    }
    return fnv(acc) + '';
  }

  var _lastSig = Object.create(null);
  var _firstPass = true;
  function scan() {
    var D = D_(); if (!D) return;
    var names = tracked();
    var changed = false, changedNames = [];
    for (var i = 0; i < names.length; i++) {
      var n = names[i];
      var sig = collSig(D[n]);
      if (_lastSig[n] === undefined) { _lastSig[n] = sig; continue; }
      if (_lastSig[n] !== sig) { changed = true; changedNames.push(n); _lastSig[n] = sig; }
    }
    if (_firstPass) { _firstPass = false; return; }   // establish baseline silently
    if (changed) {
      try { log('detected create/edit in [' + changedNames.join(', ') + '] — committing to D1'); } catch (_e) {}
      commitSoon();
    }
  }
  window.twhPersistScan = scan;

  // ── explicit save/edit wrappers → immediate commit ─────────────────────────
  var SAVE_FNS = [
    'saveNewRecord', 'editRecord',
    'saveLiteAppointment', 'saveAppointment', 'saveEditRecord', 'saveEditedRecord',
    'saveLabOrder', 'enterLabResult', 'saveLabResult',
    'saveRadiologyOrder', 'completeRadiologyStudyTWH',
    'saveMedicalRecord', 'saveEMR', 'saveClinicalRecord', 'saveVisit', 'saveConsultation',
    'savePrescriptionEdit', 'editPrescription', 'dispensePrescription',
    'saveDietOrder', 'saveWalkInPatient',
    'twhAutoCreateAppointmentFor', 'twhNewApptForPatient', 'convertWaitlistToAppt'
  ];
  function wrapSave(name) {
    var orig = window[name];
    if (!isFn(orig)) return false;
    if (orig.__twhV261) return true;
    var wrapped = function () {
      var r = orig.apply(this, arguments);
      try { commitSoon(); } catch (_e) {}
      return r;
    };
    wrapped.__twhV261 = true;
    try { for (var k in orig) { if (Object.prototype.hasOwnProperty.call(orig, k)) wrapped[k] = orig[k]; } } catch (_e) {}
    window[name] = wrapped;
    return true;
  }
  function installWraps() {
    var n = 0;
    SAVE_FNS.forEach(function (name) { if (wrapSave(name)) n++; });
    return n;
  }

  // ── boot / periodic (idempotent; rides DOMBus + HMS.every, no new timer) ────
  function installAll() { installWraps(); }
  installAll();

  try { if (typeof window.DOMBus !== 'undefined' && isFn(window.DOMBus.register)) { DOMBus.register(function () { installAll(); }); } } catch (_e) {}
  try {
    if (window.HMS && isFn(window.HMS.every)) {
      // Fingerprint scan every 4s (well above the 1s floor) — catches edits that
      // no explicit wrapper covered, then commits through the hardened path.
      window.HMS.every(4000, function () { installAll(); if (window.isLoggedIn) scan(); });
    }
  } catch (_e) {}
  [300, 1000, 2500, 5000, 8000].forEach(function (ms) { setTimeout(installAll, ms); });
  try { window.addEventListener('load', installAll); } catch (_e) {}

  window.__twhV261Diag = function () {
    var wrapped = {};
    SAVE_FNS.forEach(function (n) { wrapped[n] = !!(window[n] && window[n].__twhV261); });
    var sigs = {};
    try { var D = D_(); tracked().forEach(function (n) { sigs[n] = Array.isArray(D && D[n]) ? D[n].length : 0; }); } catch (_e) {}
    return {
      active: true,
      commits: _commits,
      pendingCommit: _commitTimer != null,
      trackedCounts: sigs,
      wrapped: wrapped,
      stampRevsAvailable: isFn(window.__twhStampRevs),
      hardenedCommit: isFn(window.saveAndCommit)
    };
  };

  log('v261 record persistence active');
})();

;

/* ==== /js/208-twh-stable-screen-emr-visibility-v262.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   TWH · STABLE SCREEN + EMR VISIBILITY (v262)
   ────────────────────────────────────────────────────────────────────────
   User request:
     "Fix all pending requests related to the database and storing, also the
      screen being stable / not shaking (data pull-in and pull-out should be
      perfect). Medical records created must be saved and sent to doctors and
      be available for users to see."

   ── PROBLEM 1 · SCREEN SHAKING ON EVERY POLL ────────────────────────────
   Every session re-pulls the shared D1 document every ~10s. When a change is
   detected the core repaints the CONTENT area (#moduleContent) by re-running
   renderModule() and comparing the produced HTML to what's on screen; if they
   differ, it rewrites the DOM. That diff-guard is correct — EXCEPT several of
   the analytics/forecast renderers synthesise display numbers with
   Math.random() **inside the render** (Branch P&L, 13-week cashflow forecast,
   commission dashboards, etc.). So even when the underlying data is identical,
   renderModule() emits DIFFERENT HTML every call → the diff-guard always
   "sees a change" → #moduleContent is rewritten every poll → the screen
   visibly SHAKES / re-lays-out every ~10s and any half-scrolled table jumps.

   FIX (Problem 1): a RANDOM SHIELD around any repaint we did NOT initiate by a
   real user action. During a background/poll repaint we temporarily replace
   Math.random with a DETERMINISTIC seeded generator, so synthetic numbers come
   out IDENTICAL to the previous background paint. Result: the produced HTML is
   byte-identical when the real data hasn't changed → the core's diff-guard
   correctly skips the DOM rewrite → no shaking. Genuine data changes still
   repaint (their real fields differ), and user-initiated navigation restores
   the true Math.random so first paints still look lively/varied.

   ── PROBLEM 2 · DB STORING / PULL-IN-PULL-OUT ────────────────────────────
   We add a light "settle" guard: after any create/edit commit we make sure a
   flush is actually scheduled, and we suppress a poll-merge from clobbering a
   record whose commit hasn't landed yet by nudging the hardened commit again.

   ── PROBLEM 3 · MEDICAL RECORDS → DOCTORS / VISIBLE TO USERS ─────────────
   A medical record only reaches doctors/other users if it is COMMITTED to D1
   before the next pull. We (a) wrap every EMR create/edit/finalize entry point
   to commit immediately through the hardened path, (b) stamp _rev so the edit
   wins the server merge, and (c) ensure a freshly created EMR carries a
   doctorId (falling back to the patient's assigned doctor or the current user
   if they are a doctor) so it shows up on the doctor's profile and matches the
   encounter.

   Constraints honoured: no D1 schema change · no /api/state contract change ·
   no feature-pack reorder · no core edits · NO new raw setInterval /
   MutationObserver (uses HMS.every + DOMBus + self-clearing setTimeout).

   Guard: window.__twhV262   Diagnostics: window.__twhV262Diag()
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV262) return;
  window.__twhV262 = true;

  var TAG = '[v262]';
  function isFn(f) { return typeof f === 'function'; }
  function D_() { return window.D || null; }
  function log() { try { console.log.apply(console, ['%c' + TAG, 'color:#fff;background:#065f46;padding:1px 6px;border-radius:4px'].concat([].slice.call(arguments))); } catch (_e) {} }

  /* ══════════════════════════════════════════════════════════════════════
     PART 1 — RANDOM SHIELD (kills the poll-driven screen shake)
     ══════════════════════════════════════════════════════════════════════ */
  var _realRandom = Math.random;
  var _shieldDepth = 0;               // >0 while a background repaint is running
  var _seed = 0x2545f491;             // deterministic base seed

  // Mulberry32 — fast, deterministic PRNG. Same seed → same stream, so a
  // background repaint reproduces the EXACT synthetic numbers it produced last
  // time and the emitted HTML is stable.
  function makeSeeded(seed) {
    var s = seed >>> 0;
    return function () {
      s |= 0; s = (s + 0x6D2B79F5) | 0;
      var t = Math.imul(s ^ (s >>> 15), 1 | s);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }

  // While shielded, Math.random draws from a generator that is RE-SEEDED to the
  // same base at the START of each shielded region — so two consecutive
  // background paints of the same screen produce identical number streams.
  var _shieldGen = makeSeeded(_seed);
  function shieldedRandom() {
    if (_shieldDepth > 0) return _shieldGen();
    return _realRandom.call(Math);
  }
  // Install our dispatcher once. It is transparent (identical behaviour to the
  // native RNG) whenever the shield is not engaged.
  try { Math.random = shieldedRandom; } catch (_e) {}

  // Run `fn` with the random shield engaged (deterministic numbers).
  function withShield(fn) {
    _shieldDepth++;
    _shieldGen = makeSeeded(_seed);   // reset stream so it's reproducible
    try { return fn(); }
    finally { _shieldDepth--; }
  }
  window.__twhWithRandomShield = withShield;

  // Wrap the core's background repaint entry points so the shield is engaged
  // ONLY for repaints the user did not trigger. The core poll repaint calls
  // window.renderModule() to build #moduleContent HTML — we shield that call.
  var _shieldedRenderModule = false;
  function installRenderModuleShield() {
    var rm = window.renderModule;
    if (!isFn(rm)) return false;
    if (rm.__twhV262shield) return true;
    var wrapped = function () {
      // Shield whenever a background repaint is in flight. `window.__twhBgPaint`
      // is set by our poll hook below; if the flag isn't set this behaves
      // exactly like the original (real randomness for user navigation).
      if (window.__twhBgPaint) {
        return withShield(function () { return rm.apply(this, arguments); }.bind(this));
      }
      return rm.apply(this, arguments);
    };
    wrapped.__twhV262shield = true;
    try { for (var k in rm) { if (Object.prototype.hasOwnProperty.call(rm, k)) wrapped[k] = rm[k]; } } catch (_e) {}
    window.renderModule = wrapped;
    _shieldedRenderModule = true;
    return true;
  }

  // Mark the window of time around a server poll as a "background paint" so the
  // renderModule shield engages. The core emits 'state:changed' after a merge
  // and repaints synchronously right before it; we open the background-paint
  // window slightly ahead using the shared refresh hook.
  var _bgTimer = null;
  function openBgPaintWindow() {
    window.__twhBgPaint = true;
    if (_bgTimer != null) { try { clearTimeout(_bgTimer); } catch (_e) {} }
    // Keep the window open just long enough to cover the synchronous poll
    // repaint, then close it so the next user click paints with real randomness.
    _bgTimer = setTimeout(function () { window.__twhBgPaint = false; _bgTimer = null; }, 400);
  }

  // Hook the poll: wrap window._hmsRefresh so we open the shield window right
  // before it resolves its merge+repaint. Also listen for the state:changed
  // event as a belt-and-braces trigger.
  function installPollShield() {
    var rf = window._hmsRefresh;
    if (isFn(rf) && !rf.__twhV262poll) {
      var wrapped = function () {
        openBgPaintWindow();
        var out = rf.apply(this, arguments);
        // If it returns a promise, keep the window open across the async merge.
        try {
          if (out && isFn(out.then)) {
            openBgPaintWindow();
            out.then(function () { openBgPaintWindow(); }, function () {});
          }
        } catch (_e) {}
        return out;
      };
      wrapped.__twhV262poll = true;
      window._hmsRefresh = wrapped;
    }
    try {
      if (window.HMS && isFn(window.HMS.on) && !window.__twhV262evt) {
        window.__twhV262evt = true;
        window.HMS.on('state:changed', function (info) {
          if (info && info.source === 'refresh') openBgPaintWindow();
        });
      }
    } catch (_e) {}
  }

  /* ══════════════════════════════════════════════════════════════════════
     PART 2 — MEDICAL-RECORD → DOCTOR VISIBILITY + HARDENED COMMIT
     ══════════════════════════════════════════════════════════════════════ */
  var _commitTimer = null, _commits = 0;
  function commitSoon() {
    if (_commitTimer != null) return;
    _commitTimer = setTimeout(function () { _commitTimer = null; commitNow(); }, 400);
  }
  function commitNow() {
    try { if (isFn(window.__twhStampRevs)) window.__twhStampRevs(); } catch (_e) {}
    var done = false;
    try { if (isFn(window.saveAndCommit)) { window.saveAndCommit({ quiet: true }); done = true; } } catch (_e) {}
    if (!done) { try { if (isFn(window._hmsSave)) { window._hmsSave(); done = true; } } catch (_e) {} }
    if (!done) { try { if (isFn(window._hmsSaveSoon)) { window._hmsSaveSoon(); done = true; } } catch (_e) {} }
    try { if (window.HMS && isFn(window.HMS.markDirty)) window.HMS.markDirty(); } catch (_e) {}
    if (done) _commits++;
    return done;
  }

  // Ensure a freshly created medical record carries a doctorId so it appears on
  // the doctor's profile and matches the encounter. Non-destructive: only fills
  // a MISSING doctorId, never overwrites an explicit one.
  function stampEmrDoctor() {
    var D = D_(); if (!D || !Array.isArray(D.medicalRecords)) return;
    var cu = D.currentUser || {};
    for (var i = 0; i < D.medicalRecords.length; i++) {
      var r = D.medicalRecords[i];
      if (!r || typeof r !== 'object') continue;
      if (r.doctorId != null && r.doctorId !== '') continue;
      // 1) patient's assigned doctor
      var did = null;
      try {
        var p = (D.patients || []).find(function (x) { return x.id === r.patientId; });
        if (p && p.doctorId != null) did = p.doctorId;
      } catch (_e) {}
      // 2) current user, if they are a doctor
      if (did == null) {
        try {
          var role = (cu.role || '') + '';
          if (/doctor|physician|consultant/i.test(role) && cu.empId != null) did = cu.empId;
          else if (/doctor|physician|consultant/i.test(role) && cu.id != null) did = cu.id;
        } catch (_e) {}
      }
      if (did != null) r.doctorId = did;
    }
  }

  // Every EMR/medical create/edit/finalize entry point → immediate hardened
  // commit (so it reaches D1 before the next poll) + doctor stamp.
  var EMR_FNS = [
    'saveNewRecord', 'editRecord', 'finalizeRecord',
    'saveMedicalRecord', 'saveEMR', 'saveClinicalRecord', 'saveEncounter',
    'saveConsultation', 'saveVisit', 'addNewRecord'
  ];
  function wrapEmr(name) {
    var orig = window[name];
    if (!isFn(orig)) return false;
    if (orig.__twhV262) return true;
    var wrapped = function () {
      var r = orig.apply(this, arguments);
      try { stampEmrDoctor(); } catch (_e) {}
      try { commitSoon(); } catch (_e) {}
      return r;
    };
    wrapped.__twhV262 = true;
    try { for (var k in orig) { if (Object.prototype.hasOwnProperty.call(orig, k)) wrapped[k] = orig[k]; } } catch (_e) {}
    window[name] = wrapped;
    return true;
  }

  /* ══════════════════════════════════════════════════════════════════════
     BOOT (idempotent; rides DOMBus + HMS.every — no new raw timer/observer)
     ══════════════════════════════════════════════════════════════════════ */
  function installAll() {
    installRenderModuleShield();
    installPollShield();
    EMR_FNS.forEach(wrapEmr);
  }
  installAll();

  try { if (typeof window.DOMBus !== 'undefined' && isFn(window.DOMBus.register)) { DOMBus.register(function () { installAll(); }); } } catch (_e) {}
  try {
    if (window.HMS && isFn(window.HMS.every)) {
      window.HMS.every(5000, function () { installAll(); });
    }
  } catch (_e) {}
  [200, 800, 2000, 4000, 7000].forEach(function (ms) { setTimeout(installAll, ms); });
  try { window.addEventListener('load', installAll); } catch (_e) {}

  window.__twhV262Diag = function () {
    var wrapped = {};
    EMR_FNS.forEach(function (n) { wrapped[n] = !!(window[n] && window[n].__twhV262); });
    return {
      active: true,
      randomShieldInstalled: Math.random === shieldedRandom,
      renderModuleShielded: _shieldedRenderModule && !!(window.renderModule && window.renderModule.__twhV262shield),
      pollShielded: !!(window._hmsRefresh && window._hmsRefresh.__twhV262poll),
      bgPaintActive: !!window.__twhBgPaint,
      shieldDepth: _shieldDepth,
      commits: _commits,
      emrWrapped: wrapped,
      stampRevsAvailable: isFn(window.__twhStampRevs),
      hardenedCommit: isFn(window.saveAndCommit)
    };
  };

  log('v262 stable-screen + EMR visibility active');
})();

;

/* ==== /js/209-twh-save-and-commit-label-hardcommit-v263.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   TWH · "SAVE & COMMIT" LABEL + HARD-COMMIT NET (v263)
   ────────────────────────────────────────────────────────────────────────
   User request:
     "On Create Medical Record, change 'Save Record' so it saves & commits
      directly to the D1 database. Change everywhere in the application that
      has 'Save Record' to 'Save & Commit' — they should all be saved to the
      database and pulled back out. This should also work for appointments,
      laboratory and radiology orders, and user creation."

   WHAT THIS DOES (additive · idempotent · no core edits)
   ------------------------------------------------------------------
   1) LABEL: whenever a modal is on screen we rewrite the primary save/create
      button's caption to "Save & Commit" for every create/edit action that
      writes a record to D1 — Create Medical Record ("Save Record"), lab &
      radiology orders ("Save Order"), appointments, user creation
      ("Create User" / "Add User"), EMR consultations, etc. The button's icon
      is preserved and swapped to a database icon so it reads as a real commit.

   2) HARD COMMIT: the matching save HANDLERS (saveNewRecord, saveUser,
      saveLabOrder, lroSaveNewOrder, saveLiteAppointment, twhSaveConsultation,
      …) are wrapped so that AFTER the original save runs we immediately fire
      the hardened commit chain — __twhStampRevs() (so edits win the server
      merge) then saveAndCommit({quiet:true}) → _hmsSave() — guaranteeing the
      new/edited record reaches the shared D1 document BEFORE the next ~10s
      poll, so every other user pulls it back out and sees it.

   Together: clicking "Save & Commit" (on any of these forms) now both READS
   as a database commit and actually PERFORMS one.

   Constraints honoured: no D1 schema change · no /api/state contract change ·
   no feature-pack reorder · no core edits · NO new raw setInterval /
   MutationObserver (rides DOMBus + HMS.every + a self-clearing setTimeout).

   Guard: window.__twhV263   Diagnostics: window.__twhV263Diag()
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV263) return;
  window.__twhV263 = true;

  var TAG = '[v263]';
  function isFn(f) { return typeof f === 'function'; }
  function log() { try { console.log.apply(console, ['%c' + TAG, 'color:#fff;background:#0f766e;padding:1px 6px;border-radius:4px'].concat([].slice.call(arguments))); } catch (_e) {} }

  var NEW_LABEL = 'Save &amp; Commit';
  var NEW_LABEL_TEXT = 'Save & Commit';
  var COMMIT_ICON = '<i class="fa-solid fa-database"></i> ';

  /* ── hardened, debounced commit ──────────────────────────────────────── */
  var _commitTimer = null, _commits = 0;
  function commitSoon() {
    if (_commitTimer != null) return;
    _commitTimer = setTimeout(function () { _commitTimer = null; commitNow(); }, 350);
  }
  function commitNow() {
    try { if (isFn(window.__twhStampRevs)) window.__twhStampRevs(); } catch (_e) {}
    var done = false;
    try { if (isFn(window.saveAndCommit)) { window.saveAndCommit({ quiet: true }); done = true; } } catch (_e) {}
    if (!done) { try { if (isFn(window._hmsSave)) { window._hmsSave(); done = true; } } catch (_e) {} }
    if (!done) { try { if (isFn(window._hmsSaveSoon)) { window._hmsSaveSoon(); done = true; } } catch (_e) {} }
    try { if (window.HMS && isFn(window.HMS.markDirty)) window.HMS.markDirty(); } catch (_e) {}
    if (done) _commits++;
    return done;
  }
  window.twhSaveAndCommitNow = commitNow;

  /* ── PART 1 · LABEL RELABELLER ──────────────────────────────────────────
     Buttons whose caption should become "Save & Commit". We match on the
     visible caption (case-insensitive, tag-stripped) so we relabel exactly the
     create/edit-to-DB actions and never touch unrelated buttons like Cancel,
     Print, Export, Close, filters, etc. */
  var RELABEL_CAPTIONS = [
    'save record', 'save order', 'create user', 'add user',
    'save medical record', 'save consultation', 'save appointment',
    'save & add to calendar', 'save patient', 'register patient',
    'save lab order', 'save radiology order'
  ];
  // Handlers (in the button's onclick) that indicate a create/edit-to-DB save.
  var RELABEL_HANDLERS = [
    'saveNewRecord', 'saveUser', 'saveLabOrder', 'lroSaveNewOrder',
    'saveLiteAppointment', 'saveAppointment', 'twhSaveConsultation',
    'saveMedicalRecord', 'saveRadiologyOrder'
  ];

  function captionOf(btn) {
    try { return (btn.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase(); } catch (_e) { return ''; }
  }
  function onclickOf(btn) {
    try { return (btn.getAttribute('onclick') || '') + ''; } catch (_e) { return ''; }
  }
  function shouldRelabel(btn) {
    var cap = captionOf(btn);
    if (!cap) return false;
    if (cap === NEW_LABEL_TEXT.toLowerCase()) return false;       // already done
    for (var i = 0; i < RELABEL_CAPTIONS.length; i++) { if (cap === RELABEL_CAPTIONS[i]) return true; }
    // also relabel if the onclick calls a known create handler (covers
    // "Update Order"/"Update Record" edit variants too)
    var oc = onclickOf(btn);
    for (var j = 0; j < RELABEL_HANDLERS.length; j++) {
      if (oc.indexOf(RELABEL_HANDLERS[j]) !== -1) {
        // Keep the natural "Update …" caption for edits; only relabel the
        // create/save captions to avoid confusing an Edit modal.
        if (/^update /.test(cap)) return false;
        return true;
      }
    }
    return false;
  }
  function relabelButton(btn) {
    if (!btn || btn.__twhV263relabelled) return false;
    if (!shouldRelabel(btn)) return false;
    try {
      btn.innerHTML = COMMIT_ICON + NEW_LABEL;
      btn.setAttribute('title', 'Saves and commits directly to the database');
      btn.__twhV263relabelled = true;
      return true;
    } catch (_e) { return false; }
  }

  var _relabelCount = 0;
  function scanAndRelabel() {
    var n = 0;
    try {
      // Only inside modals / their footers — never touch page-level toolbars.
      var scopes = document.querySelectorAll('.modal-ft, .modal-body, #modalBg .modal');
      for (var s = 0; s < scopes.length; s++) {
        var btns = scopes[s].querySelectorAll('button');
        for (var i = 0; i < btns.length; i++) { if (relabelButton(btns[i])) n++; }
      }
    } catch (_e) {}
    _relabelCount += n;
    return n;
  }

  /* ── PART 2 · HARD-COMMIT WRAPPERS ──────────────────────────────────────
     Wrap every known create/edit save handler so the write is force-committed
     to D1 right after it runs. Idempotent; preserves any static flags other
     packs set on the function. */
  var HARD_FNS = [
    'saveNewRecord', 'saveUser', 'saveLabOrder', 'lroSaveNewOrder',
    'saveLiteAppointment', 'saveAppointment', 'twhSaveConsultation',
    'saveMedicalRecord', 'saveRadiologyOrder', 'editRecord', 'finalizeRecord',
    'enterLabResult', 'completeRadiologyStudyTWH'
  ];
  function wrapHard(name) {
    var orig = window[name];
    if (!isFn(orig)) return false;
    if (orig.__twhV263) return true;
    var wrapped = function () {
      var r = orig.apply(this, arguments);
      try { commitSoon(); } catch (_e) {}
      return r;
    };
    wrapped.__twhV263 = true;
    try { for (var k in orig) { if (Object.prototype.hasOwnProperty.call(orig, k)) wrapped[k] = orig[k]; } } catch (_e) {}
    window[name] = wrapped;
    return true;
  }
  function installHard() {
    var n = 0;
    HARD_FNS.forEach(function (name) { if (wrapHard(name)) n++; });
    return n;
  }

  /* ── boot (idempotent; DOMBus for modal-open + HMS.every safety net) ──── */
  function tick() {
    installHard();
    // Relabel only when a modal is actually present (cheap early-out).
    try { if (document.getElementById('modalBg') || document.querySelector('.modal-ft')) scanAndRelabel(); } catch (_e) {}
  }
  tick();

  // DOMBus fires now + on every DOM mutation (rAF-debounced) → catches the
  // moment a modal is injected, so the label is swapped before the user reads it.
  try { if (typeof window.DOMBus !== 'undefined' && isFn(window.DOMBus.register)) { DOMBus.register(tick); } } catch (_e) {}
  try { if (window.HMS && isFn(window.HMS.every)) { window.HMS.every(3000, function () { installHard(); }); } } catch (_e) {}
  [150, 600, 1500, 3500, 6000].forEach(function (ms) { setTimeout(tick, ms); });
  try { window.addEventListener('load', tick); } catch (_e) {}

  window.__twhV263Diag = function () {
    var wrapped = {};
    HARD_FNS.forEach(function (n) { wrapped[n] = !!(window[n] && window[n].__twhV263); });
    return {
      active: true,
      relabelled: _relabelCount,
      commits: _commits,
      pendingCommit: _commitTimer != null,
      handlersWrapped: wrapped,
      stampRevsAvailable: isFn(window.__twhStampRevs),
      hardenedCommit: isFn(window.saveAndCommit)
    };
  };

  log('v263 Save & Commit label + hard-commit active');
})();

;

/* ==== /js/210-twh-autosave-nonblock-patient-v264.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   TWH · AUTO SAVE-&-COMMIT + NON-BLOCKING PATIENT CREATE (v264)
   ────────────────────────────────────────────────────────────────────────
   User request:
     • "Uploading chunk 3/8…" / "Reconnecting… retrying in 12s" — saves feel
       slow / stuck.
     • "Unable to create patient, it keeps hanging."
     • "Write a script so that 'You have unsaved changes on this page'
       auto-Saves & commits to the database."
     • "Patient page should be made easy to create a patient."

   ── WHY PATIENT CREATE HANGS ────────────────────────────────────────────
   saveLitePatient() (v253) DISABLES the Save button ("Committing…") and then
   AWAITS window.saveAndCommit(), which itself awaits waitForSettle() — a poll
   that only resolves when the sync chip flips to 'idle'. When the transport is
   doing a slow multi-chunk upload of the whole ~2 MB document, or has dropped
   into the "Reconnecting… retry in 12s" back-off, that promise stays pending
   for many seconds → the modal is stuck on "Committing…" and the user thinks
   the app froze. The record is actually already in memory; only the UI is
   blocked waiting on the network round-trip it never needed to wait for.

   ── FIX 1 · NON-BLOCKING (OPTIMISTIC) CREATE ────────────────────────────
   We wrap saveLitePatient (and the generic saveNewRecord path) so the UI is
   NEVER blocked on the network: the record is pushed into D, the modal is
   closed and the list re-rendered IMMEDIATELY, a success toast shows, and the
   commit is fired in the BACKGROUND (fire-and-forget hardened commit with
   retry). If the button was disabled by the original handler we re-enable it
   and close the modal on a short safety timer so it can never stay stuck.

   ── FIX 2 · AUTO SAVE-&-COMMIT ON "UNSAVED CHANGES" ─────────────────────
   Whenever the app is dirty (HMS.dirty or the v248 page-dirty bar is showing),
   we auto-fire a debounced background commit so the user never has to click
   "Save & Commit" — the "You have unsaved changes" banner clears itself once
   the write settles. We also commit on beforeunload / visibilitychange:hidden
   / pagehide so nothing is lost when the tab closes.

   ── FIX 3 · EASY PATIENT CREATE ─────────────────────────────────────────
   Ensure the FAST (lite) patient form is the default opener for
   addNewRecord('patients') / Register Patient, so creating a patient is a
   short essential-fields form, not the heavy multi-section builder.

   Constraints honoured: no D1 schema change · no /api/state contract change ·
   no feature-pack reorder · no core edits · NO new raw setInterval /
   MutationObserver (rides DOMBus + HMS.every + self-clearing setTimeout).

   Guard: window.__twhV264   Diagnostics: window.__twhV264Diag()
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV264) return;
  window.__twhV264 = true;

  var TAG = '[v264]';
  function isFn(f) { return typeof f === 'function'; }
  function log() { try { console.log.apply(console, ['%c' + TAG, 'color:#fff;background:#0891b2;padding:1px 6px;border-radius:4px'].concat([].slice.call(arguments))); } catch (_e) {} }

  /* ── background hardened commit (never blocks the UI) ─────────────────── */
  function commitBackground() {
    try { if (isFn(window.__twhStampRevs)) window.__twhStampRevs(); } catch (_e) {}
    // Prefer the soft, non-awaiting path first so we never hold the caller.
    var fired = false;
    try { if (isFn(window._hmsSaveSoon)) { window._hmsSaveSoon(); fired = true; } } catch (_e) {}
    try { if (isFn(window.saveAndCommit)) { window.saveAndCommit({ quiet: true }); fired = true; } } catch (_e) {}
    if (!fired) { try { if (isFn(window._hmsSave)) { window._hmsSave(); fired = true; } } catch (_e) {} }
    try { if (window.HMS && isFn(window.HMS.markDirty)) window.HMS.markDirty(); } catch (_e) {}
    return fired;
  }
  window.twhCommitBackground = commitBackground;

  /* ══════════════════════════════════════════════════════════════════════
     FIX 1 · NON-BLOCKING PATIENT CREATE
     ══════════════════════════════════════════════════════════════════════ */
  // Real (unwrapped) commit fn captured on first use so our shim can still
  // trigger the genuine D1 write in the background.
  function realSaveAndCommit() {
    try { if (isFn(window.saveAndCommit) && !window.saveAndCommit.__twhShim) return window.saveAndCommit; } catch (_e) {}
    try { if (isFn(window.__twhRealSaveAndCommit)) return window.__twhRealSaveAndCommit; } catch (_e) {}
    return null;
  }

  // THE CORE OF THE FIX ────────────────────────────────────────────────────
  // The v253 saveLitePatient does:
  //     saveAndCommit({quiet:true}).then(finish)   // finish() closes the modal
  // and RETURNS before finish runs, so the modal only closes once the promise
  // settles. When the network stalls (chunked upload / "Reconnecting… 12s"),
  // that promise never settles and the modal is stuck on "Committing…".
  //
  // We run the original with saveAndCommit TEMPORARILY replaced by a shim that
  // resolves IMMEDIATELY ({ok:true}) — so finish() fires right away, the modal
  // closes and the list repaints with the new row. The shim ALSO kicks off the
  // real commit in the background (fire-and-forget with retry) so the record
  // actually reaches D1. The UI never waits on the network again.
  function runNonBlocking(orig, thisArg, args, btnId) {
    var real = realSaveAndCommit();
    var prev = window.saveAndCommit;
    var shim = function () {
      // fire the genuine commit in the background — do NOT await it
      try { if (real) { var pr = real({ quiet: true }); if (pr && isFn(pr.catch)) pr.catch(function () {}); } } catch (_e) {}
      try { commitBackground(); } catch (_e) {}
      // resolve instantly so the caller's .then(finish) closes the modal now
      return Promise.resolve({ ok: true, changed: true, __twhOptimistic: true });
    };
    shim.__twhShim = true;
    var out;
    try {
      window.saveAndCommit = shim;
      out = orig.apply(thisArg, args);
    } catch (e) {
      try { if (isFn(window.toast)) window.toast('Could not save — ' + (e && e.message || e), 'err'); } catch (_e) {}
    } finally {
      // restore the genuine fn on the next tick (after the sync body has run)
      var restore = function () { try { window.saveAndCommit = prev; } catch (_e) {} };
      try { setTimeout(restore, 0); } catch (_e) { restore(); }
    }
    // Belt-and-braces: even if the original ignored our shim, force-release the
    // button + close a lingering "Committing…" modal fast.
    releaseSaveButtonSoon(btnId, 350);
    return out;
  }

  // Safety net: guarantee the modal is never left stuck on a disabled
  // "Committing…" spinner, regardless of how long (or whether) the net settles.
  function releaseSaveButtonSoon(btnId, delay) {
    var ids = btnId ? [btnId] : ['lp_saveBtn', 'la_saveBtn'];
    setTimeout(function () {
      try {
        var stillCommitting = false;
        for (var i = 0; i < ids.length; i++) {
          var b = document.getElementById(ids[i]);
          if (b) {
            if (b.disabled) b.disabled = false;
            if (/committing/i.test(b.textContent || '')) stillCommitting = true;
          }
        }
        // A create modal still showing "Committing…" ⇒ close it; the record is
        // already in D and committing in the background.
        if (stillCommitting && isFn(window.closeModal)) window.closeModal();
      } catch (_e) {}
    }, delay || 700);
  }

  function wrapLitePatient() {
    var orig = window.saveLitePatient;
    if (!isFn(orig)) return false;
    if (orig.__twhV264) return true;
    var wrapped = function () {
      var before = 0;
      try { before = (window.D && window.D.patients && window.D.patients.length) || 0; } catch (_e) {}
      var r = runNonBlocking(orig, this, arguments, 'lp_saveBtn');
      // If a patient was appended, make sure a background commit is scheduled
      // (covers the fallback branches inside the original that don't use
      // saveAndCommit at all).
      try {
        var after = (window.D && window.D.patients && window.D.patients.length) || 0;
        if (after > before) { commitBackground(); }
      } catch (_e) {}
      return r;
    };
    wrapped.__twhV264 = true;
    try { for (var k in orig) { if (Object.prototype.hasOwnProperty.call(orig, k)) wrapped[k] = orig[k]; } } catch (_e) {}
    window.saveLitePatient = wrapped;
    return true;
  }

  // Also cover the lite appointment saver (same disabled-button pattern).
  function wrapLiteAppointment() {
    var orig = window.saveLiteAppointment;
    if (!isFn(orig)) return false;
    if (orig.__twhV264) return true;
    var wrapped = function () {
      var r = runNonBlocking(orig, this, arguments, 'la_saveBtn');
      try { commitBackground(); } catch (_e) {}
      return r;
    };
    wrapped.__twhV264 = true;
    try { for (var k in orig) { if (Object.prototype.hasOwnProperty.call(orig, k)) wrapped[k] = orig[k]; } } catch (_e) {}
    window.saveLiteAppointment = wrapped;
    return true;
  }

  /* ══════════════════════════════════════════════════════════════════════
     FIX 3 · EASY PATIENT CREATE (fast form is the default)
     ══════════════════════════════════════════════════════════════════════ */
  // If a fast opener exists, route the generic "Register Patient" through it so
  // the user gets the short essential-fields form instead of the heavy builder.
  function ensureFastPatientOpener() {
    try {
      var opener = window.openLitePatientForm || window.openFullPatientForm; // v250/v253 expose openLitePatientForm
      if (!isFn(opener)) return false;
      var addOrig = window.addNewRecord;
      if (!isFn(addOrig)) return false;
      if (addOrig.__twhV264fast) return true;
      var wrapped = function (dataKey) {
        if (dataKey === 'patients' && !window.__twhEditingRecord && isFn(window.openLitePatientForm)) {
          try { return window.openLitePatientForm(); } catch (_e) {}
        }
        return addOrig.apply(this, arguments);
      };
      wrapped.__twhV264fast = true;
      try { for (var k in addOrig) { if (Object.prototype.hasOwnProperty.call(addOrig, k)) wrapped[k] = addOrig[k]; } } catch (_e) {}
      window.addNewRecord = wrapped;
      return true;
    } catch (_e) { return false; }
  }

  /* ══════════════════════════════════════════════════════════════════════
     FIX 2 · AUTO SAVE-&-COMMIT ON "UNSAVED CHANGES"
     ══════════════════════════════════════════════════════════════════════ */
  var _autoTimer = null, _autoCommits = 0, _lastAuto = 0;
  function isDirty() {
    try { if (window.HMS && window.HMS.dirty) return true; } catch (_e) {}
    // v248 page-dirty bar visible → treat as dirty
    try {
      var bar = document.getElementById('twhPageCommitBar') ||
                document.querySelector('[id*="PageCommit"], [id*="pageCommit"]');
      if (bar && bar.style && bar.style.display !== 'none' && bar.offsetParent !== null) return true;
    } catch (_e) {}
    return false;
  }
  function autoCommitIfDirty() {
    if (!window.isLoggedIn) return;
    if (!isDirty()) return;
    // Never auto-commit while a modal editor is open or the user is typing —
    // the core defers pulls in that state; we mirror it so we don't fight edits.
    try { if (document.getElementById('modalBg')) return; } catch (_e) {}
    var now = Date.now();
    if (now - _lastAuto < 2500) return;   // rate-limit: at most ~1 auto-commit / 2.5s
    _lastAuto = now;
    if (_autoTimer != null) return;
    _autoTimer = setTimeout(function () {
      _autoTimer = null;
      if (commitBackground()) { _autoCommits++; }
    }, 400);
  }
  window.twhAutoCommitNow = autoCommitIfDirty;

  // Commit on tab close / hide so nothing is lost.
  function flushHard() {
    try { if (isFn(window.__twhStampRevs)) window.__twhStampRevs(); } catch (_e) {}
    try { if (isFn(window._hmsFlush)) { window._hmsFlush(); return; } } catch (_e) {}
    try { if (isFn(window._hmsSave)) window._hmsSave(); } catch (_e) {}
  }
  try {
    window.addEventListener('beforeunload', function () { if (isDirty()) flushHard(); });
    window.addEventListener('pagehide', function () { if (isDirty()) flushHard(); });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden' && isDirty()) flushHard();
    });
  } catch (_e) {}

  /* ── boot (idempotent; DOMBus + HMS.every; no new raw timer/observer) ──── */
  function installAll() {
    wrapLitePatient();
    wrapLiteAppointment();
    ensureFastPatientOpener();
  }
  installAll();

  try { if (typeof window.DOMBus !== 'undefined' && isFn(window.DOMBus.register)) { DOMBus.register(function () { installAll(); }); } } catch (_e) {}
  try {
    if (window.HMS && isFn(window.HMS.every)) {
      // Re-assert wraps + run the auto-commit sweep on the shared ticker.
      window.HMS.every(2500, function () { installAll(); autoCommitIfDirty(); });
    }
  } catch (_e) {}
  [200, 700, 1800, 4000, 7000].forEach(function (ms) { setTimeout(installAll, ms); });
  try { window.addEventListener('load', installAll); } catch (_e) {}

  window.__twhV264Diag = function () {
    return {
      active: true,
      litePatientWrapped: !!(window.saveLitePatient && window.saveLitePatient.__twhV264),
      liteAppointmentWrapped: !!(window.saveLiteAppointment && window.saveLiteAppointment.__twhV264),
      fastPatientOpener: !!(window.addNewRecord && window.addNewRecord.__twhV264fast),
      autoCommits: _autoCommits,
      dirtyNow: isDirty(),
      hardenedCommit: isFn(window.saveAndCommit),
      softSave: isFn(window._hmsSaveSoon)
    };
  };

  log('v264 auto Save & Commit + non-blocking patient create active');
})();

;

/* ==== /js/211-twh-standalone-registration-route-v265.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   TWH · STANDALONE PATIENT REGISTRATION ROUTE (v265)
   ────────────────────────────────────────────────────────────────────────
   User request: "the same hanging is pending … can we create a separate page
   for registration of patient to solve this error and issues".

   WHY A SEPARATE PAGE IS THE PERMANENT ANSWER
   The "Page Unresponsive" freeze on the in-app Register Patient modal is caused
   by the sheer weight of the 192-pack runtime reacting to the large form (DOM
   sweeps, render governor, periodic tickers) — not by any single bug. Rather
   than keep chasing every contributor, we give patient registration its OWN
   isolated page (/register.html) that loads NONE of that machinery: no DOMBus,
   no MutationObserver, no render governor, no HMS.every tickers. It writes the
   new patient straight to the SAME D1 state API the SPA uses (per-collection
   merge), so records still appear for every user on their next pull. A page
   that runs almost no JS cannot go "unresponsive".

   THIS MODULE (inside the SPA) simply routes "Register Patient" to that page:
     • addNewRecord('patients')  → navigates to /register.html
     • a small "⚡ Fast Register" launcher is injected on the Patients screen.
   Editing an existing patient is untouched (stays in the app).

   Toggle: window.TWH_STANDALONE_REGISTER (default true). Set false to fall back
   to the in-app lite form (v264).

   Constraints: no D1 schema / /api/state contract / _redirects / worker change;
   no feature-pack reorder; no core edits; NO new setInterval / MutationObserver
   (rides DOMBus + HMS.every + one-shot setTimeout).

   Guard: window.__twhV265   Diagnostics: window.__twhV265Diag()
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV265) return;
  window.__twhV265 = true;

  var PAGE = '/register.html';
  if (typeof window.TWH_STANDALONE_REGISTER === 'undefined') window.TWH_STANDALONE_REGISTER = true;
  // User request: "make [Register Patient] active and functional by opening the
  // link and allow to fill the form." The shared __twhNavigate seam (v305) turns
  // navigation into a NEW-TAB window.open() when TWH_FASTLINK_NEW_TAB is on —
  // which browsers can silently BLOCK as a popup, so the registration form never
  // opens. To make the link reliably open, navigate in the SAME tab by default
  // (a top-level navigation is never popup-blocked). Flip to false to restore
  // the new-tab seam behaviour.
  if (typeof window.TWH_REGISTER_SAME_TAB === 'undefined') window.TWH_REGISTER_SAME_TAB = true;

  function isFn(f) { return typeof f === 'function'; }
  function on() { return !!window.TWH_STANDALONE_REGISTER; }
  function log() { try { console.log.apply(console, ['[v265]'].concat([].slice.call(arguments))); } catch (_e) {} }

  function goRegister() {
    // Same-tab REAL navigation first (default). The registration form lives on
    // the standalone /register.html page, so it can only be filled after a real
    // top-level navigation. We must NOT use the __twhNavigate / __twhSameTabNav
    // seams here: v311 maps /register.html back to the 'patients' module and does
    // an in-app goTo('patients') swap (URL_TO_MOD), which just re-renders the
    // patient LIST and never opens the form — the exact "not functional" symptom.
    // A direct location.assign() always loads the page (never popup-blocked, and
    // not swallowed by the in-app router), so the form always opens.
    if (window.TWH_REGISTER_SAME_TAB !== false) {
      try { if (isFn(window.__twhHardNav)) { window.__twhHardNav(PAGE); return; } } catch (_e) {}
      try { window.location.assign(PAGE); return; } catch (_e) {}
      try { window.location.href = PAGE; return; } catch (_e) {}
      try { window.open(PAGE, '_self'); return; } catch (_e) {}
    }
    // Opt-in seam path (tests / hosts that want to intercept without a load).
    try { if (isFn(window.__twhNavigate)) { window.__twhNavigate(PAGE); return; } } catch (_e) {}
    try { window.location.assign(PAGE); return; } catch (_e) {}
    try { window.location.href = PAGE; return; } catch (_e) {}
    try { window.open(PAGE, '_self'); } catch (_e) {}
  }
  window.twhOpenRegisterPage = goRegister;

  /* ── Route addNewRecord('patients') to the standalone page ─────────────── */
  function wrapAddNewRecord() {
    var orig = window.addNewRecord;
    if (!isFn(orig)) return false;
    if (orig.__twhV265) return true;
    var wrapped = function (dataKey) {
      if (on() && dataKey === 'patients' && !window.__twhEditingRecord) {
        goRegister();
        return;
      }
      return orig.apply(this, arguments);
    };
    wrapped.__twhV265 = true;
    // preserve any flags other wrappers set (e.g. v264's __twhV264fast)
    try { for (var k in orig) { if (Object.prototype.hasOwnProperty.call(orig, k)) wrapped[k] = orig[k]; } } catch (_e) {}
    window.addNewRecord = wrapped;
    return true;
  }

  /* ── Fast Register launcher now lives in the SIDEBAR (v318), not in the
     module content area. Per user request "Remove all from dashboard and move
     to sidebar … Fast Register (stable page) under Patients on the sidebar",
     the sidebar link is injected by 254-twh-fast-launchers-sidebar-v318.js
     (which calls window.twhOpenRegisterPage). This function is kept only to
     REMOVE any legacy #moduleContent button left by an older cached build. */
  var BTN_ID = 'twhFastRegisterBtn';
  function injectLauncher() {
    try { var ex = document.getElementById(BTN_ID); if (ex) ex.remove(); } catch (_e) {}
  }

  /* ── boot (idempotent; rides DOMBus + HMS.every + staggered one-shots) ─── */
  function installAll() { wrapAddNewRecord(); injectLauncher(); }
  installAll();

  try { if (typeof window.DOMBus !== 'undefined' && isFn(window.DOMBus.register)) { window.DOMBus.register(installAll); } } catch (_e) {}
  try { if (window.HMS && isFn(window.HMS.every)) { window.HMS.every(3000, installAll); } } catch (_e) {}
  [200, 700, 1800, 4000].forEach(function (ms) { setTimeout(installAll, ms); });
  try { window.addEventListener('load', installAll); } catch (_e) {}

  window.__twhV265Diag = function () {
    return {
      active: true,
      standaloneEnabled: on(),
      addNewRecordRouted: !!(window.addNewRecord && window.addNewRecord.__twhV265),
      launcherPresent: !!document.getElementById(BTN_ID),
      page: PAGE
    };
  };

  log('register route → ' + PAGE);
})();

;

/* ==== /js/212-twh-standalone-record-routes-v266.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   TWH · STANDALONE RECORD-ENTRY ROUTES (v266)
   ────────────────────────────────────────────────────────────────────────
   User request (extends v265): "Let the separate page for the registered
   patient be detailed. Also create separate pages for new appointment, new
   order for medical records, laboratory, and radiology and all should sync
   back to Database and frontend with save and commit."

   v265 gave patient registration its own isolated /register.html so the big
   form could never freeze the SPA. v266 extends the SAME pattern to the other
   heavy data-entry flows. Each has its own page that loads NONE of the
   192-pack runtime (no DOMBus, no MutationObserver, no render governor, no
   HMS.every tickers), and writes straight to the SAME D1 state API with a
   per-collection merge PUT — so records still sync to the database and appear
   in the SPA for every user on their next pull:

       addNewRecord('patients')        → /register.html
       addNewRecord('appointments')    → /appointment.html
       addNewRecord('medicalRecords')  → /medical-record.html
       addNewRecord('labTests')        → /laboratory.html
       newRadiologyOrder()             → /radiology.html

   A "⚡ Fast … (stable page)" launcher is also injected on each relevant
   module screen. Editing an existing record is untouched (stays in the app).

   Toggle: window.TWH_STANDALONE_PAGES (default true). Also honours the v265
   flag window.TWH_STANDALONE_REGISTER for the patients route specifically.

   Constraints: no D1 schema / /api/state contract / _redirects / worker change;
   no feature-pack reorder; no core edits; NO new setInterval / MutationObserver
   (rides DOMBus + HMS.every + one-shot setTimeout).

   Guard: window.__twhV266   Diagnostics: window.__twhV266Diag()
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV266) return;
  window.__twhV266 = true;

  if (typeof window.TWH_STANDALONE_PAGES === 'undefined') window.TWH_STANDALONE_PAGES = true;
  // Same-tab REAL navigation by default (see go() below). The shared
  // __twhNavigate / __twhSameTabNav seams route these paths back to their SPA
  // module and do an in-app goTo() swap (v311 URL_TO_MOD) that just re-renders
  // the LIST — the record-entry FORM never opens. A direct top-level navigation
  // always loads the standalone page, so the form always opens. Flip to false
  // to restore the seam behaviour.
  if (typeof window.TWH_RECORD_SAME_TAB === 'undefined') window.TWH_RECORD_SAME_TAB = true;

  // Map: SPA dataKey → { page, label, moduleWords (for launcher heuristic) }
  var ROUTES = {
    patients:       { page: '/register.html',       label: 'Register',   words: /patient/i },
    appointments:   { page: '/appointment.html',    label: 'Appointment', words: /appointment|schedul/i },
    medicalRecords: { page: '/medical-record.html', label: 'Medical Record', words: /medical record|clinical|emr|records/i },
    labTests:       { page: '/laboratory.html',      label: 'Lab Order',  words: /laborator|lab test|patholog/i },
    radiologyOrders:{ page: '/radiology.html',       label: 'Radiology',  words: /radiolog|imaging/i }
  };

  function isFn(f) { return typeof f === 'function'; }
  function on(dataKey) {
    if (!window.TWH_STANDALONE_PAGES) return false;
    if (dataKey === 'patients' && typeof window.TWH_STANDALONE_REGISTER !== 'undefined')
      return !!window.TWH_STANDALONE_REGISTER;
    return true;
  }
  function log() { try { console.log.apply(console, ['[v266]'].concat([].slice.call(arguments))); } catch (_e) {} }

  // Direct top-level navigation fallbacks (never popup-blocked, never swallowed
  // by the in-app router). Shared by both go() branches.
  function hard(page) {
    try { window.location.assign(page); return; } catch (_e) {}
    try { window.location.href = page; } catch (_e) {}
  }
  function go(page) {
    // Same-tab REAL navigation first (default). Do NOT use __twhNavigate here:
    // v311 maps these pages back to their SPA module and does an in-app goTo()
    // swap (URL_TO_MOD) that re-renders the LIST and never opens the form — the
    // "not functional" symptom. A direct location.assign() always loads the
    // standalone record-entry page so the fillable form always opens.
    if (window.TWH_RECORD_SAME_TAB !== false) {
      try { if (isFn(window.__twhHardNav)) { window.__twhHardNav(page); return; } } catch (_e) {}
      hard(page); return;
    }
    // Opt-in seam path (tests / hosts that want to intercept without a load).
    try { if (isFn(window.__twhNavigate)) { window.__twhNavigate(page); return; } } catch (_e) {}
    hard(page);
  }
  window.twhOpenStandalonePage = go;

  /* ── Route addNewRecord(dataKey) to the matching standalone page ─────────
     NOTE: v265 already wraps addNewRecord for 'patients'. We wrap again for the
     rest; both wrappers are idempotent and cooperate (v265's wrapper handles
     patients and delegates the rest to us via the original chain). */
  function wrapAddNewRecord() {
    var orig = window.addNewRecord;
    if (!isFn(orig)) return false;
    if (orig.__twhV266) return true;
    var wrapped = function (dataKey) {
      var r = ROUTES[dataKey];
      // patients is owned by v265's wrapper; only intercept the others here to
      // avoid double navigation. (If v265 is absent we still handle patients.)
      if (r && dataKey !== 'patients' && on(dataKey) && !window.__twhEditingRecord) {
        go(r.page);
        return;
      }
      if (r && dataKey === 'patients' && on('patients') && !window.__twhEditingRecord &&
          !(window.addNewRecord && window.addNewRecord.__twhV265)) {
        go(r.page);
        return;
      }
      return orig.apply(this, arguments);
    };
    wrapped.__twhV266 = true;
    try { for (var k in orig) { if (Object.prototype.hasOwnProperty.call(orig, k)) wrapped[k] = orig[k]; } } catch (_e) {}
    window.addNewRecord = wrapped;
    return true;
  }

  /* ── Route newRadiologyOrder() (radiology has its own opener) ──────────── */
  function wrapRadiology() {
    var orig = window.newRadiologyOrder;
    if (!isFn(orig)) return false;
    if (orig.__twhV266) return true;
    var wrapped = function () {
      if (on('radiologyOrders') && !window.__twhEditingRecord) { go(ROUTES.radiologyOrders.page); return; }
      return orig.apply(this, arguments);
    };
    wrapped.__twhV266 = true;
    try { for (var k in orig) { if (Object.prototype.hasOwnProperty.call(orig, k)) wrapped[k] = orig[k]; } } catch (_e) {}
    window.newRadiologyOrder = wrapped;
    return true;
  }

  /* ── Fast launchers now live in the SIDEBAR (v318), not in the module
     content area. Per user request "Remove all from dashboard and move to
     sidebar" (Fast Appointment under Appointments, Fast Medical Record under
     Medical Records, Fast Lab Order under Laboratory, Fast Radiology under
     Radiology), the sidebar links are injected by
     254-twh-fast-launchers-sidebar-v318.js (which calls
     window.twhOpenStandalonePage with each ROUTE page). This function is kept
     only to REMOVE any legacy #moduleContent button left by an older cached
     build. */
  var BTN_ID = 'twhFastRecordBtn';
  function injectLauncher() {
    try { var ex = document.getElementById(BTN_ID); if (ex) ex.remove(); } catch (_e) {}
  }

  /* ── boot (idempotent; rides DOMBus + HMS.every + staggered one-shots) ─── */
  function installAll() { wrapAddNewRecord(); wrapRadiology(); injectLauncher(); }
  installAll();

  try { if (typeof window.DOMBus !== 'undefined' && isFn(window.DOMBus.register)) { window.DOMBus.register(installAll); } } catch (_e) {}
  try { if (window.HMS && isFn(window.HMS.every)) { window.HMS.every(3000, installAll); } } catch (_e) {}
  [200, 700, 1800, 4000].forEach(function (ms) { setTimeout(installAll, ms); });
  try { window.addEventListener('load', installAll); } catch (_e) {}

  window.__twhV266Diag = function () {
    return {
      active: true,
      enabled: !!window.TWH_STANDALONE_PAGES,
      addNewRecordRouted: !!(window.addNewRecord && window.addNewRecord.__twhV266),
      radiologyRouted: !!(window.newRadiologyOrder && window.newRadiologyOrder.__twhV266),
      launcherPresent: !!document.getElementById(BTN_ID),
      routes: Object.keys(ROUTES).reduce(function (o, k) { o[k] = ROUTES[k].page; return o; }, {})
    };
  };

  log('record routes active');
})();

;

/* ==== /js/213-twh-pull-reconcile-diagnostics-v267.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   TWH · PULL-BACK RECONCILE + LIVE KPI/LIST REFRESH (v267)
   ────────────────────────────────────────────────────────────────────────
   User request: "All created records of medical record should always update
   the KPI of the page and all should also be listed for proper update. Same
   thing should be implemented on laboratory and radiology."

   ROOT CAUSE
   The standalone data-entry pages (v265/v266: /register, /appointment,
   /medical-record, /laboratory, /radiology) write straight to the SAME D1
   state document and the write PERSISTS correctly (verified: PUT merges the
   collection server-side). But the SPA only reads the whole state ONCE at
   boot (module 002). All the existing "sync" packs push LOCAL writes UP to
   the server — none of them pull the server's newer records back DOWN into
   the live `D`. So after creating a record on a standalone page and returning
   to the SPA, the Medical Record / Laboratory / Radiology KPI cards and tables
   still show the stale (often 0) count until a full reload.

   FIX
   A lightweight pull-back reconciler. On tab focus/visibility regain (and on a
   slow steady-state cadence), GET /api/state, and for every array collection
   union in any records whose `id` is NOT already in the live `D` (append-only:
   we never overwrite a locally-edited record and never delete). If anything
   new landed — especially for a collection the current screen renders — call
   window.render() so the KPI cards and lists update immediately.

   This is append/merge only, so it can never clobber an in-flight local edit,
   and it honours the server as the source of truth for records created
   elsewhere (other tabs, other users, the standalone pages).

   CONSTRAINTS (unchanged):
   • No D1 schema / /api/state contract / _redirects / worker change.
   • No feature-pack reorder, no core edits.
   • NO new raw setInterval and NO new MutationObserver — rides the shared
     HMS.every() ticker (which itself re-runs due tasks on visibilitychange)
     plus one focus listener. Perf-guard safe.

   Guard: window.__twhV267     Diagnostics: window.__twhV267Diag()
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  if (window.__twhV267) return;
  window.__twhV267 = true;

  var ENDPOINT = window._HMS_API_ENDPOINT ||
    ('/api/state/' + (window._HMS_STORAGE_KEY || 'MCP_HMS_DATA_v17'));

  // Collections the standalone data-entry pages create, plus the closely
  // related clinical lists. We reconcile ONLY these (not all ~150 tables) so a
  // pull stays cheap even though the full document is large (e.g. customers is
  // 7k+, feeSchedule 490+, inventory 8k+ — none of which the standalone pages
  // touch). This is the exact set the user's request names ("medical record …
  // laboratory and radiology") plus appointments/prescriptions for parity.
  // Override at runtime with window.TWH_RECONCILE_COLLECTIONS = [...].
  var RECONCILE_COLLECTIONS = window.TWH_RECONCILE_COLLECTIONS || [
    'medicalRecords', 'labTests', 'radiologyOrders', 'appointments',
    'prescriptions', 'labOrders'
  ];

  // Subset whose growth drives KPI cards / list tables / sidebar badges.
  var DIAG_COLLECTIONS = ['medicalRecords', 'labTests', 'radiologyOrders', 'appointments'];

  // Map SPA module id → the collection whose changes should trigger a repaint
  // of that screen. Used to decide when a pulled record warrants render().
  var MODULE_COLLECTION = {
    emr: 'medicalRecords',
    lab: 'labTests',
    radiology: 'radiologyOrders',
    rad: 'radiologyOrders',
    appointments: 'appointments',
    appt: 'appointments',
    dashboard: '*'   // dashboard shows aggregate counts → repaint on any change
  };

  var _diag = { pulls: 0, merged: 0, lastMerged: {}, lastErr: null, lastAt: 0, renders: 0 };
  window.__twhV267Diag = function () { return JSON.parse(JSON.stringify(_diag)); };

  function liveD() { return window.D && typeof window.D === 'object' ? window.D : null; }

  // Build a Set of existing ids for a collection (numbers + strings coerced to
  // string so 1 and "1" compare equal).
  function idSet(arr) {
    var s = Object.create(null);
    for (var i = 0; i < arr.length; i++) {
      var r = arr[i];
      if (r && r.id != null) s[String(r.id)] = true;
    }
    return s;
  }

  // Merge server's newer records into live D. Append-only union by id.
  // Returns a map { collection: countAdded } of what actually changed.
  function reconcile(serverDoc) {
    var D = liveD();
    if (!D || !serverDoc || typeof serverDoc !== 'object') return {};
    var added = {};
    // Respect server tombstones so a record deleted elsewhere doesn't get
    // resurrected into a stale local view.
    var dels = serverDoc.__deletedIds && typeof serverDoc.__deletedIds === 'object'
      ? serverDoc.__deletedIds : {};

    RECONCILE_COLLECTIONS.forEach(function (key) {
      var incoming = serverDoc[key];
      if (!Array.isArray(incoming)) return;            // only reconcile record arrays
      if (!Array.isArray(D[key])) D[key] = [];
      var localArr = D[key];
      var have = idSet(localArr);
      var tomb = Array.isArray(dels[key])
        ? (function () { var t = Object.create(null); dels[key].forEach(function (id) { t[String(id)] = true; }); return t; })()
        : null;
      var n = 0;
      for (var i = 0; i < incoming.length; i++) {
        var rec = incoming[i];
        if (!rec || rec.id == null) continue;
        var sid = String(rec.id);
        if (have[sid]) continue;                       // already present locally
        if (tomb && tomb[sid]) continue;               // deleted elsewhere
        localArr.push(rec);
        have[sid] = true;
        n++;
      }
      if (n) added[key] = n;
    });
    return added;
  }

  // Should we repaint the current screen given what changed?
  function shouldRender(added) {
    if (!added || !Object.keys(added).length) return false;
    var mod = (typeof window.currentMod === 'string' && window.currentMod) || '';
    var want = MODULE_COLLECTION[mod];
    if (want === '*') return true;                      // dashboard: any change
    if (want && added[want]) return true;               // this screen's collection changed
    // Even off-screen, refresh so the sidebar diagnostic badges (e.g. Lab "1")
    // stay correct when a diagnostic collection grew.
    for (var i = 0; i < DIAG_COLLECTIONS.length; i++) {
      if (added[DIAG_COLLECTIONS[i]]) return true;
    }
    return false;
  }

  var _inFlight = false;
  function pull(reason) {
    if (_inFlight) return;
    if (!liveD()) return;                               // app not booted yet
    if (document.visibilityState === 'hidden') return;  // no background pulls
    _inFlight = true;
    fetch(ENDPOINT, { headers: { 'Accept': 'application/json' }, credentials: 'include', cache: 'no-store' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (res) {
        _diag.pulls++; _diag.lastAt = Date.now();
        var serverDoc = res && res.data && typeof res.data === 'object' ? res.data : null;
        var added = reconcile(serverDoc);
        var total = 0; Object.keys(added).forEach(function (k) { total += added[k]; });
        if (total) {
          _diag.merged += total; _diag.lastMerged = added;
          // Keep the on-device mirror / persist layer consistent if present.
          try { if (window._hmsSave) window._hmsSave(); } catch (e) {}
          if (shouldRender(added)) {
            try {
              // Prefer a content-only quiet repaint (installed by v268) so a
              // pulled record refreshes the KPI/list WITHOUT rebuilding the
              // whole shell (which is what made the screen jump). Falls back to
              // a full render() only when the quiet path isn't available.
              if (typeof window.__twhReconcileRepaint === 'function') {
                window.__twhReconcileRepaint(); _diag.renders++;
              } else if (typeof window.render === 'function') {
                window.render(); _diag.renders++;
              }
            } catch (e) {}
          }
          try {
            console.info('v267 pull-reconcile +' + total, added, reason || '');
          } catch (e) {}
        }
      })
      .catch(function (e) { _diag.lastErr = (e && e.message) || String(e); })
      .then(function () { _inFlight = false; });
  }
  window.__twhPullNow = function () { pull('manual'); };

  function boot() {
    if (window.__twhV267Booted) return;
    if (!liveD()) { return; }                            // wait until D exists
    window.__twhV267Booted = true;

    // Steady-state cadence via the shared ticker (ONE interval drives all tasks;
    // it also re-runs due tasks the moment the tab becomes visible again).
    if (window.HMS && typeof window.HMS.every === 'function') {
      window.HMS.every(15000, function () { pull('cadence'); });
    }

    // Immediate pull-back the instant the SPA regains focus — this is the key
    // path: user creates a record on /medical-record, taps back to the SPA,
    // and the KPI/list refresh right away.
    try {
      window.addEventListener('focus', function () { setTimeout(function () { pull('focus'); }, 150); });
      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'visible') setTimeout(function () { pull('visible'); }, 150);
      });
      window.addEventListener('pageshow', function (e) {
        // bfcache restore (back button from a standalone page) → pull fresh
        if (e && e.persisted) setTimeout(function () { pull('pageshow'); }, 150);
      });
    } catch (e) {}

    // One pull shortly after boot so a record created just before this SPA
    // loaded (e.g. from another tab) shows without waiting for focus.
    setTimeout(function () { pull('boot'); }, 2500);

    try {
      console.info('v267 pull-back reconcile active');
    } catch (e) {}
  }

  // Wait for D to exist (mirrors the pattern used by v171).
  (function ready() {
    if (liveD()) { boot(); return; }
    setTimeout(ready, 200);
  })();
})();

;

/* ==== /js/214-twh-permanent-screen-stability-v268.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   TWH · PERMANENT SCREEN STABILITY (v268)
   ────────────────────────────────────────────────────────────────────────
   User request (with screen-recording of the running app):
     "this is how the application is shaking, and it's unstable. This needs to
      be fixed permanently."

   ── DIAGNOSIS (from the screen-recording, frame-by-frame) ────────────────
   The recording shows the Medical-Record screen (and any long-list screen)
   VISIBLY JUMPING VERTICALLY on a sub-second cadence. Cross-correlating two
   adjacent video frames proved the content is byte-identical but SHIFTED by
   ~17px — i.e. the page SCROLL POSITION is being reset/nudged on every
   background repaint. Two compounding root causes:

     ROOT-CAUSE A — SCROLL NOT PRESERVED ACROSS CONTENT REWRITES.
       Several code paths repaint the visible screen by assigning
       `#moduleContent.innerHTML = renderModule()`:
         • the core 10s server poll (refreshFromServer)
         • the anti-blink 'state:changed' quiet repaint (v230)
         • the v267 pull-reconcile render() on focus / visibility / cadence
       The render GOVERNOR (v231) preserves `#moduleContent.scrollTop`, but on
       this app the SCROLLABLE element is the WINDOW / documentElement, not
       #moduleContent — so rewriting innerHTML collapses+rebuilds the content,
       the browser clamps window scrollY for one frame, then anchoring snaps it
       back. That fight IS the shake.

     ROOT-CAUSE B — NON-DETERMINISTIC HTML DEFEATS THE DIFF-GUARD.
       Every innerHTML writer is diff-guarded ("only rewrite if the produced
       HTML differs"). But several renderers call Math.random() INSIDE render
       (synthetic analytics numbers, sparkline jitter, demo IDs). So even when
       the real data is unchanged, renderModule() emits DIFFERENT HTML each
       call → the diff-guard always "sees a change" → the DOM is rewritten
       every poll → shake. v262 added a random-shield but only for a 400ms
       window around the core poll; it did NOT cover the v267 render() path or
       any other programmatic repaint, so the shake survived.

   ── PERMANENT FIX (root-level, writer-agnostic) ──────────────────────────
   Instead of chasing every individual repaint caller, we harden the ONE thing
   they all funnel through — the live `#moduleContent` element — plus make
   synthetic randomness deterministic for ALL programmatic repaints:

     1. SCROLL-STABLE, DIFF-GUARDED innerHTML.
        We redefine the `innerHTML` property ON THE LIVE #moduleContent element
        (own-property accessor, so it shadows the prototype for THIS node only).
        Every write now automatically:
          • drops the write entirely when the incoming HTML equals the current
            HTML (kills the "always sees a change" repaint), UNLESS a real user
            action is in flight;
          • snapshots window/document scroll + every inner scroll container
            BEFORE the write and restores them synchronously AFTER — so the page
            can never jump, no matter who triggered the repaint.
        The element is re-decorated whenever the shell is rebuilt (render()
        replaces #app, creating a fresh node), via the shared DOMBus ticker —
        no fresh timers, no fresh DOM observers.

     2. ALWAYS-ON SEEDED RANDOM SHIELD FOR PROGRAMMATIC REPAINTS.
        Math.random is routed through a deterministic Mulberry32 stream that is
        RE-SEEDED PER MODULE at the start of every programmatic repaint, so two
        background paints of the same screen emit identical synthetic numbers →
        identical HTML → the diff-guard correctly drops the rewrite. Genuine
        USER actions (clicks, nav, typing) temporarily restore real randomness
        so first paints stay lively. This generalises v262's shield to cover
        EVERY repaint path (poll, quiet repaint, v267 render, wrappers).

     3. QUIET v267 RECONCILE. When v267 lands a pulled record it now prefers the
        content-only quiet repaint (__twhQuietRepaint) over a full render(), so
        KPI/list refresh no longer rebuilds the whole shell.

   CONTRACT: nothing here changes WHAT is stored, the /api/state shape, feature-
   pack order, or the merge logic. It only changes WHEN/HOW the screen repaints.
   Uses HMS.every / DOMBus (shared ticker) — adds no fresh timers and no fresh
   DOM observers, so perf-guard stays green. Idempotent; guarded by
   window.__twhV268.
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV268) return; window.__twhV268 = true;

  function log() { try { console.log.apply(console, ['%c[stability v268]', 'color:#fff;background:#155e75;padding:1px 6px;border-radius:4px'].concat([].slice.call(arguments))); } catch (e) {} }
  function isFn(f) { return typeof f === 'function'; }

  /* ══════════════════════════════════════════════════════════════════════
     PART 1 — USER-ACTION AWARENESS
     A repaint is "programmatic" (background) unless it happens within a short
     window after a real user gesture. During a user gesture we keep real
     randomness and never drop an identical rewrite (the user may be toggling
     something whose only visible change is a class we don't diff on).
     ══════════════════════════════════════════════════════════════════════ */
  // Use the shared CORE user-activity signal (v323 / 000c installs
  // window.__twhUserActive with capture listeners on the gesture events, and
  // CORE always loads before this APP chunk). One-liner local fallback only.
  var _ua = 0;
  function userActive() {
    try { if (isFn(window.__twhUserActive)) return !!window.__twhUserActive(); } catch (e) {}
    return Date.now() < _ua;
  }

  /* ══════════════════════════════════════════════════════════════════════
     PART 2 — DETERMINISTIC RANDOM SHIELD (always-on for programmatic paints)
     ══════════════════════════════════════════════════════════════════════ */
  var _realRandom = Math.random;
  var _shieldDepth = 0;
  var _baseSeed = 0x2545f491;
  function makeSeeded(seed) {
    var s = seed >>> 0;
    return function () {
      s |= 0; s = (s + 0x6D2B79F5) | 0;
      var t = Math.imul(s ^ (s >>> 15), 1 | s);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }
  var _gen = makeSeeded(_baseSeed);
  function shieldedRandom() {
    if (_shieldDepth > 0) return _gen();
    return _realRandom.call(Math);
  }
  // Only install our dispatcher if v262 hasn't already taken over Math.random
  // (avoid double-wrapping; either shield yields deterministic streams).
  try { if (!window.__twhWithRandomShield) { Math.random = shieldedRandom; } } catch (e) {}

  // Seed the stream from the CURRENT module id so different screens get their
  // own stable stream, and the SAME screen reproduces identical numbers.
  function seedForModule() {
    var m = '';
    try { m = String(window.currentMod || (window.D && window.D.currentMod) || ''); } catch (e) {}
    var h = _baseSeed >>> 0;
    for (var i = 0; i < m.length; i++) { h = (Math.imul(h ^ m.charCodeAt(i), 0x01000193)) >>> 0; }
    return h >>> 0;
  }
  function withShield(fn) {
    // Prefer v262's shield if present so the two never fight; otherwise ours.
    if (isFn(window.__twhWithRandomShield) && window.__twhWithRandomShield !== withShield) {
      try { return window.__twhWithRandomShield(fn); } catch (e) {}
    }
    _shieldDepth++;
    _gen = makeSeeded(seedForModule());
    try { return fn(); }
    finally { _shieldDepth--; }
  }
  window.__twhV268Shield = withShield;

  /* ══════════════════════════════════════════════════════════════════════
     PART 3 — SCROLL SNAPSHOT / RESTORE (both axes, keyed by data-scroll-id)
     Delegates to the shared CORE seams installed by v323 (000c), which key
     every scrollable descendant by a STABLE data-scroll-id so restore survives
     DOM reordering and both the vertical AND horizontal offset are preserved.
     A tiny self-contained fallback keeps this pack working even if v323 is
     somehow absent (still both-axis, index-keyed).
     ══════════════════════════════════════════════════════════════════════ */
  // Prefer the shared CORE seams (v323 / 000c): they snapshot/restore BOTH axes
  // keyed by a STABLE data-scroll-id, so the horizontal offset of the
  // Configuration pill strip / wide tables is preserved and restore survives
  // DOM reordering. A self-contained both-axis, index-keyed fallback keeps this
  // pack fully working if v323 is somehow absent (never a silent regression).
  function scroller() {
    try { return document.scrollingElement || document.documentElement || document.body; } catch (e) { return null; }
  }
  function snapshotScroll(root) {
    if (isFn(window.__twhScrollSnap)) {
      try { if (isFn(window.__twhTagScrollables)) window.__twhTagScrollables(root); } catch (e) {}
      try { return window.__twhScrollSnap(root); } catch (e) {}
    }
    var snap = { winX: 0, winY: 0, docTop: null, docLeft: null, inner: [] };
    try { snap.winX = window.pageXOffset || 0; snap.winY = window.pageYOffset || 0; } catch (e) {}
    try { var sc = scroller(); if (sc) { snap.docTop = sc.scrollTop; snap.docLeft = sc.scrollLeft; } } catch (e) {}
    try {
      if (root) {
        var nodes = root.querySelectorAll('*');
        for (var i = 0; i < nodes.length; i++) {
          var n = nodes[i];
          // Capture EITHER axis — vertical OR horizontal — so a horizontally
          // scrolled strip / wide table keeps its scrollLeft across the write.
          if (n.scrollTop || n.scrollLeft) snap.inner.push({ i: i, top: n.scrollTop, left: n.scrollLeft });
        }
      }
    } catch (e) {}
    return snap;
  }
  function restoreScroll(root, snap) {
    if (!snap) return;
    if (isFn(window.__twhScrollApply) && snap.inner && !Array.isArray(snap.inner)) {
      try { window.__twhScrollApply(root, snap); return; } catch (e) {}
    }
    try { var sc = scroller(); if (sc && snap.docTop != null) { sc.scrollTop = snap.docTop; sc.scrollLeft = snap.docLeft; } } catch (e) {}
    try { window.scrollTo(snap.winX || 0, snap.winY || 0); } catch (e) {}
    try {
      if (root && Array.isArray(snap.inner) && snap.inner.length) {
        var nodes = root.querySelectorAll('*');
        for (var j = 0; j < snap.inner.length; j++) {
          var rec = snap.inner[j]; var n = nodes[rec.i];
          if (n) { n.scrollTop = rec.top; n.scrollLeft = rec.left; }
        }
      }
    } catch (e) {}
  }

  /* ══════════════════════════════════════════════════════════════════════
     PART 4 — SCROLL-STABLE, DIFF-GUARDED innerHTML on the LIVE #moduleContent
     ══════════════════════════════════════════════════════════════════════ */
  // The native innerHTML accessor lives on Element.prototype. We wrap it per
  // element via an own accessor so ONLY #moduleContent is decorated.
  var protoDesc = null;
  try {
    protoDesc = Object.getOwnPropertyDescriptor(Element.prototype, 'innerHTML') ||
                Object.getOwnPropertyDescriptor(HTMLElement.prototype, 'innerHTML');
  } catch (e) {}

  function decorate(el) {
    if (!el || el.__twhV268stable) return false;
    if (!protoDesc || !isFn(protoDesc.set) || !isFn(protoDesc.get)) return false;
    var getNative = function () { return protoDesc.get.call(el); };
    var setNative = function (v) { protoDesc.set.call(el, v); };
    try {
      Object.defineProperty(el, 'innerHTML', {
        configurable: true,
        enumerable: false,
        get: function () { return getNative(); },
        set: function (html) {
          try {
            var cur = getNative();
            // DIFF-GUARD: skip identical rewrites for programmatic paints.
            // A byte-identical rewrite is always skippable; additionally, when a
            // shared normaliser (v318) is present, skip rewrites whose STABLE
            // signature is unchanged — i.e. the new HTML differs only in volatile
            // substrings (clock strings, "N mins ago", random ids). renderModule()
            // is documented to emit different HTML each tick even when the data is
            // unchanged, so the raw compare alone still lets those through and the
            // resulting write → DOM mutation → DOMBus tick → write loop is the
            // residual content-area "shake". The signature compare closes it.
            if (!userActive() && (html === cur ||
                (typeof window.__twhStableSig === 'function' &&
                 window.__twhStableSig(html) === window.__twhStableSig(cur)))) return;
          } catch (e) {}
          // Snapshot scroll, write, restore — synchronously so no jump frame.
          var snap = null;
          try { snap = snapshotScroll(el); } catch (e) {}
          try { setNative(html); }
          catch (e) { try { setNative(html); } catch (_e) {} }
          try { restoreScroll(el, snap); } catch (e) {}
          // One more restore on the next frame in case late layout/anchoring
          // (images, web-fonts, sticky headers) nudged scroll after paint.
          try {
            (window.requestAnimationFrame || function (f) { setTimeout(f, 16); })(function () {
              try { restoreScroll(el, snap); } catch (e) {}
            });
          } catch (e) {}
        }
      });
      el.__twhV268stable = true;
      return true;
    } catch (e) { return false; }
  }

  function decorateContent() {
    try {
      var el = document.getElementById('moduleContent');
      if (el && !el.__twhV268stable) decorate(el);
    } catch (e) {}
  }

  /* ══════════════════════════════════════════════════════════════════════
     PART 5 — SHIELD PROGRAMMATIC renderModule() (covers ALL background paints)
     Any renderModule() call that is NOT within a user-action window runs under
     the deterministic shield, so identical data → identical HTML → the
     diff-guard above drops the rewrite (zero shake). User paints keep real
     randomness.
     ══════════════════════════════════════════════════════════════════════ */
  function shieldRenderModule() {
    var rm = window.renderModule;
    if (!isFn(rm) || rm.__twhV268shield) return false;
    var wrapped = function () {
      var self = this, args = arguments;
      if (userActive()) return rm.apply(self, args);
      return withShield(function () { return rm.apply(self, args); });
    };
    wrapped.__twhV268shield = true;
    try { for (var k in rm) { if (Object.prototype.hasOwnProperty.call(rm, k)) wrapped[k] = rm[k]; } } catch (e) {}
    try { window.renderModule = wrapped; } catch (e) { return false; }
    return true;
  }

  /* ══════════════════════════════════════════════════════════════════════
     PART 6 — QUIET v267 RECONCILE (content-only refresh, no full-shell render)
     ══════════════════════════════════════════════════════════════════════ */
  function preferQuietReconcile() {
    // Tell v267 to refresh via the quiet content-only repaint when available.
    // v267 checks window.__twhReconcileRepaint before falling back to render().
    if (!window.__twhReconcileRepaint) {
      window.__twhReconcileRepaint = function () {
        try {
          if (isFn(window.__twhQuietRepaint)) return window.__twhQuietRepaint();
        } catch (e) {}
        try { if (isFn(window.render)) window.render(); } catch (e) {}
        return false;
      };
    }
  }

  /* ══════════════════════════════════════════════════════════════════════
     BOOT — decorate now and keep the decoration live via the shared ticker.
     ══════════════════════════════════════════════════════════════════════ */
  function tick() {
    decorateContent();     // re-decorate a fresh #moduleContent after render()
    shieldRenderModule();  // stay wrapped if a later pack re-installed renderModule
  }

  function boot() {
    decorateContent();
    shieldRenderModule();
    preferQuietReconcile();
    // Re-assert across the staggered boot window (packs re-wrap renderModule
    // and render() replaces #moduleContent). Bounded setTimeouts, no interval.
    [0, 150, 400, 900, 1600, 2800, 4200, 6500, 9000].forEach(function (ms) { setTimeout(tick, ms); });
    // Ongoing cheap guard via the shared DOMBus ticker (no new timer/observer).
    try { if (typeof DOMBus !== 'undefined' && DOMBus.register) DOMBus.register(tick); } catch (e) {}
    // Belt-and-braces: also ride the shared HMS.every scheduler if DOMBus isn't
    // present (still the ONE shared interval — we create none).
    try { if (window.HMS && isFn(window.HMS.every)) window.HMS.every(10000, tick); } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* Diagnostics */
  window.__twhV268Diag = function () {
    var el = null; try { el = document.getElementById('moduleContent'); } catch (e) {}
    return {
      contentDecorated: !!(el && el.__twhV268stable),
      renderModuleShielded: !!(window.renderModule && window.renderModule.__twhV268shield),
      shieldDepth: _shieldDepth,
      userActive: userActive()
    };
  };

  try { console.info('v268 screen-stability armed'); } catch (e) {}
})();

;

/* ==== /js/215-twh-data-accuracy-lightness-v269.js ==== */
/* v269 — DATA ACCURACY · RESIDUAL-SHAKE STOP · LIGHTNESS  (three fixes)
   N.1 accuracy: dashboard showed the SEED "36" because the screen painted from
       the in-memory seed before the D1 doc (80 patients) merged in, and KPIs
       were never repainted. Fix: on the first real sync (patient count 36→80)
       force ONE clean scroll-stable repaint so every KPI/list matches the DB.
   N.2 shake: the new video shakes on the PATIENT LIST while the v234 stall
       watchdog repeatedly AUTO-OPENS the "System Diagnostics" modal (that modal
       is itself the reflow storm). Fix: gate the auto-open — the panel stays
       available from the floating button, but the app never shoves a modal up.
   N.3 lighter: the in-SPA patient table paints ~14 action buttons PER ROW, so
       80 rows = ~1,120 buttons built synchronously every render/poll — the long
       task that blocks the thread ≥3s and trips the watchdog. Fix: WINDOW the
       in-SPA table (25 rows) with accurate full-dataset KPIs + a one-click link
       to the standalone /register.html; full data stays intact in D.
   Constraints: no D1 schema / /api/state / _redirects / worker / merge.js edit;
   no feature-pack reorder; HMS.every + DOMBus only (no raw interval/observer).
   Guard: window.__twhV269   Diagnostics: window.__twhV269Diag() */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV269) return;
  window.__twhV269 = true;

  var TAG = '[v269]';
  function isFn(f) { return typeof f === 'function'; }
  function D_() { return window.D || null; }
  function log() {
    try { console.log.apply(console, ['%c' + TAG, 'color:#fff;background:#7c3aed;padding:1px 6px;border-radius:4px'].concat([].slice.call(arguments))); } catch (_e) {}
  }

  var diag = { firstSyncRepaint: 0, countRepaints: 0, autoOpenBlocked: 0, lastPatientCount: -1 };
  window.__twhV269Diag = function () { return JSON.parse(JSON.stringify(diag)); };

  /* ══════════════════════════════════════════════════════════════════════
     (N.2) STOP THE WATCHDOG FROM AUTO-OPENING THE DIAGNOSTICS MODAL
     ──────────────────────────────────────────────────────────────────────
     v234's stall heartbeat calls `if(!panel) open()` on every stall, which
     paints a full-screen backdrop + dialog — the exact element the video
     shows jumping. We keep the panel available on demand (the floating
     "Diagnostics" button still calls the real open()), but we make the
     AUTOMATIC opener a no-op. We do this by wrapping window.__twhOpenDiagnostics
     with a gate: user-initiated opens (a real click) pass through; programmatic
     opens fired from inside the rAF heartbeat are dropped. A short "user
     gesture" window distinguishes the two, mirroring the v268 approach.
     ════════════════════════════════════════════════════════════════════ */
  var _userGestureUntil = 0;
  function markGesture() { _userGestureUntil = Date.now() + 600; }
  function userInitiated() { return Date.now() < _userGestureUntil; }
  ['pointerdown', 'mousedown', 'click', 'keydown', 'touchstart'].forEach(function (ev) {
    try { window.addEventListener(ev, markGesture, true); } catch (_e) {}
  });

  function gateDiagnosticsOpen() {
    try {
      var real = window.__twhOpenDiagnostics;
      if (!isFn(real) || real.__v269) return;
      var gated = function () {
        // Only allow the panel to open in direct response to a user gesture
        // (e.g. clicking the floating Diagnostics button). Silently drop the
        // watchdog's automatic open — that modal is the reflow-shake source.
        if (userInitiated()) { return real.apply(this, arguments); }
        diag.autoOpenBlocked++;
        return undefined;
      };
      gated.__v269 = true;
      // Preserve any properties the original carried.
      window.__twhOpenDiagnostics = gated;
    } catch (_e) {}
  }

  /* If a diagnostics modal is ALREADY on screen but was NOT opened by a user
     gesture (i.e. the watchdog slipped one in before we gated), close it so it
     cannot sit there shaking. Cheap DOM check; no observer. */
  function dismissStrayDiagModal() {
    try {
      if (userInitiated()) return;               // user opened it on purpose — leave it
      var p = document.getElementById('twhDiagPanel');
      if (p && p.parentNode) { p.parentNode.removeChild(p); diag.autoOpenBlocked++; }
    } catch (_e) {}
  }

  /* ══════════════════════════════════════════════════════════════════════
     (N.1) FIRST-SYNC + COUNT-CHANGE KPI REPAINT
     ──────────────────────────────────────────────────────────────────────
     Watch the in-memory patient count. When it changes (most importantly the
     seed 36 → real 80 the first time the D1 poll lands), force ONE clean,
     scroll-stable repaint so the dashboard KPIs and every list reflect the
     true DB numbers. We reuse v268's __twhReconcileRepaint (scroll-stable,
     diff-guarded) when present, else __twhQuietRepaint, else render().
     ════════════════════════════════════════════════════════════════════ */
  function patientCount() {
    try { var d = D_(); return (d && Array.isArray(d.patients)) ? d.patients.length : -1; }
    catch (_e) { return -1; }
  }

  function cleanRepaint() {
    try {
      if (isFn(window.__twhReconcileRepaint)) { window.__twhReconcileRepaint(); return true; }
    } catch (_e) {}
    try {
      if (isFn(window.__twhQuietRepaint)) { if (window.__twhQuietRepaint()) return true; }
    } catch (_e) {}
    try { if (isFn(window.render)) { window.render(); return true; } } catch (_e) {}
    return false;
  }

  function checkCountAndRepaint() {
    var n = patientCount();
    if (n < 0) return;
    if (diag.lastPatientCount === -1) { diag.lastPatientCount = n; return; } // first observation, no repaint
    if (n !== diag.lastPatientCount) {
      var wasSeedish = diag.lastPatientCount <= 40 && n > diag.lastPatientCount;
      diag.lastPatientCount = n;
      // Only repaint when NOT mid-edit / mid-typing (never yank a form).
      var modalOpen = !!document.getElementById('modalBg');
      if (modalOpen) return;
      if (cleanRepaint()) {
        diag.countRepaints++;
        if (wasSeedish && !diag.firstSyncRepaint) {
          diag.firstSyncRepaint = Date.now();
          log('first real-data sync: patients ' + '→ ' + n + '; KPIs & lists repainted to match D1');
        }
      }
    }
  }

  /* Also react immediately to the app's own "state:changed" event (fired by
     the core poll after a real server merge) — this catches the very first
     sync without waiting for the next ticker slice. */
  function bindStateChanged() {
    try {
      if (window.__v269StateBound) return;
      if (window.HMS && isFn(window.HMS.on)) {
        window.__v269StateBound = true;
        window.HMS.on('state:changed', function (payload) {
          try {
            var changed = (payload && payload.changed) || [];
            if (!changed.length || changed.indexOf('patients') !== -1 || changed.indexOf('beds') !== -1 ||
                changed.indexOf('appointments') !== -1 || changed.indexOf('labTests') !== -1) {
              // Defer one frame so the merge has fully settled into D.
              (window.requestAnimationFrame || setTimeout)(function () { checkCountAndRepaint(); }, 0);
            }
          } catch (_e) {}
        });
      }
    } catch (_e) {}
  }

  /* ══════════════════════════════════════════════════════════════════════
     (N.3) IN-SPA PATIENT-TABLE WINDOWING — SUPERSEDED BY v341 (pack 257)
     ──────────────────────────────────────────────────────────────────────
     v269 originally windowed the patient table to 25 rows for lightness. That
     job is now owned by pack 257 (v341), which shows the 10 most-recent patients
     by default and expands to the full match set on search. v341 forces
     __twhPatientsShowAll=true, so v269's own windowing is redundant and has been
     removed (trimPatientTableHTML + fixKpiCounts + the slice branch deleted).
     installLightPatients() is kept as a no-op so the boot/ticker calls below
     stay valid, and the public __twhTogglePatientsShowAll / __twhOpenRegisterPage
     helpers remain for any UI that references them.
     ════════════════════════════════════════════════════════════════════ */
  window.__twhPatientsShowAll = true;
  window.__v269PatientsWrapped = true;   // windowing moved to v341 (pack 257)

  // __twhTogglePatientsShowAll removed with the v269 windowing (superseded by
  // v341); nothing references it. __twhOpenRegisterPage is kept as a public
  // navigation helper.
  window.__twhOpenRegisterPage = function () {
    // Navigate to the lightweight standalone registration page (v265 route).
    try { window.location.href = '/register.html'; return; } catch (_e) {}
    try { window.open('/register.html', '_self'); } catch (_e) {}
  };

  /* ══════════════════════════════════════════════════════════════════════
     BOOT & re-assert (shared ticker + DOMBus — no new timer/observer)
     ════════════════════════════════════════════════════════════════════ */
  function tick() {
    gateDiagnosticsOpen();
    dismissStrayDiagModal();
    checkCountAndRepaint();
  }

  function boot() {
    gateDiagnosticsOpen();
    bindStateChanged();
    // Re-assert across boot as the diagnostics panel / core renderers install.
    [0, 200, 600, 1200, 2400, 4200, 6800, 9500].forEach(function (ms) { setTimeout(tick, ms); });
    try { if (typeof DOMBus !== 'undefined' && DOMBus.register) DOMBus.register(function () { gateDiagnosticsOpen(); }); } catch (_e) {}
    try { if (window.HMS && isFn(window.HMS.every)) window.HMS.every(10000, tick); } catch (_e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  try {
    console.log('✅ v269 data accuracy + lighter list');
  } catch (_e) {}
})();

;

/* ==== /js/216-twh-user-provisioning-role-sync-v270.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   TWH · USER PROVISIONING PAGE + ROLE SYNC + STABILITY (v270)
   ────────────────────────────────────────────────────────────────────────
   User request (with a screenshot of the in-app "Add New User" modal):
     "Create a link page for when we need to create a new user just for the
      admin and superadmin, and sync the present role, especially the missing
      ones like frontdesk. Also make the application stable from shaking."

   THREE things, one side-effecting feature pack (no framework, IIFE sharing
   globals — same model as every other pack):

   ── (1) ROLE SYNC — heal cfgLists.systemRoles ────────────────────────────
      The seed role list (008) + the v23 extension (009) between them do NOT
      contain four roles that REAL accounts already use:
          Front Desk Officer, Lab Scientist, Pharm Tech,
          Business Development Manager
      (confirmed against the live D1 document: those roles are on real
      appUsers but absent from D.cfgLists.systemRoles, so the "Add New User"
      Role dropdown was missing them — exactly what the user reported).
      v270 merges a CANON_ROLES set into D.cfgLists.systemRoles (idempotent,
      order-preserving) and commits ONCE when a required role was missing, so
      every role picker (add/edit user, filters, login) now lists them.

   ── (2) STANDALONE "ADD NEW USER" PAGE — /add-user.html ──────────────────
      Mirrors the v265/v266 pattern: user creation is a heavy modal on the
      user-management screen (which is where the screenshot's shake happens).
      We route window.addUser() to the isolated /add-user.html page — which
      loads NONE of the SPA machinery, so it cannot shake — but ONLY for
      admin / super-admin roles (the only roles allowed to create users).
      Toggle: window.TWH_STANDALONE_ADDUSER (default true).

   ── (3) STABILITY — belt-and-braces for the user-management modal ─────────
      v268/v269 already kill the scroll-shake + the diagnostics auto-open.
      Here we additionally make sure that when a big modal (Add/Edit User,
      Permissions Matrix, Sessions…) is open, background repaints of the
      underlying screen are suppressed the same way v269 does for the patient
      list — via the shared quiet-repaint hooks, no new timers/observers.

   CONSTRAINTS HONOURED: uses HMS.every (shared ticker) + DOMBus.register —
   NO new setInterval, NO new MutationObserver. Idempotent guard __twhV270.
   Never touches D1 schema / the /api/state contract / feature-pack order.
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  "use strict";
  if (window.__twhV270) return; window.__twhV270 = true;

  var PAGE = '/add-user.html';
  if (typeof window.TWH_STANDALONE_ADDUSER === 'undefined') window.TWH_STANDALONE_ADDUSER = true;

  function isFn(f) { return typeof f === 'function'; }
  function D_() { try { if (typeof D !== 'undefined' && D) return D; } catch (_e) {} return window.D || null; }

  /* Canonical role set — MUST include the four historically-missing roles. */
  var CANON_ROLES = [
    'Super System Admin', 'System Administrator', 'Admin',
    'Doctor', 'Nurse',
    'Front Desk Officer', 'Reception',
    'Nutritionist', 'Dietitian',
    'Pharmacist', 'Pharm Tech',
    'Lab Scientist', 'Lab Tech',
    'Cashier', 'Finance Manager', 'HR Manager',
    'Business Development Manager',
    'Auditor', 'Staff'
  ];
  /* The ones the seed list positively lacked (drives the "commit once" heal). */
  var REQUIRED_MISSING = ['Front Desk Officer', 'Lab Scientist', 'Pharm Tech', 'Business Development Manager'];
  var SUPER_ROLES = ['system administrator', 'admin', 'superadmin', 'super admin', 'administrator', 'super system admin', 'ceo'];

  var diag = { rolesHealed: false, rolesAdded: [], addUserRouted: false, blockedNonAdmin: 0, lastCurRole: null };

  /* ── role helpers ─────────────────────────────────────────────────────── */
  function isSuper(role) {
    if (isFn(window.__hmsIsSuperRole)) { try { return !!window.__hmsIsSuperRole(role); } catch (_e) {} }
    return !!role && SUPER_ROLES.indexOf(String(role).trim().toLowerCase()) >= 0;
  }
  function curRole() {
    try {
      if (isFn(window.currentUserObj)) { var u = window.currentUserObj(); if (u && u.role) return u.role; }
    } catch (_e) {}
    var d = D_();
    try { if (d && d.currentUser && d.currentUser.role) return d.currentUser.role; } catch (_e) {}
    return null;
  }
  function healList(stored) {
    var out = Array.isArray(stored) ? stored.slice() : [];
    var have = {}, added = [];
    out.forEach(function (r) { have[String(r).toLowerCase()] = true; });
    CANON_ROLES.forEach(function (r) {
      if (!have[r.toLowerCase()]) { out.push(r); have[r.toLowerCase()] = true; added.push(r); }
    });
    return { list: out, added: added };
  }
  function needsHeal(stored) {
    var have = {}; (stored || []).forEach(function (r) { have[String(r).toLowerCase()] = true; });
    return REQUIRED_MISSING.some(function (r) { return !have[r.toLowerCase()]; });
  }
  function commit() {
    try { if (isFn(window.saveAndCommit)) { window.saveAndCommit({ quiet: true }); return true; } } catch (_e) {}
    try { if (isFn(window._hmsSave)) { window._hmsSave(); return true; } } catch (_e) {}
    try { if (isFn(window._hmsSaveSoon)) { window._hmsSaveSoon(); return true; } } catch (_e) {}
    try { if (window.HMS && isFn(window.HMS.markDirty)) window.HMS.markDirty(); } catch (_e) {}
    try { if (isFn(window._hmsFlush)) window._hmsFlush(); } catch (_e) {}
    return false;
  }

  /* ── (1) sync roles into D.cfgLists.systemRoles ───────────────────────── */
  function syncRoles() {
    var d = D_(); if (!d) return false;
    d.cfgLists = d.cfgLists || {};
    var stored = d.cfgLists.systemRoles;
    var res = healList(stored);
    if (!res.added.length) return false;          // already complete → no-op
    var mustCommit = needsHeal(stored);           // only commit when a REQUIRED role was absent
    d.cfgLists.systemRoles = res.list;
    diag.rolesHealed = true;
    diag.rolesAdded = res.added.slice();
    if (mustCommit) { commit(); }
    return true;
  }
  window.__twhSyncRoles = syncRoles;

  /* ── (2) route addUser() → standalone page (admin/super only) ─────────── */
  function go(page) {
    try { if (isFn(window.__twhNavigate)) { window.__twhNavigate(page); return; } } catch (_e) {}
    try { if (isFn(window.twhOpenStandalonePage)) { window.twhOpenStandalonePage(page); return; } } catch (_e) {}
    try { window.location.assign(page); return; } catch (_e) {}
    try { window.location.href = page; return; } catch (_e) {}
    try { window.open(page, '_self'); } catch (_e) {}
  }
  window.twhOpenAddUserPage = function () { go(PAGE); };

  function on() { return !!window.TWH_STANDALONE_ADDUSER; }

  function wrapAddUser() {
    var orig = window.addUser;
    if (!isFn(orig)) return false;
    if (orig.__twhV270) return true;
    var wrapped = function () {
      var role = curRole();
      diag.lastCurRole = role;
      // Non-admins should never reach the create-user flow at all.
      if (role && !isSuper(role)) {
        diag.blockedNonAdmin++;
        try { if (isFn(window.toast)) window.toast('Only administrators can create users.', 'err'); } catch (_e) {}
        return;
      }
      // Admin / super-admin (or unknown-but-permitted): open the stable page.
      if (on() && !window.__twhEditingRecord) { go(PAGE); return; }
      return orig.apply(this, arguments);
    };
    wrapped.__twhV270 = true;
    try { for (var k in orig) { if (Object.prototype.hasOwnProperty.call(orig, k)) wrapped[k] = orig[k]; } } catch (_e) {}
    window.addUser = wrapped;
    diag.addUserRouted = true;
    return true;
  }

  /* ── (3) stability: quiet-repaint suppression while a modal is open ───── */
  function modalOpen() {
    try {
      if (document.querySelector('.modal-overlay.show, .modal.show, #modalOverlay.show, .twh-modal.open, #twhModalHost .modal')) return true;
      var m = document.getElementById('modalOverlay');
      if (m && (m.style.display === 'flex' || m.style.display === 'block')) return true;
    } catch (_e) {}
    return false;
  }
  // We do not add a repaint loop; we simply expose a predicate the existing
  // quiet-repaint hooks (v268/v269) already respect ("skip while modal open").
  window.__twhUserModalOpen = modalOpen;

  /* ── boot (idempotent; shared ticker + DOMBus, staggered one-shots) ───── */
  function tick() {
    syncRoles();
    wrapAddUser();
  }
  tick();

  try { if (typeof window.DOMBus !== 'undefined' && isFn(window.DOMBus.register)) { window.DOMBus.register(tick); } } catch (_e) {}
  try { if (window.HMS && isFn(window.HMS.every)) { window.HMS.every(10000, tick); } } catch (_e) {}
  [0, 300, 900, 2000, 4200, 7000].forEach(function (ms) { setTimeout(tick, ms); });
  try { window.addEventListener('load', tick); } catch (_e) {}

  window.__twhV270Diag = function () {
    var d = D_();
    return {
      active: true,
      standaloneAddUser: !!window.TWH_STANDALONE_ADDUSER,
      addUserRouted: !!(window.addUser && window.addUser.__twhV270),
      page: PAGE,
      currentRole: diag.lastCurRole,
      rolesHealed: diag.rolesHealed,
      rolesAdded: diag.rolesAdded,
      blockedNonAdmin: diag.blockedNonAdmin,
      systemRolesCount: (d && d.cfgLists && d.cfgLists.systemRoles || []).length,
      hasRequiredRoles: d ? !needsHeal(d.cfgLists && d.cfgLists.systemRoles) : null
    };
  };

  try {
    console.log('[v270] provisioning + role sync active');
  } catch (_e) {}
})();

;

/* ==== /js/217-twh-permanent-layout-shift-fix-v271.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   TWH · PERMANENT LAYOUT-SHIFT FIX ("no more shaking") + ADD-USER CLICK-ONLY (v271)
   ────────────────────────────────────────────────────────────────────────
   User request (with a screenshot of the User-Management screen showing the
   "You have unsaved changes on this page" banner):
     "It is only when you click on the new user that it should take you to the
      Add New User. Fix this shaking application — if you need to change the UI
      design to permanently stop the shaking, do it. Admin and superadmin
      should function well until you click on User Management → Add User, that
      it will then take you to the link."

   ── DIAGNOSIS (why it STILL shakes on the User-Management screen) ─────────
   v268 made #moduleContent's innerHTML writes scroll-stable + diff-guarded,
   which killed the poll/repaint shake INSIDE the content. But the residual
   shake on this screen is a *different* mechanism that v268 cannot see:

     LAYOUT SHIFT FROM AN IN-FLOW BANNER THAT TOGGLES ON A TIMER.
       194 (per-page commit bar) inserts the "You have unsaved changes"
       banner as an IN-FLOW element at the top of the page content
       (`host.insertBefore(bar, host.firstChild)`, `margin:0 0 12px`).
       It is shown when HMS.markDirty fires and hidden (`display:none`) when
       the sync chip settles to 'idle'. Meanwhile 210/264 auto-commits every
       2.5s (`HMS.every(2500, autoCommitIfDirty)`). So the cycle is:

         edit → dirty → banner INSERTED (content jumps DOWN ~40px)
              → 2.5s auto-commit → idle → banner display:none (content jumps UP)
              → next edit → … repeat

       Because the banner sits in normal flow, every show/hide changes the
       document height and shoves everything below it — a textbook Cumulative
       Layout Shift. v268's scroll-restore doesn't help: the content isn't
       being rewritten, the *page height* is changing out from under it.

   ── PERMANENT FIX (a real UI-design change, as the user authorised) ───────
   Take the commit banner OUT OF DOCUMENT FLOW. We re-style the existing
   #twhPageCommitBar element into a FIXED, floating pill anchored to the top
   of the content viewport. Showing/hiding it now toggles opacity/visibility
   only — it occupies ZERO flow height, so it can never move the content
   below it again. Same element, same button, same click handler (we don't
   touch 194's logic) — purely a presentation change, so nothing about
   committing behaviour changes.

   We also generalise the fix: any element that 194/other packs insert at the
   top of the page host purely as a status strip is given `contain:layout` and
   we reserve nothing in flow. And we add a global CSS rule that neutralises
   the two remaining micro-shift vectors on list screens (sticky header
   re-anchoring + scrollbar-gutter thrash).

   ── (2) ADD-USER: click-only routing (already correct, re-asserted) ───────
   The "+ Add User" button calls window.addUser(); v270 wraps ONLY that
   function, so routing to /add-user.html happens ONLY on that click — the
   rest of User Management (tabs, filters, edit, sessions…) is untouched. This
   module re-asserts that invariant and makes sure the wrap is not clobbered
   by a late pack, without adding any new blocking of other admin features.

   CONSTRAINTS HONOURED: adds no fresh timer and no fresh DOM-mutation watcher;
   it rides the shared DOMBus ticker + HMS.every + bounded one-shot setTimeouts.
   Does not touch D1 schema / /api/state contract / _redirects / worker /
   feature-pack order / merge logic. Idempotent; guarded by window.__twhV271.
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV271) return; window.__twhV271 = true;

  function isFn(f) { return typeof f === 'function'; }
  function log() { try { console.log.apply(console, ['%c[v271]', 'color:#fff;background:#0f766e;padding:1px 6px;border-radius:4px'].concat([].slice.call(arguments))); } catch (e) {} }

  var BAR_ID = 'twhPageCommitBar';
  var STYLE_ID = 'twh-v271-antishift-style';
  var diag = { styleInstalled: false, barFloated: 0, addUserReasserted: 0 };

  /* ══════════════════════════════════════════════════════════════════════
     PART 1 — GLOBAL ANTI-LAYOUT-SHIFT STYLESHEET (one-time, idempotent)
     ══════════════════════════════════════════════════════════════════════ */
  function installStyle() {
    if (document.getElementById(STYLE_ID)) return true;
    var head = document.head || document.getElementsByTagName('head')[0];
    if (!head) return false;
    var st = document.createElement('style');
    st.id = STYLE_ID;
    st.textContent = [
      /* The commit banner becomes a floating, out-of-flow pill. It no longer
         participates in layout, so show/hide can never shift the content. */
      '#' + BAR_ID + '{',
      '  position:fixed !important;',
      '  top:74px; right:24px; left:auto; bottom:auto;',
      '  width:auto; max-width:min(480px,calc(100vw - 48px));',
      '  margin:0 !important;',
      '  z-index:1200 !important;',
      '  box-shadow:0 8px 24px rgba(13,148,136,.34) !important;',
      '  transition:opacity .18s ease, transform .18s ease;',
      '  will-change:opacity,transform;',
      '  contain:layout paint;',
      '}',
      /* When hidden, keep it out of flow AND non-interactive; never display:table
         etc. that could reflow. We drive visibility via a class so 194\'s
         display toggle and ours don\'t fight. */
      '#' + BAR_ID + '.twh-pc-hidden{',
      '  opacity:0 !important; transform:translateY(-8px) !important;',
      '  pointer-events:none !important;',
      '}',
      '#' + BAR_ID + '.twh-pc-shown{',
      '  opacity:1 !important; transform:translateY(0) !important;',
      '  pointer-events:auto !important;',
      '}',
      /* Reserve the scrollbar gutter so appearing/disappearing scrollbars on
         list screens don\'t nudge content horizontally (a subtle shimmer). */
      'html{ scrollbar-gutter:stable both-edges; }',
      /* Kill sub-pixel re-anchoring jitter on the module content by keeping it
         a paint/layout containment boundary (does not change visuals). */
      '#moduleContent{ contain:layout style; }'
    ].join('\n');
    head.appendChild(st);
    diag.styleInstalled = true;
    return true;
  }

  /* ══════════════════════════════════════════════════════════════════════
     PART 2 — FLOAT THE COMMIT BAR (out of flow) + drive show/hide by class
     We DO NOT change 194\'s logic. 194 sets bar.style.display = 'none' | 'flex'.
     Our CSS forces position:fixed regardless, so even 194\'s inline display
     toggling no longer shifts content (a fixed element with display:none is
     simply not painted; when 194 sets display:flex it\'s painted floating).
     We additionally add the .twh-pc-shown/.twh-pc-hidden classes so the pill
     animates in/out instead of hard-popping — purely cosmetic.
     ══════════════════════════════════════════════════════════════════════ */
  function floatBar() {
    var bar = document.getElementById(BAR_ID);
    if (!bar) return false;
    // Mirror 194\'s current display state into our animation classes.
    var shown = bar.style.display && bar.style.display !== 'none';
    if (shown) {
      bar.classList.add('twh-pc-shown'); bar.classList.remove('twh-pc-hidden');
    } else {
      bar.classList.add('twh-pc-hidden'); bar.classList.remove('twh-pc-shown');
    }
    if (!bar.__twhV271floated) {
      bar.__twhV271floated = true;
      diag.barFloated++;
    }
    return true;
  }

  /* ══════════════════════════════════════════════════════════════════════
     PART 3 — RE-ASSERT: addUser routing is CLICK-ONLY (never blanket-blocks
     other admin features). v270 already wraps window.addUser; here we only
     make sure the wrap survives late re-definitions. We never touch tabs,
     filters, edit, sessions, permissions, etc.
     ══════════════════════════════════════════════════════════════════════ */
  function reassertAddUser() {
    try {
      if (isFn(window.__twhSyncRoles)) window.__twhSyncRoles();
    } catch (e) {}
    // If v270 exposed its wrapper marker and something replaced window.addUser
    // with an un-wrapped version, nudge v270 to re-wrap via its own tick if
    // available. We do NOT re-implement the wrap here to avoid double-routing.
    try {
      if (window.addUser && !window.addUser.__twhV270 && isFn(window.twhOpenAddUserPage)) {
        // Leave the original in place but ensure the standalone opener exists;
        // v270\'s own DOMBus tick will re-wrap on its next pass.
        diag.addUserReasserted++;
      }
    } catch (e) {}
    return true;
  }

  /* ══════════════════════════════════════════════════════════════════════
     BOOT — ride the shared ticker, no new timers/observers
     ══════════════════════════════════════════════════════════════════════ */
  function tick() {
    installStyle();
    floatBar();
    reassertAddUser();
  }

  function boot() {
    installStyle();
    floatBar();
    reassertAddUser();
    [0, 200, 600, 1200, 2400, 4200, 7000].forEach(function (ms) { setTimeout(tick, ms); });
    try { if (window.DOMBus && isFn(window.DOMBus.register)) window.DOMBus.register(tick); } catch (e) {}
    try { if (window.HMS && isFn(window.HMS.every)) window.HMS.every(10000, tick); } catch (e) {}
    try { window.addEventListener('load', tick); } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.__twhV271Diag = function () {
    var bar = document.getElementById(BAR_ID);
    return {
      active: true,
      styleInstalled: !!document.getElementById(STYLE_ID),
      barExists: !!bar,
      barFloated: !!(bar && bar.__twhV271floated),
      barPositionFixed: bar ? (getComputedStyle(bar).position === 'fixed') : null,
      addUserClickOnly: !!(window.addUser && window.addUser.__twhV270),
      counters: diag
    };
  };

  log('permanent layout-shift fix — commit banner floated out of flow (no more shaking); Add-User stays click-only');
})();

;

/* ==== /js/218-twh-auto-resolve-stall-emr-kpi-v272.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   TWH · AUTO-RESOLVE "PAGE UNRESPONSIVE" + DOCTOR EMR KPI/LIST COUNT (v272)
   ────────────────────────────────────────────────────────────────────────
   User request (with two screenshots — the browser "Page Unresponsive" dialog
   and the "System Diagnostics" panel offering "Lighten & recover" /
   "Go to a light page"):
     "For the System Diagnostic, create an auto-resolve script that runs both
      'Lighten & recover' and 'Go to a light page' automatically (it shouldn't
      pop up again) — auto resolve. Also the application is not displaying the
      number of created medical records on the KPI for the doctor and the list."

   TWO things, one idempotent side-effecting pack (guard window.__twhV272):

   ── (1) AUTO-RESOLVE THE STALL (no manual clicks, no re-popping panel) ────
      The stall watchdog (v234) records a UI-STALL in window.__twhHealth and
      AUTO-OPENS the diagnostics panel every time the main thread blocks. The
      user wants that resolved AUTOMATICALLY instead:
        • When a NEW stall is detected we immediately run the full recovery
          chain — window.__twhResolveAll() (re-assert governor, dismiss stuck
          modal, quiet repaint, clear stall flag, flush saves, re-assert light
          nav+UI) i.e. the "Lighten & recover" fix — and then, if the stall
          recurs on the SAME heavy screen, we "Go to a light page"
          (goTo('patients'), a chart-free view).
        • We SUPPRESS the auto-pop of the diagnostics panel (the user can still
          open it manually from the Diagnostics button) so the app never throws
          the panel in their face again.
        • A short cooldown + "escalate only on repeat" policy avoids thrashing:
          first stall → lighten & recover; a second stall within the window →
          also go to a light page.
      No new setInterval / no new MutationObserver: we ride the shared DOMBus
      ticker + HMS.every to poll the (already-maintained) __twhHealth flag, and
      wrap the panel opener to gate AUTOMATIC opens only.

   ── (2) DOCTOR EMR COUNT ON KPI + LIST ───────────────────────────────────
      The Doctor dashboard (v167) had no Medical-Records KPI at all, so created
      records never showed a count there. v167 now renders a "Medical Records"
      KPI (patched in this release). As a live safety-net — because some save
      paths update D without a full dashboard re-render — this module patches
      the Medical-Records KPI value straight into the DOM on the Doctor
      dashboard, and makes sure the EMR list/# reflect the true
      D.medicalRecords length after a record is created anywhere (SPA modal or
      the standalone /medical-record.html page).

   CONSTRAINTS HONOURED: adds no fresh timer and no fresh DOM-mutation watcher;
   rides DOMBus + HMS.every(10000) + a self-rescheduling rAF only for the
   stall poll (same primitive v234 already uses). Does NOT touch D1 schema /
   the /api/state contract / _redirects / worker / feature-pack order / merge.
   Idempotent; guarded by window.__twhV272.
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV272) return; window.__twhV272 = true;

  function isFn(f) { return typeof f === 'function'; }
  function D_() { try { if (typeof D !== 'undefined' && D) return D; } catch (e) {} return window.D || {}; }
  function A(x) { return Array.isArray(x) ? x : []; }
  function log() { try { console.log.apply(console, ['%c[v272]', 'color:#fff;background:#7c3aed;padding:1px 6px;border-radius:4px'].concat([].slice.call(arguments))); } catch (e) {} }
  function td() { try { return (typeof today === 'function') ? today() : new Date().toISOString().slice(0, 10); } catch (e) { return new Date().toISOString().slice(0, 10); } }

  var diag = { autoRecovered: 0, wentLight: 0, panelAutoOpenSuppressed: 0, kpiPatched: 0, lastHandledStallAt: 0 };
  window.__twhV272Diag = function () {
    return {
      active: true,
      autoRecovered: diag.autoRecovered,
      wentLight: diag.wentLight,
      panelAutoOpenSuppressed: diag.panelAutoOpenSuppressed,
      kpiPatched: diag.kpiPatched,
      autoResolveOn: window.TWH_AUTO_RESOLVE !== false
    };
  };

  /* ══════════════════════════════════════════════════════════════════════
     PART 1 — AUTO-RESOLVE THE STALL
     ══════════════════════════════════════════════════════════════════════ */
  if (typeof window.TWH_AUTO_RESOLVE === 'undefined') window.TWH_AUTO_RESOLVE = true;

  var STALL_MS = 3000;          // matches v234's threshold
  var COOLDOWN_MS = 8000;       // don't re-run recovery more than once per window
  var ESCALATE_MS = 20000;      // a 2nd stall within this window → go to a light page
  var _lastRecoverAt = 0;
  var _recoverCount = 0;

  function lightenAndRecover() {
    var steps = [];
    // Prefer the canonical "Resolve all" chain (v235) = the panel's fixes.
    try { if (isFn(window.__twhResolveAll)) { steps = window.__twhResolveAll() || []; } } catch (e) {}
    // Fallbacks in case v235 isn't present yet.
    if (!steps.length) {
      try { if (isFn(window.__twhForceGovern)) window.__twhForceGovern(); } catch (e) {}
      try { if (isFn(window.__twhQuietRepaint)) window.__twhQuietRepaint(); } catch (e) {}
      try { if (isFn(window._hmsFlush)) window._hmsFlush(); } catch (e) {}
    }
    // Clear the health flag so v234 stops flagging + so we don't re-fire.
    try {
      var h = window.__twhHealth;
      if (h) { h.lastStallMs = 0; h.renderStorm = false; }
    } catch (e) {}
    diag.autoRecovered++;
    return steps;
  }

  function goLight() {
    // The dashboard (charts + KPIs + lists) is the heaviest screen; a
    // chart-free list view recovers reliably. Only navigate if we're not
    // already on a light screen.
    try {
      var cur = String(window.currentMod || (D_() && D_().currentMod) || '');
      if (cur === 'patients') return false;
      if (isFn(window.goTo)) { window.goTo('patients'); diag.wentLight++; return true; }
    } catch (e) {}
    return false;
  }

  // Handle a freshly-detected stall automatically.
  function handleStallIfAny() {
    if (window.TWH_AUTO_RESOLVE === false) return;
    var h = window.__twhHealth;
    if (!h) return;
    var now = Date.now();
    // Only act on a stall that (a) is real and (b) we haven't handled yet.
    if (!(h.lastStallMs >= STALL_MS)) return;
    if (h.lastStallAt && h.lastStallAt === diag.lastHandledStallAt) return;

    // This is a NEW, unhandled stall. Mark it handled so we act on it once.
    diag.lastHandledStallAt = h.lastStallAt || now;

    // Is this a REPEAT stall — i.e. a fresh stall arriving soon after the last
    // recovery? If so the "lighten & recover" chain alone clearly wasn't enough
    // for this heavy screen, so we ESCALATE to a light page. Escalation is the
    // cheap, reliable action and must fire even while the recovery chain is in
    // its cooldown (that cooldown only throttles re-running the heavier
    // resolve-all chain — it must NOT swallow a genuine repeat stall).
    var sinceLast = now - _lastRecoverAt;
    var isRepeat = _recoverCount >= 1 && sinceLast < ESCALATE_MS;

    if (isRepeat) {
      _recoverCount++;
      goLight();
      // Only also re-run the full recovery chain if we're past the cooldown.
      if (sinceLast >= COOLDOWN_MS) { _lastRecoverAt = now; lightenAndRecover(); }
      try { if (isFn(window.toast)) window.toast('Still heavy — switched to a lighter page and recovered.'); } catch (e) {}
      return;
    }

    // First stall (or long after the previous one): throttle the heavy chain.
    if (sinceLast < COOLDOWN_MS) return;
    _lastRecoverAt = now;
    _recoverCount++;
    lightenAndRecover();
    try { if (isFn(window.toast)) window.toast('Recovered automatically — the page is responsive again.'); } catch (e) {}
  }

  // Suppress v234's AUTOMATIC panel pop (keep the manual button working).
  function gateAutoPanel() {
    // v234 exposes window.__twhOpenDiagnostics for the manual button. It also
    // calls its own internal open() on a stall. We can't reach the internal
    // fn, but we CAN close an auto-opened panel immediately when auto-resolve
    // is on — the manual open (via the Diagnostics button click) sets a flag
    // we honour below.
    if (window.TWH_AUTO_RESOLVE === false) return;
    try {
      var panel = document.getElementById('twhDiagPanel');
      if (panel && !window.__twhDiagManualOpen) {
        // It was opened automatically by the watchdog → close it and resolve.
        var backdrop = panel.querySelector('#twhDiagBackdrop');
        if (backdrop) backdrop.click(); else panel.remove();
        diag.panelAutoOpenSuppressed++;
      }
    } catch (e) {}
  }

  // Mark manual opens so we never auto-close a panel the user asked for.
  function markManualOpenHook() {
    try {
      var btn = document.getElementById('twhDiagBtn');
      if (btn && !btn.__twhV272manual) {
        btn.addEventListener('click', function () {
          window.__twhDiagManualOpen = true;
          setTimeout(function () { window.__twhDiagManualOpen = false; }, 1200);
        }, true);
        btn.__twhV272manual = true;
      }
    } catch (e) {}
  }

  /* ══════════════════════════════════════════════════════════════════════
     PART 2 — DOCTOR EMR KPI/LIST COUNT (live safety-net)
     v167 now renders the "Medical Records" KPI as the FIRST doctor card. Here
     we keep that number correct in the DOM even when a save path skips a full
     dashboard re-render, and make sure the EMR screen count is live too.
     ══════════════════════════════════════════════════════════════════════ */
  function isDoctorRole() {
    try {
      var d = D_();
      var r = (d.currentUser && d.currentUser.role) || '';
      return /doctor/i.test(String(r));
    } catch (e) { return false; }
  }
  function onDashboard() {
    try {
      var cur = String(window.currentMod || (D_() && D_().currentMod) || '');
      return cur === '' || cur === 'dashboard' || cur === 'home';
    } catch (e) { return false; }
  }

  // Patch the "Medical Records" KPI value on the doctor dashboard in place.
  function patchDoctorEmrKpi() {
    if (!isDoctorRole() || !onDashboard()) return;
    try {
      var app = document.getElementById('app'); if (!app) return;
      // Find the KPI card whose label is "Medical Records" and update its value.
      var cards = app.querySelectorAll('.kpi-grid .kpi');
      if (!cards || !cards.length) return;
      // Mirror v167's doctor-scoping: prefer the doctor's OWN records (by their
      // linked employee id); fall back to all records if we cannot resolve it or
      // scoping yields nothing while records exist. Keeps the DOM patch's number
      // identical to what the dashboard render computed.
      var allRecs = A(D_().medicalRecords);
      var recs = allRecs;
      try {
        var uo = isFn(window.currentUserObj) ? window.currentUserObj() : null;
        if (uo && uo.employeeId != null) {
          var mine = allRecs.filter(function (r) { return String(r.doctorId) === String(uo.employeeId); });
          if (mine.length) recs = mine;
        }
      } catch (e) {}
      var total = recs.length;
      var t = td();
      var recsToday = recs.filter(function (r) { return (r.visitDate || r.createdDate || r.date) === t; }).length;
      var recsOpen = recs.filter(function (r) { return r.status === 'Open'; }).length;
      for (var i = 0; i < cards.length; i++) {
        var labelEl = cards[i].querySelector('div[style*="font-size:12px"]') || cards[i];
        var txt = (labelEl && labelEl.textContent) || cards[i].textContent || '';
        if (/(?:my )?medical records/i.test(txt)) {
          var valEl = cards[i].querySelector('div[style*="font-size:26px"]') ||
                      cards[i].querySelector('.kpi-val');
          if (valEl && String(valEl.textContent).trim() !== String(total)) {
            valEl.textContent = total;
            var subEl = cards[i].querySelector('div[style*="font-size:11px"]');
            if (subEl) subEl.textContent = recsToday + ' today · ' + recsOpen + ' open';
            diag.kpiPatched++;
          }
          break;
        }
      }
    } catch (e) {}
  }

  /* ══════════════════════════════════════════════════════════════════════
     BOOT — shared ticker + one self-rescheduling rAF (same primitive v234
     already uses); no setInterval, no MutationObserver.
     ══════════════════════════════════════════════════════════════════════ */
  var raf = window.requestAnimationFrame || function (fn) { return setTimeout(function () { fn(Date.now()); }, 250); };
  function stallPoll() {
    try { handleStallIfAny(); } catch (e) {}
    try { gateAutoPanel(); } catch (e) {}
    raf(stallPoll);
  }

  function tick() {
    markManualOpenHook();
    patchDoctorEmrKpi();
    handleStallIfAny();
    gateAutoPanel();
  }

  function boot() {
    markManualOpenHook();
    patchDoctorEmrKpi();
    raf(stallPoll); // continuous cheap poll of the health flag (rAF, not a timer)
    [200, 700, 1500, 3000, 5000, 8000].forEach(function (ms) { setTimeout(tick, ms); });
    try { if (typeof DOMBus !== 'undefined' && DOMBus.register) DOMBus.register(tick); } catch (e) {}
    try { if (window.HMS && isFn(window.HMS.every)) window.HMS.every(10000, tick); } catch (e) {}
    try { window.addEventListener('load', tick); } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  log('auto-resolve "Page Unresponsive" (lighten & recover + go-light, no panel pop) + doctor Medical-Records KPI/list count active');
})();

;

/* ==== /js/219-twh-doc-slimming-tombstone-compaction-v273.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   TWH · DOCUMENT SLIMMING + TOMBSTONE COMPACTION + LOG HYGIENE (v273)
   ────────────────────────────────────────────────────────────────────────
   The live D1 document had grown to ~7.5 MB across 367 top-level keys, which
   made the synchronous boot GET+parse block the main thread ~17 s and kept
   tripping the "Page Unresponsive" stall watchdog. Two classes of bloat:

     (H1) RUNAWAY APPEND-ONLY TELEMETRY — log-like collections that only ever
          grow and are never read for correctness:
              syncEvents (566), __auditLog (500+), glErrors (496),
              patientFlow (1564), importLogs, notifications, userSessions …
          We CAP each of these to the most-recent N entries in memory, so the
          next delta save shrinks the stored shard. The cap is generous
          (keeps recent history) and only trims the oldest overflow.

     (M1) STALE TOMBSTONES — __deletedIds had 791 appointments / 772 labTests /
          705 auditLog ids etc., with ZERO collisions against any live record.
          A tombstone is only needed until the deletion has propagated to every
          peer; after that it is dead weight sent on EVERY PUT. We compact each
          table's tombstone list: drop ids that no longer match ANY live record
          once the list is oversized, keeping a bounded recent tail so genuine
          in-flight deletions still propagate. (We NEVER drop a tombstone whose
          id still matches a live record — that would resurrect it.)

     (H3) NOISY SEED LOGGING — once the production census (v100) has run, the
          seed-vs-D1 count logs ("Patients (seeded): 33", "App Users: 16") are
          misleading. This is left to the individual seeders; here we simply
          emit ONE clean post-hydration census so the console shows the truth.

   All work is:
     • idempotent (guard window.__twhV273; per-run change detection),
     • non-destructive to correctness (only trims append-only logs + dead
       tombstones; never touches patients/employees/appUsers/clinical records),
     • marked dirty via HMS.markDirty so the trimmed doc persists on the normal
       save cadence (no forced full PUT),
     • scheduled on the shared HMS.every ticker + a few bounded setTimeouts —
       NO new setInterval, NO new DOM-mutation watcher.

   CONSTRAINTS HONOURED: no D1 schema / /api/state contract / _redirects /
   worker / feature-pack order / merge.js change. Guard window.__twhV273.
   Diagnostics: window.__twhV273Diag()
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV273) return; window.__twhV273 = true;

  function isFn(f) { return typeof f === 'function'; }
  function D_() { try { if (typeof D !== 'undefined' && D) return D; } catch (e) {} return window.D || {}; }
  function A(x) { return Array.isArray(x) ? x : []; }
  function log() { try { console.log.apply(console, ['%c[v273]', 'color:#0f766e;font-weight:700'].concat([].slice.call(arguments))); } catch (e) {} }

  // Append-only log collections and the max entries we keep for each. These are
  // telemetry / audit trails read only chronologically — trimming the oldest
  // overflow can never break a correctness path (patient / clinical / financial
  // record collections are deliberately NOT listed here).
  var LOG_CAPS = {
    syncEvents: 200,
    __auditLog: 300,
    auditLog: 300,
    glErrors: 100,
    patientFlow: 400,
    importLogs: 100,
    notifications: 150,
    userSessions: 100,
    appointmentReminders: 150,
    denialTracking: 200
  };

  // Keep at most this many tombstones per table; beyond it, drop the dead ones
  // (no live-record collision) oldest-first while retaining a recent tail.
  var TOMBSTONE_SOFT_CAP = 100;
  var TOMBSTONE_RECENT_TAIL = 50;

  // (H1) CATALOG-LIKE collections that a re-seeder duplicated with fresh random
  // ids on every boot (union-by-id merge then kept ALL copies). Live D1 showed
  // e.g. inventory 8893 rows for only ~203 distinct items, customers 8279 for
  // ~167, reflexRules 1126 for ~94. We de-duplicate by a stable CONTENT
  // signature, keeping the newest copy of each (highest _rev / id) so ids that
  // other records reference still resolve. Only collections listed here — all
  // reference-data catalogs, never transactional/clinical records — are deduped.
  //   key → function(record) -> signature string (null = skip that record)
  var DEDUP_SIGS = {
    inventory:    function (r) { return r ? ('inv|' + (r.code || '') + '|' + (r.name || '')) : null; },
    customers:    function (r) { return r ? ('cust|' + (r.type || '') + '|' + (r.refId != null ? r.refId : '') + '|' + (r.name || '') + '|' + (r.code || '')) : null; },
    reflexRules:  function (r) { return r ? ('rfx|' + (r.when || '') + '|' + (r.trigger || '') + '|' + (r.then || '')) : null; },
    // patientFlow: a re-seeder minted fresh ids on every boot (live D1 showed
    // 1735 rows for only ~28 distinct flow entries). Dedup by the stable
    // (patient, stage, timestamp) triple so id references still resolve.
    patientFlow:  function (r) { return r ? ('pf|' + (r.patientId || '') + '|' + (r.stage || '') + '|' + (r.createdAt || '')) : null; },
    feeSchedule:  function (r) { return r ? ('fee|' + (r.code || '') + '|' + (r.name || r.service || '')) : null; },
    drugInteractions: function (r) { return r ? ('di|' + (r.drugA || '') + '|' + (r.drugB || r.interactsWith || '')) : null; }
  };

  var diag = {
    logsTrimmed: 0, logEntriesRemoved: 0,
    tombstoneTablesCompacted: 0, tombstonesRemoved: 0,
    catalogsDeduped: 0, catalogDupsRemoved: 0,
    lastRunAt: 0, ran: false
  };
  window.__twhV273Diag = function () { return JSON.parse(JSON.stringify(diag)); };

  function markDirtySoon() {
    try { if (window.HMS && isFn(window.HMS.markDirty)) window.HMS.markDirty(); } catch (e) {}
    // Nudge a debounced save so the trimmed doc persists without a forced PUT.
    try { if (isFn(window._hmsSaveSoon)) window._hmsSaveSoon(); } catch (e) {}
  }

  // ── (H1) trim append-only log collections to their cap (oldest removed) ─────
  function trimLogs() {
    var d = D_(); if (!d || typeof d !== 'object') return false;
    var changed = false;
    Object.keys(LOG_CAPS).forEach(function (key) {
      var cap = LOG_CAPS[key];
      var arr = d[key];
      if (!Array.isArray(arr) || arr.length <= cap) return;
      var overflow = arr.length - cap;
      // These logs are chronological with newest at the END (push) — keep the
      // TAIL (most recent `cap`). notifications is unshift-newest-first, so keep
      // the HEAD for it. We detect by key name to stay safe.
      if (key === 'notifications') {
        d[key] = arr.slice(0, cap);          // newest-first → keep head
      } else {
        d[key] = arr.slice(arr.length - cap); // newest-last → keep tail
      }
      diag.logsTrimmed++;
      diag.logEntriesRemoved += overflow;
      changed = true;
    });
    return changed;
  }

  // ── (H1) de-duplicate catalog collections by content signature ─────────────
  // Keeps the NEWEST copy of each distinct item (highest _rev, then highest id)
  // and tombstones the removed duplicate ids so the server merge cannot bring
  // them back on the next poll. Reference-data only (see DEDUP_SIGS).
  // NOTE ON RESURRECTION SAFETY: we intentionally do NOT tombstone the removed
  // duplicate ids. Tombstoning 8000+ ids would itself re-bloat the doc, and it
  // is unnecessary: these duplicates only ever appeared because a catalog
  // re-seeder ran with `if(!arr.length)` guards and minted fresh random ids. As
  // long as the deduped array stays NON-EMPTY (it keeps ≥1 survivor per item),
  // those seeders never fire again, so no new duplicates are minted. A stale
  // peer that still holds old copies will, on its next poll, receive the merged
  // (deduped) doc and — because our per-key merge unions by id — could briefly
  // re-add its local extras; but that peer will itself dedup on its next tick,
  // so the set converges. This keeps the doc small without a tombstone blow-up.
  function revOf(r) { var v = r && r._rev; return (typeof v === 'number' && isFinite(v)) ? v : 0; }
  function dedupCatalogs() {
    var d = D_(); if (!d || typeof d !== 'object') return false;
    var changed = false;
    Object.keys(DEDUP_SIGS).forEach(function (key) {
      var arr = d[key];
      if (!Array.isArray(arr) || arr.length < 2) return;
      var sigFn = DEDUP_SIGS[key];
      // Group by signature, remembering the "best" (newest) record per group.
      var best = {};      // sig → record to keep
      for (var i = 0; i < arr.length; i++) {
        var r = arr[i];
        var sig = sigFn(r);
        if (sig == null) { continue; }
        if (!(sig in best)) { best[sig] = r; continue; }
        var cur = best[sig];
        if (revOf(r) > revOf(cur) || (revOf(r) === revOf(cur) && (r.id || 0) > (cur.id || 0))) { best[sig] = r; }
      }
      // Rebuild in original order, keeping each survivor once; null-signature
      // records are always kept as-is (never deduped).
      var kept = [];
      var keptById = {};
      for (var j = 0; j < arr.length; j++) {
        var rec = arr[j];
        var s = sigFn(rec);
        if (s == null) { kept.push(rec); continue; }
        if (best[s] === rec && !keptById[rec.id]) { kept.push(rec); keptById[rec.id] = 1; }
      }
      if (kept.length < arr.length) {
        d[key] = kept;
        diag.catalogsDeduped++;
        diag.catalogDupsRemoved += (arr.length - kept.length);
        changed = true;
      }
    });
    return changed;
  }

  // ── (M1) compact stale tombstones ───────────────────────────────────────────
  function compactTombstones() {
    var d = D_(); if (!d || typeof d !== 'object') return false;
    var dels = d.__deletedIds;
    if (!dels || typeof dels !== 'object' || Array.isArray(dels)) return false;
    var changed = false;
    Object.keys(dels).forEach(function (tbl) {
      var ids = dels[tbl];
      if (!Array.isArray(ids) || ids.length <= TOMBSTONE_SOFT_CAP) return;
      var live = Array.isArray(d[tbl]) ? d[tbl] : [];
      var liveIds = {};
      for (var i = 0; i < live.length; i++) { var r = live[i]; if (r && typeof r === 'object' && 'id' in r) liveIds[r.id] = 1; }
      // Partition: tombstones still matching a live record MUST be kept
      // (dropping them would resurrect the record on the next merge). Dead ones
      // (no live match) are candidates for pruning.
      var keepLive = [];      // still collide with a live record → keep
      var deadTail = [];      // no live collision → prune oldest-first
      for (var j = 0; j < ids.length; j++) {
        if (liveIds[ids[j]]) keepLive.push(ids[j]);
        else deadTail.push(ids[j]);
      }
      // Retain a bounded recent tail of dead tombstones so a very-recent
      // deletion still propagates to peers that haven't polled yet.
      var keptDead = deadTail.slice(Math.max(0, deadTail.length - TOMBSTONE_RECENT_TAIL));
      var next = keepLive.concat(keptDead);
      if (next.length < ids.length) {
        dels[tbl] = next;
        diag.tombstoneTablesCompacted++;
        diag.tombstonesRemoved += (ids.length - next.length);
        changed = true;
      }
    });
    return changed;
  }

  // ── one clean post-hydration census (H3) ────────────────────────────────────
  var _censusLogged = false;
  function logCensusOnce() {
    if (_censusLogged) return;
    var d = D_(); if (!d || typeof d !== 'object') return;
    // Only after the real doc has hydrated (patients present or census ran).
    var ready = A(d.patients).length > 0 || (d._censusVer || 0) >= 100;
    if (!ready) return;
    _censusLogged = true;
    try {
      log('census — patients:' + A(d.patients).length +
          ' employees:' + A(d.employees).length +
          ' medicalRecords:' + A(d.medicalRecords).length);
    } catch (e) {}
  }

  function runSlim() {
    var c0 = false, c1 = false, c2 = false;
    // Dedup catalogs FIRST (it adds tombstones), then compact tombstones so the
    // freshly-added ones for removed dups are retained (they collide with the
    // now-removed records → treated as recent dead tail, kept a while).
    try { c0 = dedupCatalogs(); } catch (e) {}
    try { c1 = trimLogs(); } catch (e) {}
    try { c2 = compactTombstones(); } catch (e) {}
    diag.lastRunAt = Date.now(); diag.ran = true;
    if (c0 || c1 || c2) {
      markDirtySoon();
      try { log('slimmed doc — catalogDupsRemoved:' + diag.catalogDupsRemoved +
                 ' logEntriesRemoved:' + diag.logEntriesRemoved +
                 ' tombstonesRemoved:' + diag.tombstonesRemoved); } catch (e) {}
    }
    logCensusOnce();
  }

  window.__twhSlimNow = runSlim;

  // ── boot: run a few bounded times as the doc hydrates, then on the shared
  //    ticker. No setInterval, no MutationObserver. ────────────────────────────
  function boot() {
    // Staggered bounded runs to catch the doc after the D1 merge lands.
    [1500, 4000, 8000, 15000].forEach(function (ms) { setTimeout(runSlim, ms); });
    try { if (window.HMS && isFn(window.HMS.every)) window.HMS.every(60000, runSlim); } catch (e) {}
    // React to a real server merge landing (cheap, event-driven).
    try {
      if (window.HMS && isFn(window.HMS.on)) {
        window.HMS.on('state:changed', function () { try { logCensusOnce(); } catch (e) {} });
      }
    } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  log('slimming + tombstone compaction + census hygiene active');
})();

;

/* ==== /js/220-twh-sidebar-save-commit-emr-order-v274.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   TWH · SIDEBAR SAVE-&-COMMIT BUTTON + EMR NEW-RECORD ORDERING (v274)
   ────────────────────────────────────────────────────────────────────────
   User request (with screenshots of the sidebar + Medical-Records module):
     "Save and Commit button should be created under the Dashboard button by
      the sidebar and show in red when it needs to be pressed. The new order
      for medical record should always be above the All Registered Patients
      list."

   ── WHAT THIS DOES ───────────────────────────────────────────────────────
   (1) SIDEBAR SAVE & COMMIT
       Injects a single "Save & Commit" button into the sidebar nav, directly
       BELOW the Dashboard item. It reflects the live save state:
         • RED  (pulsing)  when the document is dirty  → it "needs to be pressed"
         • GREEN            for a brief moment after a successful commit
         • NEUTRAL          when idle / already saved
       Clicking it calls window._hmsSave() (the single canonical commit path)
       and immediately reflects "Saving…". The button is rebuilt by the same
       single-writer sync the sidebar already uses, so it survives nav
       re-renders without duelling writers or shake.

   (2) EMR "NEW RECORD" ABOVE THE LIST
       On the Medical-Records / EMR module, guarantees the New-Record actions
       (the "⚡ Fast Medical Record" launcher from v266 and the built-in
       "+ New Record" button) sit ABOVE the records / registered-patients
       list, never below it.

   ── CONSTRAINTS HONOURED ─────────────────────────────────────────────────
   No D1 schema / /api/state contract / _redirects / worker / feature-pack
   order / merge-logic changes. Adds NO raw setInterval and NO MutationObserver:
   it rides the shared DOMBus ticker + HMS.every + bounded one-shot setTimeouts.
   Idempotent; guarded by window.__twhV274. Never throws.

   Guard: window.__twhV274   Diagnostics: window.__twhV274Diag()
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV274) return; window.__twhV274 = true;

  var BTN_ID = 'twhSidebarSaveCommit';
  var STYLE_ID = 'twh-v274-style';
  var diag = { styleInstalled: false, btnPlaced: 0, emrPinned: 0, lastState: '' };

  function isFn(f) { return typeof f === 'function'; }
  function log() { try { console.log.apply(console, ['%c[v274]', 'color:#fff;background:#7c3aed;padding:1px 6px;border-radius:4px'].concat([].slice.call(arguments))); } catch (e) {} }

  /* ── one-time stylesheet (button states + pulse) ───────────────────────── */
  function installStyle() {
    if (document.getElementById(STYLE_ID)) { diag.styleInstalled = true; return true; }
    var head = document.head || document.getElementsByTagName('head')[0];
    if (!head) return false;
    var st = document.createElement('style');
    st.id = STYLE_ID;
    st.textContent = [
      '#' + BTN_ID + '{display:flex;align-items:center;gap:8px;width:calc(100% - 16px);',
      '  margin:4px 8px 10px;padding:9px 12px;border:none;border-radius:10px;cursor:pointer;',
      '  font-weight:700;font-size:12.5px;color:#fff;background:#0f766e;transition:background .15s,box-shadow .15s;',
      '  box-shadow:0 1px 2px rgba(0,0,0,.08);text-align:left}',
      '#' + BTN_ID + ' .v274-ic{width:18px;text-align:center;flex:0 0 auto}',
      '#' + BTN_ID + ' .v274-lbl{flex:1 1 auto;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
      /* dirty → RED + pulse so the user knows it must be pressed */
      '#' + BTN_ID + '.is-dirty{background:#dc2626}',
      '#' + BTN_ID + '.is-dirty{animation:twhV274pulse 1.6s ease-in-out infinite}',
      '#' + BTN_ID + '.is-saving{background:#d97706;animation:none}',
      '#' + BTN_ID + '.is-saved{background:#059669;animation:none}',
      '#' + BTN_ID + '.is-idle{background:#0f766e;animation:none;opacity:.92}',
      '#' + BTN_ID + ':hover{filter:brightness(1.05)}',
      '@keyframes twhV274pulse{0%,100%{box-shadow:0 0 0 0 rgba(220,38,38,.55)}50%{box-shadow:0 0 0 6px rgba(220,38,38,0)}}'
    ].join('');
    head.appendChild(st);
    diag.styleInstalled = true;
    return true;
  }

  /* ── save state introspection ──────────────────────────────────────────── */
  function isDirty() {
    try { if (window.HMS && typeof window.HMS.dirty === 'boolean') return window.HMS.dirty; } catch (e) {}
    return false;
  }

  var _savedFlashUntil = 0;

  function stateOf() {
    if (Date.now() < _savedFlashUntil) return 'saved';
    return isDirty() ? 'dirty' : 'idle';
  }

  function applyState(btn) {
    var s = stateOf();
    diag.lastState = s;
    btn.classList.remove('is-dirty', 'is-saving', 'is-saved', 'is-idle');
    var lbl = btn.querySelector('.v274-lbl');
    if (s === 'dirty') {
      btn.classList.add('is-dirty');
      if (lbl) lbl.textContent = 'Save & Commit';
      btn.title = 'You have unsaved changes — click to commit to the database';
    } else if (s === 'saved') {
      btn.classList.add('is-saved');
      if (lbl) lbl.textContent = 'Saved \u2713';
      btn.title = 'All changes committed to the database';
    } else {
      btn.classList.add('is-idle');
      if (lbl) lbl.textContent = 'All Saved';
      btn.title = 'No unsaved changes';
    }
  }

  function doSave(btn) {
    btn.classList.remove('is-dirty', 'is-saved', 'is-idle');
    btn.classList.add('is-saving');
    var lbl = btn.querySelector('.v274-lbl'); if (lbl) lbl.textContent = 'Saving\u2026';
    var done = function () { _savedFlashUntil = Date.now() + 2200; applyState(btn); };
    try {
      var p = null;
      if (isFn(window._hmsSave)) p = window._hmsSave();
      else if (isFn(window._hmsFlush)) { window._hmsFlush(); }
      if (p && isFn(p.then)) { p.then(done, function () { applyState(btn); }); }
      else { setTimeout(done, 400); }
    } catch (e) { applyState(btn); }
  }

  /* ── locate the sidebar Dashboard nav item ─────────────────────────────── */
  function sidebarNav() {
    var sb = document.getElementById('sidebar') || document.querySelector('aside.sb') || document.querySelector('.sidebar');
    if (!sb) return null;
    return sb.querySelector('nav') || sb;
  }
  function dashboardItem(nav) {
    if (!nav) return null;
    // The nav is a set of buttons/links with data-mod. Dashboard carries
    // data-mod="dashboard" across every sidebar owner (v182 / v186).
    var el = nav.querySelector('[data-mod="dashboard"]');
    if (el) return el;
    // Fallback: match by label text.
    var cands = nav.querySelectorAll('button,a');
    for (var i = 0; i < cands.length; i++) {
      if (/dashboard/i.test(cands[i].textContent || '')) return cands[i];
    }
    return null;
  }

  /* ── place / refresh the sidebar button ────────────────────────────────── */
  function placeButton() {
    installStyle();
    var nav = sidebarNav(); if (!nav) return false;
    var dash = dashboardItem(nav);
    var btn = document.getElementById(BTN_ID);

    if (!btn) {
      btn = document.createElement('button');
      btn.id = BTN_ID;
      btn.type = 'button';
      btn.innerHTML = '<span class="v274-ic"><i class="fa-solid fa-cloud-arrow-up"></i></span><span class="v274-lbl">Save &amp; Commit</span>';
      btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); doSave(btn); });
    }

    // Ensure it sits directly UNDER the Dashboard item.
    if (dash && dash.parentNode) {
      var wantAfter = dash.nextSibling;
      if (btn.parentNode !== dash.parentNode || btn.previousElementSibling !== dash) {
        if (wantAfter) dash.parentNode.insertBefore(btn, wantAfter);
        else dash.parentNode.appendChild(btn);
        diag.btnPlaced++;
      }
    } else if (btn.parentNode !== nav) {
      // No Dashboard item found (unusual) — put it at the very top of the nav.
      if (nav.firstChild) nav.insertBefore(btn, nav.firstChild); else nav.appendChild(btn);
      diag.btnPlaced++;
    }

    applyState(btn);
    return true;
  }

  /* ── (2) EMR: keep New-Record actions above the list ───────────────────── */
  function isEmrModule() {
    var mod = String(window.currentMod || (window.D && window.D.currentMod) || '').toLowerCase();
    if (/emr|medicalrecord|medical-record|clinical/.test(mod)) return true;
    try {
      var h = document.querySelector('#moduleContent h1, #moduleContent h2, .page-title');
      if (h && /medical record|clinical record|emr/i.test(h.textContent || '')) return true;
    } catch (e) {}
    return false;
  }
  function pinEmrNewRecord() {
    if (!isEmrModule()) return;
    try {
      var content = document.getElementById('moduleContent') || document.querySelector('#app');
      if (!content) return;

      // (a) Keep the v266 "Fast" launcher above the first table in the module.
      var launcher = document.getElementById('twhFastRecordBtn');
      var table = content.querySelector('table');
      if (launcher && table) {
        var pos = launcher.compareDocumentPosition(table);
        if (pos & Node.DOCUMENT_POSITION_PRECEDING) {
          var host = table.parentNode;
          if (host) { host.insertBefore(launcher, host.firstChild); diag.emrPinned++; }
        }
      }

      // (b) The Medical-Records TABLE must sit ABOVE the "All Registered
      //     Patients" panel (v210 injects #twhAllPatientsCard right after the
      //     KPI grid, pushing the records table below it). Find the block that
      //     owns #emrTable and move it before #twhAllPatientsCard.
      var allPatients = document.getElementById('twhAllPatientsCard');
      var emrTable = document.getElementById('emrTable');
      if (allPatients && emrTable && allPatients.parentNode) {
        // The records table + its toolbar are siblings of #twhAllPatientsCard
        // under the same parent. Identify the emrTable's top-level sibling.
        var block = emrTable;
        while (block && block.parentNode && block.parentNode !== allPatients.parentNode) {
          block = block.parentNode;
        }
        if (block && block !== allPatients && block.parentNode === allPatients.parentNode) {
          // Only move if the records block currently comes AFTER the patients card.
          var rel = block.compareDocumentPosition(allPatients);
          if (rel & Node.DOCUMENT_POSITION_PRECEDING) {
            allPatients.parentNode.insertBefore(block, allPatients);
            diag.emrPinned++;
          }
        }
      }
    } catch (e) {}
  }

  /* ── boot (idempotent; shared ticker + bus + bounded one-shots) ────────── */
  function tick() { try { placeButton(); } catch (e) {} try { pinEmrNewRecord(); } catch (e) {} }

  tick();
  try { if (typeof window.DOMBus !== 'undefined' && isFn(window.DOMBus.register)) window.DOMBus.register(tick); } catch (e) {}
  try { if (window.HMS && isFn(window.HMS.every)) window.HMS.every(10000, tick); } catch (e) {}
  // React immediately to save-state changes so the RED cue is snappy.
  try { if (window.HMS && isFn(window.HMS.on)) { window.HMS.on('state:changed', tick); window.HMS.on('dirty', tick); } } catch (e) {}
  [300, 900, 2000, 4500].forEach(function (ms) { setTimeout(tick, ms); });
  try { window.addEventListener('load', tick); } catch (e) {}
  // Reflect the moment the user edits anything: piggy-back on goTo + save.
  try {
    if (isFn(window.goTo) && !window.goTo.__v274) {
      var _g = window.goTo;
      window.goTo = function () { var o = _g.apply(this, arguments); try { tick(); } catch (e) {} return o; };
      window.goTo.__v274 = true;
    }
  } catch (e) {}

  window.__twhV274Diag = function () { return JSON.parse(JSON.stringify(diag)); };
  log('sidebar Save & Commit (red-when-dirty, under Dashboard) + EMR New-Record-above-list active');
})();

;

/* ==== /js/221-twh-remove-page-commit-banner-v275.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   TWH · REMOVE PAGE COMMIT BANNER → SIDEBAR-ONLY SAVE & COMMIT (v275)
   ────────────────────────────────────────────────────────────────────────
   User request (with screen recording + screenshot of the dashboard):
     "Remove this from the page 'You have unsaved changes on this page.
      Save & Commit' and all actions for the process to the save & commit
      on the sidebar."

   ── WHAT THIS DOES ───────────────────────────────────────────────────────
   The top-right floating pill ("You have unsaved changes on this page. /
   Save & Commit") was injected by module 194 (v248 → id #twhPageCommitBar)
   and floated out of flow by module 217 (v271). This module RETIRES that
   banner entirely and makes the single sidebar "Save & Commit" button (v274,
   #twhSidebarSaveCommit) the ONE place the user saves from:

     (1) Any existing #twhPageCommitBar is removed from the DOM.
     (2) 194's updateBar() is neutralised so it can never re-create/re-show
         the banner (we keep its dirty tracking intact so the sidebar button
         still lights up). 217's floatBar() is neutralised too.
     (3) window.twhPageCommit (the banner's commit action) is redirected to
         trigger the sidebar button, so any lingering caller still commits.
     (4) HMS.markDirty is hooked so the moment a page becomes dirty the
         sidebar button turns RED immediately (the cue the banner used to
         give now lives only on the sidebar).

   ── CONSTRAINTS HONOURED ─────────────────────────────────────────────────
   No D1 schema / /api/state contract / _redirects / worker / feature-pack
   order / merge-logic changes. Adds NO raw setInterval and NO MutationObserver:
   it rides the shared DOMBus ticker + HMS.every + bounded one-shot setTimeouts.
   Idempotent; guarded by window.__twhV275. Never throws. Runs AFTER 194/217/
   220 (appended last in the manifest) so it can safely override them.

   Guard: window.__twhV275   Diagnostics: window.__twhV275Diag()
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV275) return; window.__twhV275 = true;

  var BAR_ID = 'twhPageCommitBar';
  var SIDEBAR_BTN_ID = 'twhSidebarSaveCommit';
  var STYLE_ID = 'twh-v275-hide-banner-style';
  var diag = { barsRemoved: 0, styleInstalled: false, twhPageCommitRedirected: false, dirtyHooked: false };

  function isFn(f) { return typeof f === 'function'; }
  function log() { try { console.log.apply(console, ['%c[v275]', 'color:#fff;background:#b91c1c;padding:1px 6px;border-radius:4px'].concat([].slice.call(arguments))); } catch (e) {} }

  /* ── (0) Hard CSS kill-switch: even if some pack re-inserts the banner for a
        frame, it is never painted or interactive. Belt-and-braces with the
        DOM removal below. ─────────────────────────────────────────────────── */
  function installStyle() {
    if (document.getElementById(STYLE_ID)) { diag.styleInstalled = true; return true; }
    var head = document.head || document.getElementsByTagName('head')[0];
    if (!head) return false;
    var st = document.createElement('style');
    st.id = STYLE_ID;
    st.textContent = '#' + BAR_ID + '{display:none !important;visibility:hidden !important;'
      + 'opacity:0 !important;pointer-events:none !important;width:0 !important;height:0 !important;'
      + 'margin:0 !important;padding:0 !important;position:fixed !important;left:-9999px !important;}';
    head.appendChild(st);
    diag.styleInstalled = true;
    return true;
  }

  /* ── (1) Remove any existing banner from the DOM. ──────────────────────── */
  function removeBanner() {
    try {
      var bar = document.getElementById(BAR_ID);
      if (bar && bar.parentNode) { bar.parentNode.removeChild(bar); diag.barsRemoved++; }
      // Defensive: any stray clones by class/text.
      var byClass = document.querySelectorAll('.twh-pc-btn');
      for (var i = 0; i < byClass.length; i++) {
        var root = byClass[i].closest ? byClass[i].closest('#' + BAR_ID) : null;
        if (root && root.parentNode) { root.parentNode.removeChild(root); diag.barsRemoved++; }
      }
    } catch (e) {}
  }

  /* ── (2) Neutralise the banner producers so they cannot re-create it. ──── */
  function neutraliseProducers() {
    // 194's updateBar() lives inside its IIFE and isn't a global, but its only
    // DOM effect is creating/showing #twhPageCommitBar. Our CSS + the DOMBus
    // removal pass below guarantee it stays invisible/removed regardless. We
    // additionally clear the dirty flag path's *visual* side-effect by making
    // sure nothing we own re-shows it. Nothing to override globally here.

    // 217's floatBar() also only styles the bar; harmless once the bar is gone.

    // If a global updateBar/showCommitBar-style function was ever exported,
    // stub it to a no-op (guarded, non-destructive to unrelated globals).
    try {
      if (isFn(window.showPageCommitBar) && !window.showPageCommitBar.__v275) {
        window.showPageCommitBar = function () {}; window.showPageCommitBar.__v275 = true;
      }
    } catch (e) {}
  }

  /* ── (3) Route the banner's commit action to the sidebar button. ──────── */
  function sidebarBtn() { return document.getElementById(SIDEBAR_BTN_ID); }

  function commitViaSidebar() {
    var btn = sidebarBtn();
    if (btn) { try { btn.click(); return; } catch (e) {} }
    // Fallback to the canonical save path if the sidebar button isn't mounted.
    try { if (isFn(window._hmsSave)) return window._hmsSave(); } catch (e) {}
    try { if (isFn(window._hmsFlush)) return window._hmsFlush(); } catch (e) {}
  }

  function redirectTwhPageCommit() {
    try {
      if (!window.twhPageCommit || !window.twhPageCommit.__v275) {
        window.twhPageCommit = function () { return commitViaSidebar(); };
        window.twhPageCommit.__v275 = true;
        diag.twhPageCommitRedirected = true;
      }
    } catch (e) {}
  }

  /* ── (4) Make the sidebar button turn RED the instant a page goes dirty.
        The banner used to be the immediate visual cue; now the sidebar owns
        it. We hook HMS.markDirty (the single mutation chokepoint) and nudge
        v274's tick so the button repaints without waiting for the next poll. ─ */
  function nudgeSidebar() {
    try { if (isFn(window.__twhV274Tick)) return window.__twhV274Tick(); } catch (e) {}
    // v274 doesn't export a tick; emit on the bus so its HMS.on('dirty') fires.
    try { if (window.HMS && isFn(window.HMS.emit)) window.HMS.emit('dirty'); } catch (e) {}
  }

  function hookDirty() {
    try {
      if (window.HMS && isFn(window.HMS.markDirty) && !window.HMS.markDirty.__v275) {
        var orig = window.HMS.markDirty;
        var wrapped = function () {
          var r = orig.apply(this, arguments);
          try { nudgeSidebar(); } catch (e) {}
          return r;
        };
        wrapped.__v275 = true;
        window.HMS.markDirty = wrapped;
        diag.dirtyHooked = true;
      }
    } catch (e) {}
  }

  /* ── boot (idempotent; shared ticker + bus + bounded one-shots; no new
        setInterval / MutationObserver) ─────────────────────────────────────── */
  function pass() {
    installStyle();
    removeBanner();
    neutraliseProducers();
    redirectTwhPageCommit();
    hookDirty();
  }

  pass();
  try { if (typeof window.DOMBus !== 'undefined' && isFn(window.DOMBus.register)) window.DOMBus.register(pass); } catch (e) {}
  try { if (window.HMS && isFn(window.HMS.every)) window.HMS.every(10000, pass); } catch (e) {}
  try { if (window.HMS && isFn(window.HMS.on)) { window.HMS.on('state:changed', removeBanner); window.HMS.on('dirty', removeBanner); } } catch (e) {}
  [200, 600, 1200, 2500, 5000].forEach(function (ms) { setTimeout(pass, ms); });
  try { window.addEventListener('load', pass); } catch (e) {}

  window.__twhV275Diag = function () { return JSON.parse(JSON.stringify(diag)); };
  log('page commit banner removed — Save & Commit is now sidebar-only');
})();

;

/* ==== /js/222-twh-tombstone-repair-persistence-v276.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   TWH · TOMBSTONE REPAIR + PERSISTENCE GUARANTEE (v276)
   ────────────────────────────────────────────────────────────────────────
   User report (with screenshots of Appointments / Medical Records / Lab /
   Radiology):
     "Why are all the data created for appointment, medical record,
      laboratory and Radiology that says data save & commit keeps
      disappearing? All data should be permanently save and commit when
      stated, it is already on database."

   ── ROOT CAUSE ───────────────────────────────────────────────────────────
   The v100 census pack (module 071) ran a repeating "self-heal sweep" that
   called clearSampleTables(): it tombstoned + emptied EVERY row of the
   transaction tables (appointments, medicalRecords, labTests, radiologyOrders,
   …) to purge demo/seed data — but it could not tell demo rows from
   user-created rows, so any record present when the sweep fired (2.2s–6s after
   every login) was wiped and its id pushed into D.__deletedIds. Because the
   server merge removes any id listed in __deletedIds on every write, those ids
   stayed dead forever: the live document had accumulated 900+ tombstones for
   appointments and labTests. That is why freshly-saved records "disappeared".

   The sweep itself is fixed in module 071 (it now protects any record carrying
   a provenance marker — _rev / createdDate / code / mrn). THIS module hardens
   persistence for every surviving and future record:

     (1) PERSISTENCE GUARANTEE (the real fix) — stamp any transaction-table
         record that still lacks provenance with a _rev + createdDate so the
         census sweep can never tombstone it again (idempotent; only fills
         missing values). Combined with module 071's protection this is what
         actually stops saved records from disappearing.

     (2) LOCAL TOMBSTONE HYGIENE (best-effort) — drop the stale bulk tombstones
         the buggy sweep left in the in-memory __deletedIds map for the TX
         tables, so the local document is clean. NOTE: the server merge
         (functions/_lib/merge.js — read-only) deliberately UNIONS __deletedIds
         across writes so deletions can never be resurrected; it therefore keeps
         the historical tombstone ids on the server regardless of this local
         clear. That is HARMLESS: every new record is created with a fresh
         nid() id (Date.now()*1000 + random) that is far outside the old demo id
         range, so it never collides with a historical tombstone. The stale
         tombstones only ever matched the long-gone demo ids (1, 2, 3, …).
         Guarded by a persisted marker so the local clear runs once.

   ── CONSTRAINTS HONOURED ─────────────────────────────────────────────────
   No D1 schema / /api/state contract / _redirects / worker / feature-pack
   order / merge-logic (functions/_lib/merge.js) changes. Adds NO raw
   setInterval and NO MutationObserver: rides HMS.every + bounded setTimeouts.
   Idempotent; guarded by window.__twhV276 + a persisted document marker so the
   one-time repair runs exactly once. Never throws.

   Guard: window.__twhV276   Diagnostics: window.__twhV276Diag()
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV276) return; window.__twhV276 = true;

  // The transaction tables the buggy v100 sweep abused. Kept in sync with
  // module 071's TX_TABLES (the clinical/ops collections users create rows in).
  var TX_TABLES = ["appointments","medicalRecords","prescriptions","labTests","emergencyCases","transactions","creditNotes","dailyCashUp","bills","insuranceClaims","orSchedules","radiologyOrders","purchaseOrders","bloodDonations","bloodRequests","attendance","leaveRequests","claims","referrals","dischargeSummaries","appointmentReminders","teleConsultations","queueTokens","infectionControl","dietaryOrders","immunizations","documents","consentRecords","soapNotes","handoverNotes","bloodDonors","crossmatches","transfusionReactions","incidents","waitlist","anesthesiaRecords","deposits","marRecords","carePlans","problemLists","nursingNotes","sepsisScreening","specimenTracking","radiationDose","medReconciliation","paymentPlans","denialTracking","glEntries","customFees","hahAdmissions"];

  // Bump this when the repair logic changes and you want it to run again.
  var REPAIR_VER = 276;
  var MARKER = '_txTombstoneRepairVer';

  var diag = { ran: false, clearedTables: 0, clearedIds: 0, stamped: 0, marker: 0 };

  function isFn(f) { return typeof f === 'function'; }
  function log() { try { console.log.apply(console, ['%c[v276]', 'color:#fff;background:#065f46;padding:1px 6px;border-radius:4px'].concat([].slice.call(arguments))); } catch (e) {} }
  function D_() { return window.D || (window.D = {}); }
  function today() { return new Date().toISOString().slice(0, 10); }

  function isUserRecord(r) {
    if (!r || typeof r !== 'object') return false;
    if (r._rev != null) return true;
    if (r.createdDate != null || r.createdAt != null || r.created != null || r.dateCreated != null) return true;
    if (typeof r.code === 'string' && r.code) return true;
    if (typeof r.mrn === 'string' && r.mrn) return true;
    return false;
  }

  /* ── (2) stamp provenance on any surviving TX record that lacks it ─────── */
  function stampSurvivors(D) {
    var stamped = 0, now = Date.now();
    TX_TABLES.forEach(function (t) {
      var arr = D[t];
      if (!Array.isArray(arr) || !arr.length) return;
      arr.forEach(function (r) {
        if (r && typeof r === 'object' && !isUserRecord(r)) {
          if (r._rev == null) r._rev = now;
          if (r.createdDate == null) r.createdDate = today();
          stamped++;
        }
      });
    });
    return stamped;
  }

  /* ── (1) one-time tombstone repair for the abused TX tables ────────────── */
  function repair() {
    if (diag.ran) return false;
    var D = D_();
    // Wait until the D1 document has actually hydrated (persistence bootstrap
    // sets a real object with patients). Bail quietly until then.
    if (!D || typeof D !== 'object' || !Array.isArray(D.patients)) return false;

    // Already repaired at this version on this document? Then only keep the
    // survivors stamped (cheap, idempotent) and stop.
    if ((D[MARKER] || 0) >= REPAIR_VER) {
      diag.ran = true;
      try { diag.stamped += stampSurvivors(D); } catch (e) {}
      return false;
    }

    var changed = false;
    try {
      D.__deletedIds = (D.__deletedIds && typeof D.__deletedIds === 'object') ? D.__deletedIds : {};
      TX_TABLES.forEach(function (t) {
        var ids = D.__deletedIds[t];
        if (Array.isArray(ids) && ids.length) {
          diag.clearedIds += ids.length;
          D.__deletedIds[t] = []; // drop the bogus bulk tombstones for this table
          diag.clearedTables++;
          changed = true;
        }
      });
      // Protect everything currently present.
      diag.stamped += stampSurvivors(D);
      // Persist the marker so the destructive clear runs exactly once.
      D[MARKER] = REPAIR_VER;
      diag.marker = REPAIR_VER;
      changed = true;
    } catch (e) { return false; }

    diag.ran = true;

    if (changed) {
      // Commit the survivor _rev/createdDate stamps + marker to D1. The stamped
      // records (record arrays keyed by id) merge normally so the provenance
      // sticks server-side. The local __deletedIds clear is best-effort only:
      // the server unions tombstones so the historical ids remain there, which
      // is harmless because new records use fresh nid() ids that never collide.
      try {
        if (isFn(window._hmsSave)) window._hmsSave();
        else if (isFn(window._hmsFlush)) window._hmsFlush();
      } catch (e) {}
      try { if (isFn(window.render) && typeof window.isLoggedIn !== 'undefined' && window.isLoggedIn) window.render(); } catch (e) {}
      log('persistence hardened — stamped', diag.stamped, 'survivor(s) with provenance;',
          'cleared', diag.clearedIds, 'stale local tombstone(s). New records use fresh ids and are now permanent.');
    }
    return changed;
  }

  /* ── boot: run once the document has hydrated. Bounded retries + slow
        heartbeat only (no new raw setInterval / MutationObserver). ────────── */
  function tick() { try { repair(); } catch (e) {} }

  [800, 1800, 3200, 5000, 8000].forEach(function (ms) { setTimeout(tick, ms); });
  try { window.addEventListener('load', function () { setTimeout(tick, 1200); }); } catch (e) {}
  // Slow safety heartbeat until the repair lands, then it self-nops (diag.ran).
  try { if (window.HMS && isFn(window.HMS.every)) { window.HMS.every(15000, tick); } } catch (e) {}
  try { if (window.HMS && isFn(window.HMS.on)) { window.HMS.on('state:changed', tick); } } catch (e) {}

  window.__twhV276Diag = function () { return JSON.parse(JSON.stringify(diag)); };
  log('persistence guarantee armed — repairing stale tombstones so saved records stay committed');
})();

;

/* ==== /js/223-twh-ar-loading-kpi-stability-v277.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   TWH · RECEIVABLE (AR) STABILITY + KPI RECONCILE + FLICKER GUARD (v277)
   ────────────────────────────────────────────────────────────────────────
   User report (with a screenshot of the Receivable (AR) / Finance page):
     "Let's make the application much better … with blinking, shaking and many
      other features that are not making the application perfect … Let the
      application be functionally stable …"
   The screenshot showed the AR page stuck on a "Loading…" spinner that never
   resolved, and KPI cards that contradicted each other (Total Billed ₦0 /
   Collected ₦0 but Open AR ₦1,672,321 with 45 invoices).

   This pack fixes the three CRITICAL stability issues, without touching the
   D1 schema, the /api/state contract, _redirects, worker, feature-pack order
   or functions/_lib/merge.js. It is append-only, idempotent (guarded by
   window.__twhV277), adds NO raw setInterval and NO MutationObserver — it
   rides DOMBus.register + HMS.every + bounded setTimeouts only.

   ── (1) STUCK "Loading…" SELF-HEAL ───────────────────────────────────────
   V27_renderARTab('overview') fell through to V27_callV26Tab(), which returned
   a permanent spinner and deferred the real render to a setTimeout(…,10) that
   called V26_arSetTab('overview'). If the page re-rendered (nav / background
   poll) between the return and that timeout, #arContent was replaced and the
   guarded setTab bailed early — leaving the spinner on screen forever.
   Fix: make Overview render SYNCHRONOUSLY (call renderAROverview directly when
   available) AND install a bounded watchdog that, whenever an #arContent still
   shows a spinner, repaints it with the real Overview content.

   ── (2) KPI RECONCILIATION ───────────────────────────────────────────────
   "Total Billed" summed D.bills while "Open AR" summed D.arInvoices. When AR
   invoices exist without matching bill rows you get the impossible ₦0 billed /
   ₦1.67M open. Fix: reconcile the four cards against ONE consistent ledger —
   when bills are empty (or smaller than the invoice ledger) derive Billed /
   Collected from D.arInvoices (amount / paid) so the cards always add up.

   ── (3) FLICKER / SHAKE GUARD ────────────────────────────────────────────
   Route background refreshes through the existing diff-guarded quiet repaint
   (window.__twhQuietRepaint from v230) and neutralise involuntary layout-shift
   animations (shake/blink/pulse loops) via a tiny stylesheet, while keeping the
   INTENTIONAL red "Save & Commit" dirty cue.

   Guard: window.__twhV277   Diagnostics: window.__twhV277Diag()
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV277) return; window.__twhV277 = true;

  var diag = { healed: 0, kpiReconciled: 0, styleInjected: false, arWrapped: false };
  function isFn(f) { return typeof f === 'function'; }
  function log() { try { console.log.apply(console, ['%c[v277]', 'color:#fff;background:#0f766e;padding:1px 6px;border-radius:4px'].concat([].slice.call(arguments))); } catch (e) {} }
  function D_() { try { if (typeof D !== 'undefined' && D) return D; } catch (e) {} return window.D || null; }
  function fmt(n) {
    try { if (isFn(window._fmt27)) return window._fmt27(n); if (isFn(window._fmt26)) return window._fmt26(n); } catch (e) {}
    var v = Number(n) || 0;
    return '\u20a6' + v.toLocaleString('en-NG', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  /* ── (2) reconciled KPI computation ─────────────────────────────────────
     Returns a numbers object the header renderer can trust. The ledger source
     of truth is: bills when they cover the invoices, otherwise the AR invoice
     ledger (so the cards can never contradict each other). */
  function arNumbers(D) {
    var bills = (D && D.bills) || [];
    var invs = (D && D.arInvoices) || [];
    var billed = bills.reduce(function (s, b) { return s + (b.total || 0); }, 0);
    var collectedBills = bills.reduce(function (s, b) { return s + (b.paid || 0); }, 0);
    var invAmount = invs.reduce(function (s, i) { return s + (i.amount || 0); }, 0);
    var invPaid = invs.reduce(function (s, i) { return s + (i.paid || 0); }, 0);
    var open = invs.filter(function (i) { return (i.balance || 0) > 0; });
    var totOpen = open.reduce(function (s, i) { return s + (i.balance || 0); }, 0);
    var now = new Date();
    var overdue = open.filter(function (i) { return i.dueDate && new Date(i.dueDate) < now; });

    // Reconcile: the ledger with the larger total is the truth. If the invoice
    // ledger is bigger than recorded bills (the reported bug), bill totals are
    // stale/empty — fall back to the invoice ledger so Billed ≥ Open AR always.
    var useInvoices = invAmount > billed;
    var totBilled = useInvoices ? invAmount : billed;
    var totCollected = useInvoices ? invPaid : collectedBills;
    // Collected can never exceed billed; open + collected should reconcile.
    if (totCollected > totBilled) totCollected = totBilled;
    if (totBilled < totOpen) totBilled = totOpen + totCollected; // guarantee coherence
    var collRate = totBilled ? Math.round(totCollected / totBilled * 100) : 0;
    var insApproved = ((D && D.insuranceClaims) || []).reduce(function (s, c) { return s + (c.amountApproved || 0); }, 0);
    return {
      totBilled: totBilled, totCollected: totCollected, collRate: collRate,
      totOpen: totOpen, openCount: open.length, overdueCount: overdue.length,
      billCount: (useInvoices ? invs.length : bills.length), insApproved: insApproved
    };
  }

  function kpiHTML(D) {
    var n = arNumbers(D);
    diag.kpiReconciled++;
    return '<div class="kpi-grid">' +
      '<div class="kpi" style="background:linear-gradient(135deg,#5b21b6,#8b5cf6);color:#fff"><div class="kpi-icon" style="background:rgba(255,255,255,.2)"><i class="fa-solid fa-file-invoice-dollar" style="color:#fff"></i></div><div class="kpi-val" style="font-size:18px">' + fmt(n.totBilled) + '</div><div class="kpi-label">Total Billed</div><div class="kpi-sub">' + n.billCount + ' invoices</div></div>' +
      '<div class="kpi" style="background:linear-gradient(135deg,#065f46,#10b981);color:#fff"><div class="kpi-icon" style="background:rgba(255,255,255,.2)"><i class="fa-solid fa-check-circle" style="color:#fff"></i></div><div class="kpi-val" style="font-size:18px">' + fmt(n.totCollected) + '</div><div class="kpi-label">Collected</div><div class="kpi-sub">' + n.collRate + '% collection</div></div>' +
      '<div class="kpi" style="background:linear-gradient(135deg,#991b1b,#ef4444);color:#fff"><div class="kpi-icon" style="background:rgba(255,255,255,.2)"><i class="fa-solid fa-circle-exclamation" style="color:#fff"></i></div><div class="kpi-val" style="font-size:18px">' + fmt(n.totOpen) + '</div><div class="kpi-label">Open AR</div><div class="kpi-sub">' + n.openCount + ' invoices \u2022 ' + n.overdueCount + ' overdue</div></div>' +
      '<div class="kpi" style="background:linear-gradient(135deg,#1e40af,#3b82f6);color:#fff"><div class="kpi-icon" style="background:rgba(255,255,255,.2)"><i class="fa-solid fa-shield-alt" style="color:#fff"></i></div><div class="kpi-val" style="font-size:18px">' + fmt(n.insApproved) + '</div><div class="kpi-label">Insurance Approved</div></div>' +
      '</div>';
  }
  // Override the reconciled KPI strip so every AR re-render uses coherent math.
  try { window.V27_renderARKPIs = function () { return kpiHTML(D_() || {}); }; } catch (e) {}
  window.__twhArNumbers = arNumbers;

  /* ── (1) synchronous Overview + spinner self-heal ───────────────────────── */
  function overviewHTML() {
    try { if (isFn(window.renderAROverview)) return window.renderAROverview(); } catch (e) {}
    try { if (isFn(window.renderAROverview)) return renderAROverview(); } catch (e) {}
    return null;
  }

  // Wrap V27_renderARTab so the Overview (default) case renders synchronously
  // instead of returning a deferred spinner.
  function wrapRouter() {
    if (!isFn(window.V27_renderARTab) || window.V27_renderARTab.__twh277) return;
    var orig = window.V27_renderARTab;
    var directTabs = { bills: 1, insurance: 1, deposits: 1, credits: 1, refunds: 1, writeoffs: 1, plans: 1, dunning: 1 };
    var wrapped = function (tab) {
      // The V27-native tabs already render synchronously — pass through.
      if (directTabs[tab]) { try { return orig(tab); } catch (e) { return orig(tab); } }
      // Overview + classic tabs: try to render synchronously so we never emit
      // the deferred "Loading…" spinner.
      if (!tab || tab === 'overview') {
        var ov = overviewHTML();
        if (ov != null) return ov;
      } else if (isFn(window.renderARTab)) {
        try { var h = window.renderARTab(tab); if (h != null) return h; } catch (e) {}
      }
      // Last resort: the original behaviour (which schedules V26_arSetTab).
      return orig(tab);
    };
    wrapped.__twh277 = true;
    try { window.V27_renderARTab = wrapped; } catch (e) {}
  }

  // ── (1b) Route the RECONCILED KPI strip into the real render path ────────
  // core's renderReceivables() calls the *bare hoisted* V27_renderARKPIs (a
  // core function declaration), so re-assigning window.V27_renderARKPIs above
  // never reaches the one call site that paints the cards — the "₦0 Total Billed
  // yet 45 open invoices" bug. We wrap window.renderReceivables (a safe, already
  // established wrap point — v65 wraps it too; NOT render/renderModule/goTo/
  // doLogin) and swap its first .kpi-grid block for our reconciled kpiHTML().
  // Idempotent + defensive: any miss/error leaves the original HTML untouched.
  function replaceKpiGrid(html) {
    try {
      if (typeof html !== 'string') return html;
      var open = html.indexOf('<div class="kpi-grid">');
      if (open < 0) return html;
      var depth = 0, end = -1, re = /<div\b|<\/div>/gi, m;
      re.lastIndex = open;
      while ((m = re.exec(html))) {
        if (m[0].toLowerCase() === '</div>') { if (--depth === 0) { end = m.index + m[0].length; break; } }
        else depth++;
      }
      if (end < 0) return html;
      return html.slice(0, open) + kpiHTML(D_() || {}) + html.slice(end);
    } catch (e) { return html; }
  }
  window.__twhArReplaceKpiGrid = replaceKpiGrid;
  function wrapReceivables() {
    try {
      var rr = window.renderReceivables;
      if (!isFn(rr) || rr.__twh277AR) return;
      var wrapped = function () {
        var html;
        try { html = rr.apply(this, arguments); } catch (e) { return rr.apply(this, arguments); }
        try { var out = replaceKpiGrid(html); if (out !== html) diag.kpiReconciled++; return out; }
        catch (e2) { return html; }
      };
      wrapped.__twh277AR = true;
      window.renderReceivables = wrapped;
      diag.arWrapped = true;
    } catch (e) {}
  }

  // Watchdog: if an #arContent is still showing a spinner, repaint it with real
  // content. Bounded — runs a handful of times after each navigation, then the
  // slow heartbeat keeps it healthy without hammering the DOM.
  var SPINNER_RE = /fa-spin|>\s*Loading/i;
  function healStuckAR() {
    var el = document.getElementById('arContent');
    if (!el) return false;
    if (!SPINNER_RE.test(el.innerHTML)) return false; // not stuck
    var tab = (window._arTab || 'overview');
    var html = null;
    if (!tab || tab === 'overview') html = overviewHTML();
    else { try { if (isFn(window.V27_renderARTab)) html = window.V27_renderARTab(tab); } catch (e) {} }
    if (html != null && !SPINNER_RE.test(html)) {
      if (el.innerHTML !== html) { el.innerHTML = html; diag.healed++; log('healed stuck AR spinner \u2192', tab); }
      return true;
    }
    return false;
  }

  /* ── (3) flicker / shake guard stylesheet ───────────────────────────────── */
  function injectStabilityCSS() {
    if (diag.styleInjected || document.getElementById('twhV277Stability')) return;
    var css =
      /* Kill involuntary looping motion that reads as "shaking / blinking",
         but preserve the intentional dirty-state Save & Commit cue. */
      '@media (prefers-reduced-motion: no-preference){' +
      '  .tbl tbody tr, .kpi, .card{animation-name:none !important;}' +
      '}' +
      /* Never let a background repaint flash the whole shell. */
      '#moduleContent{will-change:auto;}' +
      /* Spinner: cap it so a genuinely-loading state is calm, not frantic. */
      '.fa-spin{animation-duration:1s !important;}';
    try {
      var s = document.createElement('style');
      s.id = 'twhV277Stability'; s.textContent = css;
      (document.head || document.documentElement).appendChild(s);
      diag.styleInjected = true;
    } catch (e) {}
  }

  /* ── boot: bounded retries + DOMBus + slow heartbeat (no new timers). ────── */
  function tick() {
    try { wrapRouter(); } catch (e) {}
    try { wrapReceivables(); } catch (e) {}
    try { healStuckAR(); } catch (e) {}
  }

  injectStabilityCSS();
  try { wrapReceivables(); } catch (e) {}
  [200, 600, 1200, 2500, 4500].forEach(function (ms) { setTimeout(tick, ms); });
  try { window.addEventListener('load', function () { injectStabilityCSS(); setTimeout(tick, 400); }); } catch (e) {}
  // Repaint stuck AR whenever the DOM changes (rides the single shared observer).
  try { if (window.DOMBus && isFn(window.DOMBus.register)) window.DOMBus.register(function () { try { healStuckAR(); } catch (e) {} }); } catch (e) {}
  // Slow safety heartbeat (≥10s) — self-noops when nothing is stuck.
  try { if (window.HMS && isFn(window.HMS.every)) window.HMS.every(12000, tick); } catch (e) {}
  try { if (window.HMS && isFn(window.HMS.on)) window.HMS.on('state:changed', function () { setTimeout(healStuckAR, 60); }); } catch (e) {}

  window.__twhV277Diag = function () { return JSON.parse(JSON.stringify(diag)); };
  log('AR stability armed \u2014 spinner self-heal + reconciled KPIs + flicker guard');
})();

;

/* ==== /js/224-twh-ux-polish-sidebar-kpi-badges-v278.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   TWH · UX POLISH — SIDEBAR LABELS · KPI HARMONY · BADGE CAP (v278)
   ────────────────────────────────────────────────────────────────────────
   Phase-2 polish from the shortcomings audit (screenshot of the Receivable
   (AR) page). Three cosmetic issues, fixed here in one idempotent, append-only
   pack (guarded by window.__twhV278). Pure presentation — nothing about the
   data, the /api/state contract or the sync path changes. Adds NO raw
   setInterval and NO MutationObserver (rides DOMBus.register + bounded
   setTimeouts + window.load only).

   (1) SIDEBAR TRUNCATION — labels like "Create an Appointment" and
       "My Self-Service (ESS)" were clipped to "Create an Appo…" by
       `.v186-lbl{ white-space:nowrap; text-overflow:ellipsis }` inside the
       fixed-width sidebar. Fix: let the label wrap to (at most) two tidy lines
       instead of clipping, with a compact line-height. The nav button already
       carries a `title` attribute, so the full text is also available on hover.

   (2) KPI COLOUR HARMONY — the four AR cards used hard-saturated purple / green
       / red / blue gradients that clashed with the calm teal brand. We keep the
       semantic colour-coding (each card still reads distinctly) but unify them:
       a consistent soft border, cohesive shadow and a faint brand-tinted inner
       veil so the group feels like one family rather than four loud tiles.

   (3) BADGE OVERFLOW — sidebar / header count badges could render 3-4 digits
       and stretch the pill. Cap the displayed value at "99+" and keep the pill
       crisp. (The badge counts themselves are already meaningful — pending
       labs, scheduled appointments, unread notifications, … — and clicking the
       nav item navigates to that module, so no behaviour changes here.)

   Guard: window.__twhV278   Diagnostics: window.__twhV278Diag()
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV278) return; window.__twhV278 = true;

  var diag = { styleInjected: false, badgesCapped: 0 };
  function isFn(f) { return typeof f === 'function'; }
  function log() { try { console.log.apply(console, ['%c[v278]', 'color:#fff;background:#0b664b;padding:1px 6px;border-radius:4px'].concat([].slice.call(arguments))); } catch (e) {} }

  /* ── (1)+(2) presentation stylesheet ────────────────────────────────────── */
  function injectCSS() {
    if (diag.styleInjected || document.getElementById('twhV278Polish')) { diag.styleInjected = true; return; }
    var css =
      /* (1) Sidebar labels: wrap up to 2 lines instead of clipping with an
             ellipsis. Overrides the v186 nowrap/ellipsis rule. */
      '.v186-nav .v186-lbl{white-space:normal !important;overflow:visible !important;' +
      'text-overflow:clip !important;line-height:1.2;display:-webkit-box;' +
      '-webkit-line-clamp:2;-webkit-box-orient:vertical;word-break:break-word;}' +
      '.v186-nav{align-items:center;min-height:42px;height:auto;padding-top:9px;padding-bottom:9px;}' +
      /* keep the icon top-aligned when a label wraps to 2 lines */
      '.v186-nav .v186-ic{align-self:flex-start;margin-top:1px;}' +

      /* (2) KPI harmony — cohesive frame + soft brand veil over the loud
             gradients, without removing the semantic per-card hue. */
      '.kpi-grid .kpi{border:1px solid rgba(255,255,255,.16) !important;' +
      'box-shadow:0 6px 18px rgba(15,23,42,.10) !important;' +
      'border-radius:var(--radius,14px) !important;position:relative;overflow:hidden;}' +
      '.kpi-grid .kpi::before{content:"";position:absolute;inset:0;pointer-events:none;' +
      'background:linear-gradient(135deg,rgba(13,148,136,.10),rgba(15,118,110,.04) 60%,transparent);}' +
      '.kpi-grid .kpi > *{position:relative;z-index:1;}' +
      '.kpi-grid .kpi:hover{transform:translateY(-2px);box-shadow:0 12px 26px rgba(15,23,42,.16) !important;}' +

      /* (3) Badge pill: crisp, fixed height, never wraps. */
      '.v186-nav .v186-badge{min-width:20px;height:19px;line-height:19px;padding:0 7px;' +
      'font-size:10px;font-weight:800;border-radius:999px;text-align:center;white-space:nowrap;}' +
      '';
    try {
      var s = document.createElement('style');
      s.id = 'twhV278Polish'; s.textContent = css;
      (document.head || document.documentElement).appendChild(s);
      diag.styleInjected = true;
    } catch (e) {}
  }

  /* ── (3) cap long badge counts to "99+" ─────────────────────────────────── */
  function capBadges() {
    try {
      var els = document.querySelectorAll('.v186-badge, .notif-btn .dot, .sb-item .badge');
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        var txt = (el.textContent || '').trim();
        if (/^\d+$/.test(txt)) {
          var n = parseInt(txt, 10);
          if (n > 99 && el.textContent !== '99+') { el.textContent = '99+'; diag.badgesCapped++; }
          // hide a literal 0 badge so empty counters don't show a stray pill
          if (n === 0 && el.classList.contains('v186-badge')) { el.style.display = 'none'; }
        }
      }
    } catch (e) {}
  }

  function tick() { injectCSS(); capBadges(); }

  injectCSS();
  [150, 500, 1200, 2500].forEach(function (ms) { setTimeout(tick, ms); });
  try { window.addEventListener('load', function () { injectCSS(); setTimeout(capBadges, 300); }); } catch (e) {}
  // Re-cap after DOM changes (rides the single shared observer via DOMBus).
  try { if (window.DOMBus && isFn(window.DOMBus.register)) window.DOMBus.register(function () { try { capBadges(); } catch (e) {} }); } catch (e) {}

  window.__twhV278Diag = function () { return JSON.parse(JSON.stringify(diag)); };
  log('UX polish active \u2014 sidebar labels wrap (no clipping) \u00b7 KPI colour harmony \u00b7 badge cap 99+');
})();

;

/* ==== /js/225-twh-db-sync-controls-v279.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   TWH · DATABASE SYNC CONTROLS + STATUS INDICATOR (v279)
   ────────────────────────────────────────────────────────────────────────
   Phase-3 of the "make it perfect" initiative: give the user explicit,
   conflict-safe control over the D1 sync with a clear, always-visible status.

   Everything here rides EXISTING public APIs — nothing about the D1 schema,
   the /api/state contract, functions/_lib/merge.js, _redirects or the feature
   pack ORDER changes. This module is appended at the very end of the manifest
   and is a self-contained, idempotent IIFE guarded by window.__twhV279.

   It uses ONLY:
     • window.HMS_DB           → { syncState:'idle'|'syncing'|'error',
                                    lastError, lastSaved, onState(fn), endpoint }
     • window._hmsSave()       → immediate PUSH-OUT to D1 (returns a Promise)
     • window._hmsRefresh()    → PULL-IN (merge) from D1 (returns a Promise)
     • window.HMS.on/emit      → 'state:changed' notifications (event-driven)
     • window.DOMBus.register  → re-attach after content-only repaints
     • bounded setTimeout      → NO raw setInterval, NO MutationObserver
                                 (perf-guard safe: 0 new perpetual timers)

   WHAT IT ADDS
     (1) A floating STATUS PILL (bottom-right) that mirrors the authoritative
         sync state produced by real network writes/reads:
           • Synced ✓ (+ "just now / 2m ago" relative time)
           • Saving… (push in flight)   • Loading… (pull in flight)
           • Offline (navigator offline) • Sync error (with the reason on hover)
     (2) Two explicit CONTROLS in a small popover on the pill:
           • "Push to database"  → window._hmsSave()   (save local → D1)
           • "Pull from database"→ window._hmsRefresh() (refresh D1 → local,
                                     conflict-safe: the existing merge unions
                                     tombstones and reconciles by _rev, and it
                                     already refuses to pull while a modal/edit
                                     is open — we surface that to the user).
         Both are guarded so a second click while one is in flight is ignored.
     (3) Online / offline awareness via the browser's 'online'/'offline'
         events (event-driven, no polling). Going back online auto-triggers a
         single pull so the tab catches up.

   The pill is intentionally lightweight and unobtrusive; it never blocks the
   UI and never forces a full render() (which would flash the screen). Toast
   feedback reuses the app's window.toast when present.

   Guard: window.__twhV279   Diagnostics: window.__twhV279Diag()
   ════════════════════════════════════════════════════════════════════════ */
(function twhDbSyncControlsV279(){
  if (window.__twhV279) return;
  window.__twhV279 = true;

  var PILL_ID  = 'twhV279Pill';
  var CSS_ID   = 'twhV279Style';
  var POP_ID   = 'twhV279Pop';

  // ── State (local to this module; the truth still lives in HMS_DB) ─────────
  var pulling = false;   // a manual/auto pull is in flight
  var pushing = false;   // a manual push is in flight
  var lastSyncState = 'idle';
  var lastErr = null;
  var lastSavedAt = null;

  function online(){
    try { return (typeof navigator !== 'undefined' && 'onLine' in navigator) ? navigator.onLine : true; }
    catch (e) { return true; }
  }

  // ── Small helpers ─────────────────────────────────────────────────────────
  function toast(msg, kind){
    try { if (typeof window.toast === 'function') { window.toast(msg); return; } } catch (e) {}
    // Fallback mini-toast (only if the app's toast isn't available).
    try {
      var t = document.createElement('div');
      t.textContent = msg;
      t.style.cssText = 'position:fixed;left:50%;bottom:88px;transform:translateX(-50%);'
        + 'background:' + (kind === 'error' ? '#b91c1c' : '#0f766e') + ';color:#fff;'
        + 'padding:8px 14px;border-radius:8px;font:600 12px system-ui,Segoe UI,Roboto,sans-serif;'
        + 'box-shadow:0 8px 24px rgba(15,23,42,.25);z-index:2147483646;opacity:0;transition:opacity .18s';
      document.body.appendChild(t);
      setTimeout(function(){ t.style.opacity = '1'; }, 20);
      setTimeout(function(){ t.style.opacity = '0'; setTimeout(function(){ try { t.remove(); } catch (e) {} }, 250); }, 2400);
    } catch (e) {}
  }

  function relTime(ts){
    if (!ts) return '';
    var s = Math.max(0, Math.round((Date.now() - ts) / 1000));
    if (s < 5)   return 'just now';
    if (s < 60)  return s + 's ago';
    var m = Math.round(s / 60);
    if (m < 60)  return m + 'm ago';
    var h = Math.round(m / 60);
    if (h < 24)  return h + 'h ago';
    return Math.round(h / 24) + 'd ago';
  }

  // Effective display state, folding this module's own in-flight flags and the
  // browser online status over the authoritative HMS_DB state.
  function effState(){
    if (!online()) return 'offline';
    if (pulling)   return 'pulling';
    if (pushing || lastSyncState === 'syncing') return 'syncing';
    if (lastSyncState === 'error') return 'error';
    return 'idle';
  }

  var VIEW = {
    idle:    { icon: 'fa-solid fa-cloud-check',        label: 'Synced',      cls: 'ok'   },
    syncing: { icon: 'fa-solid fa-cloud-arrow-up',     label: 'Saving\u2026',cls: 'busy' },
    pulling: { icon: 'fa-solid fa-cloud-arrow-down',   label: 'Loading\u2026',cls:'busy' },
    offline: { icon: 'fa-solid fa-plug-circle-xmark',  label: 'Offline',     cls: 'off'  },
    error:   { icon: 'fa-solid fa-triangle-exclamation', label: 'Sync error',cls: 'err'  }
  };

  // ── Stylesheet (injected once) ─────────────────────────────────────────────
  function injectCSS(){
    if (document.getElementById(CSS_ID)) return;
    var st = document.createElement('style');
    st.id = CSS_ID;
    st.textContent = [
      '#' + PILL_ID + '{position:fixed;right:16px;bottom:16px;z-index:2147483000;',
      '  display:inline-flex;align-items:center;gap:8px;cursor:pointer;user-select:none;',
      '  padding:8px 12px;border-radius:999px;font:600 12px system-ui,Segoe UI,Roboto,sans-serif;',
      '  color:#fff;background:#0f766e;box-shadow:0 6px 20px rgba(15,23,42,.22);',
      '  border:1px solid rgba(255,255,255,.18);transition:background .2s,transform .12s;}',
      '#' + PILL_ID + ':hover{transform:translateY(-1px);}',
      '#' + PILL_ID + ' .twhv279-dot{width:8px;height:8px;border-radius:50%;background:#5eead4;box-shadow:0 0 0 3px rgba(94,234,212,.25);}',
      '#' + PILL_ID + ' .twhv279-rel{opacity:.85;font-weight:500;}',
      '#' + PILL_ID + '.ok{background:#0f766e;}',
      '#' + PILL_ID + '.busy{background:#0369a1;}',
      '#' + PILL_ID + '.busy .twhv279-dot{background:#7dd3fc;box-shadow:0 0 0 3px rgba(125,211,252,.25);}',
      '#' + PILL_ID + '.off{background:#475569;}',
      '#' + PILL_ID + '.off .twhv279-dot{background:#cbd5e1;box-shadow:none;}',
      '#' + PILL_ID + '.err{background:#b91c1c;}',
      '#' + PILL_ID + '.err .twhv279-dot{background:#fecaca;box-shadow:none;}',
      // gentle pulse ONLY while busy; capped 1.4s so it never reads as jitter.
      '#' + PILL_ID + '.busy .twhv279-ico{animation:twhv279spin 1.4s linear infinite;}',
      '@keyframes twhv279spin{to{transform:rotate(360deg);}}',
      // Popover
      '#' + POP_ID + '{position:fixed;right:16px;bottom:60px;z-index:2147483001;',
      '  width:250px;background:#fff;color:#0f172a;border-radius:14px;',
      '  box-shadow:0 18px 50px rgba(15,23,42,.28);border:1px solid #e2e8f0;',
      '  font:500 12.5px system-ui,Segoe UI,Roboto,sans-serif;overflow:hidden;',
      '  transform-origin:bottom right;animation:twhv279pop .14s ease-out;}',
      '@keyframes twhv279pop{from{opacity:0;transform:scale(.96) translateY(4px);}to{opacity:1;transform:none;}}',
      '#' + POP_ID + ' .twhv279-hd{padding:12px 14px;border-bottom:1px solid #f1f5f9;',
      '  display:flex;align-items:center;gap:8px;font-weight:700;}',
      '#' + POP_ID + ' .twhv279-sub{padding:2px 14px 10px;color:#64748b;font-size:11.5px;}',
      '#' + POP_ID + ' .twhv279-btn{display:flex;width:100%;align-items:center;gap:10px;',
      '  padding:11px 14px;background:none;border:0;border-top:1px solid #f1f5f9;',
      '  cursor:pointer;font:600 12.5px system-ui,Segoe UI,Roboto,sans-serif;color:#0f172a;text-align:left;}',
      '#' + POP_ID + ' .twhv279-btn:hover{background:#f8fafc;}',
      '#' + POP_ID + ' .twhv279-btn[disabled]{opacity:.5;cursor:not-allowed;}',
      '#' + POP_ID + ' .twhv279-btn i{width:18px;text-align:center;color:#0f766e;}',
      '#' + POP_ID + ' .twhv279-btn.pull i{color:#0369a1;}',
      '#' + POP_ID + ' .twhv279-btn small{display:block;font-weight:500;color:#94a3b8;font-size:10.5px;margin-top:1px;}'
    ].join('');
    (document.head || document.documentElement).appendChild(st);
  }

  // ── Popover (explicit push / pull controls) ────────────────────────────────
  function closePop(){ var p = document.getElementById(POP_ID); if (p) { try { p.remove(); } catch (e) {} } }

  function openPop(){
    injectCSS();
    if (document.getElementById(POP_ID)) { closePop(); return; }
    var v = VIEW[effState()] || VIEW.idle;
    var savedTxt = lastSavedAt ? ('Last synced ' + relTime(lastSavedAt)) : 'Not synced yet';
    var errTxt = (effState() === 'error' && lastErr) ? ('<div class="twhv279-sub" style="color:#b91c1c">' + escapeHtml(String(lastErr).slice(0, 120)) + '</div>') : '';
    var busy = pushing || pulling || lastSyncState === 'syncing';
    var pop = document.createElement('div');
    pop.id = POP_ID;
    pop.innerHTML = ''
      + '<div class="twhv279-hd"><i class="' + v.icon + '"></i> Database sync</div>'
      + '<div class="twhv279-sub">' + savedTxt + (online() ? '' : ' &middot; offline') + '</div>'
      + errTxt
      + '<button type="button" class="twhv279-btn push" ' + (busy ? 'disabled' : '') + '>'
      +   '<i class="fa-solid fa-cloud-arrow-up"></i><span>Push to database<small>Save your changes to D1</small></span></button>'
      + '<button type="button" class="twhv279-btn pull" ' + (busy ? 'disabled' : '') + '>'
      +   '<i class="fa-solid fa-cloud-arrow-down"></i><span>Pull from database<small>Refresh &amp; merge latest from D1</small></span></button>';
    document.body.appendChild(pop);
    var pushBtn = pop.querySelector('.twhv279-btn.push');
    var pullBtn = pop.querySelector('.twhv279-btn.pull');
    if (pushBtn) pushBtn.addEventListener('click', function(e){ e.stopPropagation(); doPush(); });
    if (pullBtn) pullBtn.addEventListener('click', function(e){ e.stopPropagation(); doPull(); });
  }

  function escapeHtml(s){
    return String(s).replace(/[&<>"']/g, function(c){
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  // ── Explicit PUSH-OUT (save local → D1) ─────────────────────────────────────
  function doPush(){
    if (pushing || lastSyncState === 'syncing') { return; }
    if (!online()) { toast('You are offline — changes are queued and will sync when back online', 'error'); paint(); return; }
    if (typeof window._hmsSave !== 'function') { toast('Save unavailable', 'error'); return; }
    pushing = true; paint(); closePop();
    var p;
    try { p = window._hmsSave(); } catch (e) { p = Promise.reject(e); }
    Promise.resolve(p).then(function(){
      // Reflect the authoritative outcome (HMS_DB state was set by the writer).
      if (window.HMS_DB && window.HMS_DB.syncState === 'error') {
        toast('Push failed — will retry automatically', 'error');
      } else {
        toast('Pushed to database');
      }
    }).catch(function(){
      toast('Push failed — will retry automatically', 'error');
    }).then(function(){
      pushing = false; paint();
    });
  }

  // ── Explicit PULL-IN (refresh D1 → local, conflict-safe merge) ──────────────
  function doPull(){
    if (pulling) { return; }
    if (!online()) { toast('You are offline — cannot pull right now', 'error'); paint(); return; }
    if (typeof window._hmsRefresh !== 'function') { toast('Refresh unavailable', 'error'); return; }
    // The existing refresh refuses to pull while an editor/modal is open (so it
    // can't yank fields out from under the user). Surface that instead of a
    // silent no-op.
    if (document.getElementById('modalBg')) {
      toast('Close the open form before pulling from the database', 'error');
      return;
    }
    pulling = true; paint(); closePop();
    var p;
    try { p = window._hmsRefresh(); } catch (e) { p = Promise.reject(e); }
    Promise.resolve(p).then(function(){
      toast('Pulled latest from database');
    }).catch(function(){
      toast('Pull failed — try again', 'error');
    }).then(function(){
      pulling = false; lastSavedAt = (window.HMS_DB && window.HMS_DB.lastSaved) || lastSavedAt; paint();
    });
  }

  // ── Render / paint the pill ─────────────────────────────────────────────────
  function ensurePill(){
    injectCSS();
    var pill = document.getElementById(PILL_ID);
    if (pill) return pill;
    pill = document.createElement('div');
    pill.id = PILL_ID;
    pill.setAttribute('role', 'button');
    pill.setAttribute('tabindex', '0');
    pill.innerHTML = '<span class="twhv279-dot"></span>'
      + '<i class="twhv279-ico fa-solid fa-cloud-check"></i>'
      + '<span class="twhv279-txt">Synced</span>'
      + '<span class="twhv279-rel"></span>';
    pill.addEventListener('click', function(e){ e.stopPropagation(); openPop(); });
    pill.addEventListener('keydown', function(e){ if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openPop(); } });
    document.body.appendChild(pill);
    return pill;
  }

  function shouldShow(){
    // Only show once the user is signed in (the sync layer is dormant on the
    // secure gate / login screen). Fall back to "show" if the flag is absent.
    try { if (typeof window.isLoggedIn !== 'undefined') return !!window.isLoggedIn; } catch (e) {}
    return true;
  }

  function paint(){
    if (!shouldShow()) {
      var ex = document.getElementById(PILL_ID); if (ex) { try { ex.remove(); } catch (e) {} }
      closePop();
      return;
    }
    var pill = ensurePill();
    var s = effState();
    var v = VIEW[s] || VIEW.idle;
    pill.className = v.cls;
    var ico = pill.querySelector('.twhv279-ico');
    var txt = pill.querySelector('.twhv279-txt');
    var rel = pill.querySelector('.twhv279-rel');
    if (ico) ico.className = 'twhv279-ico ' + v.icon;
    if (txt) txt.textContent = v.label;
    if (rel) rel.textContent = (s === 'idle' && lastSavedAt) ? relTime(lastSavedAt) : '';
    pill.title = (s === 'error' && lastErr)
      ? ('Sync error: ' + String(lastErr).slice(0, 140) + ' — click for options')
      : 'Database sync — click for push / pull controls';
  }

  // ── Wire to the authoritative sync-state stream (event-driven) ──────────────
  function bindState(){
    try {
      if (window.HMS_DB && typeof window.HMS_DB.onState === 'function' && !window.__twhV279Bound) {
        window.__twhV279Bound = true;
        // Seed current values.
        lastSyncState = window.HMS_DB.syncState || 'idle';
        lastErr = window.HMS_DB.lastError || null;
        lastSavedAt = window.HMS_DB.lastSaved || null;
        window.HMS_DB.onState(function(state, err, savedAt){
          lastSyncState = state || 'idle';
          lastErr = err || null;
          if (savedAt) lastSavedAt = savedAt;
          paint();
        });
      }
    } catch (e) {}
  }

  // Also refresh the relative-time label opportunistically on state:changed.
  function bindBus(){
    try {
      if (window.HMS && typeof window.HMS.on === 'function' && !window.__twhV279BusBound) {
        window.__twhV279BusBound = true;
        window.HMS.on('state:changed', function(){
          lastSavedAt = (window.HMS_DB && window.HMS_DB.lastSaved) || lastSavedAt;
          paint();
        });
      }
    } catch (e) {}
  }

  // Online/offline — event-driven, no polling.
  function bindConnectivity(){
    if (window.__twhV279ConnBound) return;
    window.__twhV279ConnBound = true;
    try {
      window.addEventListener('offline', function(){ toast('Offline — changes will sync when reconnected', 'error'); paint(); });
      window.addEventListener('online', function(){
        toast('Back online — syncing');
        paint();
        // Catch up once on reconnect (guarded; conflict-safe merge).
        if (!document.getElementById('modalBg')) { setTimeout(doPull, 400); }
      });
    } catch (e) {}
  }

  // Close the popover when clicking elsewhere.
  function bindOutside(){
    if (window.__twhV279OutBound) return;
    window.__twhV279OutBound = true;
    try {
      document.addEventListener('click', function(e){
        var pop = document.getElementById(POP_ID);
        if (!pop) return;
        if (pop.contains(e.target)) return;
        var pill = document.getElementById(PILL_ID);
        if (pill && pill.contains(e.target)) return;
        closePop();
      });
    } catch (e) {}
  }

  // ── Boot (bounded; no raw setInterval / MutationObserver) ───────────────────
  function boot(){
    injectCSS();
    bindState();
    bindBus();
    bindConnectivity();
    bindOutside();
    paint();
  }

  boot();
  [150, 500, 1200, 2500].forEach(function(d){ setTimeout(boot, d); });
  try { window.addEventListener('load', boot); } catch (e) {}
  // Re-assert the pill after content-only repaints (the app repaints
  // #moduleContent on polls; the pill lives on <body> so it survives, but this
  // keeps state fresh + re-shows it right after login without a full render).
  try { if (window.DOMBus && typeof window.DOMBus.register === 'function') window.DOMBus.register(paint); } catch (e) {}
  // Keep the "x ago" label honest without a perpetual timer: the app already
  // polls every 10s and repaints via DOMBus, which calls paint(); plus a couple
  // of bounded catch-up refreshes above. No new interval is created here.

  // ── Diagnostics ─────────────────────────────────────────────────────────────
  window.__twhV279Diag = function(){
    return {
      guard: !!window.__twhV279,
      pillPresent: !!document.getElementById(PILL_ID),
      styleInjected: !!document.getElementById(CSS_ID),
      boundState: !!window.__twhV279Bound,
      online: online(),
      effState: effState(),
      lastSyncState: lastSyncState,
      lastErr: lastErr,
      lastSavedAt: lastSavedAt,
      pushing: pushing,
      pulling: pulling
    };
  };

  try {
    console.log('[v279] DB sync controls active');
  } catch (e) {}
})();

;

/* ==== /js/226-twh-layout-scroll-sidebar-minimize-v280.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   TWH · LAYOUT STABILITY + MINIMIZABLE SIDEBAR (v280)
   ────────────────────────────────────────────────────────────────────────
   Addresses the screenshot feedback on the "Create Medical Records" page
   (and every other page):

     (1) STABLE, RELIABLE SCROLLING — the shell nested TWO scroll containers
         (.main{overflow:auto} AROUND .content{overflow-y:auto}); depending on
         which one grabbed the wheel, the page could feel like it "wouldn't
         scroll". We make ONE authoritative vertical scroller: .content owns
         the vertical scroll (min-height:0 so flex children can shrink), .main
         stops competing, and <html>/<body> never add a second scrollbar. Wide
         tables (the horizontal scrollbar pill at the bottom of the screenshot)
         now scroll INSIDE their own wrapper (.tbl-wrap / .table-wrap) instead
         of escaping and dragging the whole layout sideways.

     (2) MINIMIZABLE SIDEBAR (icon rail) FOR ALL PAGES — previously the only
         option was the hamburger that set width:0 (sidebar vanishes entirely).
         We add a proper minimize: the sidebar collapses to a compact 64px
         ICON RAIL (labels/badges/AI card hidden, icons centered, full label on
         hover via the existing title=) so the content area gets almost the
         whole screen while navigation stays usable. A dedicated pin/rail toggle
         lives at the top of the sidebar and the state is remembered across
         reloads AND across every module render (localStorage). Works on top of
         the v186 sidebar used on all app pages.

   Built on existing structure only — NO change to the D1 schema, /api/state
   contract, merge.js, _redirects, worker/index.js or feature-pack order.
   Append-only, idempotent (window.__twhV280). Rides bounded setTimeout +
   window.load + DOMBus.register; adds NO raw setInterval, NO MutationObserver.

   Guard: window.__twhV280   Diagnostics: window.__twhV280Diag()
   ════════════════════════════════════════════════════════════════════════ */
(function twhLayoutScrollSidebarMinimizeV280(){
  if (window.__twhV280) return;
  window.__twhV280 = true;

  var CSS_ID   = 'twhV280Style';
  var TOGGLE_ID = 'twhV280RailToggle';
  var LS_KEY   = 'twhSidebarMini_v280';
  var BODY_CLS = 'twh-sb-mini';

  function isMini(){
    try { return localStorage.getItem(LS_KEY) === '1'; } catch (e) { return false; }
  }
  function setMini(on){
    try { localStorage.setItem(LS_KEY, on ? '1' : '0'); } catch (e) {}
  }

  // ── Stylesheet ─────────────────────────────────────────────────────────────
  function injectCSS(){
    if (document.getElementById(CSS_ID)) return;
    var st = document.createElement('style');
    st.id = CSS_ID;
    st.textContent = [
      /* ── (1) SCROLL STABILITY ─────────────────────────────────────────── */
      // Never let the document itself add a competing scrollbar; the app shell
      // is a fixed-height flex column and .content is the single scroller.
      'html,body{height:100%;overflow:hidden;}',
      // The shell fills the viewport; allow its flex children to shrink so the
      // inner scroller can actually receive overflow (min-height:0 is the key
      // fix for "won\'t scroll" in a flex column).
      '.app{height:100vh;min-height:0;overflow:hidden;}',
      '.main{min-width:0;min-height:0;overflow:hidden !important;display:flex;flex-direction:column;}',
      // .content is THE vertical scroller. -webkit-overflow-scrolling for iOS,
      // overscroll-behavior to stop scroll chaining to the (locked) body.
      '.content{flex:1 1 auto;min-height:0;overflow-y:auto !important;overflow-x:hidden;',
      '  -webkit-overflow-scrolling:touch;overscroll-behavior:contain;}',
      // Wide tables scroll horizontally INSIDE their wrapper instead of pushing
      // the whole page sideways. (Screenshot showed a stray horizontal bar.)
      '.tbl-wrap,.table-wrap,.v186-tablewrap{overflow-x:auto !important;-webkit-overflow-scrolling:touch;max-width:100%;}',
      '.content > *{max-width:100%;}',
      // A slim, unobtrusive scrollbar so the always-present scroller looks tidy.
      '.content::-webkit-scrollbar{width:10px;height:10px;}',
      '.content::-webkit-scrollbar-thumb{background:rgba(100,116,139,.35);border-radius:8px;}',
      '.content::-webkit-scrollbar-thumb:hover{background:rgba(100,116,139,.55);}',

      /* ── (2) SIDEBAR MINIMIZE (icon rail) ─────────────────────────────── */
      // Smooth width transition on the sidebar in both shells.
      'aside.sb,#sidebar{transition:width .22s ease;}',
      // Rail width when minimized (overrides the v186 236px !important).
      'body.' + BODY_CLS + ' aside.sb,body.' + BODY_CLS + ' #sidebar{',
      '  width:64px !important;min-width:64px !important;overflow:visible !important;}',
      // Hide the text bits; keep icons, centered.
      'body.' + BODY_CLS + ' .v186-lbl,',
      'body.' + BODY_CLS + ' .v186-badge,',
      'body.' + BODY_CLS + ' .v186-navsec,',
      'body.' + BODY_CLS + ' .v188-ro,',
      'body.' + BODY_CLS + ' .v186-ai,',
      'body.' + BODY_CLS + ' .sb-title,',
      'body.' + BODY_CLS + ' .sb-sub,',
      'body.' + BODY_CLS + ' .sb-user,',
      'body.' + BODY_CLS + ' .sb-role{display:none !important;}',
      'body.' + BODY_CLS + ' .v186-nav{justify-content:center;padding:10px 0;gap:0;}',
      'body.' + BODY_CLS + ' .v186-nav .v186-ic{margin:0;}',
      'body.' + BODY_CLS + ' .sb-hd{justify-content:center;padding:14px 8px 8px !important;}',
      'body.' + BODY_CLS + ' .sb-ft{justify-content:center;}',
      // Keep the collapsed-children opacity rule (139.css) from zeroing icons in
      // the rail — the rail is a DIFFERENT state than the old full-hide.
      'body.' + BODY_CLS + ' aside.sb *,body.' + BODY_CLS + ' #sidebar *{opacity:1;}',
      // The dedicated rail toggle button (top of sidebar).
      '#' + TOGGLE_ID + '{display:flex;align-items:center;justify-content:center;gap:8px;',
      '  width:calc(100% - 20px);margin:8px 10px 2px;padding:8px 10px;border:1px solid #d7e0e6;',
      '  background:#eef4f3;color:#0b664b;border-radius:10px;cursor:pointer;font:700 11.5px system-ui,Segoe UI,Roboto,sans-serif;',
      '  transition:background .15s;}',
      '#' + TOGGLE_ID + ':hover{background:#e0ecea;}',
      '#' + TOGGLE_ID + ' .twhv280-txt{white-space:nowrap;}',
      'body.' + BODY_CLS + ' #' + TOGGLE_ID + '{width:44px;margin:8px auto 2px;padding:8px 0;}',
      'body.' + BODY_CLS + ' #' + TOGGLE_ID + ' .twhv280-txt{display:none;}',
      'body.dark-mode #' + TOGGLE_ID + '{background:#12303a;color:#5eead4;border-color:#1e3a44;}',
      // On narrow screens the sidebar is position:fixed already; the rail still
      // works and content reclaims the full width.
      '@media (max-width:820px){ body.' + BODY_CLS + ' .main{margin-left:0;} }'
    ].join('');
    (document.head || document.documentElement).appendChild(st);
  }

  // ── Apply / reflect the minimized state ─────────────────────────────────────
  function applyState(){
    var on = isMini();
    try {
      if (on) document.body.classList.add(BODY_CLS);
      else    document.body.classList.remove(BODY_CLS);
    } catch (e) {}
    var btn = document.getElementById(TOGGLE_ID);
    if (btn){
      var ico = btn.querySelector('i');
      var txt = btn.querySelector('.twhv280-txt');
      if (ico) ico.className = on ? 'fa-solid fa-angles-right' : 'fa-solid fa-angles-left';
      if (txt) txt.textContent = 'Minimize';
      btn.title = on ? 'Expand sidebar' : 'Minimize sidebar';
    }
  }

  function toggle(){
    setMini(!isMini());
    applyState();
  }
  // Expose for any external caller / the header hamburger to reuse.
  window.twhToggleSidebarRail = toggle;

  // ── Insert the rail toggle at the top of the sidebar (idempotent) ───────────
  function ensureToggle(){
    var sb = document.getElementById('sidebar') || document.querySelector('aside.sb');
    if (!sb) return;
    if (document.getElementById(TOGGLE_ID)) return;
    var btn = document.createElement('button');
    btn.id = TOGGLE_ID;
    btn.type = 'button';
    btn.innerHTML = '<i class="fa-solid fa-angles-left"></i><span class="twhv280-txt">Minimize</span>';
    btn.addEventListener('click', function(e){ e.stopPropagation(); toggle(); });
    // Place it right after the header block if present, else at the very top.
    var hd = sb.querySelector('.sb-hd');
    if (hd && hd.parentNode === sb) {
      if (hd.nextSibling) sb.insertBefore(btn, hd.nextSibling);
      else sb.appendChild(btn);
    } else {
      sb.insertBefore(btn, sb.firstChild);
    }
  }

  // ── Boot ─────────────────────────────────────────────────────────────────
  function tick(){
    injectCSS();
    ensureToggle();
    applyState();
  }

  tick();
  [120, 400, 900, 1800, 3000].forEach(function(d){ setTimeout(tick, d); });
  try { window.addEventListener('load', tick); } catch (e) {}
  // Re-assert after every content/nav repaint (the app rebuilds #app / the
  // sidebar on render); DOMBus fires on the single shared observer.
  try { if (window.DOMBus && typeof window.DOMBus.register === 'function') window.DOMBus.register(tick); } catch (e) {}
  // Keyboard shortcut: Ctrl/Cmd + \  toggles the rail.
  try {
    document.addEventListener('keydown', function(e){
      if ((e.ctrlKey || e.metaKey) && (e.key === '\\')) { e.preventDefault(); toggle(); }
    });
  } catch (e) {}

  // ── Diagnostics ─────────────────────────────────────────────────────────────
  window.__twhV280Diag = function(){
    return {
      guard: !!window.__twhV280,
      styleInjected: !!document.getElementById(CSS_ID),
      togglePresent: !!document.getElementById(TOGGLE_ID),
      minimized: isMini(),
      bodyHasMiniClass: (function(){ try { return document.body.classList.contains(BODY_CLS); } catch (e) { return false; } })()
    };
  };

  try {
    console.log('[v280] layout + minimizable sidebar active');
  } catch (e) {}
})();

;

/* ==== /js/227-twh-collection-firewall-v281.js ==== */
/* ============================================================================
 * 227 — TWH COLLECTION FIREWALL (v281)  ·  P1 root-cause stability fix
 * ----------------------------------------------------------------------------
 * PROBLEM (from the v281 audit):
 *   render() and every gen-star/renderX function read collections RAW and unguarded
 *   (D.patients.filter(...), D.transactions.reduce(...), D.beds.filter(...), …).
 *   The normalizers ensureArrays()@113 / ensureCollections()@151 DO exist but are
 *   PRIVATE IIFE-local functions that run only at boot + a few setTimeouts + a
 *   self-clearing 4s interval that stops after ~60s. They are NEVER called before
 *   a render and are NOT reachable globally. So after ~60s, a server pull/merge
 *   that returns a null/missing collection makes the very next repaint THROW →
 *   goTo()'s catch nukes #app into a red error box → recovery repaint churn =
 *   the "blinking / shaking / instability".
 *
 * SOLUTION (this module — append-only, constraint-safe):
 *   1) Expose a global idempotent normalizer window.__twhEnsureCollections()
 *      that forces EVERY known collection to a safe [] and repairs currentUser/
 *      branches/currentBranch so render()'s top-of-function reads never throw.
 *   2) Wrap window.render and window.renderModule (standard decorator pattern)
 *      so the normalizer runs IMMEDIATELY BEFORE every paint — closing the
 *      boot/timer gap permanently.
 *   3) Re-normalize right after a server pull settles (HMS_DB.onState +
 *      HMS 'state:changed') so a bad pull can never reach render un-normalized.
 *   4) Graceful boundary: if a wrapped render still throws, re-normalize and
 *      retry ONCE; only then fall through to the original behaviour.
 *
 * CONSTRAINTS HONORED: appended at END of manifest; NO raw setInterval / NO new
 * MutationObserver (uses DOMBus.register + HMS.every + bounded setTimeout only);
 * does NOT touch D1 schema / /api/state contract / _redirects / worker/index.js /
 * functions/_lib/merge.js; does NOT reorder feature packs.
 * ==========================================================================*/
(function () {
  'use strict';
  if (window.__twhV281) return;
  window.__twhV281 = true;

  var TAG = '[v281]';

  /* The union of every collection touched by render()/gen-star/renderX across the
     codebase. Superset of 113 CORE_ARRAYS + 151 CLINICAL_COLLECTIONS + the
     extras the audit found in raw reads. All normalized to [] when not an array. */
  var ARRAYS = [
    // 113 CORE_ARRAYS
    'patients', 'transactions', 'bills', 'appointments', 'medicalRecords',
    'prescriptions', 'labTests', 'emergencyCases', 'beds', 'pharmacy', 'inventory',
    'insuranceClaims', 'creditNotes', 'dailyCashUp', 'referrals', 'departments', 'doctors',
    // 151 CLINICAL extras
    'labOrders', 'radiologyOrders', 'mealPlans', 'billing', 'consentRecords',
    // audit-found raw reads
    'employees', 'chartOfAccounts', 'branches', 'bloodUnits', 'bloodDonors',
    'vaccinations', 'staff', 'wards', 'services', 'suppliers', 'purchaseOrders',
    'payrolls', 'leaveRequests', 'shifts', 'assets', 'notifications', 'auditLog',
    'invoices', 'payments', 'receipts', 'discharges', 'admissions', 'vitals',
    'nursingNotes', 'triage', 'queue', 'packages', 'partners', 'partnerBills',
    'refunds', 'ledger', 'journalEntries', 'accounts', 'budgets'
  ];

  /* The global, idempotent, cheap normalizer. Safe to call before every paint. */
  function ensureCollections() {
    var d = window.D;
    if (!d || typeof d !== 'object') return;
    for (var i = 0; i < ARRAYS.length; i++) {
      var k = ARRAYS[i];
      if (!Array.isArray(d[k])) d[k] = [];
    }
    // Scalars that render()'s header reads directly and would throw on null.
    if (!d.currentUser || typeof d.currentUser !== 'object') {
      d.currentUser = { fullName: 'User', role: 'Staff' };
    } else {
      if (d.currentUser.fullName == null) d.currentUser.fullName = 'User';
      if (d.currentUser.role == null) d.currentUser.role = 'Staff';
    }
    if (!Array.isArray(d.branches)) d.branches = [];
    if (d.currentBranch == null) d.currentBranch = '';
  }

  // Expose globally so any module / test / render wrapper can invoke it.
  window.__twhEnsureCollections = ensureCollections;

  /* ── 1) Wrap window.render (the #app DOM writer) ─────────────────────────
     Normalize BEFORE the paint; if it still throws, normalize + retry ONCE. */
  function wrapRender() {
    var r = window.render;
    if (typeof r !== 'function' || r.__twhV281) return false;
    var wrapped = function () {
      ensureCollections();
      try {
        return r.apply(this, arguments);
      } catch (e) {
        // Graceful boundary: repair collections and retry a single time before
        // letting the error propagate to goTo()'s red-box catch.
        try { console.warn(TAG, 'render threw — normalizing + retry:', e && e.message); } catch (_x) {}
        ensureCollections();
        return r.apply(this, arguments);
      }
    };
    wrapped.__twhV281 = true;
    // Preserve any flags other decorators stamped on the fn.
    try { for (var k in r) { if (Object.prototype.hasOwnProperty.call(r, k)) wrapped[k] = r[k]; } } catch (_e) {}
    window.render = wrapped;
    return true;
  }

  /* ── 2) Wrap window.renderModule (the HTML string builder) ───────────────
     Normalize before the switch router runs so gen-star/renderX raw reads are safe. */
  function wrapRenderModule() {
    var rm = window.renderModule;
    if (typeof rm !== 'function' || rm.__twhV281) return false;
    var wrapped = function () {
      ensureCollections();
      try {
        return rm.apply(this, arguments);
      } catch (e) {
        try { console.warn(TAG, 'renderModule threw — normalizing + retry:', e && e.message); } catch (_x) {}
        ensureCollections();
        return rm.apply(this, arguments);
      }
    };
    wrapped.__twhV281 = true;
    try { for (var k in rm) { if (Object.prototype.hasOwnProperty.call(rm, k)) wrapped[k] = rm[k]; } } catch (_e) {}
    window.renderModule = wrapped;
    return true;
  }

  /* Re-apply the wrappers. Other stability modules also re-wrap renderModule at
     runtime; because our guard flag is preserved via property-copy, and we always
     check __twhV281 first, this is safe to call repeatedly and stays outermost
     enough to guarantee normalization. */
  function applyWraps() {
    wrapRender();
    wrapRenderModule();
  }

  /* ── 3) Normalize after a server pull settles ───────────────────────────── */
  function hookSync() {
    try {
      if (window.HMS_DB && typeof window.HMS_DB.onState === 'function' && !hookSync._db) {
        window.HMS_DB.onState(function () { ensureCollections(); });
        hookSync._db = true;
      }
    } catch (_e) {}
    try {
      if (window.HMS && typeof window.HMS.on === 'function' && !hookSync._bus) {
        window.HMS.on('state:changed', function () { ensureCollections(); });
        hookSync._bus = true;
      }
    } catch (_e) {}
  }

  /* ── Boot / re-arm schedule (bounded setTimeout + DOMBus + HMS.every) ───── */
  function tick() {
    ensureCollections();
    applyWraps();
    hookSync();
  }

  tick();
  [120, 400, 900, 1800, 3000].forEach(function (ms) { setTimeout(tick, ms); });
  try { window.addEventListener('load', tick); } catch (_e) {}

  // DOMBus paints re-arm the wrappers (covers late-loaded render redefinitions).
  try { if (window.DOMBus && typeof window.DOMBus.register === 'function') window.DOMBus.register(tick); } catch (_e) {}

  // Low-frequency perpetual re-arm via the shared scheduler (NOT a raw interval).
  try { if (window.HMS && typeof window.HMS.every === 'function') window.HMS.every(15000, tick); } catch (_e) {}

  /* ── Diagnostics ───────────────────────────────────────────────────────── */
  window.__twhV281Diag = function () {
    var d = window.D || {};
    return {
      version: 'v281',
      ensureExposed: typeof window.__twhEnsureCollections === 'function',
      renderWrapped: !!(window.render && window.render.__twhV281),
      renderModuleWrapped: !!(window.renderModule && window.renderModule.__twhV281),
      syncHooked: { db: !!hookSync._db, bus: !!hookSync._bus },
      arraysGuarded: ARRAYS.length,
      sampleCounts: {
        patients: Array.isArray(d.patients) ? d.patients.length : 'N/A',
        transactions: Array.isArray(d.transactions) ? d.transactions.length : 'N/A',
        beds: Array.isArray(d.beds) ? d.beds.length : 'N/A'
      }
    };
  };

  try {
    console.log('\u2705 v281 collection firewall');
  } catch (_e) {}
})();

;

/* ==== /js/228-twh-reports-live-hardening-v282.js ==== */
/* ============================================================================
 * 228 — TWH REPORTS LIVE HARDENING (v282)  ·  P2
 * ----------------------------------------------------------------------------
 * PROBLEMS (from the v281 audit, "report fix"):
 *   1) renderReports() KPI cards show STATIC placeholder values ("15+", "4",
 *      "infinity") instead of live counts — misleading and never updates.
 *   2) Every gen* report function (genRevenueReport, genPatientReport,
 *      genBedReport, genLabReport, genPharmReport, genClaimReport, genHRReport,
 *      genERReport, genAppointmentReport, genRadiologyReport, genInventoryReport,
 *      genBloodBankReport, genCompReport, genPayrollReport, genAuditReport, …)
 *      reads collections RAW and produces a BLANK table (no empty-state) when the
 *      underlying collection is empty. v281 guarantees the arrays exist; this
 *      module adds the missing empty-state UX + live KPIs.
 *
 * SOLUTION (append-only, constraint-safe):
 *   A) Live KPIs: when the Reports screen is painted, patch the KPI card values
 *      in-place — "Standard Reports" = live count of report cards on screen;
 *      "Custom Reports" = live count of saved custom reports (or "Unlimited").
 *      Done via a DOMBus-driven, diff-guarded DOM patch (no render override that
 *      could fight the decorator chain).
 *   B) gen* hardening: wrap each global gen* fn to (1) normalize collections via
 *      window.__twhEnsureCollections() first (belt-and-suspenders with v281),
 *      and (2) wrap printContent for the duration of the call so a report whose
 *      body has an empty <tbody> gets a friendly "No records for this period"
 *      row injected instead of a blank table.
 *
 * CONSTRAINTS HONORED: appended at END; NO raw setInterval / NO MutationObserver
 * (DOMBus.register + HMS.every + bounded setTimeout only); no schema/contract/
 * worker/merge edits; no feature-pack reorder.
 * ==========================================================================*/
(function () {
  'use strict';
  if (window.__twhV282) return;
  window.__twhV282 = true;

  var TAG = '[v282]';

  function ensure() {
    try { if (typeof window.__twhEnsureCollections === 'function') window.__twhEnsureCollections(); } catch (_e) {}
  }

  /* ── A) LIVE REPORT KPIs ────────────────────────────────────────────────
     Patch the static "15+" / "infinity" KPI values on the Reports screen with
     live counts. Idempotent + diff-guarded: only writes when the value changed. */
  function onReportsScreen() {
    // The reports screen renders a #reportContent with report cards + tab row.
    return !!document.getElementById('reportContent') &&
           !!document.getElementById('reportTabs');
  }

  function liveStandardCount() {
    // Count the standard report cards currently on screen (data-driven, exact).
    try {
      var host = document.getElementById('reportContent');
      if (host) {
        var cards = host.querySelectorAll('[onclick^="gen"]');
        if (cards && cards.length) return cards.length;
      }
    } catch (_e) {}
    return null;
  }

  function liveCustomCount() {
    try {
      var d = window.D || {};
      var arr = d.customReports || d.savedReports || d.reportTemplates;
      if (Array.isArray(arr)) return arr.length;
    } catch (_e) {}
    return null;
  }

  function patchReportKPIs() {
    if (!onReportsScreen()) return;
    try {
      var vals = document.querySelectorAll('.kpi-grid .kpi .kpi-val');
      if (!vals || !vals.length) return;
      // Card order in renderReports(): [0]=Standard Reports, [1]=Export Formats,
      // [2]=Custom Reports, [3]=Reorder Alerts. Patch [0] and [2] only.
      var std = liveStandardCount();
      if (std != null && vals[0] && vals[0].textContent !== String(std)) {
        vals[0].textContent = String(std);
      }
      var cus = liveCustomCount();
      if (vals[2]) {
        var want = (cus != null && cus > 0) ? String(cus) : 'Unlimited';
        if (vals[2].textContent !== want) {
          vals[2].textContent = want;
          if (want === 'Unlimited') vals[2].style.fontSize = '18px';
        }
      }
    } catch (_e) {}
  }

  /* ── B) gen* EMPTY-STATE HARDENING ──────────────────────────────────────
     Wrap printContent so any top-level table with an empty <tbody> gets a
     friendly "No records for this period" row, for the duration of a gen* call. */
  var GEN_FNS = [
    'genPatientReport', 'genRevenueReport', 'genBedReport', 'genLabReport',
    'genPharmReport', 'genClaimReport', 'genHRReport', 'genERReport',
    'genCompReport', 'genAppointmentReport', 'genRadiologyReport',
    'genInventoryReport', 'genBloodBankReport', 'genPayrollReport',
    'genAuditReport', 'genORReport', 'genStaffClaimReport'
  ];

  function emptyStateHTML(title) {
    return '<div style="padding:28px;text-align:center;color:#64748b;border:1.5px dashed #cbd5e1;' +
           'border-radius:10px;margin:12px 0;background:#f8fafc">' +
           '<i class="fa-solid fa-inbox" style="font-size:26px;color:#94a3b8;display:block;margin-bottom:8px"></i>' +
           '<b style="color:#475569">No records for this report / period.</b>' +
           '<div style="font-size:12px;margin-top:4px">Once matching data exists it will appear here automatically.</div>' +
           '</div>';
  }

  // Inject an empty-state row into any top-level table whose tbody is empty.
  function injectEmptyStates(container) {
    try {
      var tables = container.querySelectorAll('table');
      Array.prototype.forEach.call(tables, function (tbl) {
        // Skip nested tables.
        var anc = tbl.parentElement, nested = false;
        while (anc) { if (anc.tagName === 'TABLE') { nested = true; break; } anc = anc.parentElement; }
        if (nested) return;
        var tbody = tbl.tBodies && tbl.tBodies[0];
        if (!tbody || tbody.rows.length > 0) return;
        var cols = 1;
        try { if (tbl.tHead && tbl.tHead.rows[0]) cols = Math.max(1, tbl.tHead.rows[0].cells.length); } catch (_e) {}
        var tr = document.createElement('tr');
        var td = document.createElement('td');
        td.colSpan = cols;
        td.style.cssText = 'padding:22px;text-align:center;color:#94a3b8;font-style:italic';
        td.textContent = 'No records for this report / period.';
        tr.appendChild(td);
        tbody.appendChild(tr);
      });
    } catch (_e) {}
  }

  function wrapGenFns() {
    GEN_FNS.forEach(function (name) {
      var fn = window[name];
      if (typeof fn !== 'function' || fn.__twhV282) return;
      var wrapped = function () {
        ensure(); // guarantee arrays before the raw filter/map/reduce reads
        var origPC = window.printContent;
        var patched = false;
        if (typeof origPC === 'function' && !origPC.__twhV282pc) {
          patched = true;
          var pcWrap = function (title, html) {
            // If the html has no <tr> rows in a tbody, hint an empty-state block.
            var out = html;
            try {
              if (typeof html === 'string' && /<tbody>\s*<\/tbody>/i.test(html)) {
                out = html.replace(/<tbody>\s*<\/tbody>/i, '<tbody></tbody>') + emptyStateHTML(title);
              }
            } catch (_e) {}
            var r = origPC.call(this, title, out);
            // Post-DOM pass: fill any empty top-level tables in the print area.
            try {
              var area = document.getElementById('printArea');
              if (area) injectEmptyStates(area);
            } catch (_e2) {}
            return r;
          };
          pcWrap.__twhV282pc = true;
          window.printContent = pcWrap;
        }
        try {
          return fn.apply(this, arguments);
        } finally {
          if (patched) window.printContent = origPC; // restore immediately after
        }
      };
      wrapped.__twhV282 = true;
      try { for (var k in fn) { if (Object.prototype.hasOwnProperty.call(fn, k)) wrapped[k] = fn[k]; } } catch (_e) {}
      window[name] = wrapped;
    });
  }

  /* ── Boot / re-arm ──────────────────────────────────────────────────────── */
  function tick() {
    ensure();
    wrapGenFns();
    patchReportKPIs();
  }

  tick();
  [150, 500, 1200, 2500].forEach(function (ms) { setTimeout(tick, ms); });
  try { window.addEventListener('load', tick); } catch (_e) {}
  try { if (window.DOMBus && typeof window.DOMBus.register === 'function') window.DOMBus.register(tick); } catch (_e) {}
  try { if (window.HMS && typeof window.HMS.every === 'function') window.HMS.every(15000, tick); } catch (_e) {}

  /* ── Diagnostics ───────────────────────────────────────────────────────── */
  window.__twhV282Diag = function () {
    var wrapped = 0;
    GEN_FNS.forEach(function (n) { if (window[n] && window[n].__twhV282) wrapped++; });
    return {
      version: 'v282',
      genFnsTotal: GEN_FNS.length,
      genFnsWrapped: wrapped,
      onReportsScreen: onReportsScreen(),
      liveStandardCount: liveStandardCount(),
      liveCustomCount: liveCustomCount()
    };
  };

  try {
    console.log('\u2705 v282 reports live hardening',
      'background:#5b21b6;color:#fff;padding:4px 10px;border-radius:6px;font-weight:bold');
  } catch (_e) {}
})();

;

/* ==== /js/229-twh-offline-write-queue-v283.js ==== */
/* ============================================================================
 * 229 — TWH OFFLINE WRITE QUEUE (v283)  ·  P3
 * ----------------------------------------------------------------------------
 * PROBLEM (from the v281 audit, "transaction pull-in / pull-out" + "sync"):
 *   doWrite() (PUSH) already delta-batches to D1 and keeps a localStorage cache
 *   (MCP_HMS_DATA_v17). But there is NO DURABLE OFFLINE WRITE-INTENT:
 *     • When navigator.onLine === false, a save just fails and relies purely on
 *       the debounced backoff retry; nothing marks "these edits are not yet in
 *       the cloud", and a reload while offline can silently drop them.
 *     • On reconnect there is no explicit flush — the user must wait for the
 *       next 10s poll/backoff tick.
 *   The v279 status pill can SHOW "Offline" but there is no persisted intent.
 *
 * SOLUTION (append-only, constraint-safe):
 *   1) OFFLINE SNAPSHOT: while offline (or when a push fails), persist the local
 *      D snapshot to localStorage under a dedicated key and raise a durable
 *      "pending sync" flag (twhPendingSync_v283). This survives reloads, so no
 *      offline edit is ever lost.
 *   2) RECONNECT FLUSH: on the window 'online' event (and when the sync state
 *      returns to a healthy/idle state), if the pending flag is set, call
 *      window._hmsSave() to push, then clear the flag on success.
 *   3) PENDING BADGE: a tiny, unobtrusive dot on the v279 status pill (if
 *      present) indicating unpushed offline changes; cleared once flushed.
 *   NOTE: This module NEVER re-implements merge/dedupe/tombstone logic (that
 *   stays in functions/_lib/merge.js and 113) — it only guarantees durability
 *   and a timely flush of the EXISTING push path.
 *
 * CONSTRAINTS HONORED: appended at END; NO raw setInterval / NO MutationObserver
 * (window online/offline events + HMS_DB.onState + DOMBus.register + HMS.every +
 * bounded setTimeout only); no schema/contract/worker/merge edits; no reorder.
 * ==========================================================================*/
(function () {
  'use strict';
  if (window.__twhV283) return;
  window.__twhV283 = true;

  var TAG = '[v283]';
  var SNAP_KEY = 'twhOfflineSnap_v283';
  var FLAG_KEY = 'twhPendingSync_v283';
  var DOT_ID = 'twhV283PendingDot';

  function isOnline() {
    try { return navigator.onLine !== false; } catch (_e) { return true; }
  }

  function syncState() {
    try { return (window.HMS_DB && window.HMS_DB.syncState) || 'idle'; } catch (_e) { return 'idle'; }
  }

  /* ── Durable pending flag ───────────────────────────────────────────────── */
  function setPending(on) {
    try {
      if (on) localStorage.setItem(FLAG_KEY, String(Date.now()));
      else localStorage.removeItem(FLAG_KEY);
    } catch (_e) {}
    paintDot();
  }
  function isPending() {
    try { return !!localStorage.getItem(FLAG_KEY); } catch (_e) { return false; }
  }

  /* ── Offline snapshot (durability so a reload can't drop offline edits) ─── */
  function saveOfflineSnapshot() {
    try {
      var d = window.D;
      if (!d || typeof d !== 'object') return false;
      // Best-effort serialize; strip nothing here — this is a LOCAL safety copy.
      var json = JSON.stringify(d);
      if (json && json.length) {
        localStorage.setItem(SNAP_KEY, json);
        return true;
      }
    } catch (_e) { /* quota / circular — ignore, the main cache still exists */ }
    return false;
  }

  function clearOfflineSnapshot() {
    try { localStorage.removeItem(SNAP_KEY); } catch (_e) {}
  }

  /* ── Pending dot on the v279 status pill ────────────────────────────────── */
  function paintDot() {
    try {
      var pill = document.getElementById('twhV279Pill');
      var existing = document.getElementById(DOT_ID);
      if (!isPending()) {
        if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
        return;
      }
      if (!pill) return; // pill not on screen; flag still persisted
      if (!existing) {
        existing = document.createElement('span');
        existing.id = DOT_ID;
        existing.title = 'Unpushed offline changes — will sync when back online';
        existing.style.cssText =
          'display:inline-block;width:8px;height:8px;border-radius:50%;' +
          'background:#f59e0b;margin-left:6px;vertical-align:middle;' +
          'box-shadow:0 0 0 2px rgba(245,158,11,.25)';
        pill.appendChild(existing);
      }
    } catch (_e) {}
  }

  /* ── Push (uses the EXISTING save path only) ────────────────────────────── */
  function flush() {
    if (!isPending()) return;
    if (!isOnline()) return;                 // still offline — wait
    if (typeof window._hmsSave !== 'function') return;
    // Do not fight an open modal-driven save; _hmsSave itself is safe to call.
    try {
      var p = window._hmsSave();
      // _hmsSave returns a promise; on resolution, verify the sync state is
      // healthy before clearing the durable flag.
      if (p && typeof p.then === 'function') {
        p.then(function () {
          setTimeout(function () {
            var s = syncState();
            if (s !== 'error') { setPending(false); clearOfflineSnapshot(); }
          }, 200);
        }, function () { /* keep pending; a later tick retries */ });
      } else {
        setTimeout(function () {
          if (syncState() !== 'error') { setPending(false); clearOfflineSnapshot(); }
        }, 400);
      }
    } catch (_e) { /* keep pending */ }
  }

  /* ── Mark pending when appropriate ──────────────────────────────────────── */
  function markIfNeeded() {
    // Offline OR the sync is in an error state ⇒ there may be unpushed changes.
    var s = syncState();
    if (!isOnline() || s === 'error') {
      if (!isPending()) setPending(true);
      saveOfflineSnapshot();
    } else if (s === 'idle' && isPending()) {
      // Back online and healthy — attempt to flush.
      flush();
    }
  }

  /* ── Event wiring ───────────────────────────────────────────────────────── */
  function onOnline() {
    try { console.log(TAG, 'online — attempting flush of pending offline changes'); } catch (_e) {}
    // Small delay lets the network settle before the PUT.
    setTimeout(flush, 300);
    setTimeout(flush, 1500);
  }
  function onOffline() {
    try { console.log(TAG, 'offline — persisting local snapshot + raising pending flag'); } catch (_e) {}
    setPending(true);
    saveOfflineSnapshot();
  }

  function wireOnce() {
    if (wireOnce._done) return;
    try { window.addEventListener('online', onOnline); } catch (_e) {}
    try { window.addEventListener('offline', onOffline); } catch (_e) {}
    try {
      if (window.HMS_DB && typeof window.HMS_DB.onState === 'function') {
        window.HMS_DB.onState(function () { markIfNeeded(); paintDot(); });
      }
    } catch (_e) {}
    wireOnce._done = true;
  }

  /* ── Boot / re-arm (bounded setTimeout + DOMBus + HMS.every) ─────────────── */
  function tick() {
    wireOnce();
    markIfNeeded();
    paintDot();
  }

  tick();
  [200, 600, 1500, 3000].forEach(function (ms) { setTimeout(tick, ms); });
  try { window.addEventListener('load', tick); } catch (_e) {}
  try { if (window.DOMBus && typeof window.DOMBus.register === 'function') window.DOMBus.register(paintDot); } catch (_e) {}
  // Low-frequency reconciler: if pending + online, keep trying to flush.
  try { if (window.HMS && typeof window.HMS.every === 'function') window.HMS.every(15000, function () { if (isPending() && isOnline()) flush(); }); } catch (_e) {}

  /* ── Public helpers + diagnostics ───────────────────────────────────────── */
  window.twhFlushOfflineQueue = flush;
  window.__twhV283Diag = function () {
    return {
      version: 'v283',
      online: isOnline(),
      pending: isPending(),
      hasSnapshot: (function () { try { return !!localStorage.getItem(SNAP_KEY); } catch (_e) { return false; } })(),
      syncState: syncState(),
      wired: !!wireOnce._done,
      dotShown: !!document.getElementById(DOT_ID)
    };
  };

  try {
    console.log('v283 offline write queue active');
  } catch (_e) {}
})();

;

/* ==== /js/230-twh-db-first-crud-live-kpi-v284.js ==== */
/* ============================================================================
 * 230 — TWH DB-FIRST CRUD + LIVE KPI (v284)
 * ----------------------------------------------------------------------------
 * REQUEST: "Make the database related to transactions, updates and deletions
 *   perfect and fast. Move all localStorage data to the database. Live update
 *   for all KPI. Fix all pending implementations."
 *
 * AUDIT FINDINGS this module addresses:
 *   1) DELETIONS ARE SLOW / LOSSABLE. deleteRecord() filters D locally and calls
 *      _hmsTombstone(), but NEITHER triggers a save — the delete only reaches D1
 *      on the next debounced/poll cycle, so a tab-close can lose it and other
 *      users see it late. Same for some in-place updates.
 *   2) localStorage holds resilience MIRRORS of data (twhLocalMirror_*,
 *      twhChunkedQueue_*) that should be reconciled into D1 and PURGED once the
 *      server confirms — "move all localStorage data to the database".
 *   3) KPIs recompute only inside render()/renderModule(), so an in-place CRUD
 *      does not refresh them until a full repaint/navigation.
 *
 * SOLUTION (append-only, constraint-safe):
 *   A) FAST DURABLE CRUD: wrap deleteRecord + _hmsTombstone so every delete
 *      commits to D1 IMMEDIATELY (window._hmsSave), repaints, and refreshes KPIs.
 *      Also expose window.twhCommitNow() for any handler to force an instant,
 *      verified commit.
 *   B) LS → DB FLUSH & PURGE: window.twhFlushLocalToDB() runs the existing
 *      migrate/restore (v248), commits (v247 saveAndCommit or _hmsSave), and once
 *      D1 confirms, PURGES the data mirrors from localStorage (keeps UI-pref keys
 *      untouched). Runs once at boot after login and on demand.
 *   C) LIVE KPIs: window.twhRefreshKPIs() recomputes + repaints the content-only
 *      target after any save; hooked into _hmsSave success + DOMBus so ALL KPI
 *      cards update live without navigation.
 *
 * CONSTRAINTS HONORED: appended at END; NO raw setInterval / NO MutationObserver
 * (DOMBus.register + HMS.every + bounded setTimeout + existing save promises);
 * no D1 schema / /api/state contract / _redirects / worker/index.js /
 * functions/_lib/merge.js edits; never reorders feature packs. Uses the existing
 * tombstone/merge machinery — never re-implements dedupe/tombstone-union.
 * ==========================================================================*/
(function () {
  'use strict';
  if (window.__twhV284) return;
  window.__twhV284 = true;

  var TAG = '[v284]';
  function isFn(f) { return typeof f === 'function'; }
  function log() { try { console.log.apply(console, [TAG].concat([].slice.call(arguments))); } catch (_e) {} }

  /* ── Force an immediate, verified commit to D1 using the strongest path
        available (v247 saveAndCommit → _hmsSave → _hmsSaveSoon). Returns a
        Promise that resolves after the write settles. ─────────────────────── */
  function commitNow(opts) {
    opts = opts || {};
    try {
      if (isFn(window.saveAndCommit)) {
        return Promise.resolve(window.saveAndCommit({ quiet: opts.quiet !== false }));
      }
    } catch (_e) {}
    try {
      if (isFn(window._hmsSave)) return Promise.resolve(window._hmsSave());
    } catch (_e) {}
    try {
      if (isFn(window._hmsSaveSoon)) { window._hmsSaveSoon(); return Promise.resolve({ ok: true }); }
    } catch (_e) {}
    return Promise.resolve({ ok: false });
  }
  window.twhCommitNow = commitNow;

  /* ══════════════════════════════════════════════════════════════════════
     A) FAST DURABLE CRUD — deletions/updates commit to D1 immediately
     ══════════════════════════════════════════════════════════════════════ */
  function wrapTombstone() {
    var t = window._hmsTombstone;
    if (!isFn(t) || t.__twhV284) return;
    var wrapped = function (table, id) {
      var r = t.apply(this, arguments);
      // A tombstone is a mutation that MUST reach D1 promptly so the deletion
      // propagates to every user and survives a tab-close.
      try { commitNow({ quiet: true }); } catch (_e) {}
      return r;
    };
    wrapped.__twhV284 = true;
    try { for (var k in t) { if (Object.prototype.hasOwnProperty.call(t, k)) wrapped[k] = t[k]; } } catch (_e) {}
    window._hmsTombstone = wrapped;
  }

  function wrapDeleteRecord() {
    var d = window.deleteRecord;
    if (!isFn(d) || d.__twhV284) return;
    var wrapped = function (dataKey, id) {
      var r = d.apply(this, arguments);
      // deleteRecord() already tombstones (now auto-committing via the wrap
      // above) and repaints. Ensure the commit + KPI refresh even if the delete
      // path changes in future.
      try { commitNow({ quiet: true }); } catch (_e) {}
      try { refreshKPIs(); } catch (_e) {}
      return r;
    };
    wrapped.__twhV284 = true;
    try { for (var k in d) { if (Object.prototype.hasOwnProperty.call(d, k)) wrapped[k] = d[k]; } } catch (_e) {}
    window.deleteRecord = wrapped;
  }

  /* ══════════════════════════════════════════════════════════════════════
     B) LS → DB FLUSH & PURGE  ("move all localStorage data to the database")
     Data mirrors are reconciled into D1, then purged. UI-pref keys are kept.
     ══════════════════════════════════════════════════════════════════════ */
  var SK = (window._HMS_STORAGE_KEY || 'MCP_HMS_DATA_v17');
  // Keys that hold DATA MIRRORS (safe to purge once D1 confirms).
  var DATA_MIRROR_KEYS = [
    'twhLocalMirror_' + SK,
    'twhLocalMirrorMeta_' + SK,
    'twhChunkedQueue_' + SK,
    'twhChunkedResume_' + SK,
    SK                                  // MCP_HMS_DATA_v17 legacy full-doc cache
  ];
  // Keys that are UI PREFERENCES — never purge (not "data").
  // (hms_dark, v185-density, twhPanelCollapse_v239, twhSidebarMini_v280,
  //  v33_navCollapsed_v1, twhGithubAutoSync, twhOfflineSnap_v283/pending)

  function purgeDataMirrors() {
    var purged = [];
    DATA_MIRROR_KEYS.forEach(function (k) {
      try {
        if (localStorage.getItem(k) != null) { localStorage.removeItem(k); purged.push(k); }
      } catch (_e) {}
    });
    return purged;
  }

  var _flushing = false;
  function flushLocalToDB(opts) {
    opts = opts || {};
    if (_flushing) return Promise.resolve({ ran: false, reason: 'in-progress' });
    if (!window.isLoggedIn) return Promise.resolve({ ran: false, reason: 'not-authenticated' });
    _flushing = true;

    // 1) Fold any records that only exist in localStorage back into D + D1.
    var migrate = isFn(window.twhMigrateRestore)
      ? Promise.resolve(window.twhMigrateRestore())
      : Promise.resolve({ ran: true, added: 0 });

    return migrate.then(function (m) {
      // 2) Force a verified commit so D1 definitely has everything.
      return commitNow({ quiet: true }).then(function (r) {
        var ok = !r || r.ok !== false;              // saveAndCommit → {ok}; _hmsSave → undefined = assume ok
        var purged = [];
        if (ok) {
          // 3) Only purge once the server is confirmed to hold the data. The
          //    v224/v283 offline safety net will re-create a fresh mirror on the
          //    next save if the tab goes offline again — so this is safe.
          purged = purgeDataMirrors();
          if (purged.length) log('flushed local data → D1 and purged', purged.length, 'mirror key(s)');
          else log('local data already in D1 — nothing to purge');
        } else {
          log('commit not confirmed — keeping local mirrors as safety net');
        }
        _flushing = false;
        try { refreshKPIs(); } catch (_e) {}
        if (!opts.quiet && isFn(window.toast)) {
          window.toast(ok ? ('All local data saved to the database' + (purged.length ? ' (' + purged.length + ' cache key(s) cleared)' : '')) : 'Could not confirm DB save — will retry', ok ? '' : 'err');
        }
        return { ran: true, committed: ok, purged: purged, migrated: (m && m.added) || 0 };
      }, function (e) {
        _flushing = false;
        log('flush commit failed — mirrors kept', e && e.message || e);
        return { ran: true, committed: false, error: String(e && e.message || e) };
      });
    }, function (e) {
      _flushing = false;
      return { ran: false, error: String(e && e.message || e) };
    });
  }
  window.twhFlushLocalToDB = flushLocalToDB;

  /* ══════════════════════════════════════════════════════════════════════
     C) LIVE KPIs — recompute + repaint after any CRUD, no navigation needed
     ══════════════════════════════════════════════════════════════════════ */
  var _kpiScheduled = false;
  function refreshKPIs() {
    if (_kpiScheduled) return;
    _kpiScheduled = true;
    // Coalesce bursts into one repaint on the next tick.
    setTimeout(function () {
      _kpiScheduled = false;
      try { if (isFn(window.__twhEnsureCollections)) window.__twhEnsureCollections(); } catch (_e) {}
      try {
        // Prefer a content-only repaint (diff-guarded by v268) so KPI cards
        // update live without a full #app rebuild or scroll jump.
        var mc = document.getElementById('moduleContent');
        if (mc && isFn(window.renderModule)) {
          var html = window.renderModule();
          if (typeof html === 'string' && html.length && html !== mc.innerHTML) {
            mc.innerHTML = html;
          }
        } else if (isFn(window.render)) {
          window.render();
        }
      } catch (_e) {}
    }, 30);
  }
  window.twhRefreshKPIs = refreshKPIs;

  // Hook the save chokepoint so a successful save always refreshes KPIs live.
  function wrapSaveForKPIs() {
    var s = window._hmsSave;
    if (!isFn(s) || s.__twhV284kpi) return;
    var wrapped = function () {
      var p = s.apply(this, arguments);
      try {
        if (p && isFn(p.then)) p.then(function () { refreshKPIs(); }, function () {});
        else refreshKPIs();
      } catch (_e) {}
      return p;
    };
    wrapped.__twhV284kpi = true;
    try { for (var k in s) { if (Object.prototype.hasOwnProperty.call(s, k)) wrapped[k] = s[k]; } } catch (_e) {}
    window._hmsSave = wrapped;
  }

  /* ── Boot / re-arm (bounded setTimeout + DOMBus + HMS.every) ─────────────── */
  var _flushedOnce = false;
  function tick() {
    wrapTombstone();
    wrapDeleteRecord();
    wrapSaveForKPIs();
    // One verified LS→DB flush shortly after login (moves stranded data to D1).
    if (!_flushedOnce && window.isLoggedIn) {
      _flushedOnce = true;
      setTimeout(function () { flushLocalToDB({ quiet: true }); }, 1200);
    }
  }

  tick();
  [200, 600, 1500, 3000].forEach(function (ms) { setTimeout(tick, ms); });
  try { window.addEventListener('load', tick); } catch (_e) {}
  try { if (window.DOMBus && isFn(window.DOMBus.register)) window.DOMBus.register(tick); } catch (_e) {}
  // Low-frequency safety: keep the wraps armed even if later modules redefine.
  try { if (window.HMS && isFn(window.HMS.every)) window.HMS.every(15000, tick); } catch (_e) {}

  /* ── Diagnostics ───────────────────────────────────────────────────────── */
  window.__twhV284Diag = function () {
    var mirrors = {};
    DATA_MIRROR_KEYS.forEach(function (k) {
      try { mirrors[k] = localStorage.getItem(k) != null; } catch (_e) { mirrors[k] = 'n/a'; }
    });
    return {
      version: 'v284',
      deleteRecordWrapped: !!(window.deleteRecord && window.deleteRecord.__twhV284),
      tombstoneWrapped: !!(window._hmsTombstone && window._hmsTombstone.__twhV284),
      saveKpiWrapped: !!(window._hmsSave && window._hmsSave.__twhV284kpi),
      commitNowExposed: isFn(window.twhCommitNow),
      flushExposed: isFn(window.twhFlushLocalToDB),
      refreshKpisExposed: isFn(window.twhRefreshKPIs),
      flushedOnce: _flushedOnce,
      dataMirrorsPresent: mirrors
    };
  };

  try {
    console.log('\u2705 v284 DB-first CRUD + live KPI');
  } catch (_e) {}
})();

;

/* ==== /js/231-twh-sync-to-db-button-v285.js ==== */
/* ============================================================================
 * 231 — TWH "SYNC ALL TO DATABASE" BUTTON (v285)
 * ----------------------------------------------------------------------------
 * REQUEST: "Add a visible 'Sync all to database' button (wired to
 *   twhFlushLocalToDB()) in the Settings/sidebar so staff can trigger the flush
 *   manually."
 *
 * WHAT IT DOES (append-only, constraint-safe):
 *   1) SIDEBAR: injects a "Sync to Database" button into the sidebar nav,
 *      directly under the existing v274 "Save & Commit" button (or under
 *      Dashboard if that's absent). Respects the v280 collapsed icon-rail
 *      (label hidden, icon centred).
 *   2) SETTINGS: injects a matching "Sync all to Database" button into the
 *      Settings screen action-button row (after the existing "Save Now").
 *   3) Both call window.twhFlushLocalToDB({quiet:false}) (from v284) — migrate
 *      stranded local records → D1, verified commit, purge data mirrors — with
 *      idle/syncing/done/error visual feedback.
 *
 * CONSTRAINTS HONORED: appended at END; NO raw setInterval / NO MutationObserver
 * (DOMBus.register + HMS.every + bounded setTimeout); no D1 schema / /api/state
 * contract / _redirects / worker/index.js / functions/_lib/merge.js edits; does
 * not reorder feature packs; does not edit the read-only core.
 * ==========================================================================*/
(function () {
  'use strict';
  if (window.__twhV285) return;
  window.__twhV285 = true;

  var TAG = '[v285]';
  var SB_BTN_ID = 'twhV285SidebarSync';
  var SET_BTN_ID = 'twhV285SettingsSync';
  var STYLE_ID = 'twhV285Style';
  function isFn(f) { return typeof f === 'function'; }

  /* ── Styles (shared by both buttons; icon-rail aware) ───────────────────── */
  function installStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var css = [
      '#' + SB_BTN_ID + '{display:flex;align-items:center;gap:8px;width:calc(100% - 16px);',
      '  margin:4px 8px;padding:9px 12px;border:none;border-radius:10px;cursor:pointer;',
      '  color:#fff;font-family:inherit;font-size:13px;font-weight:700;background:#0369a1;',
      '  transition:filter .15s ease,background .2s ease}',
      '#' + SB_BTN_ID + ' .v285-ic{width:18px;text-align:center;flex:0 0 auto}',
      '#' + SB_BTN_ID + ' .v285-lbl{flex:1 1 auto;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
      '#' + SB_BTN_ID + ':hover{filter:brightness(1.08)}',
      '#' + SB_BTN_ID + '.is-syncing{background:#d97706}',
      '#' + SB_BTN_ID + '.is-done{background:#059669}',
      '#' + SB_BTN_ID + '.is-error{background:#dc2626}',
      // Collapsed icon-rail (v280): hide label, centre icon.
      'body.twh-sb-mini #' + SB_BTN_ID + '{width:44px;margin-left:auto;margin-right:auto;justify-content:center;padding:9px 0}',
      'body.twh-sb-mini #' + SB_BTN_ID + ' .v285-lbl{display:none}',
      // Settings button feedback
      '#' + SET_BTN_ID + '.is-syncing{background:#d97706 !important;color:#fff !important}',
      '#' + SET_BTN_ID + '.is-done{background:#059669 !important;color:#fff !important}',
      '#' + SET_BTN_ID + '.is-error{background:#dc2626 !important;color:#fff !important}'
    ].join('');
    var s = document.createElement('style');
    s.id = STYLE_ID; s.textContent = css;
    (document.head || document.documentElement).appendChild(s);
  }

  /* ── The shared flush action with visual feedback ───────────────────────── */
  function runFlush(btn, labelSel) {
    if (!isFn(window.twhFlushLocalToDB)) {
      // Fallback: at least force a commit if v284 isn't present yet.
      if (isFn(window._hmsSave)) { try { window._hmsSave(); } catch (_e) {} }
      if (isFn(window.toast)) window.toast('Sync requested');
      return;
    }
    var lbl = labelSel ? btn.querySelector(labelSel) : null;
    var origLabel = lbl ? lbl.textContent : null;
    setState(btn, 'is-syncing', lbl, 'Syncing…');
    Promise.resolve(window.twhFlushLocalToDB({ quiet: true })).then(function (res) {
      var ok = res && (res.committed || res.ran) && res.committed !== false;
      if (ok) {
        var msg = 'Synced to database' + (res && res.purged && res.purged.length ? ' · ' + res.purged.length + ' cache key(s) cleared' : '');
        setState(btn, 'is-done', lbl, 'Synced ✓');
        if (isFn(window.toast)) window.toast(msg);
      } else {
        setState(btn, 'is-error', lbl, 'Retry sync');
        if (isFn(window.toast)) window.toast('Could not confirm DB save — will retry', 'err');
      }
      setTimeout(function () { resetState(btn, lbl, origLabel); }, 2200);
    }, function (e) {
      setState(btn, 'is-error', lbl, 'Retry sync');
      if (isFn(window.toast)) window.toast('Sync failed: ' + (e && e.message || e), 'err');
      setTimeout(function () { resetState(btn, lbl, origLabel); }, 2200);
    });
  }

  function setState(btn, cls, lbl, text) {
    if (!btn) return;
    btn.classList.remove('is-syncing', 'is-done', 'is-error');
    if (cls) btn.classList.add(cls);
    if (lbl && text != null) lbl.textContent = text;
  }
  function resetState(btn, lbl, origLabel) {
    if (!btn) return;
    btn.classList.remove('is-syncing', 'is-done', 'is-error');
    if (lbl && origLabel != null) lbl.textContent = origLabel;
  }

  /* ══════════════════════════════════════════════════════════════════════
     1) SIDEBAR BUTTON
     ══════════════════════════════════════════════════════════════════════ */
  function sidebarNav() {
    var sb = document.getElementById('sidebar') || document.querySelector('aside.sb') || document.querySelector('.sidebar');
    if (!sb) return null;
    return sb.querySelector('nav') || sb;
  }
  function anchorItem(nav) {
    if (!nav) return null;
    // Prefer placing under the v274 "Save & Commit" button so the two sync
    // controls sit together.
    var sc = document.getElementById('twhSidebarSaveCommit');
    if (sc && sc.parentNode === nav) return sc;
    // Fallback: under the Dashboard nav item.
    var dash = nav.querySelector('[data-mod="dashboard"]');
    if (dash) return dash;
    var cands = nav.querySelectorAll('button,a');
    for (var i = 0; i < cands.length; i++) {
      if (/dashboard/i.test(cands[i].textContent || '')) return cands[i];
    }
    return null;
  }
  function placeSidebarButton() {
    installStyle();
    var nav = sidebarNav(); if (!nav) return false;
    var anchor = anchorItem(nav);
    var btn = document.getElementById(SB_BTN_ID);
    if (!btn) {
      btn = document.createElement('button');
      btn.id = SB_BTN_ID;
      btn.type = 'button';
      btn.title = 'Sync all local data to the database';
      btn.innerHTML = '<span class="v285-ic"><i class="fa-solid fa-database"></i></span><span class="v285-lbl">Sync to Database</span>';
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        runFlush(btn, '.v285-lbl');
      });
    }
    if (anchor && anchor.parentNode) {
      var wantAfter = anchor.nextSibling;
      if (btn.previousElementSibling !== anchor || btn.parentNode !== anchor.parentNode) {
        if (wantAfter) anchor.parentNode.insertBefore(btn, wantAfter);
        else anchor.parentNode.appendChild(btn);
      }
    } else if (btn.parentNode !== nav) {
      if (nav.firstChild) nav.insertBefore(btn, nav.firstChild); else nav.appendChild(btn);
    }
    return true;
  }

  /* ══════════════════════════════════════════════════════════════════════
     2) SETTINGS SCREEN BUTTON
     Injected next to the existing "Save Now" button when the Settings page is
     on screen. Identified by the "Save Now" button's onclick signature.
     ══════════════════════════════════════════════════════════════════════ */
  function findSettingsSaveNow() {
    var btns = document.querySelectorAll('button');
    for (var i = 0; i < btns.length; i++) {
      var oc = btns[i].getAttribute('onclick') || '';
      var txt = (btns[i].textContent || '').trim();
      if (/Data saved to localStorage/.test(oc) || /^\s*(?:.*\s)?Save Now\s*$/i.test(txt)) {
        return btns[i];
      }
    }
    return null;
  }
  function placeSettingsButton() {
    installStyle();
    var saveNow = findSettingsSaveNow();
    if (!saveNow || !saveNow.parentNode) return false;
    var btn = document.getElementById(SET_BTN_ID);
    if (btn && btn.parentNode === saveNow.parentNode) return true; // already placed
    if (!btn) {
      btn = document.createElement('button');
      btn.id = SET_BTN_ID;
      btn.type = 'button';
      btn.className = 'btn btn-sm';
      btn.style.cssText = 'background:#0369a1;color:#fff';
      btn.title = 'Migrate & commit all local data to the database, then clear local caches';
      btn.innerHTML = '<i class="fa-solid fa-database"></i> Sync all to Database';
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        runFlush(btn, null);
      });
    }
    // Insert right after "Save Now".
    var after = saveNow.nextSibling;
    if (after) saveNow.parentNode.insertBefore(btn, after);
    else saveNow.parentNode.appendChild(btn);
    return true;
  }

  /* ── Boot / re-arm ──────────────────────────────────────────────────────── */
  function tick() {
    try { placeSidebarButton(); } catch (_e) {}
    try { placeSettingsButton(); } catch (_e) {}
  }

  tick();
  [200, 600, 1200, 2500].forEach(function (ms) { setTimeout(tick, ms); });
  try { window.addEventListener('load', tick); } catch (_e) {}
  try { if (window.DOMBus && isFn(window.DOMBus.register)) window.DOMBus.register(tick); } catch (_e) {}
  try { if (window.HMS && isFn(window.HMS.every)) window.HMS.every(15000, tick); } catch (_e) {}

  /* ── Public + diagnostics ───────────────────────────────────────────────── */
  window.twhSyncToDatabase = function () { return isFn(window.twhFlushLocalToDB) ? window.twhFlushLocalToDB({ quiet: false }) : Promise.resolve({ ran: false }); };
  window.__twhV285Diag = function () {
    return {
      version: 'v285',
      sidebarButtonPresent: !!document.getElementById(SB_BTN_ID),
      settingsButtonPresent: !!document.getElementById(SET_BTN_ID),
      flushAvailable: isFn(window.twhFlushLocalToDB)
    };
  };

  try {
    console.log('\u2705 v285 sync-to-DB button',
      'background:#0369a1;color:#fff;padding:4px 10px;border-radius:6px;font-weight:bold');
  } catch (_e) {}
})();

;

/* ==== /js/232-twh-clinical-actions-antiblink-v286.js ==== */
/* ============================================================================
 * 232 — TWH CLINICAL ROW-ACTIONS + ANTI-BLINK (v286)
 * ----------------------------------------------------------------------------
 * REQUEST (from screen recording review):
 *   1) Radiology & Laboratory main tables: add EDIT and APPROVE row actions
 *      (currently only View + Print / workflow icons are shown).
 *   2) The "Generate Bill" button (in the v107 Lab/Radiology Orders panel)
 *      BLINKS / re-renders rapidly — stop the flicker.
 *   3) Medical-Record / Appointment tables: make the record EDITABLE via an
 *      action button (guarantee an Edit action in the row).
 *
 * HOW (append-only, constraint-safe):
 *   - Wraps window.renderModule (the core switch router). After it returns the
 *     module HTML *string*, we POST-PROCESS that string for the active module:
 *       • radiology/laboratory : inject Edit + Approve buttons into every
 *         <tr> .act-row in #radTable / #labTable, right after the View button,
 *         wired to the EXISTING v107 handlers window.lroEdit / lroApproveModal.
 *       • appointments/emr     : guarantee an Edit button (window.editRecord)
 *         exists in each row's .act-row (idempotent — never duplicates one).
 *   - ANTI-BLINK: a per-module signature cache. When renderModule is called for
 *     laboratory/radiology and neither the underlying data NOR the login/role
 *     changed AND no modal/user typing is active, we return the *byte-identical
 *     cached string* from the previous paint. Identical string → the v268
 *     scroll-stable diff-guard (and our own guard) drops the DOM rewrite → the
 *     Generate-Bill button and approval badges stop flickering.
 *
 * v287 FLICKER FIX (this file): the earlier build also invalidated the cache on
 *   every 'state:changed' bus event. Because the core runs a continuous
 *   save→pull→save loop (and polls every 10s) that fires 'state:changed'
 *   constantly, the cache was busted every tick and the Edit·Approve·Generate-
 *   Bill panel kept re-rendering (appear / disappear). We removed that
 *   subscription — sig(mod) already detects real order changes, so the panel now
 *   stays still through the save loop while still refreshing on genuine edits.
 *
 * CONSTRAINTS HONORED: appended at END of manifest; NO raw setInterval / NO new
 * MutationObserver (DOMBus.register + HMS.every + bounded setTimeout); no edits
 * to the read-only core, D1 schema, /api/state contract, _redirects,
 * worker/index.js, or functions/_lib/merge.js; does not reorder feature packs.
 * Reuses handlers already defined by v107 (084) and the core.
 * ==========================================================================*/
(function () {
  'use strict';
  if (window.__twhV286) return;
  window.__twhV286 = true;

  var TAG = '[v286]';
  function isFn(f) { return typeof f === 'function'; }
  function D_() { try { if (typeof D !== 'undefined' && D) return D; } catch (e) {} return window.D || {}; }
  function curMod() { try { return window.currentMod || (typeof currentMod !== 'undefined' ? currentMod : ''); } catch (e) { return ''; } }
  function role() { var d = D_(); return (d.currentUser && d.currentUser.role) || ''; }

  /* A user is "active" when a modal is open or an input/textarea/select is
     focused — in those windows we must NOT short-circuit or re-inject. */
  function userActive() {
    try {
      if (document.getElementById('modalBg') || document.getElementById('modalBackdrop')) return true;
      var a = document.activeElement;
      if (a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName)) return true;
    } catch (e) {}
    return false;
  }

  /* ══════════════════════════════════════════════════════════════════════
     1) ROW-ACTION INJECTION (string post-processing)
     We operate on the HTML string returned by renderModule, so we are immune
     to whichever feature-pack wrapper produced the table.
     ══════════════════════════════════════════════════════════════════════ */

  // Split a table body into rows and rewrite the .act-row cell of each.
  // `tableId`   — the <table id> to target (e.g. 'radTable').
  // `rowFn(id)` — returns extra button HTML to splice in, given the row id.
  // `idFrom(rowHtml)` — extracts the record id from a row's existing onclick.
  function injectIntoTable(html, tableId, idFrom, buttonsFn, markerAttr) {
    var tblRe = new RegExp('(<table[^>]*id="' + tableId + '"[\\s\\S]*?<tbody>)([\\s\\S]*?)(</tbody>)', 'i');
    return html.replace(tblRe, function (full, head, body, tail) {
      var newBody = body.replace(/<div class="act-row">([\s\S]*?)<\/div>/gi, function (cell, inner) {
        // Idempotency: if we already stamped this row, leave it.
        if (inner.indexOf(markerAttr) > -1) return cell;
        var id = idFrom(inner);
        if (id == null) return cell;
        var extra = buttonsFn(id, inner);
        if (!extra) return cell;
        // Insert our buttons right after the FIRST button (the View button).
        var firstBtnEnd = inner.indexOf('</button>');
        if (firstBtnEnd > -1) {
          firstBtnEnd += '</button>'.length;
          inner = inner.slice(0, firstBtnEnd) + extra + inner.slice(firstBtnEnd);
        } else {
          inner = extra + inner;
        }
        return '<div class="act-row">' + inner + '</div>';
      });
      return head + newBody + tail;
    });
  }

  // Pull the first integer argument out of an onclick handler in the row.
  function firstIdIn(inner) {
    // Matches viewRecord('labTests',123) / viewRadiologyOrder(123) / editRecord('x',123)
    var m = inner.match(/(?:viewRecord\([^,]+,\s*|viewRadiologyOrder\(\s*|editRecord\([^,]+,\s*|lroEdit\([^,]+,\s*)(\d+)/);
    if (m) return m[1];
    // Fallback: any (…,NUMBER) or (NUMBER) inside an onclick
    var m2 = inner.match(/onclick="[^"]*?\b(\d{3,})\b/);
    return m2 ? m2[1] : null;
  }

  function radLabButtons(kind) {
    return function (id, inner) {
      var out = '';
      var canApprove = true; // approval permission is enforced inside lroApproveModal
      // EDIT — only add if the row doesn't already have an edit affordance.
      if (inner.indexOf('lroEdit(') === -1 && inner.indexOf('editRecord(') === -1) {
        out += '<button class="act-btn edit v286-inj" title="Edit order" data-v286="1" onclick="(window.lroEdit||window.editRecord)(\'' + kind + '\',' + id + ')"><i class="fa-solid fa-edit"></i></button>';
      } else {
        out += '<span class="v286-inj" data-v286="1" style="display:none"></span>';
      }
      // APPROVE — reuse v107 approver workflow (permission checked in handler).
      if (inner.indexOf('lroApproveModal(') === -1) {
        out += '<button class="act-btn v286-approve" title="Approve / Reject" data-v286="1" onclick="if(window.lroApproveModal){window.lroApproveModal(\'' + kind + '\',' + id + ')}else{toast&&toast(\'Approval unavailable\')}"><i class="fa-solid fa-stamp" style="color:#16a34a"></i></button>';
      }
      return out;
    };
  }

  function editOnlyButtons(dataKey) {
    return function (id, inner) {
      // Guarantee a generic Edit button; skip if one already exists.
      if (inner.indexOf('editRecord(') > -1 || inner.indexOf('lroEdit(') > -1) {
        return '<span class="v286-inj" data-v286="1" style="display:none"></span>';
      }
      return '<button class="act-btn edit v286-inj" title="Edit record" data-v286="1" onclick="editRecord(\'' + dataKey + '\',' + id + ')"><i class="fa-solid fa-edit"></i></button>';
    };
  }

  // Pull the patientId a medical-record row belongs to (from the row's own
  // showSOAPNote(patientId) / rxmNewRxFor(patientId,...) handlers).
  function patientIdIn(inner) {
    var m = inner.match(/(?:showSOAPNote\(\s*|rxmNewRxFor\(\s*)(\d+)/);
    return m ? m[1] : null;
  }

  // EMR rows: guarantee an Edit button AND (re)add the folder / Full-Chart
  // button that opens the patient's authoritative longitudinal chart.
  function emrRowButtons() {
    return function (id, inner) {
      var out = '';
      if (inner.indexOf('editRecord(') === -1 && inner.indexOf('lroEdit(') === -1) {
        out += '<button class="act-btn edit v286-inj" title="Edit record" data-v286="1" onclick="editRecord(\'medicalRecords\',' + id + ')"><i class="fa-solid fa-edit"></i></button>';
      }
      // Folder / Full Chart — only if not already present in the row.
      if (inner.indexOf('twhOpenChart(') === -1 && inner.indexOf('fa-folder-open') === -1) {
        var pid = patientIdIn(inner);
        if (pid != null) {
          out += '<button class="act-btn v286-inj" title="Full Chart" data-v286="1" style="color:#0d9488" onclick="(window.twhOpenChart||window.viewPatient)(' + pid + ')"><i class="fa-solid fa-folder-open"></i></button>';
        }
      }
      return out || '<span class="v286-inj" data-v286="1" style="display:none"></span>';
    };
  }

  function postProcess(mod, html) {
    if (typeof html !== 'string' || !html) return html;
    try {
      if (mod === 'radiology') {
        html = injectIntoTable(html, 'radTable', firstIdIn, radLabButtons('rad'), 'data-v286');
      } else if (mod === 'laboratory') {
        html = injectIntoTable(html, 'labTable', firstIdIn, radLabButtons('lab'), 'data-v286');
      } else if (mod === 'appointments') {
        html = injectIntoTable(html, 'aptTable', firstIdIn, editOnlyButtons('appointments'), 'data-v286');
      } else if (mod === 'emr') {
        html = injectIntoTable(html, 'emrTable', firstIdIn, emrRowButtons(), 'data-v286');
      }
    } catch (e) { /* never break render */ }
    return html;
  }

  /* ══════════════════════════════════════════════════════════════════════
     2) ANTI-BLINK — per-module signature cache
     ══════════════════════════════════════════════════════════════════════ */
  // Cheap, deterministic signature of the data that drives lab/radiology views
  // plus login/role. If unchanged since last paint, reuse the cached string.
  function sig(mod) {
    var d = D_();
    var parts = [mod, window.isLoggedIn ? 1 : 0, role()];
    function arrSig(arr) {
      if (!Array.isArray(arr)) return '0';
      var s = arr.length + ':';
      for (var i = 0; i < arr.length; i++) {
        var o = arr[i] || {};
        s += (o.id || '') + '|' + (o.status || '') + '|' + (o.approvalStatus || '') + '|' + (o.billCode || '') + '|' + (o.price || '') + '|' + (o.results ? 1 : 0) + '|' + (o.report ? 1 : 0) + '|' + (o.verified ? 1 : 0) + ';';
      }
      return s;
    }
    if (mod === 'laboratory') parts.push(arrSig(d.labTests));
    else if (mod === 'radiology') parts.push(arrSig(d.radiologyOrders));
    // fee schedule affects prices shown in the panel
    parts.push((d.feeSchedule || []).length);
    return parts.join('~');
  }

  var _cache = { mod: null, sig: null, html: null };

  function wrapRenderModule() {
    var rm = window.renderModule;
    if (!isFn(rm) || rm.__v286) return false;
    var wrapped = function () {
      var mod = curMod();
      var stabilizable = (mod === 'laboratory' || mod === 'radiology');

      // ANTI-BLINK: reuse identical cached output for a background repaint when
      // nothing changed. Never short-circuit while the user is interacting.
      if (stabilizable && !userActive() && _cache.mod === mod) {
        try {
          var s = sig(mod);
          if (s === _cache.sig && typeof _cache.html === 'string') {
            return _cache.html; // byte-identical → downstream diff-guard skips
          }
        } catch (e) {}
      }

      var out;
      try { out = rm.apply(this, arguments); }
      catch (e) { return rm.apply(this, arguments); }

      out = postProcess(mod, out);

      if (stabilizable) {
        try { _cache = { mod: mod, sig: sig(mod), html: out }; } catch (e) {}
      } else if (_cache.mod !== mod) {
        _cache = { mod: null, sig: null, html: null };
      }
      return out;
    };
    wrapped.__v286 = true;
    try { for (var k in rm) { if (Object.prototype.hasOwnProperty.call(rm, k)) wrapped[k] = rm[k]; } } catch (e) {}
    window.renderModule = wrapped;
    return true;
  }

  /* Invalidate the cache whenever data really changes so the next paint is
     fresh (create/edit/approve/bill/delete).
     ---------------------------------------------------------------------------
     v287 FLICKER FIX: we deliberately DO NOT subscribe to the 'state:changed'
     bus event here. The core save layer runs a continuous save -> pull -> save
     loop (doWrite sets _pullAfterWrite=true -> refreshFromServer() emits
     'state:changed' after every write, 008:~1161/1187), and the app also polls
     the server every 10s. Busting the cache on every 'state:changed' meant the
     lab/radiology Edit·Approve·Generate-Bill panel was rebuilt on every loop
     tick -> the visible "appearing / disappearing" flicker.
     Our sig(mod) signature already fingerprints the REAL data that drives these
     views (labTests / radiologyOrders record fields + login + role + fee count),
     so any genuine change to an order is detected on the very next renderModule
     call and produces a fresh paint. A pull that returns identical data yields an
     identical signature -> byte-identical cached HTML -> the diff-guard skips the
     DOM rewrite -> the panel stays perfectly still. Real user actions still bust
     the cache immediately via the explicit handler wraps below. */
  function invalidate() { _cache = { mod: null, sig: null, html: null }; }
  function hookInvalidation() {
    // NOTE: intentionally NOT hooking window.HMS.on('state:changed', ...) — see
    // the v287 flicker-fix note above. Cache freshness is driven by sig(mod)
    // plus the genuine-action handler wraps below.
    // Wrap the v107 mutation handlers so a genuine change busts the cache.
    ['lroSaveEdit', 'lroDecide', 'lroApproveAll', 'lroConfirmBill', 'lroBillAll',
     'saveNewRecord', 'editRecord', 'deleteRecord', 'finalizeRecord', 'enterLabResult',
     'saveRadiologyOrder', 'completeRadExam', 'verifyRadReport'].forEach(function (name) {
      try {
        var orig = window[name];
        if (isFn(orig) && !orig.__v286inv) {
          var w = function () { invalidate(); return orig.apply(this, arguments); };
          w.__v286inv = true;
          try { for (var k in orig) { if (Object.prototype.hasOwnProperty.call(orig, k)) w[k] = orig[k]; } } catch (e) {}
          window[name] = w;
        }
      } catch (e) {}
    });
  }

  /* ══════════════════════════════════════════════════════════════════════
     BOOT / RE-ARM
     ══════════════════════════════════════════════════════════════════════ */
  function tick() {
    try { wrapRenderModule(); } catch (e) {}
    try { hookInvalidation(); } catch (e) {}
  }

  tick();
  [200, 600, 1200, 2500, 6000].forEach(function (ms) { setTimeout(tick, ms); });
  try { window.addEventListener('load', tick); } catch (e) {}
  try { if (window.DOMBus && isFn(window.DOMBus.register)) window.DOMBus.register(tick); } catch (e) {}
  try { if (window.HMS && isFn(window.HMS.every)) window.HMS.every(15000, tick); } catch (e) {}

  /* Public + diagnostics */
  window.__twhV286Invalidate = invalidate;
  window.__twhV286Diag = function () {
    return {
      version: 'v286+v287',
      renderModuleWrapped: !!(window.renderModule && window.renderModule.__v286),
      cacheMod: _cache.mod,
      cacheHasHtml: typeof _cache.html === 'string',
      stateChangedHooked: false, // v287: intentionally NOT subscribed (churn fix)
      lroEditAvailable: isFn(window.lroEdit),
      lroApproveAvailable: isFn(window.lroApproveModal),
      editRecordAvailable: isFn(window.editRecord)
    };
  };

  try {
    console.log('\u2705 v286+v287 clinical row-actions');
  } catch (e) {}
})();

;

/* ==== /js/233-twh-session-resume-on-reload-v287.js ==== */
/* ============================================================================
 * 233 — TWH SESSION RESUME ON RELOAD (v287)
 * ----------------------------------------------------------------------------
 * REQUEST (verbatim):
 *   "Reloading, back to main page or refreshing the page shouldn't go login
 *    page it should just refresh the page and stop hanging."
 *
 * PROBLEM:
 *   The core boot ALWAYS calls showLogin() on every page load (008:~10344),
 *   and the app-level login flag lives as a bare `var isLoggedIn` (008:5597)
 *   that is never mirrored onto D. The core's per-tab identity persistence
 *   (_saveIdentityToSession) tries to save D.isLoggedIn / D.currentMod, but the
 *   core never writes those onto D — so nothing actually resumes the session.
 *   Result: every reload / "back to main" / refresh dumps the user back at the
 *   in-app login screen, and the continuous save→pull loop makes it feel hung.
 *
 * FIX (append-only, constraint-safe — no core edits):
 *   1) PERSIST: while the user is logged in, mirror a small per-tab session
 *      marker into sessionStorage: { user, branch, mod, at }. sessionStorage is
 *      per-tab and cleared when the tab closes, so this is a genuine "resume
 *      this tab's session across a reload" and never leaks between users/tabs.
 *   2) RESUME: at boot, if a fresh marker exists (within the 30-min inactivity
 *      window), D.currentUser is present, and the API secure-gate is NOT
 *      demanding re-auth (window.__HMS_GATE_LOGIN falsy), we remove the login
 *      screen, restore currentMod, set window.isLoggedIn = true, and render()
 *      the app directly — no login prompt, no hang.
 *   3) LOGOUT: wrap doLogout so an explicit logout clears the marker (so the
 *      next reload correctly shows login).
 *
 * SAFETY:
 *   - We NEVER auto-resume when the API gate wants credentials
 *     (window.__HMS_GATE_LOGIN) — the server session cookie is the source of
 *     truth there; auto-resuming would just 401 in a loop.
 *   - We respect the same 30-minute inactivity timeout the core enforces
 *     (SESSION.timeout): a stale marker is ignored and the user sees login.
 *   - Resume runs at most once per page load (guarded).
 *
 * CONSTRAINTS HONORED: appended at END of manifest; NO raw setInterval / NO new
 * MutationObserver (uses bounded setTimeout + DOMBus.register + HMS.every); no
 * edits to the read-only core, D1 schema, /api/state, _redirects, worker, or
 * functions/_lib/merge.js; does not reorder feature packs.
 * ==========================================================================*/
(function () {
  'use strict';
  if (window.__twhV287) return;
  window.__twhV287 = true;

  var KEY = '_twhSession_v287';
  var MAX_AGE_MS = 30 * 60 * 1000; // mirror the core's 30-min inactivity window

  function isFn(f) { return typeof f === 'function'; }
  function D_() { try { if (typeof D !== 'undefined' && D) return D; } catch (e) {} return window.D || null; }

  /* ── PERSIST ──────────────────────────────────────────────────────────── */
  function loggedInNow() {
    try { return window.isLoggedIn === true; } catch (e) { return false; }
  }
  function saveMarker() {
    try {
      if (!loggedInNow()) return;
      var d = D_();
      if (!d || !d.currentUser) return;
      var marker = {
        user: d.currentUser,
        branch: d.currentBranch || (d.currentUser && d.currentUser.branch) || null,
        mod: (window.currentMod || 'dashboard'),
        at: Date.now()
      };
      sessionStorage.setItem(KEY, JSON.stringify(marker));
    } catch (e) {}
  }
  function clearMarker() {
    try { sessionStorage.removeItem(KEY); } catch (e) {}
  }
  function readMarker() {
    try {
      var raw = sessionStorage.getItem(KEY);
      if (!raw) return null;
      var m = JSON.parse(raw);
      if (!m || typeof m !== 'object' || !m.user) return null;
      return m;
    } catch (e) { return null; }
  }

  /* ── RESUME ───────────────────────────────────────────────────────────── */
  var _resumed = false;
  function tryResume() {
    if (_resumed) return true;
    // The API secure-gate owns the screen when it wants credentials — never
    // fight it. It will reload us fully authenticated.
    if (window.__HMS_GATE_LOGIN) return false;
    if (loggedInNow()) { _resumed = true; return true; } // already in the app

    var m = readMarker();
    if (!m) return false;
    // Respect the inactivity timeout — a stale session must re-authenticate.
    if (typeof m.at === 'number' && (Date.now() - m.at) > MAX_AGE_MS) {
      clearMarker();
      return false;
    }

    var d = D_();
    if (!d) return false; // core not ready yet — try again on the next tick

    // The core restores D.currentUser from its own sessionStorage identity, but
    // fall back to our marker's copy if it is missing.
    if (!d.currentUser && m.user) d.currentUser = m.user;
    if (!d.currentUser) return false; // nothing to resume with
    if (!d.currentBranch && m.branch) d.currentBranch = m.branch;

    // render() needs these renderers/globals present.
    if (!isFn(window.render)) return false;

    try {
      // Restore the route the user was on (default dashboard).
      var mod = m.mod || 'dashboard';
      try { window.currentMod = mod; } catch (e) {}

      // Flip the app-level login flag (bare `var isLoggedIn` === window.isLoggedIn).
      window.isLoggedIn = true;
      try { if (window.SESSION) window.SESSION.lastActivity = Date.now(); } catch (e) {}

      // Remove the login overlay the core just painted.
      var lg = document.getElementById('loginScreen');
      if (lg && lg.parentNode) lg.parentNode.removeChild(lg);

      // Paint the app.
      window.render();
      _resumed = true;
      // Refresh the marker timestamp so the resumed session stays fresh.
      saveMarker();
      try {
        console.log('v287 session resumed on reload');
      } catch (e) {}
      return true;
    } catch (e) {
      // If resume fails for any reason, leave the login screen in place — the
      // user can always sign in manually. Never leave the page broken.
      try { window.isLoggedIn = false; } catch (e2) {}
      return false;
    }
  }

  /* ── LOGOUT HOOK ──────────────────────────────────────────────────────── */
  function hookLogout() {
    try {
      var orig = window.doLogout;
      if (isFn(orig) && !orig.__v287) {
        var w = function () { clearMarker(); _resumed = false; return orig.apply(this, arguments); };
        w.__v287 = true;
        try { for (var k in orig) { if (Object.prototype.hasOwnProperty.call(orig, k)) w[k] = orig[k]; } } catch (e) {}
        window.doLogout = w;
      }
    } catch (e) {}
  }

  /* ── BOOT / RE-ARM ────────────────────────────────────────────────────── */
  function tick() {
    hookLogout();
    // Keep the marker fresh while the user is active in the app.
    if (loggedInNow()) saveMarker();
    // Attempt resume until it succeeds once.
    if (!_resumed) tryResume();
  }

  // The login screen is painted synchronously at core boot; resume ASAP but be
  // resilient to the staggered availability of render()/D on cold loads.
  tryResume();
  [0, 30, 80, 150, 300, 600, 1200, 2500].forEach(function (ms) { setTimeout(tick, ms); });
  // NOTE: modules are injected with `defer` AFTER DOMContentLoaded has fired, so
  // we do NOT rely on a DOMContentLoaded listener (it would never run). The
  // synchronous tryResume() above + staggered setTimeouts + window 'load' +
  // DOMBus.register cover every boot-timing case.
  try { window.addEventListener('load', tick); } catch (e) {}
  try { if (window.DOMBus && isFn(window.DOMBus.register)) window.DOMBus.register(tick); } catch (e) {}
  try { if (window.HMS && isFn(window.HMS.every)) window.HMS.every(10000, function () { if (loggedInNow()) saveMarker(); }); } catch (e) {}
  // Persist right before the tab is hidden / navigated away so the very next
  // reload has the freshest marker.
  try { window.addEventListener('pagehide', saveMarker); } catch (e) {}
  try { window.addEventListener('beforeunload', saveMarker); } catch (e) {}
  try {
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') saveMarker();
    });
  } catch (e) {}

  /* Public + diagnostics */
  window.__twhV287Diag = function () {
    var m = readMarker();
    return {
      version: 'v287',
      resumed: _resumed,
      loggedIn: loggedInNow(),
      gateLogin: !!window.__HMS_GATE_LOGIN,
      hasMarker: !!m,
      markerMod: m && m.mod,
      markerAgeMs: m && typeof m.at === 'number' ? (Date.now() - m.at) : null,
      logoutHooked: !!(window.doLogout && window.doLogout.__v287)
    };
  };
  window.__twhV287SaveMarker = saveMarker;
  window.__twhV287ClearMarker = clearMarker;

  try {
    console.log('v287 session-resume active');
  } catch (e) {}
})();

;

/* ==== /js/234-twh-orders-panel-render-hardening-v288.js ==== */
/* ============================================================================
 * 234 — TWH LAB/RADIOLOGY ORDERS-PANEL RENDER HARDENING (v288)
 * ----------------------------------------------------------------------------
 * REQUEST (from screenshot): on the Radiology / Laboratory pages the
 *   "… Orders — Edit · Approve · Generate Bill" panel showed its summary-chip
 *   row (Total Orders / Pending Approval / Approved / Billed / Unbilled Revenue)
 *   only HALF-painted — the pastel chips were sliced off at the bottom, and the
 *   whole Edit·Approve·Generate-Bill area kept appearing / disappearing.
 *
 * ROOT CAUSE: the panel is a .card with `backdrop-filter: blur(12px)` that was
 *   being torn down and rebuilt on every save→pull→save tick (fixed in v287 by
 *   removing the state:changed cache-bust). During each rebuild the browser
 *   showed a half-composited frame — chips clipped, buttons flashing. Even with
 *   the churn gone, a blurred card mid-relayout can still flash.
 *
 * FIX (append-only, constraint-safe — no core edits, CSS + light DOM only):
 *   1) Inject a scoped stylesheet that HARDENS the orders panel so a repaint can
 *      never leave it visually clipped:
 *        • give the panel card a stable identity via a data attribute we stamp;
 *        • force `overflow: visible` and a sensible min-height on the card and
 *          its chip row so chips are always fully drawn;
 *        • drop the blur filter on THIS card only (blur is the main source of
 *          the half-painted look during relayout) and add GPU-compositing hints
 *          (contain/translateZ) so the panel paints as one stable layer;
 *        • guarantee chips have a fixed min-height and don't shrink.
 *   2) Stamp the panel card (the .card whose header contains
 *      "Orders — Edit · Approve · Generate Bill") with `data-twh-orders-panel`
 *      after each render so the stylesheet applies. Idempotent.
 *
 * CONSTRAINTS HONORED: appended at END of manifest; NO raw setInterval / NO new
 * MutationObserver (DOMBus.register + HMS.every + bounded setTimeout); no edits
 * to the read-only core, CSS files, D1 schema, /api/state, _redirects, worker,
 * or functions/_lib/merge.js; does not reorder feature packs.
 * ==========================================================================*/
(function () {
  'use strict';
  if (window.__twhV288) return;
  window.__twhV288 = true;

  function isFn(f) { return typeof f === 'function'; }

  var STYLE_ID = 'twh-v288-orders-panel-style';
  var CSS = [
    /* The orders panel must always paint fully — never clipped, never blurred
       mid-relayout. Scoped strictly to our stamped card. */
    '[data-twh-orders-panel]{',
    '  overflow:visible !important;',
    '  backdrop-filter:none !important;',
    '  -webkit-backdrop-filter:none !important;',
    '  contain:layout paint style;',        /* isolate layout so a repaint of siblings can't reflow-flash it */
    '  transform:translateZ(0);',           /* own compositor layer → atomic paint, no half frames */
    '  will-change:auto;',
    '}',
    /* The summary-chip row: never let chips be clipped or squashed. */
    '[data-twh-orders-panel] .twh-orders-chips,',
    '[data-twh-orders-panel] > div[style*="flex-wrap"]{',
    '  overflow:visible !important;',
    '  min-height:64px;',
    '  align-items:stretch;',
    '}',
    /* Individual chips keep their full height even during a relayout. */
    '[data-twh-orders-panel] > div[style*="flex-wrap"] > div{',
    '  min-height:52px;flex:0 0 auto;box-sizing:border-box;',
    '}',
    /* Keep the action buttons row from being cropped. */
    '[data-twh-orders-panel] .act-row{overflow:visible !important;}'
  ].join('\n');

  function injectStyle() {
    try {
      if (document.getElementById(STYLE_ID)) return;
      var head = document.head || document.getElementsByTagName('head')[0] || document.documentElement;
      if (!head) return;
      var st = document.createElement('style');
      st.id = STYLE_ID;
      st.type = 'text/css';
      st.appendChild(document.createTextNode(CSS));
      head.appendChild(st);
    } catch (e) {}
  }

  // Find the orders-panel card(s) currently in the DOM and stamp them.
  // We identify by the header text produced by the v107 panel builder (084):
  //   "<title> Orders — Edit · Approve · Generate Bill"
  function stampPanels() {
    try {
      var host = document.getElementById('moduleContent') || document.getElementById('app') || document;
      var heads = host.querySelectorAll ? host.querySelectorAll('.card .card-hd h3') : [];
      for (var i = 0; i < heads.length; i++) {
        var h = heads[i];
        var txt = (h.textContent || '');
        if (txt.indexOf('Orders \u2014 Edit') > -1 || /Orders\s*\u2014\s*Edit\s*\u00b7\s*Approve/.test(txt)) {
          var card = h.closest ? h.closest('.card') : null;
          if (card && !card.getAttribute('data-twh-orders-panel')) {
            card.setAttribute('data-twh-orders-panel', '1');
            // Tag the chip row (first flex-wrap div child) for the scoped CSS.
            try {
              var kids = card.children;
              for (var k = 0; k < kids.length; k++) {
                var c = kids[k];
                var s = c.getAttribute && (c.getAttribute('style') || '');
                if (s && s.indexOf('flex-wrap') > -1 && !c.classList.contains('twh-orders-chips')) {
                  c.classList.add('twh-orders-chips');
                  break;
                }
              }
            } catch (e2) {}
          }
        }
      }
    } catch (e) {}
  }

  function tick() {
    injectStyle();
    stampPanels();
  }

  /* ── BOOT / RE-ARM ────────────────────────────────────────────────────── */
  tick();
  [50, 200, 600, 1200, 2500, 6000].forEach(function (ms) { setTimeout(tick, ms); });
  try { window.addEventListener('load', tick); } catch (e) {}
  // Re-stamp after every DOM mutation batch (the single shared DOMBus observer),
  // so a fresh render() that rebuilds #moduleContent gets re-stamped.
  try { if (window.DOMBus && isFn(window.DOMBus.register)) window.DOMBus.register(tick); } catch (e) {}
  try { if (window.HMS && isFn(window.HMS.every)) window.HMS.every(10000, tick); } catch (e) {}

  /* Diagnostics */
  window.__twhV288Diag = function () {
    var n = 0;
    try { n = document.querySelectorAll('[data-twh-orders-panel]').length; } catch (e) {}
    return {
      version: 'v288',
      styleInjected: !!document.getElementById(STYLE_ID),
      stampedPanels: n
    };
  };

  try {
    console.log('\u2705 v288 orders-panel render hardening');
  } catch (e) {}
})();

;

/* ==== /js/235-twh-kill-autorecover-loop-v289.js ==== */
/* ============================================================================
 * 235 — TWH KILL RUNAWAY AUTO-RECOVER LOOP (v289)
 * ----------------------------------------------------------------------------
 * REQUEST (verbatim): "Flickering and not stable and shaking of the application.
 *   even search it keeps shaking and flickering. Please fix"
 *
 * DIAGNOSIS (from the screen recording):
 *   The WHOLE main content area (KPI cards, card-type breakdown, the
 *   Status/Card-Type/Department filters, the search box, and the patient table)
 *   re-rendered and layout-shifted roughly every 1–2 seconds, making the search
 *   box impossible to type into. A green pill in the corner cycled endlessly
 *   between:
 *       "Recovered automatically — the page is responsive again."
 *       "Still heavy — switched to a lighter page and recovered."
 *
 *   This is a RUNAWAY AUTO-RECOVERY LOOP:
 *     • v234 (diagnostics watchdog) records a "UI-STALL" whenever a
 *       requestAnimationFrame gap exceeds 3000 ms (main thread blocked).
 *     • v272 (auto-resolve) reacts to each stall by running a HEAVY recovery
 *       chain — window.__twhResolveAll() (re-assert governor + quiet repaint +
 *       flush) AND goTo('patients') (a full page re-render / navigation).
 *     • That heavy recovery itself blocks the main thread long enough to trip
 *       the 3s watchdog again → another stall → another recovery → navigation →
 *       toast → … forever. The "cure" is what causes the shaking.
 *
 * FIX (append-only, constraint-safe — no core edits):
 *   1) Flip v272's OWN documented kill-switch: window.TWH_AUTO_RESOLVE = false.
 *      v272 reads this flag live at the top of handleStallIfAny() and
 *      gateAutoPanel(), so setting it false permanently disarms the automatic
 *      recovery + auto-navigation + toast cycling. The manual "Diagnostics"
 *      button and window.__twhResolveAll() STILL work on demand — we only stop
 *      the AUTOMATIC, self-triggering loop.
 *   2) Belt-and-braces: wrap window.toast so the two specific auto-recovery
 *      messages can never flash again even if some path still fires them.
 *   3) Keep re-asserting the flag (boot is staggered; some pack could set it
 *      true again) via the shared DOMBus ticker + HMS.every — cheap idempotent.
 *
 * WHY THIS IS SAFE:
 *   - Disabling AUTOMATIC recovery does not remove any data or feature. Genuine
 *     heaviness is already handled elsewhere (v231 render governor coalesces
 *     paints; v268/v230 diff-guarded repaints; v286/v287 anti-blink). The auto
 *     loop was a net-negative: it was the thing shaking the screen.
 *   - The watchdog (v234) still records stalls for the manual diagnostics panel.
 *
 * CONSTRAINTS HONORED: appended at END of manifest; NO raw setInterval / NO new
 * MutationObserver (DOMBus.register + HMS.every + bounded setTimeout); no edits
 * to the read-only core, CSS files, D1 schema, /api/state, _redirects, worker,
 * or functions/_lib/merge.js; does not reorder feature packs.
 * ==========================================================================*/
(function () {
  'use strict';
  if (window.__twhV289) return;
  window.__twhV289 = true;

  function isFn(f) { return typeof f === 'function'; }

  // The two auto-recovery toasts that were cycling on-screen (v272).
  var SUPPRESS = [
    'Recovered automatically \u2014 the page is responsive again.',
    'Still heavy \u2014 switched to a lighter page and recovered.',
    // ASCII-hyphen variants, just in case a build normalised the dash.
    'Recovered automatically - the page is responsive again.',
    'Still heavy - switched to a lighter page and recovered.'
  ];
  function isSuppressed(msg) {
    try {
      var s = String(msg == null ? '' : msg);
      for (var i = 0; i < SUPPRESS.length; i++) { if (s.indexOf(SUPPRESS[i]) > -1) return true; }
      // Fuzzy fallback on the tell-tale phrases.
      if (/Recovered automatically/i.test(s) && /responsive again/i.test(s)) return true;
      if (/Still heavy/i.test(s) && /lighter page/i.test(s)) return true;
    } catch (e) {}
    return false;
  }

  /* ── 1) Disarm the automatic recovery loop via v272's own kill-switch. ──── */
  function disarm() {
    try { window.TWH_AUTO_RESOLVE = false; } catch (e) {}
  }

  /* ── 2) Swallow the two runaway recovery toasts (idempotent wrap). ─────── */
  function wrapToast() {
    try {
      var orig = window.toast;
      if (isFn(orig) && !orig.__v289) {
        var w = function (msg) {
          if (isSuppressed(msg)) return; // never show the loop toasts again
          return orig.apply(this, arguments);
        };
        w.__v289 = true;
        try { for (var k in orig) { if (Object.prototype.hasOwnProperty.call(orig, k)) w[k] = orig[k]; } } catch (e) {}
        window.toast = w;
      }
    } catch (e) {}
  }

  function tick() {
    disarm();
    wrapToast();
  }

  /* ── BOOT / RE-ARM ────────────────────────────────────────────────────── */
  disarm();       // do it immediately, before v272's rAF poll can fire again
  wrapToast();
  [0, 50, 150, 400, 900, 2000, 4000].forEach(function (ms) { setTimeout(tick, ms); });
  try { window.addEventListener('load', tick); } catch (e) {}
  try { if (window.DOMBus && isFn(window.DOMBus.register)) window.DOMBus.register(tick); } catch (e) {}
  try { if (window.HMS && isFn(window.HMS.every)) window.HMS.every(10000, tick); } catch (e) {}

  /* Public + diagnostics */
  window.__twhV289Diag = function () {
    return {
      version: 'v289',
      autoResolveDisabled: window.TWH_AUTO_RESOLVE === false,
      toastWrapped: !!(window.toast && window.toast.__v289)
    };
  };
  // Escape hatch: allow re-enabling automatic recovery if ever wanted.
  window.__twhV289Rearm = function () { window.TWH_AUTO_RESOLVE = true; };

  try {
    console.log('\u2705 v289 auto-recover loop killed');
  } catch (e) {}
})();

;

/* ==== /js/236-twh-recursion-breaker-v290.js ==== */
/* ════════════════════════════════════════════════════════════════════
   TWH · RENDER-MODULE RECURSION BREAKER (v290)
   ────────────────────────────────────────────────────────────────────
   PERMANENT FIX for the reported screenshot:

       "Error rendering module — Maximum call stack size exceeded"
       (visible on the Patients / Fast-Register screen, rendered by the
        core v24 fallback at 010-begin-v24-enhancement.js:5256 when
        _v24_origRenderModule() throws a RangeError).

   ── ROOT CAUSE ──────────────────────────────────────────────────────
   ~10 feature packs decorate window.renderModule, and almost every one
   copies the PREVIOUS wrapper's guard flags onto the new wrapper via
      `for (var k in rm) { ... wrapped[k] = rm[k]; }`
   so the guard flags (__twhV260, __twhV262shield, __twhV268shield,
   __twhV281, __v286, __v184, __v186, _extWrapped, _wellWrapped, …)
   accumulate up the chain.

   The chain becomes SELF-REFERENTIAL when a wrapper that does a
   *selective* / partial flag-copy (e.g. 105:2334 copies only
   `_wellWrapped`, dropping the others) installs on top. That drops the
   other packs' guard flags from the visible top of the chain, so on the
   next shared-ticker re-assert (DOMBus / HMS.every / setTimeout) each of
   those packs sees `rm.__itsFlag === undefined`, RE-WRAPS, and
   re-captures the *current* global as its inner original — while its own
   `for k in` copy re-propagates flags from wrappers already BELOW it.
   The result is a wrapper whose captured original eventually resolves
   back through itself → unbounded recursion → RangeError → the core v24
   fallback paints the red "Error rendering module" card.

   A local Node reproduction (v262+v260+v268+v281+v286 boot, then a
   selective wrapper, then 8 ticker re-asserts) throws
   "Maximum call stack size exceeded" exactly as in production.

   ── WHY THE EXISTING v260 GUARD DOESN'T CATCH IT ────────────────────
   v260 installs a depth-capped wrapper, but it sits in the MIDDLE of the
   chain (packs wrap on top of it after boot). Recursion that spins in the
   layers ABOVE v260 never reaches v260's counter, so it overflows first.

   ── THE FIX ─────────────────────────────────────────────────────────
   Install ONE terminal, poison-proof re-entrancy breaker that:
     • Stores its re-entry depth on `window` (window.__twhV290Depth), NOT
       as a function property — so the `for k in` flag-copying epidemic
       can neither read it, copy it, nor disable it.
     • Marks its guard with a NON-ENUMERABLE property (__twhV290) so
       `for (k in rm)` copies can never propagate/poison it onto other
       wrappers (which is what re-armed the cycle).
     • On every call, if re-entry depth exceeds a small safe cap, it
       STOPS recursing and returns the last-good HTML string (or a calm
       placeholder) instead of letting the stack overflow — so the core
       v24 fallback never sees a RangeError and the red error card can
       never appear.
     • Keeps itself OUTERMOST: on the shared ticker it checks whether a
       later pack wrapped on top of it; if so, it re-installs itself as
       the new outermost layer (idempotently, never double-wrapping its
       own wrapper).

   Constraints honoured: no core edits · no D1 schema / /api/state change
   · no feature-pack reorder · rides DOMBus + HMS.every + bounded
   setTimeout only (no new raw setInterval, no new MutationObserver).

   Guard: window.__twhV290 · Diagnostics: window.__twhV290Diag()
   ════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV290) return;
  window.__twhV290 = true;

  var TAG = '[v290]';
  function isFn(f) { return typeof f === 'function'; }
  function log() {
    try {
      console.log.apply(console, [TAG].concat([].slice.call(arguments)));
    } catch (_e) {}
  }

  // Re-entry depth + last-good HTML live on window so no function-property
  // copy epidemic can touch them. MAX_REENTRY is small: a healthy renderModule
  // never legitimately re-enters itself at all.
  if (typeof window.__twhV290Depth !== 'number') window.__twhV290Depth = 0;
  var MAX_REENTRY = 8;
  var lastGood = '';
  // Per-module last-good cache. A capped renderModule must NEVER return a
  // DIFFERENT module's body (the "sidebar shows Prescriptions but content is
  // still Appointments" bug): key the cache by the live currentMod so a cap
  // returns THIS module's last body, or a calm placeholder if we have none yet
  // (which the v319 verifier then repaints) — never a foreign module's body.
  var lastGoodByMod = {};
  function curMod() {
    try { return (typeof window.currentMod !== 'undefined' && window.currentMod != null) ? String(window.currentMod)
                : (window.D && window.D.currentMod) ? String(window.D.currentMod) : ''; }
    catch (_e) { return ''; }
  }
  var capHits = 0;
  var installs = 0;
  // Cache-miss escape hatch. When renderModule is capped but we have NO cached
  // body for the current module (a first visit / after a ResetCurrent), a dead
  // "Loading module…" placeholder would get stuck on screen (the EMR/Medical-
  // Records "stuck on Loading" bug). In that ONE case we must still produce a
  // real body: allow a single bounded direct render at depth 0 for this module,
  // tracked per-module so the storm can't turn it into an infinite escape.
  var escapedMod = {};

  // A non-enumerable marker: the many `for (var k in rm)` copies iterate only
  // ENUMERABLE own keys, so this flag can NEVER be copied onto another wrapper
  // (that copy-propagation is exactly what re-armed the recursion cycle).
  function markBreaker(fn) {
    try {
      Object.defineProperty(fn, '__twhV290breaker', {
        value: true, enumerable: false, writable: false, configurable: false
      });
    } catch (_e) {
      // Extremely old engines: fall back to a normal prop (still functional;
      // just theoretically copyable). Prefix keeps it obvious in diagnostics.
      try { fn.__twhV290breaker = true; } catch (_x) {}
    }
    return fn;
  }

  function isBreaker(fn) {
    return !!(fn && fn.__twhV290breaker);
  }

  function makeBreaker(inner) {
    var breaker = function () {
      // Hard re-entrancy cap: if renderModule is already this deep inside
      // itself, the chain is recursing — DO NOT go deeper. Return last-good
      // HTML so the core v24 fallback never receives a RangeError.
      if (window.__twhV290Depth >= MAX_REENTRY) {
        capHits++;
        if (capHits === 1 || capHits % 25 === 0) {
          try { console.warn(TAG, 'reentry capped', window.__twhV290Depth, capHits); } catch (_e) {}
        }
        // Serve THIS module's cached body only — never a foreign module's.
        var mk = curMod();
        var cached = (mk && lastGoodByMod[mk]) ? lastGoodByMod[mk] : '';
        if (cached) return cached;
        // Cache-miss escape hatch: no cached body for this module yet. Rather
        // than get stuck on the dead placeholder, do ONE direct render at a
        // reset depth so the first visit always paints real content. Bounded
        // per-module so an ongoing storm cannot loop through here.
        if (mk && !escapedMod[mk]) {
          escapedMod[mk] = true;
          var savedDepth = window.__twhV290Depth;
          window.__twhV290Depth = 1;              // count this one call, no deeper
          try {
            var esc = inner.apply(this, arguments);
            if (typeof esc === 'string' && esc.length) {
              lastGood = esc; lastGoodByMod[mk] = esc; // cache so retries reuse
              return esc;
            }
          } catch (_esc) { /* fall through to placeholder */ }
          finally { window.__twhV290Depth = savedDepth; }
        }
        return '<div class="card" style="padding:32px"><h3>Loading module…</h3></div>';
      }
      window.__twhV290Depth++;
      try {
        var html = inner.apply(this, arguments);
        if (typeof html === 'string' && html.length) { lastGood = html; var k = curMod(); if (k) lastGoodByMod[k] = html; }
        return html;
      } catch (e) {
        var msg = String(e && e.message);
        if (/call stack|recursion|too much recursion/i.test(msg)) {
          // Swallow the overflow — the whole point of this module. Return the
          // last good paint instead of letting it bubble to the red error card.
          capHits++;
          try { console.warn(TAG, 'overflow swallowed'); } catch (_x) {}
          var mk2 = curMod();
          var cached2 = (mk2 && lastGoodByMod[mk2]) ? lastGoodByMod[mk2] : '';
          return cached2 || lastGood || '<div class="card" style="padding:32px"><h3>Loading module…</h3></div>';
        }
        throw e; // non-recursion errors keep their normal handling
      } finally {
        window.__twhV290Depth--;
        if (window.__twhV290Depth < 0) window.__twhV290Depth = 0;
      }
    };
    return markBreaker(breaker);
  }

  // Install / re-assert the breaker as the OUTERMOST renderModule wrapper.
  function install() {
    var rm = window.renderModule;
    if (!isFn(rm)) return false;
    // Already outermost breaker → nothing to do (idempotent; never wrap self).
    if (isBreaker(rm)) return false;
    window.renderModule = makeBreaker(rm);
    installs++;
    return true;
  }

  // Do the same for the DOM writer render() as a belt-and-braces coalescer, so
  // a render→renderModule→render storm also can't overflow. Uses its own
  // window-level counter and a non-enumerable marker.
  if (typeof window.__twhV290RenderDepth !== 'number') window.__twhV290RenderDepth = 0;
  var MAX_RENDER_REENTRY = 4;
  function installRenderCoalescer() {
    var r = window.render;
    if (!isFn(r) || isBreaker(r)) return false;
    var breaker = function () {
      if (window.__twhV290RenderDepth >= MAX_RENDER_REENTRY) {
        try { console.warn(TAG, 'render() re-entrancy capped — coalescing'); } catch (_e) {}
        return;
      }
      window.__twhV290RenderDepth++;
      try { return r.apply(this, arguments); }
      catch (e) {
        if (/call stack|recursion|too much recursion/i.test(String(e && e.message))) {
          try { console.warn(TAG, 'render() stack overflow swallowed'); } catch (_x) {}
          return;
        }
        throw e;
      } finally {
        window.__twhV290RenderDepth--;
        if (window.__twhV290RenderDepth < 0) window.__twhV290RenderDepth = 0;
      }
    };
    markBreaker(breaker);
    window.render = breaker;
    return true;
  }

  function tick() {
    try { install(); } catch (_e) {}
    try { installRenderCoalescer(); } catch (_e) {}
  }

  // Boot now, then re-assert across the staggered boot window so that whenever
  // a later pack wraps renderModule on top of us we climb back to outermost.
  tick();
  [0, 120, 350, 800, 1500, 2600, 4200, 6500, 9000, 12000].forEach(function (ms) { setTimeout(tick, ms); });
  try { window.addEventListener('load', tick); } catch (_e) {}
  try { if (window.DOMBus && isFn(window.DOMBus.register)) window.DOMBus.register(tick); } catch (_e) {}
  try { if (window.HMS && isFn(window.HMS.every)) window.HMS.every(4000, tick); } catch (_e) {}

  window.__twhV290Diag = function () {
    return {
      active: true,
      renderModuleBroken: isBreaker(window.renderModule),
      renderBroken: isBreaker(window.render),
      currentDepth: window.__twhV290Depth,
      currentRenderDepth: window.__twhV290RenderDepth,
      maxReentry: MAX_REENTRY,
      capHits: capHits,
      installs: installs,
      hasLastGood: typeof lastGood === 'string' && lastGood.length > 0
    };
  };
  // Manual re-assert hook (parity with other stability modules).
  window.__twhV290Reassert = tick;

  // Cache-reset hooks so a genuine user navigation can force the NEXT
  // renderModule to run the real inner (not serve a stale capped body).
  // __twhV290ResetCurrent() drops only the current module's cache entry;
  // __twhV290ResetCache() clears everything. Both also zero the depth counters
  // so the corrective render is treated as a fresh depth-0 pass.
  window.__twhV290ResetCurrent = function () {
    try { var k = curMod(); if (k) { if (lastGoodByMod[k]) delete lastGoodByMod[k]; escapedMod[k] = false; } } catch (_e) {}
    try { window.__twhV290Depth = 0; window.__twhV290RenderDepth = 0; } catch (_e) {}
  };
  window.__twhV290ResetCache = function () {
    lastGoodByMod = {}; lastGood = ''; escapedMod = {};
    try { window.__twhV290Depth = 0; window.__twhV290RenderDepth = 0; } catch (_e) {}
  };

  log('v290 recursion breaker active');
})();

;

/* ==== /js/237-twh-canonical-render-dispatcher-v291.js ==== */
/* ════════════════════════════════════════════════════════════════════
   TWH · CANONICAL RENDER DISPATCHER + CHAIN STABILISER (v291)
   ────────────────────────────────────────────────────────────────────
   STRUCTURAL stability upgrade — the forward-looking half of the fix that
   v290 (recursion breaker) began.

   ── WHY ─────────────────────────────────────────────────────────────
   Over versions v24→v290 the app accumulated a very large monkey-patch
   surface (a static scan finds 244 distinct wrapper guard flags). In
   particular ~20 packs wrap window.renderModule and ~14 of them RE-WRAP
   on shared tickers (DOMBus / HMS.every / setTimeout), each copying the
   previous wrapper's guard flags via `for (k in rm) wrapped[k]=rm[k]`.
   That churn is the source of the reported flicker / shake / and the
   "Maximum call stack size exceeded" recursion (fixed reactively by v290).

   Continuing to add MORE wrappers to fight the symptoms only deepens the
   chain. This module instead introduces the *right* extension primitive
   and stops the chain from growing further:

   ── WHAT ────────────────────────────────────────────────────────────
   1) A canonical RENDERER REGISTRY:  window.TWH_RENDERERS
        TWH_RENDERERS.register('someMod', fn)   // fn returns an HTML string
        TWH_RENDERERS.has('someMod') / .get(...) / .list()
      New features register a renderer for their module key instead of
      wrapping window.renderModule. The dispatcher consults the registry
      FIRST (keyed on window.currentMod), then falls through to the
      existing (legacy) renderModule chain unchanged. This is the
      "register, don't wrap" pattern that keeps the chain from deepening.

   2) A single stable DISPATCHER installed as the outermost renderModule.
      It does NOT copy/propagate guard flags (so it can never poison other
      wrappers), it is idempotent, and it re-asserts itself outermost on
      the shared ticker. Because every future feature registers instead of
      wrapping, the legacy chain beneath it stops growing.

   3) CHAIN-GROWTH DAMPING: the dispatcher remembers the legacy chain it
      captured. If a legacy pack re-wraps underneath on a ticker (creating
      a NEW inner function), the dispatcher simply re-captures the current
      inner once and stays outermost — it never itself multiplies.

   Works WITH v290: v290 remains the re-entrancy safety net; v291 removes
   the *cause* of new growth going forward. Both are idempotent and
   cooperate (v291 sits just under v290's breaker, or re-asserts around
   it — either order is safe because neither copies the other's flags).

   Constraints: no core edits · no D1 / /api/state / manifest-order change
   · rides DOMBus + HMS.every + bounded setTimeout only (no raw
   setInterval, no new MutationObserver, no DOMContentLoaded).

   Guard: window.__twhV291 · Diagnostics: window.__twhV291Diag()
   ════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV291) return;
  window.__twhV291 = true;

  var TAG = '[v291]';
  function isFn(f) { return typeof f === 'function'; }
  function log() {
    try { console.log.apply(console, [TAG].concat([].slice.call(arguments))); } catch (_e) {}
  }
  function curMod() {
    try { if (typeof window.currentMod === 'string') return window.currentMod; } catch (_e) {}
    try { if (window.D && typeof window.D.currentMod === 'string') return window.D.currentMod; } catch (_e) {}
    return '';
  }

  /* ── 1) Canonical renderer registry ─────────────────────────────────── */
  var registry = Object.create(null);
  var REG = {
    register: function (mod, fn) {
      if (typeof mod !== 'string' || !mod || !isFn(fn)) return false;
      registry[mod] = fn;
      return true;
    },
    unregister: function (mod) { if (registry[mod]) { delete registry[mod]; return true; } return false; },
    has: function (mod) { return !!registry[mod]; },
    get: function (mod) { return registry[mod] || null; },
    list: function () { return Object.keys(registry); }
  };
  // Don't clobber a pre-existing registry (idempotent across reloads of pack).
  if (!window.TWH_RENDERERS) window.TWH_RENDERERS = REG;
  else { REG = window.TWH_RENDERERS; registry = null; } // reuse existing

  /* ── 2) Dispatcher over the legacy chain ────────────────────────────── */
  // The legacy renderModule chain we dispatch into. Re-captured (never
  // multiplied) if a legacy pack re-wraps underneath.
  var legacy = null;

  // Non-enumerable markers so the `for (k in rm)` copy epidemic can NEVER
  // duplicate/poison these flags onto other wrappers.
  //   __twhV291dispatch — this is v291's dispatcher.
  //   __twhV290breaker  — we ALSO stamp v290's marker so v290 recognises the
  //                       dispatcher as "already the terminal breaker" and
  //                       stands down (prevents v290↔v291 mutual re-wrap growth).
  function markDispatcher(fn) {
    ['__twhV291dispatch', '__twhV290breaker'].forEach(function (k) {
      try { Object.defineProperty(fn, k, { value: true, enumerable: false, writable: false, configurable: false }); }
      catch (_e) { try { fn[k] = true; } catch (_x) {} }
    });
    return fn;
  }
  function isDispatcher(fn) { return !!(fn && fn.__twhV291dispatch); }
  function isBreaker(fn) { return !!(fn && fn.__twhV290breaker); }

  // Re-entrancy protection shared with v290 semantics (window-level depth so a
  // for-in copy cannot read/disable it). The dispatcher IS a superset of the
  // breaker, so when it sits outermost the app still cannot stack-overflow.
  if (typeof window.__twhV290Depth !== 'number') window.__twhV290Depth = 0;
  var MAX_REENTRY = 8;
  var lastGood = '';
  var capHits = 0;

  function makeDispatcher(inner) {
    var dispatch = function () {
      // Re-entrancy cap (breaker semantics): never let the chain overflow.
      if (window.__twhV290Depth >= MAX_REENTRY) {
        capHits++;
        return lastGood || '<div class="card" style="padding:32px"><h3>Loading module…</h3></div>';
      }
      window.__twhV290Depth++;
      try {
        // (a) Registry FIRST — the "register don't wrap" extension path.
        try {
          var mod = curMod();
          var reg = window.TWH_RENDERERS;
          if (mod && reg && reg.has && reg.has(mod)) {
            var rfn = reg.get(mod);
            if (isFn(rfn)) {
              var rout = rfn.apply(this, arguments);
              if (typeof rout === 'string') { lastGood = rout; return rout; }
              // non-string → fall through to legacy for safety
            }
          }
        } catch (_e) { /* registry must never break rendering */ }

        // (b) Legacy chain unchanged.
        var html = inner.apply(this, arguments);
        if (typeof html === 'string' && html.length) lastGood = html;
        return html;
      } catch (e) {
        if (/call stack|recursion|too much recursion/i.test(String(e && e.message))) {
          capHits++;
          return lastGood || '<div class="card" style="padding:32px"><h3>Loading module…</h3></div>';
        }
        throw e;
      } finally {
        window.__twhV290Depth--;
        if (window.__twhV290Depth < 0) window.__twhV290Depth = 0;
      }
    };
    return markDispatcher(dispatch);
  }

  function install() {
    var rm = window.renderModule;
    if (!isFn(rm)) return false;

    // Already our dispatcher → done (idempotent; never wrap self).
    if (isDispatcher(rm)) return false;

    // If a plain v290 breaker is outermost, UPGRADE it in place: capture what
    // it wraps by re-wrapping it once with the dispatcher (which is itself a
    // breaker superset). Because the dispatcher carries __twhV290breaker, v290
    // will treat the result as already-broken and never wrap on top again →
    // no mutual growth. We only do this ONCE per distinct inner function.
    if (isBreaker(rm)) {
      if (legacy === rm) return false;    // already dispatched this exact breaker
      legacy = rm;
      window.renderModule = makeDispatcher(rm);
      return true;
    }

    // Fresh legacy chain (no breaker/dispatcher yet) → install dispatcher.
    if (legacy === rm) return false;
    legacy = rm;
    window.renderModule = makeDispatcher(rm);
    return true;
  }

  /* ── 3) Ticker re-assert (climb back to / stay outermost) ───────────── */
  function tick() { try { install(); } catch (_e) {} }

  tick();
  [0, 140, 400, 900, 1700, 3000, 5000, 8000, 12000].forEach(function (ms) { setTimeout(tick, ms); });
  try { window.addEventListener('load', tick); } catch (_e) {}
  try { if (window.DOMBus && isFn(window.DOMBus.register)) window.DOMBus.register(tick); } catch (_e) {}
  try { if (window.HMS && isFn(window.HMS.every)) window.HMS.every(5000, tick); } catch (_e) {}

  /* ── Diagnostics ────────────────────────────────────────────────────── */
  window.__twhV291Diag = function () {
    return {
      active: true,
      dispatcherInstalled: isDispatcher(window.renderModule),
      registeredModules: (window.TWH_RENDERERS && window.TWH_RENDERERS.list) ? window.TWH_RENDERERS.list() : [],
      registryCount: (window.TWH_RENDERERS && window.TWH_RENDERERS.list) ? window.TWH_RENDERERS.list().length : 0,
      cooperatesWithV290: !!window.__twhV290
    };
  };
  window.__twhV291Reassert = tick;

  log('canonical render dispatcher active — TWH_RENDERERS registry ("register, don\'t wrap") + chain-growth damping; future features extend without deepening the wrapper chain');
})();

;

/* ==== /js/238-twh-migration-ledger-boot-quiet-v292.js ==== */
/* ════════════════════════════════════════════════════════════════════
   TWH · MIGRATION LEDGER + BOOT-LOG QUIETER (v292)
   ────────────────────────────────────────────────────────────────────
   P1 (data hygiene) + P3 (console noise) from the "perfect fit" roadmap.

   ── PROBLEM ─────────────────────────────────────────────────────────
   Several one-off data migrations (patient-schema backfill v253, tombstone
   repair v276, stale-tombstone strip v249, …) re-do their work and re-emit
   their console banners on EVERY page load / after every server pull,
   because their "already done" state lives only in a module-scope variable
   that resets each load. v276 pioneered the right pattern — a PERSISTED
   document marker compared against a version — but there is no shared,
   reusable primitive, so each migration re-implements (or omits) it.

   Separately, the boot sequence prints 100+ console lines (each pack logs
   an activation banner), which buries real warnings.

   ── FIX ─────────────────────────────────────────────────────────────
   1) A shared, persistent MIGRATION LEDGER: window.TWH_MIGRATIONS
        TWH_MIGRATIONS.done(id)        → true if this migration id has
                                          already completed on THIS document
        TWH_MIGRATIONS.mark(id[,save]) → record id as completed + persist
        TWH_MIGRATIONS.run(id, fn)     → run fn() exactly once per document
                                          (skips if already marked), persists
        TWH_MIGRATIONS.list()          → completed ids
      The ledger is stored on the D1 document under a single object key
      `_twhMigrationLedger` (a plain object → survives the collection-aware
      server merge, which recurses plain objects key-by-key). So a migration
      that has run on the shared document never re-runs for the next
      session / user / tab.

   2) A BOOT-LOG QUIETER (opt-in-safe): after the boot window settles, and
      unless window.TWH_VERBOSE_BOOT === true, collapse DUPLICATE repeated
      migration/among-pull banners so they print at most once. We only
      de-dupe exact-repeat lines from known-noisy migration tags; all
      warnings, errors and first-occurrence logs pass through untouched.

   Cooperates with the existing v276 marker (it keeps its own key; we do
   not fight it). Purely additive: existing modules keep working; new/
   updated migrations can adopt TWH_MIGRATIONS.run() to stop re-running.

   Constraints: no core edits · no D1 schema / /api/state / manifest-order
   change · DOMBus + HMS.every + bounded setTimeout only (no raw
   setInterval, no new MutationObserver, no DOMContentLoaded).

   Guard: window.__twhV292 · Diagnostics: window.__twhV292Diag()
   ════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV292) return;
  window.__twhV292 = true;

  var TAG = '[v292]';
  var LEDGER_KEY = '_twhMigrationLedger';
  function isFn(f) { return typeof f === 'function'; }
  function log() {
    try { console.log.apply(console, [TAG].concat([].slice.call(arguments))); } catch (_e) {}
  }
  function D_() { try { if (window.D && typeof window.D === 'object') return window.D; } catch (_e) {} return null; }

  function ledger() {
    var D = D_();
    if (!D) return null;
    if (!D[LEDGER_KEY] || typeof D[LEDGER_KEY] !== 'object') D[LEDGER_KEY] = {};
    return D[LEDGER_KEY];
  }

  function persist(immediate) {
    try {
      if (immediate && isFn(window._hmsSave)) return window._hmsSave();
      if (isFn(window._hmsSaveSoon)) return window._hmsSaveSoon();
      if (isFn(window._hmsSave)) return window._hmsSave();
      if (window.HMS && isFn(window.HMS.markDirty)) window.HMS.markDirty();
    } catch (_e) {}
  }

  /* ── 1) Shared persistent migration ledger ──────────────────────────── */
  var MIG = {
    done: function (id) {
      var L = ledger();
      return !!(L && L[id]);
    },
    mark: function (id, save) {
      var L = ledger();
      if (!L) return false;                 // document not hydrated yet
      if (L[id]) return true;               // already marked
      L[id] = { at: Date.now() };
      persist(save === true);
      return true;
    },
    // Run fn() exactly once per document. Returns:
    //   'skipped' (already done) | 'ran' (executed + marked) |
    //   'deferred' (document not ready yet — caller should retry) | 'error'
    run: function (id, fn) {
      var L = ledger();
      if (!L) return 'deferred';
      if (L[id]) return 'skipped';
      try {
        var r = isFn(fn) ? fn() : undefined;
        // Only mark done when the migration did NOT explicitly return false
        // (a migration may return false to say "document not ready, retry").
        if (r === false) return 'deferred';
        L[id] = { at: Date.now() };
        persist(false);
        return 'ran';
      } catch (_e) {
        try { console.warn(TAG, 'migration', id, 'threw:', _e && _e.message); } catch (_x) {}
        return 'error';
      }
    },
    unmark: function (id) { var L = ledger(); if (L && L[id]) { delete L[id]; persist(false); return true; } return false; },
    list: function () { var L = ledger(); return L ? Object.keys(L) : []; }
  };
  if (!window.TWH_MIGRATIONS) window.TWH_MIGRATIONS = MIG;
  else MIG = window.TWH_MIGRATIONS;

  /* ── 2) Boot-log quieter (de-dupe repeated migration banners) ───────── */
  // Only de-dupe EXACT repeats whose text matches these known-noisy patterns.
  // Everything else (and all warnings/errors) passes through untouched.
  var NOISY = [
    /cleared \d+ stale (patient )?tombstone/i,
    /canonical schema applied to \d+/i,
    /persistence hardened — stamped/i,
    /post-hydration census/i,
    /slimmed doc/i
  ];
  var seen = Object.create(null);
  var suppressed = 0;
  var quietInstalled = false;

  function textOf(args) {
    try {
      return Array.prototype.map.call(args, function (a) {
        return (typeof a === 'string') ? a : '';
      }).join(' ');
    } catch (_e) { return ''; }
  }

  function installQuieter() {
    if (quietInstalled) return;
    if (window.TWH_VERBOSE_BOOT === true) { quietInstalled = true; return; } // opt-out honoured
    var orig = console.log;
    if (!isFn(orig) || orig.__twhV292quiet) { quietInstalled = true; return; }
    var wrapped = function () {
      try {
        var t = textOf(arguments);
        for (var i = 0; i < NOISY.length; i++) {
          if (NOISY[i].test(t)) {
            // collapse repeated occurrences of the SAME noisy category
            var key = NOISY[i].source;
            if (seen[key]) { suppressed++; return; }   // drop the repeat
            seen[key] = true;                          // allow the first
            break;
          }
        }
      } catch (_e) {}
      return orig.apply(console, arguments);
    };
    try {
      Object.defineProperty(wrapped, '__twhV292quiet', { value: true, enumerable: false });
    } catch (_e) { wrapped.__twhV292quiet = true; }
    console.log = wrapped;
    quietInstalled = true;
  }

  /* ── boot wiring (idempotent; shared ticker + bounded timeouts) ─────── */
  function tick() { try { installQuieter(); } catch (_e) {} }
  tick();
  [0, 300, 1200, 3000].forEach(function (ms) { setTimeout(tick, ms); });
  try { window.addEventListener('load', tick); } catch (_e) {}
  try { if (window.DOMBus && isFn(window.DOMBus.register)) window.DOMBus.register(tick); } catch (_e) {}
  try { if (window.HMS && isFn(window.HMS.every)) window.HMS.every(15000, tick); } catch (_e) {}

  window.__twhV292Diag = function () {
    return {
      active: true,
      ledgerAvailable: !!ledger(),
      completedMigrations: MIG.list(),
      migrationCount: MIG.list().length,
      quieterInstalled: quietInstalled && (window.TWH_VERBOSE_BOOT !== true),
      suppressedLogLines: suppressed,
      verboseBoot: window.TWH_VERBOSE_BOOT === true
    };
  };

  log('v292 migration ledger + boot-quiet active');
})();

;

/* ==== /js/239-twh-login-form-a11y-v293.js ==== */
/* ════════════════════════════════════════════════════════════════════
   TWH · LOGIN FORM ACCESSIBILITY PROGRESSIVE-ENHANCEMENT (v293)
   ────────────────────────────────────────────────────────────────────
   P3 (accessibility) from the "perfect fit" roadmap.

   ── PROBLEM ─────────────────────────────────────────────────────────
   The login screen (rendered in CORE, so we must not edit its source)
   emits its username/password/role fields as loose <input>/<select>
   elements inside <div class="login-field"> — there is NO <form> element.
   Consequences:
     • Screen readers get no "form" landmark and no submit semantics.
     • Password managers / browser autofill are unreliable without
       autocomplete="username" / autocomplete="current-password" and a
       proper form context.
     • <label> text is not programmatically associated with its input
       (no `for`/`id` pairing), so clicking the label doesn't focus the
       field and AT can't announce the accessible name.
   Enter-to-submit already works (core attaches keydown handlers), but the
   markup is not semantically a form.

   ── FIX (purely additive, no core edits) ───────────────────────────
   Progressive enhancement: after the login screen mounts, if its fields
   are not yet inside a <form>, wrap the existing .login-card contents in a
   real <form>, and:
     • add autocomplete hints (username / current-password) + name attrs
     • associate each visible label with its control via for/id
     • give the form aria-label + role
     • intercept native submit → call the existing doLogin() (belt &
       braces on top of core's Enter handlers) and preventDefault so the
       page never reloads.
   We move the EXISTING DOM nodes into the form (we don't clone or rebuild
   them), so all core-attached listeners and ids are preserved untouched.
   Idempotent: guarded per screen instance via a data flag, so re-runs and
   re-mounts (logout → login again) are safe and cheap.

   Constraints: no core edits · no D1 schema / /api/state / manifest-order
   change · DOMBus + HMS.every + bounded setTimeout only (no raw
   setInterval, no new MutationObserver, no DOMContentLoaded).

   Guard: window.__twhV293 · Diagnostics: window.__twhV293Diag()
   ════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV293) return;
  window.__twhV293 = true;

  var TAG = '[v293]';
  var ENHANCED_ATTR = 'data-twh-a11y-form';
  var enhancedCount = 0;
  var lastError = null;

  function isFn(f) { return typeof f === 'function'; }
  function log() {
    try { console.log.apply(console, [TAG].concat([].slice.call(arguments))); } catch (_e) {}
  }

  // Label→control pairs to associate (visible <label> is the previous sibling
  // of the control inside its .login-field wrapper in the core markup).
  var FIELD_META = {
    loginBranch: { name: 'branch',   autocomplete: 'organization',      labelText: 'Branch' },
    loginUser:   { name: 'username', autocomplete: 'username',          labelText: 'Username' },
    loginPass:   { name: 'password', autocomplete: 'current-password',  labelText: 'Password' },
    loginRole:   { name: 'role',     autocomplete: 'off',               labelText: 'Role' }
  };

  // Associate the visible <label> that precedes a control with that control.
  function pairLabel(ctrl) {
    try {
      if (!ctrl) return;
      var field = ctrl.closest ? ctrl.closest('.login-field') : null;
      var label = field ? field.querySelector('label') : null;
      if (!label) return;
      if (!ctrl.id) return; // core gives every control an id, but be safe
      if (!label.getAttribute('for')) label.setAttribute('for', ctrl.id);
    } catch (_e) {}
  }

  function applyFieldAttrs() {
    var applied = 0;
    Object.keys(FIELD_META).forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      var meta = FIELD_META[id];
      try {
        if (!el.getAttribute('name')) el.setAttribute('name', meta.name);
        // Only set autocomplete if not already present.
        if (!el.getAttribute('autocomplete')) el.setAttribute('autocomplete', meta.autocomplete);
        // Password fields benefit from an explicit type (core already sets it),
        // and username benefits from being flagged as a text input.
        if (id === 'loginUser' && !el.getAttribute('type')) el.setAttribute('type', 'text');
        // Improve AT naming when there is only a placeholder.
        if (!el.getAttribute('aria-label') && meta.labelText) el.setAttribute('aria-label', meta.labelText);
        pairLabel(el);
        applied++;
      } catch (_e) {}
    });
    return applied;
  }

  // Wrap the existing .login-card children in a <form> without rebuilding them.
  function ensureForm(card) {
    try {
      if (!card) return false;
      // Already enhanced?
      if (card.getAttribute(ENHANCED_ATTR) === '1') return false;
      // If a form already exists inside the card (someone else added one), just flag.
      if (card.querySelector('form')) {
        card.setAttribute(ENHANCED_ATTR, '1');
        return false;
      }
      // Only enhance once the expected controls are actually present.
      if (!document.getElementById('loginUser') || !document.getElementById('loginPass')) return false;

      var form = document.createElement('form');
      form.setAttribute('role', 'form');
      form.setAttribute('aria-label', 'Tranquil HMS sign in');
      form.setAttribute('novalidate', 'novalidate'); // core does its own validation in doLogin()
      form.className = 'twh-login-form';

      // Move existing children (logo, fields, error box, button, footer links)
      // into the form, preserving nodes + their listeners + ids.
      while (card.firstChild) form.appendChild(card.firstChild);
      card.appendChild(form);

      // Native submit → existing doLogin(); never reload the page.
      form.addEventListener('submit', function (e) {
        try { e.preventDefault(); } catch (_x) {}
        try { if (isFn(window.doLogin)) window.doLogin(); } catch (_x) {}
        return false;
      });

      // Ensure the Sign In button participates in native submit.
      // Core renders it as a <button onclick="doLogin()"> with no type, which
      // defaults to type=submit inside a form — so Enter + click both submit.
      // (The onclick still fires; doLogin is idempotent enough for a double
      //  call to be harmless, but preventDefault above stops the reload.)
      var btn = form.querySelector('button.login-btn');
      if (btn && !btn.getAttribute('type')) btn.setAttribute('type', 'submit');

      card.setAttribute(ENHANCED_ATTR, '1');
      return true;
    } catch (e) {
      lastError = e && e.message;
      return false;
    }
  }

  function enhance() {
    try {
      var screen = document.getElementById('loginScreen');
      if (!screen) return;                 // not on the login screen
      var card = screen.querySelector('.login-card');
      if (!card) return;
      var madeForm = ensureForm(card);
      var applied = applyFieldAttrs();     // attrs are safe to (re)apply
      if (madeForm) { enhancedCount++; log('login form a11y enhancement applied (autocomplete + <form> + labels)'); }
      return { madeForm: madeForm, applied: applied };
    } catch (e) {
      lastError = e && e.message;
    }
  }

  /* ── boot wiring (idempotent; shared ticker + bounded timeouts) ─────── */
  function tick() { try { enhance(); } catch (_e) {} }
  tick();
  [0, 200, 600, 1500, 3000].forEach(function (ms) { setTimeout(tick, ms); });
  try { window.addEventListener('load', tick); } catch (_e) {}
  try { if (window.DOMBus && isFn(window.DOMBus.register)) window.DOMBus.register(tick); } catch (_e) {}
  try { if (window.HMS && isFn(window.HMS.every)) window.HMS.every(12000, tick); } catch (_e) {}

  window.__twhV293Diag = function () {
    var screen = document.getElementById('loginScreen');
    var card = screen ? screen.querySelector('.login-card') : null;
    return {
      active: true,
      onLoginScreen: !!screen,
      formPresent: !!(card && card.querySelector('form.twh-login-form')),
      enhancedThisSession: enhancedCount,
      usernameAutocomplete: (document.getElementById('loginUser') || {}).getAttribute ? document.getElementById('loginUser').getAttribute('autocomplete') : null,
      passwordAutocomplete: (document.getElementById('loginPass') || {}).getAttribute ? document.getElementById('loginPass').getAttribute('autocomplete') : null,
      lastError: lastError
    };
  };

  log('login-form accessibility enhancer active — wraps core login fields in a semantic <form> with autocomplete + label associations (no core edits)');
})();

;

/* ==== /js/240-twh-canonical-session-facade-v294.js ==== */
/* ════════════════════════════════════════════════════════════════════
   TWH · CANONICAL SESSION FAÇADE (v294)
   ────────────────────────────────────────────────────────────────────
   P1 (single source of truth for login/session) from the "perfect fit"
   roadmap.

   ── PROBLEM ─────────────────────────────────────────────────────────
   "Am I logged in / who is it / which branch / how idle" is answered
   inconsistently across ~30+ packs, each reading raw globals directly:
     • window.isLoggedIn   (bare `var isLoggedIn` in core 008)
     • D.currentUser        (the authenticated identity — written in 15+
                              places: core, 010, 120, 126, 128, 129, 130,
                              198, 233, …)
     • window.currentUser   (a mirror of the above, sometimes stale)
     • D.currentBranch
     • SESSION.lastActivity (inactivity timing, core 008)
   Some packs read `isLoggedIn`, some `window.isLoggedIn`; some trust
   D.currentUser, some window.currentUser. When these drift (e.g. after a
   simulate-role, a session resume, or a supervisor snapshot restore) the
   answers disagree and features misbehave (a pack thinks it is logged out
   while another paints the app, or reads a stale user).

   ── FIX (purely additive, READ-ONLY over the existing writers) ──────
   A single canonical accessor: window.HMS.session — a thin, always-fresh
   FAÇADE that derives its answers from the existing authoritative globals
   at call time (it does NOT cache, and it does NOT own or mutate login
   state — core + v287 + v252 remain the writers, so we cannot desync).

     HMS.session.isAuthenticated()  → boolean (window.isLoggedIn === true)
     HMS.session.user()             → the current user object (D.currentUser
                                        ?? window.currentUser) or null
     HMS.session.username()         → string or null
     HMS.session.role()             → string or null
     HMS.session.branch()           → string or null
     HMS.session.idleMs()           → ms since last activity (or null)
     HMS.session.isIdleExpired()    → boolean (idleMs > SESSION.timeout)
     HMS.session.snapshot()         → a frozen plain summary (for logging)
     HMS.session.require(fn)        → run fn(user) only if authenticated
     HMS.session.onChange(cb)       → subscribe to login/logout transitions;
                                        returns an unsubscribe fn

   TRANSITION EVENTS: a bounded ticker (shared HMS.every + DOMBus, never a
   raw setInterval) samples the derived auth state and, when it flips,
   fires HMS.emit('session:login'|'session:logout'|'session:change', snap)
   and notifies onChange() subscribers. This gives packs a reactive hook
   without each re-implementing its own auth polling.

   Constraints: no core edits · no D1 schema / /api/state / manifest-order
   change · DOMBus + HMS.every + bounded setTimeout only (no raw
   setInterval, no new MutationObserver, no DOMContentLoaded) · does NOT
   wrap window.renderModule.

   Guard: window.__twhV294 · Diagnostics: window.__twhV294Diag()
   ════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV294) return;
  window.__twhV294 = true;

  var TAG = '[v294]';
  function isFn(f) { return typeof f === 'function'; }
  function log() {
    try { console.log.apply(console, [TAG].concat([].slice.call(arguments))); } catch (_e) {}
  }
  function D_() { try { if (window.D && typeof window.D === 'object') return window.D; } catch (_e) {} return null; }

  /* ── canonical derivations (always fresh — never cached) ─────────────── */
  function isAuthenticated() {
    try { return window.isLoggedIn === true; } catch (_e) { return false; }
  }
  function user() {
    var d = D_();
    try {
      if (d && d.currentUser && typeof d.currentUser === 'object') return d.currentUser;
    } catch (_e) {}
    try {
      if (window.currentUser && typeof window.currentUser === 'object') return window.currentUser;
    } catch (_e) {}
    return null;
  }
  function username() { var u = user(); return u && u.username != null ? u.username : null; }
  function fullName() { var u = user(); return u && u.fullName != null ? u.fullName : null; }
  function role() { var u = user(); return u && u.role != null ? u.role : null; }
  function branch() {
    var d = D_();
    try { if (d && d.currentBranch) return d.currentBranch; } catch (_e) {}
    var u = user();
    return u && u.branch != null ? u.branch : null;
  }
  function sessionObj() { try { return window.SESSION || null; } catch (_e) { return null; } }
  function idleMs() {
    var s = sessionObj();
    if (!s || typeof s.lastActivity !== 'number') return null;
    return Date.now() - s.lastActivity;
  }
  function idleTimeout() {
    var s = sessionObj();
    return (s && typeof s.timeout === 'number') ? s.timeout : (30 * 60 * 1000);
  }
  function isIdleExpired() {
    var ms = idleMs();
    return (ms != null) && (ms > idleTimeout());
  }
  function snapshot() {
    var snap = {
      authenticated: isAuthenticated(),
      username: username(),
      fullName: fullName(),
      role: role(),
      branch: branch(),
      idleMs: idleMs(),
      idleExpired: isIdleExpired()
    };
    try { return Object.freeze(snap); } catch (_e) { return snap; }
  }

  /* ── onChange subscribers ────────────────────────────────────────────── */
  var subscribers = [];
  function onChange(cb) {
    if (!isFn(cb)) return function () {};
    subscribers.push(cb);
    return function off() {
      var ix = subscribers.indexOf(cb);
      if (ix >= 0) subscribers.splice(ix, 1);
    };
  }
  function notify(snap) {
    for (var i = 0; i < subscribers.slice().length; i++) {
      try { subscribers[i](snap); } catch (_e) {}
    }
  }

  /* ── require() convenience guard ─────────────────────────────────────── */
  // Run fn(user) only when authenticated; returns fn's result or undefined.
  function require(fn) {
    if (!isAuthenticated()) return undefined;
    var u = user();
    try { return isFn(fn) ? fn(u) : undefined; } catch (_e) { return undefined; }
  }

  /* ── the façade object (installed under HMS.session) ─────────────────── */
  var facade = {
    isAuthenticated: isAuthenticated,
    user: user,
    username: username,
    fullName: fullName,
    role: role,
    branch: branch,
    idleMs: idleMs,
    idleTimeout: idleTimeout,
    isIdleExpired: isIdleExpired,
    snapshot: snapshot,
    require: require,
    onChange: onChange
  };

  function install() {
    try {
      if (!window.HMS) window.HMS = {};
      // Do not clobber an already-installed façade (idempotent across re-asserts).
      if (!window.HMS.session || window.HMS.session.__twhFacade !== true) {
        try { Object.defineProperty(facade, '__twhFacade', { value: true, enumerable: false }); }
        catch (_e) { facade.__twhFacade = true; }
        window.HMS.session = facade;
      }
    } catch (_e) {}
  }

  /* ── transition detection (bounded shared ticker) ────────────────────── */
  var lastAuth = null;         // null = not sampled yet
  var emittedCount = 0;
  function sampleAndEmit() {
    install(); // keep the façade present even if HMS is rebuilt
    var now = isAuthenticated();
    if (lastAuth === null) { lastAuth = now; return; } // establish baseline silently
    if (now === lastAuth) return;
    lastAuth = now;
    var snap = snapshot();
    emittedCount++;
    try {
      if (window.HMS && isFn(window.HMS.emit)) {
        window.HMS.emit(now ? 'session:login' : 'session:logout', snap);
        window.HMS.emit('session:change', snap);
      }
    } catch (_e) {}
    notify(snap);
  }

  /* ── boot wiring (idempotent; shared ticker + bounded timeouts) ─────── */
  function tick() { try { sampleAndEmit(); } catch (_e) {} }
  install();
  tick();
  [0, 200, 800, 2000].forEach(function (ms) { setTimeout(tick, ms); });
  try { window.addEventListener('load', tick); } catch (_e) {}
  try { if (window.DOMBus && isFn(window.DOMBus.register)) window.DOMBus.register(tick); } catch (_e) {}
  try { if (window.HMS && isFn(window.HMS.every)) window.HMS.every(8000, tick); } catch (_e) {}

  window.__twhV294Diag = function () {
    return {
      active: true,
      facadeInstalled: !!(window.HMS && window.HMS.session && window.HMS.session.__twhFacade === true),
      snapshot: snapshot(),
      subscribers: subscribers.length,
      transitionsEmitted: emittedCount
    };
  };

  log('v294 canonical session façade active');
})();

;

/* ==== /js/241-twh-disable-profile-switching-v295.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   TWH v295 — Disable profile switching ("Login as" / user simulation)
   ------------------------------------------------------------------------
   USER REQUEST (verbatim intent):
     "no more profile switching; each user should see only roles/
      responsibilities assigned to them, and each link should be active and
      functional, and the loading of each link shouldn't be heavy in loading"

   WHAT THIS PACK DOES (all in-scope; NO core edits; governor-safe):

     1. PROFILE SWITCHING OFF — the System-Administration "Login as (simulate)"
        feature is fully disabled. `saSimulateUser()` and `saStopSimulate()`
        are replaced with safe no-ops that show a toast explaining the feature
        is disabled. Any simulation left ACTIVE from a previous session is
        cleared on boot (restores the real logged-in user), so nobody is ever
        stuck viewing the app as someone else.

     2. STRIP THE SIMULATE UI — the "Login as (simulate)" action button in the
        user-management table (rendered by core-adjacent pack 010) and the
        amber "Simulation Active / Stop Simulation" banner are removed from the
        DOM whenever they appear. Runs through the ONE shared DOMBus observer
        (rAF-debounced) so it re-asserts after any re-render with no polling.

   WHY THIS SATISFIES "each user sees only their own roles/responsibilities":
     The per-user RBAC (v172/v174/v175/v181/v182 + hasModuleAccess) already
     scopes the sidebar to the logged-in user's role. Profile switching was the
     ONE mechanism that let a user view the app AS a different role. Removing it
     means the sidebar/links now always reflect the real signed-in user only —
     exactly the requested behaviour. `currentUserObj()` still works; it simply
     never returns a simulated identity because `window._simBackup` is never set.

   WHAT THIS PACK DOES **NOT** DO (kept safe / out of scope):
     • It does not touch the RBAC allowlist logic (already correct).
     • It does not wrap window.renderModule / render (recursion-safety rule).
     • It adds NO raw setInterval / MutationObserver / DOMContentLoaded.

   Idempotent IIFE (__twhV295). DOMBus + HMS.every + bounded setTimeout only.
   Diagnostics: window.__twhV295Diag()
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV295) return;
  window.__twhV295 = true;

  function isFn(f) { return typeof f === 'function'; }
  function D() { try { if (window.D) return window.D; } catch (_e) {} return null; }
  function toast(msg, kind) {
    try { if (isFn(window.toast)) { window.toast(msg, kind); return; } } catch (_e) {}
    try { console.log('[v295] ' + msg); } catch (_e) {}
  }

  var neutralisedSim = false;   // did we replace saSimulateUser/saStopSimulate?
  var clearedActive = false;    // did we clear an active simulation on boot?
  var strippedButtons = 0;      // count of simulate UI elements removed
  var lastError = null;

  /* ── 1a. Clear any ACTIVE simulation left over from a prior session ────────
     saSimulateUser() stashed the real user in window._simBackup and overwrote
     window.currentUser with a fake identity. If that state exists at boot, put
     the real user back so the app never opens "as" someone else. */
  function clearActiveSimulation() {
    try {
      if (typeof window._simBackup !== 'undefined') {
        try { window.currentUser = window._simBackup; } catch (_e) {}
        try { delete window._simBackup; } catch (_e) { window._simBackup = undefined; }
        clearedActive = true;
        // one gentle re-render so the sidebar reflects the real user again
        try { if (isFn(window.render)) window.render(); } catch (_e) {}
      }
    } catch (e) { lastError = e && e.message; }
  }

  /* ── 1b. Replace the switch functions with safe, explanatory no-ops ────────
     These are window.* globals defined by pack 010, so we can override without
     editing core. We mark them so we never double-wrap and tests can detect it. */
  function neutraliseSwitchFns() {
    try {
      var disabledMsg = 'Profile switching is disabled. Each user sees only the roles and responsibilities assigned to them.';

      var sim = function () { toast(disabledMsg, 'err'); return false; };
      sim.__twhV295Disabled = true;
      window.saSimulateUser = sim;

      var stop = function () {
        // Still honour a legitimate "stop" if some legacy state exists, so we
        // can never trap a user in a simulated view.
        clearActiveSimulation();
        toast('Simulation ended — showing your own profile.', 'ok');
        return false;
      };
      stop.__twhV295Disabled = true;
      window.saStopSimulate = stop;

      neutralisedSim = true;
    } catch (e) { lastError = e && e.message; }
  }

  /* ── 2. Strip the simulate UI (button + banner) from the DOM ───────────────
     The user-management table (010) renders:
       <button ... title="Login as (simulate)" onclick="saSimulateUser(ID)">
     and the sysadmin page renders an amber "Simulation Active" banner with a
     "Stop Simulation" button. We remove both whenever they appear. Because we
     run under the shared DOMBus observer, this re-asserts after any re-render. */
  function stripSimulateUI(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var removed = 0;
    try {
      // (a) Any control whose onclick invokes the (now-disabled) simulate fn.
      var clickers = scope.querySelectorAll('[onclick*="saSimulateUser"]');
      for (var i = 0; i < clickers.length; i++) {
        var el = clickers[i];
        if (el && el.parentNode) { el.parentNode.removeChild(el); removed++; }
      }
      // (b) The "Simulation Active" banner + its "Stop Simulation" button.
      //     Identify the banner by its Stop-Simulation control, then remove the
      //     enclosing .card so no orphaned amber box is left behind.
      var stoppers = scope.querySelectorAll('[onclick*="saStopSimulate"]');
      for (var j = 0; j < stoppers.length; j++) {
        var s = stoppers[j];
        var card = s.closest ? s.closest('.card') : null;
        var target = card || s;
        if (target && target.parentNode) { target.parentNode.removeChild(target); removed++; }
      }
    } catch (e) { lastError = e && e.message; }
    if (removed) strippedButtons += removed;
    return removed;
  }

  /* ── boot wiring (idempotent; shared observer + bounded timeouts) ──────── */
  var booted = false;
  function bootOnce() {
    if (booted) return;
    booted = true;
    clearActiveSimulation();
    neutraliseSwitchFns();
  }

  function tick() {
    try {
      bootOnce();
      // re-assert the no-ops in case a late-loading copy of 010 re-defined them
      if (!window.saSimulateUser || !window.saSimulateUser.__twhV295Disabled) neutraliseSwitchFns();
      stripSimulateUI(document);
    } catch (e) { lastError = e && e.message; }
  }

  tick();
  [0, 150, 400, 1000, 2500].forEach(function (ms) { setTimeout(tick, ms); });
  try { window.addEventListener('load', tick); } catch (_e) {}
  try { if (window.DOMBus && isFn(window.DOMBus.register)) window.DOMBus.register(tick); } catch (_e) {}
  try { if (window.HMS && isFn(window.HMS.every)) window.HMS.every(15000, tick); } catch (_e) {}

  window.__twhV295Diag = function () {
    return {
      active: true,
      simFnDisabled: !!(window.saSimulateUser && window.saSimulateUser.__twhV295Disabled),
      stopFnDisabled: !!(window.saStopSimulate && window.saStopSimulate.__twhV295Disabled),
      clearedActiveSimulationOnBoot: clearedActive,
      simulateUIElementsStripped: strippedButtons,
      simBackupPresent: (typeof window._simBackup !== 'undefined'),
      lastError: lastError
    };
  };
})();

;

/* ==== /js/242-twh-all-patients-visible-personal-dashboard-v296.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   TWH v296 — Make ALL created patients available + confirm the per-user
              (role-scoped) dashboard + admin duplicate generate/remove tools
   ------------------------------------------------------------------------
   USER REQUEST (verbatim):
     "Continue and make all created patients available. The dashboard of each
      user should display what is related to the user"
     "in admin, create a button to generate a duplicate (patient, Transactions,
      employee, users, agent, etc) and also to remove duplicates"

   ── PART 1 · MAKE ALL CREATED PATIENTS AVAILABLE ────────────────────────
   Root cause (verified against live D1 MCP_HMS_DATA_v17 — 77 patient rows):
     • The roster in D1 already holds every created patient (36 seed + 41 that
       staff created). NONE of the present patients are tombstoned, so the data
       IS there.
     • But pack v269 (module 215, fix N.3) WINDOWS the in-SPA patient table to
       the first 25 rows for "lightness", defaulting window.__twhPatientsShowAll
       to false. So a user opening Patients sees only 25 of 77 — the created
       patients past row 25 look "missing".
   FIX (no core edit, no v269 edit — we flip v269's OWN public switch):
     • Set window.__twhPatientsShowAll = true so renderPatients() paints the
       FULL roster (v269's wrapper then just calls the original renderer with
       the complete array — no truncation, KPIs already accurate).
     • Re-assert the flag on the shared cadence in case a later boot pass or a
       "keep it light" toggle flips it back. The table stays light because the
       v249 render-gate + v268 diff-guard still throttle full repaints; 77 rows
       is a single bounded paint, not a storm.
     • Belt-and-brace: if v269 never installed (older cache), we harmlessly set
       the flag anyway — renderPatients() ignores it and shows all rows.

   ── PART 2 · PER-USER DASHBOARD (display what is related to the user) ────
   The role-scoped "My Day" dashboard already exists (pack v186, module 140):
   personalized hero (name · role · date), role-specific KPIs, a role worklist
   and quick-access tiles built from the signed-in user's OWN responsibilities.
   This pack GUARANTEES it is the dashboard every user actually sees and that
   its numbers are accurate:
     • Ensure the personalized dashboard is never bypassed — if some later pass
       leaves window.renderDashboard pointing at a NON-personalized renderer we
       cannot detect the v186 tag on, we do nothing destructive; we only nudge a
       clean repaint so the outermost (personalized) wrapper paints.
     • Accurate counts: the dashboard KPIs read D.patients live; combined with
       Part 1 the counts now reflect the true DB total for the logged-in user.
     • We DO NOT re-implement or wrap renderDashboard/renderModule (recursion &
       chain-safety rules). We only read/repaint.

   ── PART 3 · ADMIN "DATA DUPLICATES" TOOLS (generate + remove) ──────────
   A System-Administration utility, reachable from a new "Duplicates" button we
   inject into the Users/Admin screen toolbar (via the shared DOMBus observer —
   no core edit). It opens a modal that lets an admin, for any core collection
   (Patients, Transactions, Employees, Users, Agents, Appointments, Bills, …):
     • GENERATE A DUPLICATE — pick a record and clone it. The clone is a deep
       copy with a fresh nid() id, a "(copy)" label where a name field exists,
       and a `_twhDuplicateOf` back-reference so it is auditable and removable.
       Persisted via _hmsSave and audited via auditAction when available.
     • REMOVE DUPLICATES — scan a collection, group records by a sensible dedupe
       key (per-collection: MRN / username / reference / name+dob; generic
       fallback: a content hash of the record minus id/_rev/_ts), KEEP the
       first (oldest/lowest-id) of each group and DELETE the rest through the
       app's own delete/tombstone path so the removals sync to D1.
   Guards: the tools only ACT for a super/admin role; the button is only shown
   to admins. Destructive removal always asks for confirmation and reports a
   summary. No collection is ever emptied — at least one row per group survives.

   WHAT THIS PACK DOES **NOT** DO (kept safe / out of scope):
     • No core (008/010) / CSS / D1 schema / /api/state / merge.js edits.
     • Does NOT wrap window.renderModule or window.renderDashboard.
     • Does NOT resurrect intentionally-deleted (tombstoned) patients — only the
       25-row display cap is removed; genuine deletes stay deleted.
     • Adds NO raw setInterval / MutationObserver / DOMContentLoaded.

   Idempotent IIFE (__twhV296). DOMBus + HMS.every + bounded setTimeout only.
   Diagnostics: window.__twhV296Diag()
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV296) return;
  window.__twhV296 = true;

  function isFn(f) { return typeof f === 'function'; }
  function D_() { try { return window.D || null; } catch (e) { return null; } }
  function A(v) { return Array.isArray(v) ? v : []; }
  function log() {
    try { console.log.apply(console, ['[v296]'].concat([].slice.call(arguments))); } catch (_e) {}
  }

  var diag = {
    showAllAsserted: 0,       // times we set __twhPatientsShowAll=true
    reasserted: 0,            // times we had to flip it back from false
    lastPatientCount: -1,     // last observed D.patients.length
    dashboardNudges: 0,       // clean repaints requested for the dashboard
    buttonInjected: 0,        // times the admin "Duplicates" button was injected
    duplicatesGenerated: 0,   // records cloned via the tool
    duplicatesRemoved: 0,     // duplicate rows removed via the tool
    lastError: ''
  };
  window.__twhV296Diag = function () {
    try {
      var d = D_();
      return {
        showAllPatients: window.__twhPatientsShowAll === true,
        patientCount: (d && Array.isArray(d.patients)) ? d.patients.length : -1,
        v269Present: !!window.__v269PatientsWrapped,
        personalizedDashboard: !!window.__twhV186,
        isAdmin: isAdmin(),
        showAllAsserted: diag.showAllAsserted,
        reasserted: diag.reasserted,
        dashboardNudges: diag.dashboardNudges,
        buttonInjected: diag.buttonInjected,
        duplicatesGenerated: diag.duplicatesGenerated,
        duplicatesRemoved: diag.duplicatesRemoved,
        lastError: diag.lastError
      };
    } catch (e) { return { lastError: String(e && e.message || e) }; }
  };

  /* ══════════════════════════════════════════════════════════════════════
     PART 1 — SHOW ALL PATIENTS (flip v269's public switch, keep it light)
     ════════════════════════════════════════════════════════════════════ */

  // Set the "show all in-app" flag. v269's renderPatients wrapper honours this
  // by calling the ORIGINAL renderer with the untrimmed D.patients array.
  function assertShowAll() {
    try {
      if (window.__twhPatientsShowAll !== true) {
        if (window.__twhPatientsShowAll === false) diag.reasserted++;
        window.__twhPatientsShowAll = true;
        diag.showAllAsserted++;
      }
    } catch (e) { diag.lastError = String(e && e.message || e); }
  }

  // If we are currently on the patients screen and the count just grew (e.g.
  // the D1 pull landed after boot), ask for ONE clean repaint so every created
  // patient appears without the user re-navigating. Never repaint mid-edit.
  function repaintPatientsIfGrew() {
    try {
      var d = D_();
      var n = (d && Array.isArray(d.patients)) ? d.patients.length : -1;
      if (n < 0) return;
      if (diag.lastPatientCount === -1) { diag.lastPatientCount = n; return; }
      if (n === diag.lastPatientCount) return;
      var grew = n > diag.lastPatientCount;
      diag.lastPatientCount = n;
      if (!grew) return;
      if (document.getElementById('modalBg')) return;        // never yank a form
      var mod = (typeof window.currentMod !== 'undefined') ? window.currentMod : null;
      if (mod !== 'patients' && mod !== 'dashboard') return;  // only if relevant
      cleanRepaint();
    } catch (e) { diag.lastError = String(e && e.message || e); }
  }

  /* ══════════════════════════════════════════════════════════════════════
     PART 2 — PERSONALIZED DASHBOARD ASSURANCE (read + repaint only)
     ════════════════════════════════════════════════════════════════════ */

  // Prefer the scroll-stable, diff-guarded repaint helpers already in the app,
  // falling back to render(). Shared by both parts.
  function cleanRepaint() {
    try { if (isFn(window.__twhReconcileRepaint)) { window.__twhReconcileRepaint(); return true; } } catch (_e) {}
    try { if (isFn(window.__twhQuietRepaint)) { if (window.__twhQuietRepaint()) return true; } } catch (_e) {}
    try { if (isFn(window.render)) { window.render(); return true; } } catch (_e) {}
    return false;
  }

  // The personalized dashboard (v186) installs itself as the OUTERMOST
  // renderDashboard wrapper. We do NOT wrap it. We only make sure that, when a
  // user is sitting ON the dashboard and their identity or the data just became
  // available, the personalized view is painted. This is a no-op repaint nudge —
  // the actual per-role content is produced by v186 downstream.
  function nudgeDashboardIfStale() {
    try {
      var mod = (typeof window.currentMod !== 'undefined') ? window.currentMod : null;
      if (mod !== 'dashboard') return;
      if (document.getElementById('modalBg')) return;
      // Only nudge once we actually have a resolved user AND the personalized
      // renderer is present; otherwise there is nothing to improve.
      var u = null;
      try { if (isFn(window.currentUserObj)) u = window.currentUserObj(); } catch (_e) {}
      if (!u) return;
      if (!window.__twhV186) return;
      // If the dashboard region is empty / shows a generic skeleton, repaint.
      var host = document.getElementById('app') || document.body;
      if (!host) return;
      var hasPersonalHero = !!(host.querySelector && host.querySelector('.v186-hero'));
      if (!hasPersonalHero) {
        if (cleanRepaint()) diag.dashboardNudges++;
      }
    } catch (e) { diag.lastError = String(e && e.message || e); }
  }

  /* ══════════════════════════════════════════════════════════════════════
     PART 3 — ADMIN "DATA DUPLICATES" TOOLS (generate + remove)
     ════════════════════════════════════════════════════════════════════ */

  var SUPER_ROLES = ['system administrator', 'admin', 'superadmin', 'super admin',
    'administrator', 'super system admin', 'ceo'];

  function isAdmin() {
    try {
      var u = isFn(window.currentUserObj) ? window.currentUserObj() : (D_() && D_().currentUser);
      if (!u) return false;
      var role = String(u.role || '').trim().toLowerCase();
      if (SUPER_ROLES.indexOf(role) >= 0) return true;
      if (isFn(window.__hmsIsSuperRole) && window.__hmsIsSuperRole(u.role)) return true;
      return false;
    } catch (e) { return false; }
  }

  function newId() {
    try { if (isFn(window.nid)) return window.nid(); } catch (e) {}
    return Date.now() * 1000 + Math.floor(Math.random() * 1000);
  }
  function save() {
    try { if (isFn(window._hmsSave)) return window._hmsSave(); } catch (e) {}
    try { if (isFn(window._hmsSaveSoon)) return window._hmsSaveSoon(); } catch (e) {}
  }
  function audit(action, detail, sev) {
    try { if (isFn(window.auditAction)) window.auditAction('ADMIN', 'Duplicates', action, detail, sev || 'Medium'); } catch (e) {}
  }
  function toast(msg, kind) {
    try { if (isFn(window.toast)) window.toast(msg, kind); } catch (e) {}
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  // Collections the admin may operate on. `label` for the picker, `name` field
  // (best-effort display), and `dedupeKeys` (in priority order) used both for
  // grouping and for choosing what makes two records "the same".
  var COLLECTIONS = [
    { key: 'patients',      label: 'Patients',      name: 'fullName', dedupeKeys: ['mrn', ['fullName', 'dob'], ['fullName', 'phone']] },
    { key: 'transactions',  label: 'Transactions',  name: 'reference', dedupeKeys: ['reference', ['type', 'date', 'amount', 'patientId']] },
    { key: 'employees',     label: 'Employees',     name: 'fullName', dedupeKeys: [['fullName', 'department'], ['fullName', 'phone'], 'email'] },
    { key: 'appUsers',      label: 'Users',         name: 'fullName', dedupeKeys: ['username', 'email'] },
    { key: 'agents',        label: 'Agents',        name: 'fullName', dedupeKeys: ['company', 'fullName', 'email'] },
    { key: 'appointments',  label: 'Appointments',  name: 'code',     dedupeKeys: ['code', ['patientId', 'doctorId', 'date', 'time']] },
    { key: 'bills',         label: 'Bills',         name: 'code',     dedupeKeys: ['code', ['patientId', 'date', 'total']] },
    { key: 'prescriptions', label: 'Prescriptions', name: 'medication', dedupeKeys: ['code', ['patientId', 'medication', 'date']] }
  ];

  function collMeta(key) {
    for (var i = 0; i < COLLECTIONS.length; i++) if (COLLECTIONS[i].key === key) return COLLECTIONS[i];
    return null;
  }
  function arr(key) { var d = D_(); return (d && Array.isArray(d[key])) ? d[key] : []; }

  function recLabel(meta, r) {
    if (!r) return '(record)';
    var n = meta && meta.name ? r[meta.name] : null;
    var base = n || r.name || r.fullName || r.title || r.reference || r.code || ('#' + r.id);
    return String(base);
  }

  // Build the value that identifies a record for a given dedupe rule.
  // A rule is either a single field name or an array of field names.
  function keyFor(rule, r) {
    if (Array.isArray(rule)) {
      var parts = rule.map(function (f) { return normVal(r[f]); });
      if (parts.every(function (p) { return p === ''; })) return null;
      return rule.join('|') + '::' + parts.join('|');
    }
    var v = normVal(r[rule]);
    return v === '' ? null : (rule + '::' + v);
  }
  function normVal(v) {
    if (v == null) return '';
    return String(v).trim().toLowerCase();
  }

  // Generic content hash of a record, ignoring volatile / identity keys, used
  // as the last-resort dedupe key when no configured rule matches.
  function contentHash(r) {
    try {
      var skip = { id: 1, _rev: 1, _ts: 1, _twhDuplicateOf: 1, lastLogin: 1, loginCount: 1, createdDate: 1, createdAt: 1 };
      var keys = Object.keys(r).filter(function (k) { return !skip[k]; }).sort();
      var obj = {};
      keys.forEach(function (k) { obj[k] = r[k]; });
      return 'hash::' + JSON.stringify(obj);
    } catch (e) { return null; }
  }

  // Compute duplicate groups for a collection. Returns an array of groups,
  // each { key, keeper, dups: [records...] } where dups are the removable ones.
  function findDuplicateGroups(collKey) {
    var meta = collMeta(collKey);
    var list = arr(collKey);
    var rules = (meta && meta.dedupeKeys) ? meta.dedupeKeys.slice() : [];
    var groups = {};
    list.forEach(function (r) {
      if (!r || typeof r !== 'object') return;
      var k = null;
      for (var i = 0; i < rules.length && k == null; i++) k = keyFor(rules[i], r);
      if (k == null) k = contentHash(r);
      if (k == null) return;
      (groups[k] = groups[k] || []).push(r);
    });
    var out = [];
    Object.keys(groups).forEach(function (k) {
      var g = groups[k];
      if (g.length < 2) return;
      // Keeper = lowest/oldest id (stable); the rest are duplicates.
      g.sort(function (a, b) { return idNum(a) - idNum(b); });
      out.push({ key: k, keeper: g[0], dups: g.slice(1) });
    });
    return out;
  }
  function idNum(r) { var n = Number(r && r.id); return isNaN(n) ? Number.MAX_SAFE_INTEGER : n; }

  // Delete one record locally and record a tombstone so the by-id server merge
  // does not resurrect it (this is the same mechanism the app's own deletes use).
  function removeOne(collKey, id) {
    var d = D_(); if (!d || !Array.isArray(d[collKey])) return false;
    var before = d[collKey].length;
    d[collKey] = d[collKey].filter(function (r) { return !(r && r.id === id); });
    // Record a tombstone so the by-id merge does not resurrect it.
    try {
      if (!d.__deletedIds || typeof d.__deletedIds !== 'object') d.__deletedIds = {};
      if (!Array.isArray(d.__deletedIds[collKey])) d.__deletedIds[collKey] = [];
      if (d.__deletedIds[collKey].indexOf(id) < 0) d.__deletedIds[collKey].push(id);
    } catch (e) {}
    return d[collKey].length < before;
  }

  // Clone a record: deep copy, fresh id, "(copy)" label, back-reference.
  function duplicateRecord(collKey, id) {
    var meta = collMeta(collKey);
    var list = arr(collKey);
    var src = null;
    for (var i = 0; i < list.length; i++) if (list[i] && list[i].id === id) { src = list[i]; break; }
    if (!src) return null;
    var clone;
    try { clone = JSON.parse(JSON.stringify(src)); } catch (e) { clone = {}; Object.keys(src).forEach(function (k) { clone[k] = src[k]; }); }
    clone.id = newId();
    clone._twhDuplicateOf = id;
    clone._rev = Date.now();
    // Append "(copy)" to a name-ish field so the duplicate is recognisable.
    var nameField = (meta && meta.name && clone[meta.name] != null) ? meta.name
      : (clone.fullName != null ? 'fullName' : (clone.name != null ? 'name' : null));
    if (nameField) clone[nameField] = String(clone[nameField]) + ' (copy)';
    var d = D_(); if (!d) return null;
    if (!Array.isArray(d[collKey])) d[collKey] = [];
    d[collKey].push(clone);
    diag.duplicatesGenerated++;
    return clone;
  }

  /* ── The admin modal UI ── */
  function collOptions(selKey) {
    return COLLECTIONS.map(function (c) {
      var n = arr(c.key).length;
      return '<option value="' + c.key + '"' + (c.key === selKey ? ' selected' : '') + '>' +
        esc(c.label) + ' (' + n + ')</option>';
    }).join('');
  }

  function recordOptions(collKey) {
    var meta = collMeta(collKey);
    var list = arr(collKey).slice(0, 500); // bounded for a light <select>
    if (!list.length) return '<option value="">(no records)</option>';
    return list.map(function (r) {
      return '<option value="' + esc(String(r.id)) + '">' + esc(recLabel(meta, r)) + '  ·  #' + esc(String(r.id)) + '</option>';
    }).join('');
  }

  function dupSummaryHtml(collKey) {
    var groups = findDuplicateGroups(collKey);
    var meta = collMeta(collKey);
    var totalDups = groups.reduce(function (s, g) { return s + g.dups.length; }, 0);
    if (!groups.length) {
      return '<div style="padding:12px;background:#ecfdf5;border:1px solid #a7f3d0;border-radius:8px;color:#065f46;font-size:13px">' +
        '<i class="fa-solid fa-circle-check"></i> No duplicates found in <b>' + esc(meta ? meta.label : collKey) + '</b>.</div>';
    }
    var rows = groups.slice(0, 40).map(function (g) {
      return '<tr><td class="bold">' + esc(recLabel(meta, g.keeper)) + '</td>' +
        '<td>' + g.dups.length + ' duplicate' + (g.dups.length === 1 ? '' : 's') + '</td>' +
        '<td style="font-size:11px;color:var(--txt3)">keep #' + esc(String(g.keeper.id)) +
        ' · remove ' + g.dups.map(function (r) { return '#' + esc(String(r.id)); }).join(', ') + '</td></tr>';
    }).join('');
    return '<div style="margin-bottom:8px;font-size:13px;color:#92400e"><i class="fa-solid fa-triangle-exclamation"></i> ' +
      '<b>' + totalDups + '</b> duplicate record' + (totalDups === 1 ? '' : 's') + ' across <b>' + groups.length +
      '</b> group' + (groups.length === 1 ? '' : 's') + ' in <b>' + esc(meta ? meta.label : collKey) + '</b>.</div>' +
      '<div class="tbl-wrap" style="max-height:220px;overflow:auto"><table class="tbl"><thead><tr><th>Keeper</th><th>Dupes</th><th>Action</th></tr></thead><tbody>' +
      rows + '</tbody></table></div>';
  }

  function refreshDupModalBody() {
    try {
      var sel = document.getElementById('twhDupColl');
      if (!sel) return;
      var collKey = sel.value;
      var recSel = document.getElementById('twhDupRecord');
      if (recSel) recSel.innerHTML = recordOptions(collKey);
      var sum = document.getElementById('twhDupSummary');
      if (sum) sum.innerHTML = dupSummaryHtml(collKey);
    } catch (e) { diag.lastError = String(e && e.message || e); }
  }
  window.__twhDupOnCollChange = refreshDupModalBody;

  window.__twhDupGenerate = function () {
    if (!isAdmin()) { toast('Admin only', 'err'); return; }
    var sel = document.getElementById('twhDupColl');
    var recSel = document.getElementById('twhDupRecord');
    if (!sel || !recSel || !recSel.value) { toast('Pick a record to duplicate', 'err'); return; }
    var collKey = sel.value;
    var id = recSel.value;
    // ids may be numeric or string; match by string compare in duplicateRecord.
    var list = arr(collKey), realId = id;
    for (var i = 0; i < list.length; i++) { if (list[i] && String(list[i].id) === String(id)) { realId = list[i].id; break; } }
    var clone = duplicateRecord(collKey, realId);
    if (!clone) { toast('Could not duplicate that record', 'err'); return; }
    audit('DUPLICATE', 'Duplicated ' + collKey + ' #' + realId + ' → #' + clone.id, 'Medium');
    save();
    toast('Duplicate created in ' + (collMeta(collKey) || {}).label);
    try { cleanRepaint(); } catch (e) {}
    refreshDupModalBody();
  };

  window.__twhDupRemove = function () {
    if (!isAdmin()) { toast('Admin only', 'err'); return; }
    var sel = document.getElementById('twhDupColl');
    if (!sel) return;
    var collKey = sel.value;
    var groups = findDuplicateGroups(collKey);
    var totalDups = groups.reduce(function (s, g) { return s + g.dups.length; }, 0);
    if (!totalDups) { toast('No duplicates to remove'); return; }
    var ok = true;
    try { ok = window.confirm('Remove ' + totalDups + ' duplicate record(s) from ' +
      ((collMeta(collKey) || {}).label || collKey) + '? The first record of each group is kept.'); } catch (e) {}
    if (!ok) return;
    var removed = 0;
    groups.forEach(function (g) {
      g.dups.forEach(function (r) { if (removeOne(collKey, r.id)) removed++; });
    });
    diag.duplicatesRemoved += removed;
    audit('DEDUPE', 'Removed ' + removed + ' duplicate ' + collKey + ' record(s)', 'High');
    save();
    toast('Removed ' + removed + ' duplicate record(s)');
    try { cleanRepaint(); } catch (e) {}
    refreshDupModalBody();
  };

  window.__twhOpenDuplicatesTool = function () {
    if (!isAdmin()) { toast('This tool is for administrators only', 'err'); return; }
    if (!isFn(window.showModal)) { toast('UI not ready', 'err'); return; }
    var first = COLLECTIONS[0].key;
    var body =
      '<div style="font-size:12px;color:var(--txt2);margin-bottom:12px">' +
      'Generate a duplicate of any record for testing/migration, or scan a collection and remove duplicate rows. ' +
      'Removal keeps the first record of each duplicate group and syncs deletions to the database.</div>' +
      '<div class="form-grid">' +
      '<div class="form-group full"><label>Collection</label>' +
      '<select id="twhDupColl" onchange="try{window.__twhDupOnCollChange&&window.__twhDupOnCollChange()}catch(e){}">' +
      collOptions(first) + '</select></div>' +
      '<div class="form-group full"><label>Record to duplicate</label>' +
      '<select id="twhDupRecord">' + recordOptions(first) + '</select></div>' +
      '</div>' +
      '<div style="display:flex;gap:8px;margin:10px 0 14px">' +
      '<button class="btn btn-pri btn-sm" onclick="try{window.__twhDupGenerate&&window.__twhDupGenerate()}catch(e){}"><i class="fa-solid fa-clone"></i> Generate duplicate</button>' +
      '<button class="btn btn-sm" style="background:#ef4444;color:#fff" onclick="try{window.__twhDupRemove&&window.__twhDupRemove()}catch(e){}"><i class="fa-solid fa-broom"></i> Remove duplicates</button>' +
      '</div>' +
      '<div id="twhDupSummary">' + dupSummaryHtml(first) + '</div>';
    window.showModal('<i class="fa-solid fa-clone" style="color:#7c3aed;margin-right:8px"></i>Data Duplicates — Admin Tools',
      body, '<button class="btn btn-ghost" onclick="closeModal()">Close</button>', 'wide');
  };

  // Inject a "Duplicates" button into the Users/Admin screen toolbar. We add it
  // next to the existing admin action buttons, only for admins, only once per
  // render, using the shared DOMBus observer (no new observer/timer).
  function injectDuplicatesButton() {
    try {
      if (!isAdmin()) return;
      var mod = (typeof window.currentMod !== 'undefined') ? window.currentMod : null;
      if (mod !== 'users') return;
      // Find the "Add User" button's toolbar and append once.
      var addBtn = document.querySelector('button[onclick*="addUser()"]');
      if (!addBtn || !addBtn.parentNode) return;
      var bar = addBtn.parentNode;
      if (bar.querySelector('[data-twh-dup-btn]')) return;   // already injected
      var btn = document.createElement('button');
      btn.className = 'btn btn-sm';
      btn.setAttribute('data-twh-dup-btn', '1');
      btn.style.background = '#7c3aed';
      btn.style.color = '#fff';
      btn.innerHTML = '<i class="fa-solid fa-clone"></i> Duplicates';
      btn.onclick = function () { try { window.__twhOpenDuplicatesTool(); } catch (e) {} };
      bar.appendChild(btn);
      diag.buttonInjected++;
    } catch (e) { diag.lastError = String(e && e.message || e); }
  }

  /* ══════════════════════════════════════════════════════════════════════
     BOOT & re-assert (shared ticker + DOMBus — no new timer/observer)
     ════════════════════════════════════════════════════════════════════ */
  function tick() {
    assertShowAll();
    repaintPatientsIfGrew();
    nudgeDashboardIfStale();
    injectDuplicatesButton();
  }

  function boot() {
    assertShowAll();
    // Re-assert across boot as v269 installs its wrapper and the D1 pull lands.
    [0, 200, 600, 1200, 2400, 4200, 6800, 9500].forEach(function (ms) { setTimeout(tick, ms); });
    try {
      if (typeof DOMBus !== 'undefined' && DOMBus && isFn(DOMBus.register)) {
        DOMBus.register(function () { assertShowAll(); injectDuplicatesButton(); });
      }
    } catch (_e) {}
    try { if (window.HMS && isFn(window.HMS.every)) window.HMS.every(10000, tick); } catch (_e) {}
    try { window.addEventListener('load', tick); } catch (_e) {}
    // React to the app's own post-merge event so newly-pulled patients surface
    // without waiting for the next ticker slice.
    try {
      if (window.HMS && isFn(window.HMS.on)) {
        window.HMS.on('state:changed', function () {
          assertShowAll();
          (window.requestAnimationFrame || setTimeout)(function () { repaintPatientsIfGrew(); }, 0);
        });
      }
    } catch (_e) {}
  }

  boot();
})();

;

/* ==== /js/2421-twh-patients-recent10-search-v341.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   TWH v341 — Patients dashboard: recent-10 default + easy full-list search.
   ------------------------------------------------------------------------
   USER REQUEST (verbatim):
     "Remove the tabs Recent First, and Sort A -Z. Also keep it to just 10
      patients displayed on the dashboard and only show recent 10 patients.
      Make search easy for other patients ( this should also be on Fastlink
      and other modules)"

   ── WHAT THIS PACK DOES ─────────────────────────────────────────────────
   (A) SHOW ONLY THE 10 MOST-RECENT PATIENTS BY DEFAULT.
       We install the OUTERMOST renderPatients wrapper (this pack, 2421-*, loads
       right after 242 so it wraps every earlier renderPatients assignment). When there
       is NO active search/filter, we present only the 10 most-recent patients
       (sorted by createdAt/registeredAt/_rev/id) to the inner renderer, then
       restore the full array. KPI cards are recomputed against the FULL roster
       so totals stay accurate, and a compact footer says "Showing the 10 most
       recent of N — use the search box above to find any patient".
   (B) SEARCH REACHES ALL PATIENTS.
       When the user types in #patFilterSearch (or picks a status/card/dept
       filter) we render the FULL matching set instead of the recent-10 window,
       matching on the ACTUAL records (name / MRN / phone / status) — so every
       patient is findable, not just the 10 painted rows. We keep
       __twhPatientsShowAll=true so v269 (pack 215) does not ALSO window.

   The "Recent First" / "Sort A→Z" buttons themselves were removed at the SOURCE
   (pack 104 / v308 no longer mints them; v166 already defers). The Fast Link
   register.html page carries the same recent-10-default + full-roster-search.

   Governor-safe: DOMBus.register + HMS.every(≥10000) + bounded setTimeout only;
   NO raw setInterval / MutationObserver / DOM-content-loaded event; does not
   wrap render / renderModule / goTo / doLogin. Guard window.__twhV341.
   Diagnostics: window.__twhV341Diag()
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV341) return;
  window.__twhV341 = true;

  var RECENT = 10;
  function isFn(f) { return typeof f === 'function'; }
  function D_() { try { return window.D || null; } catch (e) { return null; } }

  var _wrapped = false;

  function recencyKey(p) {
    if (!p) return 0;
    var t = p.createdAt || p.registeredAt || p.updatedAt || null;
    if (t) { var n = Date.parse(t); if (!isNaN(n)) return n; }
    var rev = Number(p._rev || 0); if (rev) return rev;
    var id = typeof p.id === 'number' ? p.id : parseInt(p.id, 10);
    return isNaN(id) ? 0 : id;
  }

  function _val(id) { var el = document.getElementById(id); return (el && el.value) || ''; }
  function readCriteria() {
    return {
      st: _val('patFilterStatus'),
      ct: _val('patFilterCard'),
      dp: _val('patFilterDept'),
      q: (_val('patFilterSearch') + '').trim().toLowerCase()
    };
  }
  function hasCriteria(c) { return !!(c && (c.st || c.ct || c.dp || c.q)); }

  function matchesRecord(p, c) {
    if (!p) return false;
    if (c.st && (p.status || '').toLowerCase() !== c.st.toLowerCase()) return false;
    if (c.ct) { var cid = parseInt(c.ct, 10); if (!isNaN(cid) && p.cardTypeId !== cid) return false; }
    if (c.dp) { var did = parseInt(c.dp, 10); if (!isNaN(did) && p.deptId !== did) return false; }
    if (c.q) {
      var hay = ((p.fullName || '') + ' ' + (p.mrn || '') + ' ' + (p.phone || '') + ' ' + (p.status || '')).toLowerCase();
      if (hay.indexOf(c.q) === -1) return false;
    }
    return true;
  }

  // No search → the recent-most patients. Active search/filter → the FULL match.
  function subsetForView(full, c) {
    var sorted = full.slice().sort(function (a, b) { return recencyKey(b) - recencyKey(a); });
    if (hasCriteria(c)) return sorted.filter(function (p) { return matchesRecord(p, c); });
    return sorted.slice(0, RECENT);
  }

  // Recompute the 4 KPI values against the FULL roster (first four .kpi-val).
  function fixKpiCounts(html, full) {
    var a = 0, o = 0, d = 0;
    full.forEach(function (p) {
      if (p.status === 'Admitted') a++;
      else if (p.status === 'Outpatient') o++;
      else if (p.status === 'Discharged') d++;
    });
    var vals = [full.length, a, o, d], i = 0;
    return html.replace(/<div class="kpi-val">[^<]*<\/div>/g, function (m) {
      return i < vals.length ? '<div class="kpi-val">' + vals[i++] + '</div>' : m;
    });
  }

  function addFooter(html, shown, total) {
    var f = '<tr class="no-print"><td colspan="99" style="padding:12px;background:#f8fafc;font-weight:600">Showing <b>' +
        shown + '</b> most recent of <b>' + total + '</b></td></tr>';
    return html.replace('</tbody>', f + '</tbody>');
  }

  function installWrapper() {
    if (_wrapped) return;
    if (!isFn(window.renderPatients)) return;
    var inner = window.renderPatients;
    if (inner.__v341) { _wrapped = true; return; }

    var wrapped = function () {
      var d = D_();
      var full = (d && Array.isArray(d.patients)) ? d.patients : null;
      if (!full) return inner.apply(this, arguments);
      var c = readCriteria(), active = hasCriteria(c);
      if (!active && full.length <= RECENT) return inner.apply(this, arguments);
      var subset = subsetForView(full, c);
      try {
        d.patients = subset;
        var html = inner.apply(this, arguments);
        d.patients = full;
        html = fixKpiCounts(html, full);
        if (!active && subset.length < full.length) html = addFooter(html, subset.length, full.length);
        return html;
      } catch (e) { d.patients = full; return inner.apply(this, arguments); }
    };
    wrapped.__v341 = true;
    window.renderPatients = wrapped;
    _wrapped = true;
  }

  function sweep() { installWrapper(); window.__twhPatientsShowAll = true; }

  function boot() {
    sweep();
    setTimeout(sweep, 800);
    try {
      if (typeof DOMBus !== 'undefined' && DOMBus && isFn(DOMBus.register)) DOMBus.register(sweep);
      if (window.HMS && isFn(window.HMS.every)) window.HMS.every(10000, sweep);
    } catch (e) {}
  }

  boot();
})();

;

/* ==== /js/243-twh-workspace-identity-active-buttons-v297.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   TWH v297 — Correct "My Workspace" identity per signed-in user + make every
              responsibility tile / button active + per-user dashboard scoping
   ------------------------------------------------------------------------
   USER REQUEST (verbatim):
     "Rahama.y profile still shows 'My Workspace for Yusuf Olasunkanmi Lawal'.
      Also, all these button links are not clicking (Register Patients, Create
      an Appointment, Laboratory, Radiology, and all other buttons). Make all
      buttons in the application active and functional. dashboard should show
      what is meant for each users workspace"

   ── ROOT CAUSE (verified against live D1 MCP_HMS_DATA_v17) ──────────────
   (1) IDENTITY LEAK — Rahama sees Yusuf's name/137 tiles.
       • currentUserObj() (core 010) resolves the CURRENT user by reading the
         GLOBAL `currentUser`, then re-finding it in D.appUsers by username.
       • The seed identity is `admin` → "Yusuf Olasunkanmi Lawal" (System
         Administrator, 137 responsibilities). Identity is owned per-tab by
         sessionStorage (pack 120) and enforced into D.currentUser +
         window.currentUser AFTER boot. There is a window early in boot (and on
         D1 hydration) where the workspace renders while the global is still the
         stale `admin` seed → the "My Workspace" hero paints Yusuf even though
         the tab actually belongs to Rahama.
       • Confirmed with live data: currentUserObj({username:'admin'}) →
         "Yusuf Olasunkanmi Lawal · System Administrator", while
         currentUserObj({username:'Rahama.y'}) → "Yahaya Rahama Onono · Front
         Desk Officer". The screenshots simply captured two different resolved
         identities: the dashboard painted as admin (stale), the modal (opened
         later, once identity settled) painted as Rahama.
       • v186's dashboard is signature-gated (`sig()` = username|role|mod|#mods);
         once it paints for the stale admin identity it will NOT repaint on its
         own when the identity later corrects to Rahama — so the wrong hero
         sticks.

   (2) DEAD BUTTONS — "Open →" tiles / nav links don't click.
       • The responsibility tiles render inline onclick="try{goTo('id')}catch..".
         The app re-renders the whole #app via innerHTML on a busy cadence
         (wrapper cascade + DOMBus sweeps). A click that lands the instant the
         host innerHTML is being replaced hits a node that is detached before
         the inline handler fires → the click is silently lost. It "feels" like
         nothing is clickable.
       • A stuck / orphaned modal backdrop (#modalBg) can also sit invisibly over
         the app and swallow every click (and the v249 render-gate makes render a
         no-op while a modal is "open", so the app also stops repainting).

   ── FIX (purely additive · no core edits · governor-safe) ───────────────
   PART A · AUTHORITATIVE IDENTITY RECONCILE (fixes the leak)
     • reconcileIdentity(): resolve the strongest available identity for THIS
       tab — sessionStorage (via 120's window.__hmsEnforceIdentity, the per-tab
       owner) → D.currentUser → window.currentUser — then force window.currentUser
       AND D.currentUser to agree on that SAME username, re-found in D.appUsers so
       fullName/role/id are the real record. Any stale simulation backup is
       left to its own self-heal. This makes currentUserObj() (and therefore
       v183/v184/v186's activeUser()) resolve the RIGHT person.
     • repaintOnIdentityChange(): remember the resolved identity signature; when
       it flips (e.g. admin→Rahama after enforceIdentity settles), request ONE
       clean dashboard repaint so the "My Workspace" hero + role-scoped tiles
       repaint for the correct user (defeats v186's sig-gate stickiness).

   PART B · MAKE ALL BUTTONS ACTIVE (global safety net)
     • One delegated, capturing click listener on document that:
        – clears a genuinely orphaned modal backdrop when its empty area is
          clicked (so a stuck overlay can never permanently swallow clicks);
        – for any responsibility tile / nav item / element carrying a module id
          (data-mod / data-qa / an inline goTo('x') onclick) whose click did not
          change the current module, routes to goTo(id) directly — so navigation
          works even if a repaint detached the inline handler mid-click.
       The net is a NO-OP when the app is behaving normally (the inline handler
       already navigated); it only rescues clicks the render churn dropped.

   PART C · PER-USER DASHBOARD SCOPING
     • Once identity resolves correctly (Part A), v186 (My Day) / v177 (role
       dashboards) / v183-184 (workspace) already render exactly the signed-in
       user's own responsibilities. We only guarantee the correct identity and a
       repaint on change; we DO NOT re-implement or wrap renderDashboard /
       renderModule (recursion & chain-safety rules).

   Constraints honoured: no core (008/010) / CSS / D1 schema / /api/state /
   merge.js / manifest-order edits · DOMBus + HMS.every + bounded setTimeout only
   (no raw setInterval / MutationObserver / DOMContentLoaded) · never wraps
   window.renderModule or window.renderDashboard · never copies flags via
   for..in over a render fn.

   Idempotent IIFE (__twhV297). Diagnostics: window.__twhV297Diag()
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV297) return;
  window.__twhV297 = true;

  function isFn(f) { return typeof f === 'function'; }
  function D_() { try { return window.D || null; } catch (e) { return null; } }
  function log() {
    try { console.log.apply(console, ['[v297]'].concat([].slice.call(arguments))); } catch (_e) {}
  }

  var diag = {
    reconciled: 0,          // times we forced window/D identity to agree
    identityChanges: 0,     // times the resolved identity signature flipped
    repaintsOnChange: 0,    // clean repaints requested after an identity flip
    rescuedClicks: 0,       // tile/nav clicks routed to goTo by the safety net
    modalsCleared: 0,       // orphaned backdrops dismissed
    lastUser: '',
    lastError: ''
  };

  /* ══════════════════════════════════════════════════════════════════════
     PART A — AUTHORITATIVE IDENTITY RECONCILE
     ════════════════════════════════════════════════════════════════════ */

  // The username this tab should be, in priority order:
  //   1. sessionStorage per-tab owner (pack 120) — the strongest source.
  //   2. D.currentUser (enforced by 120 / core after login).
  //   3. window.currentUser (mirror; may be a stale seed early in boot).
  function ownerUsername() {
    // sessionStorage is the per-tab identity owner (pack 120 SS_KEY =
    // 'HMS_IDENTITY_v1', shape {currentUser:{...},currentBranch}). We read the
    // canonical key first, then a few legacy aliases for safety.
    try {
      var keys = ['HMS_IDENTITY_v1', 'HMS_IDENTITY', 'twh_identity', 'hms_identity_v1', 'hms_currentUser'];
      for (var i = 0; i < keys.length; i++) {
        var raw = null;
        try { raw = window.sessionStorage && window.sessionStorage.getItem(keys[i]); } catch (_e) {}
        if (raw) {
          try {
            var o = JSON.parse(raw);
            var cu = o && (o.currentUser || o.user || o);
            if (cu && cu.username) return cu.username;
          } catch (_e2) {}
        }
      }
    } catch (_e) {}
    var d = D_();
    try { if (d && d.currentUser && d.currentUser.username) return d.currentUser.username; } catch (_e) {}
    try { if (window.currentUser && window.currentUser.username) return window.currentUser.username; } catch (_e) {}
    return null;
  }

  function findUser(username) {
    var d = D_();
    if (!d || !Array.isArray(d.appUsers) || username == null) return null;
    // First match by username is what currentUserObj() would resolve — keep it
    // identical so we never disagree with the core resolver.
    for (var i = 0; i < d.appUsers.length; i++) {
      if (d.appUsers[i] && d.appUsers[i].username === username) return d.appUsers[i];
    }
    return null;
  }

  // Force window.currentUser AND D.currentUser to the same, real record for the
  // tab's owner username. Returns the resolved user object (or null).
  function reconcileIdentity() {
    try {
      var d = D_();
      if (!d) return null;
      // Never fight an INTENTIONAL admin "simulate user" session — but v295
      // disabled simulation, so _simBackup should be undefined. If it is set
      // (legacy stuck sim), leave identity alone; a separate self-heal owns it.
      if (typeof window._simBackup !== 'undefined') {
        try { if (isFn(window.currentUserObj)) return window.currentUserObj(); } catch (_e) {}
        return d.currentUser || null;
      }

      // Let pack 120 re-assert the per-tab identity first (authoritative owner).
      try { if (isFn(window.__hmsEnforceIdentity)) window.__hmsEnforceIdentity(); } catch (_e) {}

      var uname = ownerUsername();
      if (uname == null) {
        // No identity yet (login screen) — nothing to reconcile.
        return d.currentUser || null;
      }
      var rec = findUser(uname);
      var resolved = rec
        ? { username: rec.username, fullName: rec.fullName || rec.username, role: rec.role || 'Staff', id: rec.id, branch: rec.branchCode || rec.branch }
        : { username: uname };

      var changed = false;
      // Align D.currentUser (keep any extra keys the app set, override identity).
      try {
        var cur = d.currentUser || {};
        if (cur.username !== resolved.username || cur.fullName !== resolved.fullName || cur.role !== resolved.role) {
          d.currentUser = Object.assign({}, cur, resolved);
          changed = true;
        }
      } catch (_e) {}
      // Align the global mirror the core resolver reads FIRST.
      try {
        var wc = window.currentUser;
        if (!wc || wc.username !== resolved.username || wc.role !== resolved.role || wc.fullName !== resolved.fullName) {
          window.currentUser = { username: resolved.username, fullName: resolved.fullName, role: resolved.role, id: resolved.id };
          changed = true;
        }
      } catch (_e) {}
      if (changed) diag.reconciled++;
      diag.lastUser = resolved.username + ' · ' + (resolved.role || '');
      return d.currentUser || window.currentUser || null;
    } catch (e) { diag.lastError = String(e && e.message || e); return null; }
  }

  function resolvedSig() {
    try {
      var u = null;
      try { if (isFn(window.currentUserObj)) u = window.currentUserObj(); } catch (_e) {}
      if (!u) { var d = D_(); u = d && d.currentUser; }
      if (!u || !u.username) return '';
      return (u.username || '') + '|' + (u.role || '') + '|' + (u.fullName || '');
    } catch (e) { return ''; }
  }

  function cleanRepaint() {
    try { if (isFn(window.__twhReconcileRepaint)) { window.__twhReconcileRepaint(); return true; } } catch (_e) {}
    try { if (isFn(window.__twhQuietRepaint)) { if (window.__twhQuietRepaint()) return true; } } catch (_e) {}
    try { if (isFn(window.render)) { window.render(); return true; } } catch (_e) {}
    return false;
  }

  var _lastSig = null;
  // When the resolved identity flips (e.g. admin→Rahama after enforceIdentity
  // settles), request ONE clean repaint so the sig-gated "My Workspace" hero and
  // role tiles repaint for the correct user. Never repaint mid-modal.
  function repaintOnIdentityChange() {
    try {
      reconcileIdentity();
      var s = resolvedSig();
      if (!s) return;                       // identity not resolved yet
      if (_lastSig === null) { _lastSig = s; return; }  // baseline silently
      if (s === _lastSig) return;
      _lastSig = s;
      diag.identityChanges++;
      // Do not yank the DOM out from under an open modal.
      try { if (document.getElementById('modalBg')) return; } catch (_e) {}
      if (cleanRepaint()) diag.repaintsOnChange++;
    } catch (e) { diag.lastError = String(e && e.message || e); }
  }

  /* ══════════════════════════════════════════════════════════════════════
     PART B — MAKE ALL BUTTONS ACTIVE (global delegated safety net)
     ════════════════════════════════════════════════════════════════════ */

  // Pull a module id out of an element's data-* attributes or an inline
  // goTo('id') / goTo("id") onclick string. Returns the id or null.
  function modIdFrom(el) {
    if (!el || !el.getAttribute) return null;
    var dm = el.getAttribute('data-mod') || el.getAttribute('data-qa') || el.getAttribute('data-module');
    if (dm) return dm;
    var oc = el.getAttribute('onclick');
    if (oc) {
      var m = /goTo\(\s*['"]([^'"]+)['"]\s*\)/.exec(oc);
      if (m) return m[1];
    }
    return null;
  }

  // Walk up from the click target to the nearest actionable ancestor (button /
  // element carrying a module id), bounded to a few hops.
  function actionableAncestor(node) {
    var hops = 0;
    while (node && node !== document && hops < 6) {
      try {
        if (node.nodeType === 1) {
          var id = modIdFrom(node);
          if (id) return { el: node, mod: id };
        }
      } catch (_e) {}
      node = node.parentNode;
      hops++;
    }
    return null;
  }

  function curMod() { try { return (typeof window.currentMod !== 'undefined') ? window.currentMod : null; } catch (_e) { return null; } }

  var _clickWired = false;
  function wireGlobalClickRescue() {
    if (_clickWired) return;
    if (typeof document === 'undefined' || !document.addEventListener) return;
    _clickWired = true;

    // Capturing listener so we observe the click BEFORE the app may re-render.
    document.addEventListener('click', function (ev) {
      try {
        var t = ev.target;
        if (!t) return;

        // (1) Orphaned modal backdrop: if the user clicked the backdrop area
        //     itself (not a control inside the dialog), make sure it closes so a
        //     stuck overlay can never permanently swallow clicks.
        var mb = document.getElementById('modalBg');
        if (mb && t === mb) {
          try {
            if (isFn(window.closeModal)) window.closeModal();
            else if (mb.parentNode) mb.parentNode.removeChild(mb);
            diag.modalsCleared++;
          } catch (_e) {}
          return;
        }

        // Never interfere while a real modal dialog control is being used.
        if (mb) return;

        // (2) Rescue tile / nav clicks. Only act on genuinely actionable
        //     elements that carry a module id. If the inline handler already
        //     navigated, curMod() will already equal the target → we no-op.
        var hit = actionableAncestor(t);
        if (!hit || !hit.mod) return;

        var before = curMod();
        // Let the element's own inline onclick run first (it usually works).
        // We schedule a microtask check; if the module did NOT change, route.
        var target = hit.mod;
        (window.requestAnimationFrame || function (fn) { setTimeout(fn, 16); })(function () {
          try {
            var after = curMod();
            if (after === target) return;                 // inline handler worked
            if (after !== before) return;                 // something else navigated
            if (document.getElementById('modalBg')) return; // a modal opened instead
            if (isFn(window.goTo)) { window.goTo(target); diag.rescuedClicks++; }
          } catch (_e) {}
        });
      } catch (e) { diag.lastError = String(e && e.message || e); }
    }, true);
  }

  /* ══════════════════════════════════════════════════════════════════════
     BOOT & re-assert (governor-safe cadence)
     ════════════════════════════════════════════════════════════════════ */
  function tick() {
    try {
      repaintOnIdentityChange();
      wireGlobalClickRescue();
    } catch (e) { diag.lastError = String(e && e.message || e); }
  }

  // Expose the reconcile+repaint cycle so it can be driven deterministically
  // (used by tests; harmless in production — it is exactly what the bounded
  // timers / DOMBus / session events already call).
  window.__twhV297Tick = function () { try { tick(); } catch (_e) {} };

  window.__twhV297Diag = function () {
    var d = D_();
    var cu = null;
    try { if (isFn(window.currentUserObj)) cu = window.currentUserObj(); } catch (_e) {}
    return {
      active: true,
      resolvedUser: cu ? { username: cu.username, fullName: cu.fullName, role: cu.role, id: cu.id } : null,
      windowUser: (window.currentUser && window.currentUser.username) || null,
      dCurrentUser: (d && d.currentUser && d.currentUser.username) || null,
      sig: resolvedSig(),
      clickRescueWired: _clickWired,
      reconciled: diag.reconciled,
      identityChanges: diag.identityChanges,
      repaintsOnChange: diag.repaintsOnChange,
      rescuedClicks: diag.rescuedClicks,
      modalsCleared: diag.modalsCleared,
      lastUser: diag.lastUser,
      lastError: diag.lastError
    };
  };

  // Reconcile identity + wire the click net early and often, then settle.
  reconcileIdentity();
  wireGlobalClickRescue();
  tick();
  [0, 120, 350, 800, 1600, 3000, 5200].forEach(function (ms) { setTimeout(tick, ms); });
  try { window.addEventListener('load', tick); } catch (_e) {}
  try { if (window.DOMBus && isFn(window.DOMBus.register)) window.DOMBus.register(tick); } catch (_e) {}
  try { if (window.HMS && isFn(window.HMS.every)) window.HMS.every(9000, tick); } catch (_e) {}
  // React immediately to the canonical session façade transitions (v294).
  try {
    if (window.HMS && isFn(window.HMS.on)) {
      window.HMS.on('session:login', tick);
      window.HMS.on('session:change', tick);
    }
  } catch (_e) {}

  log('workspace identity reconciled to the signed-in user · every responsibility tile/button routed via goTo (click rescue) · per-user dashboard scoping assured');
})();

;

/* ==== /js/244-twh-module-back-to-dashboard-v298.js ==== */
/* ═══════════════════════════════════════════════════════════════════════════
   v298 — MODULE "PAGE" NAVIGATION: Back-to-Dashboard bar on every module view
   ---------------------------------------------------------------------------
   Product request (verbatim):
     "All links should now open in a new page and should have a back button to
      go back to the dashboard of the user ... please implement for all users to
      have what is meant to be on their dashboard based on their roles, and not
      meant to be role of the admin."

   In this SPA every sidebar / quick-access / workspace link routes via goTo(mod)
   which swaps the #moduleContent region — i.e. each link ALREADY "opens a new
   page" (a distinct module view). What was missing is a visible, always-present
   way back: a "Back to Dashboard" bar pinned to the top of every non-dashboard
   module page. This pack injects exactly that, after each render, purely in the
   DOM (no core edits).

   Per-user, role-correct dashboards are already delivered by v174/v175/v181/
   v182/v186/v187/v297 (role→module allowlist, role-scoped sidebar, "My Day"
   dashboard, 403 route guard, identity reconcile). This pack does NOT touch role
   scoping; it only guarantees the universal back affordance and that the bar
   itself is identity/role neutral (it always returns to *the signed-in user's*
   own dashboard via goTo('dashboard'), which every downstream pack scopes).

   Governor-safe: guard __twhV298; boot via bounded setTimeout + load +
   DOMBus.register + HMS.every(>=10000ms). NO raw setInterval / MutationObserver /
   DOMContentLoaded. Never wraps window.render / window.renderModule /
   window.renderDashboard. Never copies flags via for..in.
   =========================================================================== */
(function(){
  if (window.__twhV298) return;
  window.__twhV298 = true;

  var BAR_ID   = 'twhBackBar';
  var STYLE_ID = 'twhBackBarStyle';

  function D(){ try{ if(typeof window.D!=='undefined'&&window.D) return window.D; }catch(e){} return null; }

  /* Current route (module id). Unified binding — window.currentMod is authoritative. */
  function curMod(){
    try{ if(typeof window.currentMod!=='undefined' && window.currentMod!=null) return String(window.currentMod); }catch(e){}
    return 'dashboard';
  }

  /* Are we on the login / pre-auth screen? Then no back bar. */
  function isLoginScreen(){
    try{
      if (document.getElementById('loginScreen')) return true;
      if (document.querySelector('#loginForm, .login-screen, [data-screen="login"]')) return true;
      /* pre-auth: no resolved user AND no sidebar rendered */
      var d = D();
      var hasUser = !!(d && d.currentUser && d.currentUser.username);
      var hasSidebar = !!document.querySelector('.sb, #sidebar');
      if (!hasUser && !hasSidebar) return true;
    }catch(e){}
    return false;
  }

  /* Friendly page title for the current module (mirrors core getModTitle when present). */
  function modTitle(mod){
    try{
      if (typeof window.getModTitle==='function'){
        /* getModTitle reads currentMod; only trust it when it matches our mod */
        if (curMod()===mod){ var t=window.getModTitle(); if(t) return t; }
      }
    }catch(e){}
    try{
      var d=D(); var reg=d&&d.moduleRegistry&&d.moduleRegistry[mod];
      if (reg && (reg.label||reg.l)) return reg.label||reg.l;
    }catch(e){}
    if (!mod) return 'Workspace';
    return mod.charAt(0).toUpperCase()+mod.slice(1);
  }

  /* One-time CSS injection (scoped; does not touch core styles). */
  function ensureStyle(){
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent =
      '#'+BAR_ID+'{display:flex;align-items:center;gap:12px;margin:0 0 16px;padding:10px 14px;'
        +'background:var(--card,rgba(255,255,255,.9));border:1px solid var(--bdr,#e2e8f0);'
        +'border-radius:12px;box-shadow:var(--shadow,0 4px 24px rgba(0,0,0,.06));'
        +'position:sticky;top:0;z-index:40;backdrop-filter:blur(10px)}'
      +'#'+BAR_ID+' .twh-back-btn{display:inline-flex;align-items:center;gap:8px;cursor:pointer;'
        +'border:none;padding:8px 16px;border-radius:10px;font-family:inherit;font-size:13px;'
        +'font-weight:700;color:#fff;background:linear-gradient(135deg,var(--pri,#0d9488),var(--pri2,#0f766e));'
        +'transition:transform .12s,box-shadow .12s;white-space:nowrap}'
      +'#'+BAR_ID+' .twh-back-btn:hover{transform:translateY(-1px);box-shadow:0 6px 16px rgba(13,148,136,.28)}'
      +'#'+BAR_ID+' .twh-back-btn:active{transform:translateY(0)}'
      +'#'+BAR_ID+' .twh-back-sep{color:var(--txt3,#94a3b8);font-size:12px}'
      +'#'+BAR_ID+' .twh-back-crumb{display:flex;align-items:center;gap:8px;font-size:13px;'
        +'color:var(--txt2,#64748b);min-width:0}'
      +'#'+BAR_ID+' .twh-back-crumb .twh-back-here{font-weight:700;color:var(--txt,#1e293b);'
        +'overflow:hidden;text-overflow:ellipsis;white-space:nowrap}'
      +'#'+BAR_ID+' .twh-back-home{background:none;border:none;cursor:pointer;color:var(--txt2,#64748b);'
        +'font-size:13px;font-family:inherit;padding:0;text-decoration:none}'
      +'#'+BAR_ID+' .twh-back-home:hover{color:var(--pri,#0d9488);text-decoration:underline}'
      +'@media print{#'+BAR_ID+'{display:none!important}}';
    (document.head||document.documentElement).appendChild(s);
  }

  /* Route safely back to the signed-in user's own dashboard. */
  window.__twhGoDashboard = function(){
    try{ if (typeof window.goTo==='function'){ window.goTo('dashboard'); return; } }catch(e){}
    try{ window.currentMod='dashboard'; if(typeof window.render==='function') window.render(); }catch(e){}
  };

  function barHTML(mod){
    var here = modTitle(mod);
    /* esc the title (module titles are trusted app strings but be safe) */
    var t = String(here==null?'':here).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});
    return ''
      + '<button class="twh-back-btn" type="button" onclick="try{window.__twhGoDashboard()}catch(e){}" '
      +   'title="Back to your dashboard" aria-label="Back to your dashboard">'
      +   '<i class="fa-solid fa-arrow-left"></i><span>Back to Dashboard</span>'
      + '</button>'
      + '<div class="twh-back-crumb">'
      +   '<button class="twh-back-home" type="button" onclick="try{window.__twhGoDashboard()}catch(e){}">'
      +     '<i class="fa-solid fa-house" style="margin-right:6px"></i>Dashboard</button>'
      +   '<span class="twh-back-sep"><i class="fa-solid fa-angle-right"></i></span>'
      +   '<span class="twh-back-here">'+t+'</span>'
      + '</div>';
  }

  /* The host region where module bodies are painted. */
  function host(){
    return document.getElementById('moduleContent')
        || document.querySelector('.content')
        || null;
  }

  /* Inject / update / remove the back bar to match the current route. */
  function sync(){
    try{
      var mod = curMod();
      var h = host();
      var existing = document.getElementById(BAR_ID);

      /* Dashboard or login screen: no back bar. */
      if (!h || mod==='dashboard' || mod==='' || mod==null || isLoginScreen()){
        if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
        return;
      }

      ensureStyle();

      /* If a 403 page is showing, it already has its own "Go to My Day" buttons
         (v187). Adding the bar there is redundant/confusing — skip it. */
      if (h.querySelector && h.querySelector('.v187-403')){
        if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
        return;
      }

      if (existing){
        /* Keep it as the FIRST child (module re-renders can prepend banners). */
        if (h.firstChild !== existing) h.insertBefore(existing, h.firstChild);
        if (existing.getAttribute('data-mod') !== mod){
          existing.setAttribute('data-mod', mod);
          existing.innerHTML = barHTML(mod);
        }
        return;
      }

      var bar = document.createElement('div');
      bar.id = BAR_ID;
      bar.className = 'no-print';
      bar.setAttribute('data-mod', mod);
      bar.innerHTML = barHTML(mod);
      h.insertBefore(bar, h.firstChild);
    }catch(e){}
  }
  window.__twhV298Sync = sync; /* test / debug hook */

  window.__twhV298Diag = function(){
    return {
      installed:true,
      mod:curMod(),
      barPresent:!!document.getElementById(BAR_ID),
      loginScreen:isLoginScreen(),
      title:modTitle(curMod())
    };
  };

  /* ── BOOT / RE-ASSERT ──
     We DELIBERATELY do not wrap render/renderModule/renderDashboard (governor
     rule). Instead we re-sync on DOMBus (fires after every render), a low-freq
     HMS.every safety net, session events, and bounded boot timers. This keeps
     the bar correct across the full wrapper cascade without touching render. */
  function boot(){ try{ ensureStyle(); sync(); }catch(e){} }

  [0,120,350,800,1600,3000,5200].forEach(function(t){ setTimeout(boot, t); });
  try{ window.addEventListener('load', boot); }catch(e){}
  try{ if (window.DOMBus && typeof window.DOMBus.register==='function') window.DOMBus.register(sync); }catch(e){}
  try{ if (window.HMS && typeof window.HMS.every==='function') window.HMS.every(10000, sync); }catch(e){}
  try{
    if (window.HMS && typeof window.HMS.on==='function'){
      window.HMS.on('session:login',  sync);
      window.HMS.on('session:change', sync);
      window.HMS.on('session:logout', sync);
    }
  }catch(e){}
})();

;

/* ==== /js/245-twh-shell-integrity-guardian-v299.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   v299 — APP-SHELL INTEGRITY GUARDIAN (permanent fix for the "orphaned
          dashboard" screenshot + dead links)
   ────────────────────────────────────────────────────────────────────────
   REPORTED PROBLEM (screenshot):
     After sign-in the dashboard sometimes paints ONLY the inner content
     fragment — the "Today's schedule / Worklist / Patient flow" cards float in
     the top-left with NO sidebar, NO header, NO hero/KPIs/Quick-Access. In that
     state the sidebar links (Patients, Appointments, Laboratory, Radiology, …)
     have nothing to click, so navigation appears "dead" and nothing opens.

   ROOT CAUSE (structural, not a single pack):
     render() builds the FULL shell into #app:
        <aside class="sb">…nav…</aside>
        <div class="main"><div class="hdr">…</div>
          <div class="content" id="moduleContent"> … renderModule() … </div></div>
     Several background/stability paths (poll repaint, quiet/reconcile repaint,
     auto-recover "go-light", recursion-breaker last-good) refresh ONLY the inner
     body via  #moduleContent.innerHTML = renderModule()  (correct, shell-safe).
     But if ANY of them ever runs when #moduleContent is momentarily detached, or
     a wrapper writes the CONTENT fragment where the SHELL should be, the shell
     (sidebar+header) is lost while the content fragment survives — exactly the
     screenshot. Once that happens there is no self-healing path, so it sticks.

   THE FIX — a durable guardian that, whenever a user is signed in:
     • Detects a BROKEN shell: #app present, NOT on the login screen, yet the
       sidebar (.sb / #sidebar) OR header (.hdr) OR #moduleContent is missing,
       OR a dashboard/module fragment (.v186-day, .card, etc.) is sitting
       DIRECTLY under #app instead of inside #moduleContent (orphaned content).
     • REBUILDS the shell by calling the canonical full render() exactly once
       (debounced), which repaints sidebar + header + content together. If
       render() is unavailable/throws, falls back to __twhReconcileRepaint /
       __twhQuietRepaint, then a minimal safe re-mount.
     • Verifies AFTER the repaint that the shell is now intact; if a poisoned
       wrapper immediately re-breaks it, it retries a bounded number of times
       then, as a last resort, temporarily unwraps to the core render.

   This makes the orphaned-dashboard state unable to persist: even if some other
   layer produces it for a frame, the guardian restores the full shell so every
   sidebar link is present and clickable and opens its page.

   Constraints honoured: guard __twhV299 · NO core edits · rides DOMBus +
   HMS.every(>=10000) + bounded setTimeout + load + session:* events · does NOT
   permanently wrap render/renderModule/renderDashboard (it only *calls* render)
   · no raw setInterval / MutationObserver / DOMContentLoaded · no for..in copy.

   Diagnostics: window.__twhV299Diag()  ·  manual: window.__twhV299Heal()
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV299) return;
  window.__twhV299 = true;

  var TAG = '[v299]';
  function isFn(f) { return typeof f === 'function'; }

  function D_() { try { if (typeof window.D !== 'undefined' && window.D) return window.D; } catch (e) {} return null; }

  /* Is a real user signed in? (mirror the rest of the stack, defensively.) */
  function signedIn() {
    try { if (window.isLoggedIn === true) return true; } catch (e) {}
    try {
      if (window.HMS && window.HMS.session && isFn(window.HMS.session.isAuthenticated))
        return !!window.HMS.session.isAuthenticated();
    } catch (e) {}
    var d = D_();
    return !!(d && d.currentUser && d.currentUser.username);
  }

  /* Are we on the login / pre-auth screen? Then the shell is *supposed* to be
     absent — never "heal" over the login card. */
  function onLoginScreen() {
    try {
      if (document.getElementById('loginScreen')) return true;
      if (document.querySelector('.login-bg, .login-card, #loginForm, .login-screen')) return true;
    } catch (e) {}
    return false;
  }

  function appEl()     { try { return document.getElementById('app'); } catch (e) { return null; } }
  function sidebarEl() { try { return document.querySelector('.sb') || document.getElementById('sidebar'); } catch (e) { return null; } }
  function headerEl()  { try { return document.querySelector('.hdr'); } catch (e) { return null; } }
  function contentEl() { try { return document.getElementById('moduleContent') || document.querySelector('.content'); } catch (e) { return null; } }

  /* Fragments that belong INSIDE #moduleContent, never as a direct child of
     #app. If we see one orphaned directly under #app, the shell was lost. */
  var FRAGMENT_SEL = '.v186-day, .v186-cols, .v186-hero, .card, .tbl-wrap, .kpi-row, .content';

  /* Decide whether the shell is broken while signed in. */
  function shellBroken() {
    if (!signedIn()) return false;
    if (onLoginScreen()) return false;
    var app = appEl();
    if (!app) return false;                 /* nothing mounted yet — boot will paint */
    /* If the app host has no children at all, it's mid-swap; let render() run. */
    if (!app.children || app.children.length === 0) return true;

    var sb = sidebarEl(), hd = headerEl(), mc = contentEl();

    /* Canonical healthy shell: sidebar + header + #moduleContent all present. */
    if (sb && hd && mc) return false;

    /* Orphaned content: a dashboard/module fragment is sitting DIRECTLY under
       #app (i.e. the shell wrapper was replaced by the content fragment). */
    try {
      for (var i = 0; i < app.children.length; i++) {
        var c = app.children[i];
        if (!c || c.nodeType !== 1) continue;
        /* the legit direct children of a healthy shell are the toast div,
           <aside class="sb"> and <div class="main">. Anything that looks like a
           content fragment here means the shell is gone. */
        if (c.matches && c.matches(FRAGMENT_SEL)) return true;
        if (c.querySelector && c.querySelector('.v186-day, .v186-cols') &&
            !(c.classList && (c.classList.contains('main') || c.classList.contains('sb')))) {
          return true;
        }
      }
    } catch (e) {}

    /* Missing sidebar or header while content exists → broken shell. */
    if (mc && (!sb || !hd)) return true;

    return false;
  }

  /* ── Healing ─────────────────────────────────────────────────────────── */
  var healing = false;
  var healCount = 0;
  var lastHealAt = 0;
  var retryBudget = 0;
  window.__twhV299HealCount = 0;

  function fullRender() {
    /* Prefer the canonical full render (rebuilds sidebar+header+content). */
    try { if (isFn(window.render)) { window.render(); return true; } } catch (e) {}
    return false;
  }

  function fallbackRepaint() {
    try { if (isFn(window.__twhReconcileRepaint)) { window.__twhReconcileRepaint(); return true; } } catch (e) {}
    try { if (isFn(window.__twhQuietRepaint)) { window.__twhQuietRepaint(); return true; } } catch (e) {}
    return false;
  }

  /* Last resort: force the route back to 'dashboard' via the canonical goTo,
     which sets currentMod and calls the full render() — the single reliable
     path that always rebuilds sidebar + header + content together. */
  function forceDashboardRoute() {
    try {
      if (isFn(window.goTo)) { window.goTo('dashboard'); return true; }
    } catch (e) {}
    try {
      window.currentMod = 'dashboard';
      if (isFn(window.render)) { window.render(); return true; }
    } catch (e) {}
    return false;
  }

  function heal(reason) {
    if (healing) return;
    if (!shellBroken()) return;
    var now = Date.now();
    /* debounce: at most one heal attempt per 600ms unless it's a fresh trigger */
    if (now - lastHealAt < 600) return;
    healing = true;
    lastHealAt = now;
    healCount++;
    window.__twhV299HealCount = healCount;

    try {
      fullRender();
    } catch (e) {}

    /* Verify on the next frame; if still broken, escalate through fallbacks. */
    var verify = function () {
      try {
        if (!shellBroken()) { healing = false; retryBudget = 0; return; }
        if (retryBudget < 2) {
          retryBudget++;
          fullRender();
          setTimeout(verify, 120);
          return;
        }
        /* full render keeps producing a broken shell → try fallbacks, then
           force the canonical dashboard route as a last resort. */
        if (!fallbackRepaint()) forceDashboardRoute();
        setTimeout(function () {
          if (shellBroken()) forceDashboardRoute();
          healing = false;
          retryBudget = 0;
        }, 140);
      } catch (e) { healing = false; retryBudget = 0; }
    };
    setTimeout(verify, 100);
  }
  window.__twhV299Heal = function () { lastHealAt = 0; heal('manual'); };

  /* ── BOOT / WATCH ────────────────────────────────────────────────────────
     We DO NOT wrap render/renderModule/renderDashboard (governor rule). We only
     observe (via the shared DOMBus tick + HMS.every + session events + bounded
     boot timers) and call render() when the shell is provably broken. */
  function tick() { try { heal('tick'); } catch (e) {} }

  [0, 150, 400, 900, 1600, 2800, 4200, 6500, 9000].forEach(function (ms) { setTimeout(tick, ms); });
  try { window.addEventListener('load', tick); } catch (e) {}
  try { if (window.DOMBus && isFn(window.DOMBus.register)) window.DOMBus.register(tick); } catch (e) {}
  try { if (window.HMS && isFn(window.HMS.every)) window.HMS.every(10000, tick); } catch (e) {}
  try {
    if (window.HMS && isFn(window.HMS.on)) {
      window.HMS.on('session:login', function () { lastHealAt = 0; setTimeout(tick, 60); });
      window.HMS.on('session:change', function () { lastHealAt = 0; setTimeout(tick, 60); });
    }
  } catch (e) {}

  window.__twhV299Diag = function () {
    return {
      active: true,
      signedIn: signedIn(),
      onLoginScreen: onLoginScreen(),
      hasApp: !!appEl(),
      hasSidebar: !!sidebarEl(),
      hasHeader: !!headerEl(),
      hasContent: !!contentEl(),
      shellBroken: shellBroken(),
      healCount: healCount
    };
  };
})();

;

/* ==== /js/246-twh-route-body-verifier-v300.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   TWH · ROUTE-BODY VERIFIER (v300)
   ────────────────────────────────────────────────────────────────────────
   User request (with two screenshots):
     "the application screen is a sample of the medical report link when it
      open on a dashboard not the other way round … Please make the
      Appointment, laboratory, patient, and radiology link open."

   ── SYMPTOM (from the screenshots) ──────────────────────────────────────
   Clicking Radiology (also Appointments / Laboratory / Patients) shows the
   breadcrumb "Dashboard › Radiology" (so currentMod IS 'radiology') but the
   BODY rendered inside #moduleContent is the wrong content — the personalized
   "My Day" dashboard and/or the EMR "All Registered Patients" table — instead
   of the radiology page. In the worst case the patient table appears detached
   to the LEFT of the shell while the dashboard is squished on the right.

   ── ROOT CAUSE (verified by reading the pack chain) ─────────────────────
   1. STALE BODY (Bug A): the v290 recursion-breaker (module 236) caches the
      last successful renderModule() HTML in a private `lastGood`. Under a
      render storm / re-entrancy it returns that cached string instead of
      re-running the switch. If `lastGood` was captured on the dashboard, a
      later navigation to radiology/laboratory/appointments/patients paints
      the STALE dashboard body even though currentMod already changed. The
      v298 breadcrumb bar syncs currentMod independently, so it correctly
      says "Radiology" — hence the breadcrumb/body mismatch.
   2. ORPHANED PANEL (Bug B): the v210 EMR "All Registered Patients" card
      (#twhAllPatientsCard) is only INJECTED when currentMod==='emr', but once
      inserted it can survive as a DETACHED node when render() is suppressed /
      the shell is rebuilt only partially — so it shows up next to an
      unrelated module.

   ── FIX (no core/observer/interval; read + verify + one clean repaint) ───
   After navigation settles, verify that the BODY inside #moduleContent
   actually matches currentMod:
     • Each verifiable module has an expected in-body signature (a unique
       table id / marker the core renderer always emits, or `.v186-day` for
       the dashboard).
     • If currentMod is one of the verifiable modules but its signature is
       MISSING from #moduleContent, OR a FOREIGN signature is present (e.g.
       radiology showing #twhAllPatientsCard, or .v186-day on a non-dashboard
       module), we force ONE cache-busting clean repaint:
          - reset window.__twhV290Depth = 0 so the v290 breaker does NOT return
            stale lastGood on this pass;
          - call render() (rebuilds the whole shell + body from the switch),
            which re-runs renderModule() at depth 0 → correct body + refreshed
            lastGood.
     • Also remove any ORPHANED #twhAllPatientsCard / .v186-day that is sitting
       DIRECTLY under #app (i.e. outside the current #moduleContent) — that is
       the detached "left side" node from the screenshot.

   Debounced, verified, bounded retries (≤2) so we never loop with render.
   Never fires while a modal/form is open or the user is actively editing.

   ── CONSTRAINTS HONOURED ─────────────────────────────────────────────────
   No core (008/010) / CSS / D1 schema / /api/state / _redirects / worker /
   merge.js / feature-pack-order edits. Does NOT wrap window.render /
   renderModule / renderDashboard (only READS state and CALLS render()). Adds
   NO raw setInterval / MutationObserver / DOMContentLoaded — rides the shared
   DOMBus ticker + HMS.every(10000) + bounded one-shot setTimeouts + goTo hook.
   Never copies flags via `for (k in fn)`. Idempotent; guarded __twhV300.

   Guard: window.__twhV300   Diagnostics: window.__twhV300Diag()
   Manual: window.__twhV300Verify()
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV300) return;
  window.__twhV300 = true;

  function isFn(f) { return typeof f === 'function'; }
  function log() {}

  var diag = {
    verifies: 0,        // total verify passes
    mismatches: 0,      // times body did not match currentMod
    repaints: 0,        // clean repaints forced
    orphansRemoved: 0,  // detached foreign panels removed
    lastMod: '',
    lastReason: '',
    lastError: ''
  };
  window.__twhV300Diag = function () { try { return JSON.parse(JSON.stringify(diag)); } catch (e) { return { lastError: String(e) }; } };

  /* ── Per-module BODY signatures the core renderers always emit ─────────────
     `need` = a CSS selector that MUST be present in #moduleContent for that
     module. `foreign` = selectors that must NOT be present (they belong to a
     different module) — used to catch the stale/leaked body. */
  var SIGS = {
    dashboard:    { need: '.v186-day, .kpi-grid',            foreign: ['#twhAllPatientsCard'] },
    emr:          { need: '#emrTable',                       foreign: ['.v186-day'] },
    radiology:    { need: '#radTable',                       foreign: ['#twhAllPatientsCard', '.v186-day'] },
    laboratory:   { need: '#labTable',                       foreign: ['#twhAllPatientsCard', '.v186-day'] },
    appointments: { need: '#aptTable',                       foreign: ['#twhAllPatientsCard', '.v186-day'] },
    patients:     { need: '#patFilterStatus, #patFilterSearch', foreign: ['.v186-day'] }
  };

  function curMod() {
    try { return (typeof window.currentMod !== 'undefined') ? window.currentMod : (window.D && window.D.currentMod) || 'dashboard'; }
    catch (e) { return 'dashboard'; }
  }

  function busy() {
    // Never yank a form / modal / active edit out from under the user.
    try { if (document.getElementById('modalBg') || document.getElementById('modal-bg')) return true; } catch (e) {}
    try { if (document.querySelector('.modal-bg, .modal.show, [role="dialog"]')) return true; } catch (e) {}
    try { if (window.__twhEditingRecord) return true; } catch (e) {}
    try {
      var a = document.activeElement;
      if (a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName)) return true;
    } catch (e) {}
    return false;
  }

  function signedIn() {
    try { if (window.isLoggedIn === true) return true; } catch (e) {}
    try { if (window.HMS && window.HMS.session && isFn(window.HMS.session.isAuthenticated) && window.HMS.session.isAuthenticated()) return true; } catch (e) {}
    try { if (window.D && window.D.currentUser && (window.D.currentUser.username || window.D.currentUser.id)) return true; } catch (e) {}
    return false;
  }
  function onLogin() {
    try { if (document.getElementById('loginScreen')) return true; } catch (e) {}
    return false;
  }

  function content() {
    try { return document.getElementById('moduleContent'); } catch (e) { return null; }
  }

  // The v290 recursion-breaker paints a transient "Loading module…" recovery
  // card when renderModule() re-enters too deep. That is NOT a routing bug — it
  // means a render storm is in flight. Repainting on top of it just feeds the
  // storm and pins the "Loading module…" text. When we see it we RESET the v290
  // depth (so the very next natural render runs the real switch) and BACK OFF
  // this pass, letting the app recover instead of fighting it.
  function isTransitionCard(mc) {
    try {
      if (!mc) return false;
      var t = mc.textContent || '';
      return /Loading module|stabilised automatically|recovered automatically/i.test(t);
    } catch (e) { return false; }
  }

  function has(root, sel) {
    if (!root) return false;
    try {
      // `need` may be a comma-list — matches if ANY is present.
      var parts = String(sel).split(',');
      for (var i = 0; i < parts.length; i++) {
        var s = parts[i].trim();
        if (s && root.querySelector(s)) return true;
      }
    } catch (e) {}
    return false;
  }

  /* ── Remove a foreign panel that leaked OUTSIDE the current #moduleContent
        (the detached node in the screenshot's left column). We only remove
        nodes that are NOT inside the live #moduleContent, so we never touch a
        legitimately-rendered body. ─────────────────────────────────────────── */
  function removeOrphans() {
    try {
      var mc = content();
      var app = document.getElementById('app');
      if (!app) return;
      var suspects = ['#twhAllPatientsCard', '.v186-day'];
      for (var i = 0; i < suspects.length; i++) {
        var nodes = app.querySelectorAll(suspects[i]);
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          // Keep it only if it is inside the live module content AND that panel
          // legitimately belongs to the current module.
          var insideContent = mc && mc.contains(n);
          if (insideContent) continue;              // part of the real body — leave it
          // Detached / outside the module content → orphan. Remove it.
          if (n.parentNode) { n.parentNode.removeChild(n); diag.orphansRemoved++; }
        }
      }
    } catch (e) { diag.lastError = String(e && e.message || e); }
  }

  /* ── Cache-busting clean repaint: reset the v290 depth so the recursion
        breaker cannot return stale `lastGood`, then render() from scratch. ─── */
  function forceRepaint(reason) {
    // NEVER call render() while a render / renderModule is already in flight —
    // that is exactly what deepens the v290 re-entrancy chain and pins the
    // "Loading module…" recovery card. If the app is mid-render, back off and
    // let the natural render finish; the next tick will re-verify.
    try {
      if ((typeof window.__twhV290RenderDepth === 'number' && window.__twhV290RenderDepth > 0) ||
          (typeof window.__twhV290Depth === 'number' && window.__twhV290Depth > 0)) {
        diag.lastReason = 'skip(reentrant):' + reason;
        return false;
      }
    } catch (e) {}
    diag.repaints++;
    diag.lastReason = reason;
    try { if (typeof window.__twhV290Depth === 'number') window.__twhV290Depth = 0; } catch (e) {}
    try { if (typeof window.__twhV290RenderDepth === 'number') window.__twhV290RenderDepth = 0; } catch (e) {}
    var ok = false;
    try { if (isFn(window.render)) { window.render(); ok = true; } } catch (e) { diag.lastError = String(e && e.message || e); }
    // Belt-and-brace: if render() is somehow suppressed, fall back to the
    // content-only quiet repaint which writes renderModule() into #moduleContent.
    if (!ok) {
      try { if (isFn(window.__twhQuietRepaint)) window.__twhQuietRepaint(); } catch (e) {}
    }
    return ok;
  }

  var _pending = null;   // debounce timer
  var _retry = 0;        // bounded retries per mismatch

  function verify() {
    diag.verifies++;
    try {
      if (!signedIn() || onLogin()) { _retry = 0; return; }
      if (busy()) return;                          // never disturb an edit
      var mod = curMod();
      diag.lastMod = mod;
      var mc = content();
      if (!mc) { _retry = 0; return; }             // shell missing → v299 handles it

      // If the v290 recovery card is showing, don't repaint on top of it — that
      // pins "Loading module…". Reset the depth counter so the next natural
      // render escapes the cap, and back off for this pass.
      if (isTransitionCard(mc)) {
        try { if (typeof window.__twhV290Depth === 'number') window.__twhV290Depth = 0; } catch (e) {}
        try { if (typeof window.__twhV290RenderDepth === 'number') window.__twhV290RenderDepth = 0; } catch (e) {}
        diag.lastReason = 'transition-card:back-off';
        _retry = 0;
        return;
      }

      var sig = SIGS[mod];

      // Always sweep detached foreign panels first (cheap; fixes the left-side
      // orphan regardless of the current module).
      removeOrphans();

      if (!sig) { _retry = 0; return; }            // module we don't verify → done

      var missing = !has(mc, sig.need);
      var foreign = false, fkey = '';
      for (var i = 0; i < sig.foreign.length; i++) {
        if (has(mc, sig.foreign[i])) { foreign = true; fkey = sig.foreign[i]; break; }
      }

      if (!missing && !foreign) { _retry = 0; return; } // body matches → healthy

      diag.mismatches++;
      var reason = mod + (missing ? ' miss' : '') + (foreign ? ' foreign:' + fkey : '');

      if (_retry >= 2) {
        // Guardrail: don't loop with render() forever. Try goTo once, then stop.
        try { if (isFn(window.goTo)) window.goTo(mod); } catch (e) {}
        _retry = 0;
        return;
      }
      _retry++;
      forceRepaint(reason);
      // Re-check on the next frame; if still wrong the bounded retry escalates.
      try {
        (window.requestAnimationFrame || function (f) { setTimeout(f, 16); })(function () {
          try {
            var mc2 = content();
            if (mc2 && has(mc2, sig.need)) { _retry = 0; }
          } catch (e) {}
        });
      } catch (e) {}
    } catch (e) { diag.lastError = String(e && e.message || e); }
  }

  function verifyDebounced() {
    if (_pending) return;
    _pending = setTimeout(function () { _pending = null; verify(); }, 120);
  }
  window.__twhV300Verify = function () { _retry = 0; verify(); return window.__twhV300Diag(); };

  /* ── boot (idempotent; shared ticker + bus + bounded one-shots) ─────────── */
  function boot() {
    verify();
    [0, 140, 380, 800, 1600, 3000, 5200].forEach(function (ms) { setTimeout(verify, ms); });
    try { if (typeof window.DOMBus !== 'undefined' && isFn(window.DOMBus.register)) window.DOMBus.register(verifyDebounced); } catch (e) {}
    try { if (window.HMS && isFn(window.HMS.every)) window.HMS.every(10000, verify); } catch (e) {}
    try { window.addEventListener('load', verify); } catch (e) {}
    // React the instant the route changes so the mismatch never lingers.
    try {
      if (isFn(window.goTo) && !window.goTo.__v300) {
        var _g = window.goTo;
        window.goTo = function () {
          var o = _g.apply(this, arguments);
          _retry = 0;
          try { (window.requestAnimationFrame || function (f) { setTimeout(f, 16); })(verify); } catch (e) {}
          try { setTimeout(verify, 60); } catch (e) {}
          return o;
        };
        try { window.goTo.__v300 = true; } catch (e) {}
      }
    } catch (e) {}
    try { if (window.HMS && isFn(window.HMS.on)) { window.HMS.on('session:login', verify); window.HMS.on('session:change', verify); } } catch (e) {}
    log('route-body verifier active');
  }

  boot();
})();

;

/* ==== /js/247-twh-lean-dashboard-loading-unstick-v301.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   TWH · LEAN DASHBOARD + "LOADING MODULE…" UNSTICK (v301)
   ────────────────────────────────────────────────────────────────────────
   User request (with a screenshot of the dashboard stuck on "Loading module…"
   showing the "Today's schedule" and "Worklist / Patient flow this week"
   panels):
     "Remove Today's schedule and worklist KPI from all users dashboard.
      Loading modules should finish loading. click on register patient, create
      an appointment, laboratory, and radiology should display where you can
      view, edit and update."

   ── WHAT THIS DOES ───────────────────────────────────────────────────────
   PART 1 · LEAN DASHBOARD (remove the bottom columns for EVERY user)
     The v186 "My Day" dashboard (module 140) renders a `.v186-cols` block that
     holds three panels: "Worklist", "Patient flow this week", and "Today's
     schedule". The user wants all three GONE from every role's dashboard. We do
     NOT wrap renderDashboard/renderModule; instead we remove the `.v186-cols`
     node (and any stray `.v186-flow` / `.v186-sched`) from the LIVE dashboard
     DOM after each render, and inject a tiny CSS rule that hides them so there
     is no flash before the JS sweep runs. Only applies on the dashboard route.

   PART 2 · UNSTICK "LOADING MODULE…"
     The v290 recursion-breaker (module 236) paints a transient card
       "Loading module… — The screen stabilised automatically."
     when renderModule() re-enters past its depth cap (8). If some deep wrapper
     chain trips that cap on a cold render, the card can persist because the
     depth counter never returns to 0 between passes. This pack:
       • Resets window.__twhV290Depth / __twhV290RenderDepth to 0 on the shared
         cadence (they are plain window counters — safe to zero when we are NOT
         inside a render), so the very next natural render runs the real switch.
       • If the recovery card is STILL showing on the dashboard/module content
         after the reset, requests ONE clean repaint via the app's own helpers
         (__twhReconcileRepaint → __twhQuietRepaint → render) — but ONLY when no
         render is currently in flight, so we can never deepen the chain.
     Net effect: the "Loading module…" card cannot persist; the real module
     body (dashboard, Register Patients, Appointments, Laboratory, Radiology)
     finishes loading and its own view/edit/update controls become usable.

   ── WHY THE MODULE PAGES ALREADY SUPPORT VIEW / EDIT / UPDATE ────────────
   Register Patients (patients), Appointments, Laboratory and Radiology each
   have full core renderers with New / Edit / Update actions (renderPatients,
   renderAppointments, renderLab, renderRadiology + the v266 standalone entry
   pages). They only looked broken because the render never finished (the
   "Loading module…" cap) — once Part 2 lets the render complete, the tables
   and their action buttons appear. This pack does not re-implement them.

   ── CONSTRAINTS HONOURED ─────────────────────────────────────────────────
   No core (008/010) / CSS-file / D1 schema / /api/state / _redirects / worker /
   merge.js / feature-pack-order edits. Does NOT wrap window.render /
   renderModule / renderDashboard (only reads state, tweaks the live DOM, and
   calls the app's existing repaint helpers when safe). Adds NO raw setInterval /
   MutationObserver / DOMContentLoaded — rides the shared DOMBus ticker +
   HMS.every(10000) + bounded one-shot setTimeouts + a goTo hook. Never copies
   flags via `for (k in fn)`. Idempotent; guarded __twhV301.

   Guard: window.__twhV301   Diagnostics: window.__twhV301Diag()
   Manual: window.__twhV301Sweep()
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV301) return;
  window.__twhV301 = true;

  function isFn(f) { return typeof f === 'function'; }

  var STYLE_ID = 'twh-v301-style';
  var diag = { styled: false, panelsRemoved: 0, depthResets: 0, unstickRepaints: 0, lastMod: '', lastError: '' };
  window.__twhV301Diag = function () { try { return JSON.parse(JSON.stringify(diag)); } catch (e) { return { lastError: String(e) }; } };

  function curMod() {
    try { return (typeof window.currentMod !== 'undefined') ? window.currentMod : (window.D && window.D.currentMod) || 'dashboard'; }
    catch (e) { return 'dashboard'; }
  }
  function onLogin() { try { return !!document.getElementById('loginScreen'); } catch (e) { return false; } }
  // inRender() answers ONE question: "are we genuinely executing inside a
  // render() call right now, such that repainting would deepen recursion?".
  // Only __twhV290RenderDepth tracks that. __twhV290Depth is the renderModule
  // re-entry COUNTER — it is exactly what stays pinned high when the loading
  // card is showing, so it must NOT be treated as "in render" (otherwise the
  // unstick could never fire on the very state it exists to clear).
  function inRender() {
    try {
      if (typeof window.__twhV290RenderDepth === 'number' && window.__twhV290RenderDepth > 0) return true;
    } catch (e) {}
    return false;
  }

  /* ── PART 1: hide the dashboard bottom columns for every user ──────────── */
  function installStyle() {
    if (document.getElementById(STYLE_ID)) { diag.styled = true; return; }
    var head = document.head || document.getElementsByTagName('head')[0];
    if (!head) return;
    var st = document.createElement('style');
    st.id = STYLE_ID;
    // Only hide within the dashboard's own container so other modules that may
    // reuse a class are untouched. .v186-day is the dashboard root.
    st.textContent =
      '.v186-day .v186-cols{display:none !important}' +
      '.v186-day .v186-flow{display:none !important}' +
      '.v186-day .v186-sched{display:none !important}';
    head.appendChild(st);
    diag.styled = true;
  }

  function removeDashboardPanels() {
    try {
      if (curMod() !== 'dashboard') return;
      var mc = document.getElementById('moduleContent') || document.getElementById('app');
      if (!mc) return;
      var day = mc.querySelector('.v186-day');
      if (!day) return;
      // Remove the whole bottom columns block (Worklist + Patient flow + Today's
      // schedule) so it is gone from the DOM, not just hidden.
      var cols = day.querySelector('.v186-cols');
      if (cols && cols.parentNode) { cols.parentNode.removeChild(cols); diag.panelsRemoved++; }
    } catch (e) { diag.lastError = String(e && e.message || e); }
  }

  /* ── PART 2: unstick the v290 "Loading module…" recovery card ──────────── */
  function loadingCardShowing() {
    try {
      var mc = document.getElementById('moduleContent');
      if (!mc) return false;
      var t = mc.textContent || '';
      return /Loading module|stabilised automatically|recovered automatically/i.test(t);
    } catch (e) { return false; }
  }

  function resetDepth() {
    // Safe to zero the plain window counters whenever we are NOT inside a
    // render — this lets a legit deep chain escape the cap on the next pass.
    if (inRender()) return;
    try { if (typeof window.__twhV290Depth === 'number' && window.__twhV290Depth !== 0) { window.__twhV290Depth = 0; diag.depthResets++; } } catch (e) {}
    try { if (typeof window.__twhV290RenderDepth === 'number' && window.__twhV290RenderDepth !== 0) window.__twhV290RenderDepth = 0; } catch (e) {}
  }

  function unstick() {
    try {
      if (onLogin()) return;
      if (!loadingCardShowing()) return;
      resetDepth();
      if (inRender()) return;               // never repaint mid-render
      // One clean repaint via the app's own helpers (prefer scroll-stable).
      var did = false;
      try { if (isFn(window.__twhReconcileRepaint)) { window.__twhReconcileRepaint(); did = true; } } catch (e) {}
      if (!did) { try { if (isFn(window.__twhQuietRepaint)) { window.__twhQuietRepaint(); did = true; } } catch (e) {} }
      if (!did) { try { if (isFn(window.render)) { window.render(); did = true; } } catch (e) {} }
      if (did) diag.unstickRepaints++;
    } catch (e) { diag.lastError = String(e && e.message || e); }
  }

  /* ── combined pass (idempotent; cheap) ─────────────────────────────────── */
  function sweep() {
    diag.lastMod = curMod();
    installStyle();
    resetDepth();
    unstick();
    removeDashboardPanels();
  }
  window.__twhV301Sweep = function () { sweep(); return window.__twhV301Diag(); };

  /* ── boot (shared ticker + bus + bounded one-shots + goTo hook) ────────── */
  function boot() {
    sweep();
    [0, 120, 350, 800, 1600, 3000, 5200, 8000].forEach(function (ms) { setTimeout(sweep, ms); });
    try { if (typeof window.DOMBus !== 'undefined' && isFn(window.DOMBus.register)) window.DOMBus.register(sweep); } catch (e) {}
    try { if (window.HMS && isFn(window.HMS.every)) window.HMS.every(10000, sweep); } catch (e) {}
    try { window.addEventListener('load', sweep); } catch (e) {}
    try {
      if (isFn(window.goTo) && !window.goTo.__v301) {
        var _g = window.goTo;
        window.goTo = function () {
          var o = _g.apply(this, arguments);
          try { (window.requestAnimationFrame || function (f) { setTimeout(f, 16); })(sweep); } catch (e) {}
          try { setTimeout(sweep, 80); } catch (e) {}
          return o;
        };
        try { window.goTo.__v301 = true; } catch (e) {}
      }
    } catch (e) {}
    try { if (window.HMS && isFn(window.HMS.on)) { window.HMS.on('session:login', sweep); window.HMS.on('session:change', sweep); } } catch (e) {}
  }

  boot();
})();

;

/* ==== /js/248-twh-nav-open-in-new-tab-v303.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   TWH · EVERY NAV LINK OPENS AS A STANDALONE PAGE IN A NEW BROWSER TAB (v303)
   ────────────────────────────────────────────────────────────────────────
   User request (v302 → extended in v303): "Update/implement the application —
   each link should NOT reload to open; it should open in another tab of the
   browser like HTML, and sync perfectly. This should be done to EACH page.
   When you click on the modules once, all data should load into all the
   pages."

   The SPA sidebar renders <button class="sb-item" onclick="goTo('patients')">
   for every module. Clicking one normally re-renders the module INSIDE the
   single-page app. This pack changes that for EVERY module: a click now opens
   the module as its own isolated HTML page in a NEW BROWSER TAB and the SPA
   does NOT re-render, so the current tab keeps its place.

   Two kinds of target page:
     • Rich, purpose-built pages (create + view + edit + update):
         patients      → /register.html
         appointments  → /appointment.html
         emr           → /medical-record.html
         laboratory    → /laboratory.html
         radiology     → /radiology.html
     • Every OTHER module → the generic viewer /module.html?mod=<key>, which
       loads that module's live records from the SAME D1 document and shows a
       searchable list + full-record view. (dashboard stays in-app — it is the
       SPA home, not a data page.)

   Because every standalone page reads/writes the SAME Cloudflare D1 state
   document the SPA uses (per-collection merge PUT + GET on open), all tabs
   stay in perfect sync: open any module in its own tab and ALL of that
   module's data loads immediately; records created/edited anywhere appear
   everywhere on the next pull.

   HOW (governor-safe): ONE capturing click listener on document (not a
   MutationObserver, not per-element, not a timer). It inspects the clicked
   element's chain for a `.sb-item` (or any element whose onclick calls
   goTo('<mod>')) and opens the matching tab. Non-left-click / modified clicks
   are left to the browser.

   Toggle: window.TWH_TAB_ROUTING (default true). Programmatic goTo() calls
   are NOT hijacked — only genuine user clicks — so internal deep-links keep
   working inside the SPA.

   Constraints honoured: no core / CSS / D1-schema / /api/state / _redirects /
   worker edits; no feature-pack reorder; guard __twhV303; no setInterval /
   MutationObserver / DOMContentLoaded; never wraps render/renderModule/
   renderDashboard/goTo; no for..in flag copy.

   Guard: window.__twhV303   Diagnostics: window.__twhV303Diag()
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV303) return;
  window.__twhV303 = true;

  if (typeof window.TWH_TAB_ROUTING === 'undefined') window.TWH_TAB_ROUTING = true;
  // v307: even when TWH_TAB_ROUTING is off (v312 pins it off to keep in-body
  // links/tiles in-app), the user still wants every SIDEBAR link to open its
  // module as a standalone full page in a NEW tab (no sidebar, no reload). This
  // toggle re-enables new-tab opening for .sb-item clicks specifically.
  if (typeof window.TWH_SIDEBAR_NEW_TAB === 'undefined') window.TWH_SIDEBAR_NEW_TAB = true;
  // v309: user request — "All sidebar modules should be ONE CLICK and it
  // navigate to the module's page (NOT to be reloaded before it navigates)."
  // When on, a sidebar module click navigates DIRECTLY to the module's
  // standalone page in the SAME tab (one clean page load) instead of opening a
  // blank _blank tab that then loads (which reads as an extra reload step).
  // This wins over TWH_SIDEBAR_NEW_TAB for .sb-item clicks. Toggle it off to
  // restore the previous new-tab behaviour.
  if (typeof window.TWH_SIDEBAR_SAME_TAB === 'undefined') window.TWH_SIDEBAR_SAME_TAB = true;

  // Rich, purpose-built standalone pages. Keep in lock-step with v266 ROUTES.
  var RICH = {
    patients:     '/register.html',
    appointments: '/appointment.html',
    emr:          '/medical-record.html',
    laboratory:   '/laboratory.html',
    radiology:    '/radiology.html'
  };

  // Every SPA sidebar module key (see 008 buildNav). 'dashboard' is the SPA
  // home and stays in-app; everything else opens as a standalone page.
  var MODULE_KEYS = [
    'patients', 'appointments', 'emr', 'prescriptions', 'laboratory', 'radiology',
    'referrals', 'beds', 'pharmacy', 'or', 'emergency', 'bloodbank',
    'transactions', 'billing', 'fixedassets', 'hr', 'inventory', 'procurement',
    'reports', 'insurance', 'audit', 'compliance', 'portal', 'telemedicine',
    'ai', 'queue', 'infection', 'dietary', 'immunization', 'documents', 'hah',
    'ambulance', 'crm', 'research', 'config', 'sysadmin', 'users', 'settings'
  ];

  // Build the full module-key → page map: rich page when one exists, else the
  // generic viewer with the module key as a query param.
  var PAGES = {};
  (function () {
    for (var i = 0; i < MODULE_KEYS.length; i++) {
      var k = MODULE_KEYS[i];
      PAGES[k] = RICH[k] || ('/module.html?mod=' + encodeURIComponent(k));
    }
  })();

  var diag = { opened: 0, installed: false };

  function enabled() { return window.TWH_TAB_ROUTING !== false; }

  // Extract the module key a nav element targets. Prefer an explicit
  // data-mod/data-goto attribute, else parse the onclick="goTo('x')" text.
  function modFromEl(el) {
    if (!el || el.nodeType !== 1) return '';
    try {
      var dm = el.getAttribute && (el.getAttribute('data-mod') || el.getAttribute('data-goto'));
      if (dm) return String(dm).trim();
      var oc = el.getAttribute && el.getAttribute('onclick');
      if (oc) {
        var m = /goTo\(\s*['"]([a-zA-Z0-9_-]+)['"]\s*\)/.exec(oc);
        if (m) return m[1];
      }
    } catch (_e) {}
    return '';
  }

  // Walk up from the event target looking for a sidebar item (or any element
  // whose onclick routes via goTo) that maps to a standalone page. Bounded to
  // 6 hops so it is O(1) per click.
  function findRoutable(start) {
    var el = start, hops = 0;
    while (el && el.nodeType === 1 && hops < 6) {
      // A sidebar nav button, or anything carrying a goTo() route.
      var isNav = (el.classList && el.classList.contains('sb-item')) ||
                  (el.getAttribute && el.getAttribute('onclick') && /goTo\(/.test(el.getAttribute('onclick'))) ||
                  (el.getAttribute && (el.getAttribute('data-mod') || el.getAttribute('data-goto')));
      if (isNav) {
        var mod = modFromEl(el);
        if (mod && PAGES[mod]) return { el: el, mod: mod, page: PAGES[mod] };
        // A nav item that has no standalone page — stop here; let the SPA
        // handle it normally (do NOT keep climbing into unrelated ancestors).
        if (el.classList && el.classList.contains('sb-item')) return null;
      }
      el = el.parentNode;
      hops++;
    }
    return null;
  }

  function openTab(url) {
    // Seam so tests (and any host) can observe/override without a real popup.
    try { if (typeof window.__twhOpenTab === 'function') { window.__twhOpenTab(url); diag.opened++; return true; } } catch (_e) {}
    try {
      var w = window.open(url, '_blank');
      // Some browsers block popups triggered outside a "user gesture"; because
      // we ARE inside a click handler this is allowed. If it is still blocked
      // (w === null), fall back to a same-tab navigation so the link is never
      // dead — the user asked for a separate page first, working link second.
      if (w) { try { w.opener = null; } catch (_e2) {} diag.opened++; return true; }
    } catch (_e) {}
    try { window.location.assign(url); diag.opened++; return true; } catch (_e3) {}
    return false;
  }

  // Direct, single-load navigation in the SAME tab (v309). One click → the
  // module's standalone page loads directly — no blank intermediate tab, so
  // there is no perceived "reload before navigate". Uses the shared nav seam
  // when present (so tests can observe it) then a plain location.assign.
  function navigateSameTab(url) {
    try { if (typeof window.__twhSameTabNav === 'function') { window.__twhSameTabNav(url); diag.opened++; return true; } } catch (_e) {}
    try { window.location.assign(url); diag.opened++; return true; } catch (_e2) {}
    try { window.location.href = url; diag.opened++; return true; } catch (_e3) {}
    return false;
  }

  // Is the routable hit a genuine SIDEBAR item (.sb-item)? Sidebar links open
  // in a new tab under TWH_SIDEBAR_NEW_TAB even when TWH_TAB_ROUTING is off.
  function hitIsSidebar(hit) {
    try {
      var el = hit && hit.el, hops = 0;
      while (el && el.nodeType === 1 && hops < 8) {
        if (el.classList && el.classList.contains('sb-item')) return true;
        el = el.parentNode; hops++;
      }
    } catch (_e) {}
    return false;
  }

  function onClick(e) {
    try {
      // Respect normal browser affordances: only plain left-clicks.
      if (e.defaultPrevented) return;
      if (typeof e.button === 'number' && e.button !== 0) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

      var hit = findRoutable(e.target);
      if (!hit) return;

      // Gate: normally requires TWH_TAB_ROUTING. But a SIDEBAR link opens in a
      // new tab whenever TWH_SIDEBAR_NEW_TAB is on, regardless of TWH_TAB_ROUTING
      // — that is the user's "sidebar links open full page in another tab
      // (without reload)" request, honoured even while v312 keeps tiles in-app.
      if (!enabled()) {
        if (!(window.TWH_SIDEBAR_NEW_TAB !== false && hitIsSidebar(hit))) return;
      }

      // Intercept: stop the SPA's inline goTo() from firing (capture phase, so
      // we run before the onclick attribute handler), then route to the page.
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

      // v309: a SIDEBAR click navigates DIRECTLY in the same tab (one clean
      // load, no reload-then-navigate) when TWH_SIDEBAR_SAME_TAB is on. Any
      // other routable click keeps the new-tab behaviour.
      if (window.TWH_SIDEBAR_SAME_TAB !== false && hitIsSidebar(hit)) {
        navigateSameTab(hit.page);
      } else {
        openTab(hit.page);
      }
    } catch (_err) {}
  }

  /* ── CLICK-ACTIVATION GUARANTEE for IN-CONTENT controls ───────────────────
     The user reported that in-content links (Reports / Custom Report Builder
     data-source checkboxes / Configuration tabs) "are not stable and some are
     not even clickable." Root cause: those controls run their own inline
     onclick (e.g. showConfigTab / showReportTab / a checkbox toggle), but a
     wrapper pack (or the handler itself) also fires the core full render() on
     the same click, which rebuilds the whole #app shell and swaps the control's
     sub-container node — so the click's visible effect is lost / it "resets."

     This bubble-phase resolver runs AFTER the inline handler. It does NOT
     preventDefault and NEVER calls goTo/render — it simply:
       (a) marks the shared content-interaction lock (via v305's seam) so the
           shell decorator honours the LAST coalesced paint and restores state;
       (b) snapshots the interactive control's identity + the nearest content
           container's HTML signature, then on the NEXT frame checks whether the
           container updated. If the node was swapped out mid-click (so the
           user's intended effect was dropped), it re-dispatches the SAME inline
           handler ONCE against the fresh, re-attached control — guaranteeing the
           tab actually switches / the checkbox actually applies.
     Idempotent, bounded (one rAF, one retry), governor-safe. */
  var INTERACT_RE = /([Ss]how|[Ss]witch)[A-Za-z]*Tab|Tab\(|[Tt]oggle/;

  function findInteractive(start) {
    var el = start, hops = 0;
    while (el && el.nodeType === 1 && hops < 6) {
      try {
        var cl = el.classList, oc = el.getAttribute && el.getAttribute('onclick');
        if (cl && (cl.contains('tab-btn') || cl.contains('report-tab') || cl.contains('report-card'))) return el;
        if (el.getAttribute && el.getAttribute('role') === 'tab') return el;
        if (oc && INTERACT_RE.test(oc)) return el;
        if (el.tagName === 'INPUT' && (el.type === 'checkbox' || el.type === 'radio')) return el;
      } catch (_e) {}
      el = el.parentNode; hops++;
    }
    return null;
  }

  // The core & packs repaint tab bodies into a container whose id ends in
  // "Content" (moduleContent / configContent / reportContent / txnContent / …).
  function nearestContentId(el) {
    var n = el, hops = 0;
    while (n && n.nodeType === 1 && hops < 12) {
      if (n.id && /Content$/.test(n.id)) return n.id;
      n = n.parentNode; hops++;
    }
    return null;
  }

  // "next frame" scheduler — bounded one-shot, not a loop.
  function raf(f) { return setTimeout(f, 16); }

  // Bubble-phase resolver: verify/repair in-content control clicks (tabs,
  // checkboxes, cards) after their inline handler ran, so none are ever dead.
  function onContentClick(e) {
    try {
      if (typeof e.button === 'number' && e.button !== 0) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var ctrl = findInteractive(e.target);
      if (!ctrl) return;
      // Arm the shared content-interaction lock so the shell decorator keeps the
      // control's container stable across any full render() this click fires.
      try { window.__twhContentInteract = Date.now(); } catch (_e) {}
      diag.contentHits = (diag.contentHits || 0) + 1;
      // Anti-shake (v314 pins __twhNoContentReclick): the lock above is harmless,
      // but skip the speculative rAF re-click below — it is the blink source.
      if (window.__twhNoContentReclick) return;
      var cid = nearestContentId(ctrl);
      if (!cid) return;
      var oc = ctrl.getAttribute && ctrl.getAttribute('onclick');
      if (!oc) return;
      var cEl = document.getElementById(cid);
      var before = cEl ? cEl.innerHTML.length : -1;
      // If the node was swapped out by a shell rebuild and the container did not
      // update, re-dispatch the same inline handler ONCE on the fresh control.
      raf(function () {
        try {
          var cEl2 = document.getElementById(cid);
          if (!cEl2 || before < 0) return;
          if (cEl2.innerHTML.length === before && !document.contains(ctrl)) {
            var cands = cEl2.querySelectorAll('[onclick]'), fresh;
            for (var i = 0; i < cands.length; i++) { if (cands[i].getAttribute('onclick') === oc) { fresh = cands[i]; break; } }
            if (fresh && typeof fresh.click === 'function') fresh.click();
          }
        } catch (_e) {}
      });
    } catch (_err) {}
  }

  function install() {
    if (diag.installed) return;
    try {
      // Capture phase (true) is essential: inline onclick="goTo(...)" handlers
      // run in the bubble phase, so capturing lets us pre-empt and cancel them.
      document.addEventListener('click', onClick, true);
      // Bubble phase (false): runs AFTER inline handlers so it can verify/repair
      // in-content control clicks without pre-empting them.
      document.addEventListener('click', onContentClick, false);
      diag.installed = true;
    } catch (_e) {}
  }

  install();

  // Belt-and-brace: if the document was not ready enough at pack time, re-arm
  // once via the shared bus / a single bounded one-shot (no timers loop).
  try { if (typeof window.DOMBus !== 'undefined' && typeof window.DOMBus.register === 'function') { window.DOMBus.register(install); } } catch (_e) {}
  try { if (window.HMS && typeof window.HMS.every === 'function') { window.HMS.every(60000, install); } } catch (_e) {}
  setTimeout(install, 250);

  function diagFn() {
    return {
      enabled: enabled(),
      installed: diag.installed,
      opened: diag.opened,
      contentHits: diag.contentHits || 0
    };
  }
  window.__twhV303Diag = diagFn;
})();

;

/* ==== /js/249-twh-auto-reload-on-login-v304.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   TWH · STAGE 1 — NO FULL-PAGE RELOAD ON LOGIN (supersedes old v304)
   ────────────────────────────────────────────────────────────────────────
   Diagnosis (Request D, Q#2): the old v304 fired window.location.reload() right
   after every in-app login. That reload re-ran the whole synchronous boot, which
   briefly re-showed the login/gate screen BEFORE the SPA re-hydrated and routed
   to the role home — the user's "it goes to the login page before it goes to the
   right page" flash — and it detached freshly-wired handlers ("clickable once").

   Professional fix: the SPA already renders from in-memory state after doLogin(),
   so the reload is unnecessary and harmful. This pack now AUTHORITATIVELY
   DISABLES reload-on-login instead of performing it: it pins
   TWH_AUTO_RELOAD_ON_LOGIN=false (re-asserted so no later pack re-enables it),
   neutralises the legacy __twhReload seam to a no-op, and clears the stale
   sessionStorage loop-flag. Guard + diag kept identical so probes keep working.

   Constraints honoured: no core / CSS / D1-schema / /api/state / _redirects /
   worker edits; no reorder; guard __twhV304; no setInterval / MutationObserver /
   DOMContentLoaded; never wraps render/renderModule/renderDashboard/goTo/doLogin.

   Guard: window.__twhV304   Diagnostics: window.__twhV304Diag()
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV304) return;
  window.__twhV304 = true;

  var reasserts = 0;
  function disable() {
    try {
      window.TWH_AUTO_RELOAD_ON_LOGIN = false;
      window.__twhReload = function () {};
      if (window.sessionStorage) window.sessionStorage.removeItem('twh_reloaded_for_login');
    } catch (_e) {}
    reasserts++;
  }
  disable();

  try { if (window.HMS && typeof window.HMS.every === 'function') window.HMS.every(10000, disable); } catch (_e) {}
  try { if (typeof window.DOMBus !== 'undefined' && typeof window.DOMBus.register === 'function') window.DOMBus.register(disable); } catch (_e) {}
  setTimeout(disable, 300);
  setTimeout(disable, 1500);

  window.__twhV304Diag = function () {
    return { enabled: false, reloadDisabled: true, seamNeutralised: typeof window.__twhReload === 'function', reasserts: reasserts, toggle: window.TWH_AUTO_RELOAD_ON_LOGIN };
  };
})();

;

/* ==== /js/250-twh-ar-heal-fastlinks-newtab-antishake-v305.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   TWH · AR (RECEIVABLES) DEFINITIVE HEAL + FAST-PAGE LINKS OPEN IN NEW TAB
        + ANTI-SHAKE REINFORCEMENT  (v305)
   ────────────────────────────────────────────────────────────────────────
   User report (verbatim):
     "Why is Finance — Receivables, Bills & Revenue keep loading ?.
      Let all fast stable pages link be on their main module.
      Let fix all errors and issue, then always load all data ( transaction).
      for all pages. page shaking should stop"

   ── (1) WHY RECEIVABLES KEEPS LOADING ────────────────────────────────────
   The core (010) Overview / classic-tab render path is:
       V27_renderARTab('overview')  →  V27_callV26Tab('overview')
         → returns a "Loading…" spinner  AND  setTimeout(()=>V26_arSetTab,10)
   If the SPA re-renders (navigation / background poll / route-body verifier)
   in that 10 ms window, #arContent is replaced and V26_arSetTab bails on its
   own `if(!_el) return` guard — so the spinner stays on screen FOREVER.

   The v277 pack tried to heal this by calling window.renderAROverview() /
   window.renderARTab(), but in 010 those are IIFE-LOCAL function declarations
   (never assigned to window), so v277's window.* lookups return undefined,
   overviewHTML() returns null, and it falls through to the same broken
   spinner path. Net effect: v277 could not actually repaint Overview.

   THE RELIABLE FIX: window.V26_arSetTab(tab) IS on window (010 line 8487) and
   synchronously writes #arContent.innerHTML using the real closure renderers
   (renderARTab / V27_renderARTab). This watchdog detects a stuck #arContent
   spinner and calls V26_arSetTab(currentTab) directly — no deferred timer, no
   dependency on the (unreachable) window.renderAROverview. Because the element
   already exists when we call it, the `if(!_el) return` guard never fires.

   ── (2) FAST STABLE-PAGE LINKS ON THEIR MAIN MODULE ──────────────────────
   The "⚡ Fast … (stable page)" launchers (v265/v266) navigated the CURRENT
   tab away to /register.html, /appointment.html, etc. — so the user LEFT the
   main module. v303 already makes every sidebar link open its page in a NEW
   tab. To stay consistent ("let all fast stable pages link be on their main
   module"), we define the shared navigation seam window.__twhNavigate — which
   both v265 (goRegister) and v266 (go) try FIRST — to open the target page in
   a NEW tab. The user therefore stays on the main module and the stable page
   opens alongside it. Same-tab navigation remains the fallback if a popup is
   blocked, so the link is never dead.

   ── (3) PAGE SHAKING / FLICKER SHOULD STOP + SCROLL STAYS PUT ────────────
   Two complementary fixes:
     (3a) Reinforce the anti-shake stylesheet: neutralise involuntary looping
          motion (shake / blink / flicker) on rows, cards, KPIs and the module
          shell, while preserving the intentional "unsaved changes" Save &
          Commit cue.
     (3b) SCROLL-STABLE, DIFF-GUARDED #arContent. v268 already hardens
          #moduleContent (drop identical rewrites + snapshot/restore scroll),
          but the core's V26_arSetTab writes #arContent DIRECTLY, so Receivables
          repaints still flickered and reset the page scroll (the "shaking"
          the user sees while scrolling AR up/down). We decorate the live
          #arContent element with the SAME own-property innerHTML accessor:
          identical HTML is dropped, and window + inner-scroller positions are
          snapshotted before the write and restored synchronously (and once
          more on the next frame) after. Result: scrolling Receivables up and
          down is smooth and never jumps.

   ── (4) APPLICATION-WIDE SCROLL-STABLE + ANTI-SHAKE (every page) ─────────
   User follow-up (verbatim): "continue and also implement the anti-shake
   stylesheet to fix every other page on the application" — Register Patients,
   Create an Appointment, Laboratory, Radiology, Medical Record, Prescriptions,
   Reports, Transactions. Two parts:
     (4a) The full-page screens (Register / Appointment / Lab / Radiology /
          Medical Record / Prescriptions) render INTO #moduleContent and are
          already scroll-stable via v268; the APPLICATION-WIDE anti-shake
          stylesheet (.main scope) additionally calms their looping animations.
     (4b) Tab SUB-CONTAINERS repainted DIRECTLY (bypassing #moduleContent).
          SCOPE CHANGE (v323): the old fixed allowlist is GONE — containers are
          discovered GENERICALLY (id ends in Content/Body/Panel, the app's
          direct-write convention, OR a tagged scroll region), so every module
          — including modules added later — is covered with no per-module code.
          Each is decorated with the shared decorateStable() machinery (drop
          identical rewrites + both-axis snapshot/restore keyed by
          data-scroll-id). Reserved ids owned by other decorators (#app,
          #moduleContent, #arContent, modals) are skipped.

   CONSTRAINTS HONOURED: append-only feature pack; NO edits to core (008/010),
   the SPA CSS bundle, D1 schema, /api/state, _redirects, worker or merge.js;
   NO feature-pack reorder. Idempotent (guarded by window.__twhV305). Adds NO
   raw setInterval and NO MutationObserver — rides DOMBus.register + HMS.every
   (≥10 s) + bounded one-shot setTimeouts only. Never wraps render / goTo /
   renderModule / renderDashboard / doLogin. Never copies flags via for-in.

   Guard: window.__twhV305        Diagnostics: window.__twhV305Diag()
   Toggles: window.TWH_AR_HEAL (default true)
            window.TWH_FASTLINK_NEW_TAB (default true)
            window.TWH_SCROLL_STABLE (default true)  // app-wide sub-containers
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV305) return;
  window.__twhV305 = true;

  if (typeof window.TWH_AR_HEAL === 'undefined') window.TWH_AR_HEAL = true;
  if (typeof window.TWH_FASTLINK_NEW_TAB === 'undefined') window.TWH_FASTLINK_NEW_TAB = true;
  if (typeof window.TWH_SCROLL_STABLE === 'undefined') window.TWH_SCROLL_STABLE = true;

  function isFn(f) { return typeof f === 'function'; }

  var diag = { appStyleInjected: false };

  /* ── Content-interaction lock (shared seam) ───────────────────────────────
     When the user acts on an IN-CONTENT control (a tab button, a data-source
     checkbox, a card/toggle), a wrapper pack — or the handler itself — may fire
     the core full render() on the same click, rebuilding the whole #app shell
     and swapping the sub-container node out from under the user. window.
     __twhContentInteract is a short-lived timestamp the v303 resolver sets on
     such a click; while it is hot, userActive() keeps the shell decorator
     honouring the LAST coalesced paint (state/scroll restored) so the click is
     never dropped. Extends the plain 350 ms gesture window to cover late
     wrapper-driven repaints. */
  function contentInteractHot() {
    try { return typeof window.__twhContentInteract === 'number' && (Date.now() - window.__twhContentInteract) < 700; } catch (_e) { return false; }
  }

  // SCOPE CHANGE (v323): fixed allowlist GONE; containers discovered
  // generically (see decorateAllContainers). Ids owned by other decorators are
  // skipped (#arContent→decorateAR, #moduleContent→v268, #app→decorateShell).
  var RESERVED_IDS = { app: 1, moduleContent: 1, arContent: 1, modalBg: 1, sidebar: 1, toast: 1 };

  /* ── (1) AR / Receivables stuck-spinner self-heal ───────────────────────── */
  // Matches the core's deferred spinner: <i class="fa-solid fa-spinner fa-spin"></i> Loading…
  var SPINNER_RE = /fa-spin|>\s*Loading/i;

  function healStuckAR() {
    if (!window.TWH_AR_HEAL) return false;
    var el = document.getElementById('arContent');
    if (!el) return false;
    if (!SPINNER_RE.test(el.innerHTML)) return false; // not stuck — nothing to do
    var tab = window._arTab || 'overview';
    // V26_arSetTab is on window (core 010) and synchronously repaints #arContent
    // using the real closure-scoped renderers. Because #arContent exists right
    // now, its internal `if(!_el) return` guard cannot bail early.
    if (isFn(window.V26_arSetTab)) {
      try {
        window.V26_arSetTab(tab);
        // If it repainted to real content, count it.
        var after = document.getElementById('arContent');
        if (after && !SPINNER_RE.test(after.innerHTML)) {
          return true;
        }
      } catch (e) {}
    }
    return false;
  }

  /* ── (2) Fast stable-page links open in a NEW tab (stay on main module) ─── */
  function openTab(url) {
    // Reuse v303's opener seam if present so all "open in new tab" behaviour is
    // observable / overridable through a single hook.
    try { if (isFn(window.__twhOpenTab)) { window.__twhOpenTab(url); return true; } } catch (_e) {}
    try {
      var w = window.open(url, '_blank');
      if (w) { try { w.opener = null; } catch (_e2) {} return true; }
    } catch (e) {}
    // Popup blocked → same-tab navigation so the link is never dead.
    try { window.location.assign(url); return true; } catch (_e3) {}
    return false;
  }

  // v265 (goRegister) and v266 (go) both call window.__twhNavigate(page) FIRST
  // when it is a function. Defining it here makes every "⚡ Fast … (stable page)"
  // launcher open in a new tab instead of replacing the current tab.
  function installNavSeam() {
    // Install unconditionally so the toggle can be flipped at runtime; the
    // toggle is honoured at call time (below), not at install time.
    if (window.__twhNavigate && window.__twhNavigate.__twhV305) return;
    var seam = function (page) {
      if (!window.TWH_FASTLINK_NEW_TAB) {
        // toggle off → fall back to same-tab navigation (seam-overridable)
        try { if (isFn(window.__twhSameTabNav)) { window.__twhSameTabNav(page); return; } } catch (_e) {}
        try { window.location.assign(page); return; } catch (_e2) {}
        try { window.location.href = page; return; } catch (_e3) {}
        return;
      }
      openTab(page);
    };
    seam.__twhV305 = true;
    try { window.__twhNavigate = seam; } catch (_e) {}
  }

  /* ── (3) APPLICATION-WIDE anti-shake stylesheet + AR scroll ─────────────────
     Extend the same anti-shake protection to EVERY page (Register Patients,
     Appointments, Laboratory, Radiology, Medical Record, Prescriptions,
     Reports, Transactions, …). Neutralise involuntary looping motion (shake /
     blink / flicker) on rows, cards and KPIs across the whole content area,
     while PRESERVING the intentional dirty-state Save & Commit pulse (scoped
     away from .dirty / [data-dirty] / .save-commit cues). Also folds in the AR
     scroll rules (req #5) — the long 14-tab bar scrolls horizontally on narrow
     viewports and #arContent scrolls smoothly with scrollable tables. */
  function injectAppWideAntiShakeCSS() {
    if (diag.appStyleInjected || document.getElementById('twhV305AppAntiShake')) { diag.appStyleInjected = true; return; }
    var css =
      '@media (prefers-reduced-motion:no-preference){' +
      '.main .tbl tbody tr,.main .kpi,.main .card,.main .cust-row{animation-name:none!important}' +
      '.dirty,.dirty *,[data-dirty],[data-dirty] *,.save-commit,.save-commit *{animation-name:revert!important}}' +
      '.ar-tabs-wrap .tab-row{overflow-x:auto;flex-wrap:nowrap}' +
      '.ar-tabs-wrap .tab-row .tab-btn{flex:none;white-space:nowrap}';
    try {
      var s = document.createElement('style');
      s.id = 'twhV305AppAntiShake';
      s.textContent = css;
      (document.head || document.documentElement).appendChild(s);
      diag.appStyleInjected = true;
    } catch (_e) {}
  }

  /* ── (4) scroll-stable, diff-guarded #arContent (kills AR flicker/shake) ──
     v268 makes ONLY #moduleContent scroll-stable + diff-guarded. The core's
     V26_arSetTab writes #arContent DIRECTLY (bypassing #moduleContent), so AR
     tab repaints can still (a) rewrite identical HTML → flicker, and (b) reset
     the window scroll → shake / jump. We decorate the LIVE #arContent element
     with an own-property innerHTML accessor that:
        • drops the write when the incoming HTML equals the current HTML
          (unless a real user action is in flight), and
        • snapshots window + inner-scroller positions before the write and
          restores them synchronously (and once more next frame) after — so the
          page never jumps while browsing Receivables.
     This mirrors v268 exactly but for the one container it does not cover. */
  var _protoDesc = null;
  try {
    _protoDesc = Object.getOwnPropertyDescriptor(Element.prototype, 'innerHTML') ||
                 Object.getOwnPropertyDescriptor(HTMLElement.prototype, 'innerHTML');
  } catch (_e) {}

  // User-activity signal: prefer the shared CORE source (v323 / 000c installs
  // window.__twhUserActive with the same capture listeners + content-interaction
  // window), so we don't install a duplicate set of global listeners. A tiny
  // local fallback covers the (never-in-practice) case where CORE is absent.
  function userActive() {
    try { if (isFn(window.__twhUserActive) && window.__twhUserActive !== userActive) return !!window.__twhUserActive(); } catch (_e) {}
    return contentInteractHot();
  }
  // sigStable(a,b): true when a rewrite is safe to DROP — either byte-identical,
  // or (when the shared v318 normaliser is present) the STABLE signatures match,
  // i.e. the two HTML strings differ ONLY in volatile substrings (clock strings,
  // "N mins ago", random ids). Dropping such rewrites is what stops the residual
  // content-area shake (write → mutation → DOMBus tick → write loop) on AR / the
  // shell / tab sub-containers, which have no deterministic-render shield.
  function sigStable(a, b) {
    if (a === b) return true;
    try {
      if (isFn(window.__twhStableSig)) return window.__twhStableSig(a) === window.__twhStableSig(b);
    } catch (_e) {}
    return false;
  }
  // Prefer the shared CORE seams (v323 / 000c): both-axis snapshot/restore keyed
  // by a STABLE data-scroll-id, so restore survives DOM reordering and the
  // horizontal offset of the Configuration pill strip / wide tables is kept.
  // Self-contained both-axis, index-keyed fallback if v323 is somehow absent.
  function scroller() {
    try { return document.scrollingElement || document.documentElement || document.body; } catch (_e) { return null; }
  }
  function snapScroll(root) {
    if (isFn(window.__twhScrollSnap)) {
      try { if (isFn(window.__twhTagScrollables)) window.__twhTagScrollables(root); } catch (_e) {}
      try { return window.__twhScrollSnap(root); } catch (_e) {}
    }
    var snap = { winX: 0, winY: 0, docTop: null, docLeft: null, inner: [] };
    try { snap.winX = window.pageXOffset || 0; snap.winY = window.pageYOffset || 0; } catch (_e) {}
    try { var sc = scroller(); if (sc) { snap.docTop = sc.scrollTop; snap.docLeft = sc.scrollLeft; } } catch (_e) {}
    try {
      if (root) {
        var nodes = root.querySelectorAll('*');
        for (var i = 0; i < nodes.length; i++) {
          var n = nodes[i];
          // Capture EITHER axis so a horizontally scrolled strip / wide table
          // keeps its scrollLeft across the write ("sideways keeps going back").
          if (n.scrollTop || n.scrollLeft) snap.inner.push({ i: i, top: n.scrollTop, left: n.scrollLeft });
        }
      }
    } catch (_e) {}
    return snap;
  }
  function restoreScroll(root, snap) {
    if (!snap) return;
    if (isFn(window.__twhScrollApply) && snap.inner && !Array.isArray(snap.inner)) {
      try { window.__twhScrollApply(root, snap); return; } catch (_e) {}
    }
    try { var sc = scroller(); if (sc && snap.docTop != null) { sc.scrollTop = snap.docTop; sc.scrollLeft = snap.docLeft; } } catch (_e) {}
    try { window.scrollTo(snap.winX || 0, snap.winY || 0); } catch (_e) {}
    try {
      if (root && Array.isArray(snap.inner) && snap.inner.length) {
        var nodes = root.querySelectorAll('*');
        for (var j = 0; j < snap.inner.length; j++) {
          var rec = snap.inner[j]; var n = nodes[rec.i];
          if (n) { n.scrollTop = rec.top; n.scrollLeft = rec.left; }
        }
      }
    } catch (_e) {}
  }
  // Generic scroll-stable, diff-guarded innerHTML decorator for ANY element.
  // Exposed as window.__twhScrollStable so sibling packs (e.g. v307's sidebar
  // new-tab handler) reuse this exact machinery instead of duplicating it.
  // opts: { flag: marker-property, enabled: fn()->bool, onWrite: fn(),
  //         coalesce: bool }
  //   coalesce:true → buffer rapid successive writes and paint only the LAST
  //   one per animation frame (used for the whole-shell #app root, where many
  //   packs re-run render() in one burst on navigation → 3-5× full rewrites =
  //   the visible blink/flicker). Off by default (sub-containers repaint once).
  function decorateStable(el, opts) {
    opts = opts || {};
    var flag = opts.flag || '__twhScrollStable';
    if (!el || el[flag]) return false;
    if (!_protoDesc || !isFn(_protoDesc.set) || !isFn(_protoDesc.get)) return false;
    var enabled = isFn(opts.enabled) ? opts.enabled : function () { return true; };
    var coalesce = !!opts.coalesce;
    var getNative = function () { return _protoDesc.get.call(el); };
    var setNative = function (v) { _protoDesc.set.call(el, v); };
    var raf = window.requestAnimationFrame || function (f) { return setTimeout(f, 16); };
    var pending = null, scheduled = false, pendSnap = null;
    function paint(html, snap) {
      try { setNative(html); } catch (_e) { try { setNative(html); } catch (_e2) {} }
      try { restoreScroll(el, snap); } catch (_e) {}
      try { raf(function () { try { restoreScroll(el, snap); } catch (_e) {} }); } catch (_e) {}
      try { if (isFn(opts.onWrite)) opts.onWrite(); } catch (_e) {}
    }
    function flush() {
      scheduled = false;
      if (pending == null) return;
      var html = pending; pending = null;
      var snap = pendSnap; pendSnap = null;
      try { var cur = getNative(); if (!userActive() && sigStable(html, cur)) return; } catch (_e) {}
      paint(html, snap);
    }
    try {
      Object.defineProperty(el, 'innerHTML', {
        configurable: true, enumerable: false,
        get: function () { return (coalesce && pending != null) ? pending : getNative(); },
        set: function (html) {
          if (!enabled()) { setNative(html); return; }
          try { var cur = (coalesce && pending != null) ? pending : getNative(); if (!userActive() && sigStable(html, cur)) return; } catch (_e) {}
          if (coalesce) {
            if (pending == null) { try { pendSnap = snapScroll(el); } catch (_e) { pendSnap = null; } }
            pending = html;
            if (!scheduled) { scheduled = true; try { raf(flush); } catch (_e) { flush(); } }
            return;
          }
          var snap = null;
          try { snap = snapScroll(el); } catch (_e) {}
          paint(html, snap);
        }
      });
      el[flag] = true;
      return true;
    } catch (_e) { return false; }
  }
  try { window.__twhScrollStable = decorateStable; } catch (_e) {}

  /* ── Whole-shell #app anti-flicker: coalesce + diff-guard the shell root ──
     goTo(mod)→render() rewrites #app.innerHTML (core 008). Many packs re-run
     render()/verify()/sweep() right after a nav (in the SAME frame), so #app is
     rebuilt 3-5× per navigation — the blink/flicker the user reported on
     Reports / Custom Report Builder / Configuration. Decorating #app with the
     coalescing variant collapses that burst into ONE paint. Toggle:
     window.TWH_SHELL_ANTIFLICKER (default true). */
  if (typeof window.TWH_SHELL_ANTIFLICKER === 'undefined') window.TWH_SHELL_ANTIFLICKER = true;
  function decorateShell() {
    if (!window.TWH_SHELL_ANTIFLICKER) return false;
    var el = document.getElementById('app');
    if (!el || el.__twhV305shell) return false;
    var ok = decorateStable(el, {
      flag: '__twhV305shell',
      coalesce: true,
      enabled: function () { return !!window.TWH_SHELL_ANTIFLICKER; }
    });
    return ok;
  }
  try { window.__twhDecorateShell = decorateShell; } catch (_e) {}

  function decorateAR() {
    var el = document.getElementById('arContent');
    if (!el || el.__twhV305stable) return false;
    var okDone = decorateStable(el, {
      flag: '__twhV305stable',
      enabled: function () { return !!window.TWH_AR_HEAL; }
    });
    return okDone;
  }

  /* ── application-wide sub-container scroll-stable decoration ──────────────
     Reuse the exact same decorateStable() machinery for every known tab
     sub-container id (see CONTAINER_IDS) so Transactions, Reports, Billing,
     Payables, HR, Appointments, AI, Hospital-at-Home, etc. all stop shaking
     and preserve scroll position on re-render. The shell re-creates these
     nodes on navigation, so the DOMBus ticker keeps them decorated. */
  function decorateAppContainer(el) {
    if (!el || el.__twhV305appStable) return false;
    var okDone = decorateStable(el, {
      flag: '__twhV305appStable',
      enabled: function () { return !!window.TWH_SCROLL_STABLE; }
    });
    return okDone;
  }

  // GENERIC (allowlist-free) sub-container discovery: decorate any id-bearing
  // node that follows the app's direct-write convention (id ends in
  // Content/Body/Panel) OR is a tagged scroll region — covering every module,
  // present and future, with no per-module code. Reserved ids are skipped.
  function decorateAllContainers() {
    if (!window.TWH_SCROLL_STABLE) return;
    try {
      var list = document.querySelectorAll('[id$="Content"],[id$="Body"],[id$="Panel"],[data-scroll-id][id]');
      for (var i = 0; i < list.length; i++) {
        var el = list[i], id = el.id;
        if (!id || RESERVED_IDS[id] || el.__twhV305appStable) continue;
        decorateAppContainer(el);
      }
    } catch (_e) {}
  }

  /* ── (5) PROACTIVE synchronous AR tab render — kill the spinner double-paint ─
     User request: "In Receivables (AR) page make all the tab pages active and
     not shake or blink; scroll should also be made better."

     ROOT CAUSE of the AR tab blink: for the 7 "classic" tabs (Overview, AR
     Invoices, Receipts, Aging, Customers, Statements, GL Posting) the core's
     V27_renderARTab() default case calls V27_callV26Tab(), which returns a
     "<i class='fa-spin'></i> Loading…" placeholder AND schedules
     setTimeout(()=>V26_arSetTab(tab),10). So the tab paints TWICE: spinner →
     (10 ms later) real content. That deferred second paint is the visible
     blink, and it also resets scroll.

     THE PERMANENT CURE: V26_arSetTab IS on window and synchronously repaints
     #arContent with the REAL closure renderers (renderARTab / V27_renderARTab)
     — with NO spinner and NO setTimeout. We wrap it so that after it runs, if
     #arContent still shows the deferred spinner (because the initial
     renderReceivables embedded V27_renderARTab(tab) which returned the
     placeholder), we IMMEDIATELY re-fill it synchronously in the same call —
     the spinner never survives to a paint. We also proactively heal the very
     first AR render (renderReceivables) the same way. Idempotent + guarded. */
  // Wrap V26_arSetTab so no spinner ever survives to a paint. For the 7 classic
  // tabs the core's V27 default returns a "Loading…" placeholder + a deferred
  // setTimeout re-render (the blink). After the core setter runs, if #arContent
  // still shows the spinner we re-run the setter SYNCHRONOUSLY in the same call
  // (guarded against re-entrancy) so the real content paints in one frame.
  function wrapArSetTab() {
    var fn = window.V26_arSetTab;
    if (!isFn(fn) || fn.__twhV305sync) return false;
    var wrapped = function (t) {
      var r = fn.apply(this, arguments);
      try {
        var el = document.getElementById('arContent');
        if (el && SPINNER_RE.test(el.innerHTML) && !window.__twhARSyncing) {
          window.__twhARSyncing = true;
          try { fn.call(this, t); } catch (_e) {} finally { window.__twhARSyncing = false; }
        }
      } catch (_e) {}
      return r;
    };
    wrapped.__twhV305sync = true;
    try { window.V26_arSetTab = wrapped; } catch (_e) {}
    return true;
  }

  /* ── boot: bounded retries + DOMBus + slow heartbeat (no new timers) ────── */
  function tick() {
    try { installNavSeam(); } catch (_e) {}
    try { injectAppWideAntiShakeCSS(); } catch (_e) {}
    try { wrapArSetTab(); } catch (_e) {}
    try { decorateShell(); } catch (_e) {}
    try { decorateAR(); } catch (_e) {}
    try { decorateAllContainers(); } catch (_e) {}
    try { healStuckAR(); } catch (_e) {}
  }

  installNavSeam();
  injectAppWideAntiShakeCSS();
  wrapArSetTab();
  decorateShell();
  decorateAllContainers();
  [150, 500, 1100, 2200, 4200].forEach(function (ms) { setTimeout(tick, ms); });
  try { window.addEventListener('load', function () { injectAppWideAntiShakeCSS(); wrapArSetTab(); setTimeout(tick, 350); }); } catch (_e) {}
  // Repaint a stuck AR spinner + re-decorate sub-containers whenever the DOM
  // changes (rides the shared observer — no new MutationObserver). We wrap
  // V26_arSetTab and PROACTIVELY heal the first AR render on the same sweep so
  // the spinner never survives to a paint (no blink), then fall back to the
  // reactive heal for any edge case.
  try { if (window.DOMBus && isFn(window.DOMBus.register)) window.DOMBus.register(function () { try { wrapArSetTab(); } catch (_e0) {} try { healStuckAR(); } catch (_e1) {} try { decorateAllContainers(); } catch (_e2) {} }); } catch (_e) {}
  // Slow safety heartbeat (≥10 s) — self-noops when nothing is stuck.
  try { if (window.HMS && isFn(window.HMS.every)) window.HMS.every(10000, tick); } catch (_e) {}
  try { if (window.HMS && isFn(window.HMS.on)) window.HMS.on('state:changed', function () { setTimeout(healStuckAR, 60); }); } catch (_e) {}

  window.__twhV305Diag = function () { return JSON.parse(JSON.stringify(diag)); };
})();

;

/* ==== /js/251-twh-hide-sidebar-username-v306.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   TWH · HIDE SIDEBAR USER NAME (v306)
   ────────────────────────────────────────────────────────────────────────
   User request (verbatim): "… but remove Yusuf Olasunkanmi Lawal".

   That text is the signed-in user's display name, rendered by the CORE shell
   (008) in the sidebar footer:

       <div class="sb-ft">
         <div class="sb-avatar">…</div>
         <div>
           <div class="sb-user">${D.currentUser.fullName}</div>   ← REMOVE
           <div class="sb-role">${D.currentUser.role}</div>       ← keep
         </div>
         … change-password / logout buttons …
       </div>

   The name is dynamic (it changes per signed-in user), and the shell is
   re-rendered on every navigation, so a one-shot DOM delete would reappear.
   008 is a CORE file that MUST NOT be edited, and the SPA CSS bundle
   (007-styles.css) is likewise off-limits. The robust, re-render-proof fix is
   therefore a persistent injected stylesheet that hides .sb-ft .sb-user. The
   role line (.sb-role) and the avatar/logout controls are untouched, so the
   footer still reads e.g. "System Administration" with its avatar and buttons.

   Append-only feature pack (guard window.__twhV306). No core / CSS-bundle /
   schema / /api/state / _redirects / worker / merge edits; no feature-pack
   reorder. Adds NO timers, NO MutationObserver — a single injected <style>
   does all the work; a couple of bounded re-checks re-inject the tag only if
   something removed it. Never wraps render / renderModule / goTo / doLogin.

   Guard: window.__twhV306        Diagnostics: window.__twhV306Diag()
   Toggle: window.TWH_HIDE_SIDEBAR_USERNAME (default true)
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV306) return;
  window.__twhV306 = true;

  if (typeof window.TWH_HIDE_SIDEBAR_USERNAME === 'undefined') window.TWH_HIDE_SIDEBAR_USERNAME = true;

  var STYLE_ID = 'twhV306HideUsername';
  var diag = { injected: 0, present: false, lastError: null };

  function isFn(f) { return typeof f === 'function'; }

  function apply() {
    try {
      var existing = document.getElementById(STYLE_ID);
      if (!window.TWH_HIDE_SIDEBAR_USERNAME) {
        // toggle off → remove the rule so the name shows again
        if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
        diag.present = false;
        return;
      }
      if (existing) { diag.present = true; return; }
      var s = document.createElement('style');
      s.id = STYLE_ID;
      // Hide ONLY the user-name line inside the sidebar footer. Keep .sb-role,
      // the avatar and the logout / change-password buttons.
      s.textContent = '.sb-ft .sb-user{display:none !important;}';
      (document.head || document.documentElement).appendChild(s);
      diag.injected++;
      diag.present = true;
    } catch (e) { diag.lastError = String(e && e.message || e); }
  }

  apply();
  // Re-inject only if the tag ever goes missing (bounded one-shots + DOMBus +
  // slow heartbeat). The stylesheet itself survives shell re-renders, so this
  // is just belt-and-braces — no per-frame work.
  [400, 1600].forEach(function (ms) { setTimeout(apply, ms); });
  try { if (window.DOMBus && isFn(window.DOMBus.register)) window.DOMBus.register(apply); } catch (_e) {}
  try { if (window.HMS && isFn(window.HMS.every)) window.HMS.every(15000, apply); } catch (_e) {}

  window.__twhV306Diag = function () { return JSON.parse(JSON.stringify(diag)); };
})();

;

/* ==== /js/252-twh-inapp-nav-delegation-v314.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   TWH · REQUEST-D CONSOLIDATION — Stages 2·3·4 in one governor-safe pack
   ────────────────────────────────────────────────────────────────────────
   Fixes the three reported behaviours by setting ONE authoritative policy so
   the existing packs stop fighting each other — it adds NO new click handler,
   it just points the ones already installed at the right, stable behaviour.

   • Stage 2 (v314) — IN-APP NAV (no reload, no login flash, no "clickable once"):
     sidebar / tile / profile module clicks should navigate via the SPA's own
     goTo() (in-app, SPA stays alive) instead of a full-page standalone load
     (which tears down the SPA, re-shows the login/gate flash, and detaches the
     just-wired handlers so the element "works once then needs a reload"). The
     in-app path already exists — v312's capture handler calls goTo() when the
     routing flags are OFF, and it resolves the module at click time (never
     caches a node), so a re-render can't orphan it. This pack simply PINS those
     flags OFF and keeps re-asserting them so no later pack flips them back on:
         TWH_TAB_ROUTING / TWH_SIDEBAR_NEW_TAB / TWH_SIDEBAR_SAME_TAB /
         TWH_FASTLINK_NEW_TAB / TWH_AUTO_RELOAD_ON_LOGIN = false.
     The rich record-entry forms (register.html, appointment.html, …) are still
     reached via the "Register / Add New" buttons (v265/v266) — unchanged.

   • Stage 3 (v315) — SILENCE PRE-LOGIN 401: while the secure gate is active
     (__HMS_GATE_LOGIN, or __HMS_AUTH.configured && !authenticated) a narrow fetch
     guard resolves GET/HEAD /api/state/… as a benign empty 200, so the expected
     401 never reaches the console and cannot start a reload-on-401 loop behind
     the login overlay. Writes and every other request pass straight through;
     server-side security is unchanged. Once signed in the gate clears and the
     guard is a no-op.

   • Stage 4 (v316) — ONE REPAINT/TAB-HEAL OWNER: pins TWH_NO_SHAKE_GATE=true so
     the core data-signature repaint gate (v309) always runs — that gate is the
     shake-killer (it skips a rebuild when the data signature is unchanged). Tab
     healing stays with the SINGLE existing owner (v303's bubble-phase resolver);
     we publish __twhTabHealOwner so no pack adds a second competing repair (the
     duplicate repair was itself a source of the blinking / disappearing tabs).

   Guards __twhV314/__twhV315/__twhV316 all set so existing probes/tests pass.

   Constraints honoured: no core / CSS / D1-schema / /api/state (server) /
   _redirects / worker edits; no feature-pack reorder; no setInterval /
   MutationObserver / DOMContentLoaded; never wraps render/renderModule/
   renderDashboard/goTo/doLogin.

   Diagnostics: window.__twhV314Diag() / __twhV315Diag() / __twhV316Diag()
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV314 && window.__twhV315 && window.__twhV316) return;
  window.__twhV314 = true; window.__twhV315 = true; window.__twhV316 = true;

  function isFn(f) { return typeof f === 'function'; }

  /* ── Stages 2 & 4: authoritative flag policy (register, don't wrap) ──── */
  var OFF = ['TWH_TAB_ROUTING', 'TWH_SIDEBAR_NEW_TAB', 'TWH_SIDEBAR_SAME_TAB', 'TWH_FASTLINK_NEW_TAB', 'TWH_AUTO_RELOAD_ON_LOGIN'];
  function pin() {
    try {
      for (var i = 0; i < OFF.length; i++) window[OFF[i]] = false;
      window.TWH_NO_SHAKE_GATE = true;
      // Suppress v303's speculative bubble-phase re-click — the last shake
      // source for Register Patient / Sort A-Z / action buttons. Honoured by
      // v303's onContentClick early-return, re-asserted on every pin() cycle so
      // no later pack can reintroduce the blink/double-fire.
      window.__twhNoContentReclick = true;
      if (!window.__twhTabHealOwner) window.__twhTabHealOwner = 'v303';
    } catch (_e) {}
  }
  pin();

  /* ── Stage 3: pre-login 401 fetch guard ──────────────────────────────── */
  var d315 = { installed: false, shortCircuited: 0 };
  (function installFetchGuard() {
    if (!isFn(window.fetch) || window.fetch.__twhGuarded || typeof Response === 'undefined') return;
    var native = window.fetch.bind(window);
    function gateActive() {
      try {
        if (window.__HMS_GATE_LOGIN) return true;
        var a = window.__HMS_AUTH;
        return !!(a && a.configured && !a.authenticated);
      } catch (_e) { return false; }
    }
    window.fetch = function (input, init) {
      try {
        var url = (typeof input === 'string') ? input : (input && input.url) || '';
        var m = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
        if (gateActive() && (m === 'GET' || m === 'HEAD') && /\/api\/state\//.test(url)) {
          d315.shortCircuited++;
          return Promise.resolve(new Response('{}', { status: 200, headers: { 'Content-Type': 'application/json' } }));
        }
      } catch (_e) {}
      return native(input, init);
    };
    try { window.fetch.__twhGuarded = true; } catch (_e) {}
    d315.installed = true;
  })();

  /* ── keep the policy pinned (governor-safe: shared bus + bounded one-shot) ── */
  setTimeout(pin, 1500);
  try { if (window.DOMBus && isFn(window.DOMBus.register)) window.DOMBus.register(pin); } catch (_e) {}
  try { if (window.HMS && isFn(window.HMS.every)) window.HMS.every(10000, pin); } catch (_e) {}

  window.__twhV314Diag = function () { return { tabRouting: window.TWH_TAB_ROUTING, sidebarNewTab: window.TWH_SIDEBAR_NEW_TAB, sidebarSameTab: window.TWH_SIDEBAR_SAME_TAB, autoReloadOnLogin: window.TWH_AUTO_RELOAD_ON_LOGIN }; };
  window.__twhV315Diag = function () { return { installed: d315.installed, shortCircuited: d315.shortCircuited }; };
  window.__twhV316Diag = function () { return { gatePinned: window.TWH_NO_SHAKE_GATE === true, tabHealOwner: window.__twhTabHealOwner || 'v303' }; };
})();

;

/* ==== /js/253-twh-dbsync-auto-5min-v317.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   TWH · DATABASE-SYNC AUTO PUSH / PULL EVERY 5 MINUTES (v317)
   ────────────────────────────────────────────────────────────────────────
   User request (verbatim): "Database sync - expand for push/pull should be 5mins".

   The docked "Database sync" control (v309, sidebar) exposes manual Push / Pull
   but there was no automatic cadence — records only reached D1 (and other tabs)
   when someone opened the dock and clicked. This pack adds a governor-safe
   AUTOMATIC push + pull on a fixed 5-minute interval, reusing the SAME public
   sync helpers the dock buttons call:
       • push  → window.__twhV309Push()  (falls back to window._hmsSave())
       • pull  → window.__twhV309Pull()  (falls back to window._hmsRefresh())

   Safety rules (all borrowed from the existing manual path, so behaviour is
   identical to a user clicking the buttons):
     • never before login / while the gate is active,
     • never while offline,
     • never while a modal / editor is open (a pull would clobber typing — the
       helpers already refuse, we also skip to avoid a wasted cycle),
     • push only when there is something to send (HMS.dirty) so an idle app makes
       no needless traffic; pull always runs so this tab catches other tabs' work.
   Push runs first (flush local → D1), then a short bounded delay, then pull
   (D1 → local) so the two directions never collide.

   Scheduling is the single sanctioned periodic engine — ONE HMS.every task at
   the 5-minute period (paused when the tab is hidden). No raw setInterval, no
   MutationObserver, no DOMContentLoaded. Never wraps render / renderModule /
   goTo / doLogin.

   Toggle:  window.TWH_AUTOSYNC_MS   (default 300000 = 5 min; set 0/false to disable)
   Guard:   window.__twhV317        Diagnostics: window.__twhV317Diag()
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV317) return;
  window.__twhV317 = true;

  var FIVE_MIN = 300000;
  if (typeof window.TWH_AUTOSYNC_MS === 'undefined') window.TWH_AUTOSYNC_MS = FIVE_MIN;

  function isFn(f) { return typeof f === 'function'; }
  var diag = { autoPushes: 0, autoPulls: 0, skips: 0, lastRun: 0, running: false };

  function enabled() {
    var v = window.TWH_AUTOSYNC_MS;
    return v !== false && v !== 0 && v !== '0';
  }
  function period() {
    var v = Number(window.TWH_AUTOSYNC_MS);
    return (isFinite(v) && v >= 10000) ? v : FIVE_MIN;
  }
  function online() {
    try { return ('onLine' in navigator) ? navigator.onLine : true; } catch (_e) { return true; }
  }
  function gateActive() {
    try {
      if (window.__HMS_GATE_LOGIN) return true;
      var a = window.__HMS_AUTH;
      return !!(a && a.configured && !a.authenticated);
    } catch (_e) { return false; }
  }
  function modalOpen() {
    try { return !!document.getElementById('modalBg'); } catch (_e) { return false; }
  }
  function blocked() {
    return !enabled() || !online() || gateActive() || modalOpen() ||
      !!(window.HMS_DB && window.HMS_DB.syncState === 'syncing');
  }
  function run(a, b) {
    if (isFn(window[a])) { try { window[a](); return true; } catch (_e) {} return true; }
    if (isFn(window[b])) { try { window[b](); return true; } catch (_e) {} }
    return false;
  }

  // One cycle: push (only if dirty) → bounded delay → pull. Push flushes local →
  // D1, pull refreshes D1 → local; the gap keeps the two directions from racing.
  function cycle() {
    if (diag.running || blocked()) { if (!diag.running) diag.skips++; return; }
    diag.running = true;
    diag.lastRun = Date.now();
    var dirty = true;
    try { if (window.HMS && typeof window.HMS.dirty === 'boolean') dirty = window.HMS.dirty; } catch (_e) {}
    try { if (dirty && run('__twhV309Push', '_hmsSave')) diag.autoPushes++; } catch (_e) {}
    setTimeout(function () {
      try { if (!modalOpen() && online() && !gateActive() && run('__twhV309Pull', '_hmsRefresh')) diag.autoPulls++; } catch (_e) {}
      diag.running = false;
    }, 4000);
  }

  // Single sanctioned periodic engine, at the configured (default 5-min) period.
  try { if (window.HMS && isFn(window.HMS.every)) window.HMS.every(period(), cycle); } catch (_e) {}

  window.__twhV317Diag = function () {
    var o = JSON.parse(JSON.stringify(diag));
    o.enabled = enabled(); o.effectivePeriod = period(); o.online = online();
    return o;
  };
})();

;

/* ==== /js/254-twh-fast-launchers-sidebar-v318.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   TWH · FAST LAUNCHERS IN THE SIDEBAR + STABLE-SIGNATURE ANTI-SHAKE (v318)
   ────────────────────────────────────────────────────────────────────────
   (A) FAST LINKS UNDER EACH MODULE — on each DOMBus tick applyLinks() inserts
       a "⚡ Fast …" button right AFTER its parent v188 module button (matched
       by data-mod), ONLY when missing/misplaced (diff-guarded → no shake), and
       removes it when the parent is absent or the entry's gate fn returns false.
   (B) STABLE-SIGNATURE NORMALISER → window.__twhStableSig(html): strips volatile
       substrings (clocks, "N mins ago", ISO dates, uuids) so v268/v305 compare a
       STABLE signature and drop redundant rewrites. One capped chained replace.
   Constraints: no core edits, no reorder, no new setInterval/MutationObserver.
   Idempotent. Guard: window.__twhV318.
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV318) return;
  window.__twhV318 = true;

  /* ── (B) STABLE-SIGNATURE NORMALISER (install first so v268/v305 see it) ──
     Collapse volatile substrings that change every render even when the data is
     identical (clock times, "N mins ago", ISO datetimes, weekday prefixes,
     counter ids, uuids, nonce attrs) so an unchanged screen → unchanged sig.
     One alternation regex (all → '') + one whitespace pass keeps it small. */
  var VOL = new RegExp(
    '\\d{1,2}:\\d{2}(:\\d{2})?\\s?[ap]?m?' +                    // clock times
    '|\\b\\d+\\s*(sec|min|hour|hr|day|week|month|year)[a-z]*\\s+ago\\b' +
    '|\\bjust now\\b' +
    '|\\b\\d{4}-\\d{2}-\\d{2}t[\\d:.]+z?\\b' +                  // ISO datetimes
    '|\\b(mon|tue|wed|thu|fri|sat|sun)[a-z]*,?\\s+' +          // weekday prefixes
    '|(id|for|aria-labelledby|aria-controls)="[^"]*?\\d{4,}[^"]*"' + // counter ids
    '|\\b[0-9a-f]{8}(-[0-9a-f]{4}){3}-[0-9a-f]{12}\\b' +       // uuids
    '|data-(ts|nonce|rand|key)="[^"]*"',                       // nonce attrs
    'gi');
  window.__twhStableSig = function (html) {
    if (html == null) return '';
    var s = String(html).slice(0, 400000);   // cap cost (no-op if already shorter)
    try { s = s.replace(VOL, '').replace(/\s+/g, ' '); } catch (_e) {}
    return s;
  };

  /* ── (A) FAST LINKS ────────────────────────────────────────────────────── */
  // ADMIN-ONLY GATE — the Fast Add User link may appear ONLY for admin /
  // superadmin accounts (the only roles allowed to create users). We reuse the
  // canonical super-role source of truth (window.__hmsIsSuperRole, installed by
  // v172/v178/v188) fed by the live current-user role, so the gate follows role
  // switches and role-simulation start/stop exactly like the rest of RBAC.
  function curRole() {
    try {
      var u = (window.currentUserObj && window.currentUserObj()) || (window.D && window.D.currentUser);
      if (u && u.role) return u.role;
    } catch (_e) {}
    return null;
  }
  // window.__hmsIsSuperRole is the canonical super-role gate (installed by the
  // v172/v178/v188 packs that run before any Fast link renders); tiny inline
  // fallback only if it is somehow absent.
  function isAdmin() {
    var role = curRole();
    try { if (typeof window.__hmsIsSuperRole === 'function') return !!window.__hmsIsSuperRole(role); } catch (_e) {}
    return String(role || '').toLowerCase().indexOf('admin') >= 0;
  }

  // PRESCRIPTIONS GATE — the Fast Prescription link may appear ONLY for users
  // who actually have the Prescriptions module (the request: "accessed by users
  // that have Prescriptions"). We reuse the SPA's canonical
  // window.hasModuleAccess('prescriptions') (respects module-enabled, per-user
  // overrides AND role responsibilities) so the gate follows role switches /
  // simulations / config changes exactly like the rest of the app. When that
  // helper is unavailable (very early boot), fall back to the same clinical +
  // pharmacy role set the standalone access-gate enforces.
  // Fallback role set (substring match, so short tokens subsume longer titles:
  // "pharmac" covers Pharmacist / Chief Pharmacist / Pharmacy Technician).
  var RX_RE = /doctor|consultant|physician|medical officer|registrar|nurse|pharmac|dispenser/;
  function canRx() {
    try { if (typeof window.hasModuleAccess === 'function') return !!window.hasModuleAccess('prescriptions'); } catch (_e) {}
    var role = String(curRole() || '').toLowerCase();
    return isAdmin() || (!!role && RX_RE.test(role));
  }

  // CANONICAL PER-MODULE GATE — each non-admin Fast pill is gated by the SPA's
  // window.hasModuleAccess(<module>) so a link shows ONLY for a user whose
  // role/overrides include that module. Admins pass all; pre-RBAC we allow (the
  // standalone page re-enforces via access-gate.js on open).
  function gateFor(mod) {
    if (isAdmin()) return true;
    try {
      if (typeof window.hasModuleAccess === 'function') return !!window.hasModuleAccess(mod);
    } catch (_e) {}
    return true;
  }

  // Each entry: parent module id (data-mod) + Fast link. RULE (per request:
  // "Only apply Fastlink HTML to users who have the main modules, while others
  // with no main modules shouldn't see it. like doctors shouldn't see
  // invoice") — a Fast pill shows ONLY for a user who actually holds the parent
  // main module. Entries with no explicit `gate` default to gateFor(mod), i.e.
  // the canonical window.hasModuleAccess(mod); on top of that applyLinks() only
  // injects a pill when the parent [data-mod=MOD] nav button is present, so a
  // role without the module (a Doctor has no `billing` → no Invoice pill; no
  // `patients` → no Register; etc.) never sees the link. Only two special
  // cases carry an explicit gate: Add User (admin-only) and Prescription
  // (canRx role fallback for very-early boot). `billing` (Invoice) uses the
  // default module gate so it follows exactly whoever holds the billing module.
  var FAST = [
    { mod: 'dashboard',     label: 'Add User',       page: '/add-user.html',       gate: isAdmin },
    { mod: 'patients',      label: 'Register',       page: '/register.html' },
    { mod: 'appointments',  label: 'Appointment',    page: '/appointment.html' },
    { mod: 'emr',           label: 'Medical Record', page: '/medical-record.html' },
    { mod: 'prescriptions', label: 'Prescription',   page: '/prescription.html',   gate: canRx },
    { mod: 'laboratory',    label: 'Lab Order',      page: '/laboratory.html' },
    { mod: 'radiology',     label: 'Radiology',      page: '/radiology.html' },
    { mod: 'billing',       label: 'Invoice',        page: '/billing.html' }
  ];

  // Navigation used by every injected Fast link (same-tab real navigation).
  window.twhFastNav = function (page) {
    try {
      if (page === '/register.html' && typeof window.twhOpenRegisterPage === 'function') {
        window.twhOpenRegisterPage(); return;
      }
      if (typeof window.twhOpenStandalonePage === 'function') {
        window.twhOpenStandalonePage(page); return;
      }
    } catch (_e) {}
    try { window.location.href = page; } catch (_e) {}
  };

  // Styling lives entirely in the CSS bundle (149-nav-scroll-fix-v322.css) so
  // the app3 JS chunk stays within budget and pills are styled before first
  // paint — no runtime <style> injection is needed here.
  function makeBtn(f) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'twh-fast-nav';
    b.setAttribute('data-fast-for', f.mod);
    b.title = 'Fast ' + f.label + ' (stable page)';
    b.innerHTML = '<i class="fa-solid fa-bolt"></i>Fast ' + f.label;
    b.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      window.twhFastNav(f.page);
    });
    return b;
  }

  function sidebarNav() {
    try {
      var sb = document.getElementById('sidebar') || document.querySelector('aside.sb');
      return sb ? sb.querySelector('nav') : null;
    } catch (_e) { return null; }
  }

  // Insert each Fast link immediately AFTER its parent module button, but ONLY
  // when it's missing or misplaced — so we never write on idle (no shake).
  function applyLinks() {
    var nav = sidebarNav();
    if (!nav) return;
    FAST.forEach(function (f) {
      // Match the module's nav button by its data-mod (covers every nav-button
      // class variant — .v186-nav / .v182-link / .sb-item — in one selector).
      var parent = nav.querySelector('[data-mod="' + f.mod + '"]');
      var existing = nav.querySelector('.twh-fast-nav[data-fast-for="' + f.mod + '"]');
      // Role gate: an explicit f.gate (Add User = admin, Prescription = canRx)
      // wins; otherwise default to the canonical per-module gate gateFor(f.mod)
      // so a pill shows only for a user who actually holds that module.
      var allowed = true;
      try { allowed = f.gate ? f.gate() : gateFor(f.mod); }
      catch (_e) { allowed = false; }
      if (!parent || !allowed) {
        // Parent module absent OR gate failed → the Fast link must not show.
        if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
        return;
      }
      if (existing) {
        if (parent.nextSibling === existing) return;             // already correct
        if (existing.parentNode) existing.parentNode.removeChild(existing); // misplaced
      }
      var btn = makeBtn(f);
      if (parent.nextSibling) parent.parentNode.insertBefore(btn, parent.nextSibling);
      else parent.parentNode.appendChild(btn);
    });
  }

  applyLinks();
  try { if (typeof window.DOMBus !== 'undefined' && typeof window.DOMBus.register === 'function') { window.DOMBus.register(applyLinks); } } catch (_e) {}
  [150, 400, 900, 1800, 6000].forEach(function (ms) { setTimeout(applyLinks, ms); });
  try { window.addEventListener('load', applyLinks); } catch (_e) {}

  window.__twhV318Diag = function () {
    return { active: true, currentRole: curRole(), isAdmin: isAdmin(), canRx: canRx() };
  };
})();

;

/* ==== /js/256-twh-one-click-nav-paint-v320.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   TWH · DETERMINISTIC ONE-CLICK NAV PAINT (v320)
   ────────────────────────────────────────────────────────────────────────
   User report:
     "Why are the application modules on the sidebar not one click to open …
      Also, do one click for the functions (sublink) on the dashboard."

   Every sidebar module button AND every dashboard function tile / sublink is
   an inline  onclick="goTo('<mod>')"  (see 144-block-6, 132-v182 for the
   sidebar; 117-twh-role-dashboards for the dashboard action tiles — some tiles
   chain a sub-tab, e.g. goTo('dietary');dietSetTab('assess')). So a SINGLE fix
   on goTo() covers both the sidebar and the dashboard sublinks.

   ── WHY A FIRST CLICK COULD FAIL TO PAINT ────────────────────────────────
   goTo(mod) sets currentMod then calls render(), which rebuilds the shell and
   paints renderModule() into #moduleContent. But render()/renderModule() are
   wrapped by the v290 recursion-breaker + the v229 render-coalescer + the v231
   governor. During the steady render storm (~40 packs call render()/syncNav()
   on every DOMBus tick) the re-entry depth counters are frequently NON-ZERO at
   the click instant, so the breaker COALESCES the click's own render (returns
   without painting) or serves the PREVIOUS module's cached body. The screen
   then stays on the old module until an idle tick or a 2nd click — the
   "modules need two clicks / a reload" symptom. v319 detects a stale body and
   RETRIES render() up to 5×; that is reactive and still loses the timing race
   on the FIRST click when the storm is dense.

   ── FIX — a direct, synchronous, authoritative paint at click time ───────
   Wrap goTo as the OUTERMOST handler and, for a genuine user navigation, PAINT
   THE TARGET MODULE'S BODY DIRECTLY into #moduleContent in the SAME synchronous
   turn — bypassing the coalesced render() for that ONE intentional paint, so
   there is no race to lose:
     1. mark __twhUserNav (one tick) — only user nav force-paints; the storm's
        own render() calls stay coalesced (that is what keeps the app fast).
     2. set currentMod = mod, drop THIS module's v290 cache + zero the depth
        counters (via __twhV290ResetCurrent) so renderModule() returns FRESH
        html for the target, never a cached/foreign body.
     3. run the real goTo (keeps the app's side-effects: shell rebuild via
        render(), _hmsSave(), runClinicalAlerts(), sidebar active-state, and any
        sub-tab chained after goTo in the tile's onclick).
     4. SYNCHRONOUSLY verify the body switched; if #moduleContent is still the
        pre-nav body / empty / the v290 "Loading module…" card, call
        renderModule() directly and write the string straight into
        #moduleContent — one clean paint, done before the click returns.
     5. a bounded rAF + one 50 ms fallback re-checks ONLY for the rare case the
        synchronous write itself was suppressed (e.g. #moduleContent not yet in
        the DOM because the shell rebuild is mid-flight). Single corrective
        paint per nav — can never loop with render().

   Because the paint is a direct innerHTML write of the FRESH module string, the
   very first click always lands, for EVERY module (sidebar links AND dashboard
   sublinks/tiles), independent of the render-storm timing.

   ── CONSTRAINTS ──────────────────────────────────────────────────────────
   Wraps ONLY window.goTo (never render / renderModule / renderDashboard /
   doLogin). Never copies flags via `for (k in fn)`. No core / CSS-file / D1 /
   /api/state / _redirects / worker / pack-order edits. No raw setInterval /
   MutationObserver / DOMContentLoaded — rides the shared DOMBus ticker + a few
   bounded one-shot setTimeouts + rAF. Idempotent; guard __twhV320. Loads LAST
   (pack 256) so it sits outermost over v319; if a later pack re-wraps goTo we
   re-assert outermost on the next boot tick.

   Guard: window.__twhV320   Diagnostics: window.__twhV320Diag()
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV320) return;
  window.__twhV320 = true;

  function isFn(f) { return typeof f === 'function'; }
  var diag = { navs: 0, directPaints: 0, fallbackPaints: 0, lastMode: '' };
  window.__twhV320Diag = function () { return diag; };
  // v320 SUPERSEDES v319 (the earlier retry-render single-click owner): the
  // direct synchronous paint below is strictly stronger than v319's up-to-5×
  // render() retry, so v319 is retired from the boot manifest. Publish the v319
  // guard so any lingering probe that asks "is single-click armed?" sees an owner.
  window.__twhV319 = true;

  function curMod() {
    try {
      var m = (window.currentMod != null) ? window.currentMod : (window.D && window.D.currentMod);
      if (m != null) return String(m);
    } catch (e) {}
    return 'dashboard';
  }

  // Drop the target module's v290 cache + zero the depth counters so a direct
  // renderModule() call returns FRESH html (not cached / not coalesced). Safe:
  // goTo runs at the TOP of the stack from a click, never inside a live render.
  function freshDepth() {
    try { if (isFn(window.__twhV290ResetCurrent)) window.__twhV290ResetCurrent(); } catch (e) {}
    try { window.__twhV290Depth = 0; window.__twhV290RenderDepth = 0; } catch (e) {}
  }

  // True when a string is a v290/v291 recovery card ("Loading module…" /
  // "…stabilised automatically" / "…recovered automatically") — NOT a real body.
  function isCard(s) { return /Loading module|d automatically/i.test(s); }

  // Body clearly not painted for a fresh route: empty or the v290 recovery card.
  function bodyLooksUnpainted() {
    try {
      var mc = document.getElementById('moduleContent');
      if (!mc) return true;
      var t = (mc.textContent || '').trim();
      return !t || isCard(t);
    } catch (e) { return false; }
  }

  // Direct, authoritative paint: write the FRESH module string straight into
  // #moduleContent, bypassing the coalesced render(). Returns true only if it
  // wrote a REAL body (never a recovery card — that would just re-pin "Loading
  // module…"). freshDepth() first zeroes the v290/v291 depth + clears this
  // route's cache/escape-latch so renderModule() re-runs the real switch at
  // depth 0 rather than serving a cached/coalesced card.
  // Authoritative paint. PRIMARY: the pristine core switch captured by v321
  // (009z) at forced depth 0, bypassing the whole v290/v291 wrapper stack — it
  // can never return a "Loading module…" card, so the 1st click on ANY module
  // lands a real body regardless of storm timing. FALLBACK (v321 absent): the
  // (wrapped) renderModule at reset depth, rejecting any recovery card.
  function directPaint() {
    try { if (window.__twhAuthoritativePaint && window.__twhAuthoritativePaint()) return true; } catch (e) {}
    try {
      var mc = document.getElementById('moduleContent');
      if (mc && isFn(window.renderModule)) {
        freshDepth();
        var html = window.renderModule();
        if (typeof html === 'string' && html.length && !isCard(html)) { mc.innerHTML = html; return true; }
      }
    } catch (e) {}
    return false;
  }

  var bodyBefore = '';
  function bodyHTML() {
    try { var mc = document.getElementById('moduleContent'); return mc ? mc.innerHTML : ''; }
    catch (e) { return ''; }
  }
  // Should we take over the paint? Yes when the body is empty / the v290
  // "Loading module…" card, OR this is a CROSS-module nav whose body did NOT
  // change after the app's own render ran (render() was coalesced/capped and
  // left the previous module's body). If the body already switched cleanly
  // (before !== after on a cross-module nav) the app painted it — no waste.
  // Same-module re-clicks fall through (no needless repaint).
  function shouldPaint(fromMod, toMod) {
    if (bodyLooksUnpainted()) return true;
    return toMod !== fromMod && bodyHTML() === bodyBefore;
  }

  function install() {
    if (!isFn(window.goTo)) return false;
    if (window.goTo.__v320) return true;
    var inner = window.goTo;
    var wrapped = function (mod) {
      diag.navs++;
      var fromMod = curMod();
      var toMod = (mod != null) ? String(mod) : fromMod;

      // 1) mark intentional user nav for this synchronous turn.
      window.__twhUserNav = true;
      // 2) fresh depth + drop this route's stale cache BEFORE the app renders,
      //    so nothing in the chain can coalesce or cache-serve the paint.
      freshDepth();
      // Snapshot the body so we can tell if the app's own render actually
      // repainted it (changed) or was coalesced (left the old body untouched).
      bodyBefore = bodyHTML();

      // 3) run the real navigation (sets currentMod + render() + side-effects +
      //    any sub-tab call chained after goTo in a dashboard tile's onclick).
      var out;
      try { out = inner.apply(this, arguments); }
      catch (e) { out = undefined; }

      // 4) SYNCHRONOUS verification + direct paint — lands before the click
      //    returns, so the FIRST click always shows the target module.
      try {
        if (shouldPaint(fromMod, toMod)) {
          if (directPaint()) { diag.directPaints++; diag.lastMode = 'direct'; }
        } else { diag.lastMode = 'ok'; try { if (isFn(window.syncNav)) window.syncNav(); } catch (e) {} }
      } catch (e) {}

      // 5) bounded fallback: ONLY if the body is still empty / a recovery card
      //    (e.g. the shell was mid-rebuild so the sync write could not land, or
      //    renderModule kept returning the v290 card under a dense storm). One
      //    rAF + one 50 ms timeout, a single direct re-paint — never loops. If
      //    even that cannot land a real body, the v300 route-body verifier
      //    (which now covers emr) force-repaints on its next pass. Also releases
      //    __twhUserNav.
      var heal = function () {
        try {
          if (bodyLooksUnpainted() && directPaint()) { diag.fallbackPaints++; diag.lastMode = 'fallback'; }
        } catch (e) {}
        window.__twhUserNav = false;
      };
      // One bounded 50 ms settle for the rare shell-mid-rebuild case; the step-4
      // synchronous directPaint handles the normal path. heal is idempotent.
      try { setTimeout(heal, 50); } catch (e) {}
      return out;
    };
    wrapped.__v320 = true;
    // Preserve the flags earlier wrappers probe (016/140/142/144/246/247) so
    // they never re-wrap on top of us and defeat the outermost guarantee.
    wrapped.__v34 = inner.__v34; wrapped.__v186 = inner.__v186; wrapped.__v187 = inner.__v187;
    wrapped.__v188 = inner.__v188; wrapped.__v300 = inner.__v300; wrapped.__v301 = inner.__v301;
    window.goTo = wrapped;
    return true;
  }

  // Boot + re-assert outermost across the staggered boot window (so if a later
  // pack wraps goTo on top of us, we climb back to outermost on the next tick).
  function tick() { try { install(); } catch (e) {} }
  tick();
  [400, 1400, 3000, 6500].forEach(function (ms) { try { setTimeout(tick, ms); } catch (e) {} });
  // DOMBus fires tick continuously (covers the window 'load' re-assert too).
  try { if (window.DOMBus && isFn(window.DOMBus.register)) window.DOMBus.register(tick); } catch (e) {}
})();

;

/* ==== /js/257-twh-lab-panel-parameters-v354.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   TWH v354 — Laboratory Enter-Results: PANEL PARAMETERS auto-expansion.
   ------------------------------------------------------------------------
   USER REQUEST (verbatim):
     "Implement on the Enter Result for the order lab test form to have tests
      on these parameters from the Excel test ( Parameters should be based on
      the Enter Results, also update the result output)"

   ── WHAT THIS PACK DOES ─────────────────────────────────────────────────
   The Enter-Results modal (008) seeds ONE row per ordered test and lets the
   technician "Add laboratory test" from the catalogue. Multi-analyte panels
   (FULL BLOOD COUNT, LIVER FUNCTION TEST, URINE M/C/S, SEMEN ANALYSIS, WIDAL,
   HEPATITIS B PROFILE, …) used to arrive as a SINGLE blank row.

   This pack ships the panel→parameter map extracted from the hospital's own
   workbook ("SOME TESTS WITH THEIR PARAMETERS.xlsx", 32 panels / 286
   analytes) and expands a panel into:
       • a bold PANEL HEADER row (name only, no result) — for the printed
         report grouping, and
       • one row PER PARAMETER, pre-filled with its Unit + Reference Values.

   Expansion happens in BOTH entry paths:
       1) picking a panel from the "Add laboratory test" dropdown
          (wraps window.labResultAddFromCatalog), and
       2) opening the modal on an ordered panel test
          (a bounded, one-shot post-open sweep that turns the single seeded
           panel row into its full parameter set — only when that row still
           has NO result, so saved results are never clobbered).

   The stored line format is unchanged ("Name: Result | Unit | Ref"), so the
   printed LABORATORY REPORT (labReportHTML) renders every parameter as its
   own row automatically — the "result output" is updated for free.

   Governor-safe: NO perpetual timers, NO DOM observers, NO recursion. One
   bounded setTimeout for late-arriving CORE helpers, plus the shared DOMBus
   hook used by v343. Guard window.__twhV354.
   Diagnostics: window.__twhV354Panel(name)  → resolved panel or null.
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV354) return;
  window.__twhV354 = true;

  function isFn(f) { return typeof f === 'function'; }

  /* ── Panel dataset (LAZY-LOADED) ─────────────────────────────────────────
     The 32-panel / 286-analyte reference table extracted from the hospital
     workbook is served as a static, un-bundled JSON (public/lab-panel-
     parameters.json → dist root). Keeping it OUT of the JS bundle means it
     never weighs on the initial-load size budget, and it is only ever fetched
     when the laboratory workflow is actually used. Shape:
         { "PANEL NAME": [["param","unit","ref"], …], … }
     We prefetch it on first idle and also on first Enter-Results open; every
     successful load re-runs the expansion sweep so an already-open modal fills
     in the moment the data arrives. */
  function norm(s) { return String(s == null ? '' : s).toLowerCase().replace(/[^a-z0-9]/g, ''); }

  var PANELS = [];        // [{name,params:[{n,u,r}]}]
  var BY_NORM = {};       // normalised full name  -> panel
  var BY_ABBR = {};       // parenthetical abbrev  -> panel  (e.g. "lft","fbc")
  var LOADED = false;
  var LOADING = false;

  function ingest(map) {
    if (!map || typeof map !== 'object') return;
    Object.keys(map).forEach(function (name) {
      var rows = map[name] || [];
      var params = rows.map(function (r) {
        return { n: (r[0] || '').trim(), u: (r[1] || '').trim(), r: (r[2] || '').trim() };
      });
      var panel = { name: name, params: params };
      PANELS.push(panel);
      var nn = norm(name);
      if (nn && !BY_NORM[nn]) BY_NORM[nn] = panel;
      var re = /\(([^)]+)\)/g, m;
      while ((m = re.exec(name))) {
        var ab = norm(m[1]);
        if (ab && ab.length >= 2 && !BY_ABBR[ab]) BY_ABBR[ab] = panel;
      }
    });
    LOADED = true;
  }

  function loadPanels(cb) {
    if (LOADED) { if (cb) cb(); return; }
    if (LOADING) { return; }
    LOADING = true;
    try {
      fetch('/lab-panel-parameters.json', { credentials: 'same-origin' })
        .then(function (r) { return r && r.ok ? r.json() : null; })
        .then(function (map) {
          LOADING = false;
          if (map) {
            ingest(map);
            try { if (typeof window.__twhV354AfterLoad === 'function') window.__twhV354AfterLoad(); } catch (e) {}
            if (cb) cb();
          }
        })
        .catch(function () { LOADING = false; });
    } catch (e) { LOADING = false; }
  }
  window.__twhV354Load = loadPanels;


  /* Resolve an ordered/catalogue test name to a panel, tolerant of the small
     naming differences between the workbook and the catalogue:
       "FULL BLOOD COUNT (FBC)"  → FULL BLOOD COUNT   (drop-parenthetical)
       "E/U/Cr (Electrolytes…)"  → E/U/CR             (drop-parenthetical)
       "LIVER FUNCTION TEST (LFT)" exact, or via "lft" abbrev
     Order: exact-norm → norm-without-parenthetical → abbrev token → null. */
  function resolvePanel(name) {
    if (!name) return null;
    var n = norm(name);
    if (BY_NORM[n]) return BY_NORM[n];
    // strip any "( … )" and retry on the base name
    var base = String(name).replace(/\([^)]*\)/g, ' ').trim();
    var bn = norm(base);
    if (bn && BY_NORM[bn]) return BY_NORM[bn];
    // try each parenthetical token as an abbreviation
    var re = /\(([^)]+)\)/g, m;
    while ((m = re.exec(String(name)))) {
      var ab = norm(m[1]);
      if (ab && BY_ABBR[ab]) return BY_ABBR[ab];
    }
    return null;
  }
  window.__twhV354Panel = resolvePanel;
  window.__twhV354Panels = PANELS;

  /* ── Row building ──────────────────────────────────────────────────────── */
  // Build panel rows: a bold HEADER row (name only) + one row per parameter.
  // Uses the CORE helper _lrRowHTML so styling/escaping stay identical. We must
  // call the pre-wrap builder (see rawRowHTML) — never the wrapped window
  // reference — otherwise a panel-name header row would recurse back into panel
  // expansion. rawRowHTML is captured the moment we install the wrap.
  var rawRowHTML = null;
  function panelRowsHTML(panel) {
    var build = rawRowHTML || window._lrRowHTML;
    if (!panel || !isFn(build)) return '';
    var html = build.call(null, panel.name, '', '', ''); // group/header row (no result)
    panel.params.forEach(function (p) {
      html += build.call(null, p.n, '', p.u, p.r);
    });
    return html;
  }
  window.__twhV354PanelRowsHTML = panelRowsHTML;

  /* ── Path 1: "Add laboratory test" dropdown ────────────────────────────── */
  // Wrap labResultAddFromCatalog so picking a PANEL appends the whole set of
  // parameter rows. Non-panel tests fall through to the previous behaviour
  // (v343 single-analyte unit/ref fill).
  function wrapAddFromCatalog() {
    var orig = window.labResultAddFromCatalog;
    if (!isFn(orig) || orig.__v354) return;
    var wrapped = function (sel) {
      if (sel && sel.value) {
        if (!LOADED) loadPanels(); // dataset not cached yet — start it
        var panel = resolvePanel(sel.value);
        if (panel && panel.params.length) {
          // Append the header + every parameter row straight into the grid
          // using the pre-wrap builder (panelRowsHTML), so a single dropdown
          // pick yields the whole panel and never recurses.
          var tb = document.getElementById('lr_rows');
          if (tb) {
            var frag = document.createElement('tbody');
            frag.innerHTML = panelRowsHTML(panel);
            var newRows = frag.querySelectorAll('tr.lr-row');
            for (var k = 0; k < newRows.length; k++) tb.appendChild(newRows[k]);
            sel.value = '';
            return;
          }
        }
      }
      return orig.call(this, sel);
    };
    wrapped.__v354 = true;
    wrapped.__v343 = true; // block a later v343 sweep from double-wrapping
    window.labResultAddFromCatalog = wrapped;
  }

  /* ── Path 2: modal seeds an ordered panel as a single row ──────────────── */
  // enterLabResult() (CORE) seeds each pending test by calling
  // window._lrRowHTML(name,'','','') and concatenating the returned markup.
  // We wrap that CORE helper (already window-exposed, so this is bundle-safe
  // and layered cleanly on top of v343's own wrap) so that when it is asked to
  // seed a BLANK row (no result/unit/ref) whose name resolves to a known panel,
  // it returns the panel HEADER row + one row PER PARAMETER instead of a single
  // empty row. Rows that carry a saved result/unit/ref (editing a completed
  // report, or the v343 single-analyte fill) are passed straight through, so
  // existing results are never clobbered and non-panel tests are unaffected.
  function wrapRowHTMLForPanels() {
    var orig = window._lrRowHTML;
    if (!isFn(orig) || orig.__v354) return;
    rawRowHTML = orig; // pre-wrap builder — used by panelRowsHTML (avoids recursion)
    var wrapped = function (name, result, unit, ref) {
      var blank = (result == null || String(result) === '') &&
                  (unit == null || String(unit) === '') &&
                  (ref == null || String(ref) === '');
      if (blank && name) {
        var panel = resolvePanel(name);
        if (panel && panel.params.length) {
          return panelRowsHTML(panel); // header + every parameter row
        }
      }
      return orig.call(this, name, result, unit, ref);
    };
    wrapped.__v354 = true;
    // Carry v343's marker too so a later v343 DOMBus sweep treats our wrapper as
    // already-wrapped and never double-wraps _lrRowHTML.
    wrapped.__v343 = true;
    window._lrRowHTML = wrapped;
  }

  /* ── DOM re-expansion for an already-open modal ────────────────────────── */
  // When the dataset arrives AFTER the modal has painted (first-ever open races
  // the lazy fetch), or right after enterLabResult() seeds rows, walk #lr_rows
  // and replace any BLANK single row whose Test name resolves to a panel with
  // that panel's header + parameter rows. Rows carrying a saved result/unit/ref
  // are left untouched, so a completed report is never clobbered.
  function expandOpenModal() {
    try {
      if (!LOADED) return;
      var tb = document.getElementById('lr_rows');
      if (!tb || !tb.querySelectorAll) return;
      var rows = tb.querySelectorAll('tr.lr-row');
      if (!rows || !rows.length) return;
      var list = [];
      for (var i = 0; i < rows.length; i++) list.push(rows[i]);
      list.forEach(function (tr) {
        if (tr.getAttribute('data-v354') === '1') return; // already a panel row
        var nameEl = tr.querySelector('.lr-name');
        var resEl = tr.querySelector('.lr-result');
        var unitEl = tr.querySelector('.lr-unit');
        var refEl = tr.querySelector('.lr-ref');
        if (!nameEl) return;
        var nm = String(nameEl.value || '').trim();
        var hasData = (resEl && String(resEl.value || '').trim()) ||
                      (unitEl && String(unitEl.value || '').trim()) ||
                      (refEl && String(refEl.value || '').trim());
        if (!nm || hasData) return;
        var panel = resolvePanel(nm);
        if (!panel || !panel.params.length) return;
        var frag = document.createElement('tbody');
        frag.innerHTML = panelRowsHTML(panel);
        var newRows = frag.querySelectorAll('tr.lr-row');
        if (!newRows.length) return;
        for (var k = 0; k < newRows.length; k++) {
          newRows[k].setAttribute('data-v354', '1');
          tr.parentNode.insertBefore(newRows[k], tr);
        }
        tr.parentNode.removeChild(tr);
      });
    } catch (e) { /* never break the modal */ }
  }
  window.__twhV354ExpandOpen = expandOpenModal;
  // Called by loadPanels() the moment the dataset finishes loading.
  window.__twhV354AfterLoad = expandOpenModal;

  /* Wrap enterLabResult so we (a) kick off the dataset load and (b) re-expand
     the freshly-painted modal once data is available (bounded microtask, no
     perpetual timer). The synchronous _lrRowHTML wrap handles the common case
     where the dataset is already cached; expandOpenModal covers the cold race. */
  function wrapEnterLabResult() {
    var orig = window.enterLabResult;
    if (!isFn(orig) || orig.__v354) return;
    var wrapped = function () {
      var r = orig.apply(this, arguments);
      loadPanels(function () { setTimeout(expandOpenModal, 0); });
      setTimeout(expandOpenModal, 0);
      return r;
    };
    wrapped.__v354 = true;
    window.enterLabResult = wrapped;
  }

  function sweep() { wrapAddFromCatalog(); wrapRowHTMLForPanels(); wrapEnterLabResult(); }

  sweep();
  setTimeout(sweep, 600);
  try {
    if (typeof DOMBus !== 'undefined' && DOMBus && isFn(DOMBus.register)) DOMBus.register(sweep);
  } catch (e) {}

  /* Prefetch the dataset when the browser is idle so the first Enter-Results
     open is instant. Single one-shot; never polls. */
  try {
    var kick = function () { loadPanels(); };
    var ric = window['requestIdleCallback'];
    if (typeof ric === 'function') ric(kick, { timeout: 4000 });
    else setTimeout(kick, 1500);
  } catch (e) {}

  try {
    console.log('%c🧪 TWH v354 lab-panel-parameters — lazy dataset wired (fetch /lab-panel-parameters.json on demand)',
      'background:#4c1d95;color:#fff;padding:2px 7px;border-radius:5px;font-weight:bold');
  } catch (e) {}
})();

;

/* ==== /js/258-twh-transactions-tabs-filter-v355.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   TWH · TRANSACTIONS / FINANCE — functional tabs + working filter   (v355)
   ────────────────────────────────────────────────────────────────────────
   User bug report (two screenshots of the Finance "Transactions" workspace):
     • Tab strip: "All Transactions · Receivables → Receipt → GL ·
       Payables → Pay → GL · GL Reconcile & Reports · Receipts ·
       Refunds & Adjustments · Daily Cash-Up · Credit Notes".
     • Filter toolbar: [dd/mm/yyyy] to [dd/mm/yyyy]  [All Methods ▾]
       [All Status ▾]  [▼ Filter].
     "Fix all this to be functional and active. When clicked, it should open
      the page once."

   TWO ROOT CAUSES
   ───────────────
   1. FILTER IS A NO-OP.  008 defines:
        function applyTxnFilter(){ toast('Filter applied'); }
      The date-range, Method and Status controls (id txnFilterFrom / txnFilterTo
      / txnFilterMethod / txnFilterStatus) are read by NOTHING — clicking
      "Filter" only pops a toast and the table never changes.

   2. TABS RELY ON `event.target` FOR THE ACTIVE PILL.  008's showTxnTab does:
        try{ if(event&&event.target) event.target.classList.add('active'); }
      When the v324 universal sub-tab persistence re-applies the chosen tab
      PROGRAMMATICALLY (fn(want) — no DOM event), `event.target` is undefined,
      so NO pill gets `.active`. v324 then sees the active tab "drifted" from
      what the user chose and re-invokes showTxnTab again on the next DOMBus
      tick … a repaint-loop that makes the content pane flicker / re-open
      repeatedly. Hence "it should open the page once."

   PERMANENT FIX (decorator only — no core edits, no data changes)
   ───────────────────────────────────────────────────────────────
   • applyTxnFilter(): real client-side filter over the rendered table
     (#txnTableWrap): keeps only rows whose Date ∈ [from,to], Method matches
     the Method dropdown, and Status matches the Status dropdown. Empty controls
     mean "no constraint". Shows a live "N of M" count + a "Clear" affordance,
     and toasts the result. Also bound to the controls' change events so the
     table updates the moment a value is picked (Filter button re-applies too).
   • showTxnTab()/GL-extension tabs: after the inner switcher runs, set `.active`
     deterministically by MATCHING the tab key against each button's onclick —
     independent of any DOM event — so the highlighted pill always agrees with
     the visible pane. This makes the v324 re-apply idempotent (active === want)
     and the flicker/re-open loop stops: the page opens exactly once.

   CONTRACT: idempotent (window.__twhV355txn); NO setInterval / MutationObserver
   (rides DOMBus + bounded one-shot timers); wraps existing globals only; never
   touches D / state-worker / redirects / manifest order.
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV355txn) return;
  window.__twhV355txn = true;

  function isFn(f) { return typeof f === 'function'; }
  function byId(id) { try { return document.getElementById(id); } catch (_e) { return null; } }
  function gv(id) { var el = byId(id); return el ? String(el.value || '') : ''; }

  /* ── header cell → column index map for the "All Transactions" table ─────
     Read the <thead> live so we survive column re-orders. Falls back to the
     known 008 layout if headers can't be read. */
  function colMap(tbl) {
    var map = { date: -1, method: -1, status: -1 };
    try {
      var ths = tbl.tHead ? tbl.tHead.querySelectorAll('th') : [];
      for (var i = 0; i < ths.length; i++) {
        var t = (ths[i].textContent || '').trim().toLowerCase();
        if (map.date === -1 && t === 'date') map.date = i;
        else if (map.method === -1 && t === 'method') map.method = i;
        else if (map.status === -1 && t === 'status') map.status = i;
      }
    } catch (_e) {}
    // 008 default: #,Code,Patient,Type,Category,Method,Amount,BillRef,Reference,Status,Date,Cashier,Actions
    if (map.method === -1) map.method = 5;
    if (map.status === -1) map.status = 9;
    if (map.date === -1) map.date = 10;
    return map;
  }

  function cellText(tr, idx) {
    try {
      if (idx < 0) return '';
      var td = tr.children && tr.children[idx];
      return td ? (td.textContent || '').trim() : '';
    } catch (_e) { return ''; }
  }

  // A transaction date cell is a plain ISO-ish date ("2026-08-22"); compare as
  // strings after normalising to YYYY-MM-DD (works for lexicographic range).
  function normDate(s) {
    s = String(s || '').trim();
    var m = s.match(/(\d{4})[-/](\d{1,2})[-/](\d{1,2})/);
    if (m) return m[1] + '-' + ('0' + m[2]).slice(-2) + '-' + ('0' + m[3]).slice(-2);
    return s;
  }

  /* ── the working filter ──────────────────────────────────────────────── */
  function runTxnFilter(opts) {
    var wrap = byId('txnTableWrap');
    if (!wrap) return null;                       // filter bar not on this tab
    var tbl = wrap.querySelector('table');
    if (!tbl || !tbl.tBodies || !tbl.tBodies[0]) return null;

    var from = normDate(gv('txnFilterFrom'));
    var to   = normDate(gv('txnFilterTo'));
    var method = gv('txnFilterMethod').trim();
    var status = gv('txnFilterStatus').trim();
    var cm = colMap(tbl);

    var rows = tbl.tBodies[0].rows;
    var total = 0, shown = 0;
    for (var i = 0; i < rows.length; i++) {
      var tr = rows[i];
      if (tr.getAttribute && tr.getAttribute('data-txn-empty') === '1') continue;
      // skip a placeholder "no rows" row (single wide cell)
      if (tr.children && tr.children.length <= 2) continue;
      total++;
      var ok = true;
      if (from || to) {
        var d = normDate(cellText(tr, cm.date));
        if (from && d && d < from) ok = false;
        if (to && d && d > to) ok = false;
        if ((from || to) && !d) ok = false;
      }
      if (ok && method) {
        var mv = cellText(tr, cm.method);
        if (mv.toLowerCase().indexOf(method.toLowerCase()) === -1) ok = false;
      }
      if (ok && status) {
        var sv = cellText(tr, cm.status);
        if (sv.toLowerCase() !== status.toLowerCase()) ok = false;
      }
      tr.style.display = ok ? '' : 'none';
      if (ok) shown++;
    }

    // live count badge next to the Filter button
    var active = !!(from || to || method || status);
    updateFilterBadge(shown, total, active);

    if (!opts || !opts.silent) {
      try {
        if (isFn(window.toast)) {
          window.toast(active ? ('Showing ' + shown + ' of ' + total + ' transaction' + (total === 1 ? '' : 's'))
                              : 'Filter cleared — showing all ' + total);
        }
      } catch (_e) {}
    }
    return { shown: shown, total: total, active: active };
  }

  function updateFilterBadge(shown, total, active) {
    try {
      var btn = document.querySelector('button[onclick*="applyTxnFilter"]');
      if (!btn) return;
      var bar = btn.parentNode;
      if (!bar) return;
      var badge = bar.querySelector('#txnFilterCount');
      if (!badge) {
        badge = document.createElement('span');
        badge.id = 'txnFilterCount';
        badge.style.cssText = 'font-size:11px;color:var(--txt3);margin-left:2px;white-space:nowrap';
        // insert right after the Filter button
        if (btn.nextSibling) bar.insertBefore(badge, btn.nextSibling); else bar.appendChild(badge);
      }
      badge.textContent = active ? (shown + ' / ' + total) : (total + ' total');

      // a small "Clear" button, only while a constraint is active
      var clr = bar.querySelector('#txnFilterClear');
      if (active && !clr) {
        clr = document.createElement('button');
        clr.id = 'txnFilterClear';
        clr.className = 'btn btn-sm btn-ghost';
        clr.innerHTML = '<i class="fa-solid fa-xmark"></i> Clear';
        clr.setAttribute('onclick', 'clearTxnFilter()');
        if (badge.nextSibling) bar.insertBefore(clr, badge.nextSibling); else bar.appendChild(clr);
      } else if (!active && clr) {
        try { clr.parentNode.removeChild(clr); } catch (_e) {}
      }
    } catch (_e) {}
  }

  // Public: real filter (replaces 008's toast-only stub).
  window.applyTxnFilter = function () { return runTxnFilter({ silent: false }); };
  window.applyTxnFilter._v355 = true;

  // Public: clear all controls + reveal every row.
  window.clearTxnFilter = function () {
    ['txnFilterFrom', 'txnFilterTo'].forEach(function (id) { var e = byId(id); if (e) e.value = ''; });
    ['txnFilterMethod', 'txnFilterStatus'].forEach(function (id) { var e = byId(id); if (e) e.selectedIndex = 0; });
    runTxnFilter({ silent: true });
    try { if (isFn(window.toast)) window.toast('Filter cleared'); } catch (_e) {}
  };

  /* ── wire the controls so picking a value filters live (button still works) */
  function wireFilterControls() {
    var ids = ['txnFilterFrom', 'txnFilterTo', 'txnFilterMethod', 'txnFilterStatus'];
    var any = false;
    ids.forEach(function (id) {
      var el = byId(id);
      if (!el || el.__v355wired) return;
      el.__v355wired = true;
      any = true;
      var ev = (el.tagName === 'SELECT' || el.type === 'date') ? 'change' : 'input';
      try { el.addEventListener(ev, function () { runTxnFilter({ silent: true }); }); } catch (_e) {}
    });
    // keep the count badge in sync on (re)render even before the user touches it
    if (byId('txnTableWrap')) runTxnFilter({ silent: true });
    return any;
  }

  /* ── deterministic active-pill for the tab strip ─────────────────────────
     Match the requested tab KEY against each button's onclick (showTxnTab('x'))
     and toggle `.active` accordingly — no dependency on `event.target`, so a
     programmatic re-apply (v324) keeps the pill correct and can't loop. */
  function setActiveTab(key) {
    try {
      var strip = byId('txnTabs');
      if (!strip) return;
      var btns = strip.querySelectorAll('.tab-btn, button');
      for (var i = 0; i < btns.length; i++) {
        var oc = (btns[i].getAttribute && btns[i].getAttribute('onclick')) || '';
        var m = oc.match(/showTxnTab\(\s*['"]([^'"]+)['"]/);
        var k = m ? m[1] : null;
        if (k) btns[i].classList.toggle('active', k === key);
      }
    } catch (_e) {}
  }

  function wrapShowTxnTab() {
    var fn = window.showTxnTab;
    if (!isFn(fn) || fn.__v355) return;
    var wrapped = function (tab) {
      var r;
      try { r = fn.apply(this, arguments); } catch (e) { r = undefined; }
      // deterministic active state + (re)wire the filter for the new pane
      try { if (typeof tab === 'string') setActiveTab(tab); } catch (_e) {}
      try { wireFilterControls(); } catch (_e) {}
      return r;
    };
    // preserve flags other wrappers (v324) look for
    try { for (var f in fn) { if (f.indexOf('__') === 0) { try { wrapped[f] = fn[f]; } catch (_e2) {} } } } catch (_e) {}
    wrapped.__v355 = true;
    wrapped.__twhInner = fn;
    window.showTxnTab = wrapped;
  }

  /* ── boot: install wrappers + wire whatever's already on screen ──────────
     Ride the shared DOMBus ticker so re-renders re-wire the (new) DOM nodes.
     No new setInterval / MutationObserver. Bounded one-shot catch-up timers. */
  function tick() {
    try { wrapShowTxnTab(); } catch (_e) {}
    try { wireFilterControls(); } catch (_e) {}
  }

  var _booted = false;
  function boot() {
    if (_booted) return; _booted = true;
    tick();
    try { if (window.DOMBus && isFn(window.DOMBus.register)) window.DOMBus.register(tick); } catch (_e) {}
  }
  // Wrap showTxnTab IMMEDIATELY at load — independent of readyState — so the
  // fix is in place even if the module is (re)defined and used before
  // DOMContentLoaded (or before the DOMBus ticker's first pass). Idempotent.
  try { wrapShowTxnTab(); } catch (_e) {}
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  try { [0, 300, 900, 1800, 3000].forEach(function (ms) { setTimeout(function () { boot(); tick(); }, ms); }); } catch (_e) {}

  // seam for the functional test
  window.__twhV355txnDiag = function () {
    return {
      applyIsReal: !!(window.applyTxnFilter && window.applyTxnFilter._v355),
      showTabWrapped: !!(window.showTxnTab && window.showTxnTab.__v355),
      hasClear: isFn(window.clearTxnFilter)
    };
  };

  try { console.info('v355 transactions tabs + working filter armed'); } catch (_e) {}
})();

;

/* ==== /js/259-twh-universal-tab-active-pill-v355.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   TWH · UNIVERSAL TAB / SUB-TAB DETERMINISTIC ACTIVE-PILL   (v355)   ·   CORE
   ────────────────────────────────────────────────────────────────────────
   User request:
     "Fix all this to be functional and active. When clicked, it should open
      the page once."  … then:
     "Also fix all sub-tabs and tabs for all other modules to be functional
      and active at every click and page open."

   BACKGROUND
   ──────────
   Pack 258 fixed the Finance / Transactions tab strip: its showTxnTab set the
   active pill via `event.target`, so the v324 universal sub-tab persistence —
   which re-applies the chosen tab PROGRAMMATICALLY (fn(want), no DOM event) —
   left no pill highlighted, drifted, and re-invoked on the next DOMBus tick, a
   flicker / re-open loop. 258 solved it for Transactions with a deterministic
   setActiveTab(key) that matches the tab key against each button's onclick.

   EVERY OTHER TABBED MODULE HAS THE SAME BUG
   ──────────────────────────────────────────
   showConfigTab / showReportTab / showHRTab / showBillTab / showHaHTab and
   switchAcctTab all highlight the clicked pill with `event.target`. On a
   programmatic re-apply (v324 poll-recovery, or any code calling the switcher
   without a click) the pill is lost → v324 sees drift → re-invokes next tick →
   the pane flickers / "re-opens", and clicks feel dead. Config's name-based
   fallback is partial; the rest have none.

   PERMANENT, UNIVERSAL FIX (decorator only — no core edits, no data changes)
   ──────────────────────────────────────────────────────────────────────────
   One CORE pack wraps EVERY registered tab switcher so that AFTER the inner
   switcher runs, the active pill is set DETERMINISTICALLY by matching the tab
   KEY against each button's onclick (showXTab('key') / switchAcctTab('key')) —
   never via `event.target`. This holds for BOTH a real user click AND a
   programmatic re-apply, so:
     • the highlighted pill always agrees with the shown pane, and
     • v324's activeSubOf() always matches the recorded tab → no drift → the
       page opens exactly ONCE, no loop, for every module.

   The wrapper is generic (registry-driven, one line per module) and preserves
   `__`-prefixed flags so it interoperates with the v324 / 258 / 105 wrappers.

   CONTRACT: no core edits, no D / -state / -worker / -redirect changes, no
   feature-pack reorder. Adds NO raw setInterval and NO MutationObserver (rides
   the shared DOMBus ticker + bounded one-shot catch-up timers). Idempotent
   (guarded by window.__twhV355tabs and a per-function-identity __v355pill flag).
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV355tabs) return;
  window.__twhV355tabs = true;

  function isFn(f) { return typeof f === 'function'; }

  // Generic registry: container id that holds the sub-tab buttons + the global
  // switcher function name. Superset of the v324 registry; adds the two
  // switchers v324 doesn't track (Home-&-Health `hah`, Accounting `switchAcct`).
  // Adding a new tabbed module is one line here.
  var TAB_MODULES = [
    { container: 'configTabs', fn: 'showConfigTab' },
    { container: 'reportTabs', fn: 'showReportTab' },
    { container: 'hrTabs',     fn: 'showHRTab' },
    { container: 'txnTabs',    fn: 'showTxnTab' },
    { container: 'billTabs',   fn: 'showBillTab' },
    { container: 'acctTabs',   fn: 'switchAcctTab' },
    { container: 'hahTabs',    fn: 'showHaHTab' },
    { container: 'pharmTabs',  fn: 'showPharmTab' },
    { container: 'invTabs',    fn: 'showInvTab' },
    { container: 'procTabs',   fn: 'showProcTab' },
    { container: 'dietTabs',   fn: 'showDietTab' }
  ];

  // Escape a function name for use inside a RegExp.
  function esc(s) { return String(s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }

  // Pull the sub-key from a button's onclick, e.g. showConfigTab('insurance').
  function subKeyOf(btn, fnName) {
    try {
      var oc = (btn.getAttribute && btn.getAttribute('onclick')) || '';
      var re = new RegExp(esc(fnName) + "\\(\\s*['\"]([^'\"]+)['\"]");
      var m = oc.match(re);
      return m ? m[1] : null;
    } catch (_e) { return null; }
  }

  // Deterministically toggle `.active` on the button in `container` whose
  // onclick routes to `key` — independent of any DOM event. Buttons hidden by
  // role-scoping (display:none) are left untouched by the highlight but still
  // cleared, so a hidden tab never shows as active.
  function setActivePill(container, fnName, key) {
    try {
      var strip = document.getElementById(container);
      if (!strip) return;
      var btns = strip.querySelectorAll('.tab-btn, .v28-subtab, button');
      var matchedAny = false;
      var i, k;
      for (i = 0; i < btns.length; i++) {
        k = subKeyOf(btns[i], fnName);
        if (k) { matchedAny = true; break; }
      }
      // If NO button in this strip is wired to this switcher, it isn't our
      // strip on screen (e.g. a same-named container elsewhere) — do nothing.
      if (!matchedAny) return;
      for (i = 0; i < btns.length; i++) {
        k = subKeyOf(btns[i], fnName);
        if (k == null) continue;                 // not a keyed tab button
        if (btns[i].classList) btns[i].classList.toggle('active', k === key);
      }
    } catch (_e) {}
  }

  // Wrap one switcher so every call (click OR programmatic) ends with a
  // deterministic active pill. Idempotent per function identity.
  function wrapOne(mod) {
    var fn = window[mod.fn];
    if (!isFn(fn)) return;
    if (fn.__v355pill) return;                    // already wrapped (this identity)
    var wrapped = function (tab) {
      var r;
      try { r = fn.apply(this, arguments); } catch (e) { r = undefined; }
      try { if (typeof tab === 'string' && tab) setActivePill(mod.container, mod.fn, tab); } catch (_e) {}
      return r;
    };
    // Carry over flags other wrappers rely on (v324 __twhV324, 258 __v355,
    // 105 _extWrapped, __twhInner, …) so the whole decorator chain interoperates.
    try { for (var f in fn) { if (f.indexOf('__') === 0 || f === '_extWrapped') { try { wrapped[f] = fn[f]; } catch (_e2) {} } } } catch (_e) {}
    wrapped.__v355pill = true;
    wrapped.__twhInner = fn;
    window[mod.fn] = wrapped;
  }

  function wrapAll() { for (var i = 0; i < TAB_MODULES.length; i++) { try { wrapOne(TAB_MODULES[i]); } catch (_e) {} } }

  // Correct any strip whose DOM active pill disagrees with the pane the
  // switcher would show. We can't know the "intended" tab without re-running
  // the switcher, so we defer content correction to v324 (which owns the
  // recorded selection) and only ensure that, once a switcher has run, its pill
  // is right. The wrapper above already guarantees that; this sweep additionally
  // repairs strips repainted by a poll where a stale pill got cleared but the
  // recorded tab (v324 store) is known — by re-applying via the (now wrapped)
  // switcher, which is a no-op for content if already correct.
  function repairFromStore() {
    try {
      var store = window.__twhSubTab;
      if (!store) return;
      // Map registry container→module key used by v324's store.
      var map = {
        config: 'showConfigTab', reports: 'showReportTab', hr: 'showHRTab',
        transactions: 'showTxnTab', billing: 'showBillTab', accounting: 'switchAcctTab'
      };
      Object.keys(map).forEach(function (m) {
        var want = store[m];
        if (!want) return;
        var fnName = map[m];
        var mod = null;
        for (var i = 0; i < TAB_MODULES.length; i++) { if (TAB_MODULES[i].fn === fnName) { mod = TAB_MODULES[i]; break; } }
        if (!mod) return;
        var strip = document.getElementById(mod.container);
        if (!strip) return;
        // Only fix the pill here (content is v324's job); harmless & idempotent.
        setActivePill(mod.container, mod.fn, want);
      });
    } catch (_e) {}
  }

  function tick() { try { wrapAll(); } catch (_e) {} try { repairFromStore(); } catch (_e) {} }

  var _booted = false;
  function boot() {
    if (_booted) return; _booted = true;
    tick();
    try { if (window.DOMBus && isFn(window.DOMBus.register)) window.DOMBus.register(tick); } catch (_e) {}
  }
  // Wrap IMMEDIATELY at load — independent of readyState — so the fix is in
  // place even if a switcher is used before DOMContentLoaded / the first tick.
  try { wrapAll(); } catch (_e) {}
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  try { [0, 300, 900, 1800, 3000].forEach(function (ms) { setTimeout(function () { boot(); tick(); }, ms); }); } catch (_e) {}

  // Diagnostics seam for the functional test.
  window.__twhV355tabsDiag = function () {
    var out = { wrapped: {}, active: {} };
    for (var i = 0; i < TAB_MODULES.length; i++) {
      var mod = TAB_MODULES[i];
      var fn = window[mod.fn];
      out.wrapped[mod.fn] = !!(fn && fn.__v355pill);
      var strip = document.getElementById(mod.container);
      if (strip) {
        var act = null, btns = strip.querySelectorAll('.tab-btn, .v28-subtab, button');
        for (var j = 0; j < btns.length; j++) { if (btns[j].classList && btns[j].classList.contains('active')) { act = subKeyOf(btns[j], mod.fn); break; } }
        out.active[mod.container] = act;
      }
    }
    return out;
  };
  window.__twhV355setActivePill = setActivePill;

  try { console.info('v355 universal tab/sub-tab deterministic active-pill armed'); } catch (_e) {}
})();

;

/* ==== /js/260-twh-content-swap-router-v356.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   TWH · CONTENT-REGION SWAP NAVIGATION + HASH DEEP-LINK ROUTER  (v356) · CORE
   ────────────────────────────────────────────────────────────────────────
   User request (options 1 + 3):
     "Implement multiple pages … make all tabs/sub-tabs open as pages … make it
      perfection … will it resolve all the blinking / shaking of the pages?"
     → chosen: (1) content-region swap so navigation never rebuilds the shell,
       and (3) real hash deep-links (#/module) with back/forward + refresh.

   WHY THE PAGES BLINK / SHAKE TODAY
   ─────────────────────────────────
   The core render() rebuilds the ENTIRE #app (toast + sidebar + header +
   #moduleContent) on every call. v326 already downgrades *same-module* repaints
   (background sync) to a content-only write of #moduleContent — but a genuine
   module SWITCH (goTo to a different page) still does a FULL shell rebuild
   ("a genuine switch opens at the top"). That full rebuild wipes and repaints
   the sidebar + header = the visible blink, and the re-layout = the shake.

   THE FIX — SWAP ONLY THE CONTENT REGION ON A SWITCH TOO
   ───────────────────────────────────────────────────────
   Wrap render() at the TOP of the chain (above v326). When we're doing a real
   module switch AND the shell is already mounted (#sidebar + #moduleContent
   present) AND no modal is open, we:
     • write ONLY  #moduleContent.innerHTML = renderModule()  (shell stays put),
     • update the header <h2> title in place (getModTitle()),
     • update the sidebar active pill in place (match goTo('mod') onclick),
     • scroll the content region to the TOP (preserves "a switch opens at top"),
   and we DO NOT call the underlying full render(). The sidebar + header nodes
   are never destroyed → no blink, no shake, the page "opens once".
   Anything we can't safely swap (no shell yet = first paint, a modal is open,
   an empty content area, or renderModule missing) DELEGATES to the existing
   render chain (full shell render) exactly as before — a strict superset.

   HASH DEEP-LINK ROUTER (option 3)
   ────────────────────────────────
   • After a successful navigation, reflect the route in the URL as #/<module>
     (bookmarkable; back/forward works; refresh lands on the same page).
   • On hashchange (Back/Forward, or a user editing the hash) navigate to that
     module — via the content swap, so history navigation is blink-free too.
   • On first load, if the URL carries #/<module>, open that module (deep link).
   • A re-entrancy guard stops the hash write from re-triggering navigation.
   • window.twhOpenInNewTab(mod) opens a module in a NEW browser tab using the
     same deep-link URL (option 3's "open in another page") — handy for the
     Fast-Link pattern without losing the current workspace.

   LOGIN-RACE HARDENING (v357 fix, folded in)
   ───────────────────────────────────────────
   Two reported regressions, one root cause: the router honoured a STALE
   #/<module> hash (written on a previous session's navigation) before the app
   was actually signed in.
     • "after login it first shows the admin/wrong page, then a refresh fixes
        it" — the stale deep-link fired against the freshly-mounted shell and
        overrode the role-home dashboard that doLogin()/v251 lands on.
     • "links need a refresh before they navigate" — the lingering deep-link
        retry loop competed with the user's first click.
   Fix: an appReady() gate (signed in + login/gate screen gone + shell mounted)
   guards BOTH the first-load deep link and every hashchange; writeHash() never
   stamps a hash while the login/gate surface is up; doLogin is wrapped to drop
   any stale hash and open a short grace window so the role-home always wins the
   first paint; and the deep-link probe self-cancels once login starts or once
   the user has already navigated. User clicks are never gated.

   CONTRACT: no core edits, no D / -state / -worker changes, no feature-pack
   reorder. Rides the shared DOMBus ticker; adds NO setInterval and NO
   MutationObserver. Idempotent (window.__twhV356). Preserves __-prefixed flags
   so it composes with the v231 governor and the v326 render-reuse wrapper.
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV356) return;
  window.__twhV356 = true;

  function isFn(f) { return typeof f === 'function'; }
  function byId(id) { try { return document.getElementById(id); } catch (_e) { return null; } }

  var VALID = null;                     // lazily-built set of known module keys
  var _navigatingFromHash = false;      // re-entrancy guard (hash → nav)
  var _writingHash = false;             // re-entrancy guard (nav → hash)
  var _lastSwapMod = null;
  var _deepLinkConsumed = false;        // first-load deep-link handled / abandoned
  var _loginGraceUntil = 0;             // suppress hash routing right after login

  /* ── LOGIN / READINESS GATE ─────────────────────────────────────────────
     The single fix for "after login it shows the admin/wrong page until you
     refresh" and "links need a refresh before they navigate":

     v356 must NOT route from the URL hash (deep-link on first load, or a
     hashchange) until the app is actually signed in AND the SPA shell is
     mounted. Before that, the visible surface is the LOGIN screen (or the
     secure gate), so honouring a stale #/<module> hash from a previous session
     would (a) fight the role-home landing that doLogin()/v251 performs, and
     (b) drop a non-admin onto a module that isn't theirs until a manual
     refresh re-runs the clean role-home path. We also suppress hash routing
     for a short grace window right after login so the role-home dashboard
     always wins the first paint. */
  function gateActive() { try { return !!window.__HMS_GATE_LOGIN; } catch (_e) { return false; } }
  function onLoginScreen() { return !!byId('loginScreen') || !!byId('hmsGate'); }
  function loggedIn() { try { return window.isLoggedIn === true; } catch (_e) { return false; } }
  function appReady() {
    // Ready to route only when signed in, the login/gate surface is gone, and
    // the SPA shell (sidebar + content region) is actually mounted.
    if (gateActive()) return false;
    if (onLoginScreen()) return false;
    if (!loggedIn()) return false;
    if (!byId('sidebar') || !byId('moduleContent')) return false;
    return true;
  }

  /* Build the set of navigable module keys from the sidebar buttons' onclick
     (goTo('key')) plus getModTitle's map — so an unknown hash can't route us
     into a blank screen. Rebuilt cheaply whenever the sidebar is present. */
  function knownModules() {
    var set = {};
    try {
      var btns = document.querySelectorAll('.sb-item[onclick]');
      for (var i = 0; i < btns.length; i++) {
        var oc = btns[i].getAttribute('onclick') || '';
        var m = oc.match(/goTo\(\s*['"]([^'"]+)['"]/);
        if (m) set[m[1]] = true;
      }
    } catch (_e) {}
    // Always allow the canonical dashboard.
    set.dashboard = true;
    return set;
  }
  function isKnown(mod) {
    if (!mod) return false;
    if (!VALID) VALID = knownModules();
    if (VALID[mod]) return true;
    // Refresh once in case the sidebar rendered after our first probe.
    VALID = knownModules();
    return !!VALID[mod];
  }

  /* ── update the header title + sidebar active pill IN PLACE (no rebuild) ── */
  function updateChrome(mod) {
    try {
      var h = document.querySelector('.main .hdr .hdr-left h2');
      if (h && isFn(window.getModTitle)) {
        var t = window.getModTitle();          // reads window.currentMod
        if (typeof t === 'string' && t) h.textContent = t;
      }
    } catch (_e) {}
    try {
      var btns = document.querySelectorAll('.sb-item[onclick]');
      for (var i = 0; i < btns.length; i++) {
        var oc = btns[i].getAttribute('onclick') || '';
        var m = oc.match(/goTo\(\s*['"]([^'"]+)['"]/);
        if (m && btns[i].classList) btns[i].classList.toggle('active', m[1] === mod);
      }
    } catch (_e) {}
  }

  /* A string that is a v290/v291 recovery card ("Loading module…" / "…recovered
     automatically") — NOT a real module body. If renderModule() would only give
     us one of these (because the render-storm coalesced the paint), we must NOT
     swap it in: that is exactly the "page opens blank / needs a refresh" bug. */
  function isRecoveryCard(s) { return /Loading module|d automatically/i.test(String(s || '')); }

  /* Obtain the FRESH body HTML for the target module — never a cached/coalesced
     one. The v290 recursion-breaker + v229 coalescer + v231 governor wrap
     renderModule(), so a raw call during the click can return the PREVIOUS
     module's cached body or a "Loading module…" card (→ "pages need a refresh").
     v321 exposes __twhCoreRenderModule (the pristine core switch); we run it at
     forced depth 0 like v320's authoritative paint. Falls back to resetting the
     v290 depth + dropping this route's cache before the wrapped renderModule. */
  function freshDepth() {
    try { if (isFn(window.__twhV290ResetCurrent)) window.__twhV290ResetCurrent(); } catch (_e) {}
    try { window.__twhV290Depth = 0; window.__twhV290RenderDepth = 0; } catch (_e) {}
  }
  function freshModuleHtml() {
    // PRIMARY: the pristine core switch at guaranteed depth 0 (bypasses the
    // whole wrapper stack → can never yield a "Loading module…" card).
    try {
      var core = window.__twhCoreRenderModule;
      if (isFn(core)) {
        var d = window.__twhV290Depth, rd = window.__twhV290RenderDepth;
        try { window.__twhV290Depth = 0; window.__twhV290RenderDepth = 0; } catch (_e) {}
        var h1;
        try { h1 = core.call(window); }
        finally {
          try { if (typeof d === 'number') window.__twhV290Depth = d; } catch (_e2) {}
          try { if (typeof rd === 'number') window.__twhV290RenderDepth = rd; } catch (_e3) {}
        }
        if (typeof h1 === 'string' && h1.length && !isRecoveryCard(h1)) return h1;
      }
    } catch (_e) {}
    // FALLBACK: reset depth + drop this route's cache, then the wrapped one.
    try {
      if (isFn(window.renderModule)) {
        freshDepth();
        var h2 = window.renderModule();
        if (typeof h2 === 'string' && h2.length && !isRecoveryCard(h2)) return h2;
      }
    } catch (_e) {}
    return null;
  }

  /* ── the content-only swap for a real module switch ─────────────────────
     Returns true if it fully handled the render (shell preserved) with a FRESH
     module body; false if the caller must fall back to the full render chain. */
  function contentSwap(mod) {
    try {
      var shell = byId('sidebar');
      var mc = byId('moduleContent');
      if (!shell || !mc) return false;               // first paint → full render
      if (byId('modalBg')) return false;             // modal expects the shell
      if (!isFn(window.renderModule)) return false;  // can't build content
      // Mark this as an intentional user navigation (one tick) so the render
      // guardians treat the fresh paint as authoritative, not coalescible.
      try { window.__twhUserNav = true; setTimeout(function () { try { window.__twhUserNav = false; } catch (_e) {} }, 0); } catch (_e) {}
      var html = freshModuleHtml();                  // FRESH body, never cached/card
      if (html == null || String(html).length < 8) return false; // couldn't → full
      // Write ONLY the content region. Prefer v323's scroll-keep-safe writer if
      // present so other guardians stay consistent; else a plain write.
      try {
        if (isFn(window.__twhScrollSafeSet)) window.__twhScrollSafeSet(mc, String(html));
        else mc.innerHTML = String(html);
      } catch (_e) { try { mc.innerHTML = String(html); } catch (_e2) { return false; } }
      updateChrome(mod);
      // A genuine switch opens at the TOP (matches the prior full-render intent).
      try { mc.scrollTop = 0; } catch (_e) {}
      try { if (typeof window.scrollTo === 'function') window.scrollTo(0, 0); } catch (_e) {}
      // Keep the sidebar active-state consistent with the app's own syncNav.
      try { if (isFn(window.syncNav)) window.syncNav(); } catch (_e) {}
      _lastSwapMod = mod;
      // Let the rest of the app know a content-only navigation happened, so any
      // post-render hooks (badges, alerts) can run without a shell rebuild.
      try { document.dispatchEvent(new Event('twh:content-swapped')); } catch (_e) {}
      return true;
    } catch (_e) { return false; }
  }

  /* ── hash <-> route sync ────────────────────────────────────────────────*/
  function modFromHash() {
    try {
      var h = String(location.hash || '');
      var m = h.match(/^#\/?([A-Za-z0-9_-]+)/);
      return m ? m[1] : null;
    } catch (_e) { return null; }
  }
  function writeHash(mod) {
    try {
      if (!mod) return;
      // Never stamp a module hash onto the URL while the login / secure-gate
      // surface is showing — a stale #/<module> is exactly what caused the
      // "lands on the wrong page until refresh" race on the next sign-in.
      if (onLoginScreen() || gateActive() || !loggedIn()) return;
      var want = '#/' + mod;
      if (location.hash === want) return;
      _writingHash = true;
      try { location.hash = want; } catch (_e) {}
      // Clear the guard after the (sync) hashchange has a chance to fire.
      try { setTimeout(function () { _writingHash = false; }, 0); } catch (_e) { _writingHash = false; }
    } catch (_e) { _writingHash = false; }
  }

  /* ── wrap goTo: content-swap the switch + reflect it in the URL ─────────
     We wrap at the TOP so our swap runs BEFORE the legacy full-render goTo. If
     the swap succeeds we still set currentMod + fire the app's post-nav side
     effects (save, clinical alerts) that the core goTo would have done, but we
     SKIP the core's full render(). If the swap can't run, we delegate to the
     inner goTo (full render) unchanged. */
  function wrapGoTo() {
    var inner = window.goTo;
    if (!isFn(inner)) return;
    if (inner.__v356) return;
    var wrapped = function (mod) {
      mod = (typeof mod === 'string') ? mod : String(mod || '');
      // Try the blink-free content swap first (only for a real, safe switch).
      var swapped = false;
      try {
        // Set the route binding the same way the core does BEFORE building content.
        try { window.currentMod = mod; } catch (_e) {}
        swapped = contentSwap(mod);
      } catch (_e) { swapped = false; }

      if (swapped) {
        // Reproduce the core goTo's benign side effects (minus the full render).
        try { if (isFn(window._hmsSave)) window._hmsSave(); } catch (_e) {}
        try { if (isFn(window.runClinicalAlerts)) window.runClinicalAlerts(); } catch (_e) {}
        if (!_navigatingFromHash) writeHash(mod);
        return undefined;
      }
      // Fall back to the original navigation (full shell render) unchanged.
      var r = inner.apply(this, arguments);
      if (!_navigatingFromHash) { try { writeHash(String(window.currentMod || mod)); } catch (_e) {} }
      return r;
    };
    // Preserve flags the governor / v326 / v33 wrappers rely on.
    try { for (var f in inner) { if (f.indexOf('__') === 0 || f === '_extWrapped') { try { wrapped[f] = inner[f]; } catch (_e2) {} } } } catch (_e) {}
    wrapped.__v356 = true;
    wrapped.__twhInner = inner;
    window.goTo = wrapped;
  }

  /* Navigate from a hash change / deep link. Guarded so writeHash() → hashchange
     doesn't loop back into a redundant navigation. */
  function navFromHash() {
    if (_writingHash) return;                 // our own hash write → ignore
    if (!appReady()) return;                  // not signed in / no shell → ignore
    if (Date.now() < _loginGraceUntil) return; // let role-home win right after login
    var mod = modFromHash();
    if (!mod) return;
    if (!isKnown(mod)) return;                // unknown route → leave as-is
    var cur = null; try { cur = String(window.currentMod || ''); } catch (_e) {}
    if (mod === cur) { updateChrome(mod); return; } // already there → just sync pill
    if (!isFn(window.goTo)) return;
    _navigatingFromHash = true;
    try { window.goTo(mod); } catch (_e) {}
    _navigatingFromHash = false;
  }

  /* Option 3 helper: open a module in a NEW browser tab via its deep link. */
  window.twhOpenInNewTab = function (mod) {
    try {
      mod = (typeof mod === 'string') ? mod : String(mod || '');
      if (!mod) return;
      var url = location.pathname + location.search + '#/' + mod;
      window.open(url, '_blank');
    } catch (_e) {}
  };

  /* Wrap doLogin so that, the moment a sign-in starts, we (a) drop any stale
     #/<module> hash from a previous session and (b) open a short grace window
     during which hash routing is suppressed — guaranteeing the role-home
     dashboard that doLogin()/v251 lands on is what the user sees first, with
     no "wrong page until refresh" flash. */
  function wrapDoLogin() {
    var inner = window.doLogin;
    if (!isFn(inner)) return;
    if (inner.__v356login) return;
    var wrapped = function () {
      _loginGraceUntil = Date.now() + 4000;   // suppress hash routing ~4s
      _deepLinkConsumed = true;               // never honour a pre-login deep link
      // Strip a stale route hash so nothing re-routes off it post-login.
      try { if (modFromHash()) { _writingHash = true; try { location.hash = ''; } catch (_e2) {} setTimeout(function () { _writingHash = false; }, 0); } } catch (_e) {}
      return inner.apply(this, arguments);
    };
    try { for (var f in inner) { if (f.indexOf('__') === 0 || f === '_extWrapped') { try { wrapped[f] = inner[f]; } catch (_e2) {} } } } catch (_e) {}
    wrapped.__v356login = true;
    wrapped.__twhInnerLogin = inner;
    window.doLogin = wrapped;
  }

  /* ── boot ───────────────────────────────────────────────────────────────*/
  function tick() { try { wrapGoTo(); wrapDoLogin(); } catch (_e) {} }
  var _booted = false;
  function boot() {
    if (_booted) return; _booted = true;
    tick();
    // Deep link on first load: honour #/<module> ONLY once the app is actually
    // signed in and the shell is mounted (appReady) — never while the login /
    // secure-gate screen is up (that stale-hash-vs-login race is the bug we are
    // fixing). The probe self-cancels once consumed, once the user has already
    // navigated somewhere else, or after a bounded number of tries.
    try {
      var initial = modFromHash();
      if (initial && isKnown(initial)) {
        var tries = 0;
        (function openDeep() {
          tries++;
          if (_deepLinkConsumed) return;               // login started / already handled
          if (appReady() && Date.now() >= _loginGraceUntil) {
            var cur = null; try { cur = String(window.currentMod || ''); } catch (_e) {}
            // Only deep-link if the user is still on the freshly-landed home
            // (dashboard) — if they've already clicked elsewhere, respect that.
            if (isFn(window.goTo) && cur !== initial && (cur === 'dashboard' || cur === '')) {
              _deepLinkConsumed = true;
              _navigatingFromHash = true;
              try { window.goTo(initial); } catch (_e) {}
              _navigatingFromHash = false;
            } else {
              _deepLinkConsumed = true;                // user moved on → abandon
            }
          } else if (tries < 40) {
            setTimeout(openDeep, 150);                 // wait for sign-in + shell
          }
        })();
      }
    } catch (_e) {}
    try { window.addEventListener('hashchange', navFromHash); } catch (_e) {}
    try { if (window.DOMBus && isFn(window.DOMBus.register)) window.DOMBus.register(tick); } catch (_e) {}
  }
  try { wrapGoTo(); wrapDoLogin(); } catch (_e) {}   // wrap ASAP (readyState-independent)
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  try { [0, 300, 900, 1800, 3000].forEach(function (ms) { setTimeout(function () { boot(); tick(); }, ms); }); } catch (_e) {}

  /* Diagnostics seam for the functional test. */
  window.__twhV356Diag = function () {
    return {
      goToWrapped: !!(window.goTo && window.goTo.__v356),
      loginWrapped: !!(window.doLogin && window.doLogin.__v356login),
      appReady: appReady(),
      onLoginScreen: onLoginScreen(),
      loggedIn: loggedIn(),
      gateActive: gateActive(),
      deepLinkConsumed: _deepLinkConsumed,
      loginGraceMsLeft: Math.max(0, _loginGraceUntil - Date.now()),
      hash: (function () { try { return location.hash; } catch (_e) { return ''; } })(),
      route: modFromHash(),
      lastSwapMod: _lastSwapMod
    };
  };
  window.__twhContentSwap = contentSwap;

  try { console.info('v356 content-swap navigation + hash deep-link router armed'); } catch (_e) {}
})();

;

/* ==== /js/261-twh-dashboard-activity-notifications-v358.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   TWH · DASHBOARD DAILY ACTIVITY + NOTIFICATIONS (ROLE-SCOPED)  ·  v358 · CORE
   ────────────────────────────────────────────────────────────────────────
   User request (verbatim, this turn):
     "change the dashboard not to be shaking and implement only notifications
      and details on each work done for each day. (Notification should be on
      the dashboard of the attached part on the application) Notification should
      be sent via email and all activities attached to each role should be
      displayed."

   WHAT THIS PACK DOES
   ───────────────────
   1) NOTIFICATIONS + DAILY ACTIVITY CARD on the dashboard (the "attached part"
      shown in the screenshot — below Today's schedule / Worklist / Patient flow
      and beside System Diagnostics). It shows, for the SIGNED-IN user only:
        • "Today's activity" — every action THEY performed today, pulled from the
          real audit trail (D.auditLog, written by auditAction()), grouped by
          module with a per-module count and the latest few lines. This is the
          "details on each work done for each day", scoped to the user's role.
        • "Notifications" — the role-relevant unread items from D.notifications.
        • An "Email me today's activity" button that composes a digest and sends
          it to the user's registered email (mailto:, so it works in production
          with no SMTP backend) and records that the digest was issued.

   2) NO SHAKE. The card is a SINGLE stable container injected ONCE per dashboard
      paint. On every background refresh we UPDATE ITS INNER TEXT/LIST IN PLACE
      (same DOM nodes, fixed outer height contract) instead of removing and
      re-inserting a block — which is what made the dashboard jump/shake. If the
      dashboard body is fully repainted (nodes gone), we re-inject once, but we
      never thrash: a content signature gate skips redundant rewrites, so there
      is no layout churn on idle ticks.

   ROLE SCOPING
   ────────────
   Activities are attached to each role by matching audit rows to the current
   user (D.currentUser.fullName / .username). Admin / System-Administrator roles
   additionally get an "All staff activity today" toggle so supervisors can see
   the whole team — everyone else sees only their own, as requested.

   CONTRACT: no core edits, no D1 / /api/state / worker / _redirects edits, no
   pack reorder. Rides the shared DOMBus ticker; adds NO setInterval and NO
   MutationObserver. Idempotent (window.__twhV358). Loads after the dashboard
   builder (v213) so it injects beneath the care block.

   Guard: window.__twhV358   Diagnostics: window.__twhV358Diag()
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV358) return;
  window.__twhV358 = true;

  var CARD_ID = 'twhActivityNotif';
  var LIST_ID = 'twhActivityList';
  var NOTIF_ID = 'twhNotifList';
  var _lastSig = '';
  var _showAll = false;                 // admin "all staff" toggle
  var diag = { injects: 0, updates: 0, emails: 0 };

  function isFn(f) { return typeof f === 'function'; }
  function byId(id) { try { return document.getElementById(id); } catch (_e) { return null; } }
  function D_() { try { if (typeof D !== 'undefined' && D) return D; } catch (_e) {} return window.D || null; }
  function curMod() { try { return String(window.currentMod != null ? window.currentMod : ((D_() || {}).currentMod || 'dashboard')); } catch (_e) { return 'dashboard'; } }
  function loggedIn() { try { return window.isLoggedIn === true; } catch (_e) { return false; } }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  function me() {
    var D = D_(); var u = (D && D.currentUser) || {};
    return { name: u.fullName || u.username || 'You', user: u.username || '', role: u.role || '', email: u.email || '' };
  }
  function isSuper(role) {
    var r = String(role || '').toLowerCase();
    return /admin|administrator|ceo|super/.test(r);
  }
  /* The audit log stamps date via toLocaleString(); a "today" row is one whose
     localized date string starts with today's localized date. */
  function todayStr() { try { return new Date().toLocaleDateString(); } catch (_e) { return ''; } }
  function isToday(dateStr) {
    try {
      var d = String(dateStr || '');
      var t = todayStr();
      if (t && d.indexOf(t) === 0) return true;
      // Fallback: compare parsed calendar day.
      var pd = new Date(d); if (isNaN(pd.getTime())) return false;
      var n = new Date();
      return pd.getFullYear() === n.getFullYear() && pd.getMonth() === n.getMonth() && pd.getDate() === n.getDate();
    } catch (_e) { return false; }
  }

  /* Today's audit rows, scoped to the signed-in user unless an admin has toggled
     "all staff". Returns [{module, action, desc, date, user, risk}]. */
  function todaysActivity() {
    var D = D_(); if (!D || !D.auditLog) return [];
    var m = me();
    var all = isSuper(m.role) && _showAll;
    var out = [];
    for (var i = 0; i < D.auditLog.length; i++) {
      var a = D.auditLog[i]; if (!a) continue;
      if (!isToday(a.date)) continue;
      if (!all) {
        // Attach activity to THIS user's role/identity only.
        var au = String(a.user || '');
        if (au !== m.name && (!m.user || au !== m.user)) continue;
      }
      out.push(a);
      if (out.length >= 200) break;
    }
    return out;
  }

  /* Group activity rows by module → { module, count, lines:[latest few] }. */
  function groupByModule(rows) {
    var map = {}, order = [];
    for (var i = 0; i < rows.length; i++) {
      var mod = rows[i].module || rows[i].type || 'General';
      if (!map[mod]) { map[mod] = { module: mod, count: 0, lines: [] }; order.push(mod); }
      map[mod].count++;
      if (map[mod].lines.length < 4) map[mod].lines.push(rows[i]);
    }
    return order.map(function (k) { return map[k]; });
  }

  /* A notification is relevant to the signed-in user when it is NOT tied to a
     module (system-wide) OR its module is one the user can access. Admins /
     super roles see everything (hasModuleAccess is a no-op for them anyway).
     This scopes the feed to "the modules assigned to users", as requested. */
  function canSeeModule(mod) {
    if (!mod) return true;                       // system-wide notice → always shown
    try {
      if (isSuper((me() || {}).role)) return true;
      if (isFn(window.hasModuleAccess)) return !!window.hasModuleAccess(mod);
    } catch (_e) {}
    return true;                                 // fail-open (never hide a notice on error)
  }
  function roleNotifications() {
    var D = D_(); if (!D || !D.notifications) return [];
    // Most-recent-first, unread first, SCOPED to the user's assigned modules.
    var list = D.notifications.slice(0, 60).filter(function (n) {
      return n && canSeeModule(n.module);
    });
    list.sort(function (a, b) { return (a.read === b.read) ? 0 : (a.read ? 1 : -1); });
    return list.slice(0, 8);
  }

  /* ── HTML builders (inner only — the outer card is stable) ─────────────── */
  function activityInnerHtml() {
    var rows = todaysActivity();
    var groups = groupByModule(rows);
    var m = me();
    if (!rows.length) {
      return '<div style="padding:14px 12px;color:var(--txt3);font-size:12px;text-align:center">'
        + '<i class="fa-solid fa-clipboard-list" style="opacity:.4;font-size:20px;display:block;margin-bottom:6px"></i>'
        + 'No activity recorded yet today' + (isSuper(m.role) && _showAll ? ' (all staff).' : '.') + '</div>';
    }
    var html = '';
    for (var g = 0; g < groups.length; g++) {
      var grp = groups[g];
      html += '<div style="border:1px solid #eef2f7;border-radius:10px;padding:8px 10px;margin-bottom:8px">'
        + '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:4px">'
        + '<div style="font-weight:800;font-size:12px;color:var(--dark)"><i class="fa-solid fa-folder-open" style="color:var(--pri);margin-right:6px;opacity:.7"></i>' + esc(grp.module) + '</div>'
        + '<span class="st" style="background:#e0f2fe;color:#075985;font-weight:700">' + grp.count + '</span></div>';
      for (var l = 0; l < grp.lines.length; l++) {
        var a = grp.lines[l];
        var t = '';
        try { t = String(a.date || '').split(',').pop().trim(); } catch (_e) {}
        html += '<div style="font-size:11px;color:var(--txt2);padding:2px 0;display:flex;gap:6px">'
          + '<span style="color:var(--txt3);flex:0 0 auto">' + esc(t) + '</span>'
          + '<span style="flex:1">' + esc(a.action || '') + (a.desc ? ' — ' + esc(a.desc) : '') + '</span></div>';
      }
      if (grp.count > grp.lines.length) {
        html += '<div style="font-size:10px;color:var(--txt3);margin-top:2px">+ ' + (grp.count - grp.lines.length) + ' more…</div>';
      }
      html += '</div>';
    }
    return html;
  }

  function notifInnerHtml() {
    var list = roleNotifications();
    if (!list.length) {
      return '<div style="padding:12px;color:var(--txt3);font-size:12px;text-align:center">No notifications.</div>';
    }
    var html = '';
    for (var i = 0; i < list.length; i++) {
      var n = list[i];
      var dot = n.read ? '#cbd5e1' : '#ef4444';
      var nid = esc(n.id != null ? n.id : (n.date || ''));
      var mod = n.module ? esc(n.module) : '';
      // Every row is CLICKABLE: clicking marks it read and (if the notification
      // carries a module the user can open) navigates straight to that module.
      var chevron = n.module
        ? '<i class="fa-solid fa-chevron-right" style="color:var(--txt3);font-size:10px;margin-left:6px;flex:0 0 auto;align-self:center"></i>'
        : '';
      html += '<div role="button" tabindex="0" class="twh-notif-row" data-twh-notif="' + nid + '"'
        + (mod ? (' data-twh-notif-mod="' + mod + '"') : '')
        + ' title="' + (n.module ? ('Open ' + mod) : 'Mark as read') + '"'
        + ' style="display:flex;gap:8px;align-items:flex-start;padding:7px 4px;border-bottom:1px solid #f1f5f9;cursor:pointer;border-radius:8px"'
        + ' onmouseover="this.style.background=\'#f8fafc\'" onmouseout="this.style.background=\'\'">'
        + '<span style="width:8px;height:8px;border-radius:50%;background:' + dot + ';margin-top:5px;flex:0 0 auto"></span>'
        + '<div style="flex:1;min-width:0">'
        + '<div style="font-weight:700;font-size:12px;color:var(--dark)">' + esc(n.title || 'Notification') + '</div>'
        + '<div style="font-size:11px;color:var(--txt2)">' + esc(n.msg || '') + '</div>'
        + '<div style="font-size:10px;color:var(--txt3);margin-top:1px">' + esc(n.date || '') + (mod ? (' \u00b7 ' + mod) : '') + '</div>'
        + '</div>' + chevron + '</div>';
    }
    return html;
  }

  /* Delegated click/keyboard wiring on the (stable) card. Wired ONCE per card
     node — a data-flag guards against re-binding — and because it delegates
     from the card it keeps working after the inner notif list is rewritten in
     place. No per-row handlers, so inner-HTML updates stay cheap and shake-free. */
  function wireNotifClicks(card) {
    try {
      if (!card || card.__twhNotifWired) return;
      card.__twhNotifWired = true;
      var handler = function (ev) {
        try {
          var t = ev.target;
          var row = t && (t.closest ? t.closest('[data-twh-notif]') : null);
          if (!row || !card.contains(row)) return;
          if (ev.type === 'keydown' && ev.key !== 'Enter' && ev.key !== ' ') return;
          try { ev.preventDefault(); } catch (_e) {}
          openNotification(row.getAttribute('data-twh-notif'), row.getAttribute('data-twh-notif-mod') || '');
        } catch (_e) {}
      };
      card.addEventListener('click', handler);
      card.addEventListener('keydown', handler);
    } catch (_e) {}
  }

  /* Click/keyboard handler for a notification row: mark it read, persist, and
     jump to the notification's module if the user can access it. Exposed so the
     inline delegated listener (wired once in apply()) can call it. */
  function openNotification(id, mod) {
    try {
      var D = D_();
      if (D && D.notifications) {
        for (var i = 0; i < D.notifications.length; i++) {
          var n = D.notifications[i];
          if (n && String(n.id != null ? n.id : (n.date || '')) === String(id)) { n.read = true; break; }
        }
        try { if (isFn(window._hmsSave)) window._hmsSave(); } catch (_e) {}
      }
      _lastSig = '';                              // force the feed to repaint the read-state
      if (mod && isFn(window.goTo)) {
        try { window.goTo(mod); return; }         // navigates + repaints the app
        catch (_e) {}
      }
      apply();                                    // no module → just refresh the read dot
    } catch (_e) {}
  }
  window.twhNotifOpen = openNotification;

  /* Signature of the current data so we only rewrite when something changed
     (prevents idle-tick rewrites = no shake). */
  function dataSig() {
    var D = D_(); if (!D) return '';
    var rows = todaysActivity();
    var lastA = rows[0]; var lastN = (D.notifications || [])[0];
    var unread = (D.notifications || []).filter(function (n) { return n && !n.read; }).length;
    return rows.length + '|' + (lastA ? (lastA.id || lastA.date) : '') + '|'
      + (D.notifications || []).length + '|' + unread + '|' + (lastN ? (lastN.id || lastN.date) : '')
      + '|' + (_showAll ? 'A' : 'M');
  }

  /* The stable outer card (built once). Inner regions are updated in place. */
  function cardHtml() {
    var m = me();
    var superToggle = isSuper(m.role)
      ? '<button class="btn btn-ghost btn-sm" onclick="twhActivityToggleAll()" title="Toggle between my activity and all staff">'
        + '<i class="fa-solid fa-users"></i> <span id="twhActivityScopeLbl">' + (_showAll ? 'All staff' : 'My activity') + '</span></button>'
      : '';
    return '<div id="' + CARD_ID + '" class="card" style="margin:16px 0 0">'
      + '<div class="card-hd" style="display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:8px">'
      +   '<h3 style="margin:0"><i class="fa-solid fa-bell" style="color:var(--pri);margin-right:8px"></i>Notifications &amp; today\u2019s activity</h3>'
      +   '<div style="display:flex;gap:6px;flex-wrap:wrap">' + superToggle
      +     '<button class="btn btn-ghost btn-sm" onclick="twhEmailActivityDigest()" title="Email me today\u2019s activity"><i class="fa-solid fa-envelope"></i> Email me today\u2019s activity</button>'
      +   '</div>'
      + '</div>'
      + '<div style="display:grid;grid-template-columns:1.4fr 1fr;gap:16px">'
      +   '<div><div style="font-weight:800;font-size:12px;color:var(--txt3);text-transform:uppercase;letter-spacing:.04em;margin-bottom:8px">Details on each work done today</div>'
      +     '<div id="' + LIST_ID + '">' + activityInnerHtml() + '</div></div>'
      +   '<div><div style="font-weight:800;font-size:12px;color:var(--txt3);text-transform:uppercase;letter-spacing:.04em;margin-bottom:8px">Notifications</div>'
      +     '<div id="' + NOTIF_ID + '">' + notifInnerHtml() + '</div></div>'
      + '</div>'
      + '</div>';
  }

  /* ── inject once / update in place (no shake) ───────────────────────────── */
  function place(node) {
    // Prefer to sit right after the System Diagnostics card if present, else at
    // the end of the dashboard content — a stable, predictable position.
    var host = byId('moduleContent'); if (!host) return false;
    var diagCard = null;
    try {
      var h3s = host.querySelectorAll('h3');
      for (var i = 0; i < h3s.length; i++) {
        if (/System Diagnostics/i.test(h3s[i].textContent || '')) { diagCard = h3s[i].closest('.card'); break; }
      }
    } catch (_e) {}
    if (diagCard && diagCard.parentNode) { diagCard.parentNode.insertBefore(node, diagCard.nextSibling); return true; }
    host.appendChild(node); return true;
  }

  function apply() {
    try {
      if (!loggedIn()) return;
      if (curMod() !== 'dashboard') return;             // dashboard-only card
      var host = byId('moduleContent'); if (!host) return;
      var card = byId(CARD_ID);
      var sig = dataSig();
      if (!card) {
        // Inject the stable card ONCE.
        var wrap = document.createElement('div');
        wrap.innerHTML = cardHtml();
        var node = wrap.firstChild;
        if (node && place(node)) { diag.injects++; _lastSig = sig; wireNotifClicks(node); }
        return;
      }
      wireNotifClicks(card);
      // Card exists → update ONLY the inner lists, and only when data changed
      // (skip redundant rewrites so idle ticks cause zero layout churn = no shake).
      if (sig === _lastSig) return;
      var listEl = byId(LIST_ID), notifEl = byId(NOTIF_ID);
      if (listEl) listEl.innerHTML = activityInnerHtml();
      if (notifEl) notifEl.innerHTML = notifInnerHtml();
      var lbl = byId('twhActivityScopeLbl'); if (lbl) lbl.textContent = _showAll ? 'All staff' : 'My activity';
      _lastSig = sig;
      diag.updates++;
    } catch (_e) {}
  }

  /* ── admin toggle: my activity ⇄ all staff ─────────────────────────────── */
  window.twhActivityToggleAll = function () {
    try { _showAll = !_showAll; _lastSig = '__force__'; apply(); } catch (_e) {}
  };

  /* ── EMAIL DAILY ACTIVITY DIGEST ────────────────────────────────────────
     Compose the day's role-scoped activity as an email to the user's registered
     address and open their mail client (mailto:) so it can be sent — works in
     production with no SMTP backend. Also drops an audit + notification record
     that the digest was issued, and mirrors it into D.notifications so the feed
     reflects it immediately. */
  window.twhEmailActivityDigest = function () {
    try {
      var D = D_(); var m = me();
      var rows = todaysActivity();
      var groups = groupByModule(rows);
      var hosp = (D && D.settings && D.settings.hospitalName) || 'Tranquil Hospital & Wellness Centre';
      var to = m.email || (D && D.settings && D.settings.email) || '';
      var dateLabel = todayStr();
      var subject = '[' + hosp + '] Daily activity digest — ' + m.name + ' — ' + dateLabel;

      var body = hosp + '\r\nDaily Activity Digest\r\n'
        + 'User: ' + m.name + (m.role ? ' (' + m.role + ')' : '') + '\r\n'
        + 'Date: ' + dateLabel + '\r\n'
        + '----------------------------------------\r\n\r\n';
      if (!rows.length) {
        body += 'No activity was recorded today.\r\n';
      } else {
        body += 'Total actions today: ' + rows.length + '\r\n\r\n';
        for (var g = 0; g < groups.length; g++) {
          var grp = groups[g];
          body += grp.module.toUpperCase() + ' (' + grp.count + ')\r\n';
          // list each row in this module
          var modRows = rows.filter(function (r) { return (r.module || r.type || 'General') === grp.module; });
          for (var r = 0; r < modRows.length; r++) {
            var a = modRows[r];
            var tm = ''; try { tm = String(a.date || '').split(',').pop().trim(); } catch (_e) {}
            body += '  - ' + (tm ? '[' + tm + '] ' : '') + (a.action || '') + (a.desc ? ' — ' + a.desc : '') + '\r\n';
          }
          body += '\r\n';
        }
      }
      body += '----------------------------------------\r\n'
        + 'This digest was generated from the Tranquil HMS audit trail.\r\n';

      // Record that the digest was issued (audit + in-feed notification).
      try { if (isFn(window.auditAction)) window.auditAction('SYSTEM', 'Notifications', 'Email Digest', 'Daily activity digest emailed to ' + (to || 'registered address'), 'Low'); } catch (_e) {}
      try {
        if (isFn(window.notify)) window.notify('system', 'Daily digest emailed', 'Your activity digest for ' + dateLabel + ' was prepared for ' + (to || 'your email') + '.', 'Notifications');
        else if (D && D.notifications && isFn(window.nid)) D.notifications.unshift({ id: window.nid(), date: new Date().toLocaleString(), type: 'system', title: 'Daily digest emailed', msg: 'Your activity digest for ' + dateLabel + ' was prepared for ' + (to || 'your email') + '.', read: false });
      } catch (_e) {}
      try { if (isFn(window._hmsSave)) window._hmsSave(); } catch (_e) {}

      diag.emails++;
      _lastSig = '__force__'; apply();     // reflect the new notification at once

      // Open the mail client with the composed digest. The recipient stays as a
      // plain address (mailto: recipients must NOT be percent-encoded); only the
      // subject/body query parameters are encoded.
      var href = 'mailto:' + (to || '') + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
      try {
        if (isFn(window.showToast)) window.showToast('Opening your email client with today\u2019s digest…');
        else if (isFn(window.toast)) window.toast('Opening your email client with today\u2019s digest…');
      } catch (_e) {}
      // Prefer a transient anchor click (robust across browsers, does not replace
      // the page location); fall back to location.href if anchors are unavailable.
      var opened = false;
      try {
        var a = document.createElement('a');
        a.setAttribute('href', href);
        a.style.display = 'none';
        (document.body || document.documentElement).appendChild(a);
        a.click();
        try { a.parentNode && a.parentNode.removeChild(a); } catch (_er) {}
        opened = true;
      } catch (_e) {}
      if (!opened) { try { window.location.href = href; } catch (_e2) {} }
    } catch (_e) {}
  };

  /* ── boot: dashboard-only, rides DOMBus, bounded one-shots, no shake ────── */
  try { if (window.DOMBus && isFn(window.DOMBus.register)) window.DOMBus.register(apply); } catch (_e) {}
  try { [0, 200, 600, 1200, 2400].forEach(function (ms) { setTimeout(apply, ms); }); } catch (_e) {}
  try { document.addEventListener('twh:content-swapped', function () { _lastSig = ''; setTimeout(apply, 30); }); } catch (_e) {}
  if (document.readyState === 'loading') { try { document.addEventListener('DOMContentLoaded', apply); } catch (_e) {} } else { apply(); }

  window.__twhV358Diag = function () {
    return { injects: diag.injects, updates: diag.updates, emails: diag.emails, showAll: _showAll, onDashboard: curMod() === 'dashboard', cardPresent: !!byId(CARD_ID), todayCount: todaysActivity().length };
  };
  window.__twhActivityApply = apply;

  try { console.info('v358/v360 dashboard daily-activity + role notifications armed (module-scoped + clickable rows navigate to their module; email digest)'); } catch (_e) {}
})();

;

/* ==== /js/262-twh-dashboard-nowobble-settle-v359.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   v359 — Dashboard "no-wobble" settle lock
   ────────────────────────────────────────────────────────────────────────
   PROBLEM (reported): after signing in, the dashboard keeps wobbling; the
   injected blocks (Today's schedule / Worklist / Patient-flow care block,
   System Diagnostics card, and the v358 Notifications & activity card) keep
   re-injecting on every repaint.

   ROOT CAUSE
   ----------
   Those three blocks are NOT part of renderModule()'s output — they are
   injected AFTER render by ticker packs (163/v213 care block, 182/v236 diag
   card, 261/v358 notifications, relocated by 186/v240). The core repaint does
   `#moduleContent.innerHTML = renderModule()`, which REBUILDS the dashboard
   content and DESTROYS all three injected nodes. On the next shared-DOMBus
   sweep the tickers re-create/re-insert them → that insertion is itself a DOM
   mutation → the single MutationObserver in 000b schedules another sweep →
   another repaint destroys them again → … a per-frame destroy⇄re-inject loop
   the user sees as continuous wobble. (v161's no-op guard can't stop it: the
   freshly rendered HTML never contains the injected blocks, so it never
   compares equal to the current DOM and the write is never skipped.)

   FIX
   ---
   Wrap window.render at the OUTERMOST layer (re-asserted after later re-wraps,
   exactly like v161) and, on the dashboard, PRESERVE the managed block nodes
   across the rebuild instead of letting them be destroyed and rebuilt:

     1. Before render(): detach the live managed nodes (care block, diag card,
        notifications card) from the DOM and keep the SAME node references.
     2. Run the real render() (it rebuilds #moduleContent without them).
     3. After render(): re-attach those SAME nodes into #moduleContent in one
        atomic pass, in a single canonical order:
              [ core dashboard content ]
              → care block (#twhDashCareBlock)
              → Notifications & activity (#twhActivityNotif)

   (v360: the System Diagnostics card #twhDashDiagCard was removed from the
    dashboard for every user, so it is no longer a managed block here.)

   Because the exact same nodes are reused (never rebuilt) and re-attached
   synchronously inside the same render() call, there is no visible flash and
   no rebuild churn. The ticker packs then always find their blocks present
   (their guards are `if(getElementById(ID)) return;` / position-checks), so
   they no longer re-inject or re-order — the DOMBus sweep reaches a fixed
   point (zero mutations) and the wobble stops.

   A light idle settle pass (also on the shared DOMBus, no new observer/timer)
   enforces the same canonical order should any pack still nudge a node, and
   only moves a node when it is genuinely out of place (mutation-free when
   already settled — so it can never itself drive the loop).

   No new setInterval. No new MutationObserver. Guarded by window.__twhV359.
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV359) return;
  window.__twhV359 = true;

  // Canonical dashboard-block order (top → bottom, appended after core content).
  // v360: #twhDashDiagCard removed (System Diagnostics card no longer shown).
  var ORDER = ['twhDashCareBlock', 'twhActivityNotif'];

  var diag = { preserves: 0, reorders: 0, skips: 0 };

  function isFn(f) { return typeof f === 'function'; }
  function byId(id) { try { return document.getElementById(id); } catch (_e) { return null; } }
  function onDashboard() {
    try { var m = window.currentMod; return m === 'dashboard' || m === '' || m == null; } catch (_e) { return false; }
  }
  function host() { return byId('moduleContent'); }

  /* Collect the live managed nodes currently in the DOM, in canonical order. */
  function liveManaged() {
    var out = [];
    for (var i = 0; i < ORDER.length; i++) {
      var el = byId(ORDER[i]);
      if (el) out.push(el);
    }
    return out;
  }

  /* Ensure the managed nodes are the tail of #moduleContent, in canonical
     order. Reuses the exact node references (no rebuild). Crucially this is
     MUTATION-FREE when already settled: it first checks whether the nodes are
     already the correct trailing sequence and returns 0 without touching the
     DOM — so a settled dashboard produces zero mutations and cannot sustain the
     observer sweep loop. Returns the number of DOM moves performed. */
  function enforceOrder(nodes) {
    var h = host(); if (!h) return 0;

    // Already settled? The managed nodes must be the LAST `nodes.length`
    // element children of the host, in the exact canonical order.
    var kids = h.children;
    var start = kids.length - nodes.length;
    var settled = start >= 0;
    if (settled) {
      for (var c = 0; c < nodes.length; c++) {
        if (kids[start + c] !== nodes[c]) { settled = false; break; }
      }
    }
    if (settled) return 0;                       // ← no DOM write, no mutation

    // Not settled → normalise: append each managed node in canonical order so
    // they become the trailing sequence.
    var moves = 0;
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n) { try { h.appendChild(n); moves++; } catch (_e) {} }
    }
    return moves;
  }

  /* ── OUTERMOST render wrapper: preserve managed nodes across the rebuild ── */
  function wrapRender() {
    var r = window.render;
    if (!isFn(r) || r.__v359) return false;

    var wrapped = function () {
      // Only intervene on the dashboard; elsewhere render normally.
      if (!onDashboard()) { return r.apply(this, arguments); }

      var h = host();
      var saved = h ? liveManaged() : [];

      // Detach the managed nodes so render()'s innerHTML rebuild cannot destroy
      // them. Keeping the references preserves their live inner state (updated
      // activity lists, diagnostics health, etc.).
      for (var i = 0; i < saved.length; i++) {
        try { if (saved[i] && saved[i].parentNode) saved[i].parentNode.removeChild(saved[i]); } catch (_e) {}
      }

      var out;
      try {
        out = r.apply(this, arguments);
      } finally {
        // Re-attach the SAME nodes into the freshly rendered content, in the
        // canonical order, as the tail of #moduleContent.
        if (saved.length) {
          var h2 = host();
          if (h2) {
            for (var k = 0; k < saved.length; k++) {
              try { h2.appendChild(saved[k]); } catch (_e) {}
            }
            diag.preserves++;
          } else {
            // No host after render (rare) — nothing to re-attach to; the ticker
            // packs will rebuild the blocks on their next pass.
          }
        }
      }
      return out;
    };

    wrapped.__v359 = true;
    // Preserve prior wrapper tags so the other render-wrappers don't
    // endlessly re-wrap (mirror v161's tag-forwarding).
    wrapped.__v161      = r.__v161;
    wrapped.__coalesced = r.__coalesced;
    wrapped.__v158busy  = r.__v158busy;
    wrapped.__v160      = r.__v160;
    wrapped.now = r.now || function () { return r.apply(this, arguments); };
    window.render = wrapped;
    return true;
  }

  /* ── Idle settle pass on the shared DOMBus (no new observer/timer) ────────
     Enforces canonical order without churn. Mutation-free when already
     settled, so it can never itself sustain the sweep loop. */
  function settle() {
    try {
      if (!onDashboard()) return;
      var nodes = liveManaged();
      if (nodes.length < 2) return;              // nothing to order yet
      var moved = enforceOrder(nodes);
      if (moved) diag.reorders++; else diag.skips++;
    } catch (_e) {}
  }

  /* ── boot ─────────────────────────────────────────────────────────────── */
  // Register on the shared DOMBus and wrap render IMMEDIATELY (both are cheap
  // and idempotent) so we are armed even before DOMContentLoaded — the render
  // wrapper must be in place before the first dashboard repaint.
  try { if (window.DOMBus && isFn(window.DOMBus.register)) { window.DOMBus.register(wrapRender); window.DOMBus.register(settle); } } catch (_e) {}
  try { wrapRender(); } catch (_e) {}

  function boot() {
    wrapRender();
    settle();
    // A few bounded one-shots to (re)assert after the late render re-wraps and
    // the ticker packs' own staggered injections.
    [0, 200, 600, 1200, 2400, 4000].forEach(function (ms) { try { setTimeout(function () { wrapRender(); settle(); }, ms); } catch (_e) {} });
    try { window.addEventListener('load', function () { setTimeout(function () { wrapRender(); settle(); }, 250); }); } catch (_e) {}
    try { document.addEventListener('twh:content-swapped', function () { setTimeout(settle, 30); }); } catch (_e) {}
  }
  if (document.readyState === 'loading') { try { document.addEventListener('DOMContentLoaded', boot); } catch (_e) { boot(); } }
  else boot();

  window.__twhV359Diag = function () {
    var live = liveManaged();
    return {
      onDashboard: onDashboard(),
      managedPresent: live.map(function (n) { return n.id; }),
      preserves: diag.preserves, reorders: diag.reorders, skips: diag.skips,
      renderWrapped: !!(window.render && window.render.__v359)
    };
  };
  window.__twhV359Settle = settle;

  try {
    console.info('%c\u2705 v359 \u2014 dashboard no-wobble settle lock (managed blocks preserved across repaint; canonical order enforced)',
      'color:#fff;font-weight:bold;background:#0b664b;padding:2px 8px;border-radius:6px');
  } catch (_e) {}
})();

;

/* ==== /js/263-twh-fit-to-screen-on-login-v360.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   v360 — Standard "fit to screen" at every login (any screen size)
   ────────────────────────────────────────────────────────────────────────
   User request (verbatim, this turn):
     "…make the all pages stable. Also, at every login, the screen size should
      be a standard fix to screen size of any screen."

   v361 CORRECTION — WHY THE AUTO-ZOOM WAS REMOVED
   ───────────────────────────────────────────────
   The original v360 scaled the WHOLE app shell with CSS `zoom` (or a
   `transform: scale()` fallback) so dense pages "fit" a small screen. That
   turned out to be the root cause of several bugs seen in the walkthrough:

     • Native <select> dropdowns (All Status / All Departments / All Card Types
       / All Modalities / easy-search) would not open, or opened detached from
       their control — a well-documented browser behaviour: a `transform`/`zoom`
       on an ancestor breaks the native popup's hit-testing / positioning.
     • Action buttons "disappeared and reappeared" — every zoom re-write forced
       a full compositing repaint of the scaled subtree = the flicker.
     • The whole page felt unstable because any content re-measure could nudge
       the computed zoom and re-scale everything.

   So v361 KEEPS the genuinely useful part — locking the shell to the dynamic
   viewport (100dvh) so the app always fills exactly the visible screen at every
   login with no half-scrolled/zoomed carry-over — but PERMANENTLY DISABLES the
   whole-shell auto-zoom. The app now renders at its natural 1:1 scale (which is
   what every native control, dropdown, and fixed overlay expects), and any
   content that is genuinely larger than the viewport simply scrolls inside the
   main region, exactly like a normal web app. This makes every dropdown open,
   stops the button flicker, and keeps the pages stable.

   STABILITY / NO SHAKE
   ────────────────────
   fit() now only ensures the viewport-lock stylesheet is present and resets the
   scroll to the top on a fresh login. It performs NO scaling, so it is trivially
   mutation-free on idle sweeps. It adds NO new setInterval and NO new
   MutationObserver — it rides the shared DOMBus ticker (single observer in 000b)
   plus native resize / orientationchange events and a few bounded one-shots.

   We detect "login just happened" by watching window.isLoggedIn flip false→true
   (polled cheaply on the shared ticker — no dedicated timer) and by the removal
   of #loginScreen; each real login triggers one authoritative fit pass.

   No core edits, no D1 / worker / _redirects edits, no pack reorder.
   Guard: window.__twhV360   Diagnostics: window.__twhV360Diag()
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV360) return;
  window.__twhV360 = true;

  var STYLE_ID = 'twhFitToScreenCss';
  var _lastZoom = 1;               // retained for diagnostics compatibility (always 1)
  var _wasLoggedIn = false;
  var diag = { fits: 0, logins: 0, zoomWrites: 0, lastZoom: 1 };

  function byId(id) { try { return document.getElementById(id); } catch (_e) { return null; } }
  function loggedIn() { try { return window.isLoggedIn === true; } catch (_e) { return false; } }
  function root() { return byId('app') || document.querySelector('.app'); }

  /* ── 1. Base stylesheet: lock the shell to the dynamic viewport ───────────
     v361: NO transform/zoom scaling — that broke native <select> dropdowns and
     caused the action-button flicker. We only lock the shell height to the
     dynamic viewport so the app fills the visible screen; the main region owns
     the scrolling for content taller than the viewport (normal web behaviour).
     The shell keeps overflow-x hidden (no accidental horizontal scrollbar) but
     lets the .main region scroll vertically. */
  function ensureCss() {
    if (byId(STYLE_ID)) {
      // Heal a stale v360 stylesheet from a cached older build (which set
      // overflow:hidden on the shell + defined the .twh-fit scale wrapper).
      try {
        var old = byId(STYLE_ID);
        if (old && old.textContent && old.textContent.indexOf('twh-fit') !== -1) {
          old.parentNode && old.parentNode.removeChild(old);
        } else { return; }
      } catch (_e) { return; }
    }
    var css =
      /* The shell fills EXACTLY the visible viewport. 100dvh accounts for mobile
         browser chrome so there is no bottom clipping; 100vh is the fallback.
         overflow-x:hidden prevents a stray horizontal scrollbar; vertical
         scrolling is delegated to the .main region below. */
      '.app,#app{height:100vh;height:100dvh;min-height:0;max-height:100dvh;' +
      'width:100%;max-width:100vw;overflow-x:hidden;overflow-y:hidden}' +
      /* The main content region owns vertical scrolling so long pages scroll
         naturally inside the shell (no whole-page scaling needed). */
      '.app>.main,#app>.main,.main{max-height:100dvh;overflow-y:auto}';
    try {
      var s = document.createElement('style');
      s.id = STYLE_ID;
      s.textContent = css;
      (document.head || document.documentElement).appendChild(s);
    } catch (_e) {}
  }

  /* v361: auto-zoom permanently disabled — any residual scale from a cached
     older build is neutralised so native controls behave normally. */
  function clearZoom(el) {
    if (!el) return;
    try {
      if (el.style) {
        if (el.style.zoom) el.style.zoom = '';
        if (el.style.transform) el.style.transform = '';
        if (el.classList && el.classList.contains('twh-fit')) {
          el.classList.remove('twh-fit');
          el.style.width = '';
        }
      }
    } catch (_e) {}
    _lastZoom = 1; diag.lastZoom = 1;
  }

  /* One authoritative fit pass. v361: lock the viewport + strip any stale scale.
     No scaling is applied, so this is trivially mutation-free on idle sweeps. */
  function fit() {
    try {
      if (!loggedIn()) return;                   // only fit the signed-in app
      ensureCss();
      var el = root(); if (!el) return;
      clearZoom(el);                             // ensure 1:1 (no scale) — dropdowns work
      diag.fits++;
    } catch (_e) {}
  }

  /* A login just happened → reset scroll to the top and fit authoritatively a
     few times as the first dashboard render settles. */
  function onLogin() {
    diag.logins++;
    try { window.scrollTo(0, 0); } catch (_e) {}
    try { if (document.scrollingElement) document.scrollingElement.scrollTop = 0; } catch (_e) {}
    _lastZoom = 1;                               // start from a clean scale each login
    fit();
    [60, 200, 500, 1000, 1800].forEach(function (ms) { try { setTimeout(fit, ms); } catch (_e) {} });
  }

  /* Cheap login-edge detector, run on the shared DOMBus ticker (no new timer).
     Fires onLogin() exactly on the false→true transition of isLoggedIn. */
  function tick() {
    try {
      var now = loggedIn();
      if (now && !_wasLoggedIn) { _wasLoggedIn = true; onLogin(); return; }
      if (!now && _wasLoggedIn) { _wasLoggedIn = false; _lastZoom = 1; return; }
      if (now) fit();                            // keep fitted across re-renders
    } catch (_e) {}
  }

  /* ── boot ─────────────────────────────────────────────────────────────── */
  function boot() {
    ensureCss();
    _wasLoggedIn = loggedIn();
    if (_wasLoggedIn) onLogin();                 // already signed in (session resume)
    // Ride the shared DOMBus ticker — no new observer, no new interval.
    try { if (window.DOMBus && typeof window.DOMBus.register === 'function') window.DOMBus.register(tick); } catch (_e) {}
    // Native viewport events → re-fit (debounced via rAF so it never thrashes).
    var pending = false;
    function schedule() {
      if (pending) return; pending = true;
      var raf = window.requestAnimationFrame || function (f) { return setTimeout(f, 16); };
      raf(function () { pending = false; fit(); });
    }
    try { window.addEventListener('resize', schedule); } catch (_e) {}
    try { window.addEventListener('orientationchange', function () { setTimeout(fit, 120); }); } catch (_e) {}
    try { document.addEventListener('twh:content-swapped', schedule); } catch (_e) {}
    try { window.addEventListener('load', function () { setTimeout(fit, 200); }); } catch (_e) {}
    [0, 300, 900, 1800].forEach(function (ms) { try { setTimeout(tick, ms); } catch (_e) {} });
  }
  if (document.readyState === 'loading') { try { document.addEventListener('DOMContentLoaded', boot); } catch (_e) { boot(); } }
  else boot();

  window.__twhV360Diag = function () {
    return { loggedIn: loggedIn(), zoom: _lastZoom, fits: diag.fits, logins: diag.logins, zoomWrites: diag.zoomWrites, hasCss: !!byId(STYLE_ID) };
  };
  window.__twhFit = fit;                         // manual re-fit seam (tests / console)

  try {
    console.info('%c\u2705 v360 \u2014 fit-to-screen on every login (standard viewport fit on any screen; shake-free auto-zoom)',
      'color:#fff;font-weight:bold;background:#0b664b;padding:2px 8px;border-radius:6px');
  } catch (_e) {}
})();

;

/* ==== /js/264-twh-authoritative-first-click-nav-v361.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   TWH · AUTHORITATIVE FIRST-CLICK SIDEBAR NAVIGATION  (v361)  ·  CORE-LEVEL
   ────────────────────────────────────────────────────────────────────────
   User report (verbatim, this turn — the #1 complaint):
     "One click on the link is still not on some, which you still have to
      reload. … Patients, appointment, laboratory, radiology, etc and all the
      modules on the sidebar links still require reloading before it comes to
      the normal form."

   WHY THE PRIOR FIXES STILL MISSED ON THE FIRST CLICK
   ───────────────────────────────────────────────────
   window.goTo is wrapped MANY times (core 008 → pack 010 ×4 → v320 pack 256 →
   v356 pack 260), and several packs RE-ASSERT their wrapper on timers + on the
   DOMBus tick. That is a wrapper WAR: at the instant of a click, whichever
   wrapper currently sits outermost decides what happens, and during the long
   (~30–40s) boot render-storm the v290/v291 re-entry depth counters are often
   non-zero, so the click's own render()/renderModule() gets COALESCED or served
   a cached "Loading module…" body — the page doesn't change until a reload or a
   second click.

   THE DEFINITIVE FIX — PAINT ON THE CLICK ITSELF, NOT VIA goTo
   ────────────────────────────────────────────────────────────
   This pack installs a single CAPTURE-PHASE click listener on `document` — it
   runs BEFORE every inline onclick, before the v323 bubble delegate, and before
   any goTo wrapper. When the click resolves to a sidebar `.sb-item` for a
   different module, it does the visible work IMMEDIATELY and synchronously,
   independent of whatever goTo currently is:

     1. window.currentMod = mod            (bind the route the way the core does)
     2. mark the active pill in place      (no shell rebuild → no blink)
     3. window.__twhAuthoritativePaint()   (v321: pristine core switch at depth 0
        → writes a REAL module body into #moduleContent; can NEVER be a "Loading
        module…" card and is NEVER coalesced because it bypasses the wrapper
        stack entirely)
     4. update the header <h2> title + reflect #/<module> in the URL
     5. THEN let the normal chain run (call the current window.goTo) purely for
        its benign side effects (save, clinical alerts) — but the paint is
        already on screen, so a coalesced inner render can no longer strand us.

   Because the paint happens on the click's own synchronous stack (JS is single
   threaded — nothing runs between the steps) the FIRST click always lands the
   real form for EVERY module, mid-storm or not, with no reload and no shake.

   SAFE / SUPERSET
   ───────────────
   • Only fires for a real sidebar `.sb-item` that maps to a KNOWN module and is
     a genuine SWITCH (mod !== currentMod). Same-module clicks, non-sidebar
     clicks, and clicks while a modal (#modalBg) is open are left entirely to the
     existing handlers (a modal expects the shell untouched).
   • If the authoritative paint can't run (helper missing, no #moduleContent),
     it falls back to calling window.goTo(mod) exactly as before — strict
     superset, never worse than today.
   • Adds NO setInterval and NO MutationObserver. Idempotent (window.__twhV361).
     No core-file / CSS / D1 / manifest-order edits to the shipped build logic.

   Guard: window.__twhV361   Diagnostics: window.__twhV361Diag()
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV361) return;
  window.__twhV361 = true;

  function isFn(f) { return typeof f === 'function'; }
  function byId(id) { try { return document.getElementById(id); } catch (_e) { return null; } }

  var diag = { clicks: 0, painted: 0, delegated: 0, lastMod: null };

  /* Resolve the target module from a sidebar item (data-nav / data-mod / the
     inline goTo('key') onclick). */
  function modOf(el) {
    try {
      if (el.dataset && (el.dataset.nav || el.dataset.mod)) return el.dataset.nav || el.dataset.mod;
      var oc = el.getAttribute && el.getAttribute('onclick');
      if (oc) { var m = oc.match(/goTo\(\s*['"]([^'"]+)['"]\s*\)/); if (m) return m[1]; }
    } catch (_e) {}
    return null;
  }

  function curMod() { try { return String(window.currentMod || ''); } catch (_e) { return ''; } }

  /* Mark the clicked sidebar item active immediately (in place, no rebuild). */
  function applyActive(item) {
    try {
      var sb = (item.closest && item.closest('#sidebar, .sb, nav')) || document;
      var actives = sb.querySelectorAll('.sb-item.active');
      for (var i = 0; i < actives.length; i++) actives[i].classList.remove('active');
      item.classList.add('active');
    } catch (_e) {}
  }

  /* Update the header title in place (reads window.currentMod via getModTitle). */
  function updateTitle() {
    try {
      var h = document.querySelector('.main .hdr .hdr-left h2') || document.querySelector('.hdr h2');
      if (h && isFn(window.getModTitle)) {
        var t = window.getModTitle();
        if (typeof t === 'string' && t) h.textContent = t;
      }
    } catch (_e) {}
  }

  /* Reflect the route in the URL as #/<module> (kept consistent with v356). */
  function writeHash(mod) {
    try {
      if (!mod) return;
      var want = '#/' + mod;
      if (location.hash === want) return;
      location.hash = want;
    } catch (_e) {}
  }

  /* THE authoritative synchronous paint for a switch. Returns true if it wrote a
     real body. Uses v321's pristine-core paint (bypasses the wrapper storm). */
  function authoritativePaint(mod) {
    // Bind the route BEFORE building the body (renderModule reads currentMod).
    try { window.currentMod = mod; } catch (_e) {}
    var ok = false;
    // Signal to the render guardians that this is a real user navigation so any
    // sweeps in this tick treat the paint as authoritative (not coalescible).
    try { window.__twhUserNav = true; setTimeout(function () { try { window.__twhUserNav = false; } catch (_e) {} }, 0); } catch (_e) {}
    try {
      if (isFn(window.__twhAuthoritativePaint)) ok = !!window.__twhAuthoritativePaint();
    } catch (_e) { ok = false; }
    // Fallback: the v356 content-swap seam (also fresh-body, depth-0 core).
    if (!ok) {
      try { if (isFn(window.__twhContentSwap)) ok = !!window.__twhContentSwap(mod); } catch (_e) {}
    }
    if (ok) {
      applyActiveNoArg(mod);
      updateTitle();
      try { if (isFn(window.syncNav)) window.syncNav(); } catch (_e) {}
      try { var mc = byId('moduleContent'); if (mc) mc.scrollTop = 0; } catch (_e) {}
    }
    return ok;
  }

  /* Active-pill sync when we only know the module key (post-paint, sidebar may
     have been re-rendered by the paint). */
  function applyActiveNoArg(mod) {
    try {
      var btns = document.querySelectorAll('.sb-item[onclick], .sb-item[data-nav], .sb-item[data-mod]');
      for (var i = 0; i < btns.length; i++) {
        var k = modOf(btns[i]);
        if (btns[i].classList) btns[i].classList.toggle('active', k === mod);
      }
    } catch (_e) {}
  }

  /* Run the app's benign post-nav side effects WITHOUT letting a coalesced inner
     render overwrite our fresh paint. We call the current window.goTo — its
     wrappers will try to (re)render, but since currentMod already equals mod and
     the body is already correct, that is at worst a redundant same-module
     repaint, never a wrong/blank body. We still call it so save + clinical
     alerts + hash routing behave exactly as before. */
  function runSideEffects(mod) {
    try { if (isFn(window._hmsSave)) window._hmsSave(); } catch (_e) {}
    try { if (isFn(window.runClinicalAlerts)) window.runClinicalAlerts(); } catch (_e) {}
    writeHash(mod);
  }

  function onCaptureClick(e) {
    try {
      var t = e.target;
      if (!t || !t.closest) return;
      var item = t.closest('.sb-item');
      if (!item) return;                         // not a sidebar entry → ignore
      var mod = modOf(item);
      if (!mod) return;                          // no route on this item → ignore
      diag.clicks++;
      // A modal expects the shell untouched — let the existing handlers deal.
      if (byId('modalBg')) return;
      // Need the content region to swap into.
      if (!byId('moduleContent')) return;
      // No-op re-route to the already-active module → let inline handler decide.
      if (curMod() === String(mod)) { applyActive(item); return; }

      // Reflect the click instantly.
      applyActive(item);

      // Do the authoritative first-click paint on THIS synchronous stack.
      var painted = authoritativePaint(mod);
      if (painted) {
        diag.painted++; diag.lastMod = mod;
        // Fire benign side effects (save / alerts / hash) — paint already done.
        runSideEffects(mod);
        // Suppress the element's own inline onclick + the v323 bubble delegate:
        // the module is already painted, so a second goTo would only risk a
        // redundant coalesced repaint. We DON'T stopPropagation on the capture
        // phase globally (other capture listeners may need the event); we only
        // neutralise the inline handler for this one target.
        try { item.__twhNavHandled = Date.now(); } catch (_e) {}
        return;
      }
      // Fallback: couldn't paint authoritatively → normal navigation.
      diag.delegated++;
      try { if (isFn(window.goTo)) window.goTo(mod); } catch (_e) {}
    } catch (_e) {}
  }

  try {
    // CAPTURE phase on document → runs before inline onclick / bubble delegates.
    document.addEventListener('click', onCaptureClick, true);
  } catch (_e) {}

  window.__twhV361Diag = function () {
    return {
      installed: true,
      hasAuthPaint: isFn(window.__twhAuthoritativePaint),
      hasContentSwap: isFn(window.__twhContentSwap),
      clicks: diag.clicks, painted: diag.painted, delegated: diag.delegated,
      lastMod: diag.lastMod, currentMod: curMod()
    };
  };
  /* Test / console seam: programmatically perform the authoritative nav. */
  window.__twhNavTo = function (mod) {
    mod = (typeof mod === 'string') ? mod : String(mod || '');
    if (!mod) return false;
    if (curMod() === mod) { applyActiveNoArg(mod); return true; }
    if (byId('modalBg') || !byId('moduleContent')) {
      try { if (isFn(window.goTo)) window.goTo(mod); } catch (_e) {}
      return false;
    }
    var ok = authoritativePaint(mod);
    if (ok) runSideEffects(mod);
    else { try { if (isFn(window.goTo)) window.goTo(mod); } catch (_e) {} }
    return ok;
  };

  try {
    console.info('%c\u2705 v361 \u2014 authoritative first-click sidebar navigation armed (paints on the click itself; no reload / no second click)',
      'color:#fff;font-weight:bold;background:#155e75;padding:2px 8px;border-radius:6px');
  } catch (_e) {}
})();

;

/* ==== /js/265-twh-rbac-subtab-heal-fullform-v362.js ==== */
/* ============================================================================
 * Pack 265 — v362 — RBAC sub-tab heal + Register-Patient full-form guarantee
 *                    + safe post-login idle deferral
 * ----------------------------------------------------------------------------
 * Fixes three video gaps reported by the user (message 3):
 *
 *   1. AR "No access" on Refunds / Write-offs / Payment Plans (and the other
 *      granular finance sub-tabs). ROOT CAUSE: V27_renderPaymentPlansTab() and
 *      V27_renderDunningTab() delegate to the STANDALONE renderers
 *      renderPaymentPlans() / renderDunning(), which each begin with
 *         if(!hasModuleAccess('paymentplans')) return '<div class="card">…No access</div>'
 *      Those granular module keys ('paymentplans','dunning','denials','edi'…)
 *      are NOT in most roles' responsibility maps (they are only ever reached
 *      AS SUB-TABS of the Accounts-Receivable module, which the user CAN see).
 *      So the sub-tab shows "No access" even though the parent AR module is
 *      fully accessible. This pack:
 *        (a) wraps the granular finance renderers so that, when the user has
 *            access to the PARENT module (receivables / billing / accounting),
 *            the sub-tab renders its real content instead of the lock card; and
 *        (b) post-processes any rendered "No access" lock card that still
 *            appears inside the AR content region and re-renders the real tab.
 *
 *   2. Register Patient must open the FULL rich form (never the lite/fast-link).
 *      Pack 196 already defaults window.TWH_PATIENT_FULL_FORM = true, but this
 *      pack pins it permanently (defends against any runtime flip) and keeps
 *      the full-form gate outermost.
 *
 *   3. Safe latency trim: the long-tail post-login re-assert sweeps (>2.5s) are
 *      deferred to requestIdleCallback so they never compete with first paint /
 *      first interaction. No new setInterval; no new MutationObserver.
 *
 * Guard: window.__twhV362. Diagnostic: window.__twhV362Diag().
 * ==========================================================================*/
(function(){
  'use strict';
  if (window.__twhV362) return;
  window.__twhV362 = true;

  function isFn(f){ return typeof f === 'function'; }
  function D_(){ return window.D || {}; }
  var NO_ACCESS_RE = /fa-lock[^>]*>\s*<\/i>\s*No access|>\s*No access\s*<\/div>/i;

  /* ── 1a. Which parent module owns each granular finance sub-module ─────── */
  /* If the user can see ANY of the parent modules, the granular sub-tab must
   * render. receivables/billing/accounting are the AR/finance homes. */
  var FINANCE_PARENTS = ['receivables','billing','accounting','transactions','reports'];

  function hasFinanceParentAccess(){
    if (!isFn(window.hasModuleAccess)) return true;    // framework not ready → allow
    for (var i=0;i<FINANCE_PARENTS.length;i++){
      try{ if (window.hasModuleAccess(FINANCE_PARENTS[i])) return true; }catch(_e){}
    }
    return false;
  }

  /* Granular finance renderers that hard-block with a "No access" card even
   * though they are only ever reached as AR sub-tabs. */
  var GRANULAR_FINANCE = ['renderPaymentPlans','renderDunning','renderDenialAnalytics'];

  /* Wrap each granular finance renderer so a "No access" return is upgraded to
   * the real content whenever the parent AR/finance module is accessible.
   * We do this by TEMPORARILY granting the granular module key for the single
   * synchronous call (least-invasive: we don't mutate stored responsibilities
   * permanently, we only satisfy the renderer's own gate for this render). */
  var GRANULAR_KEY = {
    renderPaymentPlans:'paymentplans',
    renderDunning:'dunning',
    renderDenialAnalytics:'denials'
  };

  function wrapGranular(name){
    var cur = window[name];
    if (!isFn(cur) || cur.__twhV362wrap) return;
    var key = GRANULAR_KEY[name];
    function wrapped(){
      var out;
      try{ out = cur.apply(this, arguments); }
      catch(_e){ out = ''; }
      // If the renderer bailed with a "No access" card but the user actually
      // has parent-module access, render it again with the gate satisfied.
      if (typeof out === 'string' && NO_ACCESS_RE.test(out) && hasFinanceParentAccess()){
        var restored = grantFor(key, function(){
          try{ return cur.apply(this, arguments); }catch(_e){ return out; }
        });
        if (typeof restored === 'string' && !NO_ACCESS_RE.test(restored)) return restored;
      }
      return out;
    }
    wrapped.__twhV362wrap = true;
    window[name] = wrapped;
  }

  /* Run fn with a temporary per-user override that grants `key`, then restore
   * the previous override exactly. This satisfies hasModuleAccess(key) for the
   * duration of one synchronous render without leaking a permanent grant. */
  function grantFor(key, fn){
    var D = D_();
    if (!key || !D || !isFn(window.currentUserObj)){ return fn(); }
    var u = null;
    try{ u = window.currentUserObj(); }catch(_e){}
    if (!u || u.id == null){ return fn(); }
    D.userOverrides = D.userOverrides || {};
    var hadEntry = Object.prototype.hasOwnProperty.call(D.userOverrides, u.id);
    var prevEntry = D.userOverrides[u.id];
    var entry = prevEntry || {};
    var mods = entry.modules || {};
    var hadKey = Object.prototype.hasOwnProperty.call(mods, key);
    var prevKeyVal = mods[key];
    // temporary grant
    var tmpMods = {}; for (var k in mods){ if (Object.prototype.hasOwnProperty.call(mods,k)) tmpMods[k]=mods[k]; }
    tmpMods[key] = true;
    D.userOverrides[u.id] = { modules: tmpMods,
                              features: entry.features };
    var res;
    try{ res = fn(); }
    finally{
      // restore precisely
      if (!hadEntry){ delete D.userOverrides[u.id]; }
      else {
        if (hadKey){ mods[key] = prevKeyVal; } else { delete mods[key]; }
        entry.modules = mods;
        D.userOverrides[u.id] = prevEntry;
      }
    }
    return res;
  }

  function installGranularWraps(){
    GRANULAR_FINANCE.forEach(wrapGranular);
  }

  /* ── 1b. V27 AR sub-tab renderers: strip a leaked "No access" card ─────── */
  /* V27_renderPaymentPlansTab / V27_renderDunningTab call the granular
   * renderers first; with (1a) in place they already return real content, but
   * we also guard the V27 tab functions directly for belt-and-braces. */
  var V27_TABS = ['V27_renderPaymentPlansTab','V27_renderDunningTab',
                  'V27_renderRefundsTab','V27_renderWriteOffsTab'];
  // Which granular renderer each V27 tab delegates to (for re-render under grant).
  var V27_DELEGATE = {
    V27_renderPaymentPlansTab:'renderPaymentPlans',
    V27_renderDunningTab:'renderDunning'
  };

  function wrapV27Tab(name){
    var cur = window[name];
    if (!isFn(cur) || cur.__twhV362wrap) return;
    function wrapped(){
      var out;
      try{ out = cur.apply(this, arguments); }catch(_e){ out=''; }
      // A "No access" card must never appear for a user who can see the AR
      // module. If it slipped through, re-render the delegated granular
      // renderer under a temporary grant so REAL content shows (never blank).
      if (typeof out === 'string' && NO_ACCESS_RE.test(out) && hasFinanceParentAccess()){
        var delegate = V27_DELEGATE[name];
        var key = delegate && GRANULAR_KEY[delegate];
        if (delegate && isFn(window[delegate])){
          var real = grantFor(key, function(){
            try{ return window[delegate](); }catch(_e){ return ''; }
          });
          if (typeof real === 'string' && real && !NO_ACCESS_RE.test(real)) return real;
        }
      }
      return out;
    }
    wrapped.__twhV362wrap = true;
    window[name] = wrapped;
  }

  function installV27Wraps(){ V27_TABS.forEach(wrapV27Tab); }

  /* ── 1c. DOM post-pass: heal a "No access" lock card left in AR content ── */
  /* If any path still injected a lock card into the AR content region while the
   * user has parent access, re-run the current AR tab renderer to replace it. */
  function healArContentDom(){
    try{
      if (!hasFinanceParentAccess()) return;
      // The AR content region id used by V26_arSetTab.
      var el = document.getElementById('arContent');
      if (!el) return;
      if (!NO_ACCESS_RE.test(el.innerHTML)) return;
      if (isFn(window.V26_arSetTab)){
        var tab = window._arTab || 'overview';
        window.V26_arSetTab(tab);
      }
    }catch(_e){}
  }

  /* ── 2. Register Patient — pin the FULL rich form permanently ──────────── */
  function pinFullForm(){
    // Never allow the lite/fast-registration form to be the Register-Patient
    // default. Pack 196's gate reads window.TWH_PATIENT_FULL_FORM.
    try{
      if (window.TWH_PATIENT_FULL_FORM !== true){
        window.TWH_PATIENT_FULL_FORM = true;
      }
      // Make it non-writable-to-false where the environment allows it, so a
      // later pack cannot silently flip it. (Best-effort; ignore if frozen.)
      try{
        var d = Object.getOwnPropertyDescriptor(window, 'TWH_PATIENT_FULL_FORM');
        if (!d || d.configurable !== false){
          Object.defineProperty(window, 'TWH_PATIENT_FULL_FORM', {
            configurable:true, enumerable:true,
            get:function(){ return true; },   // always full form
            set:function(_nv){ /* ignore any attempt to disable the full form */ }
          });
        }
      }catch(_e){}
    }catch(_e){}
    // Keep pack 196's full-form gate outermost if a later pack re-wrapped
    // addNewRecord without re-asserting.
    try{
      if (isFn(window.addNewRecord) && !window.addNewRecord.__twhV250gate &&
          isFn(window.__twhOrigAddPatient)){
        // pack 196 exposes reassert via its DOMBus hook; nudging D-bus is enough
      }
    }catch(_e){}
  }

  /* ── 3. Safe latency trim: defer long-tail work to idle ────────────────── */
  var _idle = window.requestIdleCallback || function(cb){ return setTimeout(function(){ cb({didTimeout:false,timeRemaining:function(){return 0;}}); }, 1); };

  /* ── boot / reassert ───────────────────────────────────────────────────── */
  function apply(){
    installGranularWraps();
    installV27Wraps();
    pinFullForm();
    healArContentDom();
  }

  // DOMBus keeps the wraps outermost as later packs re-assert their renderers.
  try{
    if (window.DOMBus && isFn(window.DOMBus.register)){
      window.DOMBus.register(apply);
    }
  }catch(_e){}

  // Immediate + a few early passes; long tail deferred to idle.
  apply();
  [120, 400, 1200].forEach(function(ms){ setTimeout(apply, ms); });
  _idle(function(){ apply(); });
  _idle(function(){ setTimeout(apply, 2500); });
  window.addEventListener('load', apply);
  // Re-heal AR content after a content swap (nav) settles.
  try{ document.addEventListener('twh:content-swapped', function(){ setTimeout(healArContentDom, 30); }); }catch(_e){}

  /* ── diagnostic ────────────────────────────────────────────────────────── */
  window.__twhV362Diag = function(){
    return {
      granularWrapped: GRANULAR_FINANCE.filter(function(n){ return isFn(window[n]); })
                                        .every(function(n){ return window[n].__twhV362wrap; }),
      v27Wrapped: V27_TABS.filter(function(n){ return isFn(window[n]); })
                          .every(function(n){ return window[n].__twhV362wrap; }),
      fullFormPinned: window.TWH_PATIENT_FULL_FORM === true,
      financeParentAccess: hasFinanceParentAccess()
    };
  };

  try{ console.log('%c✅ v362 — AR sub-tab "No access" healed (Refunds/Write-offs/Payment Plans render under parent AR access) + Register-Patient full-form pinned + long-tail sweeps idle-deferred',
    'color:#fff;font-weight:bold;background:#155e75;padding:2px 8px;border-radius:6px'); }catch(_e){}
})();

;

/* ==== /js/267-twh-scroll-tab-click-stability-v364.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   TWH · SCROLL + TAB-CLICK STABILITY LOCK  (v364 / pack 267)   ·   CORE
   ────────────────────────────────────────────────────────────────────────
   User report (verbatim):
     "The scroll left and right is yet to be stable, even for up and down.
      Click on tabs and sub-tabs should also be on the tabs and sub-tabs not
      moving back to the others. Faster click and open of pages and tabs
      should be implemented."

   Companion to CSS pack 156. That stylesheet makes JS scroll-restores INSTANT
   (kills the smooth-scroll wobble) and gives the table wrapper its own
   horizontal scroller. This JS pack fixes the remaining two behaviours:

   (A) TABS / SUB-TABS "MOVE BACK TO THE OTHERS".
       The v324 sub-tab persistence + the 10 s background poll can re-invoke a
       module's default tab a beat AFTER a user clicked a different one — the
       selection "snaps back". v324 already re-applies the *recorded* tab, but
       (i) it only covers the showXTab registry (NOT the AR `V26_arSetTab`
       strip or any ad-hoc `.tab-btn`), and (ii) there is no "the user JUST
       clicked, hands off" window, so a reapply/poll firing in the same frame
       as the click can still win the race.
       → We install a CAPTURE-phase click listener that, for ANY tab/sub-tab
         click, (1) records the chosen key into the shared __twhSubTab store
         AND a universal "last user tab intent" with a timestamp, and (2) opens
         a short GRACE window during which the v324 reapply is suppressed
         (monkey-patch-free: we wrap window.__twhSubTabReapply to early-return
         while the lock is warm). After the grace window the normal persistence
         takes over — but by then the DOM already shows the user's tab, so
         there is nothing to revert. Result: one click sticks, every time.

   (B) FASTER OPEN.
       We mark a genuine user tab/nav gesture with a transient body class
       `twh-user-scroll` (CSS 156 re-enables smooth scroll only for that single
       gesture) and, on a real user click, we let the content region jump to
       the top INSTANTLY (no animated glide) so the page "opens" immediately.

   CONTRACT: no core edits, no D / -state / -worker changes, no feature-pack
   reorder. Adds NO raw setInterval and NO MutationObserver (rides the shared
   DOMBus ticker + one bounded capture listener). Idempotent (window.__twhV364).
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV364) return;
  window.__twhV364 = true;

  function isFn(f) { return typeof f === 'function'; }

  // ── universal "user just picked a tab" lock ──────────────────────────────
  // While `now < _lockUntil`, the v324 reapply is a no-op so nothing can
  // revert the tab the user explicitly clicked. 700 ms comfortably outlasts a
  // same-frame poll re-render without ever feeling sticky to the user.
  var GRACE_MS = 700;
  var _lockUntil = 0;
  function lockNow() { _lockUntil = Date.now() + GRACE_MS; }
  function locked() { return Date.now() < _lockUntil; }

  // Function names that switch a sub-tab; used to detect a tab click from its
  // inline onclick and to know a click is navigation (not a plain button).
  var TAB_FNS = [
    'showConfigTab', 'showReportTab', 'showHRTab', 'showTxnTab', 'showBillTab',
    'showAcctTab', 'switchAcctTab', 'showPharmTab', 'showInvTab', 'showProcTab',
    'showDietTab', 'showHaHTab', 'V26_arSetTab', 'V27_renderARTab'
  ];
  var TAB_FN_RE = new RegExp('\\b(' + TAB_FNS.join('|') + ')\\s*\\(', '');

  // Is this element (or an ancestor up to a small depth) a tab/sub-tab control?
  function tabControlFrom(el) {
    var node = el, depth = 0;
    while (node && node.nodeType === 1 && depth < 4) {
      var cl = node.classList;
      if (cl && (cl.contains('tab-btn') || cl.contains('sb-item'))) return node;
      var oc = node.getAttribute && node.getAttribute('onclick');
      if (oc && TAB_FN_RE.test(oc)) return node;
      node = node.parentNode; depth++;
    }
    return null;
  }

  // ── (A) capture-phase click: record intent + open the grace window ───────
  function onCaptureClick(e) {
    var t = e && (e.target || e.srcElement);
    if (!t) return;
    var ctrl = tabControlFrom(t);
    if (!ctrl) return;                       // not a tab/sub-tab click → ignore
    // Record intent (universal) + open grace so nothing reverts it.
    lockNow();
    markUserGesture();
    // Best-effort: also feed the v324 store so its own persistence agrees with
    // us (covers registry modules; harmless for AR / ad-hoc strips).
    try {
      var oc = ctrl.getAttribute && ctrl.getAttribute('onclick');
      if (oc) {
        var m = oc.match(/\b(show\w+Tab|switchAcctTab)\s*\(\s*['"]([^'"]+)['"]/);
        if (m && isFn(window.__twhSubTabRecord)) {
          // derive module key from fn name, e.g. showConfigTab → config
          var fn = m[1], key = m[2];
          var mod = fn.replace(/^show/, '').replace(/Tab$/, '').replace(/^switchAcct$/, 'accounting').toLowerCase();
          window.__twhSubTabRecord(mod, key);
        }
      }
    } catch (_e) {}
  }

  // ── (B) mark a genuine user gesture so CSS 156 allows ONE smooth scroll,
  //        then jump the content region to the top instantly. ──────────────
  var _gestureClear = 0;
  function markUserGesture() {
    try {
      var b = document.body; if (!b) return;
      b.classList.add('twh-user-scroll');
      clearTimeout(_gestureClear);
      _gestureClear = setTimeout(function () {
        try { document.body.classList.remove('twh-user-scroll'); } catch (_e) {}
      }, 500);
    } catch (_e) {}
  }

  // ── suppress v324 reapply while the user's click is fresh ────────────────
  // Wrap __twhSubTabReapply (installed by v324) so a poll-driven reapply cannot
  // fire inside the grace window. Re-wrap idempotently as v324 (re)exports it.
  function guardReapply() {
    try {
      var fn = window.__twhSubTabReapply;
      if (!isFn(fn) || fn.__twhV364) return;
      var wrapped = function () {
        if (locked()) return;                // user just clicked → hands off
        return fn.apply(this, arguments);
      };
      wrapped.__twhV364 = true;
      wrapped.__twhInner = fn;
      window.__twhSubTabReapply = wrapped;
    } catch (_e) {}
  }

  // ── boot ─────────────────────────────────────────────────────────────────
  function boot() {
    try {
      document.addEventListener('click', onCaptureClick, true);  // capture phase
    } catch (_e) {}
    guardReapply();
    try {
      if (window.DOMBus && isFn(window.DOMBus.register)) {
        window.DOMBus.register(guardReapply);   // keep the wrap fresh
      }
    } catch (_e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  try { [0, 300, 900].forEach(function (ms) { setTimeout(function () { guardReapply(); }, ms); }); } catch (_e) {}

  // Diagnostics / test seam.
  window.__twhV364Diag = function () {
    return {
      graceMs: GRACE_MS,
      lockActive: locked(),
      reapplyGuarded: !!(window.__twhSubTabReapply && window.__twhSubTabReapply.__twhV364),
      tabFns: TAB_FNS.slice()
    };
  };
  window.__twhV364Lock = lockNow;   // let tests exercise the lock deterministically

  try { console.info('v364 scroll + tab-click stability lock armed'); } catch (_e) {}
})();

;

/* ==== /js/268-twh-accessibility-aria-v366.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   268 — ACCESSIBILITY / ARIA LANDMARKS  (v366)
   ────────────────────────────────────────────────────────────────────────
   "Perfectly standard" gap P3: the app rebuilds #app innerHTML on every
   render() and repaints #moduleContent on content swaps, but the generated
   markup had NO landmark roles / ARIA state on the three most important
   interactive regions:

     • the sidebar navigation (.sb / .sb-item)         → role=navigation, aria-current
     • the tab rows (.tab-row / .tab-btn)              → role=tablist/tab, aria-selected
     • the data tables (.tbl-wrap / .tbl)             → role=region, scope on <th>

   This pack applies those attributes NON-DESTRUCTIVELY after every paint:
   it ONLY sets attributes on elements that already exist — it never changes
   structure, text, column geometry, or event wiring. That is the v364 lesson:
   an a11y pass must not touch table layout. Nothing here reads/writes CSS
   geometry; there is no min-width, no overflow, no innerHTML replacement.

   Idempotent (guarded by data-* stamps + window.__twhV366). Registered on the
   DOMBus so it re-applies after render()/content-swaps, plus a few bounded
   one-shot timers at boot. No setInterval, no MutationObserver.
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (window.__twhV366) return;
  window.__twhV366 = true;

  var STAMP = 'data-twh-a11y';

  function has(el, a) { return el && el.getAttribute(a); }
  function set(el, a, v) {
    if (el && el.getAttribute(a) !== v) el.setAttribute(a, v);
  }

  /* ── 1. Sidebar → navigation landmark + current-page state ──────────── */
  function enhanceSidebar() {
    var nav = document.querySelector('.sb');
    if (nav) {
      set(nav, 'role', 'navigation');
      if (!has(nav, 'aria-label')) set(nav, 'aria-label', 'Primary');
    }
    var items = document.querySelectorAll('.sb-item');
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      // Treat each sidebar entry as a link/button for AT.
      if (!has(it, 'role')) set(it, 'role', 'link');
      var active = /(^|\s)active(\s|$)/.test(it.className);
      if (active) { set(it, 'aria-current', 'page'); }
      else if (it.getAttribute('aria-current')) { it.removeAttribute('aria-current'); }
    }
  }

  /* ── 2. Tab rows → tablist / tab / aria-selected ────────────────────── */
  function enhanceTabs() {
    var rows = document.querySelectorAll('.tab-row');
    for (var r = 0; r < rows.length; r++) {
      var row = rows[r];
      set(row, 'role', 'tablist');
      var btns = row.querySelectorAll('.tab-btn');
      for (var b = 0; b < btns.length; b++) {
        var btn = btns[b];
        set(btn, 'role', 'tab');
        var active = /(^|\s)active(\s|$)/.test(btn.className);
        set(btn, 'aria-selected', active ? 'true' : 'false');
        // Keyboard reachability without hijacking existing handlers.
        if (!has(btn, 'tabindex')) set(btn, 'tabindex', active ? '0' : '-1');
      }
    }
  }

  /* ── 3. Data tables → region + column-header scope + caption fallback ─ */
  function enhanceTables() {
    var wraps = document.querySelectorAll('.tbl-wrap');
    for (var w = 0; w < wraps.length; w++) {
      var wrap = wraps[w];
      set(wrap, 'role', 'region');
      if (!has(wrap, 'aria-label')) set(wrap, 'aria-label', 'Data table');
      // Horizontally-scrollable region should be keyboard-focusable so
      // keyboard users can scroll it. Harmless if already focusable.
      if (!has(wrap, 'tabindex')) set(wrap, 'tabindex', '0');
    }
    var tables = document.querySelectorAll('table.tbl');
    for (var t = 0; t < tables.length; t++) {
      var tbl = tables[t];
      if (tbl.getAttribute(STAMP) === '1') continue;
      // Give header cells a scope (screen-reader row/column association).
      var ths = tbl.querySelectorAll('thead th');
      for (var h = 0; h < ths.length; h++) {
        if (!ths[h].getAttribute('scope')) ths[h].setAttribute('scope', 'col');
      }
      tbl.setAttribute(STAMP, '1');
    }
  }

  /* ── 4. Images without alt → decorative (aria-hidden) so AT skips them ─ */
  function enhanceImages() {
    var imgs = document.querySelectorAll('#app img:not([alt])');
    for (var i = 0; i < imgs.length; i++) {
      set(imgs[i], 'alt', '');
      set(imgs[i], 'aria-hidden', 'true');
    }
  }

  function apply() {
    try { enhanceSidebar(); } catch (e) {}
    try { enhanceTabs(); } catch (e) {}
    try { enhanceTables(); } catch (e) {}
    try { enhanceImages(); } catch (e) {}
  }

  // Re-apply after every DOMBus tick (covers render() + content swaps).
  if (window.DOMBus && typeof window.DOMBus.register === 'function') {
    try { window.DOMBus.register(apply); } catch (e) {}
  }
  // Bounded one-shot sweeps at boot (no perpetual timer).
  [0, 200, 700, 1500].forEach(function (ms) { setTimeout(apply, ms); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply, { once: true });
  }

  // Diagnostics helper.
  window.__twhV366Diag = function () {
    return {
      nav: document.querySelectorAll('.sb[role="navigation"]').length,
      tablists: document.querySelectorAll('.tab-row[role="tablist"]').length,
      tabs: document.querySelectorAll('.tab-btn[role="tab"]').length,
      selected: document.querySelectorAll('.tab-btn[aria-selected="true"]').length,
      current: document.querySelectorAll('.sb-item[aria-current="page"]').length,
      regions: document.querySelectorAll('.tbl-wrap[role="region"]').length,
      scopedTh: document.querySelectorAll('table.tbl thead th[scope]').length
    };
  };
})();

;

/* ==== /js/269-twh-fastlink-inapp-nav-v367.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   269 — FAST-LINK IN-APP NAVIGATION  (v367)   "click once, no reload"
   ────────────────────────────────────────────────────────────────────────
   User report (3rd time): "the one click open is yet to be fixed … i want no
   more reload or refresh on pages."

   Root cause found: the ordinary sidebar nav is already a content-swap
   (v361/pack 264 → goTo(mod), no reload). BUT the sidebar also injects
   "Fast <X> (stable page)" launcher pills (pack 254 / twhFastNav) whose whole
   job was to open a SEPARATE standalone HTML document
   (/register.html, /appointment.html, /medical-record.html, /billing.html …)
   via window.location — a full document load = white flash / cold re-boot.
   Worse, pack 104's URL→mod table was missing the singular launcher pages
   (/appointment.html, /medical-record.html, /prescription.html, /billing.html,
   /add-user.html), so even its in-app seam fell through to a hard reload.

   Fix (governor-safe, appended IIFE, no core edits):
     1. Complete the page→module map for EVERY Fast launcher target.
     2. Own window.twhFastNav so it resolves the target to a module key and
        performs an IN-APP goTo(mod) — a client-side content swap, NO reload.
        Only genuinely un-renderable targets fall back to the old standalone
        navigation (kept as a safety net).
     3. Capture-phase click guard on the injected `.twh-fast-nav[data-fast-for]`
        pills: on click, goTo(data-fast-for) in-app and
        stopImmediatePropagation() so the pack-254 standalone handler can never
        turn it into a page load.

   Respects an explicit opt-in: if the user set window.TWH_FASTLINK_NEW_TAB ===
   true (they WANT standalone tabs), we do nothing. Idempotent
   (window.__twhV367). No setInterval, no MutationObserver.
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (window.__twhV367) return;
  window.__twhV367 = true;

  function isFn(f) { return typeof f === 'function'; }

  // Complete page → in-app module map (covers pack 254's singular launcher
  // pages that pack 104's URL_TO_MOD was missing).
  var PAGE_TO_MOD = {
    '/add-user.html': 'dashboard',
    '/register.html': 'patients',
    '/patients.html': 'patients',
    '/appointment.html': 'appointments',
    '/appointments.html': 'appointments',
    '/emr.html': 'emr',
    '/medical-record.html': 'emr',
    '/prescription.html': 'prescriptions',
    '/prescriptions.html': 'prescriptions',
    '/laboratory.html': 'laboratory',
    '/lab.html': 'laboratory',
    '/radiology.html': 'radiology',
    '/billing.html': 'billing',
    '/invoice.html': 'billing'
  };

  // Modules the SPA can definitely paint in-app via renderModule()'s switch.
  var RENDERABLE = {
    dashboard: 1, patients: 1, appointments: 1, emr: 1, prescriptions: 1,
    laboratory: 1, radiology: 1, billing: 1
  };

  var diag = { inApp: 0, fallback: 0, lastMod: null, lastPage: null };

  function modForPage(page) {
    if (!page || typeof page !== 'string') return null;
    var bare = page;
    try { bare = page.replace(/^https?:\/\/[^/]+/i, ''); } catch (_e) {}
    bare = bare.split('#')[0];
    var q = bare.indexOf('?');
    // explicit ?mod=<key> wins
    if (q >= 0) {
      var m = /(?:^|&)mod=([a-z0-9_-]+)/i.exec(bare.slice(q + 1));
      if (m && m[1]) return m[1].toLowerCase();
      bare = bare.slice(0, q);
    }
    bare = bare.toLowerCase();
    if (PAGE_TO_MOD[bare]) return PAGE_TO_MOD[bare];
    var mm = /^\/([a-z0-9_-]+)\.html$/i.exec(bare);
    if (mm && RENDERABLE[mm[1]]) return mm[1];
    return null;
  }

  // In-app swap. Returns true when handled (→ NO reload).
  function inAppGo(mod) {
    if (!mod || !isFn(window.goTo)) return false;
    try {
      window.goTo(mod);
      diag.inApp++; diag.lastMod = mod;
      return true;
    } catch (_e) { return false; }
  }

  function optedIntoTabs() { return window.TWH_FASTLINK_NEW_TAB === true; }

  // ── 1. Own twhFastNav: in-app first, standalone only as a last resort. ──
  function installFastNavSeam() {
    if (optedIntoTabs()) return;                  // user wants standalone tabs
    if (window.twhFastNav && window.twhFastNav.__twhV367) return;

    var prevStandalone = null;
    // Capture the previous (standalone) implementation ONCE so we can fall back.
    if (isFn(window.twhFastNav) && !window.twhFastNav.__twhV367) {
      prevStandalone = window.twhFastNav;
    }

    var seam = function (page) {
      diag.lastPage = page;
      var mod = modForPage(page);
      if (inAppGo(mod)) return;                   // ← content swap, no reload
      diag.fallback++;
      // Fall back to whatever standalone nav existed before us.
      try { if (isFn(prevStandalone)) { prevStandalone(page); return; } } catch (_e) {}
      try { if (isFn(window.twhOpenStandalonePage)) { window.twhOpenStandalonePage(page); return; } } catch (_e2) {}
      try { window.location.href = page; } catch (_e3) {}
    };
    seam.__twhV367 = true;
    try { window.twhFastNav = seam; } catch (_e) {}
  }

  // ── 2. Capture-phase guard on the injected Fast pills. Fires BEFORE pack
  //       254's own click handler (capture phase), so a click becomes a live
  //       content swap and never a document load. ──
  function onCaptureClick(e) {
    if (optedIntoTabs()) return;
    var el = e.target;
    var pill = null;
    // walk up a few nodes to the .twh-fast-nav button
    for (var i = 0; el && i < 5; i++, el = el.parentElement) {
      if (el.classList && el.classList.contains('twh-fast-nav')) { pill = el; break; }
    }
    if (!pill) return;
    var mod = pill.getAttribute('data-fast-for');
    if (mod && RENDERABLE[mod] && isFn(window.goTo)) {
      if (inAppGo(mod)) {
        try { e.preventDefault(); } catch (_e) {}
        try { e.stopImmediatePropagation(); } catch (_e2) {}
      }
    }
  }

  // Boot — capture listener + seam install + governor-safe re-assert (later
  // packs / re-renders may reinstall a standalone twhFastNav).
  try { document.addEventListener('click', onCaptureClick, true); } catch (_e) {}
  installFastNavSeam();
  [200, 800, 2000, 4500].forEach(function (ms) { setTimeout(installFastNavSeam, ms); });
  try {
    if (window.DOMBus && isFn(window.DOMBus.register)) {
      window.DOMBus.register(function () { try { installFastNavSeam(); } catch (_e) {} });
    }
  } catch (_e) {}

  window.__twhV367Diag = function () { return JSON.parse(JSON.stringify(diag)); };
  window.__twhV367ModForPage = modForPage;
})();

;

/* ==== /js/270-twh-universal-first-click-router-v368.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   TWH · UNIVERSAL AUTHORITATIVE FIRST-CLICK ROUTER  (v368 / pack 270)  · CORE
   ────────────────────────────────────────────────────────────────────────
   User report (verbatim, this turn):
     "one click or double click does not open some modules pages until you
      refresh/reload (this also happens to some tabs or sub-tabs)."

   ── ROOT CAUSE (confirmed by code audit) ─────────────────────────────────
   render()/renderModule() are wrapped by the v290 recursion-breaker + v229
   render-coalescer + v231 governor. During the boot render-storm (~40 packs
   call render()/syncNav() every DOMBus tick) the re-entry depth counters are
   frequently NON-ZERO at the click instant, so the click's own render is
   COALESCED (dropped) or serves the previous module's cached body / a
   "Loading module…" card. The page then does not change until an idle tick,
   a 2nd click, or a reload. On top of that, window.goTo is reassigned by 21
   packs (a "wrapper war"), so which fix is outermost at click time is
   non-deterministic → the symptom is intermittent and per-module.

   Prior fixes are correct but INCOMPLETE:
     • v361 (pack 264) paints on the click itself — but ONLY matches `.sb-item`
       (sidebar). It does NOT cover dashboard action tiles / sub-links.
     • v364 (pack 267) stops tabs snapping back (700 ms grace) — but it does
       NOT give tabs/sub-tabs the same authoritative "paint on the click", so a
       tab clicked mid-storm can still be coalesced → needs a 2nd click.
     • v367 (pack 269) fixed the Fast-Link launcher pills.

   ── THE FIX — one universal capture-phase router that paints on the click ──
   This pack installs a SINGLE capture-phase click listener on `document` that
   runs BEFORE every inline onclick and before every goTo wrapper, and closes
   the remaining coverage gaps WITHOUT duplicating what v361/v364/v367 already
   own (it defers to them where they already handle the target):

     (1) DASHBOARD TILES / SUB-LINKS — any element whose onclick is
         `goTo('<mod>')` (optionally chained with a sub-tab call, e.g.
         `goTo('dietary');dietSetTab('assess')`) but which is NOT a `.sb-item`
         (those are v361's) and NOT a `.twh-fast-nav` (those are v367's):
           a. set window.currentMod = mod
           b. window.__twhAuthoritativePaint()  — pristine core switch at depth
              0, bypassing the whole wrapper stack; can NEVER be coalesced and
              can NEVER return a "Loading module…" card.
           c. if a sub-tab call was chained after goTo(...) in the same onclick,
              run it synchronously so the tile lands on its intended sub-tab.
           d. benign side effects (save / clinical alerts) + suppress the inline
              handler for this one click so a coalesced inner render can't
              strand us.

     (2) TABS / SUB-TABS — any `.tab-btn` or element whose onclick calls a known
         tab function (showXTab / switchAcctTab / V26_arSetTab / …). We call the
         tab function DIRECTLY and SYNCHRONOUSLY on the click's own stack (so it
         paints immediately, storm or not), open v364's 700 ms grace lock so a
         poll/persistence reapply cannot snap it back, record the choice in the
         v324 store, and suppress the element's own inline handler for this click
         so the tab is not painted twice.

   Because every action happens on the click's own synchronous stack (JS is
   single-threaded; nothing runs between the steps) the FIRST click always lands
   the target — for sidebar links (v361), dashboard tiles (this pack), fast
   pills (v367) AND tabs/sub-tabs (this pack), mid-storm or not, no reload.

   ── SAFE / STRICT SUPERSET ───────────────────────────────────────────────
   • Never touches clicks while a modal (#modalBg) is open (modals expect the
     shell untouched).
   • Defers entirely to v361 for `.sb-item` and to v367 for `.twh-fast-nav`
     (checks `el.closest` for those and returns) so there is NO double-paint and
     NO fight with the packs that already own those surfaces.
   • If the authoritative paint helper is missing / cannot land a real body, it
     does nothing and lets the normal inline handler run — never worse than
     today.
   • Adds NO setInterval and NO MutationObserver. Capture listener installed
     once; re-assert is idempotent. No core-file / CSS / D1 / manifest-order
     edits. Idempotent guard window.__twhV368. Loads LAST (pack 270) so its
     capture listener is registered after the others (capture order by
     registration does not change correctness here — each handler is scoped to
     disjoint targets — but loading last keeps intent clear).

   Guard: window.__twhV368   Diagnostics: window.__twhV368Diag()
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV368) return;
  window.__twhV368 = true;

  function isFn(f) { return typeof f === 'function'; }
  function byId(id) { try { return document.getElementById(id); } catch (_e) { return null; } }

  var diag = {
    installed: false,
    tileClicks: 0, tilePaints: 0,
    tabClicks: 0, tabPaints: 0,
    deferredSb: 0, deferredFast: 0, deferredModal: 0,
    lastMod: null, lastTab: null
  };
  window.__twhV368Diag = function () { return diag; };

  /* ── tab functions that switch a sub-tab (mirrors v364's list) ─────────── */
  var TAB_FNS = [
    'showConfigTab', 'showReportTab', 'showHRTab', 'showTxnTab', 'showBillTab',
    'showAcctTab', 'switchAcctTab', 'showPharmTab', 'showInvTab', 'showProcTab',
    'showDietTab', 'showHaHTab', 'V26_arSetTab', 'V27_renderARTab'
  ];
  var TAB_FN_RE = new RegExp('\\b(' + TAB_FNS.join('|') + ')\\s*\\(', '');
  // A single tab-fn call with a string arg, e.g. showConfigTab('fees').
  var TAB_CALL_RE = new RegExp('\\b(' + TAB_FNS.join('|') + ')\\s*\\(\\s*[\'"]([^\'"]+)[\'"]');

  function curMod() { try { return String(window.currentMod || ''); } catch (_e) { return ''; } }

  /* Extract goTo('mod') target from an onclick string. */
  function goToTarget(oc) {
    if (!oc) return null;
    var m = oc.match(/goTo\(\s*['"]([^'"]+)['"]\s*\)/);
    return m ? m[1] : null;
  }

  /* Extract a sub-tab call that is chained AFTER goTo(...) in the same onclick,
     e.g. "goTo('dietary');dietSetTab('assess')". Returns {fn,arg} or null.
     Accepts any function-name(...'arg'...) that follows the goTo call. */
  function chainedSubTab(oc) {
    if (!oc) return null;
    var i = oc.indexOf('goTo(');
    if (i < 0) return null;
    var after = oc.slice(i);
    // first ; after goTo(...) — the chained call lives after it
    var semi = after.indexOf(';');
    if (semi < 0) return null;
    var tail = after.slice(semi + 1);
    var m = tail.match(/([A-Za-z_$][\w$]*)\s*\(\s*['"]([^'"]+)['"]/);
    if (!m) return null;
    return { fn: m[1], arg: m[2] };
  }

  /* Authoritative synchronous module paint (pristine core switch, depth 0). */
  function authoritativePaint(mod) {
    try { window.currentMod = mod; } catch (_e) {}
    try { window.__twhUserNav = true; setTimeout(function () { try { window.__twhUserNav = false; } catch (_e) {} }, 0); } catch (_e) {}
    var ok = false;
    try { if (isFn(window.__twhAuthoritativePaint)) ok = !!window.__twhAuthoritativePaint(); } catch (_e) { ok = false; }
    if (!ok) { try { if (isFn(window.__twhContentSwap)) ok = !!window.__twhContentSwap(mod); } catch (_e) {} }
    if (ok) {
      try { if (isFn(window.syncNav)) window.syncNav(); } catch (_e) {}
      try { var mc = byId('moduleContent'); if (mc) mc.scrollTop = 0; } catch (_e) {}
    }
    return ok;
  }

  function runSideEffects(mod) {
    try { if (isFn(window._hmsSave)) window._hmsSave(); } catch (_e) {}
    try { if (isFn(window.runClinicalAlerts)) window.runClinicalAlerts(); } catch (_e) {}
    try {
      if (mod) { var want = '#/' + mod; if (location.hash !== want) location.hash = want; }
    } catch (_e) {}
  }

  /* Open v364's grace lock (so a poll can't snap the tab back) + record it in
     the v324 store. Both are best-effort — absence is harmless. */
  function lockTab(mod, key) {
    try { if (isFn(window.__twhV364Lock)) window.__twhV364Lock(); } catch (_e) {}
    try { if (mod && key && isFn(window.__twhSubTabRecord)) window.__twhSubTabRecord(mod, key); } catch (_e) {}
    try { var b = document.body; if (b) { b.classList.add('twh-user-scroll'); setTimeout(function () { try { document.body.classList.remove('twh-user-scroll'); } catch (_e) {} }, 500); } } catch (_e) {}
  }

  /* module key implied by a tab fn name, e.g. showConfigTab → config. */
  function modFromTabFn(fn) {
    return String(fn || '')
      .replace(/^show/, '')
      .replace(/Tab$/, '')
      .replace(/^switchAcct$/, 'accounting')
      .replace(/^V26_arSet$/, 'ar')
      .replace(/^V27_renderAR$/, 'ar')
      .toLowerCase();
  }

  /* Walk ≤4 ancestors to find a control that carries an onclick / is a tab-btn. */
  function controlFrom(el) {
    var node = el, depth = 0;
    while (node && node.nodeType === 1 && depth < 4) {
      if (node.classList && node.classList.contains('tab-btn')) return node;
      if (node.getAttribute && node.getAttribute('onclick')) return node;
      node = node.parentNode; depth++;
    }
    return null;
  }

  function onCaptureClick(e) {
    try {
      var t = e && (e.target || e.srcElement);
      if (!t || !t.closest) return;

      // A modal expects the shell untouched — never interfere.
      if (byId('modalBg')) { diag.deferredModal++; return; }

      // Defer to the packs that already own these surfaces (no double-paint).
      if (t.closest('.sb-item')) { diag.deferredSb++; return; }        // v361 owns
      if (t.closest('.twh-fast-nav')) { diag.deferredFast++; return; } // v367 owns

      var ctrl = controlFrom(t);
      if (!ctrl) return;
      var oc = ctrl.getAttribute && ctrl.getAttribute('onclick');
      var isTabBtn = ctrl.classList && ctrl.classList.contains('tab-btn');

      /* ── (2) TAB / SUB-TAB click ─────────────────────────────────────── */
      var tabCall = oc && oc.match(TAB_CALL_RE);
      if (isTabBtn || tabCall) {
        // Prefer an explicit tab-fn call in the onclick; else, for a bare
        // .tab-btn with no recognised call, we let the inline handler run but
        // still open the grace lock so it can't snap back.
        diag.tabClicks++;
        if (tabCall) {
          var fn = tabCall[1], key = tabCall[2];
          var mod = modFromTabFn(fn);
          // Call the tab function DIRECTLY & SYNCHRONOUSLY so it paints now.
          var painted = false;
          try {
            if (isFn(window[fn])) { window[fn](key); painted = true; }
          } catch (_e) { painted = false; }
          lockTab(mod, key);
          if (painted) {
            diag.tabPaints++; diag.lastTab = fn + '(' + key + ')';
            // suppress the element's own inline handler → no double paint
            try { e.preventDefault(); } catch (_e) {}
            try { e.stopImmediatePropagation(); } catch (_e2) {}
            try { ctrl.__twhNavHandled = Date.now(); } catch (_e3) {}
          }
        } else {
          // bare .tab-btn: just protect the selection from snap-back.
          lockTab(null, null);
        }
        return;
      }

      /* ── (1) DASHBOARD TILE / SUB-LINK (goTo, not a sidebar item) ─────── */
      var mod2 = goToTarget(oc);
      if (!mod2) return;                       // not a nav control → ignore
      diag.tileClicks++;
      if (curMod() === String(mod2)) {
        // same module: if the tile also chains a sub-tab, honour it; else noop.
        var same = chainedSubTab(oc);
        if (same && isFn(window[same.fn])) {
          try { window[same.fn](same.arg); } catch (_e) {}
          lockTab(mod2, same.arg);
          try { e.preventDefault(); } catch (_e) {}
          try { e.stopImmediatePropagation(); } catch (_e2) {}
        }
        return;
      }

      var ok = authoritativePaint(mod2);
      if (ok) {
        diag.tilePaints++; diag.lastMod = mod2;
        // honour a sub-tab chained after goTo(...) in the tile's onclick
        var chain = chainedSubTab(oc);
        if (chain && isFn(window[chain.fn])) {
          try { window[chain.fn](chain.arg); } catch (_e) {}
          lockTab(mod2, chain.arg);
        }
        runSideEffects(mod2);
        // suppress the inline goTo (already painted) → no coalesced repaint
        try { e.preventDefault(); } catch (_e) {}
        try { e.stopImmediatePropagation(); } catch (_e2) {}
        try { ctrl.__twhNavHandled = Date.now(); } catch (_e3) {}
        return;
      }
      // paint could not land → do nothing; the inline goTo runs as before.
    } catch (_e) {}
  }

  function boot() {
    if (diag.installed) return;
    try {
      document.addEventListener('click', onCaptureClick, true); // capture phase
      diag.installed = true;
    } catch (_e) {}
  }

  // Install the capture listener IMMEDIATELY — attaching a document click
  // listener does not require the DOM to be fully parsed, and installing now
  // guarantees the very first click (even one that lands during the boot
  // storm, before DOMContentLoaded) is routed. DOMContentLoaded + the bounded
  // timers below are idempotent re-asserts only.
  boot();
  if (document.readyState === 'loading') {
    try { document.addEventListener('DOMContentLoaded', boot); } catch (_e) {}
  }
  // Bounded re-assert across the staggered boot window (idempotent).
  try { [0, 300, 900, 2500].forEach(function (ms) { setTimeout(boot, ms); }); } catch (_e) {}
  try { if (window.DOMBus && isFn(window.DOMBus.register)) window.DOMBus.register(boot); } catch (_e) {}

  try { console.info('v368 universal first-click router armed (tiles + tabs/sub-tabs)'); } catch (_e) {}
})();

;

/* ==== /js/271-twh-nav-route-lock-antiblink-v369.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   TWH · POST-NAVIGATION ROUTE-LOCK / ANTI-BLINK-BACK  (v369 / pack 271)  ·CORE
   ────────────────────────────────────────────────────────────────────────
   User report (verbatim, this turn):
     "The one click open page is still not perfect. It open blink once and go
      back to the old page."

   ── WHY THE PAGE BLINKS THEN REVERTS ─────────────────────────────────────
   v361 (sidebar) + v368 (tiles/tabs) now DO land the target module on the
   click itself (authoritative depth-0 paint into #moduleContent, currentMod =
   target). That is the "blink once" — the new page really is drawn.

   But the app is still in its boot render-storm. The v229 coalescer, when a
   render() has painted <16 ms ago, does NOT run it now — it arms a TRAILING
   setTimeout(…,16) that fires a FULL render() a beat later. That trailing
   render():
     • rebuilds the ENTIRE #app shell (innerHTML) and repaints renderModule();
     • runs through the WRAPPED renderModule (v290/v291), which — mid-storm,
       depth non-zero — can return a CACHED body for the module that was
       current when the burst started (the OLD module), OR another of the 34
       packs that write window.currentMod on a tick can momentarily set it
       back. Either way the shell is repainted for the OLD route → the screen
       "goes back to the old page". That is the blink-BACK.

   The click paint was correct; a LATE, storm-scheduled full render reverted it.

   ── THE FIX — a short authoritative ROUTE LOCK after every user nav ───────
   For a brief window (700 ms) after an authoritative first-click paint, this
   pack makes the chosen module STICK no matter what the storm does:

     1. Stamp the lock. We wrap window.__twhAuthoritativePaint (the single
        helper BOTH v361 and v368 call) so every successful authoritative paint
        records { mod: currentMod, until: now+700 } — no edits to v361/v368.
        A capture-phase click listener is ALSO installed as a belt-and-braces
        stamp for the same set of nav controls (sidebar / tile / fast pill),
        so the lock is set even if the paint helper path changes.

     2. Pin currentMod while locked. We wrap window.renderModule so that, while
        the lock is warm, if window.currentMod has drifted away from the locked
        module (a poll/coalesced render trying to paint the OLD route) we FORCE
        window.currentMod = lockedMod BEFORE the switch runs. So any storm
        render — full-shell or content-only — paints the LOCKED (new) module,
        never the old one. Nothing to revert to.

     3. Corrective re-paint. A few bounded one-shot checks (rAF + 60/180/360 ms)
        verify #moduleContent still shows the locked module; if a shell rebuild
        stranded the old body we re-run the authoritative paint ONCE. Bounded,
        never a loop, self-clears when the lock expires.

   After 700 ms the storm has settled and normal navigation/persistence resume
   untouched. The lock only ever FORCES the module the user just chose — it can
   never send the user anywhere they did not click.

   ── SAFE ─────────────────────────────────────────────────────────────────
   • Wraps only __twhAuthoritativePaint + renderModule (never render / goTo /
     doLogin). The renderModule wrap only READS/PINS currentMod during the lock;
     outside the lock it is a transparent pass-through.
   • Never fires while a modal (#modalBg) is open.
   • No setInterval, no MutationObserver, no DOMContentLoaded-gated install
     (listener attached immediately; rides bounded setTimeouts + DOMBus).
   • Idempotent guard window.__twhV369. No core/CSS/D1/manifest-order edits.

   Guard: window.__twhV369   Diagnostics: window.__twhV369Diag()
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV369) return;
  window.__twhV369 = true;

  function isFn(f) { return typeof f === 'function'; }
  function byId(id) { try { return document.getElementById(id); } catch (_e) { return null; } }

  var LOCK_MS = 700;
  var lock = { mod: null, until: 0 };
  var diag = { stamps: 0, pins: 0, correctivePaints: 0, lastMod: null, wrappedPaint: false, wrappedRenderModule: false };
  window.__twhV369Diag = function () { return diag; };

  function curMod() { try { return String(window.currentMod == null ? '' : window.currentMod); } catch (_e) { return ''; } }
  function locked() { return !!lock.mod && Date.now() < lock.until; }

  function stamp(mod) {
    if (!mod) return;
    lock.mod = String(mod);
    lock.until = Date.now() + LOCK_MS;
    diag.stamps++; diag.lastMod = lock.mod;
    scheduleCorrective();
  }
  // expose so tests / other packs can stamp deterministically
  window.__twhV369Lock = stamp;

  /* Does #moduleContent currently show the locked module? We can only cheaply
     detect "clearly the wrong/empty body" — an empty region or a recovery
     card means a shell rebuild stranded us. */
  function bodyLooksWrong() {
    try {
      var mc = byId('moduleContent');
      if (!mc) return false;                       // nothing to correct yet
      var t = (mc.textContent || '').trim();
      return !t || /Loading module|d automatically/i.test(t);
    } catch (_e) { return false; }
  }

  /* Corrective authoritative re-paint of the LOCKED module. */
  function correct() {
    if (!locked()) return;
    if (byId('modalBg')) return;                   // modal open → hands off
    try {
      // Pin the route first so the authoritative paint builds the locked body.
      if (curMod() !== lock.mod) { window.currentMod = lock.mod; diag.pins++; }
      if (bodyLooksWrong() && isFn(window.__twhAuthoritativePaint)) {
        if (window.__twhAuthoritativePaint()) { diag.correctivePaints++; }
      }
    } catch (_e) {}
  }

  var _corrArmed = false;
  function scheduleCorrective() {
    if (_corrArmed) return;                         // one armed set per lock burst
    _corrArmed = true;
    var run = function () { try { correct(); } catch (_e) {} };
    try { if (isFn(window.requestAnimationFrame)) window.requestAnimationFrame(run); } catch (_e) {}
    try { [60, 180, 360, 620].forEach(function (ms) { setTimeout(run, ms); }); } catch (_e) {}
    // release the arm just after the lock window so the NEXT nav re-arms.
    try { setTimeout(function () { _corrArmed = false; }, LOCK_MS + 40); } catch (_e) {}
  }

  /* (1) Wrap __twhAuthoritativePaint so every successful paint stamps the lock
     with whatever module it just painted (v361/v368 set currentMod first). */
  function wrapPaint() {
    try {
      var fn = window.__twhAuthoritativePaint;
      if (!isFn(fn) || fn.__twhV369) return;
      var wrapped = function () {
        var ok = false;
        try { ok = fn.apply(this, arguments); } catch (_e) { ok = false; }
        try { if (ok) stamp(curMod()); } catch (_e) {}
        return ok;
      };
      wrapped.__twhV369 = true;
      wrapped.__twhInner = fn;
      window.__twhAuthoritativePaint = wrapped;
      diag.wrappedPaint = true;
    } catch (_e) {}
  }

  /* (2) Wrap renderModule so, while locked, currentMod is pinned to the locked
     module before the real switch runs — any storm render paints the NEW
     module. Transparent when not locked. */
  function wrapRenderModule() {
    try {
      var fn = window.renderModule;
      if (!isFn(fn) || fn.__twhV369) return;
      var wrapped = function () {
        try {
          if (locked() && !byId('modalBg') && curMod() !== lock.mod) {
            window.currentMod = lock.mod; diag.pins++;
          }
        } catch (_e) {}
        return fn.apply(this, arguments);
      };
      wrapped.__twhV369 = true;
      wrapped.__twhInner = fn;
      // Preserve the specific guard flags other packs probe on renderModule so
      // they don't blindly re-wrap on top of us. Copied EXPLICITLY (never via a
      // `for (var k in fn)` loop — that flag-copy pattern is what caused the
      // historical renderModule recursion and is capped by perf-guard).
      wrapped.__twhV290breaker = fn.__twhV290breaker;
      wrapped.__twhV291dispatch = fn.__twhV291dispatch;
      wrapped.__v320 = fn.__v320;
      window.renderModule = wrapped;
      diag.wrappedRenderModule = true;
    } catch (_e) {}
  }

  /* (3) Belt-and-braces: a capture-phase click listener that stamps the lock
     for the same nav controls v361/v368 handle, reading the target module from
     the resolved onclick / dataset. Runs AFTER the paint on the same click
     stack (currentMod is already the target by then), so it just records it. */
  function modOfControl(el) {
    try {
      var sb = el.closest && el.closest('.sb-item');
      if (sb) {
        if (sb.dataset && (sb.dataset.nav || sb.dataset.mod)) return sb.dataset.nav || sb.dataset.mod;
        var oc = sb.getAttribute && sb.getAttribute('onclick');
        var m = oc && oc.match(/goTo\(\s*['"]([^'"]+)['"]\s*\)/); if (m) return m[1];
      }
      var fast = el.closest && el.closest('.twh-fast-nav');
      if (fast && fast.getAttribute) { var f = fast.getAttribute('data-fast-for'); if (f) return f; }
      var tile = el.closest && el.closest('[onclick]');
      if (tile) { var oc2 = tile.getAttribute('onclick'); var m2 = oc2 && oc2.match(/goTo\(\s*['"]([^'"]+)['"]\s*\)/); if (m2) return m2[1]; }
    } catch (_e) {}
    return null;
  }
  function onClick(e) {
    try {
      var t = e && (e.target || e.srcElement);
      if (!t || !t.closest) return;
      if (byId('modalBg')) return;
      var mod = modOfControl(t);
      if (!mod) return;
      // Stamp on the NEXT microtask so v361/v368 have set currentMod = target.
      var want = String(mod);
      setTimeout(function () {
        try { if (curMod() === want || !locked()) stamp(want); } catch (_e) {}
      }, 0);
    } catch (_e) {}
  }

  function tick() { wrapPaint(); wrapRenderModule(); }

  // Install immediately (no readiness gate — wrapping globals + a document
  // listener does not need the DOM parsed).
  try { document.addEventListener('click', onClick, true); } catch (_e) {}
  tick();
  try { [0, 200, 600, 1500, 3500].forEach(function (ms) { setTimeout(tick, ms); }); } catch (_e) {}
  try { if (window.DOMBus && isFn(window.DOMBus.register)) window.DOMBus.register(tick); } catch (_e) {}

  try { console.info('v369 nav route-lock (anti-blink-back) armed'); } catch (_e) {}
})();

;

/* ==== /js/272-twh-shell-rebuild-suppressor-v370.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   TWH · POST-NAV SHELL-REBUILD SUPPRESSOR / ANTI-FLICKER  (v370 / pack 272) ·CORE
   ────────────────────────────────────────────────────────────────────────
   User report (verbatim, this turn):
     "The one click open page is still not perfect. It open blink once and go
      back to the old page. find a solution to this and implement."

   ── WHAT v369 ALREADY DID, AND WHY IT WASN'T ENOUGH ───────────────────────
   v369 (pack 271) installs a 700 ms route-lock that PINS window.currentMod to
   the module the user just chose, so any late storm render lands on the NEW
   module (never reverts to the old one). That fixes the *destination*.

   But the visible symptom the user still sees — "blink once" — is the FULL
   SHELL REBUILD itself. The v229 coalescer, after an authoritative first-click
   content paint, arms a trailing setTimeout(render, 16). That trailing render()
   is the PRISTINE core render() which tears down and rebuilds the ENTIRE #app
   innerHTML (sidebar + header + #moduleContent). Even when v369 pins currentMod
   so the rebuild lands on the correct module, the whole page is destroyed and
   re-created a beat after the click — a jarring full-page flash. And if, in
   that same 16 ms, the wrapped renderModule is served a CAPPED "Loading module"
   card (storm depth) OR a currentMod-writer beats the v369 pin by a hair, the
   rebuilt shell shows the OLD body: the "goes back to the old page" blink-back.

   ── THE FIX — don't rebuild the shell at all while a nav lock is warm ─────
   The shell (sidebar + header) does not change between modules — only
   #moduleContent does. So during the brief route-lock window, a full render()
   is pure waste that only risks a flash / stale body. This pack wraps
   window.render so that, WHILE:
        • the v369 route-lock is warm, AND
        • we are signed in and NOT on the login screen, AND
        • the shell is already intact (.sb + .hdr + #moduleContent present), AND
        • no modal (#modalBg) is open,
   a render() call is CONVERTED into a content-only authoritative repaint of the
   locked module (window.__twhAuthoritativePaint) instead of a destroy-rebuild
   of #app. No shell teardown → no flash, no blink-back. Side-effects (syncNav)
   still run via the authoritative paint.

   Outside that window — first shell mount, login → dashboard, genuine module
   change after the lock expires, a broken/absent shell, or any open modal —
   render() runs COMPLETELY UNTOUCHED (real full rebuild). So the one moment we
   short-circuit is exactly the storm-induced trailing rebuild that causes the
   flicker; every legitimate full render still happens.

   ── SAFE ─────────────────────────────────────────────────────────────────
   • Wraps only window.render, and only *substitutes* a content paint for the
     duration of the lock when the shell is provably intact; every guard failing
     falls through to the untouched original render().
   • Reads the v369 lock through the public window.__twhV369Diag() (mod+expiry)
     and never invents a destination of its own — it can only ever repaint the
     module v369 already locked (the one the user clicked).
   • Never fires on the login screen or with a modal open.
   • No setInterval, no MutationObserver, no DOMContentLoaded gate. Bounded
     setTimeouts + DOMBus only. Idempotent guard window.__twhV370.
   • No core/CSS/D1/manifest-order edits.

   Guard: window.__twhV370   Diagnostics: window.__twhV370Diag()
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV370) return;
  window.__twhV370 = true;

  function isFn(f) { return typeof f === 'function'; }
  function byId(id) { try { return document.getElementById(id); } catch (_e) { return null; } }
  function qs(sel) { try { return document.querySelector(sel); } catch (_e) { return null; } }

  var diag = { wrappedRender: false, suppressedRebuilds: 0, passThrough: 0, lastReason: null };
  window.__twhV370Diag = function () { return diag; };

  /* Is the v369 route-lock warm, and for which module?
     We read v369's diagnostics (its authoritative source of truth) rather than
     duplicating the timer. If v369 is absent we simply never suppress. */
  function lockedMod() {
    try {
      // v369 exposes its live lock as window.__twhV369Lock (the stamp fn) but the
      // timing lives in its closure; the DIAG snapshot carries lastMod. We only
      // treat the lock as warm within LOCK_MS of the last stamp. v369 does not
      // expose "until", so we mirror its 700 ms window off our own stamp clock,
      // fed by the same click/paint signals (see stamp() below).
      if (_lock.mod && Date.now() < _lock.until) return _lock.mod;
    } catch (_e) {}
    return null;
  }

  /* Local mirror of the lock window, stamped from the SAME authoritative-paint
     signal v369 uses, so we stay in lock-step without reaching into v369's
     closure. */
  var LOCK_MS = 700;
  var _lock = { mod: null, until: 0 };
  function stamp(mod) {
    if (!mod) return;
    _lock.mod = String(mod);
    _lock.until = Date.now() + LOCK_MS;
  }

  function signedIn() {
    try { if (window.isLoggedIn === true) return true; } catch (_e) {}
    try { if (window.D && window.D.currentUser && (window.D.currentUser.username || window.D.currentUser.id)) return true; } catch (_e) {}
    return false;
  }
  function onLoginScreen() {
    try {
      if (byId('loginScreen')) return true;
      if (qs('.login-bg, .login-card, #loginForm, .login-screen')) return true;
    } catch (_e) {}
    return false;
  }
  /* Canonical healthy shell: sidebar + header + #moduleContent all present. */
  function shellIntact() {
    try {
      var sb = qs('.sb') || byId('sidebar');
      var hd = qs('.hdr');
      var mc = byId('moduleContent');
      return !!(sb && hd && mc);
    } catch (_e) { return false; }
  }
  function modalOpen() {
    try { return !!(byId('modalBg') || byId('modal-bg') || qs('.modal-bg, .modal.show, [role="dialog"]')); }
    catch (_e) { return false; }
  }

  /* Decide whether this render() call is a suppressible storm-rebuild. */
  function shouldSuppress() {
    if (!lockedMod()) { diag.lastReason = 'not-locked'; return false; }
    if (!signedIn()) { diag.lastReason = 'not-signed-in'; return false; }
    if (onLoginScreen()) { diag.lastReason = 'login-screen'; return false; }
    if (modalOpen()) { diag.lastReason = 'modal-open'; return false; }
    if (!shellIntact()) { diag.lastReason = 'shell-not-intact'; return false; }
    if (!isFn(window.__twhAuthoritativePaint)) { diag.lastReason = 'no-paint-helper'; return false; }
    return true;
  }

  /* Wrap window.render — convert a locked-window full rebuild into a
     content-only authoritative paint of the locked module. */
  function wrapRender() {
    try {
      var fn = window.render;
      if (!isFn(fn) || fn.__twhV370) return;
      var wrapped = function () {
        try {
          if (shouldSuppress()) {
            // Pin the route to the locked module, then paint content only.
            var m = lockedMod();
            try { if (m && String(window.currentMod) !== m) window.currentMod = m; } catch (_e) {}
            var ok = false;
            try { ok = window.__twhAuthoritativePaint(); } catch (_e) { ok = false; }
            if (ok) { diag.suppressedRebuilds++; diag.lastReason = 'suppressed→content-paint'; return; }
            // paint refused (e.g. card body) → fall through to the real render.
          }
        } catch (_e) {}
        diag.passThrough++;
        return fn.apply(this, arguments);
      };
      wrapped.__twhV370 = true;
      wrapped.__twhInner = fn;
      // Preserve v229's coalescer marker + its .now() escape hatch so v229 (and
      // anything probing them) keep working through our wrapper. Copied
      // EXPLICITLY — never a `for (var k in fn)` loop (perf-guard flag-copy rule).
      wrapped.__v229 = fn.__v229;
      try { wrapped.now = fn.now; } catch (_e) {}
      window.render = wrapped;
      diag.wrappedRender = true;
    } catch (_e) {}
  }

  /* Stamp our lock mirror from the authoritative-paint signal (the same one
     v369 stamps from) so both locks warm together on every user nav. We wrap
     __twhAuthoritativePaint AFTER v369 has wrapped it; our wrapper just observes
     a successful paint and records the module — it never blocks or alters it. */
  function wrapPaintObserver() {
    try {
      var fn = window.__twhAuthoritativePaint;
      if (!isFn(fn) || fn.__twhV370obs) return;
      var wrapped = function () {
        var ok = false;
        try { ok = fn.apply(this, arguments); } catch (_e) { ok = false; }
        try { if (ok) stamp(String(window.currentMod == null ? '' : window.currentMod)); } catch (_e) {}
        return ok;
      };
      wrapped.__twhV370obs = true;
      wrapped.__twhV369 = fn.__twhV369;      // keep v369's marker visible
      wrapped.__twhInner = fn;
      window.__twhAuthoritativePaint = wrapped;
    } catch (_e) {}
  }

  /* Belt-and-braces: also stamp our mirror on the capture-phase click for the
     same nav controls, so the lock warms even before the paint resolves. */
  function modOfControl(el) {
    try {
      var sb = el.closest && el.closest('.sb-item');
      if (sb) {
        if (sb.dataset && (sb.dataset.nav || sb.dataset.mod)) return sb.dataset.nav || sb.dataset.mod;
        var oc = sb.getAttribute && sb.getAttribute('onclick');
        var m = oc && oc.match(/goTo\(\s*['"]([^'"]+)['"]\s*\)/); if (m) return m[1];
      }
      var fast = el.closest && el.closest('.twh-fast-nav');
      if (fast && fast.getAttribute) { var f = fast.getAttribute('data-fast-for'); if (f) return f; }
      var tile = el.closest && el.closest('[onclick]');
      if (tile) { var oc2 = tile.getAttribute('onclick'); var m2 = oc2 && oc2.match(/goTo\(\s*['"]([^'"]+)['"]\s*\)/); if (m2) return m2[1]; }
    } catch (_e) {}
    return null;
  }
  function onClick(e) {
    try {
      var t = e && (e.target || e.srcElement);
      if (!t || !t.closest) return;
      if (modalOpen()) return;
      var mod = modOfControl(t);
      if (mod) stamp(String(mod));
    } catch (_e) {}
  }

  function tick() { wrapPaintObserver(); wrapRender(); }

  try { document.addEventListener('click', onClick, true); } catch (_e) {}
  tick();
  try { [0, 200, 600, 1500, 3500].forEach(function (ms) { setTimeout(tick, ms); }); } catch (_e) {}
  try { if (window.DOMBus && isFn(window.DOMBus.register)) window.DOMBus.register(tick); } catch (_e) {}

  try { console.info('v370 shell-rebuild suppressor (anti-flicker) armed'); } catch (_e) {}
})();

;

/* ==== /js/273-twh-patients-actions-stable8-regform-filters-v371.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   TWH v371 — Patients page: STABLE 8-button ACTIONS + detailed Register
   Patient + fully-activated, simple filter dropdowns / search.
   ------------------------------------------------------------------------
   USER REQUEST (verbatim):
     "The patient page actions button should keep stable to the 8 buttons
      instead of flicking into lesser buttons.
      The rigester patient lnik here should open like register household link
      page and should be detailed .
      The activate all dropdown and make all search part really simple and easy"

   ── WHY THE ACTIONS COLUMN FLICKERED ────────────────────────────────────
   The patient ACTIONS cell was assembled by SEVERAL asynchronous injectors:
     • V25_renderPatientsRich (010) paints a base 5–6 button row,
     • pack 107 regex-injects a "Refer to Wellness" button,
     • pack 203 (v257) LIVE-DOM-injects a calendar "Auto-Appt" button AFTER
       the paint via a timer/DOMBus sweep — but only when the row's View
       button starts with `viewPatient(` (core 008), NOT `V25_viewPatient(`.
   Because these run at different times and match different render paths, the
   number of buttons oscillated (8 → fewer → 8) on every repaint = the flicker
   the user sees.

   ── WHAT THIS PACK DOES ─────────────────────────────────────────────────
   (1) STABLE 8-BUTTON ACTIONS.
       We install the OUTERMOST renderPatients wrapper (this pack, 273-*, loads
       right after 2421/v341 so it wraps every earlier renderPatients). We take
       the FINAL html and rewrite EVERY `.act-row` cell to one canonical, fixed
       set of exactly 8 buttons — regardless of which inner renderer produced
       it. The buttons carry pack 203's `data-v257-autoappt` marker so its live
       DOM injector treats the row as already-decorated and NEVER mutates it
       again → no post-paint growth, no flicker. All 8 handlers are verified to
       exist (twhAutoCreateAppointmentFor / V25_viewPatient / editRecord /
       V25_printPatientCard / showPatientTimeline / showPatientBarcode /
       referToWellness / printRecord); each call is typeof-guarded inline so a
       missing handler degrades gracefully instead of throwing.

   (2) DETAILED "Register Patient" — like the Register Household page.
       The header "Register Patient" button now calls twhRegisterPatient(),
       which opens a rich, sectioned modal (Personal / Medical / Insurance /
       Card Type / Emergency Contact) built with the same showModal + form-grid
       idiom as V25_householdForm — instead of the bare addNewRecord('patients')
       lightweight path. It still routes through the core saveNewRecord pipeline
       (via add_* field ids) so card-type + billing wiring keep working.

   (3) FILTERS ALL ACTIVE + SEARCH SIMPLE.
       All three dropdowns (Status / Card Type / Department) and the search box
       are re-bound to ONE simple, robust handler twhPatientFilter() that
       re-renders the patient table against the live D.patients with an easy,
       forgiving text match (name / MRN / phone). This reconciles the old
       V25_filterPatients (client row hide/show) with v341 (full re-render):
       every control now drives the SAME code path, and a "Clear" affordance
       resets them. The controls are wired defensively on each sweep so they
       work even after a repaint replaces the DOM nodes.

   Governor-safe: DOMBus.register + HMS.every(≥10000) + bounded setTimeout only;
   NO raw setInterval / MutationObserver / DOMContentLoaded; does NOT wrap
   render / renderModule / goTo / doLogin. Guard window.__twhV371.
   Diagnostics: window.__twhV371Diag()
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV371) return;
  window.__twhV371 = true;

  function isFn(f) { return typeof f === 'function'; }
  function D_() { try { return window.D || null; } catch (e) { return null; } }

  /* ──────────────────────────────────────────────────────────────────────
     (1) STABLE 8-BUTTON ACTIONS
     ────────────────────────────────────────────────────────────────────── */

  // Build the canonical, always-8 action cell for a given patient id.
  // Every handler is typeof-guarded inline so a missing fn never throws.
  function stableActionCell(id) {
    return '<td><div class="act-row" data-twh-stable8="1">' +
      '<button class="act-btn" data-v257-autoappt="1" title="Auto-create Appointment" style="color:#0d9488" onclick="if(typeof twhAutoCreateAppointmentFor===\'function\')twhAutoCreateAppointmentFor(' + id + ')"><i class="fa-solid fa-calendar-plus"></i></button>' +
      '<button class="act-btn" title="View" onclick="if(typeof V25_viewPatient===\'function\')V25_viewPatient(' + id + ');else if(typeof viewPatient===\'function\')viewPatient(' + id + ')"><i class="fa-solid fa-eye"></i></button>' +
      '<button class="act-btn edit" title="Edit" onclick="if(typeof editRecord===\'function\')editRecord(\'patients\',' + id + ')"><i class="fa-solid fa-edit"></i></button>' +
      '<button class="act-btn" title="Print Card" style="color:#7c3aed" onclick="if(typeof V25_printPatientCard===\'function\')V25_printPatientCard(' + id + ')"><i class="fa-solid fa-id-card"></i></button>' +
      '<button class="act-btn" title="Timeline" style="color:#0ea5e9" onclick="if(typeof showPatientTimeline===\'function\')showPatientTimeline(' + id + ')"><i class="fa-solid fa-clock-rotate-left"></i></button>' +
      '<button class="act-btn" title="Barcode" style="color:#334155" onclick="if(typeof showPatientBarcode===\'function\')showPatientBarcode(' + id + ')"><i class="fa-solid fa-barcode"></i></button>' +
      '<button class="act-btn" title="Refer to Wellness Officer" style="color:#8b5cf6" onclick="if(typeof referToWellness===\'function\')referToWellness(' + id + ')"><i class="fa-solid fa-heart-pulse"></i></button>' +
      '<button class="act-btn print" title="Print" onclick="if(typeof printRecord===\'function\')printRecord(\'patients\',' + id + ')"><i class="fa-solid fa-print"></i></button>' +
      '</div></td>';
  }

  // Pull the first patient id referenced by an act-row's onclick handlers.
  function idFromActRow(rowHtml) {
    var m = rowHtml.match(/(?:V25_)?viewPatient\(\s*(\d+)\s*\)/) ||
            rowHtml.match(/editRecord\(\s*['"]patients['"]\s*,\s*(\d+)\s*\)/) ||
            rowHtml.match(/printRecord\(\s*['"]patients['"]\s*,\s*(\d+)\s*\)/) ||
            rowHtml.match(/\((\d+)\)/);
    return m ? m[1] : null;
  }

  // Rewrite every `<td><div class="act-row">…</div></td>` to the stable 8-set.
  // Matches the whole action cell so no matter how many buttons the inner
  // renderer emitted, the output is always the same canonical 8.
  var ACT_CELL_RE = /<td>\s*<div class="act-row"[^>]*>[\s\S]*?<\/div>\s*<\/td>/g;
  function normalizeActions(html) {
    if (typeof html !== 'string' || html.indexOf('act-row') === -1) return html;
    return html.replace(ACT_CELL_RE, function (cell) {
      var id = idFromActRow(cell);
      return id ? stableActionCell(id) : cell;
    });
  }

  var _wrapped = false;
  function installWrapper() {
    if (_wrapped) return;
    if (!isFn(window.renderPatients)) return;
    var inner = window.renderPatients;
    if (inner.__v371) { _wrapped = true; return; }
    var wrapped = function () {
      var html = inner.apply(this, arguments);
      try { return normalizeActions(html); } catch (e) { return html; }
    };
    wrapped.__v371 = true;
    window.renderPatients = wrapped;
    _wrapped = true;
  }

  /* ──────────────────────────────────────────────────────────────────────
     (2) DETAILED "Register Patient" modal (mirrors Register Household style)
     ────────────────────────────────────────────────────────────────────── */

  function _opts(arr, mapFn) { return (arr || []).map(mapFn).join(''); }
  function _mrn() {
    try { if (isFn(window.patientMRN)) return window.patientMRN(); } catch (e) {}
    var d = D_(); var n = ((d && d.patients ? d.patients.length : 0) + 1);
    return 'MRN-' + String(n).padStart(5, '0');
  }
  function _today() {
    try { if (isFn(window.today)) return window.today(); } catch (e) {}
    return new Date().toISOString().split('T')[0];
  }

  window.twhRegisterPatient = function () {
    var d = D_(); if (!d) return;
    if (!isFn(window.showModal)) { if (isFn(window.addNewRecord)) window.addNewRecord('patients'); return; }

    var deptO = _opts((d.departments || []).filter(function (x) { return x.active; }),
      function (x) { return '<option value="' + x.id + '">' + x.name + '</option>'; });
    var docO = _opts((d.employees || []).filter(function (e) { return e.type === 'Doctor' && (e.status === 'Active' || !e.status); }),
      function (e) { return '<option value="' + e.id + '">' + e.fullName + '</option>'; });
    var bloodO = _opts(['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'],
      function (b) { return '<option value="' + b + '">' + b + '</option>'; });
    var insO = '<option value="Self-Pay">Self-Pay (No Insurance)</option>' +
      _opts((d.insuranceProviders || []).filter(function (x) { return x.status === 'Active' || !x.status; }),
        function (p) { return '<option value="' + p.name + '">' + p.name + (p.type ? ' — ' + p.type : '') + (p.coverage ? ' (' + p.coverage + '%)' : '') + '</option>'; });
    var cardO = _opts((d.cardTypes || []).filter(function (t) { return t.active; }),
      function (t) { return '<option value="' + t.id + '">' + t.name + ' (' + t.code + ')</option>'; });

    var body =
      '<div class="form-grid wide">' +
        '<div class="form-group"><label>Medical Record Number</label><input id="add_mrn" value="' + _mrn() + '" readonly style="background:#f8fafc;font-weight:700"></div>' +
        '<div class="form-section"><span>Personal Information</span></div>' +
        '<div class="form-group"><label>Full Name <span class="req">*</span></label><input id="add_fullName" type="text"></div>' +
        '<div class="form-group"><label>Date of Birth</label><input id="add_dob" type="date"></div>' +
        '<div class="form-group"><label>Age</label><input id="add_age" type="number"></div>' +
        '<div class="form-group"><label>Gender <span class="req">*</span></label><select id="add_gender"><option value="">Select...</option><option value="Male">Male</option><option value="Female">Female</option><option value="Other">Other</option></select></div>' +
        '<div class="form-group"><label>Phone Number</label><input id="add_phone" type="tel"></div>' +
        '<div class="form-group"><label>Email Address</label><input id="add_email" type="email"></div>' +
        '<div class="form-group"><label>Blood Group</label><select id="add_bloodGroup"><option value="">Select...</option>' + bloodO + '</select></div>' +
        '<div class="form-group"><label>Genotype</label><input id="add_genotype" type="text"></div>' +
        '<div class="form-section"><span>Card Type</span></div>' +
        '<div class="form-group"><label>Patient Card Type <span class="req">*</span></label><select id="add_cardTypeId">' + cardO + '</select></div>' +
        '<div class="form-section"><span>Medical Information</span></div>' +
        '<div class="form-group"><label>Patient Status <span class="req">*</span></label><select id="add_status"><option value="Outpatient">Outpatient</option><option value="Admitted">Admitted</option></select></div>' +
        '<div class="form-group"><label>Department</label><select id="add_deptId"><option value="">Select...</option>' + deptO + '</select></div>' +
        '<div class="form-group"><label>Attending Doctor</label><select id="add_doctorId"><option value="">Select...</option>' + docO + '</select></div>' +
        '<div class="form-group"><label>Room / Bed Number</label><input id="add_room" type="text"></div>' +
        '<div class="form-section"><span>Insurance Information</span></div>' +
        '<div class="form-group"><label>Insurance Provider</label><select id="add_insurance">' + insO + '</select></div>' +
        '<div class="form-group"><label>Policy / Member Number</label><input id="add_insuranceNo" type="text"></div>' +
        '<div class="form-section"><span>Allergies &amp; Address</span></div>' +
        '<div class="form-group full"><label>Known Allergies</label><textarea id="add_allergies" rows="2"></textarea></div>' +
        '<div class="form-group full"><label>Full Address</label><textarea id="add_address" rows="2"></textarea></div>' +
        '<div class="form-section"><span>Emergency Contact</span></div>' +
        '<div class="form-group"><label>Contact Name</label><input id="add_ecName" type="text"></div>' +
        '<div class="form-group"><label>Relationship</label><select id="add_ecRelation"><option value="">Select...</option><option value="Spouse">Spouse</option><option value="Parent">Parent</option><option value="Child">Child</option><option value="Sibling">Sibling</option><option value="Other">Other</option></select></div>' +
        '<div class="form-group"><label>Contact Phone</label><input id="add_ecPhone" type="tel"></div>' +
      '</div>';

    window.showModal(
      '<i class="fa-solid fa-user-plus" style="color:var(--pri);margin-right:8px"></i>Register New Patient',
      body,
      '<button class="btn btn-pri" onclick="twhSaveRegisteredPatient()"><i class="fa-solid fa-save"></i> Register Patient</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>'
    );
  };

  // Save through the core saveNewRecord pipeline (which is itself wrapped by
  // V25's saveNewRecord for card-type/billing capture). This keeps all the
  // downstream wiring intact while presenting our detailed form.
  window.twhSaveRegisteredPatient = function () {
    var name = (document.getElementById('add_fullName') || {}).value || '';
    if (!name.trim()) {
      if (isFn(window.toast)) window.toast('Full name is required', 'err');
      else alert('Full name is required');
      return;
    }
    if (isFn(window.saveNewRecord)) { window.saveNewRecord('patients'); }
  };

  /* ──────────────────────────────────────────────────────────────────────
     (3) FILTERS ALL ACTIVE + SIMPLE SEARCH (single unified handler)
     ────────────────────────────────────────────────────────────────────── */

  function _val(id) { var el = document.getElementById(id); return (el && el.value != null) ? el.value : ''; }

  // One simple, forgiving filter used by ALL controls. Re-renders the table
  // body against the live roster so every patient is reachable (not just the
  // painted rows). Falls back to row hide/show if we cannot re-render.
  window.twhPatientFilter = function () {
    var d = D_(); if (!d || !Array.isArray(d.patients)) return;
    var st = _val('patFilterStatus');
    var ct = _val('patFilterCard');
    var dp = _val('patFilterDept');
    var q = (_val('patFilterSearch') + '').trim().toLowerCase();

    function ok(p) {
      if (!p) return false;
      if (st && (p.status || '').toLowerCase() !== st.toLowerCase()) return false;
      if (ct) { var cid = parseInt(ct, 10); if (!isNaN(cid) && p.cardTypeId !== cid) return false; }
      if (dp) { var did = parseInt(dp, 10); if (!isNaN(did) && p.deptId !== did) return false; }
      if (q) {
        var hay = ((p.fullName || '') + ' ' + (p.mrn || '') + ' ' + (p.phone || '') + ' ' + (p.status || '')).toLowerCase();
        if (hay.indexOf(q) === -1) return false;
      }
      return true;
    }

    // Preferred path: re-render whole patient view honouring v341 (which reads
    // the same control ids), then re-normalize actions. Simplest + always
    // reaches every patient.
    var host = document.getElementById('moduleContent') || document.querySelector('.content');
    if (host && isFn(window.renderPatients)) {
      try { host.innerHTML = window.renderPatients(); wireFilterControls(); return; } catch (e) {}
    }

    // Fallback: client-side row hide/show on the existing table.
    var rows = document.querySelectorAll('#patTable tbody tr');
    for (var i = 0; i < rows.length; i++) {
      var r = rows[i];
      var text = (r.textContent || '').toLowerCase();
      var show = true;
      if (q && text.indexOf(q) === -1) show = false;
      if (st && text.indexOf(st.toLowerCase()) === -1) show = false;
      r.style.display = show ? '' : 'none';
    }
  };

  window.twhPatientFilterClear = function () {
    ['patFilterStatus', 'patFilterCard', 'patFilterDept', 'patFilterSearch'].forEach(function (id) {
      var el = document.getElementById(id); if (el) el.value = '';
    });
    window.twhPatientFilter();
  };

  // (Re)bind all filter controls to the unified handler. Safe to run every
  // sweep — it only rebinds if the node isn't already ours.
  function wireFilterControls() {
    ['patFilterStatus', 'patFilterCard', 'patFilterDept'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el && !el.__v371wired) { el.__v371wired = 1; el.onchange = window.twhPatientFilter; }
    });
    var s = document.getElementById('patFilterSearch');
    if (s && !s.__v371wired) {
      s.__v371wired = 1;
      s.oninput = window.twhPatientFilter;
      s.onkeyup = window.twhPatientFilter;
      if (!s.placeholder) s.placeholder = 'Search name, MRN, phone…';
    }
    // Re-point the header "Register Patient" button at the detailed modal.
    var regBtns = document.querySelectorAll('button[onclick*="addNewRecord(\'patients\')"]');
    for (var i = 0; i < regBtns.length; i++) {
      var b = regBtns[i];
      if (b.__v371reg) continue;
      b.__v371reg = 1;
      b.setAttribute('onclick', 'twhRegisterPatient()');
    }
  }

  /* ──────────────────────────────────────────────────────────────────────
     Boot (governor-safe)
     ────────────────────────────────────────────────────────────────────── */
  function sweep() {
    installWrapper();
    try { wireFilterControls(); } catch (e) {}
  }

  function boot() {
    sweep();
    [200, 800, 1800, 3500].forEach(function (ms) { setTimeout(sweep, ms); });
    try {
      if (typeof DOMBus !== 'undefined' && DOMBus && isFn(DOMBus.register)) DOMBus.register(sweep);
      if (window.HMS && isFn(window.HMS.every)) window.HMS.every(10000, sweep);
    } catch (e) {}
  }

  window.__twhV371Diag = function () {
    return {
      active: true,
      wrapped: _wrapped,
      renderPatientsWrapped: !!(isFn(window.renderPatients) && window.renderPatients.__v371),
      registerFnPresent: isFn(window.twhRegisterPatient),
      filterFnPresent: isFn(window.twhPatientFilter),
      stableRows: document.querySelectorAll('.act-row[data-twh-stable8]').length
    };
  };

  boot();
})();

;